(() => {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree5c1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree5c1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lHFn1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1b76d419da237d65$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $1b76d419da237d65$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $ani5R.defineComponent)({
    __name: 'App',
    props: {
        startPage: {},
        query: {},
        folder: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {};
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("ey4ci", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("ani5R")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("ani5R")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("ani5R")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("ani5R")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("ani5R")).createElementVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("ani5R")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("ani5R")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("ani5R")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("ani5R")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("ani5R")).getCurrentInstance);
$parcel$export(module.exports, "guardReactiveProps", () => (parcelRequire("ani5R")).guardReactiveProps);
$parcel$export(module.exports, "h", () => (parcelRequire("ani5R")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("ani5R")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("ani5R")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("ani5R")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("8bTPG")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "KeepAlive", () => (parcelRequire("ani5R")).KeepAlive);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("8bTPG")).markRaw);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("ani5R")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("ani5R")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("X5A94")).normalizeClass);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("ani5R")).onBeforeUnmount);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("ani5R")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("ani5R")).onUnmounted);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("ani5R")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("ani5R")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("ani5R")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("ani5R")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("ani5R")).resolveComponent);
$parcel$export(module.exports, "resolveDirective", () => (parcelRequire("ani5R")).resolveDirective);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("ani5R")).resolveDynamicComponent);
$parcel$export(module.exports, "Suspense", () => (parcelRequire("ani5R")).Suspense);
$parcel$export(module.exports, "toHandlers", () => (parcelRequire("ani5R")).toHandlers);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("8bTPG")).toRaw);
$parcel$export(module.exports, "watch", () => (parcelRequire("ani5R")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("ani5R")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("ani5R")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("ani5R")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("dDLnc")).createApp);
$parcel$export(module.exports, "Transition", () => (parcelRequire("dDLnc")).Transition);
$parcel$export(module.exports, "vShow", () => (parcelRequire("dDLnc")).vShow);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("dDLnc")).withModifiers);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("8bTPG")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("8bTPG")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("8bTPG")).onScopeDispose);
$parcel$export(module.exports, "toRef", () => (parcelRequire("8bTPG")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("8bTPG")).toRefs);
$parcel$export(module.exports, "triggerRef", () => (parcelRequire("8bTPG")).triggerRef);
$parcel$export(module.exports, "unref", () => (parcelRequire("8bTPG")).unref);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("X5A94")).normalizeProps);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("X5A94")).toDisplayString);
/**
* vue v3.5.20
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $ani5R = parcelRequire("ani5R");parcelRequire("dDLnc");parcelRequire("8bTPG");parcelRequire("X5A94");
function $a9777f2bcb9d7de1$var$initDev() {
    (0, $ani5R.initCustomFormatter)();
}
const $a9777f2bcb9d7de1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("ani5R", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $78da16583ad93b9f$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $78da16583ad93b9f$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $78da16583ad93b9f$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $78da16583ad93b9f$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $78da16583ad93b9f$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $78da16583ad93b9f$export$694b237e827a3d23);
$parcel$export(module.exports, "withDirectives", () => $78da16583ad93b9f$export$49729353e7c1e6c5);
$parcel$export(module.exports, "useTransitionState", () => $78da16583ad93b9f$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $78da16583ad93b9f$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $78da16583ad93b9f$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $78da16583ad93b9f$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $78da16583ad93b9f$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $78da16583ad93b9f$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $78da16583ad93b9f$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $78da16583ad93b9f$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $78da16583ad93b9f$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $78da16583ad93b9f$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $78da16583ad93b9f$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $78da16583ad93b9f$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "watch", () => $78da16583ad93b9f$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "onUpdated", () => $78da16583ad93b9f$export$5876c47052fb88b1);
$parcel$export(module.exports, "KeepAlive", () => $78da16583ad93b9f$export$70eb8a58709972df);
$parcel$export(module.exports, "onUnmounted", () => $78da16583ad93b9f$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeUpdate", () => $78da16583ad93b9f$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveComponent", () => $78da16583ad93b9f$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $78da16583ad93b9f$export$b44c564a05ca975);
$parcel$export(module.exports, "resolveDirective", () => $78da16583ad93b9f$export$a1989e995cd481be);
$parcel$export(module.exports, "renderList", () => $78da16583ad93b9f$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "renderSlot", () => $78da16583ad93b9f$export$4abee4c34694ada1);
$parcel$export(module.exports, "openBlock", () => $78da16583ad93b9f$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $78da16583ad93b9f$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "toHandlers", () => $78da16583ad93b9f$export$2fb94ff667a6a1a);
$parcel$export(module.exports, "computed", () => $78da16583ad93b9f$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $78da16583ad93b9f$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $78da16583ad93b9f$export$a976684a0efeb93f);
$parcel$export(module.exports, "hasInjectionContext", () => $78da16583ad93b9f$export$caf6761f24fc571a);
$parcel$export(module.exports, "createRenderer", () => $78da16583ad93b9f$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $78da16583ad93b9f$export$200524cf0d997ff0);
$parcel$export(module.exports, "watchEffect", () => $78da16583ad93b9f$export$ede35fc0e5500309);
$parcel$export(module.exports, "Suspense", () => $78da16583ad93b9f$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "createElementBlock", () => $78da16583ad93b9f$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $78da16583ad93b9f$export$42098e0eaa15c48e);
$parcel$export(module.exports, "guardReactiveProps", () => $78da16583ad93b9f$export$1f1be0e0e384d7d2);
$parcel$export(module.exports, "mergeProps", () => $78da16583ad93b9f$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createCommentVNode", () => $78da16583ad93b9f$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $78da16583ad93b9f$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $78da16583ad93b9f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $78da16583ad93b9f$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $78da16583ad93b9f$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("8bTPG")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("8bTPG")).markRaw);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("8bTPG")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("X5A94")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("X5A94")).normalizeClass);
/**
* @vue/runtime-core v3.5.20
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8bTPG = parcelRequire("8bTPG");

var $X5A94 = parcelRequire("X5A94");
const $78da16583ad93b9f$var$stack = [];
function $78da16583ad93b9f$var$pushWarningContext(vnode) {
    $78da16583ad93b9f$var$stack.push(vnode);
}
function $78da16583ad93b9f$var$popWarningContext() {
    $78da16583ad93b9f$var$stack.pop();
}
let $78da16583ad93b9f$var$isWarning = false;
function $78da16583ad93b9f$var$warn$1(msg, ...args) {
    if ($78da16583ad93b9f$var$isWarning) return;
    $78da16583ad93b9f$var$isWarning = true;
    (0, $8bTPG.pauseTracking)();
    const instance = $78da16583ad93b9f$var$stack.length ? $78da16583ad93b9f$var$stack[$78da16583ad93b9f$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $78da16583ad93b9f$var$getComponentTrace();
    if (appWarnHandler) $78da16583ad93b9f$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$78da16583ad93b9f$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$78da16583ad93b9f$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $8bTPG.resetTracking)();
    $78da16583ad93b9f$var$isWarning = false;
}
function $78da16583ad93b9f$var$getComponentTrace() {
    let currentVNode = $78da16583ad93b9f$var$stack[$78da16583ad93b9f$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $78da16583ad93b9f$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$78da16583ad93b9f$var$formatTraceEntry(entry));
    });
    return logs;
}
function $78da16583ad93b9f$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$78da16583ad93b9f$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$78da16583ad93b9f$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $78da16583ad93b9f$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$78da16583ad93b9f$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $78da16583ad93b9f$var$formatProp(key, value, raw) {
    if ((0, $X5A94.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $8bTPG.isRef)(value)) {
        value = $78da16583ad93b9f$var$formatProp(key, (0, $8bTPG.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $X5A94.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $8bTPG.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $78da16583ad93b9f$export$dfbcecb440255e4a(val, type) {
    return;
}
const $78da16583ad93b9f$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $78da16583ad93b9f$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $78da16583ad93b9f$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $78da16583ad93b9f$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $X5A94.isFunction)(fn)) {
        const res = $78da16583ad93b9f$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $X5A94.isPromise)(res)) res.catch((err)=>{
            $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $X5A94.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($78da16583ad93b9f$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $X5A94.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $8bTPG.pauseTracking)();
            $78da16583ad93b9f$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $8bTPG.resetTracking)();
            return;
        }
    }
    $78da16583ad93b9f$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $78da16583ad93b9f$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $78da16583ad93b9f$var$queue = [];
let $78da16583ad93b9f$var$flushIndex = -1;
const $78da16583ad93b9f$var$pendingPostFlushCbs = [];
let $78da16583ad93b9f$var$activePostFlushCbs = null;
let $78da16583ad93b9f$var$postFlushIndex = 0;
const $78da16583ad93b9f$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $78da16583ad93b9f$var$currentFlushPromise = null;
const $78da16583ad93b9f$var$RECURSION_LIMIT = 100;
function $78da16583ad93b9f$export$bdd553fddd433dcb(fn) {
    const p = $78da16583ad93b9f$var$currentFlushPromise || $78da16583ad93b9f$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $78da16583ad93b9f$var$findInsertionIndex(id) {
    let start = $78da16583ad93b9f$var$flushIndex + 1;
    let end = $78da16583ad93b9f$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $78da16583ad93b9f$var$queue[middle];
        const middleJobId = $78da16583ad93b9f$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $78da16583ad93b9f$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $78da16583ad93b9f$var$getId(job);
        const lastJob = $78da16583ad93b9f$var$queue[$78da16583ad93b9f$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $78da16583ad93b9f$var$getId(lastJob)) $78da16583ad93b9f$var$queue.push(job);
        else $78da16583ad93b9f$var$queue.splice($78da16583ad93b9f$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $78da16583ad93b9f$var$queueFlush();
    }
}
function $78da16583ad93b9f$var$queueFlush() {
    if (!$78da16583ad93b9f$var$currentFlushPromise) $78da16583ad93b9f$var$currentFlushPromise = $78da16583ad93b9f$var$resolvedPromise.then($78da16583ad93b9f$var$flushJobs);
}
function $78da16583ad93b9f$export$59536a0199721cab(cb) {
    if (!(0, $X5A94.isArray)(cb)) {
        if ($78da16583ad93b9f$var$activePostFlushCbs && cb.id === -1) $78da16583ad93b9f$var$activePostFlushCbs.splice($78da16583ad93b9f$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $78da16583ad93b9f$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $78da16583ad93b9f$var$pendingPostFlushCbs.push(...cb);
    $78da16583ad93b9f$var$queueFlush();
}
function $78da16583ad93b9f$var$flushPreFlushCbs(instance, seen, i = $78da16583ad93b9f$var$flushIndex + 1) {
    for(; i < $78da16583ad93b9f$var$queue.length; i++){
        const cb = $78da16583ad93b9f$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $78da16583ad93b9f$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $78da16583ad93b9f$var$flushPostFlushCbs(seen) {
    if ($78da16583ad93b9f$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($78da16583ad93b9f$var$pendingPostFlushCbs)
        ].sort((a, b)=>$78da16583ad93b9f$var$getId(a) - $78da16583ad93b9f$var$getId(b));
        $78da16583ad93b9f$var$pendingPostFlushCbs.length = 0;
        if ($78da16583ad93b9f$var$activePostFlushCbs) {
            $78da16583ad93b9f$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $78da16583ad93b9f$var$activePostFlushCbs = deduped;
        for($78da16583ad93b9f$var$postFlushIndex = 0; $78da16583ad93b9f$var$postFlushIndex < $78da16583ad93b9f$var$activePostFlushCbs.length; $78da16583ad93b9f$var$postFlushIndex++){
            const cb = $78da16583ad93b9f$var$activePostFlushCbs[$78da16583ad93b9f$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $78da16583ad93b9f$var$activePostFlushCbs = null;
        $78da16583ad93b9f$var$postFlushIndex = 0;
    }
}
const $78da16583ad93b9f$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $78da16583ad93b9f$var$flushJobs(seen) {
    const check = (0, $X5A94.NOOP);
    try {
        for($78da16583ad93b9f$var$flushIndex = 0; $78da16583ad93b9f$var$flushIndex < $78da16583ad93b9f$var$queue.length; $78da16583ad93b9f$var$flushIndex++){
            const job = $78da16583ad93b9f$var$queue[$78da16583ad93b9f$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $78da16583ad93b9f$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $78da16583ad93b9f$var$flushIndex < $78da16583ad93b9f$var$queue.length; $78da16583ad93b9f$var$flushIndex++){
            const job = $78da16583ad93b9f$var$queue[$78da16583ad93b9f$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $78da16583ad93b9f$var$flushIndex = -1;
        $78da16583ad93b9f$var$queue.length = 0;
        $78da16583ad93b9f$var$flushPostFlushCbs(seen);
        $78da16583ad93b9f$var$currentFlushPromise = null;
        if ($78da16583ad93b9f$var$queue.length || $78da16583ad93b9f$var$pendingPostFlushCbs.length) $78da16583ad93b9f$var$flushJobs(seen);
    }
}
function $78da16583ad93b9f$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $78da16583ad93b9f$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $78da16583ad93b9f$var$getComponentName(instance.type);
        $78da16583ad93b9f$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $78da16583ad93b9f$var$isHmrUpdating = false;
const $78da16583ad93b9f$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $78da16583ad93b9f$var$map = /* @__PURE__ */ new Map();
function $78da16583ad93b9f$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $78da16583ad93b9f$var$map.get(id);
    if (!record) {
        $78da16583ad93b9f$var$createRecord(id, instance.type);
        record = $78da16583ad93b9f$var$map.get(id);
    }
    record.instances.add(instance);
}
function $78da16583ad93b9f$var$unregisterHMR(instance) {
    $78da16583ad93b9f$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $78da16583ad93b9f$var$createRecord(id, initialDef) {
    if ($78da16583ad93b9f$var$map.has(id)) return false;
    $78da16583ad93b9f$var$map.set(id, {
        initialDef: $78da16583ad93b9f$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $78da16583ad93b9f$var$normalizeClassComponent(component) {
    return $78da16583ad93b9f$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $78da16583ad93b9f$var$rerender(id, newRender) {
    const record = $78da16583ad93b9f$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $78da16583ad93b9f$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $78da16583ad93b9f$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $78da16583ad93b9f$var$isHmrUpdating = false;
    });
}
function $78da16583ad93b9f$var$reload(id, newComp) {
    const record = $78da16583ad93b9f$var$map.get(id);
    if (!record) return;
    newComp = $78da16583ad93b9f$var$normalizeClassComponent(newComp);
    $78da16583ad93b9f$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $78da16583ad93b9f$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $78da16583ad93b9f$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $78da16583ad93b9f$var$updateComponentDef(oldComp, newComp);
            $78da16583ad93b9f$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $78da16583ad93b9f$var$queueJob(()=>{
            $78da16583ad93b9f$var$isHmrUpdating = true;
            instance.parent.update();
            $78da16583ad93b9f$var$isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $78da16583ad93b9f$export$59536a0199721cab(()=>{
        $78da16583ad93b9f$var$hmrDirtyComponents.clear();
    });
}
function $78da16583ad93b9f$var$updateComponentDef(oldComp, newComp) {
    (0, $X5A94.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $78da16583ad93b9f$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $78da16583ad93b9f$var$devtools$1;
let $78da16583ad93b9f$var$buffer = [];
let $78da16583ad93b9f$var$devtoolsNotInstalled = false;
function $78da16583ad93b9f$var$emit$1(event, ...args) {
    if ($78da16583ad93b9f$var$devtools$1) $78da16583ad93b9f$var$devtools$1.emit(event, ...args);
    else if (!$78da16583ad93b9f$var$devtoolsNotInstalled) $78da16583ad93b9f$var$buffer.push({
        event: event,
        args: args
    });
}
function $78da16583ad93b9f$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $78da16583ad93b9f$var$devtools$1 = hook;
    if ($78da16583ad93b9f$var$devtools$1) {
        $78da16583ad93b9f$var$devtools$1.enabled = true;
        $78da16583ad93b9f$var$buffer.forEach(({ event: event, args: args })=>$78da16583ad93b9f$var$devtools$1.emit(event, ...args));
        $78da16583ad93b9f$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $78da16583ad93b9f$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$78da16583ad93b9f$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $78da16583ad93b9f$var$devtoolsNotInstalled = true;
                $78da16583ad93b9f$var$buffer = [];
            }
        }, 3e3);
    } else {
        $78da16583ad93b9f$var$devtoolsNotInstalled = true;
        $78da16583ad93b9f$var$buffer = [];
    }
}
function $78da16583ad93b9f$var$devtoolsInitApp(app, version) {
    $78da16583ad93b9f$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $78da16583ad93b9f$export$ffb0004e005737fa,
        Text: $78da16583ad93b9f$export$5f1af8db9871e1d6,
        Comment: $78da16583ad93b9f$export$4d299b491347818a,
        Static: $78da16583ad93b9f$export$c1b9a1d3af45b7b6
    });
}
function $78da16583ad93b9f$var$devtoolsUnmountApp(app) {
    $78da16583ad93b9f$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $78da16583ad93b9f$var$devtoolsComponentAdded = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $78da16583ad93b9f$var$devtoolsComponentUpdated = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $78da16583ad93b9f$var$_devtoolsComponentRemoved = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $78da16583ad93b9f$var$devtoolsComponentRemoved = (component)=>{
    if ($78da16583ad93b9f$var$devtools$1 && typeof $78da16583ad93b9f$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$78da16583ad93b9f$var$devtools$1.cleanupBuffer(component)) $78da16583ad93b9f$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $78da16583ad93b9f$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $78da16583ad93b9f$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $78da16583ad93b9f$var$devtoolsPerfStart = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $78da16583ad93b9f$var$devtoolsPerfEnd = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $78da16583ad93b9f$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $78da16583ad93b9f$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $78da16583ad93b9f$var$devtoolsComponentEmit(component, event, params) {
    $78da16583ad93b9f$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $78da16583ad93b9f$var$currentRenderingInstance = null;
let $78da16583ad93b9f$var$currentScopeId = null;
function $78da16583ad93b9f$var$setCurrentRenderingInstance(instance) {
    const prev = $78da16583ad93b9f$var$currentRenderingInstance;
    $78da16583ad93b9f$var$currentRenderingInstance = instance;
    $78da16583ad93b9f$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $78da16583ad93b9f$export$ac020265ca2cc4cd(id) {
    $78da16583ad93b9f$var$currentScopeId = id;
}
function $78da16583ad93b9f$export$f2dc6805dc11834e() {
    $78da16583ad93b9f$var$currentScopeId = null;
}
const $78da16583ad93b9f$export$15ba313e13f3dd04 = (_id)=>$78da16583ad93b9f$export$694b237e827a3d23;
function $78da16583ad93b9f$export$694b237e827a3d23(fn, ctx = $78da16583ad93b9f$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $78da16583ad93b9f$export$c20bee82f26f1e27(-1);
        const prevInstance = $78da16583ad93b9f$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $78da16583ad93b9f$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $78da16583ad93b9f$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $78da16583ad93b9f$var$validateDirectiveName(name) {
    if ((0, $X5A94.isBuiltInDirective)(name)) $78da16583ad93b9f$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $78da16583ad93b9f$export$49729353e7c1e6c5(vnode, directives) {
    if ($78da16583ad93b9f$var$currentRenderingInstance === null) return vnode;
    const instance = $78da16583ad93b9f$var$getComponentPublicInstance($78da16583ad93b9f$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $X5A94.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $X5A94.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $8bTPG.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $78da16583ad93b9f$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $8bTPG.pauseTracking)();
            $78da16583ad93b9f$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $8bTPG.resetTracking)();
        }
    }
}
const $78da16583ad93b9f$var$TeleportEndKey = Symbol("_vte");
const $78da16583ad93b9f$var$isTeleport = (type)=>type.__isTeleport;
const $78da16583ad93b9f$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $78da16583ad93b9f$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $78da16583ad93b9f$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $78da16583ad93b9f$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $78da16583ad93b9f$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $X5A94.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $78da16583ad93b9f$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $78da16583ad93b9f$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = $78da16583ad93b9f$var$resolveTarget(n2.props, querySelector);
                const targetAnchor = $78da16583ad93b9f$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $78da16583ad93b9f$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $78da16583ad93b9f$var$isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $78da16583ad93b9f$var$updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                $78da16583ad93b9f$var$updateCssVars(n2, true);
            }
            if ($78da16583ad93b9f$var$isTeleportDeferred(n2.props)) {
                n2.el.__isMounted = false;
                $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                    mountToTarget();
                    delete n2.el.__isMounted;
                }, parentSuspense);
            } else mountToTarget();
        } else {
            if ($78da16583ad93b9f$var$isTeleportDeferred(n2.props) && n1.el.__isMounted === false) {
                $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                    $78da16583ad93b9f$var$TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $78da16583ad93b9f$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $78da16583ad93b9f$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $78da16583ad93b9f$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $78da16583ad93b9f$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $78da16583ad93b9f$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $78da16583ad93b9f$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $78da16583ad93b9f$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $78da16583ad93b9f$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $78da16583ad93b9f$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$78da16583ad93b9f$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $78da16583ad93b9f$var$moveTeleport,
    hydrate: $78da16583ad93b9f$var$hydrateTeleport
};
function $78da16583ad93b9f$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $78da16583ad93b9f$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $78da16583ad93b9f$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    const target = vnode.target = $78da16583ad93b9f$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const disabled = $78da16583ad93b9f$var$isTeleportDisabled(vnode.props);
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) $78da16583ad93b9f$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $78da16583ad93b9f$var$updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $78da16583ad93b9f$export$76d55a0304a371f4 = $78da16583ad93b9f$var$TeleportImpl;
function $78da16583ad93b9f$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $78da16583ad93b9f$var$prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$78da16583ad93b9f$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const $78da16583ad93b9f$var$leaveCbKey = Symbol("_leaveCb");
const $78da16583ad93b9f$var$enterCbKey = Symbol("_enterCb");
function $78da16583ad93b9f$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $78da16583ad93b9f$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $78da16583ad93b9f$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $78da16583ad93b9f$var$TransitionHookValidator = [
    Function,
    Array
];
const $78da16583ad93b9f$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $78da16583ad93b9f$var$TransitionHookValidator,
    onEnter: $78da16583ad93b9f$var$TransitionHookValidator,
    onAfterEnter: $78da16583ad93b9f$var$TransitionHookValidator,
    onEnterCancelled: $78da16583ad93b9f$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $78da16583ad93b9f$var$TransitionHookValidator,
    onLeave: $78da16583ad93b9f$var$TransitionHookValidator,
    onAfterLeave: $78da16583ad93b9f$var$TransitionHookValidator,
    onLeaveCancelled: $78da16583ad93b9f$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $78da16583ad93b9f$var$TransitionHookValidator,
    onAppear: $78da16583ad93b9f$var$TransitionHookValidator,
    onAfterAppear: $78da16583ad93b9f$var$TransitionHookValidator,
    onAppearCancelled: $78da16583ad93b9f$var$TransitionHookValidator
};
const $78da16583ad93b9f$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $78da16583ad93b9f$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $78da16583ad93b9f$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $78da16583ad93b9f$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $78da16583ad93b9f$export$f13e630aa3915748();
        const state = $78da16583ad93b9f$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $78da16583ad93b9f$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            const child = $78da16583ad93b9f$var$findNonCommentChild(children);
            const rawProps = (0, $8bTPG.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $78da16583ad93b9f$var$emptyPlaceholder(child);
            const innerChild = $78da16583ad93b9f$var$getInnerChild$1(child);
            if (!innerChild) return $78da16583ad93b9f$var$emptyPlaceholder(child);
            let enterHooks = $78da16583ad93b9f$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $78da16583ad93b9f$export$4d299b491347818a) $78da16583ad93b9f$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $78da16583ad93b9f$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $78da16583ad93b9f$export$4d299b491347818a && !$78da16583ad93b9f$var$isSameVNodeType(innerChild, oldInnerChild) && $78da16583ad93b9f$var$recursiveGetSubtree(instance).type !== $78da16583ad93b9f$export$4d299b491347818a) {
                let leavingHooks = $78da16583ad93b9f$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $78da16583ad93b9f$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $78da16583ad93b9f$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $78da16583ad93b9f$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $78da16583ad93b9f$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $78da16583ad93b9f$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$78da16583ad93b9f$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$78da16583ad93b9f$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $78da16583ad93b9f$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $78da16583ad93b9f$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $78da16583ad93b9f$export$abd95b5f5e8a8837 = $78da16583ad93b9f$var$BaseTransitionImpl;
function $78da16583ad93b9f$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $78da16583ad93b9f$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $78da16583ad93b9f$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $78da16583ad93b9f$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $X5A94.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$78da16583ad93b9f$var$leaveCbKey]) el[$78da16583ad93b9f$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $78da16583ad93b9f$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$78da16583ad93b9f$var$leaveCbKey]) leavingVNode.el[$78da16583ad93b9f$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$78da16583ad93b9f$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$78da16583ad93b9f$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$78da16583ad93b9f$var$enterCbKey]) el[$78da16583ad93b9f$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$78da16583ad93b9f$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$78da16583ad93b9f$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $78da16583ad93b9f$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $78da16583ad93b9f$var$emptyPlaceholder(vnode) {
    if ($78da16583ad93b9f$var$isKeepAlive(vnode)) {
        vnode = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $78da16583ad93b9f$var$getInnerChild$1(vnode) {
    if (!$78da16583ad93b9f$var$isKeepAlive(vnode)) {
        if ($78da16583ad93b9f$var$isTeleport(vnode.type) && vnode.children) return $78da16583ad93b9f$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $X5A94.isFunction)(children.default)) return children.default();
    }
}
function $78da16583ad93b9f$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $78da16583ad93b9f$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $78da16583ad93b9f$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $78da16583ad93b9f$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($78da16583ad93b9f$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $78da16583ad93b9f$export$4d299b491347818a) ret.push(key != null ? $78da16583ad93b9f$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $78da16583ad93b9f$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $X5A94.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $X5A94.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $78da16583ad93b9f$export$f680877a34711e37() {
    const i = $78da16583ad93b9f$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $78da16583ad93b9f$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $78da16583ad93b9f$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $78da16583ad93b9f$export$83a5dbc1f35517ca(key) {
    const i = $78da16583ad93b9f$export$f13e630aa3915748();
    const r = (0, $8bTPG.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $X5A94.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $78da16583ad93b9f$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $X5A94.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$78da16583ad93b9f$var$setRef(r, oldRawRef && ((0, $X5A94.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($78da16583ad93b9f$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $78da16583ad93b9f$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $78da16583ad93b9f$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $X5A94.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $8bTPG.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $X5A94.EMPTY_OBJ) ? (0, $X5A94.NO) : (key)=>{
        return (0, $X5A94.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2)=>{
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, $X5A94.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $8bTPG.isRef)(oldRef)) {
            if (canSetRef(oldRef)) oldRef.value = null;
            const oldRawRefAtom = oldRawRef;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $X5A94.isFunction)(ref)) $78da16583ad93b9f$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $X5A94.isString)(ref);
        const _isRef = (0, $8bTPG.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $X5A94.isArray)(existing) && (0, $X5A94.remove)(existing, refValue);
                    else {
                        if (!(0, $X5A94.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $78da16583ad93b9f$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $78da16583ad93b9f$var$hasLoggedMismatchError = false;
const $78da16583ad93b9f$var$logMismatchError = ()=>{
    if ($78da16583ad93b9f$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $78da16583ad93b9f$var$hasLoggedMismatchError = true;
};
const $78da16583ad93b9f$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $78da16583ad93b9f$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $78da16583ad93b9f$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($78da16583ad93b9f$var$isSVGContainer(container)) return "svg";
    if ($78da16583ad93b9f$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $78da16583ad93b9f$var$isComment = (node)=>node.nodeType === 8;
function $78da16583ad93b9f$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $78da16583ad93b9f$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $78da16583ad93b9f$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $78da16583ad93b9f$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $X5A94.def)(node, "__vnode", vnode, true);
            (0, $X5A94.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $78da16583ad93b9f$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $78da16583ad93b9f$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $78da16583ad93b9f$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $78da16583ad93b9f$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $78da16583ad93b9f$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($78da16583ad93b9f$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$getContainerType(container), optimized);
                    if ($78da16583ad93b9f$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $78da16583ad93b9f$export$22f9b5ffd89dac9("") : $78da16583ad93b9f$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $78da16583ad93b9f$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $78da16583ad93b9f$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $78da16583ad93b9f$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $78da16583ad93b9f$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!$78da16583ad93b9f$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $78da16583ad93b9f$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        $78da16583ad93b9f$var$logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!$78da16583ad93b9f$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        $78da16583ad93b9f$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $78da16583ad93b9f$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $78da16583ad93b9f$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $X5A94.isOn)(key) && !(0, $X5A94.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $8bTPG.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $78da16583ad93b9f$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $78da16583ad93b9f$var$normalizeVNode(children[i]);
            const isText = vnode.type === $78da16583ad93b9f$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $78da16583ad93b9f$var$normalizeVNode(children[i + 1]).type === $78da16583ad93b9f$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$78da16583ad93b9f$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $78da16583ad93b9f$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $78da16583ad93b9f$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $78da16583ad93b9f$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $78da16583ad93b9f$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$78da16583ad93b9f$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $78da16583ad93b9f$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $78da16583ad93b9f$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $78da16583ad93b9f$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $78da16583ad93b9f$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $78da16583ad93b9f$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $78da16583ad93b9f$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $X5A94.normalizeClass)(clientValue);
        if (!$78da16583ad93b9f$var$isSetEqual($78da16583ad93b9f$var$toClassSet(actual || ""), $78da16583ad93b9f$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $X5A94.isString)(clientValue) ? clientValue : (0, $X5A94.stringifyStyle)((0, $X5A94.normalizeStyle)(clientValue));
        const actualMap = $78da16583ad93b9f$var$toStyleMap(actual);
        const expectedMap = $78da16583ad93b9f$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $78da16583ad93b9f$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$78da16583ad93b9f$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $X5A94.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $X5A94.isBooleanAttr)(key) || (0, $X5A94.isKnownHtmlAttr)(key))) {
        if ((0, $X5A94.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $X5A94.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $X5A94.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$78da16583ad93b9f$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$78da16583ad93b9f$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $78da16583ad93b9f$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $78da16583ad93b9f$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $78da16583ad93b9f$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $78da16583ad93b9f$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $78da16583ad93b9f$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $78da16583ad93b9f$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $78da16583ad93b9f$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $X5A94.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $X5A94.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $78da16583ad93b9f$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $78da16583ad93b9f$var$allowMismatchAttr = "data-allow-mismatch";
const $78da16583ad93b9f$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $78da16583ad93b9f$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($78da16583ad93b9f$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($78da16583ad93b9f$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($78da16583ad93b9f$var$MismatchTypeString[allowedType]);
    }
}
const $78da16583ad93b9f$var$requestIdleCallback = (0, $X5A94.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $78da16583ad93b9f$var$cancelIdleCallback = (0, $X5A94.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $78da16583ad93b9f$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $78da16583ad93b9f$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$78da16583ad93b9f$var$cancelIdleCallback(id);
    };
function $78da16583ad93b9f$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $78da16583ad93b9f$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($78da16583ad93b9f$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $78da16583ad93b9f$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $78da16583ad93b9f$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $X5A94.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $78da16583ad93b9f$var$forEachElement(node, cb) {
    if ($78da16583ad93b9f$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($78da16583ad93b9f$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $78da16583ad93b9f$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $78da16583ad93b9f$export$d75d499b4c16cf21(source) {
    if ((0, $X5A94.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $78da16583ad93b9f$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$78da16583ad93b9f$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $78da16583ad93b9f$var$currentInstance;
            $78da16583ad93b9f$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$78da16583ad93b9f$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $78da16583ad93b9f$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$78da16583ad93b9f$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $78da16583ad93b9f$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $8bTPG.ref)(false);
            const error = (0, $8bTPG.ref)();
            const delayed = (0, $8bTPG.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $78da16583ad93b9f$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $78da16583ad93b9f$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $78da16583ad93b9f$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $78da16583ad93b9f$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $78da16583ad93b9f$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $78da16583ad93b9f$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $78da16583ad93b9f$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $78da16583ad93b9f$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $78da16583ad93b9f$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $X5A94.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $78da16583ad93b9f$var$invalidateMount(instance2.m);
            $78da16583ad93b9f$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $X5A94.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $78da16583ad93b9f$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $78da16583ad93b9f$var$getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$78da16583ad93b9f$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $78da16583ad93b9f$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $78da16583ad93b9f$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$78da16583ad93b9f$var$matches(include, name));
            exclude && pruneCache((name)=>!$78da16583ad93b9f$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($78da16583ad93b9f$var$isSuspense(instance.subTree.type)) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $78da16583ad93b9f$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $78da16583ad93b9f$var$getInnerChild(instance.subTree));
            }
        };
        $78da16583ad93b9f$export$6d1641039221b5cb(cacheSubtree);
        $78da16583ad93b9f$export$5876c47052fb88b1(cacheSubtree);
        $78da16583ad93b9f$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $78da16583ad93b9f$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $78da16583ad93b9f$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $78da16583ad93b9f$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$78da16583ad93b9f$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $78da16583ad93b9f$var$getInnerChild(rawVNode);
            if (vnode.type === $78da16583ad93b9f$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $78da16583ad93b9f$var$getComponentName($78da16583ad93b9f$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$78da16583ad93b9f$var$matches(include, name)) || exclude && name && $78da16583ad93b9f$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $78da16583ad93b9f$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $78da16583ad93b9f$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $78da16583ad93b9f$export$70eb8a58709972df = $78da16583ad93b9f$var$KeepAliveImpl;
function $78da16583ad93b9f$var$matches(pattern, name) {
    if ((0, $X5A94.isArray)(pattern)) return pattern.some((p)=>$78da16583ad93b9f$var$matches(p, name));
    else if ((0, $X5A94.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $X5A94.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $78da16583ad93b9f$export$ba52d824b95a2154(hook, target) {
    $78da16583ad93b9f$var$registerKeepAliveHook(hook, "a", target);
}
function $78da16583ad93b9f$export$bf1440eeaf5fa709(hook, target) {
    $78da16583ad93b9f$var$registerKeepAliveHook(hook, "da", target);
}
function $78da16583ad93b9f$var$registerKeepAliveHook(hook, type, target = $78da16583ad93b9f$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $78da16583ad93b9f$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($78da16583ad93b9f$var$isKeepAlive(current.parent.vnode)) $78da16583ad93b9f$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $78da16583ad93b9f$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $78da16583ad93b9f$var$injectHook(type, hook, keepAliveRoot, true);
    $78da16583ad93b9f$export$13348a43ccacfe58(()=>{
        (0, $X5A94.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $78da16583ad93b9f$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $78da16583ad93b9f$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $78da16583ad93b9f$var$injectHook(type, hook, target = $78da16583ad93b9f$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $8bTPG.pauseTracking)();
            const reset = $78da16583ad93b9f$var$setCurrentInstance(target);
            const res = $78da16583ad93b9f$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $8bTPG.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $78da16583ad93b9f$var$createHook = (lifecycle)=>(hook, target = $78da16583ad93b9f$var$currentInstance)=>{
        if (!$78da16583ad93b9f$var$isInSSRComponentSetup || lifecycle === "sp") $78da16583ad93b9f$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $78da16583ad93b9f$export$23b7aeb0d671f804 = $78da16583ad93b9f$var$createHook("bm");
const $78da16583ad93b9f$export$6d1641039221b5cb = $78da16583ad93b9f$var$createHook("m");
const $78da16583ad93b9f$export$ab91988a13872e4c = $78da16583ad93b9f$var$createHook("bu");
const $78da16583ad93b9f$export$5876c47052fb88b1 = $78da16583ad93b9f$var$createHook("u");
const $78da16583ad93b9f$export$40c420df62d2614 = $78da16583ad93b9f$var$createHook("bum");
const $78da16583ad93b9f$export$13348a43ccacfe58 = $78da16583ad93b9f$var$createHook("um");
const $78da16583ad93b9f$export$ebf0c601f267bceb = $78da16583ad93b9f$var$createHook("sp");
const $78da16583ad93b9f$export$898295a813d662eb = $78da16583ad93b9f$var$createHook("rtg");
const $78da16583ad93b9f$export$2b41f4235363e921 = $78da16583ad93b9f$var$createHook("rtc");
function $78da16583ad93b9f$export$6a3a15856e50ad19(hook, target = $78da16583ad93b9f$var$currentInstance) {
    $78da16583ad93b9f$var$injectHook("ec", hook, target);
}
const $78da16583ad93b9f$var$COMPONENTS = "components";
const $78da16583ad93b9f$var$DIRECTIVES = "directives";
function $78da16583ad93b9f$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $78da16583ad93b9f$var$resolveAsset($78da16583ad93b9f$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $78da16583ad93b9f$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $78da16583ad93b9f$export$b44c564a05ca975(component) {
    if ((0, $X5A94.isString)(component)) return $78da16583ad93b9f$var$resolveAsset($78da16583ad93b9f$var$COMPONENTS, component, false) || component;
    else return component || $78da16583ad93b9f$var$NULL_DYNAMIC_COMPONENT;
}
function $78da16583ad93b9f$export$a1989e995cd481be(name) {
    return $78da16583ad93b9f$var$resolveAsset($78da16583ad93b9f$var$DIRECTIVES, name);
}
function $78da16583ad93b9f$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $78da16583ad93b9f$var$currentRenderingInstance || $78da16583ad93b9f$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $78da16583ad93b9f$var$COMPONENTS) {
            const selfName = $78da16583ad93b9f$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $X5A94.camelize)(name) || selfName === (0, $X5A94.capitalize)((0, $X5A94.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $78da16583ad93b9f$var$resolve(instance[type] || Component[type], name) || // global registration
        $78da16583ad93b9f$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $78da16583ad93b9f$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $X5A94.camelize)(name)] || registry[(0, $X5A94.capitalize)((0, $X5A94.camelize)(name))]);
}
function $78da16583ad93b9f$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $X5A94.isArray)(source);
    if (sourceIsArray || (0, $X5A94.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $8bTPG.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $8bTPG.isShallow)(source);
            isReadonlySource = (0, $8bTPG.isReadonly)(source);
            source = (0, $8bTPG.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $8bTPG.toReadonly)((0, $8bTPG.toReactive)(source[i])) : (0, $8bTPG.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $X5A94.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $78da16583ad93b9f$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $X5A94.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $78da16583ad93b9f$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($78da16583ad93b9f$var$currentRenderingInstance.ce || $78da16583ad93b9f$var$currentRenderingInstance.parent && $78da16583ad93b9f$var$isAsyncWrapper($78da16583ad93b9f$var$currentRenderingInstance.parent) && $78da16583ad93b9f$var$currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return $78da16583ad93b9f$export$e7eaa45e502fe5cc(), $78da16583ad93b9f$export$9f2dfe8048dfb22b($78da16583ad93b9f$export$ffb0004e005737fa, null, [
            $78da16583ad93b9f$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $78da16583ad93b9f$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $78da16583ad93b9f$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $78da16583ad93b9f$export$9f2dfe8048dfb22b($78da16583ad93b9f$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $X5A94.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $78da16583ad93b9f$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$78da16583ad93b9f$export$3868d13f8734ae81(child)) return true;
        if (child.type === $78da16583ad93b9f$export$4d299b491347818a) return false;
        if (child.type === $78da16583ad93b9f$export$ffb0004e005737fa && !$78da16583ad93b9f$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $78da16583ad93b9f$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $X5A94.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $78da16583ad93b9f$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($78da16583ad93b9f$var$isStatefulComponent(i)) return $78da16583ad93b9f$var$getComponentPublicInstance(i);
    return $78da16583ad93b9f$var$getPublicInstance(i.parent);
};
const $78da16583ad93b9f$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $X5A94.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$78da16583ad93b9f$var$getPublicInstance(i.parent),
    $root: (i)=>$78da16583ad93b9f$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $78da16583ad93b9f$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $78da16583ad93b9f$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $78da16583ad93b9f$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $78da16583ad93b9f$var$instanceWatch.bind(i) : (0, $X5A94.NOOP)
});
const $78da16583ad93b9f$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $78da16583ad93b9f$var$hasSetupBinding = (state, key)=>state !== (0, $X5A94.EMPTY_OBJ) && !state.__isScriptSetup && (0, $X5A94.hasOwn)(state, key);
const $78da16583ad93b9f$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($78da16583ad93b9f$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $X5A94.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $78da16583ad93b9f$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $78da16583ad93b9f$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $8bTPG.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $X5A94.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($78da16583ad93b9f$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $X5A94.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions, type: type } }, key) {
        let normalizedProps, cssModules;
        return !!(accessCache[key] || data !== (0, $X5A94.EMPTY_OBJ) && key[0] !== "$" && (0, $X5A94.hasOwn)(data, key) || $78da16583ad93b9f$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $X5A94.hasOwn)(normalizedProps, key) || (0, $X5A94.hasOwn)(ctx, key) || (0, $X5A94.hasOwn)($78da16583ad93b9f$var$publicPropertiesMap, key) || (0, $X5A94.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $X5A94.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $78da16583ad93b9f$var$target;
const $78da16583ad93b9f$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $X5A94.extend)({}, $78da16583ad93b9f$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $78da16583ad93b9f$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $X5A94.isGloballyAllowed)(key);
        return has;
    }
});
function $78da16583ad93b9f$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($78da16583ad93b9f$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$78da16583ad93b9f$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $X5A94.NOOP)
        });
    });
    return target;
}
function $78da16583ad93b9f$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $X5A94.NOOP)
        });
    });
}
function $78da16583ad93b9f$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $8bTPG.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($78da16583ad93b9f$var$isReservedPrefix(key[0])) {
                $78da16583ad93b9f$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $X5A94.NOOP)
            });
        }
    });
}
const $78da16583ad93b9f$var$warnRuntimeUsage = (method)=>$78da16583ad93b9f$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $78da16583ad93b9f$export$80b33eababae110e() {
    return null;
}
function $78da16583ad93b9f$export$51ecece22fc17ddc() {
    return null;
}
function $78da16583ad93b9f$export$da25b65ca24b518a(exposed) {}
function $78da16583ad93b9f$export$77e79129327f3d0d(options) {}
function $78da16583ad93b9f$export$1b3acd4bb805b712() {
    return null;
}
function $78da16583ad93b9f$export$acd55aa037e791bb() {}
function $78da16583ad93b9f$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $78da16583ad93b9f$export$9203a8e84125433c() {
    return $78da16583ad93b9f$var$getContext("useSlots").slots;
}
function $78da16583ad93b9f$export$75e29435042cd2ea() {
    return $78da16583ad93b9f$var$getContext("useAttrs").attrs;
}
function $78da16583ad93b9f$var$getContext(calledFunctionName) {
    const i = $78da16583ad93b9f$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $78da16583ad93b9f$var$createSetupContext(i));
}
function $78da16583ad93b9f$var$normalizePropsOrEmits(props) {
    return (0, $X5A94.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $78da16583ad93b9f$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $78da16583ad93b9f$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $X5A94.isArray)(opt) || (0, $X5A94.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $78da16583ad93b9f$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $X5A94.isArray)(a) && (0, $X5A94.isArray)(b)) return a.concat(b);
    return (0, $X5A94.extend)({}, $78da16583ad93b9f$var$normalizePropsOrEmits(a), $78da16583ad93b9f$var$normalizePropsOrEmits(b));
}
function $78da16583ad93b9f$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $78da16583ad93b9f$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $78da16583ad93b9f$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $78da16583ad93b9f$var$unsetCurrentInstance();
    if ((0, $X5A94.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $78da16583ad93b9f$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$78da16583ad93b9f$var$setCurrentInstance(ctx)
    ];
}
function $78da16583ad93b9f$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $78da16583ad93b9f$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $78da16583ad93b9f$var$shouldCacheAccess = true;
function $78da16583ad93b9f$var$applyOptions(instance) {
    const options = $78da16583ad93b9f$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $78da16583ad93b9f$var$shouldCacheAccess = false;
    if (options.beforeCreate) $78da16583ad93b9f$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $78da16583ad93b9f$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $X5A94.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $X5A94.isObject)(data)) ;
        else instance.data = (0, $8bTPG.reactive)(data);
    }
    $78da16583ad93b9f$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $X5A94.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $X5A94.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $X5A94.NOOP);
        const set = !(0, $X5A94.isFunction)(opt) && (0, $X5A94.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $X5A94.NOOP);
        const c = $78da16583ad93b9f$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$78da16583ad93b9f$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $X5A94.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $78da16583ad93b9f$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $78da16583ad93b9f$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $X5A94.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($78da16583ad93b9f$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($78da16583ad93b9f$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($78da16583ad93b9f$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($78da16583ad93b9f$export$5876c47052fb88b1, updated);
    registerLifecycleHook($78da16583ad93b9f$export$ba52d824b95a2154, activated);
    registerLifecycleHook($78da16583ad93b9f$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($78da16583ad93b9f$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($78da16583ad93b9f$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($78da16583ad93b9f$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($78da16583ad93b9f$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($78da16583ad93b9f$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($78da16583ad93b9f$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $X5A94.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $X5A94.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $78da16583ad93b9f$var$markAsyncBoundary(instance);
}
function $78da16583ad93b9f$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $X5A94.NOOP)) {
    if ((0, $X5A94.isArray)(injectOptions)) injectOptions = $78da16583ad93b9f$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $X5A94.isObject)(opt)) {
            if ("default" in opt) injected = $78da16583ad93b9f$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $78da16583ad93b9f$export$a976684a0efeb93f(opt.from || key);
        } else injected = $78da16583ad93b9f$export$a976684a0efeb93f(opt);
        if ((0, $8bTPG.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $78da16583ad93b9f$var$callHook(hook, instance, type) {
    $78da16583ad93b9f$export$dae85862a8d94378((0, $X5A94.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $78da16583ad93b9f$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $78da16583ad93b9f$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $X5A94.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $X5A94.isFunction)(handler)) $78da16583ad93b9f$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $X5A94.isFunction)(raw)) $78da16583ad93b9f$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $X5A94.isObject)(raw)) {
        if ((0, $X5A94.isArray)(raw)) raw.forEach((r)=>$78da16583ad93b9f$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $X5A94.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $X5A94.isFunction)(handler)) $78da16583ad93b9f$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $78da16583ad93b9f$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$78da16583ad93b9f$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $78da16583ad93b9f$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $X5A94.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $78da16583ad93b9f$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $78da16583ad93b9f$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$78da16583ad93b9f$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $78da16583ad93b9f$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $78da16583ad93b9f$var$internalOptionMergeStrats = {
    data: $78da16583ad93b9f$var$mergeDataFn,
    props: $78da16583ad93b9f$var$mergeEmitsOrPropsOptions,
    emits: $78da16583ad93b9f$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $78da16583ad93b9f$var$mergeObjectOptions,
    computed: $78da16583ad93b9f$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $78da16583ad93b9f$var$mergeAsArray,
    created: $78da16583ad93b9f$var$mergeAsArray,
    beforeMount: $78da16583ad93b9f$var$mergeAsArray,
    mounted: $78da16583ad93b9f$var$mergeAsArray,
    beforeUpdate: $78da16583ad93b9f$var$mergeAsArray,
    updated: $78da16583ad93b9f$var$mergeAsArray,
    beforeDestroy: $78da16583ad93b9f$var$mergeAsArray,
    beforeUnmount: $78da16583ad93b9f$var$mergeAsArray,
    destroyed: $78da16583ad93b9f$var$mergeAsArray,
    unmounted: $78da16583ad93b9f$var$mergeAsArray,
    activated: $78da16583ad93b9f$var$mergeAsArray,
    deactivated: $78da16583ad93b9f$var$mergeAsArray,
    errorCaptured: $78da16583ad93b9f$var$mergeAsArray,
    serverPrefetch: $78da16583ad93b9f$var$mergeAsArray,
    // assets
    components: $78da16583ad93b9f$var$mergeObjectOptions,
    directives: $78da16583ad93b9f$var$mergeObjectOptions,
    // watch
    watch: $78da16583ad93b9f$var$mergeWatchOptions,
    // provide / inject
    provide: $78da16583ad93b9f$var$mergeDataFn,
    inject: $78da16583ad93b9f$var$mergeInject
};
function $78da16583ad93b9f$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $X5A94.extend)((0, $X5A94.isFunction)(to) ? to.call(this, this) : to, (0, $X5A94.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $78da16583ad93b9f$var$mergeInject(to, from) {
    return $78da16583ad93b9f$var$mergeObjectOptions($78da16583ad93b9f$var$normalizeInject(to), $78da16583ad93b9f$var$normalizeInject(from));
}
function $78da16583ad93b9f$var$normalizeInject(raw) {
    if ((0, $X5A94.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $78da16583ad93b9f$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $78da16583ad93b9f$var$mergeObjectOptions(to, from) {
    return to ? (0, $X5A94.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $78da16583ad93b9f$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $X5A94.isArray)(to) && (0, $X5A94.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $X5A94.extend)(/* @__PURE__ */ Object.create(null), $78da16583ad93b9f$var$normalizePropsOrEmits(to), $78da16583ad93b9f$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $78da16583ad93b9f$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $X5A94.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $78da16583ad93b9f$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $78da16583ad93b9f$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $X5A94.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $78da16583ad93b9f$var$uid$1 = 0;
function $78da16583ad93b9f$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $X5A94.isFunction)(rootComponent)) rootComponent = (0, $X5A94.extend)({}, rootComponent);
        if (rootProps != null && !(0, $X5A94.isObject)(rootProps)) rootProps = null;
        const context = $78da16583ad93b9f$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $78da16583ad93b9f$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $78da16583ad93b9f$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $X5A94.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $X5A94.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $78da16583ad93b9f$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $78da16583ad93b9f$var$devtoolsInitApp(app, $78da16583ad93b9f$export$83d89fbfd8236492);
                    }
                    return $78da16583ad93b9f$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $78da16583ad93b9f$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $78da16583ad93b9f$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $78da16583ad93b9f$var$currentApp;
                $78da16583ad93b9f$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $78da16583ad93b9f$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $78da16583ad93b9f$var$currentApp = null;
function $78da16583ad93b9f$export$abe1e183e22e10ad(key, value) {
    if (!$78da16583ad93b9f$var$currentInstance) ;
    else {
        let provides = $78da16583ad93b9f$var$currentInstance.provides;
        const parentProvides = $78da16583ad93b9f$var$currentInstance.parent && $78da16583ad93b9f$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $78da16583ad93b9f$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $78da16583ad93b9f$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $78da16583ad93b9f$export$f13e630aa3915748();
    if (instance || $78da16583ad93b9f$var$currentApp) {
        let provides = $78da16583ad93b9f$var$currentApp ? $78da16583ad93b9f$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $X5A94.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $78da16583ad93b9f$export$caf6761f24fc571a() {
    return !!($78da16583ad93b9f$export$f13e630aa3915748() || $78da16583ad93b9f$var$currentApp);
}
const $78da16583ad93b9f$var$internalObjectProto = {};
const $78da16583ad93b9f$var$createInternalObject = ()=>Object.create($78da16583ad93b9f$var$internalObjectProto);
const $78da16583ad93b9f$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $78da16583ad93b9f$var$internalObjectProto;
function $78da16583ad93b9f$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $78da16583ad93b9f$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $78da16583ad93b9f$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $8bTPG.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $78da16583ad93b9f$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $78da16583ad93b9f$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $8bTPG.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($78da16583ad93b9f$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $X5A94.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $X5A94.camelize)(key);
                        props[camelizedKey] = $78da16583ad93b9f$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($78da16583ad93b9f$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $X5A94.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $X5A94.hyphenate)(key)) === key || !(0, $X5A94.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $78da16583ad93b9f$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $X5A94.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $8bTPG.trigger)(instance.attrs, "set", "");
}
function $78da16583ad93b9f$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $X5A94.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $X5A94.hasOwn)(options, camelKey = (0, $X5A94.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$78da16583ad93b9f$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $8bTPG.toRaw)(props);
        const castValues = rawCastValues || (0, $X5A94.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $78da16583ad93b9f$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $X5A94.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $78da16583ad93b9f$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $X5A94.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $X5A94.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $78da16583ad93b9f$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $X5A94.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $78da16583ad93b9f$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $78da16583ad93b9f$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $78da16583ad93b9f$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $X5A94.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $78da16583ad93b9f$var$normalizePropsOptions(raw2, appContext, true);
            (0, $X5A94.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $X5A94.isObject)(comp)) cache.set(comp, (0, $X5A94.EMPTY_ARR));
        return 0, $X5A94.EMPTY_ARR;
    }
    if ((0, $X5A94.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $X5A94.camelize)(raw[i]);
        if ($78da16583ad93b9f$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $X5A94.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $X5A94.camelize)(key);
        if ($78da16583ad93b9f$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $X5A94.isArray)(opt) || (0, $X5A94.isFunction)(opt) ? {
                type: opt
            } : (0, $X5A94.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $X5A94.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $X5A94.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $X5A94.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $X5A94.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $X5A94.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $78da16583ad93b9f$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $X5A94.isReservedProp)(key)) return true;
    return false;
}
function $78da16583ad93b9f$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $78da16583ad93b9f$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $8bTPG.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $X5A94.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $78da16583ad93b9f$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $78da16583ad93b9f$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $78da16583ad93b9f$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $X5A94.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $78da16583ad93b9f$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $78da16583ad93b9f$var$warn$1($78da16583ad93b9f$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $78da16583ad93b9f$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $78da16583ad93b9f$var$isSimpleType = /* @__PURE__ */ (0, $X5A94.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $78da16583ad93b9f$var$assertType(value, type) {
    let valid;
    const expectedType = $78da16583ad93b9f$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($78da16583ad93b9f$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $X5A94.isObject)(value);
    else if (expectedType === "Array") valid = (0, $X5A94.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $78da16583ad93b9f$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $X5A94.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $X5A94.toRawType)(value);
    const expectedValue = $78da16583ad93b9f$var$styleValue(value, expectedType);
    const receivedValue = $78da16583ad93b9f$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $78da16583ad93b9f$var$isExplicable(expectedType) && !$78da16583ad93b9f$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($78da16583ad93b9f$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $78da16583ad93b9f$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $78da16583ad93b9f$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $78da16583ad93b9f$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $78da16583ad93b9f$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $78da16583ad93b9f$var$normalizeSlotValue = (value)=>(0, $X5A94.isArray)(value) ? value.map($78da16583ad93b9f$var$normalizeVNode) : [
        $78da16583ad93b9f$var$normalizeVNode(value)
    ];
const $78da16583ad93b9f$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $78da16583ad93b9f$export$694b237e827a3d23((...args)=>{
        return $78da16583ad93b9f$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $78da16583ad93b9f$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($78da16583ad93b9f$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $X5A94.isFunction)(value)) slots[key] = $78da16583ad93b9f$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $78da16583ad93b9f$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $78da16583ad93b9f$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $78da16583ad93b9f$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $78da16583ad93b9f$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$78da16583ad93b9f$var$isInternalKey(key)) slots[key] = children[key];
};
const $78da16583ad93b9f$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $78da16583ad93b9f$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $78da16583ad93b9f$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $X5A94.def)(slots, "_", type, true);
        } else $78da16583ad93b9f$var$normalizeObjectSlots(children, slots);
    } else if (children) $78da16583ad93b9f$var$normalizeVNodeSlots(instance, children);
};
const $78da16583ad93b9f$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $X5A94.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $78da16583ad93b9f$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $78da16583ad93b9f$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $78da16583ad93b9f$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$78da16583ad93b9f$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $78da16583ad93b9f$var$supported;
let $78da16583ad93b9f$var$perf;
function $78da16583ad93b9f$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $78da16583ad93b9f$var$isSupported()) $78da16583ad93b9f$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsPerfStart(instance, type, $78da16583ad93b9f$var$isSupported() ? $78da16583ad93b9f$var$perf.now() : Date.now());
}
function $78da16583ad93b9f$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $78da16583ad93b9f$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$78da16583ad93b9f$var$formatComponentName(instance, instance.type)}> ${type}`;
        $78da16583ad93b9f$var$perf.mark(endTag);
        $78da16583ad93b9f$var$perf.measure(measureName, startTag, endTag);
        $78da16583ad93b9f$var$perf.clearMeasures(measureName);
        $78da16583ad93b9f$var$perf.clearMarks(startTag);
        $78da16583ad93b9f$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsPerfEnd(instance, type, $78da16583ad93b9f$var$isSupported() ? $78da16583ad93b9f$var$perf.now() : Date.now());
}
function $78da16583ad93b9f$var$isSupported() {
    if ($78da16583ad93b9f$var$supported !== void 0) return $78da16583ad93b9f$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $78da16583ad93b9f$var$supported = true;
        $78da16583ad93b9f$var$perf = window.performance;
    } else $78da16583ad93b9f$var$supported = false;
    return $78da16583ad93b9f$var$supported;
}
function $78da16583ad93b9f$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $X5A94.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $X5A94.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $X5A94.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $78da16583ad93b9f$var$queuePostRenderEffect = $78da16583ad93b9f$var$queueEffectWithSuspense;
function $78da16583ad93b9f$export$53ae2f996c64e9a(options) {
    return $78da16583ad93b9f$var$baseCreateRenderer(options);
}
function $78da16583ad93b9f$export$200524cf0d997ff0(options) {
    return $78da16583ad93b9f$var$baseCreateRenderer(options, $78da16583ad93b9f$var$createHydrationFunctions);
}
function $78da16583ad93b9f$var$baseCreateRenderer(options, createHydrationFns) {
    $78da16583ad93b9f$var$initFeatureFlags();
    const target = (0, $X5A94.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $X5A94.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$78da16583ad93b9f$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $78da16583ad93b9f$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $78da16583ad93b9f$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $78da16583ad93b9f$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $78da16583ad93b9f$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $78da16583ad93b9f$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $78da16583ad93b9f$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $X5A94.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $X5A94.def)(el, "__vnode", vnode, true);
            (0, $X5A94.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $78da16583ad93b9f$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            vnodeHook && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $78da16583ad93b9f$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(children[i]) : $78da16583ad93b9f$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $X5A94.EMPTY_OBJ);
        const newProps = n2.props || (0, $X5A94.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $78da16583ad93b9f$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $78da16583ad93b9f$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $78da16583ad93b9f$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            vnodeHook && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $78da16583ad93b9f$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $78da16583ad93b9f$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$78da16583ad93b9f$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $X5A94.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $X5A94.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $X5A94.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $78da16583ad93b9f$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $78da16583ad93b9f$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($78da16583ad93b9f$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $78da16583ad93b9f$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($78da16583ad93b9f$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $78da16583ad93b9f$var$isAsyncWrapper(initialVNode);
                $78da16583ad93b9f$var$toggleRecurse(instance, false);
                if (bm) (0, $X5A94.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $78da16583ad93b9f$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $78da16583ad93b9f$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && // @ts-expect-error _def is private
                    root.ce._def.shadowRoot !== false) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = $78da16583ad93b9f$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $78da16583ad93b9f$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $78da16583ad93b9f$var$queuePostRenderEffect(()=>$78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $78da16583ad93b9f$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $78da16583ad93b9f$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $78da16583ad93b9f$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $78da16583ad93b9f$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $X5A94.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $78da16583ad93b9f$var$toggleRecurse(instance, true);
                const nextTree = $78da16583ad93b9f$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $78da16583ad93b9f$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $78da16583ad93b9f$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $78da16583ad93b9f$var$queuePostRenderEffect(()=>$78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $8bTPG.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$78da16583ad93b9f$var$queueJob(job);
        $78da16583ad93b9f$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $78da16583ad93b9f$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $78da16583ad93b9f$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $8bTPG.pauseTracking)();
        $78da16583ad93b9f$var$flushPreFlushCbs(instance);
        (0, $8bTPG.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $X5A94.EMPTY_ARR);
        c2 = c2 || (0, $X5A94.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]);
            if ($78da16583ad93b9f$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[e2]) : $78da16583ad93b9f$var$normalizeVNode(c2[e2]);
            if ($78da16583ad93b9f$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $78da16583ad93b9f$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $78da16583ad93b9f$var$getSequence(newIndexToOldIndexMap) : (0, $X5A94.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, fallback to el placeholder for unresolved async component
                anchorVNode.el || anchorVNode.placeholder : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $78da16583ad93b9f$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $78da16583ad93b9f$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $78da16583ad93b9f$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    if (el._isLeaving) el[$78da16583ad93b9f$var$leaveCbKey](true);
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $8bTPG.pauseTracking)();
            $78da16583ad93b9f$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $8bTPG.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$78da16583ad93b9f$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $78da16583ad93b9f$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $78da16583ad93b9f$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            vnodeHook && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $78da16583ad93b9f$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $78da16583ad93b9f$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $78da16583ad93b9f$var$invalidateMount(m);
        $78da16583ad93b9f$var$invalidateMount(a);
        if (bum) (0, $X5A94.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $78da16583ad93b9f$var$queuePostRenderEffect(um, parentSuspense);
        $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$78da16583ad93b9f$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $78da16583ad93b9f$var$flushPreFlushCbs();
            $78da16583ad93b9f$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $78da16583ad93b9f$var$createAppAPI(render, hydrate)
    };
}
function $78da16583ad93b9f$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $78da16583ad93b9f$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $78da16583ad93b9f$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $78da16583ad93b9f$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $X5A94.isArray)(ch1) && (0, $X5A94.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $78da16583ad93b9f$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $78da16583ad93b9f$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $78da16583ad93b9f$export$5f1af8db9871e1d6 && // avoid cached text nodes retaining detached dom nodes
        c2.patchFlag !== -1) c2.el = c1.el;
        if (c2.type === $78da16583ad93b9f$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $78da16583ad93b9f$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $78da16583ad93b9f$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $78da16583ad93b9f$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $78da16583ad93b9f$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const $78da16583ad93b9f$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $78da16583ad93b9f$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $78da16583ad93b9f$export$a976684a0efeb93f($78da16583ad93b9f$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $78da16583ad93b9f$export$ede35fc0e5500309(effect, options) {
    return $78da16583ad93b9f$var$doWatch(effect, null, options);
}
function $78da16583ad93b9f$export$b7f27ea67102d543(effect, options) {
    return $78da16583ad93b9f$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $78da16583ad93b9f$export$2035654f31b0e555(effect, options) {
    return $78da16583ad93b9f$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $78da16583ad93b9f$export$3db5d71bdb2d5499(source, cb, options) {
    return $78da16583ad93b9f$var$doWatch(source, cb, options);
}
function $78da16583ad93b9f$var$doWatch(source, cb, options = (0, $X5A94.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $X5A94.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($78da16583ad93b9f$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $78da16583ad93b9f$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $X5A94.NOOP);
            watchStopHandle.resume = (0, $X5A94.NOOP);
            watchStopHandle.pause = (0, $X5A94.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $78da16583ad93b9f$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$78da16583ad93b9f$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $78da16583ad93b9f$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $78da16583ad93b9f$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $8bTPG.watch)(source, cb, baseWatchOptions);
    if ($78da16583ad93b9f$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $78da16583ad93b9f$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $X5A94.isString)(source) ? source.includes(".") ? $78da16583ad93b9f$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $X5A94.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $78da16583ad93b9f$var$setCurrentInstance(this);
    const res = $78da16583ad93b9f$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $78da16583ad93b9f$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $78da16583ad93b9f$export$fb78bd113157f1a1(props, name, options = (0, $X5A94.EMPTY_OBJ)) {
    const i = $78da16583ad93b9f$export$f13e630aa3915748();
    const camelizedName = (0, $X5A94.camelize)(name);
    const hyphenatedName = (0, $X5A94.hyphenate)(name);
    const modifiers = $78da16583ad93b9f$var$getModelModifiers(props, camelizedName);
    const res = (0, $8bTPG.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $X5A94.EMPTY_OBJ);
        let prevEmittedValue;
        $78da16583ad93b9f$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $X5A94.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $X5A94.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $X5A94.hasChanged)(value, emittedValue) && (0, $X5A94.hasChanged)(value, prevSetValue) && !(0, $X5A94.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $X5A94.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $78da16583ad93b9f$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $X5A94.camelize)(modelName)}Modifiers`] || props[`${(0, $X5A94.hyphenate)(modelName)}Modifiers`];
};
function $78da16583ad93b9f$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $X5A94.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $78da16583ad93b9f$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $X5A94.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $X5A94.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $X5A94.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $X5A94.toHandlerKey)((0, $X5A94.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $X5A94.toHandlerKey)((0, $X5A94.hyphenate)(event))];
    if (handler) $78da16583ad93b9f$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $78da16583ad93b9f$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $78da16583ad93b9f$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $X5A94.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $78da16583ad93b9f$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $X5A94.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $X5A94.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $X5A94.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $X5A94.extend)(normalized, raw);
    if ((0, $X5A94.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $78da16583ad93b9f$var$isEmitListener(options, key) {
    if (!options || !(0, $X5A94.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $X5A94.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $X5A94.hasOwn)(options, (0, $X5A94.hyphenate)(key)) || (0, $X5A94.hasOwn)(options, key);
}
let $78da16583ad93b9f$var$accessedAttrs = false;
function $78da16583ad93b9f$var$markAttrsAccessed() {
    $78da16583ad93b9f$var$accessedAttrs = true;
}
function $78da16583ad93b9f$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $78da16583ad93b9f$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $78da16583ad93b9f$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $78da16583ad93b9f$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $78da16583ad93b9f$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $78da16583ad93b9f$var$blockStack.length = 0;
        $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, 1);
        result = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $X5A94.isModelListener))) fallthroughAttrs = $78da16583ad93b9f$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $78da16583ad93b9f$export$7770a22486565649(root, vnode.transition);
    result = root;
    $78da16583ad93b9f$var$setCurrentRenderingInstance(prev);
    return result;
}
const $78da16583ad93b9f$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $78da16583ad93b9f$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $78da16583ad93b9f$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $78da16583ad93b9f$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($78da16583ad93b9f$export$3868d13f8734ae81(child)) {
            if (child.type !== $78da16583ad93b9f$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $78da16583ad93b9f$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $X5A94.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $78da16583ad93b9f$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $X5A94.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $78da16583ad93b9f$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $78da16583ad93b9f$export$4d299b491347818a;
};
function $78da16583ad93b9f$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $78da16583ad93b9f$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$78da16583ad93b9f$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $78da16583ad93b9f$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $78da16583ad93b9f$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$78da16583ad93b9f$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $78da16583ad93b9f$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $78da16583ad93b9f$var$isSuspense = (type)=>type.__isSuspense;
let $78da16583ad93b9f$var$suspenseId = 0;
const $78da16583ad93b9f$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $78da16583ad93b9f$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $78da16583ad93b9f$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $78da16583ad93b9f$var$hydrateSuspense,
    normalize: $78da16583ad93b9f$var$normalizeSuspenseChildren
};
const $78da16583ad93b9f$export$74bf444e3cd11ea5 = $78da16583ad93b9f$var$SuspenseImpl;
function $78da16583ad93b9f$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $X5A94.isFunction)(eventListener)) eventListener();
}
function $78da16583ad93b9f$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $78da16583ad93b9f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $78da16583ad93b9f$var$triggerEvent(vnode, "onPending");
        $78da16583ad93b9f$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $78da16583ad93b9f$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $78da16583ad93b9f$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($78da16583ad93b9f$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $78da16583ad93b9f$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $78da16583ad93b9f$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $78da16583ad93b9f$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $78da16583ad93b9f$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $78da16583ad93b9f$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $78da16583ad93b9f$var$setActiveBranch(suspense, newBranch);
    } else {
        $78da16583ad93b9f$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $78da16583ad93b9f$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $78da16583ad93b9f$var$hasWarned = false;
function $78da16583ad93b9f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $78da16583ad93b9f$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $X5A94.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $78da16583ad93b9f$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $78da16583ad93b9f$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $78da16583ad93b9f$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $78da16583ad93b9f$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $78da16583ad93b9f$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $78da16583ad93b9f$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $78da16583ad93b9f$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $78da16583ad93b9f$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $78da16583ad93b9f$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $78da16583ad93b9f$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $78da16583ad93b9f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $78da16583ad93b9f$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $78da16583ad93b9f$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $78da16583ad93b9f$var$normalizeSuspenseSlot(children.fallback) : $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
}
function $78da16583ad93b9f$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $X5A94.isFunction)(s)) {
        const trackBlock = $78da16583ad93b9f$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $78da16583ad93b9f$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $78da16583ad93b9f$var$currentBlock;
            $78da16583ad93b9f$var$closeBlock();
        }
    }
    if ((0, $X5A94.isArray)(s)) {
        const singleChild = $78da16583ad93b9f$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $78da16583ad93b9f$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $78da16583ad93b9f$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $X5A94.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $78da16583ad93b9f$export$59536a0199721cab(fn);
}
function $78da16583ad93b9f$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $78da16583ad93b9f$var$updateHOCHostEl(parentComponent, el);
    }
}
function $78da16583ad93b9f$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $78da16583ad93b9f$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $78da16583ad93b9f$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $78da16583ad93b9f$export$4d299b491347818a = Symbol.for("v-cmt");
const $78da16583ad93b9f$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $78da16583ad93b9f$var$blockStack = [];
let $78da16583ad93b9f$var$currentBlock = null;
function $78da16583ad93b9f$export$e7eaa45e502fe5cc(disableTracking = false) {
    $78da16583ad93b9f$var$blockStack.push($78da16583ad93b9f$var$currentBlock = disableTracking ? null : []);
}
function $78da16583ad93b9f$var$closeBlock() {
    $78da16583ad93b9f$var$blockStack.pop();
    $78da16583ad93b9f$var$currentBlock = $78da16583ad93b9f$var$blockStack[$78da16583ad93b9f$var$blockStack.length - 1] || null;
}
let $78da16583ad93b9f$var$isBlockTreeEnabled = 1;
function $78da16583ad93b9f$export$c20bee82f26f1e27(value, inVOnce = false) {
    $78da16583ad93b9f$var$isBlockTreeEnabled += value;
    if (value < 0 && $78da16583ad93b9f$var$currentBlock && inVOnce) $78da16583ad93b9f$var$currentBlock.hasOnce = true;
}
function $78da16583ad93b9f$var$setupBlock(vnode) {
    vnode.dynamicChildren = $78da16583ad93b9f$var$isBlockTreeEnabled > 0 ? $78da16583ad93b9f$var$currentBlock || (0, $X5A94.EMPTY_ARR) : null;
    $78da16583ad93b9f$var$closeBlock();
    if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && $78da16583ad93b9f$var$currentBlock) $78da16583ad93b9f$var$currentBlock.push(vnode);
    return vnode;
}
function $78da16583ad93b9f$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $78da16583ad93b9f$var$setupBlock($78da16583ad93b9f$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $78da16583ad93b9f$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $78da16583ad93b9f$var$setupBlock($78da16583ad93b9f$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $78da16583ad93b9f$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $78da16583ad93b9f$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $78da16583ad93b9f$var$vnodeArgsTransformer;
function $78da16583ad93b9f$export$83beccd3afeeb809(transformer) {
    $78da16583ad93b9f$var$vnodeArgsTransformer = transformer;
}
const $78da16583ad93b9f$var$createVNodeWithArgsTransform = (...args)=>{
    return $78da16583ad93b9f$var$_createVNode(...$78da16583ad93b9f$var$vnodeArgsTransformer ? $78da16583ad93b9f$var$vnodeArgsTransformer(args, $78da16583ad93b9f$var$currentRenderingInstance) : args);
};
const $78da16583ad93b9f$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $78da16583ad93b9f$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $X5A94.isString)(ref) || (0, $8bTPG.isRef)(ref) || (0, $X5A94.isFunction)(ref) ? {
        i: $78da16583ad93b9f$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $78da16583ad93b9f$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $78da16583ad93b9f$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $78da16583ad93b9f$var$normalizeKey(props),
        ref: props && $78da16583ad93b9f$var$normalizeRef(props),
        scopeId: $78da16583ad93b9f$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $78da16583ad93b9f$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $78da16583ad93b9f$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $X5A94.isString)(children) ? 8 : 16;
    if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $78da16583ad93b9f$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $78da16583ad93b9f$var$currentBlock.push(vnode);
    return vnode;
}
const $78da16583ad93b9f$export$bf5c4cf060303d58 = $78da16583ad93b9f$var$_createVNode;
function $78da16583ad93b9f$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $78da16583ad93b9f$var$NULL_DYNAMIC_COMPONENT) type = $78da16583ad93b9f$export$4d299b491347818a;
    if ($78da16583ad93b9f$export$3868d13f8734ae81(type)) {
        const cloned = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $78da16583ad93b9f$var$normalizeChildren(cloned, children);
        if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && !isBlockNode && $78da16583ad93b9f$var$currentBlock) {
            if (cloned.shapeFlag & 6) $78da16583ad93b9f$var$currentBlock[$78da16583ad93b9f$var$currentBlock.indexOf(type)] = cloned;
            else $78da16583ad93b9f$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($78da16583ad93b9f$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $78da16583ad93b9f$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $X5A94.isString)(klass)) props.class = (0, $X5A94.normalizeClass)(klass);
        if ((0, $X5A94.isObject)(style)) {
            if ((0, $8bTPG.isProxy)(style) && !(0, $X5A94.isArray)(style)) style = (0, $X5A94.extend)({}, style);
            props.style = (0, $X5A94.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $X5A94.isString)(type) ? 1 : $78da16583ad93b9f$var$isSuspense(type) ? 128 : $78da16583ad93b9f$var$isTeleport(type) ? 64 : (0, $X5A94.isObject)(type) ? 4 : (0, $X5A94.isFunction)(type) ? 2 : 0;
    return $78da16583ad93b9f$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $78da16583ad93b9f$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $8bTPG.isProxy)(props) || $78da16583ad93b9f$var$isInternalObject(props) ? (0, $X5A94.extend)({}, props) : props;
}
function $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $78da16583ad93b9f$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $78da16583ad93b9f$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $X5A94.isArray)(ref) ? ref.concat($78da16583ad93b9f$var$normalizeRef(extraProps)) : [
            ref,
            $78da16583ad93b9f$var$normalizeRef(extraProps)
        ] : $78da16583ad93b9f$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $78da16583ad93b9f$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $78da16583ad93b9f$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $78da16583ad93b9f$var$deepCloneVNode(vnode) {
    const cloned = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $X5A94.isArray)(vnode.children)) cloned.children = vnode.children.map($78da16583ad93b9f$var$deepCloneVNode);
    return cloned;
}
function $78da16583ad93b9f$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$5f1af8db9871e1d6, null, text, flag);
}
function $78da16583ad93b9f$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $78da16583ad93b9f$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($78da16583ad93b9f$export$e7eaa45e502fe5cc(), $78da16583ad93b9f$export$9f2dfe8048dfb22b($78da16583ad93b9f$export$4d299b491347818a, null, text)) : $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a, null, text);
}
function $78da16583ad93b9f$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
    else if ((0, $X5A94.isArray)(child)) return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($78da16583ad93b9f$export$3868d13f8734ae81(child)) return $78da16583ad93b9f$var$cloneIfMounted(child);
    else return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$5f1af8db9871e1d6, null, String(child));
}
function $78da16583ad93b9f$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $78da16583ad93b9f$export$ee4f9e12c0a92a1a(child);
}
function $78da16583ad93b9f$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $X5A94.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $78da16583ad93b9f$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$78da16583ad93b9f$var$isInternalObject(children)) children._ctx = $78da16583ad93b9f$var$currentRenderingInstance;
            else if (slotFlag === 3 && $78da16583ad93b9f$var$currentRenderingInstance) {
                if ($78da16583ad93b9f$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $X5A94.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $78da16583ad93b9f$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $78da16583ad93b9f$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $78da16583ad93b9f$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $X5A94.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $X5A94.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $X5A94.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $X5A94.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $78da16583ad93b9f$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $78da16583ad93b9f$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $78da16583ad93b9f$var$emptyAppContext = $78da16583ad93b9f$var$createAppContext();
let $78da16583ad93b9f$var$uid = 0;
function $78da16583ad93b9f$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $78da16583ad93b9f$var$emptyAppContext;
    const instance = {
        uid: $78da16583ad93b9f$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $8bTPG.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $78da16583ad93b9f$var$normalizePropsOptions(type, appContext),
        emitsOptions: $78da16583ad93b9f$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $X5A94.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $X5A94.EMPTY_OBJ),
        data: (0, $X5A94.EMPTY_OBJ),
        props: (0, $X5A94.EMPTY_OBJ),
        attrs: (0, $X5A94.EMPTY_OBJ),
        slots: (0, $X5A94.EMPTY_OBJ),
        refs: (0, $X5A94.EMPTY_OBJ),
        setupState: (0, $X5A94.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $78da16583ad93b9f$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $78da16583ad93b9f$var$currentInstance = null;
const $78da16583ad93b9f$export$f13e630aa3915748 = ()=>$78da16583ad93b9f$var$currentInstance || $78da16583ad93b9f$var$currentRenderingInstance;
let $78da16583ad93b9f$var$internalSetCurrentInstance;
let $78da16583ad93b9f$var$setInSSRSetupState;
{
    const g = (0, $X5A94.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $78da16583ad93b9f$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$78da16583ad93b9f$var$currentInstance = v1);
    $78da16583ad93b9f$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$78da16583ad93b9f$var$isInSSRComponentSetup = v1);
}const $78da16583ad93b9f$var$setCurrentInstance = (instance)=>{
    const prev = $78da16583ad93b9f$var$currentInstance;
    $78da16583ad93b9f$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $78da16583ad93b9f$var$internalSetCurrentInstance(prev);
    };
};
const $78da16583ad93b9f$var$unsetCurrentInstance = ()=>{
    $78da16583ad93b9f$var$currentInstance && $78da16583ad93b9f$var$currentInstance.scope.off();
    $78da16583ad93b9f$var$internalSetCurrentInstance(null);
};
const $78da16583ad93b9f$var$isBuiltInTag = /* @__PURE__ */ (0, $X5A94.makeMap)("slot,component");
function $78da16583ad93b9f$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($78da16583ad93b9f$var$isBuiltInTag(name) || isNativeTag(name)) $78da16583ad93b9f$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $78da16583ad93b9f$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $78da16583ad93b9f$var$isInSSRComponentSetup = false;
function $78da16583ad93b9f$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $78da16583ad93b9f$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $78da16583ad93b9f$var$isStatefulComponent(instance);
    $78da16583ad93b9f$var$initProps(instance, props, isStateful, isSSR);
    $78da16583ad93b9f$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $78da16583ad93b9f$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $78da16583ad93b9f$var$setInSSRSetupState(false);
    return setupResult;
}
function $78da16583ad93b9f$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $78da16583ad93b9f$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $8bTPG.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $78da16583ad93b9f$var$createSetupContext(instance) : null;
        const reset = $78da16583ad93b9f$var$setCurrentInstance(instance);
        const setupResult = $78da16583ad93b9f$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $X5A94.isPromise)(setupResult);
        (0, $8bTPG.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$78da16583ad93b9f$var$isAsyncWrapper(instance)) $78da16583ad93b9f$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($78da16583ad93b9f$var$unsetCurrentInstance, $78da16583ad93b9f$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $78da16583ad93b9f$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $78da16583ad93b9f$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $78da16583ad93b9f$var$handleSetupResult(instance, setupResult, isSSR);
    } else $78da16583ad93b9f$var$finishComponentSetup(instance, isSSR);
}
function $78da16583ad93b9f$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $X5A94.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $X5A94.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $8bTPG.proxyRefs)(setupResult);
    }
    $78da16583ad93b9f$var$finishComponentSetup(instance, isSSR);
}
let $78da16583ad93b9f$var$compile;
let $78da16583ad93b9f$var$installWithProxy;
function $78da16583ad93b9f$export$667bb5a67822b941(_compile) {
    $78da16583ad93b9f$var$compile = _compile;
    $78da16583ad93b9f$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $78da16583ad93b9f$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $78da16583ad93b9f$export$c93a9c496c5211fa = ()=>!$78da16583ad93b9f$var$compile;
function $78da16583ad93b9f$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $78da16583ad93b9f$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $78da16583ad93b9f$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $X5A94.extend)((0, $X5A94.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $78da16583ad93b9f$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $X5A94.NOOP);
        if ($78da16583ad93b9f$var$installWithProxy) $78da16583ad93b9f$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $78da16583ad93b9f$var$setCurrentInstance(instance);
        (0, $8bTPG.pauseTracking)();
        try {
            $78da16583ad93b9f$var$applyOptions(instance);
        } finally{
            (0, $8bTPG.resetTracking)();
            reset();
        }
    }
}
const $78da16583ad93b9f$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $8bTPG.track)(target, "get", "");
        return target[key];
    }
};
function $78da16583ad93b9f$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $8bTPG.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $78da16583ad93b9f$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $78da16583ad93b9f$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $78da16583ad93b9f$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $8bTPG.proxyRefs)((0, $8bTPG.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $78da16583ad93b9f$var$publicPropertiesMap) return $78da16583ad93b9f$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $78da16583ad93b9f$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $78da16583ad93b9f$var$classifyRE = /(?:^|[-_])(\w)/g;
const $78da16583ad93b9f$var$classify = (str)=>str.replace($78da16583ad93b9f$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $78da16583ad93b9f$var$getComponentName(Component, includeInferred = true) {
    return (0, $X5A94.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $78da16583ad93b9f$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $78da16583ad93b9f$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $78da16583ad93b9f$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $78da16583ad93b9f$var$isClassComponent(value) {
    return (0, $X5A94.isFunction)(value) && "__vccOpts" in value;
}
const $78da16583ad93b9f$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $8bTPG.computed)(getterOrOptions, debugOptions, $78da16583ad93b9f$var$isInSSRComponentSetup);
    return c;
};
function $78da16583ad93b9f$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $X5A94.isObject)(propsOrChildren) && !(0, $X5A94.isArray)(propsOrChildren)) {
            if ($78da16583ad93b9f$export$3868d13f8734ae81(propsOrChildren)) return $78da16583ad93b9f$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $78da16583ad93b9f$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $78da16583ad93b9f$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $78da16583ad93b9f$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $78da16583ad93b9f$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $78da16583ad93b9f$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $8bTPG.toRaw)(instance.props)));
        if (instance.setupState !== (0, $X5A94.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $X5A94.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $8bTPG.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $X5A94.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $X5A94.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $8bTPG.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $X5A94.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $X5A94.isArray)(opts) && opts.includes(key) || (0, $X5A94.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $8bTPG.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $78da16583ad93b9f$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $78da16583ad93b9f$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $78da16583ad93b9f$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $X5A94.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && $78da16583ad93b9f$var$currentBlock) $78da16583ad93b9f$var$currentBlock.push(cached);
    return true;
}
const $78da16583ad93b9f$export$83d89fbfd8236492 = "3.5.20";
const $78da16583ad93b9f$export$c106dd0671a0fc2d = (0, $X5A94.NOOP);
const $78da16583ad93b9f$export$795e0ad4a0e2ed30 = $78da16583ad93b9f$var$ErrorTypeStrings$1;
const $78da16583ad93b9f$export$6922d3b3a607469e = $78da16583ad93b9f$var$devtools$1;
const $78da16583ad93b9f$export$b0c258b32c26c785 = $78da16583ad93b9f$var$setDevtoolsHook$1;
const $78da16583ad93b9f$var$_ssrUtils = {
    createComponentInstance: $78da16583ad93b9f$var$createComponentInstance,
    setupComponent: $78da16583ad93b9f$var$setupComponent,
    renderComponentRoot: $78da16583ad93b9f$var$renderComponentRoot,
    setCurrentRenderingInstance: $78da16583ad93b9f$var$setCurrentRenderingInstance,
    isVNode: $78da16583ad93b9f$export$3868d13f8734ae81,
    normalizeVNode: $78da16583ad93b9f$var$normalizeVNode,
    getComponentPublicInstance: $78da16583ad93b9f$var$getComponentPublicInstance,
    ensureValidVNode: $78da16583ad93b9f$var$ensureValidVNode,
    pushWarningContext: $78da16583ad93b9f$var$pushWarningContext,
    popWarningContext: $78da16583ad93b9f$var$popWarningContext
};
const $78da16583ad93b9f$export$a9679033567b336d = $78da16583ad93b9f$var$_ssrUtils;
const $78da16583ad93b9f$export$83cf26e06ea620e1 = null;
const $78da16583ad93b9f$export$dc678eddf276286e = null;
const $78da16583ad93b9f$export$22072a82865312f6 = null;

});
parcelRegister("8bTPG", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $5f6aa8fade9cc028$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $5f6aa8fade9cc028$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $5f6aa8fade9cc028$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $5f6aa8fade9cc028$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $5f6aa8fade9cc028$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $5f6aa8fade9cc028$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $5f6aa8fade9cc028$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $5f6aa8fade9cc028$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $5f6aa8fade9cc028$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $5f6aa8fade9cc028$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $5f6aa8fade9cc028$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $5f6aa8fade9cc028$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $5f6aa8fade9cc028$export$5eb48af14254449e);
$parcel$export(module.exports, "isProxy", () => $5f6aa8fade9cc028$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $5f6aa8fade9cc028$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $5f6aa8fade9cc028$export$90a44edba14e47be);
$parcel$export(module.exports, "isReadonly", () => $5f6aa8fade9cc028$export$92d09b48637741e7);
$parcel$export(module.exports, "toReadonly", () => $5f6aa8fade9cc028$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "shallowReactive", () => $5f6aa8fade9cc028$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $5f6aa8fade9cc028$export$352205f445242f02);
$parcel$export(module.exports, "markRaw", () => $5f6aa8fade9cc028$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $5f6aa8fade9cc028$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $5f6aa8fade9cc028$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "triggerRef", () => $5f6aa8fade9cc028$export$f402f86588575ccc);
$parcel$export(module.exports, "unref", () => $5f6aa8fade9cc028$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $5f6aa8fade9cc028$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $5f6aa8fade9cc028$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $5f6aa8fade9cc028$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $5f6aa8fade9cc028$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "computed", () => $5f6aa8fade9cc028$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $5f6aa8fade9cc028$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $5f6aa8fade9cc028$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.20
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $X5A94 = parcelRequire("X5A94");
function $5f6aa8fade9cc028$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $5f6aa8fade9cc028$var$activeEffectScope;
class $5f6aa8fade9cc028$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = $5f6aa8fade9cc028$var$activeEffectScope;
        if (!detached && $5f6aa8fade9cc028$var$activeEffectScope) this.index = ($5f6aa8fade9cc028$var$activeEffectScope.scopes || ($5f6aa8fade9cc028$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $5f6aa8fade9cc028$var$activeEffectScope;
            try {
                $5f6aa8fade9cc028$var$activeEffectScope = this;
                return fn();
            } finally{
                $5f6aa8fade9cc028$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $5f6aa8fade9cc028$var$activeEffectScope;
            $5f6aa8fade9cc028$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            $5f6aa8fade9cc028$var$activeEffectScope = this.prevScope;
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $5f6aa8fade9cc028$export$7056603ea81600be(detached) {
    return new $5f6aa8fade9cc028$export$1168ed9dbc71ddbd(detached);
}
function $5f6aa8fade9cc028$export$c7be4b0125a10cba() {
    return $5f6aa8fade9cc028$var$activeEffectScope;
}
function $5f6aa8fade9cc028$export$a780418acd4762da(fn, failSilently = false) {
    if ($5f6aa8fade9cc028$var$activeEffectScope) $5f6aa8fade9cc028$var$activeEffectScope.cleanups.push(fn);
}
let $5f6aa8fade9cc028$var$activeSub;
const $5f6aa8fade9cc028$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $5f6aa8fade9cc028$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $5f6aa8fade9cc028$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($5f6aa8fade9cc028$var$activeEffectScope && $5f6aa8fade9cc028$var$activeEffectScope.active) $5f6aa8fade9cc028$var$activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($5f6aa8fade9cc028$var$pausedQueueEffects.has(this)) {
                $5f6aa8fade9cc028$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $5f6aa8fade9cc028$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $5f6aa8fade9cc028$var$cleanupEffect(this);
        $5f6aa8fade9cc028$var$prepareDeps(this);
        const prevEffect = $5f6aa8fade9cc028$var$activeSub;
        const prevShouldTrack = $5f6aa8fade9cc028$var$shouldTrack;
        $5f6aa8fade9cc028$var$activeSub = this;
        $5f6aa8fade9cc028$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $5f6aa8fade9cc028$var$cleanupDeps(this);
            $5f6aa8fade9cc028$var$activeSub = prevEffect;
            $5f6aa8fade9cc028$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$5f6aa8fade9cc028$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $5f6aa8fade9cc028$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $5f6aa8fade9cc028$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($5f6aa8fade9cc028$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $5f6aa8fade9cc028$var$isDirty(this);
    }
}
let $5f6aa8fade9cc028$var$batchDepth = 0;
let $5f6aa8fade9cc028$var$batchedSub;
let $5f6aa8fade9cc028$var$batchedComputed;
function $5f6aa8fade9cc028$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $5f6aa8fade9cc028$var$batchedComputed;
        $5f6aa8fade9cc028$var$batchedComputed = sub;
        return;
    }
    sub.next = $5f6aa8fade9cc028$var$batchedSub;
    $5f6aa8fade9cc028$var$batchedSub = sub;
}
function $5f6aa8fade9cc028$var$startBatch() {
    $5f6aa8fade9cc028$var$batchDepth++;
}
function $5f6aa8fade9cc028$var$endBatch() {
    if (--$5f6aa8fade9cc028$var$batchDepth > 0) return;
    if ($5f6aa8fade9cc028$var$batchedComputed) {
        let e = $5f6aa8fade9cc028$var$batchedComputed;
        $5f6aa8fade9cc028$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($5f6aa8fade9cc028$var$batchedSub){
        let e = $5f6aa8fade9cc028$var$batchedSub;
        $5f6aa8fade9cc028$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $5f6aa8fade9cc028$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $5f6aa8fade9cc028$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $5f6aa8fade9cc028$var$removeSub(link);
            $5f6aa8fade9cc028$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $5f6aa8fade9cc028$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($5f6aa8fade9cc028$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $5f6aa8fade9cc028$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $5f6aa8fade9cc028$var$globalVersion) return;
    computed.globalVersion = $5f6aa8fade9cc028$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$5f6aa8fade9cc028$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $5f6aa8fade9cc028$var$activeSub;
    const prevShouldTrack = $5f6aa8fade9cc028$var$shouldTrack;
    $5f6aa8fade9cc028$var$activeSub = computed;
    $5f6aa8fade9cc028$var$shouldTrack = true;
    try {
        $5f6aa8fade9cc028$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $X5A94.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $5f6aa8fade9cc028$var$activeSub = prevSub;
        $5f6aa8fade9cc028$var$shouldTrack = prevShouldTrack;
        $5f6aa8fade9cc028$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $5f6aa8fade9cc028$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$5f6aa8fade9cc028$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $5f6aa8fade9cc028$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $5f6aa8fade9cc028$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $5f6aa8fade9cc028$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $5f6aa8fade9cc028$export$28352bb4dd362521(fn);
    if (options) (0, $X5A94.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $5f6aa8fade9cc028$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $5f6aa8fade9cc028$var$shouldTrack = true;
const $5f6aa8fade9cc028$var$trackStack = [];
function $5f6aa8fade9cc028$export$938a971395fef855() {
    $5f6aa8fade9cc028$var$trackStack.push($5f6aa8fade9cc028$var$shouldTrack);
    $5f6aa8fade9cc028$var$shouldTrack = false;
}
function $5f6aa8fade9cc028$export$1f8ffc6fd33b1d16() {
    $5f6aa8fade9cc028$var$trackStack.push($5f6aa8fade9cc028$var$shouldTrack);
    $5f6aa8fade9cc028$var$shouldTrack = true;
}
function $5f6aa8fade9cc028$export$c39176b1babaa8b8() {
    const last = $5f6aa8fade9cc028$var$trackStack.pop();
    $5f6aa8fade9cc028$var$shouldTrack = last === void 0 ? true : last;
}
function $5f6aa8fade9cc028$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($5f6aa8fade9cc028$var$activeSub instanceof $5f6aa8fade9cc028$export$28352bb4dd362521) $5f6aa8fade9cc028$var$activeSub.cleanup = fn;
}
function $5f6aa8fade9cc028$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $5f6aa8fade9cc028$var$activeSub;
        $5f6aa8fade9cc028$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $5f6aa8fade9cc028$var$activeSub = prevSub;
        }
    }
}
let $5f6aa8fade9cc028$var$globalVersion = 0;
class $5f6aa8fade9cc028$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $5f6aa8fade9cc028$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$5f6aa8fade9cc028$var$activeSub || !$5f6aa8fade9cc028$var$shouldTrack || $5f6aa8fade9cc028$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $5f6aa8fade9cc028$var$activeSub) {
            link = this.activeLink = new $5f6aa8fade9cc028$var$Link($5f6aa8fade9cc028$var$activeSub, this);
            if (!$5f6aa8fade9cc028$var$activeSub.deps) $5f6aa8fade9cc028$var$activeSub.deps = $5f6aa8fade9cc028$var$activeSub.depsTail = link;
            else {
                link.prevDep = $5f6aa8fade9cc028$var$activeSub.depsTail;
                $5f6aa8fade9cc028$var$activeSub.depsTail.nextDep = link;
                $5f6aa8fade9cc028$var$activeSub.depsTail = link;
            }
            $5f6aa8fade9cc028$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $5f6aa8fade9cc028$var$activeSub.depsTail;
                link.nextDep = void 0;
                $5f6aa8fade9cc028$var$activeSub.depsTail.nextDep = link;
                $5f6aa8fade9cc028$var$activeSub.depsTail = link;
                if ($5f6aa8fade9cc028$var$activeSub.deps === link) $5f6aa8fade9cc028$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $5f6aa8fade9cc028$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $5f6aa8fade9cc028$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $5f6aa8fade9cc028$var$endBatch();
        }
    }
}
function $5f6aa8fade9cc028$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$5f6aa8fade9cc028$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $5f6aa8fade9cc028$var$targetMap = /* @__PURE__ */ new WeakMap();
const $5f6aa8fade9cc028$export$3c41b1a4e06acc14 = Symbol("");
const $5f6aa8fade9cc028$export$49093fa1cddcb78d = Symbol("");
const $5f6aa8fade9cc028$export$4f926f0baab682cd = Symbol("");
function $5f6aa8fade9cc028$export$6b2a7d5132615086(target, type, key) {
    if ($5f6aa8fade9cc028$var$shouldTrack && $5f6aa8fade9cc028$var$activeSub) {
        let depsMap = $5f6aa8fade9cc028$var$targetMap.get(target);
        if (!depsMap) $5f6aa8fade9cc028$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $5f6aa8fade9cc028$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $5f6aa8fade9cc028$var$targetMap.get(target);
    if (!depsMap) {
        $5f6aa8fade9cc028$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $5f6aa8fade9cc028$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $X5A94.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $X5A94.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $5f6aa8fade9cc028$export$4f926f0baab682cd || !(0, $X5A94.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($5f6aa8fade9cc028$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($5f6aa8fade9cc028$export$3c41b1a4e06acc14));
                        if ((0, $X5A94.isMap)(target)) run(depsMap.get($5f6aa8fade9cc028$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($5f6aa8fade9cc028$export$3c41b1a4e06acc14));
                        if ((0, $X5A94.isMap)(target)) run(depsMap.get($5f6aa8fade9cc028$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $X5A94.isMap)(target)) run(depsMap.get($5f6aa8fade9cc028$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $5f6aa8fade9cc028$var$endBatch();
}
function $5f6aa8fade9cc028$var$getDepFromReactive(object, key) {
    const depMap = $5f6aa8fade9cc028$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $5f6aa8fade9cc028$export$1544eab4943788e4(array) {
    const raw = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $5f6aa8fade9cc028$export$6b2a7d5132615086(raw, "iterate", $5f6aa8fade9cc028$export$4f926f0baab682cd);
    return $5f6aa8fade9cc028$export$7f3fe6025abfa26e(array) ? raw : raw.map($5f6aa8fade9cc028$export$45c769cf449a508c);
}
function $5f6aa8fade9cc028$export$5eb48af14254449e(arr) {
    $5f6aa8fade9cc028$export$6b2a7d5132615086(arr = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(arr), "iterate", $5f6aa8fade9cc028$export$4f926f0baab682cd);
    return arr;
}
const $5f6aa8fade9cc028$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $5f6aa8fade9cc028$var$iterator(this, Symbol.iterator, $5f6aa8fade9cc028$export$45c769cf449a508c);
    },
    concat (...args) {
        return $5f6aa8fade9cc028$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $X5A94.isArray)(x) ? $5f6aa8fade9cc028$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $5f6aa8fade9cc028$var$iterator(this, "entries", (value)=>{
            value[1] = $5f6aa8fade9cc028$export$45c769cf449a508c(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "filter", fn, thisArg, (v)=>v.map($5f6aa8fade9cc028$export$45c769cf449a508c), arguments);
    },
    find (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "find", fn, thisArg, $5f6aa8fade9cc028$export$45c769cf449a508c, arguments);
    },
    findIndex (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "findLast", fn, thisArg, $5f6aa8fade9cc028$export$45c769cf449a508c, arguments);
    },
    findLastIndex (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $5f6aa8fade9cc028$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $5f6aa8fade9cc028$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $5f6aa8fade9cc028$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $5f6aa8fade9cc028$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $5f6aa8fade9cc028$var$noTracking(this, "pop");
    },
    push (...args) {
        return $5f6aa8fade9cc028$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $5f6aa8fade9cc028$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $5f6aa8fade9cc028$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $5f6aa8fade9cc028$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $5f6aa8fade9cc028$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $5f6aa8fade9cc028$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $5f6aa8fade9cc028$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $5f6aa8fade9cc028$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $5f6aa8fade9cc028$var$noTracking(this, "unshift", args);
    },
    values () {
        return $5f6aa8fade9cc028$var$iterator(this, "values", $5f6aa8fade9cc028$export$45c769cf449a508c);
    }
};
function $5f6aa8fade9cc028$var$iterator(self, method, wrapValue) {
    const arr = $5f6aa8fade9cc028$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$5f6aa8fade9cc028$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $5f6aa8fade9cc028$var$arrayProto = Array.prototype;
function $5f6aa8fade9cc028$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $5f6aa8fade9cc028$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$5f6aa8fade9cc028$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $5f6aa8fade9cc028$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $5f6aa8fade9cc028$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $5f6aa8fade9cc028$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $5f6aa8fade9cc028$var$reduce(self, method, fn, args) {
    const arr = $5f6aa8fade9cc028$export$5eb48af14254449e(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!$5f6aa8fade9cc028$export$7f3fe6025abfa26e(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, $5f6aa8fade9cc028$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function $5f6aa8fade9cc028$var$searchProxy(self, method, args) {
    const arr = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(self);
    $5f6aa8fade9cc028$export$6b2a7d5132615086(arr, "iterate", $5f6aa8fade9cc028$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $5f6aa8fade9cc028$export$5f3ca29d057519b3(args[0])) {
        args[0] = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $5f6aa8fade9cc028$var$noTracking(self, method, args = []) {
    $5f6aa8fade9cc028$export$938a971395fef855();
    $5f6aa8fade9cc028$var$startBatch();
    const res = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $5f6aa8fade9cc028$var$endBatch();
    $5f6aa8fade9cc028$export$c39176b1babaa8b8();
    return res;
}
const $5f6aa8fade9cc028$var$isNonTrackableKeys = /* @__PURE__ */ (0, $X5A94.makeMap)(`__proto__,__v_isRef,__isVue`);
const $5f6aa8fade9cc028$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $X5A94.isSymbol)));
function $5f6aa8fade9cc028$var$hasOwnProperty(key) {
    if (!(0, $X5A94.isSymbol)(key)) key = String(key);
    const obj = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
    $5f6aa8fade9cc028$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $5f6aa8fade9cc028$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $5f6aa8fade9cc028$var$shallowReadonlyMap : $5f6aa8fade9cc028$var$readonlyMap : isShallow2 ? $5f6aa8fade9cc028$var$shallowReactiveMap : $5f6aa8fade9cc028$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $X5A94.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $5f6aa8fade9cc028$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $5f6aa8fade9cc028$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $5f6aa8fade9cc028$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $X5A94.isSymbol)(key) ? $5f6aa8fade9cc028$var$builtInSymbols.has(key) : $5f6aa8fade9cc028$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $5f6aa8fade9cc028$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $X5A94.isIntegerKey)(key) ? res : res.value;
        if ((0, $X5A94.isObject)(res)) return isReadonly2 ? $5f6aa8fade9cc028$export$6ec456bd5b7b3c51(res) : $5f6aa8fade9cc028$export$90a44edba14e47be(res);
        return res;
    }
}
class $5f6aa8fade9cc028$var$MutableReactiveHandler extends $5f6aa8fade9cc028$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $5f6aa8fade9cc028$export$92d09b48637741e7(oldValue);
            if (!$5f6aa8fade9cc028$export$7f3fe6025abfa26e(value) && !$5f6aa8fade9cc028$export$92d09b48637741e7(value)) {
                oldValue = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(oldValue);
                value = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $X5A94.isArray)(target) && $5f6aa8fade9cc028$export$4f9f5282de18fc69(oldValue) && !$5f6aa8fade9cc028$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $X5A94.isArray)(target) && (0, $X5A94.isIntegerKey)(key) ? Number(key) < target.length : (0, $X5A94.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $5f6aa8fade9cc028$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $5f6aa8fade9cc028$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $X5A94.hasChanged)(value, oldValue)) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $X5A94.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $X5A94.isSymbol)(key) || !$5f6aa8fade9cc028$var$builtInSymbols.has(key)) $5f6aa8fade9cc028$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $5f6aa8fade9cc028$export$6b2a7d5132615086(target, "iterate", (0, $X5A94.isArray)(target) ? "length" : $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $5f6aa8fade9cc028$var$ReadonlyReactiveHandler extends $5f6aa8fade9cc028$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $5f6aa8fade9cc028$var$mutableHandlers = /* @__PURE__ */ new $5f6aa8fade9cc028$var$MutableReactiveHandler();
const $5f6aa8fade9cc028$var$readonlyHandlers = /* @__PURE__ */ new $5f6aa8fade9cc028$var$ReadonlyReactiveHandler();
const $5f6aa8fade9cc028$var$shallowReactiveHandlers = /* @__PURE__ */ new $5f6aa8fade9cc028$var$MutableReactiveHandler(true);
const $5f6aa8fade9cc028$var$shallowReadonlyHandlers = /* @__PURE__ */ new $5f6aa8fade9cc028$var$ReadonlyReactiveHandler(true);
const $5f6aa8fade9cc028$var$toShallow = (value)=>value;
const $5f6aa8fade9cc028$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $5f6aa8fade9cc028$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $X5A94.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $5f6aa8fade9cc028$var$toShallow : isReadonly2 ? $5f6aa8fade9cc028$export$4a78e7a2a4fb689f : $5f6aa8fade9cc028$export$45c769cf449a508c;
        !isReadonly2 && $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $5f6aa8fade9cc028$export$49093fa1cddcb78d : $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $5f6aa8fade9cc028$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $5f6aa8fade9cc028$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
            const rawKey = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $X5A94.hasChanged)(key, rawKey)) $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "get", key);
                $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $5f6aa8fade9cc028$var$getProto(rawTarget);
            const wrap = shallow ? $5f6aa8fade9cc028$var$toShallow : readonly ? $5f6aa8fade9cc028$export$4a78e7a2a4fb689f : $5f6aa8fade9cc028$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $5f6aa8fade9cc028$export$6b2a7d5132615086($5f6aa8fade9cc028$export$ab18938b9fc5f28e(target), "iterate", $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
            const rawKey = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $X5A94.hasChanged)(key, rawKey)) $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "has", key);
                $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $5f6aa8fade9cc028$var$toShallow : readonly ? $5f6aa8fade9cc028$export$4a78e7a2a4fb689f : $5f6aa8fade9cc028$export$45c769cf449a508c;
            !readonly && $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "iterate", $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $X5A94.extend)(instrumentations, readonly ? {
        add: $5f6aa8fade9cc028$var$createReadonlyMethod("add"),
        set: $5f6aa8fade9cc028$var$createReadonlyMethod("set"),
        delete: $5f6aa8fade9cc028$var$createReadonlyMethod("delete"),
        clear: $5f6aa8fade9cc028$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !$5f6aa8fade9cc028$export$7f3fe6025abfa26e(value) && !$5f6aa8fade9cc028$export$92d09b48637741e7(value)) value = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
            const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
            const proto = $5f6aa8fade9cc028$var$getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$5f6aa8fade9cc028$export$7f3fe6025abfa26e(value) && !$5f6aa8fade9cc028$export$92d09b48637741e7(value)) value = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
            const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $5f6aa8fade9cc028$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $X5A94.hasChanged)(value, oldValue)) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $5f6aa8fade9cc028$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $5f6aa8fade9cc028$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $5f6aa8fade9cc028$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $5f6aa8fade9cc028$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $X5A94.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $5f6aa8fade9cc028$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentationGetter(false, false)
};
const $5f6aa8fade9cc028$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentationGetter(false, true)
};
const $5f6aa8fade9cc028$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentationGetter(true, false)
};
const $5f6aa8fade9cc028$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentationGetter(true, true)
};
function $5f6aa8fade9cc028$var$checkIdentityKeys(target, has, key) {
    const rawKey = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $X5A94.toRawType)(target);
        $5f6aa8fade9cc028$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $5f6aa8fade9cc028$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $5f6aa8fade9cc028$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $5f6aa8fade9cc028$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $5f6aa8fade9cc028$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $5f6aa8fade9cc028$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $5f6aa8fade9cc028$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $5f6aa8fade9cc028$var$targetTypeMap((0, $X5A94.toRawType)(value));
}
function $5f6aa8fade9cc028$export$90a44edba14e47be(target) {
    if ($5f6aa8fade9cc028$export$92d09b48637741e7(target)) return target;
    return $5f6aa8fade9cc028$var$createReactiveObject(target, false, $5f6aa8fade9cc028$var$mutableHandlers, $5f6aa8fade9cc028$var$mutableCollectionHandlers, $5f6aa8fade9cc028$var$reactiveMap);
}
function $5f6aa8fade9cc028$export$8d81cefd22d22260(target) {
    return $5f6aa8fade9cc028$var$createReactiveObject(target, false, $5f6aa8fade9cc028$var$shallowReactiveHandlers, $5f6aa8fade9cc028$var$shallowCollectionHandlers, $5f6aa8fade9cc028$var$shallowReactiveMap);
}
function $5f6aa8fade9cc028$export$6ec456bd5b7b3c51(target) {
    return $5f6aa8fade9cc028$var$createReactiveObject(target, true, $5f6aa8fade9cc028$var$readonlyHandlers, $5f6aa8fade9cc028$var$readonlyCollectionHandlers, $5f6aa8fade9cc028$var$readonlyMap);
}
function $5f6aa8fade9cc028$export$7c4b5f2b50f09f6b(target) {
    return $5f6aa8fade9cc028$var$createReactiveObject(target, true, $5f6aa8fade9cc028$var$shallowReadonlyHandlers, $5f6aa8fade9cc028$var$shallowReadonlyCollectionHandlers, $5f6aa8fade9cc028$var$shallowReadonlyMap);
}
function $5f6aa8fade9cc028$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $X5A94.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const targetType = $5f6aa8fade9cc028$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $5f6aa8fade9cc028$export$352205f445242f02(value) {
    if ($5f6aa8fade9cc028$export$92d09b48637741e7(value)) return $5f6aa8fade9cc028$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $5f6aa8fade9cc028$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $5f6aa8fade9cc028$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $5f6aa8fade9cc028$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $5f6aa8fade9cc028$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $5f6aa8fade9cc028$export$ab18938b9fc5f28e(raw) : observed;
}
function $5f6aa8fade9cc028$export$995ab8b13ad7a9d0(value) {
    if (!(0, $X5A94.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $X5A94.def)(value, "__v_skip", true);
    return value;
}
const $5f6aa8fade9cc028$export$45c769cf449a508c = (value)=>(0, $X5A94.isObject)(value) ? $5f6aa8fade9cc028$export$90a44edba14e47be(value) : value;
const $5f6aa8fade9cc028$export$4a78e7a2a4fb689f = (value)=>(0, $X5A94.isObject)(value) ? $5f6aa8fade9cc028$export$6ec456bd5b7b3c51(value) : value;
function $5f6aa8fade9cc028$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
function $5f6aa8fade9cc028$export$eff4d24c3ff7876e(value) {
    return $5f6aa8fade9cc028$var$createRef(value, false);
}
function $5f6aa8fade9cc028$export$9b7bc5fe3b17c8b3(value) {
    return $5f6aa8fade9cc028$var$createRef(value, true);
}
function $5f6aa8fade9cc028$var$createRef(rawValue, shallow) {
    if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $5f6aa8fade9cc028$var$RefImpl(rawValue, shallow);
}
class $5f6aa8fade9cc028$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $5f6aa8fade9cc028$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $5f6aa8fade9cc028$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $5f6aa8fade9cc028$export$7f3fe6025abfa26e(newValue) || $5f6aa8fade9cc028$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $5f6aa8fade9cc028$export$ab18938b9fc5f28e(newValue);
        if ((0, $X5A94.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $5f6aa8fade9cc028$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $5f6aa8fade9cc028$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $5f6aa8fade9cc028$export$a239a76781616204(ref2) {
    return $5f6aa8fade9cc028$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $5f6aa8fade9cc028$export$30bdcc2218aa9458(source) {
    return (0, $X5A94.isFunction)(source) ? source() : $5f6aa8fade9cc028$export$a239a76781616204(source);
}
const $5f6aa8fade9cc028$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $5f6aa8fade9cc028$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(oldValue) && !$5f6aa8fade9cc028$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $5f6aa8fade9cc028$export$f353fd1b97db3fa0(objectWithRefs) {
    return $5f6aa8fade9cc028$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $5f6aa8fade9cc028$var$shallowUnwrapHandlers);
}
class $5f6aa8fade9cc028$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $5f6aa8fade9cc028$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $5f6aa8fade9cc028$export$a20c2dd6199824cb(factory) {
    return new $5f6aa8fade9cc028$var$CustomRefImpl(factory);
}
function $5f6aa8fade9cc028$export$2e9533675e5e70e0(object) {
    const ret = (0, $X5A94.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $5f6aa8fade9cc028$var$propertyToRef(object, key);
    return ret;
}
class $5f6aa8fade9cc028$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $5f6aa8fade9cc028$var$getDepFromReactive($5f6aa8fade9cc028$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $5f6aa8fade9cc028$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function $5f6aa8fade9cc028$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $X5A94.isFunction)(source)) return new $5f6aa8fade9cc028$var$GetterRefImpl(source);
    else if ((0, $X5A94.isObject)(source) && arguments.length > 1) return $5f6aa8fade9cc028$var$propertyToRef(source, key, defaultValue);
    else return $5f6aa8fade9cc028$export$eff4d24c3ff7876e(source);
}
function $5f6aa8fade9cc028$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $5f6aa8fade9cc028$export$4f9f5282de18fc69(val) ? val : new $5f6aa8fade9cc028$var$ObjectRefImpl(source, key, defaultValue);
}
class $5f6aa8fade9cc028$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $5f6aa8fade9cc028$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $5f6aa8fade9cc028$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $5f6aa8fade9cc028$var$activeSub !== this) {
            $5f6aa8fade9cc028$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $5f6aa8fade9cc028$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
function $5f6aa8fade9cc028$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $X5A94.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $5f6aa8fade9cc028$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $5f6aa8fade9cc028$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $5f6aa8fade9cc028$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $5f6aa8fade9cc028$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $5f6aa8fade9cc028$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $5f6aa8fade9cc028$var$INITIAL_WATCHER_VALUE = {};
const $5f6aa8fade9cc028$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $5f6aa8fade9cc028$var$activeWatcher = void 0;
function $5f6aa8fade9cc028$export$2532f7acfca7c82d() {
    return $5f6aa8fade9cc028$var$activeWatcher;
}
function $5f6aa8fade9cc028$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $5f6aa8fade9cc028$var$activeWatcher) {
    if (owner) {
        let cleanups = $5f6aa8fade9cc028$var$cleanupMap.get(owner);
        if (!cleanups) $5f6aa8fade9cc028$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $5f6aa8fade9cc028$export$3db5d71bdb2d5499(source, cb, options = (0, $X5A94.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $5f6aa8fade9cc028$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($5f6aa8fade9cc028$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $5f6aa8fade9cc028$export$df3f009e3d155b20(source2, 1);
        return $5f6aa8fade9cc028$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $5f6aa8fade9cc028$export$7f3fe6025abfa26e(source);
    } else if ($5f6aa8fade9cc028$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $X5A94.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$5f6aa8fade9cc028$export$352205f445242f02(s) || $5f6aa8fade9cc028$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(s)) return s.value;
                else if ($5f6aa8fade9cc028$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $X5A94.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $X5A94.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $5f6aa8fade9cc028$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $5f6aa8fade9cc028$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $5f6aa8fade9cc028$var$activeWatcher;
            $5f6aa8fade9cc028$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $5f6aa8fade9cc028$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $X5A94.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$5f6aa8fade9cc028$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $5f6aa8fade9cc028$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $X5A94.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($5f6aa8fade9cc028$var$INITIAL_WATCHER_VALUE) : $5f6aa8fade9cc028$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $X5A94.hasChanged)(v, oldValue[i])) : (0, $X5A94.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $5f6aa8fade9cc028$var$activeWatcher;
                $5f6aa8fade9cc028$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $5f6aa8fade9cc028$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $5f6aa8fade9cc028$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $5f6aa8fade9cc028$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $5f6aa8fade9cc028$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$5f6aa8fade9cc028$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $5f6aa8fade9cc028$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $5f6aa8fade9cc028$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $5f6aa8fade9cc028$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $X5A94.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(value)) $5f6aa8fade9cc028$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $X5A94.isArray)(value)) for(let i = 0; i < value.length; i++)$5f6aa8fade9cc028$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $X5A94.isSet)(value) || (0, $X5A94.isMap)(value)) value.forEach((v)=>{
        $5f6aa8fade9cc028$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $X5A94.isPlainObject)(value)) {
        for(const key in value)$5f6aa8fade9cc028$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $5f6aa8fade9cc028$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("X5A94", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $0b19d744f65e59ab$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $0b19d744f65e59ab$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $0b19d744f65e59ab$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $0b19d744f65e59ab$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $0b19d744f65e59ab$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $0b19d744f65e59ab$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $0b19d744f65e59ab$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $0b19d744f65e59ab$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $0b19d744f65e59ab$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $0b19d744f65e59ab$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $0b19d744f65e59ab$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $0b19d744f65e59ab$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $0b19d744f65e59ab$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $0b19d744f65e59ab$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $0b19d744f65e59ab$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $0b19d744f65e59ab$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $0b19d744f65e59ab$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $0b19d744f65e59ab$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $0b19d744f65e59ab$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $0b19d744f65e59ab$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $0b19d744f65e59ab$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $0b19d744f65e59ab$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $0b19d744f65e59ab$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $0b19d744f65e59ab$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $0b19d744f65e59ab$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $0b19d744f65e59ab$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $0b19d744f65e59ab$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $0b19d744f65e59ab$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $0b19d744f65e59ab$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $0b19d744f65e59ab$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $0b19d744f65e59ab$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $0b19d744f65e59ab$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $0b19d744f65e59ab$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $0b19d744f65e59ab$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $0b19d744f65e59ab$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $0b19d744f65e59ab$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $0b19d744f65e59ab$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $0b19d744f65e59ab$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "normalizeProps", () => $0b19d744f65e59ab$export$601abcd8103db5e4);
$parcel$export(module.exports, "isHTMLTag", () => $0b19d744f65e59ab$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $0b19d744f65e59ab$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $0b19d744f65e59ab$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $0b19d744f65e59ab$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $0b19d744f65e59ab$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $0b19d744f65e59ab$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $0b19d744f65e59ab$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $0b19d744f65e59ab$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $0b19d744f65e59ab$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $0b19d744f65e59ab$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $0b19d744f65e59ab$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $0b19d744f65e59ab$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $0b19d744f65e59ab$export$b5b1545233b45293);
$parcel$export(module.exports, "normalizeCssVarValue", () => $0b19d744f65e59ab$export$97fe3d6453ee2f5e);
/**
* @vue/shared v3.5.20
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0b19d744f65e59ab$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $0b19d744f65e59ab$export$cf583d23ab39677c = {};
const $0b19d744f65e59ab$export$6bd8558f433f1cc1 = [];
const $0b19d744f65e59ab$export$5702a91a6f42969f = ()=>{};
const $0b19d744f65e59ab$export$c01351c0af048e39 = ()=>false;
const $0b19d744f65e59ab$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $0b19d744f65e59ab$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $0b19d744f65e59ab$export$8b58be045bf06082 = Object.assign;
const $0b19d744f65e59ab$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $0b19d744f65e59ab$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $0b19d744f65e59ab$export$b5a638e9b3fff9f3 = (val, key)=>$0b19d744f65e59ab$var$hasOwnProperty.call(val, key);
const $0b19d744f65e59ab$export$43bee75e5e14138e = Array.isArray;
const $0b19d744f65e59ab$export$5c90113a285f2241 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object Map]";
const $0b19d744f65e59ab$export$6750766a7c7ec627 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object Set]";
const $0b19d744f65e59ab$export$871608497c498473 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object Date]";
const $0b19d744f65e59ab$export$49841c62b9eff15 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object RegExp]";
const $0b19d744f65e59ab$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $0b19d744f65e59ab$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $0b19d744f65e59ab$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $0b19d744f65e59ab$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $0b19d744f65e59ab$export$4369c812aac99591 = (val)=>{
    return ($0b19d744f65e59ab$export$a6cdc56e425d0d0a(val) || $0b19d744f65e59ab$export$f6e2535fb5126e54(val)) && $0b19d744f65e59ab$export$f6e2535fb5126e54(val.then) && $0b19d744f65e59ab$export$f6e2535fb5126e54(val.catch);
};
const $0b19d744f65e59ab$export$830c053460e5ddf6 = Object.prototype.toString;
const $0b19d744f65e59ab$export$1dccc787cc36538b = (value)=>$0b19d744f65e59ab$export$830c053460e5ddf6.call(value);
const $0b19d744f65e59ab$export$5ad0a3c360b8fbb5 = (value)=>{
    return $0b19d744f65e59ab$export$1dccc787cc36538b(value).slice(8, -1);
};
const $0b19d744f65e59ab$export$53b83ca8eaab0383 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object Object]";
const $0b19d744f65e59ab$export$e2a2b93446ec9fe = (key)=>$0b19d744f65e59ab$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $0b19d744f65e59ab$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $0b19d744f65e59ab$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $0b19d744f65e59ab$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $0b19d744f65e59ab$var$camelizeRE = /-(\w)/g;
const $0b19d744f65e59ab$export$161d051f5dd25de7 = $0b19d744f65e59ab$var$cacheStringFunction((str)=>{
    return str.replace($0b19d744f65e59ab$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $0b19d744f65e59ab$var$hyphenateRE = /\B([A-Z])/g;
const $0b19d744f65e59ab$export$6e6a0a3676c4b8bb = $0b19d744f65e59ab$var$cacheStringFunction((str)=>str.replace($0b19d744f65e59ab$var$hyphenateRE, "-$1").toLowerCase());
const $0b19d744f65e59ab$export$9a00dee1beb8f576 = $0b19d744f65e59ab$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $0b19d744f65e59ab$export$8c022799eeaaefcd = $0b19d744f65e59ab$var$cacheStringFunction((str)=>{
    const s = str ? `on${$0b19d744f65e59ab$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $0b19d744f65e59ab$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $0b19d744f65e59ab$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $0b19d744f65e59ab$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $0b19d744f65e59ab$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $0b19d744f65e59ab$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $0b19d744f65e59ab$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $0b19d744f65e59ab$var$_globalThis;
const $0b19d744f65e59ab$export$ff5f2eeb11fc7e14 = ()=>{
    return $0b19d744f65e59ab$var$_globalThis || ($0b19d744f65e59ab$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $0b19d744f65e59ab$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $0b19d744f65e59ab$export$53d5e12f9a1d3cde(name) {
    return $0b19d744f65e59ab$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $0b19d744f65e59ab$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $0b19d744f65e59ab$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $0b19d744f65e59ab$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $0b19d744f65e59ab$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $0b19d744f65e59ab$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $0b19d744f65e59ab$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $0b19d744f65e59ab$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $0b19d744f65e59ab$export$f73b8c13b7f97ebf = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$GLOBALS_ALLOWED);
const $0b19d744f65e59ab$export$d6571a1911e4f27e = $0b19d744f65e59ab$export$f73b8c13b7f97ebf;
const $0b19d744f65e59ab$var$range = 2;
function $0b19d744f65e59ab$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $0b19d744f65e59ab$var$range; j <= i + $0b19d744f65e59ab$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $0b19d744f65e59ab$export$8756898546458274(value) {
    if ($0b19d744f65e59ab$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $0b19d744f65e59ab$export$844ec244b1367d54(item) ? $0b19d744f65e59ab$export$76a205ce979d066a(item) : $0b19d744f65e59ab$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($0b19d744f65e59ab$export$844ec244b1367d54(value) || $0b19d744f65e59ab$export$a6cdc56e425d0d0a(value)) return value;
}
const $0b19d744f65e59ab$var$listDelimiterRE = /;(?![^(]*\))/g;
const $0b19d744f65e59ab$var$propertyDelimiterRE = /:([^]+)/;
const $0b19d744f65e59ab$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $0b19d744f65e59ab$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($0b19d744f65e59ab$var$styleCommentRE, "").split($0b19d744f65e59ab$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($0b19d744f65e59ab$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $0b19d744f65e59ab$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($0b19d744f65e59ab$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($0b19d744f65e59ab$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $0b19d744f65e59ab$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $0b19d744f65e59ab$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($0b19d744f65e59ab$export$844ec244b1367d54(value)) res = value;
    else if ($0b19d744f65e59ab$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $0b19d744f65e59ab$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($0b19d744f65e59ab$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $0b19d744f65e59ab$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$0b19d744f65e59ab$export$844ec244b1367d54(klass)) props.class = $0b19d744f65e59ab$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $0b19d744f65e59ab$export$8756898546458274(style);
    return props;
}
const $0b19d744f65e59ab$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $0b19d744f65e59ab$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $0b19d744f65e59ab$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $0b19d744f65e59ab$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $0b19d744f65e59ab$export$1ccf854a0984f890 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$HTML_TAGS);
const $0b19d744f65e59ab$export$6328ce7565ea1049 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$SVG_TAGS);
const $0b19d744f65e59ab$export$4a46ca4c5be17b20 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$MATH_TAGS);
const $0b19d744f65e59ab$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$VOID_TAGS);
const $0b19d744f65e59ab$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $0b19d744f65e59ab$export$d186f5eb2e810715 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$specialBooleanAttrs);
const $0b19d744f65e59ab$export$f763ba3b84e9cd8c = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $0b19d744f65e59ab$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $0b19d744f65e59ab$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $0b19d744f65e59ab$var$attrValidationCache = {};
function $0b19d744f65e59ab$export$d55ef77660f30d12(name) {
    if ($0b19d744f65e59ab$var$attrValidationCache.hasOwnProperty(name)) return $0b19d744f65e59ab$var$attrValidationCache[name];
    const isUnsafe = $0b19d744f65e59ab$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $0b19d744f65e59ab$var$attrValidationCache[name] = !isUnsafe;
}
const $0b19d744f65e59ab$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $0b19d744f65e59ab$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $0b19d744f65e59ab$export$80da416f43933831 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $0b19d744f65e59ab$export$fc0748a8e0014066 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $0b19d744f65e59ab$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $0b19d744f65e59ab$var$escapeRE = /["'&<>]/;
function $0b19d744f65e59ab$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $0b19d744f65e59ab$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $0b19d744f65e59ab$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $0b19d744f65e59ab$export$7b105034a53bde5f(src) {
    return src.replace($0b19d744f65e59ab$var$commentStripRE, "");
}
const $0b19d744f65e59ab$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $0b19d744f65e59ab$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($0b19d744f65e59ab$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $0b19d744f65e59ab$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $0b19d744f65e59ab$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $0b19d744f65e59ab$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $0b19d744f65e59ab$export$871608497c498473(a);
    let bValidType = $0b19d744f65e59ab$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $0b19d744f65e59ab$export$a244864fd9645c7f(a);
    bValidType = $0b19d744f65e59ab$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $0b19d744f65e59ab$export$43bee75e5e14138e(a);
    bValidType = $0b19d744f65e59ab$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $0b19d744f65e59ab$var$looseCompareArrays(a, b) : false;
    aValidType = $0b19d744f65e59ab$export$a6cdc56e425d0d0a(a);
    bValidType = $0b19d744f65e59ab$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$0b19d744f65e59ab$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $0b19d744f65e59ab$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$0b19d744f65e59ab$export$ae8015769846262c(item, val));
}
const $0b19d744f65e59ab$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $0b19d744f65e59ab$export$b5b1545233b45293 = (val)=>{
    return $0b19d744f65e59ab$export$844ec244b1367d54(val) ? val : val == null ? "" : $0b19d744f65e59ab$export$43bee75e5e14138e(val) || $0b19d744f65e59ab$export$a6cdc56e425d0d0a(val) && (val.toString === $0b19d744f65e59ab$export$830c053460e5ddf6 || !$0b19d744f65e59ab$export$f6e2535fb5126e54(val.toString)) ? $0b19d744f65e59ab$var$isRef(val) ? $0b19d744f65e59ab$export$b5b1545233b45293(val.value) : JSON.stringify(val, $0b19d744f65e59ab$var$replacer, 2) : String(val);
};
const $0b19d744f65e59ab$var$replacer = (_key, val)=>{
    if ($0b19d744f65e59ab$var$isRef(val)) return $0b19d744f65e59ab$var$replacer(_key, val.value);
    else if ($0b19d744f65e59ab$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$0b19d744f65e59ab$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($0b19d744f65e59ab$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$0b19d744f65e59ab$var$stringifySymbol(v))
    };
    else if ($0b19d744f65e59ab$export$a244864fd9645c7f(val)) return $0b19d744f65e59ab$var$stringifySymbol(val);
    else if ($0b19d744f65e59ab$export$a6cdc56e425d0d0a(val) && !$0b19d744f65e59ab$export$43bee75e5e14138e(val) && !$0b19d744f65e59ab$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $0b19d744f65e59ab$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $0b19d744f65e59ab$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $0b19d744f65e59ab$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});



parcelRegister("dDLnc", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("ani5R")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("ani5R")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("ani5R")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("X5A94")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("ani5R")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("ani5R")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("ani5R")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("ani5R")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("ani5R")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("ani5R")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("ani5R")).createRenderer);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("ani5R")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("ani5R")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("ani5R")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("ani5R")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("ani5R")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("ani5R")).getTransitionRawChildren);
$parcel$export(module.exports, "guardReactiveProps", () => (parcelRequire("ani5R")).guardReactiveProps);
$parcel$export(module.exports, "h", () => (parcelRequire("ani5R")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("ani5R")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("ani5R")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("ani5R")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("8bTPG")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("ani5R")).isRuntimeOnly);
$parcel$export(module.exports, "KeepAlive", () => (parcelRequire("ani5R")).KeepAlive);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("8bTPG")).markRaw);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("ani5R")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("ani5R")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("X5A94")).normalizeClass);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("ani5R")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("ani5R")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("ani5R")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("ani5R")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("ani5R")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("ani5R")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("ani5R")).provide);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("ani5R")).queuePostFlushCb);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("ani5R")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("ani5R")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("ani5R")).resolveComponent);
$parcel$export(module.exports, "resolveDirective", () => (parcelRequire("ani5R")).resolveDirective);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("ani5R")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("ani5R")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("ani5R")).setTransitionHooks);
$parcel$export(module.exports, "Static", () => (parcelRequire("ani5R")).Static);
$parcel$export(module.exports, "Suspense", () => (parcelRequire("ani5R")).Suspense);
$parcel$export(module.exports, "toHandlers", () => (parcelRequire("ani5R")).toHandlers);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("8bTPG")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("ani5R")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("ani5R")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("ani5R")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("ani5R")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("ani5R")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("ani5R")).withDirectives);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("8bTPG")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("8bTPG")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("8bTPG")).onScopeDispose);
$parcel$export(module.exports, "toRef", () => (parcelRequire("8bTPG")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("8bTPG")).toRefs);
$parcel$export(module.exports, "triggerRef", () => (parcelRequire("8bTPG")).triggerRef);
$parcel$export(module.exports, "unref", () => (parcelRequire("8bTPG")).unref);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("X5A94")).normalizeProps);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("X5A94")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $9ee3aa3420ae2c81$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $9ee3aa3420ae2c81$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "createApp", () => $9ee3aa3420ae2c81$export$4e373c34abfa8c68);
$parcel$export(module.exports, "withModifiers", () => $9ee3aa3420ae2c81$export$26bd3b8e29e6f273);
/**
* @vue/runtime-dom v3.5.20
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $8bTPG = parcelRequire("8bTPG");
var $8bTPG = parcelRequire("8bTPG");parcelRequire("X5A94");

var $X5A94 = parcelRequire("X5A94");
let $9ee3aa3420ae2c81$var$policy = void 0;
const $9ee3aa3420ae2c81$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($9ee3aa3420ae2c81$var$tt) try {
    $9ee3aa3420ae2c81$var$policy = /* @__PURE__ */ $9ee3aa3420ae2c81$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $9ee3aa3420ae2c81$var$unsafeToTrustedHTML = $9ee3aa3420ae2c81$var$policy ? (val)=>$9ee3aa3420ae2c81$var$policy.createHTML(val) : (val)=>val;
const $9ee3aa3420ae2c81$var$svgNS = "http://www.w3.org/2000/svg";
const $9ee3aa3420ae2c81$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $9ee3aa3420ae2c81$var$doc = typeof document !== "undefined" ? document : null;
const $9ee3aa3420ae2c81$var$templateContainer = $9ee3aa3420ae2c81$var$doc && /* @__PURE__ */ $9ee3aa3420ae2c81$var$doc.createElement("template");
const $9ee3aa3420ae2c81$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $9ee3aa3420ae2c81$var$doc.createElementNS($9ee3aa3420ae2c81$var$svgNS, tag) : namespace === "mathml" ? $9ee3aa3420ae2c81$var$doc.createElementNS($9ee3aa3420ae2c81$var$mathmlNS, tag) : is ? $9ee3aa3420ae2c81$var$doc.createElement(tag, {
            is: is
        }) : $9ee3aa3420ae2c81$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$9ee3aa3420ae2c81$var$doc.createTextNode(text),
    createComment: (text)=>$9ee3aa3420ae2c81$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$9ee3aa3420ae2c81$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $9ee3aa3420ae2c81$var$templateContainer.innerHTML = $9ee3aa3420ae2c81$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $9ee3aa3420ae2c81$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $9ee3aa3420ae2c81$var$TRANSITION = "transition";
const $9ee3aa3420ae2c81$var$ANIMATION = "animation";
const $9ee3aa3420ae2c81$var$vtcKey = Symbol("_vtc");
const $9ee3aa3420ae2c81$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $9ee3aa3420ae2c81$var$TransitionPropsValidators = /* @__PURE__ */ (0, $X5A94.extend)({}, (0, $ani5R.BaseTransitionPropsValidators), $9ee3aa3420ae2c81$var$DOMTransitionPropsValidators);
const $9ee3aa3420ae2c81$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $9ee3aa3420ae2c81$var$TransitionPropsValidators;
    return t;
};
const $9ee3aa3420ae2c81$export$be58926105124dd4 = /* @__PURE__ */ $9ee3aa3420ae2c81$var$decorate$1((props, { slots: slots })=>(0, $ani5R.h)((0, $ani5R.BaseTransition), $9ee3aa3420ae2c81$var$resolveTransitionProps(props), slots));
const $9ee3aa3420ae2c81$var$callHook = (hook, args = [])=>{
    if ((0, $X5A94.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $9ee3aa3420ae2c81$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $X5A94.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $9ee3aa3420ae2c81$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $9ee3aa3420ae2c81$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $9ee3aa3420ae2c81$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveFromClass);
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveToClass);
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $9ee3aa3420ae2c81$var$callHook(hook, [
                el,
                resolve
            ]);
            $9ee3aa3420ae2c81$var$nextFrame(()=>{
                $9ee3aa3420ae2c81$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $9ee3aa3420ae2c81$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$9ee3aa3420ae2c81$var$hasExplicitCallback(hook)) $9ee3aa3420ae2c81$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $X5A94.extend)(baseProps, {
        onBeforeEnter (el) {
            $9ee3aa3420ae2c81$var$callHook(onBeforeEnter, [
                el
            ]);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, enterFromClass);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $9ee3aa3420ae2c81$var$callHook(onBeforeAppear, [
                el
            ]);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, appearFromClass);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $9ee3aa3420ae2c81$var$forceReflow();
                $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveActiveClass);
                $9ee3aa3420ae2c81$var$forceReflow();
            }
            $9ee3aa3420ae2c81$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveFromClass);
                $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveToClass);
                if (!$9ee3aa3420ae2c81$var$hasExplicitCallback(onLeave)) $9ee3aa3420ae2c81$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $9ee3aa3420ae2c81$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $9ee3aa3420ae2c81$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $9ee3aa3420ae2c81$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $9ee3aa3420ae2c81$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $9ee3aa3420ae2c81$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $X5A94.isObject)(duration)) return [
        $9ee3aa3420ae2c81$var$NumberOf(duration.enter),
        $9ee3aa3420ae2c81$var$NumberOf(duration.leave)
    ];
    else {
        const n = $9ee3aa3420ae2c81$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $9ee3aa3420ae2c81$var$NumberOf(val) {
    const res = (0, $X5A94.toNumber)(val);
    return res;
}
function $9ee3aa3420ae2c81$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$9ee3aa3420ae2c81$var$vtcKey] || (el[$9ee3aa3420ae2c81$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $9ee3aa3420ae2c81$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$9ee3aa3420ae2c81$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$9ee3aa3420ae2c81$var$vtcKey] = void 0;
    }
}
function $9ee3aa3420ae2c81$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $9ee3aa3420ae2c81$var$endId = 0;
function $9ee3aa3420ae2c81$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$9ee3aa3420ae2c81$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $9ee3aa3420ae2c81$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $9ee3aa3420ae2c81$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$9ee3aa3420ae2c81$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$9ee3aa3420ae2c81$var$TRANSITION}Duration`);
    const transitionTimeout = $9ee3aa3420ae2c81$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$9ee3aa3420ae2c81$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$9ee3aa3420ae2c81$var$ANIMATION}Duration`);
    const animationTimeout = $9ee3aa3420ae2c81$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $9ee3aa3420ae2c81$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $9ee3aa3420ae2c81$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $9ee3aa3420ae2c81$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $9ee3aa3420ae2c81$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $9ee3aa3420ae2c81$var$TRANSITION : $9ee3aa3420ae2c81$var$ANIMATION : null;
        propCount = type ? type === $9ee3aa3420ae2c81$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $9ee3aa3420ae2c81$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$9ee3aa3420ae2c81$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $9ee3aa3420ae2c81$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$9ee3aa3420ae2c81$var$toMs(d) + $9ee3aa3420ae2c81$var$toMs(delays[i])));
}
function $9ee3aa3420ae2c81$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $9ee3aa3420ae2c81$var$forceReflow() {
    return document.body.offsetHeight;
}
function $9ee3aa3420ae2c81$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$9ee3aa3420ae2c81$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $9ee3aa3420ae2c81$var$vShowOriginalDisplay = Symbol("_vod");
const $9ee3aa3420ae2c81$var$vShowHidden = Symbol("_vsh");
const $9ee3aa3420ae2c81$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$9ee3aa3420ae2c81$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $9ee3aa3420ae2c81$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $9ee3aa3420ae2c81$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $9ee3aa3420ae2c81$var$setDisplay(el, false);
            });
        } else $9ee3aa3420ae2c81$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $9ee3aa3420ae2c81$var$setDisplay(el, value);
    }
};
function $9ee3aa3420ae2c81$var$setDisplay(el, value) {
    el.style.display = value ? el[$9ee3aa3420ae2c81$var$vShowOriginalDisplay] : "none";
    el[$9ee3aa3420ae2c81$var$vShowHidden] = !value;
}
function $9ee3aa3420ae2c81$var$initVShowForSSR() {
    $9ee3aa3420ae2c81$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $9ee3aa3420ae2c81$var$CSS_VAR_TEXT = Symbol("");
function $9ee3aa3420ae2c81$export$ef28b76f07940108(getter) {
    const instance = (0, $ani5R.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$9ee3aa3420ae2c81$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $9ee3aa3420ae2c81$var$setVarsOnNode(instance.ce, vars);
        else $9ee3aa3420ae2c81$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $ani5R.onBeforeUpdate)(()=>{
        (0, $ani5R.queuePostFlushCb)(setVars);
    });
    (0, $ani5R.onMounted)(()=>{
        (0, $ani5R.watch)(setVars, (0, $X5A94.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $ani5R.onUnmounted)(()=>ob.disconnect());
    });
}
function $9ee3aa3420ae2c81$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $9ee3aa3420ae2c81$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $9ee3aa3420ae2c81$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $ani5R.Fragment)) vnode.children.forEach((c)=>$9ee3aa3420ae2c81$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $ani5R.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $9ee3aa3420ae2c81$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $9ee3aa3420ae2c81$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $X5A94.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$9ee3aa3420ae2c81$var$CSS_VAR_TEXT] = cssText;
    }
}
const $9ee3aa3420ae2c81$var$displayRE = /(^|;)\s*display\s*:/;
function $9ee3aa3420ae2c81$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $X5A94.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $X5A94.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $9ee3aa3420ae2c81$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $9ee3aa3420ae2c81$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $9ee3aa3420ae2c81$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$9ee3aa3420ae2c81$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $9ee3aa3420ae2c81$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($9ee3aa3420ae2c81$var$vShowOriginalDisplay in el) {
        el[$9ee3aa3420ae2c81$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$9ee3aa3420ae2c81$var$vShowHidden]) style.display = "none";
    }
}
const $9ee3aa3420ae2c81$var$semicolonRE = /[^\\];\s*$/;
const $9ee3aa3420ae2c81$var$importantRE = /\s*!important$/;
function $9ee3aa3420ae2c81$var$setStyle(style, name, val) {
    if ((0, $X5A94.isArray)(val)) val.forEach((v)=>$9ee3aa3420ae2c81$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $9ee3aa3420ae2c81$var$autoPrefix(style, name);
            if ($9ee3aa3420ae2c81$var$importantRE.test(val)) style.setProperty((0, $X5A94.hyphenate)(prefixed), val.replace($9ee3aa3420ae2c81$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $9ee3aa3420ae2c81$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $9ee3aa3420ae2c81$var$prefixCache = {};
function $9ee3aa3420ae2c81$var$autoPrefix(style, rawName) {
    const cached = $9ee3aa3420ae2c81$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $X5A94.camelize)(rawName);
    if (name !== "filter" && name in style) return $9ee3aa3420ae2c81$var$prefixCache[rawName] = name;
    name = (0, $X5A94.capitalize)(name);
    for(let i = 0; i < $9ee3aa3420ae2c81$var$prefixes.length; i++){
        const prefixed = $9ee3aa3420ae2c81$var$prefixes[i] + name;
        if (prefixed in style) return $9ee3aa3420ae2c81$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $9ee3aa3420ae2c81$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $9ee3aa3420ae2c81$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $X5A94.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($9ee3aa3420ae2c81$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($9ee3aa3420ae2c81$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $X5A94.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $X5A94.isSymbol)(value) ? String(value) : value);
}
function $9ee3aa3420ae2c81$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $9ee3aa3420ae2c81$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $X5A94.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $9ee3aa3420ae2c81$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $9ee3aa3420ae2c81$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $9ee3aa3420ae2c81$var$veiKey = Symbol("_vei");
function $9ee3aa3420ae2c81$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$9ee3aa3420ae2c81$var$veiKey] || (el[$9ee3aa3420ae2c81$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $9ee3aa3420ae2c81$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $9ee3aa3420ae2c81$var$createInvoker(nextValue, instance);
            $9ee3aa3420ae2c81$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $9ee3aa3420ae2c81$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $9ee3aa3420ae2c81$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $9ee3aa3420ae2c81$var$parseName(name) {
    let options;
    if ($9ee3aa3420ae2c81$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($9ee3aa3420ae2c81$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $X5A94.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $9ee3aa3420ae2c81$var$cachedNow = 0;
const $9ee3aa3420ae2c81$var$p = /* @__PURE__ */ Promise.resolve();
const $9ee3aa3420ae2c81$var$getNow = ()=>$9ee3aa3420ae2c81$var$cachedNow || ($9ee3aa3420ae2c81$var$p.then(()=>$9ee3aa3420ae2c81$var$cachedNow = 0), $9ee3aa3420ae2c81$var$cachedNow = Date.now());
function $9ee3aa3420ae2c81$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $ani5R.callWithAsyncErrorHandling)($9ee3aa3420ae2c81$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $9ee3aa3420ae2c81$var$getNow();
    return invoker;
}
function $9ee3aa3420ae2c81$var$sanitizeEventValue(value, propName) {
    if ((0, $X5A94.isFunction)(value) || (0, $X5A94.isArray)(value)) return value;
    (0, $ani5R.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $X5A94.NOOP;
}
function $9ee3aa3420ae2c81$var$patchStopImmediatePropagation(e, value) {
    if ((0, $X5A94.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $9ee3aa3420ae2c81$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $9ee3aa3420ae2c81$var$patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $9ee3aa3420ae2c81$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $9ee3aa3420ae2c81$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $X5A94.isOn)(key)) {
        if (!(0, $X5A94.isModelListener)(key)) $9ee3aa3420ae2c81$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $9ee3aa3420ae2c81$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $9ee3aa3420ae2c81$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $9ee3aa3420ae2c81$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $X5A94.isString)(nextValue))) $9ee3aa3420ae2c81$var$patchDOMProp(el, (0, $X5A94.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $9ee3aa3420ae2c81$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $9ee3aa3420ae2c81$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $9ee3aa3420ae2c81$var$isNativeOn(key) && (0, $X5A94.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($9ee3aa3420ae2c81$var$isNativeOn(key) && (0, $X5A94.isString)(value)) return false;
    return key in el;
}
const $9ee3aa3420ae2c81$var$REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $9ee3aa3420ae2c81$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    const Comp = (0, $ani5R.defineComponent)(options, extraOptions);
    if ((0, $X5A94.isPlainObject)(Comp)) (0, $X5A94.extend)(Comp, extraOptions);
    class VueCustomElement extends $9ee3aa3420ae2c81$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $9ee3aa3420ae2c81$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $9ee3aa3420ae2c81$export$a00e2346eabbdbef(options, extraOptions, $9ee3aa3420ae2c81$export$35800275c0037383);
};
const $9ee3aa3420ae2c81$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $9ee3aa3420ae2c81$export$b337c1a55163dbe3 extends $9ee3aa3420ae2c81$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $9ee3aa3420ae2c81$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $9ee3aa3420ae2c81$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow({
                mode: "open"
            });
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $9ee3aa3420ae2c81$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $ani5R.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $X5A94.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $X5A94.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $X5A94.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>{
            def.configureApp = this._def.configureApp;
            resolve(this._def = def, true);
        });
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $X5A94.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $8bTPG.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $X5A94.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $X5A94.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $9ee3aa3420ae2c81$var$REMOVAL;
        const camelKey = (0, $X5A94.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $X5A94.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === $9ee3aa3420ae2c81$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                ob && ob.disconnect();
                if (val === true) this.setAttribute((0, $X5A94.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $X5A94.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $X5A94.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $9ee3aa3420ae2c81$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $ani5R.createVNode)(this._def, (0, $X5A94.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $X5A94.isPlainObject)(args[0]) ? (0, $X5A94.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $X5A94.hyphenate)(event) !== event) dispatch((0, $X5A94.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $9ee3aa3420ae2c81$export$da5acfe93a94e37d(caller) {
    const instance = (0, $ani5R.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $ani5R.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $ani5R.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $9ee3aa3420ae2c81$export$64d45095031fa749() {
    const el = $9ee3aa3420ae2c81$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $9ee3aa3420ae2c81$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $ani5R.getCurrentInstance)();
        if (!instance) return 0, $X5A94.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $X5A94.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $X5A94.EMPTY_OBJ;
        return mod;
    }
}
const $9ee3aa3420ae2c81$var$positionMap = /* @__PURE__ */ new WeakMap();
const $9ee3aa3420ae2c81$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $9ee3aa3420ae2c81$var$moveCbKey = Symbol("_moveCb");
const $9ee3aa3420ae2c81$var$enterCbKey = Symbol("_enterCb");
const $9ee3aa3420ae2c81$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $9ee3aa3420ae2c81$var$TransitionGroupImpl = /* @__PURE__ */ $9ee3aa3420ae2c81$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $X5A94.extend)({}, $9ee3aa3420ae2c81$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $ani5R.getCurrentInstance)();
        const state = (0, $ani5R.useTransitionState)();
        let prevChildren;
        let children;
        (0, $ani5R.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$9ee3aa3420ae2c81$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($9ee3aa3420ae2c81$var$callPendingCbs);
            prevChildren.forEach($9ee3aa3420ae2c81$var$recordPosition);
            const movedChildren = prevChildren.filter($9ee3aa3420ae2c81$var$applyTranslation);
            $9ee3aa3420ae2c81$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $9ee3aa3420ae2c81$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$9ee3aa3420ae2c81$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$9ee3aa3420ae2c81$var$moveCbKey] = null;
                        $9ee3aa3420ae2c81$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $8bTPG.toRaw)(props);
            const cssTransitionProps = $9ee3aa3420ae2c81$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $ani5R.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $ani5R.setTransitionHooks)(child, (0, $ani5R.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $9ee3aa3420ae2c81$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $ani5R.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $ani5R.setTransitionHooks)(child, (0, $ani5R.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $ani5R.createVNode)(tag, null, children);
        };
    }
});
const $9ee3aa3420ae2c81$export$19ffa8f511f7bc2e = $9ee3aa3420ae2c81$var$TransitionGroupImpl;
function $9ee3aa3420ae2c81$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$9ee3aa3420ae2c81$var$moveCbKey]) el[$9ee3aa3420ae2c81$var$moveCbKey]();
    if (el[$9ee3aa3420ae2c81$var$enterCbKey]) el[$9ee3aa3420ae2c81$var$enterCbKey]();
}
function $9ee3aa3420ae2c81$var$recordPosition(c) {
    $9ee3aa3420ae2c81$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $9ee3aa3420ae2c81$var$applyTranslation(c) {
    const oldPos = $9ee3aa3420ae2c81$var$positionMap.get(c);
    const newPos = $9ee3aa3420ae2c81$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $9ee3aa3420ae2c81$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$9ee3aa3420ae2c81$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $9ee3aa3420ae2c81$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $9ee3aa3420ae2c81$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $X5A94.isArray)(fn) ? (value)=>(0, $X5A94.invokeArrayFns)(fn, value) : fn;
};
function $9ee3aa3420ae2c81$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $9ee3aa3420ae2c81$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $9ee3aa3420ae2c81$var$assignKey = Symbol("_assign");
const $9ee3aa3420ae2c81$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $9ee3aa3420ae2c81$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $X5A94.looseToNumber)(domValue);
            el[$9ee3aa3420ae2c81$var$assignKey](domValue);
        });
        if (trim) $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $9ee3aa3420ae2c81$var$addEventListener(el, "compositionstart", $9ee3aa3420ae2c81$var$onCompositionStart);
            $9ee3aa3420ae2c81$var$addEventListener(el, "compositionend", $9ee3aa3420ae2c81$var$onCompositionEnd);
            $9ee3aa3420ae2c81$var$addEventListener(el, "change", $9ee3aa3420ae2c81$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $X5A94.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $9ee3aa3420ae2c81$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $9ee3aa3420ae2c81$var$getValue(el);
            const checked = el.checked;
            const assign = el[$9ee3aa3420ae2c81$var$assignKey];
            if ((0, $X5A94.isArray)(modelValue)) {
                const index = (0, $X5A94.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $X5A94.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($9ee3aa3420ae2c81$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $9ee3aa3420ae2c81$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        $9ee3aa3420ae2c81$var$setChecked(el, binding, vnode);
    }
};
function $9ee3aa3420ae2c81$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $X5A94.isArray)(value)) checked = (0, $X5A94.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $X5A94.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $X5A94.looseEqual)(value, $9ee3aa3420ae2c81$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $9ee3aa3420ae2c81$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $X5A94.looseEqual)(value, vnode.props.value);
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            el[$9ee3aa3420ae2c81$var$assignKey]($9ee3aa3420ae2c81$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $X5A94.looseEqual)(value, vnode.props.value);
    }
};
const $9ee3aa3420ae2c81$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $X5A94.isSet)(value);
        $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $X5A94.looseToNumber)($9ee3aa3420ae2c81$var$getValue(o)) : $9ee3aa3420ae2c81$var$getValue(o));
            el[$9ee3aa3420ae2c81$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $ani5R.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $9ee3aa3420ae2c81$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $9ee3aa3420ae2c81$var$setSelected(el, value);
    }
};
function $9ee3aa3420ae2c81$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $X5A94.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $X5A94.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $9ee3aa3420ae2c81$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $X5A94.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $X5A94.looseEqual)($9ee3aa3420ae2c81$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $9ee3aa3420ae2c81$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $9ee3aa3420ae2c81$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $9ee3aa3420ae2c81$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $9ee3aa3420ae2c81$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $9ee3aa3420ae2c81$export$87d227567b51ca39;
        case "TEXTAREA":
            return $9ee3aa3420ae2c81$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $9ee3aa3420ae2c81$export$8847c2e532b35714;
                case "radio":
                    return $9ee3aa3420ae2c81$export$b4356c59b38b7aa9;
                default:
                    return $9ee3aa3420ae2c81$export$f1f88689f5728478;
            }
    }
}
function $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $9ee3aa3420ae2c81$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $9ee3aa3420ae2c81$var$initVModelForSSR() {
    $9ee3aa3420ae2c81$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $9ee3aa3420ae2c81$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $X5A94.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $9ee3aa3420ae2c81$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $X5A94.isArray)(value)) {
            if (vnode.props && (0, $X5A94.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $X5A94.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $9ee3aa3420ae2c81$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $9ee3aa3420ae2c81$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $9ee3aa3420ae2c81$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $9ee3aa3420ae2c81$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$9ee3aa3420ae2c81$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $9ee3aa3420ae2c81$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $9ee3aa3420ae2c81$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $9ee3aa3420ae2c81$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $9ee3aa3420ae2c81$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $X5A94.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $9ee3aa3420ae2c81$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $9ee3aa3420ae2c81$var$rendererOptions = /* @__PURE__ */ (0, $X5A94.extend)({
    patchProp: $9ee3aa3420ae2c81$var$patchProp
}, $9ee3aa3420ae2c81$var$nodeOps);
let $9ee3aa3420ae2c81$var$renderer;
let $9ee3aa3420ae2c81$var$enabledHydration = false;
function $9ee3aa3420ae2c81$var$ensureRenderer() {
    return $9ee3aa3420ae2c81$var$renderer || ($9ee3aa3420ae2c81$var$renderer = (0, $ani5R.createRenderer)($9ee3aa3420ae2c81$var$rendererOptions));
}
function $9ee3aa3420ae2c81$var$ensureHydrationRenderer() {
    $9ee3aa3420ae2c81$var$renderer = $9ee3aa3420ae2c81$var$enabledHydration ? $9ee3aa3420ae2c81$var$renderer : (0, $ani5R.createHydrationRenderer)($9ee3aa3420ae2c81$var$rendererOptions);
    $9ee3aa3420ae2c81$var$enabledHydration = true;
    return $9ee3aa3420ae2c81$var$renderer;
}
const $9ee3aa3420ae2c81$export$b3890eb0ae9dca99 = (...args)=>{
    $9ee3aa3420ae2c81$var$ensureRenderer().render(...args);
};
const $9ee3aa3420ae2c81$export$fa8d919ba61d84db = (...args)=>{
    $9ee3aa3420ae2c81$var$ensureHydrationRenderer().hydrate(...args);
};
const $9ee3aa3420ae2c81$export$4e373c34abfa8c68 = (...args)=>{
    const app = $9ee3aa3420ae2c81$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $9ee3aa3420ae2c81$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $X5A94.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $9ee3aa3420ae2c81$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $9ee3aa3420ae2c81$export$35800275c0037383 = (...args)=>{
    const app = $9ee3aa3420ae2c81$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $9ee3aa3420ae2c81$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $9ee3aa3420ae2c81$var$resolveRootNamespace(container));
    };
    return app;
};
function $9ee3aa3420ae2c81$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $9ee3aa3420ae2c81$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $X5A94.isHTMLTag)(tag) || (0, $X5A94.isSVGTag)(tag) || (0, $X5A94.isMathMLTag)(tag),
        writable: false
    });
}
function $9ee3aa3420ae2c81$var$injectCompilerOptionsCheck(app) {
    if ((0, $ani5R.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $ani5R.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $ani5R.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $ani5R.warn)(msg);
            }
        });
    }
}
function $9ee3aa3420ae2c81$var$normalizeContainer(container) {
    if ((0, $X5A94.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $9ee3aa3420ae2c81$var$ssrDirectiveInitialized = false;
const $9ee3aa3420ae2c81$export$800b28255aa678d9 = ()=>{
    if (!$9ee3aa3420ae2c81$var$ssrDirectiveInitialized) {
        $9ee3aa3420ae2c81$var$ssrDirectiveInitialized = true;
        $9ee3aa3420ae2c81$var$initVModelForSSR();
        $9ee3aa3420ae2c81$var$initVShowForSSR();
    }
};

});



parcelRegister("13HSe", function(module, exports) {

$parcel$export(module.exports, "render", () => $0c581aad2e315a73$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
function $0c581aad2e315a73$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", null, [
        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)($props.startPage), {
            query: $props.query,
            folder: $props.folder
        }, null, 8, [
            "query",
            "folder"
        ]))
    ]);
}

});

parcelRegister("jT0Dj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7a3a51666c47842$export$2e2bcd8739ae039);
let $e7a3a51666c47842$var$NOOP = ()=>{};
var $e7a3a51666c47842$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("3lAm9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2f7d0f789fbcb95d$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");

var $d9Xjz = parcelRequire("d9Xjz");

var $lwv2V = parcelRequire("lwv2V");

var $bzn4g = parcelRequire("bzn4g");

var $4qljO = parcelRequire("4qljO");

var $jQXUZ = parcelRequire("jQXUZ");

var $kH4va = parcelRequire("kH4va");
var $2f7d0f789fbcb95d$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $ani5R.defineComponent)({
    __name: 'ContactForm',
    props: {
        query: {},
        folder: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const { fetchFormData: fetchFormData } = (0, $jQXUZ.useInitialiseForm)(props.query, props.folder);
        const contactFormStore = (0, $4qljO.useContactFormStore)();
        (0, $kH4va.useInitialiseContactList)();
        (0, $ani5R.onMounted)(()=>{
            fetchFormData();
        });
        const formItem = (0, $8bTPG.computed)(()=>contactFormStore.getFirstFormItem);
        const showForm = (0, $8bTPG.computed)(()=>contactFormStore.showForm);
        const showResult = (0, $8bTPG.computed)(()=>contactFormStore.showResult);
        const showSuccess = (0, $8bTPG.computed)(()=>contactFormStore.showSuccessMessage);
        const showError = (0, $8bTPG.computed)(()=>contactFormStore.showFailureMessage);
        const showLoading = (0, $8bTPG.computed)(()=>!contactFormStore.dataReady && !contactFormStore.hasError);
        const __returned__ = {
            props: props,
            fetchFormData: fetchFormData,
            contactFormStore: contactFormStore,
            formItem: formItem,
            showForm: showForm,
            showResult: showResult,
            showSuccess: showSuccess,
            showError: showError,
            showLoading: showLoading,
            ContactFormContainer: $d9Xjz.default,
            ContactFormResult: $lwv2V.default,
            ContactFormLoading: $bzn4g.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("d9Xjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $994a2047849979b3$export$2e2bcd8739ae039);
let $994a2047849979b3$var$script;




let $994a2047849979b3$var$initialize = ()=>{
    $994a2047849979b3$var$script = (parcelRequire("aMp4A"));
    if ($994a2047849979b3$var$script.__esModule) $994a2047849979b3$var$script = $994a2047849979b3$var$script.default;
    $994a2047849979b3$var$script.render = (parcelRequire("7TBpe")).render;
    $994a2047849979b3$var$script.__cssModules = {};
    (parcelRequire("e5Ad9")).default($994a2047849979b3$var$script);
    $994a2047849979b3$var$script.__scopeId = 'data-v-a47082';
    $994a2047849979b3$var$script.__file = "ContactFormContainer.vue";
};
$994a2047849979b3$var$initialize();
var $994a2047849979b3$export$2e2bcd8739ae039 = $994a2047849979b3$var$script;

});
parcelRegister("aMp4A", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c8ddb49d3a1c213d$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");

var $1NIhz = parcelRequire("1NIhz");

var $9w9TI = parcelRequire("9w9TI");

var $cLmPt = parcelRequire("cLmPt");

var $gPyYa = parcelRequire("gPyYa");

var $fdBZp = parcelRequire("fdBZp");
var $c8ddb49d3a1c213d$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $ani5R.defineComponent)({
    __name: 'ContactFormContainer',
    props: {
        formItem: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const isRTL = (0, $8bTPG.computed)(()=>props.formItem.setFormRtl ? 'rtl' : 'ltr');
        const { onSubmitForm: onSubmitForm } = (0, $1NIhz.useSubmitForm)();
        const { currentTopic: currentTopic, allTopics: allTopics, privacyActive: privacyActive, contactListActive: contactListActive, otherTopicActive: otherTopicActive } = (0, $9w9TI.useFormTopics)();
        const __returned__ = {
            props: props,
            isRTL: isRTL,
            onSubmitForm: onSubmitForm,
            currentTopic: currentTopic,
            allTopics: allTopics,
            privacyActive: privacyActive,
            contactListActive: contactListActive,
            otherTopicActive: otherTopicActive,
            ContactFormPrivacyOption: $cLmPt.default,
            ContactFormContactList: $gPyYa.default,
            ContactFormOtherOptions: $fdBZp.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("1NIhz", function(module, exports) {

$parcel$export(module.exports, "useSubmitForm", () => $fc80056be7c9fcb4$export$f892117c4d06c1ea);

var $4qljO = parcelRequire("4qljO");
const $fc80056be7c9fcb4$var$getSiteMarket = ()=>{
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    return pathSegments.length >= 2 ? `${pathSegments[0]}/${pathSegments[1]}` : '';
};
const $fc80056be7c9fcb4$var$addConfigsToPayload = (payload, formPath, templatePath, market, siteMarket)=>{
    return {
        ...payload,
        form_path: formPath,
        template_path: templatePath,
        market: market,
        siteMarket: siteMarket
    };
};
const $fc80056be7c9fcb4$var$sendToApi = (payload, url)=>{
    return fetch(url, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    });
};
const $fc80056be7c9fcb4$export$f892117c4d06c1ea = ()=>{
    const contactFormStore = (0, $4qljO.useContactFormStore)();
    const formPath = contactFormStore.getFormConfigurationPath ?? '';
    const templatePath = contactFormStore.getFormTemplatePath ?? '';
    const apiEndpoint = contactFormStore.getFormProcessorApiEndPoint ?? '';
    const market = contactFormStore.getMarket ?? '';
    const siteMarket = $fc80056be7c9fcb4$var$getSiteMarket();
    const onSubmitForm = (payload)=>{
        grecaptcha.enterprise.execute(contactFormStore.getRecaptchaSiteKey, {
            action: contactFormStore.getRecaptchaActionWord
        }).then((recaptchaResponse)=>{
            const payloadWithRecaptcha = {
                ...payload,
                'g-recaptcha-response': recaptchaResponse,
                'site-key': contactFormStore.getRecaptchaSiteKey
            };
            const finalPayload = $fc80056be7c9fcb4$var$addConfigsToPayload(payloadWithRecaptcha, formPath, templatePath, market, siteMarket);
            return $fc80056be7c9fcb4$var$sendToApi(finalPayload, apiEndpoint);
        }).then((response)=>{
            contactFormStore.updateFormStatus(!response.ok);
        }).catch(()=>{
            contactFormStore.updateFormStatus(true);
        });
    };
    return {
        onSubmitForm: onSubmitForm
    };
};

});
parcelRegister("4qljO", function(module, exports) {

$parcel$export(module.exports, "useContactFormStore", () => $39c7c2839e1a9ea8$export$595d622c5b1cad01);

var $gqFxE = parcelRequire("gqFxE");
const $39c7c2839e1a9ea8$var$getFirstItemProperty = (formItems, propertyToGet)=>{
    const firstItem = formItems.length > 0 ? formItems[0] : null;
    return firstItem ? firstItem[propertyToGet] : null;
};
const $39c7c2839e1a9ea8$export$595d622c5b1cad01 = (0, $gqFxE.defineStore)('contactFormStore', {
    state: ()=>({
            apiError: false,
            pathError: false,
            dataError: false,
            dataReady: false,
            formItems: [],
            countryItems: [],
            formSent: false,
            formSentError: false,
            recaptchaUrl: '',
            recaptchaActionWord: '',
            recaptchaSiteKey: ''
        }),
    getters: {
        hasError: (state)=>state.apiError || state.pathError || state.dataError,
        getFormItems: (state)=>state.formItems,
        getCountryItems: (state)=>state.countryItems,
        getFirstFormItem: (state)=>state.formItems.length > 0 ? state.formItems[0] : null,
        getFormProcessorApiEndPoint: (state)=>$39c7c2839e1a9ea8$var$getFirstItemProperty(state.formItems, 'formProcessorApiEndpoint'),
        getContactListApiEndPoint: (state)=>$39c7c2839e1a9ea8$var$getFirstItemProperty(state.formItems, 'contactListApiEndpoint'),
        getFormConfigurationPath: (state)=>$39c7c2839e1a9ea8$var$getFirstItemProperty(state.formItems, 'formConfigurationPath'),
        getFormTemplatePath: (state)=>$39c7c2839e1a9ea8$var$getFirstItemProperty(state.formItems, 'formTemplatePath'),
        getMarket: (state)=>$39c7c2839e1a9ea8$var$getFirstItemProperty(state.formItems, 'market'),
        getRecaptchaUrl: (state)=>''.concat(state.recaptchaUrl, state.recaptchaSiteKey),
        getRecaptchaActionWord: (state)=>state.recaptchaActionWord,
        getRecaptchaSiteKey: (state)=>state.recaptchaSiteKey,
        showForm: (state)=>state.dataReady && !state.formSent,
        showResult: (state)=>state.dataReady && state.formSent,
        showSuccessMessage: (state)=>state.dataReady && state.formSent && !state.formSentError,
        showFailureMessage: (state)=>state.dataReady && state.formSent && state.formSentError
    },
    actions: {
        setRecaptchaParams (formItem) {
            this.recaptchaUrl = formItem.recaptchaGoogleUrl;
            this.recaptchaActionWord = formItem.recaptchaActionWord;
            this.recaptchaSiteKey = formItem.recaptchaSiteKey;
        },
        loadFormAndCountryItems (formItems, countryItems) {
            this.formItems = formItems;
            const firstItem = this.getFirstFormItem;
            if (firstItem) this.setRecaptchaParams(firstItem);
            this.countryItems = countryItems;
            this.dataReady = true;
        },
        updateFormStatus (hasError) {
            this.formSent = true;
            this.formSentError = hasError;
        }
    }
});

});
parcelRegister("gqFxE", function(module, exports) {

$parcel$export(module.exports, "createPinia", () => $cadf5b4931a2c7e1$export$4b9f6a0748623d44);
$parcel$export(module.exports, "defineStore", () => $cadf5b4931a2c7e1$export$5061c4f75bbcb4a);
$parcel$export(module.exports, "storeToRefs", () => $cadf5b4931a2c7e1$export$586af8bd019552de);
/*!
 * pinia v3.0.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");

var $ebhvL = parcelRequire("ebhvL");
const $cadf5b4931a2c7e1$var$IS_CLIENT = typeof window !== 'undefined';
/**
 * setActivePinia must be called to handle SSR at the top of functions like
 * `fetch`, `setup`, `serverPrefetch` and others
 */ let $cadf5b4931a2c7e1$var$activePinia;
/**
 * Sets or unsets the active pinia. Used in SSR and internally when calling
 * actions and getters
 *
 * @param pinia - Pinia instance
 */ // @ts-expect-error: cannot constrain the type of the return
const $cadf5b4931a2c7e1$export$89ffb8149ccd46af = (pinia)=>$cadf5b4931a2c7e1$var$activePinia = pinia;
/**
 * Get the currently active pinia if there is any.
 */ const $cadf5b4931a2c7e1$export$d0cc41ca14a2d060 = ()=>(0, $ani5R.hasInjectionContext)() && (0, $ani5R.inject)($cadf5b4931a2c7e1$var$piniaSymbol) || $cadf5b4931a2c7e1$var$activePinia;
const $cadf5b4931a2c7e1$var$piniaSymbol = /* istanbul ignore next */ Symbol();
function $cadf5b4931a2c7e1$var$isPlainObject(// eslint-disable-next-line @typescript-eslint/no-explicit-any
o) {
    return o && typeof o === 'object' && Object.prototype.toString.call(o) === '[object Object]' && typeof o.toJSON !== 'function';
}
// type DeepReadonly<T> = { readonly [P in keyof T]: DeepReadonly<T[P]> }
// TODO: can we change these to numbers?
/**
 * Possible types for SubscriptionCallback
 */ var $cadf5b4931a2c7e1$export$d97371ba8df8c539;
(function(MutationType) {
    /**
     * Direct mutation of the state:
     *
     * - `store.name = 'new name'`
     * - `store.$state.name = 'new name'`
     * - `store.list.push('new item')`
     */ MutationType["direct"] = "direct";
    /**
     * Mutated the state with `$patch` and an object
     *
     * - `store.$patch({ name: 'newName' })`
     */ MutationType["patchObject"] = "patch object";
    /**
     * Mutated the state with `$patch` and a function
     *
     * - `store.$patch(state => state.name = 'newName')`
     */ MutationType["patchFunction"] = "patch function";
// maybe reset? for $state = {} and $reset
})($cadf5b4931a2c7e1$export$d97371ba8df8c539 || ($cadf5b4931a2c7e1$export$d97371ba8df8c539 = {}));
/*
 * FileSaver.js A saveAs() FileSaver implementation.
 *
 * Originally by Eli Grey, adapted as an ESM module by Eduardo San Martin
 * Morote.
 *
 * License : MIT
 */ // The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
const $cadf5b4931a2c7e1$var$_global = /*#__PURE__*/ (()=>typeof window === 'object' && window.window === window ? window : typeof self === 'object' && self.self === self ? self : typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global ? $parcel$global : typeof globalThis === 'object' ? globalThis : {
        HTMLElement: null
    })();
function $cadf5b4931a2c7e1$var$bom(blob, { autoBom: autoBom = false } = {}) {
    // prepend BOM for UTF-8 XML and text/* types (including HTML)
    // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
    if (autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
        String.fromCharCode(0xfeff),
        blob
    ], {
        type: blob.type
    });
    return blob;
}
function $cadf5b4931a2c7e1$var$download(url, name, opts) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.onload = function() {
        $cadf5b4931a2c7e1$var$saveAs(xhr.response, name, opts);
    };
    xhr.onerror = function() {
        console.error('could not download file');
    };
    xhr.send();
}
function $cadf5b4931a2c7e1$var$corsEnabled(url) {
    const xhr = new XMLHttpRequest();
    // use sync to avoid popup blocker
    xhr.open('HEAD', url, false);
    try {
        xhr.send();
    } catch (e) {}
    return xhr.status >= 200 && xhr.status <= 299;
}
// `a.click()` doesn't work for all browsers (#465)
function $cadf5b4931a2c7e1$var$click(node) {
    try {
        node.dispatchEvent(new MouseEvent('click'));
    } catch (e) {
        const evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
            detail: 0,
            screenX: 80,
            screenY: 20,
            clientX: 80,
            clientY: 20,
            ctrlKey: false,
            altKey: false,
            shiftKey: false,
            metaKey: false,
            button: 0,
            relatedTarget: null
        });
        node.dispatchEvent(evt);
    }
}
const $cadf5b4931a2c7e1$var$_navigator = typeof navigator === 'object' ? navigator : {
    userAgent: ''
};
// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
const $cadf5b4931a2c7e1$var$isMacOSWebView = /*#__PURE__*/ (()=>/Macintosh/.test($cadf5b4931a2c7e1$var$_navigator.userAgent) && /AppleWebKit/.test($cadf5b4931a2c7e1$var$_navigator.userAgent) && !/Safari/.test($cadf5b4931a2c7e1$var$_navigator.userAgent))();
const $cadf5b4931a2c7e1$var$saveAs = !$cadf5b4931a2c7e1$var$IS_CLIENT ? ()=>{} // noop
 : typeof HTMLAnchorElement !== 'undefined' && 'download' in HTMLAnchorElement.prototype && !$cadf5b4931a2c7e1$var$isMacOSWebView ? $cadf5b4931a2c7e1$var$downloadSaveAs : 'msSaveOrOpenBlob' in $cadf5b4931a2c7e1$var$_navigator ? $cadf5b4931a2c7e1$var$msSaveAs : $cadf5b4931a2c7e1$var$fileSaverSaveAs;
function $cadf5b4931a2c7e1$var$downloadSaveAs(blob, name = 'download', opts) {
    const a = document.createElement('a');
    a.download = name;
    a.rel = 'noopener'; // tabnabbing
    // TODO: detect chrome extensions & packaged apps
    // a.target = '_blank'
    if (typeof blob === 'string') {
        // Support regular links
        a.href = blob;
        if (a.origin !== location.origin) {
            if ($cadf5b4931a2c7e1$var$corsEnabled(a.href)) $cadf5b4931a2c7e1$var$download(blob, name, opts);
            else {
                a.target = '_blank';
                $cadf5b4931a2c7e1$var$click(a);
            }
        } else $cadf5b4931a2c7e1$var$click(a);
    } else {
        // Support blobs
        a.href = URL.createObjectURL(blob);
        setTimeout(function() {
            URL.revokeObjectURL(a.href);
        }, 4e4); // 40s
        setTimeout(function() {
            $cadf5b4931a2c7e1$var$click(a);
        }, 0);
    }
}
function $cadf5b4931a2c7e1$var$msSaveAs(blob, name = 'download', opts) {
    if (typeof blob === 'string') {
        if ($cadf5b4931a2c7e1$var$corsEnabled(blob)) $cadf5b4931a2c7e1$var$download(blob, name, opts);
        else {
            const a = document.createElement('a');
            a.href = blob;
            a.target = '_blank';
            setTimeout(function() {
                $cadf5b4931a2c7e1$var$click(a);
            });
        }
    } else // @ts-ignore: works on windows
    navigator.msSaveOrOpenBlob($cadf5b4931a2c7e1$var$bom(blob, opts), name);
}
function $cadf5b4931a2c7e1$var$fileSaverSaveAs(blob, name, opts, popup) {
    // Open a popup immediately do go around popup blocker
    // Mostly only available on user interaction and the fileReader is async so...
    popup = popup || open('', '_blank');
    if (popup) popup.document.title = popup.document.body.innerText = 'downloading...';
    if (typeof blob === 'string') return $cadf5b4931a2c7e1$var$download(blob, name, opts);
    const force = blob.type === 'application/octet-stream';
    const isSafari = /constructor/i.test(String($cadf5b4931a2c7e1$var$_global.HTMLElement)) || 'safari' in $cadf5b4931a2c7e1$var$_global;
    const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((isChromeIOS || force && isSafari || $cadf5b4931a2c7e1$var$isMacOSWebView) && typeof FileReader !== 'undefined') {
        // Safari doesn't allow downloading of blob URLs
        const reader = new FileReader();
        reader.onloadend = function() {
            let url = reader.result;
            if (typeof url !== 'string') {
                popup = null;
                throw new Error('Wrong reader.result type');
            }
            url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, 'data:attachment/file;');
            if (popup) popup.location.href = url;
            else location.assign(url);
            popup = null; // reverse-tabnabbing #460
        };
        reader.readAsDataURL(blob);
    } else {
        const url = URL.createObjectURL(blob);
        if (popup) popup.location.assign(url);
        else location.href = url;
        popup = null; // reverse-tabnabbing #460
        setTimeout(function() {
            URL.revokeObjectURL(url);
        }, 4e4); // 40s
    }
}
/**
 * Shows a toast or console.log
 *
 * @param message - message to log
 * @param type - different color of the tooltip
 */ function $cadf5b4931a2c7e1$var$toastMessage(message, type) {
    const piniaMessage = "\uD83C\uDF4D " + message;
    if (typeof __VUE_DEVTOOLS_TOAST__ === 'function') // No longer available :(
    __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
    else if (type === 'error') console.error(piniaMessage);
    else if (type === 'warn') console.warn(piniaMessage);
    else console.log(piniaMessage);
}
function $cadf5b4931a2c7e1$var$isPinia(o) {
    return '_a' in o && 'install' in o;
}
/**
 * This file contain devtools actions, they are not Pinia actions.
 */ // ---
function $cadf5b4931a2c7e1$var$checkClipboardAccess() {
    if (!('clipboard' in navigator)) {
        $cadf5b4931a2c7e1$var$toastMessage(`Your browser doesn't support the Clipboard API`, 'error');
        return true;
    }
}
function $cadf5b4931a2c7e1$var$checkNotFocusedError(error) {
    if (error instanceof Error && error.message.toLowerCase().includes('document is not focused')) {
        $cadf5b4931a2c7e1$var$toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', 'warn');
        return true;
    }
    return false;
}
async function $cadf5b4931a2c7e1$var$actionGlobalCopyState(pinia) {
    if ($cadf5b4931a2c7e1$var$checkClipboardAccess()) return;
    try {
        await navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
        $cadf5b4931a2c7e1$var$toastMessage('Global state copied to clipboard.');
    } catch (error) {
        if ($cadf5b4931a2c7e1$var$checkNotFocusedError(error)) return;
        $cadf5b4931a2c7e1$var$toastMessage(`Failed to serialize the state. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function $cadf5b4931a2c7e1$var$actionGlobalPasteState(pinia) {
    if ($cadf5b4931a2c7e1$var$checkClipboardAccess()) return;
    try {
        $cadf5b4931a2c7e1$var$loadStoresState(pinia, JSON.parse(await navigator.clipboard.readText()));
        $cadf5b4931a2c7e1$var$toastMessage('Global state pasted from clipboard.');
    } catch (error) {
        if ($cadf5b4931a2c7e1$var$checkNotFocusedError(error)) return;
        $cadf5b4931a2c7e1$var$toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function $cadf5b4931a2c7e1$var$actionGlobalSaveState(pinia) {
    try {
        $cadf5b4931a2c7e1$var$saveAs(new Blob([
            JSON.stringify(pinia.state.value)
        ], {
            type: 'text/plain;charset=utf-8'
        }), 'pinia-state.json');
    } catch (error) {
        $cadf5b4931a2c7e1$var$toastMessage(`Failed to export the state as JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
let $cadf5b4931a2c7e1$var$fileInput;
function $cadf5b4931a2c7e1$var$getFileOpener() {
    if (!$cadf5b4931a2c7e1$var$fileInput) {
        $cadf5b4931a2c7e1$var$fileInput = document.createElement('input');
        $cadf5b4931a2c7e1$var$fileInput.type = 'file';
        $cadf5b4931a2c7e1$var$fileInput.accept = '.json';
    }
    function openFile() {
        return new Promise((resolve, reject)=>{
            $cadf5b4931a2c7e1$var$fileInput.onchange = async ()=>{
                const files = $cadf5b4931a2c7e1$var$fileInput.files;
                if (!files) return resolve(null);
                const file = files.item(0);
                if (!file) return resolve(null);
                return resolve({
                    text: await file.text(),
                    file: file
                });
            };
            // @ts-ignore: TODO: changed from 4.3 to 4.4
            $cadf5b4931a2c7e1$var$fileInput.oncancel = ()=>resolve(null);
            $cadf5b4931a2c7e1$var$fileInput.onerror = reject;
            $cadf5b4931a2c7e1$var$fileInput.click();
        });
    }
    return openFile;
}
async function $cadf5b4931a2c7e1$var$actionGlobalOpenStateFile(pinia) {
    try {
        const open1 = $cadf5b4931a2c7e1$var$getFileOpener();
        const result = await open1();
        if (!result) return;
        const { text: text, file: file } = result;
        $cadf5b4931a2c7e1$var$loadStoresState(pinia, JSON.parse(text));
        $cadf5b4931a2c7e1$var$toastMessage(`Global state imported from "${file.name}".`);
    } catch (error) {
        $cadf5b4931a2c7e1$var$toastMessage(`Failed to import the state from JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
function $cadf5b4931a2c7e1$var$loadStoresState(pinia, state) {
    for(const key in state){
        const storeState = pinia.state.value[key];
        // store is already instantiated, patch it
        if (storeState) Object.assign(storeState, state[key]);
        else // store is not instantiated, set the initial state
        pinia.state.value[key] = state[key];
    }
}
function $cadf5b4931a2c7e1$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
const $cadf5b4931a2c7e1$var$PINIA_ROOT_LABEL = "\uD83C\uDF4D Pinia (root)";
const $cadf5b4931a2c7e1$var$PINIA_ROOT_ID = '_root';
function $cadf5b4931a2c7e1$var$formatStoreForInspectorTree(store) {
    return $cadf5b4931a2c7e1$var$isPinia(store) ? {
        id: $cadf5b4931a2c7e1$var$PINIA_ROOT_ID,
        label: $cadf5b4931a2c7e1$var$PINIA_ROOT_LABEL
    } : {
        id: store.$id,
        label: store.$id
    };
}
function $cadf5b4931a2c7e1$var$formatStoreForInspectorState(store) {
    if ($cadf5b4931a2c7e1$var$isPinia(store)) {
        const storeNames = Array.from(store._s.keys());
        const storeMap = store._s;
        const state = {
            state: storeNames.map((storeId)=>({
                    editable: true,
                    key: storeId,
                    value: store.state.value[storeId]
                })),
            getters: storeNames.filter((id)=>storeMap.get(id)._getters).map((id)=>{
                const store = storeMap.get(id);
                return {
                    editable: false,
                    key: id,
                    value: store._getters.reduce((getters, key)=>{
                        getters[key] = store[key];
                        return getters;
                    }, {})
                };
            })
        };
        return state;
    }
    const state = {
        state: Object.keys(store.$state).map((key)=>({
                editable: true,
                key: key,
                value: store.$state[key]
            }))
    };
    // avoid adding empty getters
    if (store._getters && store._getters.length) state.getters = store._getters.map((getterName)=>({
            editable: false,
            key: getterName,
            value: store[getterName]
        }));
    if (store._customProperties.size) state.customProperties = Array.from(store._customProperties).map((key)=>({
            editable: true,
            key: key,
            value: store[key]
        }));
    return state;
}
function $cadf5b4931a2c7e1$var$formatEventData(events) {
    if (!events) return {};
    if (Array.isArray(events)) // TODO: handle add and delete for arrays and objects
    return events.reduce((data, event)=>{
        data.keys.push(event.key);
        data.operations.push(event.type);
        data.oldValue[event.key] = event.oldValue;
        data.newValue[event.key] = event.newValue;
        return data;
    }, {
        oldValue: {},
        keys: [],
        operations: [],
        newValue: {}
    });
    else return {
        operation: $cadf5b4931a2c7e1$var$formatDisplay(events.type),
        key: $cadf5b4931a2c7e1$var$formatDisplay(events.key),
        oldValue: events.oldValue,
        newValue: events.newValue
    };
}
function $cadf5b4931a2c7e1$var$formatMutationType(type) {
    switch(type){
        case $cadf5b4931a2c7e1$export$d97371ba8df8c539.direct:
            return 'mutation';
        case $cadf5b4931a2c7e1$export$d97371ba8df8c539.patchFunction:
            return '$patch';
        case $cadf5b4931a2c7e1$export$d97371ba8df8c539.patchObject:
            return '$patch';
        default:
            return 'unknown';
    }
}
// timeline can be paused when directly changing the state
let $cadf5b4931a2c7e1$var$isTimelineActive = true;
const $cadf5b4931a2c7e1$var$componentStateTypes = [];
const $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID = 'pinia:mutations';
const $cadf5b4931a2c7e1$var$INSPECTOR_ID = 'pinia';
const { assign: $cadf5b4931a2c7e1$var$assign$1 } = Object;
/**
 * Gets the displayed name of a store in devtools
 *
 * @param id - id of the store
 * @returns a formatted string
 */ const $cadf5b4931a2c7e1$var$getStoreType = (id)=>"\uD83C\uDF4D " + id;
/**
 * Add the pinia plugin without any store. Allows displaying a Pinia plugin tab
 * as soon as it is added to the application.
 *
 * @param app - Vue application
 * @param pinia - pinia instance
 */ function $cadf5b4931a2c7e1$var$registerPiniaDevtools(app, pinia) {
    (0, $ebhvL.setupDevToolsPlugin)({
        id: 'dev.esm.pinia',
        label: "Pinia \uD83C\uDF4D",
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes: $cadf5b4931a2c7e1$var$componentStateTypes,
        app: app
    }, (api)=>{
        if (typeof api.now !== 'function') $cadf5b4931a2c7e1$var$toastMessage('You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.');
        api.addTimelineLayer({
            id: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
            label: `Pinia \u{1F34D}`,
            color: 0xe5df88
        });
        api.addInspector({
            id: $cadf5b4931a2c7e1$var$INSPECTOR_ID,
            label: "Pinia \uD83C\uDF4D",
            icon: 'storage',
            treeFilterPlaceholder: 'Search stores',
            actions: [
                {
                    icon: 'content_copy',
                    action: ()=>{
                        $cadf5b4931a2c7e1$var$actionGlobalCopyState(pinia);
                    },
                    tooltip: 'Serialize and copy the state'
                },
                {
                    icon: 'content_paste',
                    action: async ()=>{
                        await $cadf5b4931a2c7e1$var$actionGlobalPasteState(pinia);
                        api.sendInspectorTree($cadf5b4931a2c7e1$var$INSPECTOR_ID);
                        api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
                    },
                    tooltip: 'Replace the state with the content of your clipboard'
                },
                {
                    icon: 'save',
                    action: ()=>{
                        $cadf5b4931a2c7e1$var$actionGlobalSaveState(pinia);
                    },
                    tooltip: 'Save the state as a JSON file'
                },
                {
                    icon: 'folder_open',
                    action: async ()=>{
                        await $cadf5b4931a2c7e1$var$actionGlobalOpenStateFile(pinia);
                        api.sendInspectorTree($cadf5b4931a2c7e1$var$INSPECTOR_ID);
                        api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
                    },
                    tooltip: 'Import the state from a JSON file'
                }
            ],
            nodeActions: [
                {
                    icon: 'restore',
                    tooltip: 'Reset the state (with "$reset")',
                    action: (nodeId)=>{
                        const store = pinia._s.get(nodeId);
                        if (!store) $cadf5b4931a2c7e1$var$toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, 'warn');
                        else if (typeof store.$reset !== 'function') $cadf5b4931a2c7e1$var$toastMessage(`Cannot reset "${nodeId}" store because it doesn't have a "$reset" method implemented.`, 'warn');
                        else {
                            store.$reset();
                            $cadf5b4931a2c7e1$var$toastMessage(`Store "${nodeId}" reset.`);
                        }
                    }
                }
            ]
        });
        api.on.inspectComponent((payload)=>{
            const proxy = payload.componentInstance && payload.componentInstance.proxy;
            if (proxy && proxy._pStores) {
                const piniaStores = payload.componentInstance.proxy._pStores;
                Object.values(piniaStores).forEach((store)=>{
                    payload.instanceData.state.push({
                        type: $cadf5b4931a2c7e1$var$getStoreType(store.$id),
                        key: 'state',
                        editable: true,
                        value: store._isOptionsAPI ? {
                            _custom: {
                                value: (0, $8bTPG.toRaw)(store.$state),
                                actions: [
                                    {
                                        icon: 'restore',
                                        tooltip: 'Reset the state of this store',
                                        action: ()=>store.$reset()
                                    }
                                ]
                            }
                        } : Object.keys(store.$state).reduce((state, key)=>{
                            state[key] = store.$state[key];
                            return state;
                        }, {})
                    });
                    if (store._getters && store._getters.length) payload.instanceData.state.push({
                        type: $cadf5b4931a2c7e1$var$getStoreType(store.$id),
                        key: 'getters',
                        editable: false,
                        value: store._getters.reduce((getters, key)=>{
                            try {
                                getters[key] = store[key];
                            } catch (error) {
                                // @ts-expect-error: we just want to show it in devtools
                                getters[key] = error;
                            }
                            return getters;
                        }, {})
                    });
                });
            }
        });
        api.on.getInspectorTree((payload)=>{
            if (payload.app === app && payload.inspectorId === $cadf5b4931a2c7e1$var$INSPECTOR_ID) {
                let stores = [
                    pinia
                ];
                stores = stores.concat(Array.from(pinia._s.values()));
                payload.rootNodes = (payload.filter ? stores.filter((store)=>'$id' in store ? store.$id.toLowerCase().includes(payload.filter.toLowerCase()) : $cadf5b4931a2c7e1$var$PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase())) : stores).map($cadf5b4931a2c7e1$var$formatStoreForInspectorTree);
            }
        });
        // Expose pinia instance as $pinia to window
        globalThis.$pinia = pinia;
        api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === $cadf5b4931a2c7e1$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $cadf5b4931a2c7e1$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) // this could be the selected store restored for a different project
                // so it's better not to say anything here
                return;
                if (inspectedStore) {
                    // Expose selected store as $store to window
                    if (payload.nodeId !== $cadf5b4931a2c7e1$var$PINIA_ROOT_ID) globalThis.$store = (0, $8bTPG.toRaw)(inspectedStore);
                    payload.state = $cadf5b4931a2c7e1$var$formatStoreForInspectorState(inspectedStore);
                }
            }
        });
        api.on.editInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === $cadf5b4931a2c7e1$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $cadf5b4931a2c7e1$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) return $cadf5b4931a2c7e1$var$toastMessage(`store "${payload.nodeId}" not found`, 'error');
                const { path: path } = payload;
                if (!$cadf5b4931a2c7e1$var$isPinia(inspectedStore)) // access only the state
                {
                    if (path.length !== 1 || !inspectedStore._customProperties.has(path[0]) || path[0] in inspectedStore.$state) path.unshift('$state');
                } else // Root access, we can omit the `.value` because the devtools API does it for us
                path.unshift('state');
                $cadf5b4931a2c7e1$var$isTimelineActive = false;
                payload.set(inspectedStore, path, payload.state.value);
                $cadf5b4931a2c7e1$var$isTimelineActive = true;
            }
        });
        api.on.editComponentState((payload)=>{
            if (payload.type.startsWith("\uD83C\uDF4D")) {
                const storeId = payload.type.replace(/^🍍\s*/, '');
                const store = pinia._s.get(storeId);
                if (!store) return $cadf5b4931a2c7e1$var$toastMessage(`store "${storeId}" not found`, 'error');
                const { path: path } = payload;
                if (path[0] !== 'state') return $cadf5b4931a2c7e1$var$toastMessage(`Invalid path for store "${storeId}":\n${path}\nOnly state can be modified.`);
                // rewrite the first entry to be able to directly set the state as
                // well as any other path
                path[0] = '$state';
                $cadf5b4931a2c7e1$var$isTimelineActive = false;
                payload.set(store, path, payload.state.value);
                $cadf5b4931a2c7e1$var$isTimelineActive = true;
            }
        });
    });
}
function $cadf5b4931a2c7e1$var$addStoreToDevtools(app, store) {
    if (!$cadf5b4931a2c7e1$var$componentStateTypes.includes($cadf5b4931a2c7e1$var$getStoreType(store.$id))) $cadf5b4931a2c7e1$var$componentStateTypes.push($cadf5b4931a2c7e1$var$getStoreType(store.$id));
    (0, $ebhvL.setupDevToolsPlugin)({
        id: 'dev.esm.pinia',
        label: "Pinia \uD83C\uDF4D",
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes: $cadf5b4931a2c7e1$var$componentStateTypes,
        app: app,
        settings: {
            logStoreChanges: {
                label: 'Notify about new/deleted stores',
                type: 'boolean',
                defaultValue: true
            }
        }
    }, (api)=>{
        // gracefully handle errors
        const now = typeof api.now === 'function' ? api.now.bind(api) : Date.now;
        store.$onAction(({ after: after, onError: onError, name: name, args: args })=>{
            const groupId = $cadf5b4931a2c7e1$var$runningActionId++;
            api.addTimelineEvent({
                layerId: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDEEB " + name,
                    subtitle: 'start',
                    data: {
                        store: $cadf5b4931a2c7e1$var$formatDisplay(store.$id),
                        action: $cadf5b4931a2c7e1$var$formatDisplay(name),
                        args: args
                    },
                    groupId: groupId
                }
            });
            after((result)=>{
                $cadf5b4931a2c7e1$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: "\uD83D\uDEEC " + name,
                        subtitle: 'end',
                        data: {
                            store: $cadf5b4931a2c7e1$var$formatDisplay(store.$id),
                            action: $cadf5b4931a2c7e1$var$formatDisplay(name),
                            args: args,
                            result: result
                        },
                        groupId: groupId
                    }
                });
            });
            onError((error)=>{
                $cadf5b4931a2c7e1$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        logType: 'error',
                        title: "\uD83D\uDCA5 " + name,
                        subtitle: 'end',
                        data: {
                            store: $cadf5b4931a2c7e1$var$formatDisplay(store.$id),
                            action: $cadf5b4931a2c7e1$var$formatDisplay(name),
                            args: args,
                            error: error
                        },
                        groupId: groupId
                    }
                });
            });
        }, true);
        store._customProperties.forEach((name)=>{
            (0, $8bTPG.watch)(()=>(0, $8bTPG.unref)(store[name]), (newValue, oldValue)=>{
                api.notifyComponentUpdate();
                api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
                if ($cadf5b4931a2c7e1$var$isTimelineActive) api.addTimelineEvent({
                    layerId: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: 'Change',
                        subtitle: name,
                        data: {
                            newValue: newValue,
                            oldValue: oldValue
                        },
                        groupId: $cadf5b4931a2c7e1$var$activeAction
                    }
                });
            }, {
                deep: true
            });
        });
        store.$subscribe(({ events: events, type: type }, state)=>{
            api.notifyComponentUpdate();
            api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
            if (!$cadf5b4931a2c7e1$var$isTimelineActive) return;
            // rootStore.state[store.id] = state
            const eventData = {
                time: now(),
                title: $cadf5b4931a2c7e1$var$formatMutationType(type),
                data: $cadf5b4931a2c7e1$var$assign$1({
                    store: $cadf5b4931a2c7e1$var$formatDisplay(store.$id)
                }, $cadf5b4931a2c7e1$var$formatEventData(events)),
                groupId: $cadf5b4931a2c7e1$var$activeAction
            };
            if (type === $cadf5b4931a2c7e1$export$d97371ba8df8c539.patchFunction) eventData.subtitle = "\u2935\uFE0F";
            else if (type === $cadf5b4931a2c7e1$export$d97371ba8df8c539.patchObject) eventData.subtitle = "\uD83E\uDDE9";
            else if (events && !Array.isArray(events)) eventData.subtitle = events.type;
            if (events) eventData.data['rawEvent(s)'] = {
                _custom: {
                    display: 'DebuggerEvent',
                    type: 'object',
                    tooltip: 'raw DebuggerEvent[]',
                    value: events
                }
            };
            api.addTimelineEvent({
                layerId: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
                event: eventData
            });
        }, {
            detached: true,
            flush: 'sync'
        });
        const hotUpdate = store._hotUpdate;
        store._hotUpdate = (0, $8bTPG.markRaw)((newStore)=>{
            hotUpdate(newStore);
            api.addTimelineEvent({
                layerId: $cadf5b4931a2c7e1$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDD25 " + store.$id,
                    subtitle: 'HMR update',
                    data: {
                        store: $cadf5b4931a2c7e1$var$formatDisplay(store.$id),
                        info: $cadf5b4931a2c7e1$var$formatDisplay(`HMR update`)
                    }
                }
            });
            // update the devtools too
            api.notifyComponentUpdate();
            api.sendInspectorTree($cadf5b4931a2c7e1$var$INSPECTOR_ID);
            api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
        });
        const { $dispose: $dispose } = store;
        store.$dispose = ()=>{
            $dispose();
            api.notifyComponentUpdate();
            api.sendInspectorTree($cadf5b4931a2c7e1$var$INSPECTOR_ID);
            api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
            api.getSettings().logStoreChanges && $cadf5b4931a2c7e1$var$toastMessage(`Disposed "${store.$id}" store \u{1F5D1}`);
        };
        // trigger an update so it can display new registered stores
        api.notifyComponentUpdate();
        api.sendInspectorTree($cadf5b4931a2c7e1$var$INSPECTOR_ID);
        api.sendInspectorState($cadf5b4931a2c7e1$var$INSPECTOR_ID);
        api.getSettings().logStoreChanges && $cadf5b4931a2c7e1$var$toastMessage(`"${store.$id}" store installed \u{1F195}`);
    });
}
let $cadf5b4931a2c7e1$var$runningActionId = 0;
let $cadf5b4931a2c7e1$var$activeAction;
/**
 * Patches a store to enable action grouping in devtools by wrapping the store with a Proxy that is passed as the
 * context of all actions, allowing us to set `runningAction` on each access and effectively associating any state
 * mutation to the action.
 *
 * @param store - store to patch
 * @param actionNames - list of actionst to patch
 */ function $cadf5b4931a2c7e1$var$patchActionForGrouping(store, actionNames, wrapWithProxy) {
    // original actions of the store as they are given by pinia. We are going to override them
    const actions = actionNames.reduce((storeActions, actionName)=>{
        // use toRaw to avoid tracking #541
        storeActions[actionName] = (0, $8bTPG.toRaw)(store)[actionName];
        return storeActions;
    }, {});
    for(const actionName in actions)store[actionName] = function() {
        // the running action id is incremented in a before action hook
        const _actionId = $cadf5b4931a2c7e1$var$runningActionId;
        const trackedStore = wrapWithProxy ? new Proxy(store, {
            get (...args) {
                $cadf5b4931a2c7e1$var$activeAction = _actionId;
                return Reflect.get(...args);
            },
            set (...args) {
                $cadf5b4931a2c7e1$var$activeAction = _actionId;
                return Reflect.set(...args);
            }
        }) : store;
        // For Setup Stores we need https://github.com/tc39/proposal-async-context
        $cadf5b4931a2c7e1$var$activeAction = _actionId;
        const retValue = actions[actionName].apply(trackedStore, arguments);
        // this is safer as async actions in Setup Stores would associate mutations done outside of the action
        $cadf5b4931a2c7e1$var$activeAction = undefined;
        return retValue;
    };
}
/**
 * pinia.use(devtoolsPlugin)
 */ function $cadf5b4931a2c7e1$var$devtoolsPlugin({ app: app, store: store, options: options }) {
    // HMR module
    if (store.$id.startsWith('__hot:')) return;
    // detect option api vs setup api
    store._isOptionsAPI = !!options.state;
    // Do not overwrite actions mocked by @pinia/testing (#2298)
    if (!store._p._testing) {
        $cadf5b4931a2c7e1$var$patchActionForGrouping(store, Object.keys(options.actions), store._isOptionsAPI);
        // Upgrade the HMR to also update the new actions
        const originalHotUpdate = store._hotUpdate;
        (0, $8bTPG.toRaw)(store)._hotUpdate = function(newStore) {
            originalHotUpdate.apply(this, arguments);
            $cadf5b4931a2c7e1$var$patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions), !!store._isOptionsAPI);
        };
    }
    $cadf5b4931a2c7e1$var$addStoreToDevtools(app, // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
    store);
}
/**
 * Creates a Pinia instance to be used by the application
 */ function $cadf5b4931a2c7e1$export$4b9f6a0748623d44() {
    const scope = (0, $8bTPG.effectScope)(true);
    // NOTE: here we could check the window object for a state and directly set it
    // if there is anything like it with Vue 3 SSR
    const state = scope.run(()=>(0, $8bTPG.ref)({}));
    let _p = [];
    // plugins added before calling app.use(pinia)
    let toBeInstalled = [];
    const pinia = (0, $8bTPG.markRaw)({
        install (app) {
            // this allows calling useStore() outside of a component setup after
            // installing pinia's plugin
            $cadf5b4931a2c7e1$export$89ffb8149ccd46af(pinia);
            pinia._a = app;
            app.provide($cadf5b4931a2c7e1$var$piniaSymbol, pinia);
            app.config.globalProperties.$pinia = pinia;
            /* istanbul ignore else */ if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $cadf5b4931a2c7e1$var$IS_CLIENT) $cadf5b4931a2c7e1$var$registerPiniaDevtools(app, pinia);
            toBeInstalled.forEach((plugin)=>_p.push(plugin));
            toBeInstalled = [];
        },
        use (plugin) {
            if (!this._a) toBeInstalled.push(plugin);
            else _p.push(plugin);
            return this;
        },
        _p: _p,
        // it's actually undefined here
        // @ts-expect-error
        _a: null,
        _e: scope,
        _s: new Map(),
        state: state
    });
    // pinia devtools rely on dev only features so they cannot be forced unless
    // the dev build of Vue is used. Avoid old browsers like IE11.
    if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $cadf5b4931a2c7e1$var$IS_CLIENT && typeof Proxy !== 'undefined') pinia.use($cadf5b4931a2c7e1$var$devtoolsPlugin);
    return pinia;
}
/**
 * Dispose a Pinia instance by stopping its effectScope and removing the state, plugins and stores. This is mostly
 * useful in tests, with both a testing pinia or a regular pinia and in applications that use multiple pinia instances.
 * Once disposed, the pinia instance cannot be used anymore.
 *
 * @param pinia - pinia instance
 */ function $cadf5b4931a2c7e1$export$75b0179c67a9344e(pinia) {
    pinia._e.stop();
    pinia._s.clear();
    pinia._p.splice(0);
    pinia.state.value = {};
    // @ts-expect-error: non valid
    pinia._a = null;
}
/**
 * Checks if a function is a `StoreDefinition`.
 *
 * @param fn - object to test
 * @returns true if `fn` is a StoreDefinition
 */ const $cadf5b4931a2c7e1$var$isUseStore = (fn)=>{
    return typeof fn === 'function' && typeof fn.$id === 'string';
};
/**
 * Mutates in place `newState` with `oldState` to _hot update_ it. It will
 * remove any key not existing in `newState` and recursively merge plain
 * objects.
 *
 * @param newState - new state object to be patched
 * @param oldState - old state that should be used to patch newState
 * @returns - newState
 */ function $cadf5b4931a2c7e1$var$patchObject(newState, oldState) {
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in oldState){
        const subPatch = oldState[key];
        // skip the whole sub tree
        if (!(key in newState)) continue;
        const targetValue = newState[key];
        if ($cadf5b4931a2c7e1$var$isPlainObject(targetValue) && $cadf5b4931a2c7e1$var$isPlainObject(subPatch) && !(0, $8bTPG.isRef)(subPatch) && !(0, $8bTPG.isReactive)(subPatch)) newState[key] = $cadf5b4931a2c7e1$var$patchObject(targetValue, subPatch);
        else // objects are either a bit more complex (e.g. refs) or primitives, so we
        // just set the whole thing
        newState[key] = subPatch;
    }
    return newState;
}
/**
 * Creates an _accept_ function to pass to `import.meta.hot` in Vite applications.
 *
 * @example
 * ```js
 * const useUser = defineStore(...)
 * if (import.meta.hot) {
 *   import.meta.hot.accept(acceptHMRUpdate(useUser, import.meta.hot))
 * }
 * ```
 *
 * @param initialUseStore - return of the defineStore to hot update
 * @param hot - `import.meta.hot`
 */ function $cadf5b4931a2c7e1$export$d3530ca2abd36d5e(initialUseStore, hot) {
    var newModule;
    return ()=>{};
}
const $cadf5b4931a2c7e1$var$noop = ()=>{};
function $cadf5b4931a2c7e1$var$addSubscription(subscriptions, callback, detached, onCleanup = $cadf5b4931a2c7e1$var$noop) {
    subscriptions.add(callback);
    const removeSubscription = ()=>{
        const isDel = subscriptions.delete(callback);
        isDel && onCleanup();
    };
    if (!detached && (0, $8bTPG.getCurrentScope)()) (0, $8bTPG.onScopeDispose)(removeSubscription);
    return removeSubscription;
}
function $cadf5b4931a2c7e1$var$triggerSubscriptions(subscriptions, ...args) {
    subscriptions.forEach((callback)=>{
        callback(...args);
    });
}
const $cadf5b4931a2c7e1$var$fallbackRunWithContext = (fn)=>fn();
/**
 * Marks a function as an action for `$onAction`
 * @internal
 */ const $cadf5b4931a2c7e1$var$ACTION_MARKER = Symbol();
/**
 * Action name symbol. Allows to add a name to an action after defining it
 * @internal
 */ const $cadf5b4931a2c7e1$var$ACTION_NAME = Symbol();
function $cadf5b4931a2c7e1$var$mergeReactiveObjects(target, patchToApply) {
    // Handle Map instances
    if (target instanceof Map && patchToApply instanceof Map) patchToApply.forEach((value, key)=>target.set(key, value));
    else if (target instanceof Set && patchToApply instanceof Set) // Handle Set instances
    patchToApply.forEach(target.add, target);
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in patchToApply){
        if (!patchToApply.hasOwnProperty(key)) continue;
        const subPatch = patchToApply[key];
        const targetValue = target[key];
        if ($cadf5b4931a2c7e1$var$isPlainObject(targetValue) && $cadf5b4931a2c7e1$var$isPlainObject(subPatch) && target.hasOwnProperty(key) && !(0, $8bTPG.isRef)(subPatch) && !(0, $8bTPG.isReactive)(subPatch)) // NOTE: here I wanted to warn about inconsistent types but it's not possible because in setup stores one might
        // start the value of a property as a certain type e.g. a Map, and then for some reason, during SSR, change that
        // to `undefined`. When trying to hydrate, we want to override the Map with `undefined`.
        target[key] = $cadf5b4931a2c7e1$var$mergeReactiveObjects(targetValue, subPatch);
        else // @ts-expect-error: subPatch is a valid value
        target[key] = subPatch;
    }
    return target;
}
const $cadf5b4931a2c7e1$var$skipHydrateSymbol = /* istanbul ignore next */ Symbol();
/**
 * Tells Pinia to skip the hydration process of a given object. This is useful in setup stores (only) when you return a
 * stateful object in the store but it isn't really state. e.g. returning a router instance in a setup store.
 *
 * @param obj - target object
 * @returns obj
 */ function $cadf5b4931a2c7e1$export$dbb88672ab248e88(obj) {
    return Object.defineProperty(obj, $cadf5b4931a2c7e1$var$skipHydrateSymbol, {});
}
/**
 * Returns whether a value should be hydrated
 *
 * @param obj - target variable
 * @returns true if `obj` should be hydrated
 */ function $cadf5b4931a2c7e1$export$bdc3d2e33d3136e5(obj) {
    return !$cadf5b4931a2c7e1$var$isPlainObject(obj) || !Object.prototype.hasOwnProperty.call(obj, $cadf5b4931a2c7e1$var$skipHydrateSymbol);
}
const { assign: $cadf5b4931a2c7e1$var$assign } = Object;
function $cadf5b4931a2c7e1$var$isComputed(o) {
    return !!((0, $8bTPG.isRef)(o) && o.effect);
}
function $cadf5b4931a2c7e1$var$createOptionsStore(id, options, pinia, hot) {
    const { state: state, actions: actions, getters: getters } = options;
    const initialState = pinia.state.value[id];
    let store;
    function setup() {
        if (!initialState && true) /* istanbul ignore if */ pinia.state.value[id] = state ? state() : {};
        // avoid creating a state in pinia.state.value
        const localState = (0, $8bTPG.toRefs)(pinia.state.value[id]);
        return $cadf5b4931a2c7e1$var$assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name)=>{
            computedGetters[name] = (0, $8bTPG.markRaw)((0, $8bTPG.computed)(()=>{
                $cadf5b4931a2c7e1$export$89ffb8149ccd46af(pinia);
                // it was created just before
                const store = pinia._s.get(id);
                // allow cross using stores
                // @ts-expect-error
                // return getters![name].call(context, context)
                // TODO: avoid reading the getter while assigning with a global variable
                return getters[name].call(store, store);
            }));
            return computedGetters;
        }, {}));
    }
    store = $cadf5b4931a2c7e1$var$createSetupStore(id, setup, options, pinia, hot, true);
    return store;
}
function $cadf5b4931a2c7e1$var$createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
    let scope;
    const optionsForPlugin = $cadf5b4931a2c7e1$var$assign({
        actions: {}
    }, options);
    // watcher options for $subscribe
    const $subscribeOptions = {
        deep: true
    };
    var event;
    // internal state
    let isListening; // set to true at the end
    let isSyncListening; // set to true at the end
    let subscriptions = new Set();
    let actionSubscriptions = new Set();
    let debuggerEvents;
    const initialState = pinia.state.value[$id];
    // avoid setting the state for option stores if it is set
    // by the setup
    if (!isOptionsStore && !initialState && true) /* istanbul ignore if */ pinia.state.value[$id] = {};
    const hotState = (0, $8bTPG.ref)({});
    // avoid triggering too many listeners
    // https://github.com/vuejs/pinia/issues/1129
    let activeListener;
    function $patch(partialStateOrMutator) {
        let subscriptionMutation;
        isListening = isSyncListening = false;
        if (typeof partialStateOrMutator === 'function') {
            partialStateOrMutator(pinia.state.value[$id]);
            subscriptionMutation = {
                type: $cadf5b4931a2c7e1$export$d97371ba8df8c539.patchFunction,
                storeId: $id,
                events: debuggerEvents
            };
        } else {
            $cadf5b4931a2c7e1$var$mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
            subscriptionMutation = {
                type: $cadf5b4931a2c7e1$export$d97371ba8df8c539.patchObject,
                payload: partialStateOrMutator,
                storeId: $id,
                events: debuggerEvents
            };
        }
        const myListenerId = activeListener = Symbol();
        (0, $ani5R.nextTick)().then(()=>{
            if (activeListener === myListenerId) isListening = true;
        });
        isSyncListening = true;
        // because we paused the watcher, we need to manually call the subscriptions
        $cadf5b4931a2c7e1$var$triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
    }
    const $reset = isOptionsStore ? function $reset() {
        const { state: state } = options;
        const newState = state ? state() : {};
        // we use a patch to group all changes into one single subscription
        this.$patch(($state)=>{
            // @ts-expect-error: FIXME: shouldn't error?
            $cadf5b4931a2c7e1$var$assign($state, newState);
        });
    } : $cadf5b4931a2c7e1$var$noop;
    function $dispose() {
        scope.stop();
        subscriptions.clear();
        actionSubscriptions.clear();
        pinia._s.delete($id);
    }
    /**
     * Helper that wraps function so it can be tracked with $onAction
     * @param fn - action to wrap
     * @param name - name of the action
     */ const action = (fn, name = '')=>{
        if ($cadf5b4931a2c7e1$var$ACTION_MARKER in fn) {
            fn[$cadf5b4931a2c7e1$var$ACTION_NAME] = name;
            return fn;
        }
        const wrappedAction = function() {
            $cadf5b4931a2c7e1$export$89ffb8149ccd46af(pinia);
            const args = Array.from(arguments);
            const afterCallbackSet = new Set();
            const onErrorCallbackSet = new Set();
            function after(callback) {
                afterCallbackSet.add(callback);
            }
            function onError(callback) {
                onErrorCallbackSet.add(callback);
            }
            // @ts-expect-error
            $cadf5b4931a2c7e1$var$triggerSubscriptions(actionSubscriptions, {
                args: args,
                name: wrappedAction[$cadf5b4931a2c7e1$var$ACTION_NAME],
                store: store,
                after: after,
                onError: onError
            });
            let ret;
            try {
                ret = fn.apply(this && this.$id === $id ? this : store, args);
            // handle sync errors
            } catch (error) {
                $cadf5b4931a2c7e1$var$triggerSubscriptions(onErrorCallbackSet, error);
                throw error;
            }
            if (ret instanceof Promise) return ret.then((value)=>{
                $cadf5b4931a2c7e1$var$triggerSubscriptions(afterCallbackSet, value);
                return value;
            }).catch((error)=>{
                $cadf5b4931a2c7e1$var$triggerSubscriptions(onErrorCallbackSet, error);
                return Promise.reject(error);
            });
            // trigger after callbacks
            $cadf5b4931a2c7e1$var$triggerSubscriptions(afterCallbackSet, ret);
            return ret;
        };
        wrappedAction[$cadf5b4931a2c7e1$var$ACTION_MARKER] = true;
        wrappedAction[$cadf5b4931a2c7e1$var$ACTION_NAME] = name; // will be set later
        // @ts-expect-error: we are intentionally limiting the returned type to just Fn
        // because all the added properties are internals that are exposed through `$onAction()` only
        return wrappedAction;
    };
    const _hmrPayload = /*#__PURE__*/ (0, $8bTPG.markRaw)({
        actions: {},
        getters: {},
        state: [],
        hotState: hotState
    });
    const partialStore = {
        _p: pinia,
        $id: // _s: scope,
        $id,
        $onAction: $cadf5b4931a2c7e1$var$addSubscription.bind(null, actionSubscriptions),
        $patch: $patch,
        $reset: $reset,
        $subscribe (callback, options = {}) {
            const removeSubscription = $cadf5b4931a2c7e1$var$addSubscription(subscriptions, callback, options.detached, ()=>stopWatcher());
            const stopWatcher = scope.run(()=>(0, $8bTPG.watch)(()=>pinia.state.value[$id], (state)=>{
                    if (options.flush === 'sync' ? isSyncListening : isListening) callback({
                        storeId: $id,
                        type: $cadf5b4931a2c7e1$export$d97371ba8df8c539.direct,
                        events: debuggerEvents
                    }, state);
                }, $cadf5b4931a2c7e1$var$assign({}, $subscribeOptions, options)));
            return removeSubscription;
        },
        $dispose: $dispose
    };
    const store = (0, $8bTPG.reactive)(typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $cadf5b4931a2c7e1$var$IS_CLIENT ? $cadf5b4931a2c7e1$var$assign({
        _hmrPayload: _hmrPayload,
        _customProperties: (0, $8bTPG.markRaw)(new Set())
    }, partialStore) : partialStore);
    // store the partial store now so the setup of stores can instantiate each other before they are finished without
    // creating infinite loops.
    pinia._s.set($id, store);
    const runWithContext = pinia._a && pinia._a.runWithContext || $cadf5b4931a2c7e1$var$fallbackRunWithContext;
    // TODO: idea create skipSerialize that marks properties as non serializable and they are skipped
    const setupStore = runWithContext(()=>pinia._e.run(()=>(scope = (0, $8bTPG.effectScope)()).run(()=>setup({
                    action: action
                }))));
    // overwrite existing actions to support $onAction
    for(const key in setupStore){
        const prop = setupStore[key];
        if ((0, $8bTPG.isRef)(prop) && !$cadf5b4931a2c7e1$var$isComputed(prop) || (0, $8bTPG.isReactive)(prop)) {
            if (!isOptionsStore) {
                // in setup stores we must hydrate the state and sync pinia state tree with the refs the user just created
                if (initialState && $cadf5b4931a2c7e1$export$bdc3d2e33d3136e5(prop)) {
                    if ((0, $8bTPG.isRef)(prop)) prop.value = initialState[key];
                    else // probably a reactive object, lets recursively assign
                    // @ts-expect-error: prop is unknown
                    $cadf5b4931a2c7e1$var$mergeReactiveObjects(prop, initialState[key]);
                }
                // transfer the ref to the pinia state to keep everything in sync
                pinia.state.value[$id][key] = prop;
            }
        } else if (typeof prop === 'function') {
            const actionValue = action(prop, key);
            // this a hot module replacement store because the hotUpdate method needs
            // to do it with the right context
            // @ts-expect-error
            setupStore[key] = actionValue;
            // list actions so they can be used in plugins
            // @ts-expect-error
            optionsForPlugin.actions[key] = prop;
        }
    }
    // add the state, getters, and action properties
    /* istanbul ignore if */ $cadf5b4931a2c7e1$var$assign(store, setupStore);
    // allows retrieving reactive objects with `storeToRefs()`. Must be called after assigning to the reactive object.
    // Make `storeToRefs()` work with `reactive()` #799
    $cadf5b4931a2c7e1$var$assign((0, $8bTPG.toRaw)(store), setupStore);
    // use this instead of a computed with setter to be able to create it anywhere
    // without linking the computed lifespan to wherever the store is first
    // created.
    Object.defineProperty(store, '$state', {
        get: ()=>(0, pinia.state.value[$id]),
        set: (state)=>{
            $patch(($state)=>{
                // @ts-expect-error: FIXME: shouldn't error?
                $cadf5b4931a2c7e1$var$assign($state, state);
            });
        }
    });
    var newStore, stateKey, stateKey1, key, key1;
    if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $cadf5b4931a2c7e1$var$IS_CLIENT) {
        const nonEnumerable = {
            writable: true,
            configurable: true,
            // avoid warning on devtools trying to display this property
            enumerable: false
        };
        [
            '_p',
            '_hmrPayload',
            '_getters',
            '_customProperties'
        ].forEach((p)=>{
            Object.defineProperty(store, p, $cadf5b4931a2c7e1$var$assign({
                value: store[p]
            }, nonEnumerable));
        });
    }
    // apply all plugins
    pinia._p.forEach((extender)=>{
        /* istanbul ignore else */ if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $cadf5b4931a2c7e1$var$IS_CLIENT) {
            const extensions = scope.run(()=>extender({
                    store: store,
                    app: pinia._a,
                    pinia: pinia,
                    options: optionsForPlugin
                }));
            Object.keys(extensions || {}).forEach((key)=>store._customProperties.add(key));
            $cadf5b4931a2c7e1$var$assign(store, extensions);
        } else $cadf5b4931a2c7e1$var$assign(store, scope.run(()=>extender({
                store: store,
                app: pinia._a,
                pinia: pinia,
                options: optionsForPlugin
            })));
    });
    // only apply hydrate to option stores with an initial state in pinia
    if (initialState && isOptionsStore && options.hydrate) options.hydrate(store.$state, initialState);
    isListening = true;
    isSyncListening = true;
    return store;
}
// allows unused stores to be tree shaken
/*! #__NO_SIDE_EFFECTS__ */ function $cadf5b4931a2c7e1$export$5061c4f75bbcb4a(// TODO: add proper types from above
id, setup, setupOptions) {
    let options;
    const isSetupStore = typeof setup === 'function';
    // the option store setup will contain the actual options in this case
    options = isSetupStore ? setupOptions : setup;
    function useStore(pinia, hot) {
        const hasContext = (0, $ani5R.hasInjectionContext)();
        pinia = pinia || (hasContext ? (0, $ani5R.inject)($cadf5b4931a2c7e1$var$piniaSymbol, null) : null);
        if (pinia) $cadf5b4931a2c7e1$export$89ffb8149ccd46af(pinia);
        pinia = $cadf5b4931a2c7e1$var$activePinia;
        if (!pinia._s.has(id)) {
            // creating the store registers it in `pinia._s`
            if (isSetupStore) $cadf5b4931a2c7e1$var$createSetupStore(id, setup, options, pinia);
            else $cadf5b4931a2c7e1$var$createOptionsStore(id, options, pinia);
        }
        const store = pinia._s.get(id);
        // StoreGeneric cannot be casted towards Store
        return store;
    }
    useStore.$id = id;
    return useStore;
}
let $cadf5b4931a2c7e1$var$mapStoreSuffix = 'Store';
/**
 * Changes the suffix added by `mapStores()`. Can be set to an empty string.
 * Defaults to `"Store"`. Make sure to extend the MapStoresCustomization
 * interface if you are using TypeScript.
 *
 * @param suffix - new suffix
 */ function $cadf5b4931a2c7e1$export$3c0d0850ffd38177(suffix // could be 'Store' but that would be annoying for JS
) {
    $cadf5b4931a2c7e1$var$mapStoreSuffix = suffix;
}
/**
 * Allows using stores without the composition API (`setup()`) by generating an
 * object to be spread in the `computed` field of a component. It accepts a list
 * of store definitions.
 *
 * @example
 * ```js
 * export default {
 *   computed: {
 *     // other computed properties
 *     ...mapStores(useUserStore, useCartStore)
 *   },
 *
 *   created() {
 *     this.userStore // store with id "user"
 *     this.cartStore // store with id "cart"
 *   }
 * }
 * ```
 *
 * @param stores - list of stores to map to an object
 */ function $cadf5b4931a2c7e1$export$4701f243feba9f88(...stores) {
    return stores.reduce((reduced, useStore)=>{
        // @ts-expect-error: $id is added by defineStore
        reduced[useStore.$id + $cadf5b4931a2c7e1$var$mapStoreSuffix] = function() {
            return useStore(this.$pinia);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $cadf5b4931a2c7e1$export$a337c713bdba072(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = function() {
            // @ts-expect-error: FIXME: should work?
            return useStore(this.$pinia)[key];
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function() {
            const store = useStore(this.$pinia);
            const storeKey = keysOrMapper[key];
            // for some reason TS is unable to infer the type of storeKey to be a
            // function
            return typeof storeKey === 'function' ? storeKey.call(this, store) : store[storeKey];
        };
        return reduced;
    }, {});
}
/**
 * Alias for `mapState()`. You should use `mapState()` instead.
 * @deprecated use `mapState()` instead.
 */ const $cadf5b4931a2c7e1$export$74d9085e6d5a97cb = $cadf5b4931a2c7e1$export$a337c713bdba072;
/**
 * Allows directly using actions from your store without using the composition
 * API (`setup()`) by generating an object to be spread in the `methods` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $cadf5b4931a2c7e1$export$1d73b9b98821f6dc(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            // @ts-expect-error: FIXME: should work?
            return useStore(this.$pinia)[key](...args);
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            // @ts-expect-error: FIXME: should work?
            return useStore(this.$pinia)[keysOrMapper[key]](...args);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $cadf5b4931a2c7e1$export$c069310e76f1a3e7(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[key];
            },
            set (value) {
                return useStore(this.$pinia)[key] = value;
            }
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[keysOrMapper[key]];
            },
            set (value) {
                return useStore(this.$pinia)[keysOrMapper[key]] = value;
            }
        };
        return reduced;
    }, {});
}
/**
 * Creates an object of references with all the state, getters, and plugin-added
 * state properties of the store. Similar to `toRefs()` but specifically
 * designed for Pinia stores so methods and non reactive properties are
 * completely ignored.
 *
 * @param store - store to extract the refs from
 */ function $cadf5b4931a2c7e1$export$586af8bd019552de(store) {
    const rawStore = (0, $8bTPG.toRaw)(store);
    const refs = {};
    for(const key in rawStore){
        const value = rawStore[key];
        // There is no native method to check for a computed
        // https://github.com/vuejs/core/pull/4165
        if (value.effect) // @ts-expect-error: too hard to type correctly
        refs[key] = // ...
        (0, $8bTPG.computed)({
            get: ()=>store[key],
            set (value) {
                store[key] = value;
            }
        });
        else if ((0, $8bTPG.isRef)(value) || (0, $8bTPG.isReactive)(value)) // @ts-expect-error: the key is state or getter
        refs[key] = // ---
        (0, $8bTPG.toRef)(store, key);
    }
    return refs;
}

});
parcelRegister("ebhvL", function(module, exports) {

$parcel$export(module.exports, "setupDevToolsPlugin", () => $a52fad25e66add48$export$1f0daed17c8e64f);

var $gNtJt = parcelRequire("gNtJt");

var $bV4bh = parcelRequire("bV4bh");

var $55txk = parcelRequire("55txk");

var $5cFFA = parcelRequire("5cFFA");
var $a52fad25e66add48$var$__create = Object.create;
var $a52fad25e66add48$var$__defProp = Object.defineProperty;
var $a52fad25e66add48$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $a52fad25e66add48$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $a52fad25e66add48$var$__getProtoOf = Object.getPrototypeOf;
var $a52fad25e66add48$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a52fad25e66add48$var$__esm = (fn, res)=>function __init() {
        return fn && (res = (0, fn[$a52fad25e66add48$var$__getOwnPropNames(fn)[0]])(fn = 0)), res;
    };
var $a52fad25e66add48$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$a52fad25e66add48$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $a52fad25e66add48$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $a52fad25e66add48$var$__getOwnPropNames(from))if (!$a52fad25e66add48$var$__hasOwnProp.call(to, key) && key !== except) $a52fad25e66add48$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $a52fad25e66add48$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $a52fad25e66add48$var$__toESM = (mod, isNodeMode, target22)=>(target22 = mod != null ? $a52fad25e66add48$var$__create($a52fad25e66add48$var$__getProtoOf(mod)) : {}, $a52fad25e66add48$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $a52fad25e66add48$var$__defProp(target22, "default", {
        value: mod,
        enumerable: true
    }) : target22, mod));
// ../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js
var $a52fad25e66add48$var$init_esm_shims = $a52fad25e66add48$var$__esm({
    "../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js" () {
        "use strict";
    }
});
// ../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js
var $a52fad25e66add48$var$require_speakingurl = $a52fad25e66add48$var$__commonJS({
    "../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js" (exports, module) {
        "use strict";
        $a52fad25e66add48$var$init_esm_shims();
        (function(root) {
            "use strict";
            var charMap = {
                // latin
                "\xC0": "A",
                "\xC1": "A",
                "\xC2": "A",
                "\xC3": "A",
                "\xC4": "Ae",
                "\xC5": "A",
                "\xC6": "AE",
                "\xC7": "C",
                "\xC8": "E",
                "\xC9": "E",
                "\xCA": "E",
                "\xCB": "E",
                "\xCC": "I",
                "\xCD": "I",
                "\xCE": "I",
                "\xCF": "I",
                "\xD0": "D",
                "\xD1": "N",
                "\xD2": "O",
                "\xD3": "O",
                "\xD4": "O",
                "\xD5": "O",
                "\xD6": "Oe",
                "\u0150": "O",
                "\xD8": "O",
                "\xD9": "U",
                "\xDA": "U",
                "\xDB": "U",
                "\xDC": "Ue",
                "\u0170": "U",
                "\xDD": "Y",
                "\xDE": "TH",
                "\xDF": "ss",
                "\xE0": "a",
                "\xE1": "a",
                "\xE2": "a",
                "\xE3": "a",
                "\xE4": "ae",
                "\xE5": "a",
                "\xE6": "ae",
                "\xE7": "c",
                "\xE8": "e",
                "\xE9": "e",
                "\xEA": "e",
                "\xEB": "e",
                "\xEC": "i",
                "\xED": "i",
                "\xEE": "i",
                "\xEF": "i",
                "\xF0": "d",
                "\xF1": "n",
                "\xF2": "o",
                "\xF3": "o",
                "\xF4": "o",
                "\xF5": "o",
                "\xF6": "oe",
                "\u0151": "o",
                "\xF8": "o",
                "\xF9": "u",
                "\xFA": "u",
                "\xFB": "u",
                "\xFC": "ue",
                "\u0171": "u",
                "\xFD": "y",
                "\xFE": "th",
                "\xFF": "y",
                "\u1E9E": "SS",
                // language specific
                // Arabic
                "\u0627": "a",
                "\u0623": "a",
                "\u0625": "i",
                "\u0622": "aa",
                "\u0624": "u",
                "\u0626": "e",
                "\u0621": "a",
                "\u0628": "b",
                "\u062A": "t",
                "\u062B": "th",
                "\u062C": "j",
                "\u062D": "h",
                "\u062E": "kh",
                "\u062F": "d",
                "\u0630": "th",
                "\u0631": "r",
                "\u0632": "z",
                "\u0633": "s",
                "\u0634": "sh",
                "\u0635": "s",
                "\u0636": "dh",
                "\u0637": "t",
                "\u0638": "z",
                "\u0639": "a",
                "\u063A": "gh",
                "\u0641": "f",
                "\u0642": "q",
                "\u0643": "k",
                "\u0644": "l",
                "\u0645": "m",
                "\u0646": "n",
                "\u0647": "h",
                "\u0648": "w",
                "\u064A": "y",
                "\u0649": "a",
                "\u0629": "h",
                "\uFEFB": "la",
                "\uFEF7": "laa",
                "\uFEF9": "lai",
                "\uFEF5": "laa",
                // Persian additional characters than Arabic
                "\u06AF": "g",
                "\u0686": "ch",
                "\u067E": "p",
                "\u0698": "zh",
                "\u06A9": "k",
                "\u06CC": "y",
                // Arabic diactrics
                "\u064E": "a",
                "\u064B": "an",
                "\u0650": "e",
                "\u064D": "en",
                "\u064F": "u",
                "\u064C": "on",
                "\u0652": "",
                // Arabic numbers
                "\u0660": "0",
                "\u0661": "1",
                "\u0662": "2",
                "\u0663": "3",
                "\u0664": "4",
                "\u0665": "5",
                "\u0666": "6",
                "\u0667": "7",
                "\u0668": "8",
                "\u0669": "9",
                // Persian numbers
                "\u06F0": "0",
                "\u06F1": "1",
                "\u06F2": "2",
                "\u06F3": "3",
                "\u06F4": "4",
                "\u06F5": "5",
                "\u06F6": "6",
                "\u06F7": "7",
                "\u06F8": "8",
                "\u06F9": "9",
                // Burmese consonants
                "\u1000": "k",
                "\u1001": "kh",
                "\u1002": "g",
                "\u1003": "ga",
                "\u1004": "ng",
                "\u1005": "s",
                "\u1006": "sa",
                "\u1007": "z",
                "\u1005\u103B": "za",
                "\u100A": "ny",
                "\u100B": "t",
                "\u100C": "ta",
                "\u100D": "d",
                "\u100E": "da",
                "\u100F": "na",
                "\u1010": "t",
                "\u1011": "ta",
                "\u1012": "d",
                "\u1013": "da",
                "\u1014": "n",
                "\u1015": "p",
                "\u1016": "pa",
                "\u1017": "b",
                "\u1018": "ba",
                "\u1019": "m",
                "\u101A": "y",
                "\u101B": "ya",
                "\u101C": "l",
                "\u101D": "w",
                "\u101E": "th",
                "\u101F": "h",
                "\u1020": "la",
                "\u1021": "a",
                // consonant character combos
                "\u103C": "y",
                "\u103B": "ya",
                "\u103D": "w",
                "\u103C\u103D": "yw",
                "\u103B\u103D": "ywa",
                "\u103E": "h",
                // independent vowels
                "\u1027": "e",
                "\u104F": "-e",
                "\u1023": "i",
                "\u1024": "-i",
                "\u1009": "u",
                "\u1026": "-u",
                "\u1029": "aw",
                "\u101E\u103C\u1031\u102C": "aw",
                "\u102A": "aw",
                // numbers
                "\u1040": "0",
                "\u1041": "1",
                "\u1042": "2",
                "\u1043": "3",
                "\u1044": "4",
                "\u1045": "5",
                "\u1046": "6",
                "\u1047": "7",
                "\u1048": "8",
                "\u1049": "9",
                // virama and tone marks which are silent in transliteration
                "\u1039": "",
                "\u1037": "",
                "\u1038": "",
                // Czech
                "\u010D": "c",
                "\u010F": "d",
                "\u011B": "e",
                "\u0148": "n",
                "\u0159": "r",
                "\u0161": "s",
                "\u0165": "t",
                "\u016F": "u",
                "\u017E": "z",
                "\u010C": "C",
                "\u010E": "D",
                "\u011A": "E",
                "\u0147": "N",
                "\u0158": "R",
                "\u0160": "S",
                "\u0164": "T",
                "\u016E": "U",
                "\u017D": "Z",
                // Dhivehi
                "\u0780": "h",
                "\u0781": "sh",
                "\u0782": "n",
                "\u0783": "r",
                "\u0784": "b",
                "\u0785": "lh",
                "\u0786": "k",
                "\u0787": "a",
                "\u0788": "v",
                "\u0789": "m",
                "\u078A": "f",
                "\u078B": "dh",
                "\u078C": "th",
                "\u078D": "l",
                "\u078E": "g",
                "\u078F": "gn",
                "\u0790": "s",
                "\u0791": "d",
                "\u0792": "z",
                "\u0793": "t",
                "\u0794": "y",
                "\u0795": "p",
                "\u0796": "j",
                "\u0797": "ch",
                "\u0798": "tt",
                "\u0799": "hh",
                "\u079A": "kh",
                "\u079B": "th",
                "\u079C": "z",
                "\u079D": "sh",
                "\u079E": "s",
                "\u079F": "d",
                "\u07A0": "t",
                "\u07A1": "z",
                "\u07A2": "a",
                "\u07A3": "gh",
                "\u07A4": "q",
                "\u07A5": "w",
                "\u07A6": "a",
                "\u07A7": "aa",
                "\u07A8": "i",
                "\u07A9": "ee",
                "\u07AA": "u",
                "\u07AB": "oo",
                "\u07AC": "e",
                "\u07AD": "ey",
                "\u07AE": "o",
                "\u07AF": "oa",
                "\u07B0": "",
                // Georgian https://en.wikipedia.org/wiki/Romanization_of_Georgian
                // National system (2002)
                "\u10D0": "a",
                "\u10D1": "b",
                "\u10D2": "g",
                "\u10D3": "d",
                "\u10D4": "e",
                "\u10D5": "v",
                "\u10D6": "z",
                "\u10D7": "t",
                "\u10D8": "i",
                "\u10D9": "k",
                "\u10DA": "l",
                "\u10DB": "m",
                "\u10DC": "n",
                "\u10DD": "o",
                "\u10DE": "p",
                "\u10DF": "zh",
                "\u10E0": "r",
                "\u10E1": "s",
                "\u10E2": "t",
                "\u10E3": "u",
                "\u10E4": "p",
                "\u10E5": "k",
                "\u10E6": "gh",
                "\u10E7": "q",
                "\u10E8": "sh",
                "\u10E9": "ch",
                "\u10EA": "ts",
                "\u10EB": "dz",
                "\u10EC": "ts",
                "\u10ED": "ch",
                "\u10EE": "kh",
                "\u10EF": "j",
                "\u10F0": "h",
                // Greek
                "\u03B1": "a",
                "\u03B2": "v",
                "\u03B3": "g",
                "\u03B4": "d",
                "\u03B5": "e",
                "\u03B6": "z",
                "\u03B7": "i",
                "\u03B8": "th",
                "\u03B9": "i",
                "\u03BA": "k",
                "\u03BB": "l",
                "\u03BC": "m",
                "\u03BD": "n",
                "\u03BE": "ks",
                "\u03BF": "o",
                "\u03C0": "p",
                "\u03C1": "r",
                "\u03C3": "s",
                "\u03C4": "t",
                "\u03C5": "y",
                "\u03C6": "f",
                "\u03C7": "x",
                "\u03C8": "ps",
                "\u03C9": "o",
                "\u03AC": "a",
                "\u03AD": "e",
                "\u03AF": "i",
                "\u03CC": "o",
                "\u03CD": "y",
                "\u03AE": "i",
                "\u03CE": "o",
                "\u03C2": "s",
                "\u03CA": "i",
                "\u03B0": "y",
                "\u03CB": "y",
                "\u0390": "i",
                "\u0391": "A",
                "\u0392": "B",
                "\u0393": "G",
                "\u0394": "D",
                "\u0395": "E",
                "\u0396": "Z",
                "\u0397": "I",
                "\u0398": "TH",
                "\u0399": "I",
                "\u039A": "K",
                "\u039B": "L",
                "\u039C": "M",
                "\u039D": "N",
                "\u039E": "KS",
                "\u039F": "O",
                "\u03A0": "P",
                "\u03A1": "R",
                "\u03A3": "S",
                "\u03A4": "T",
                "\u03A5": "Y",
                "\u03A6": "F",
                "\u03A7": "X",
                "\u03A8": "PS",
                "\u03A9": "O",
                "\u0386": "A",
                "\u0388": "E",
                "\u038A": "I",
                "\u038C": "O",
                "\u038E": "Y",
                "\u0389": "I",
                "\u038F": "O",
                "\u03AA": "I",
                "\u03AB": "Y",
                // Latvian
                "\u0101": "a",
                // 'č': 'c', // duplicate
                "\u0113": "e",
                "\u0123": "g",
                "\u012B": "i",
                "\u0137": "k",
                "\u013C": "l",
                "\u0146": "n",
                // 'š': 's', // duplicate
                "\u016B": "u",
                // 'ž': 'z', // duplicate
                "\u0100": "A",
                // 'Č': 'C', // duplicate
                "\u0112": "E",
                "\u0122": "G",
                "\u012A": "I",
                "\u0136": "k",
                "\u013B": "L",
                "\u0145": "N",
                // 'Š': 'S', // duplicate
                "\u016A": "U",
                // 'Ž': 'Z', // duplicate
                // Macedonian
                "\u040C": "Kj",
                "\u045C": "kj",
                "\u0409": "Lj",
                "\u0459": "lj",
                "\u040A": "Nj",
                "\u045A": "nj",
                "\u0422\u0441": "Ts",
                "\u0442\u0441": "ts",
                // Polish
                "\u0105": "a",
                "\u0107": "c",
                "\u0119": "e",
                "\u0142": "l",
                "\u0144": "n",
                // 'ó': 'o', // duplicate
                "\u015B": "s",
                "\u017A": "z",
                "\u017C": "z",
                "\u0104": "A",
                "\u0106": "C",
                "\u0118": "E",
                "\u0141": "L",
                "\u0143": "N",
                "\u015A": "S",
                "\u0179": "Z",
                "\u017B": "Z",
                // Ukranian
                "\u0404": "Ye",
                "\u0406": "I",
                "\u0407": "Yi",
                "\u0490": "G",
                "\u0454": "ye",
                "\u0456": "i",
                "\u0457": "yi",
                "\u0491": "g",
                // Romanian
                "\u0103": "a",
                "\u0102": "A",
                "\u0219": "s",
                "\u0218": "S",
                // 'ş': 's', // duplicate
                // 'Ş': 'S', // duplicate
                "\u021B": "t",
                "\u021A": "T",
                "\u0163": "t",
                "\u0162": "T",
                // Russian https://en.wikipedia.org/wiki/Romanization_of_Russian
                // ICAO
                "\u0430": "a",
                "\u0431": "b",
                "\u0432": "v",
                "\u0433": "g",
                "\u0434": "d",
                "\u0435": "e",
                "\u0451": "yo",
                "\u0436": "zh",
                "\u0437": "z",
                "\u0438": "i",
                "\u0439": "i",
                "\u043A": "k",
                "\u043B": "l",
                "\u043C": "m",
                "\u043D": "n",
                "\u043E": "o",
                "\u043F": "p",
                "\u0440": "r",
                "\u0441": "s",
                "\u0442": "t",
                "\u0443": "u",
                "\u0444": "f",
                "\u0445": "kh",
                "\u0446": "c",
                "\u0447": "ch",
                "\u0448": "sh",
                "\u0449": "sh",
                "\u044A": "",
                "\u044B": "y",
                "\u044C": "",
                "\u044D": "e",
                "\u044E": "yu",
                "\u044F": "ya",
                "\u0410": "A",
                "\u0411": "B",
                "\u0412": "V",
                "\u0413": "G",
                "\u0414": "D",
                "\u0415": "E",
                "\u0401": "Yo",
                "\u0416": "Zh",
                "\u0417": "Z",
                "\u0418": "I",
                "\u0419": "I",
                "\u041A": "K",
                "\u041B": "L",
                "\u041C": "M",
                "\u041D": "N",
                "\u041E": "O",
                "\u041F": "P",
                "\u0420": "R",
                "\u0421": "S",
                "\u0422": "T",
                "\u0423": "U",
                "\u0424": "F",
                "\u0425": "Kh",
                "\u0426": "C",
                "\u0427": "Ch",
                "\u0428": "Sh",
                "\u0429": "Sh",
                "\u042A": "",
                "\u042B": "Y",
                "\u042C": "",
                "\u042D": "E",
                "\u042E": "Yu",
                "\u042F": "Ya",
                // Serbian
                "\u0452": "dj",
                "\u0458": "j",
                // 'љ': 'lj',  // duplicate
                // 'њ': 'nj', // duplicate
                "\u045B": "c",
                "\u045F": "dz",
                "\u0402": "Dj",
                "\u0408": "j",
                // 'Љ': 'Lj', // duplicate
                // 'Њ': 'Nj', // duplicate
                "\u040B": "C",
                "\u040F": "Dz",
                // Slovak
                "\u013E": "l",
                "\u013A": "l",
                "\u0155": "r",
                "\u013D": "L",
                "\u0139": "L",
                "\u0154": "R",
                // Turkish
                "\u015F": "s",
                "\u015E": "S",
                "\u0131": "i",
                "\u0130": "I",
                // 'ç': 'c', // duplicate
                // 'Ç': 'C', // duplicate
                // 'ü': 'u', // duplicate, see langCharMap
                // 'Ü': 'U', // duplicate, see langCharMap
                // 'ö': 'o', // duplicate, see langCharMap
                // 'Ö': 'O', // duplicate, see langCharMap
                "\u011F": "g",
                "\u011E": "G",
                // Vietnamese
                "\u1EA3": "a",
                "\u1EA2": "A",
                "\u1EB3": "a",
                "\u1EB2": "A",
                "\u1EA9": "a",
                "\u1EA8": "A",
                "\u0111": "d",
                "\u0110": "D",
                "\u1EB9": "e",
                "\u1EB8": "E",
                "\u1EBD": "e",
                "\u1EBC": "E",
                "\u1EBB": "e",
                "\u1EBA": "E",
                "\u1EBF": "e",
                "\u1EBE": "E",
                "\u1EC1": "e",
                "\u1EC0": "E",
                "\u1EC7": "e",
                "\u1EC6": "E",
                "\u1EC5": "e",
                "\u1EC4": "E",
                "\u1EC3": "e",
                "\u1EC2": "E",
                "\u1ECF": "o",
                "\u1ECD": "o",
                "\u1ECC": "o",
                "\u1ED1": "o",
                "\u1ED0": "O",
                "\u1ED3": "o",
                "\u1ED2": "O",
                "\u1ED5": "o",
                "\u1ED4": "O",
                "\u1ED9": "o",
                "\u1ED8": "O",
                "\u1ED7": "o",
                "\u1ED6": "O",
                "\u01A1": "o",
                "\u01A0": "O",
                "\u1EDB": "o",
                "\u1EDA": "O",
                "\u1EDD": "o",
                "\u1EDC": "O",
                "\u1EE3": "o",
                "\u1EE2": "O",
                "\u1EE1": "o",
                "\u1EE0": "O",
                "\u1EDE": "o",
                "\u1EDF": "o",
                "\u1ECB": "i",
                "\u1ECA": "I",
                "\u0129": "i",
                "\u0128": "I",
                "\u1EC9": "i",
                "\u1EC8": "i",
                "\u1EE7": "u",
                "\u1EE6": "U",
                "\u1EE5": "u",
                "\u1EE4": "U",
                "\u0169": "u",
                "\u0168": "U",
                "\u01B0": "u",
                "\u01AF": "U",
                "\u1EE9": "u",
                "\u1EE8": "U",
                "\u1EEB": "u",
                "\u1EEA": "U",
                "\u1EF1": "u",
                "\u1EF0": "U",
                "\u1EEF": "u",
                "\u1EEE": "U",
                "\u1EED": "u",
                "\u1EEC": "\u01B0",
                "\u1EF7": "y",
                "\u1EF6": "y",
                "\u1EF3": "y",
                "\u1EF2": "Y",
                "\u1EF5": "y",
                "\u1EF4": "Y",
                "\u1EF9": "y",
                "\u1EF8": "Y",
                "\u1EA1": "a",
                "\u1EA0": "A",
                "\u1EA5": "a",
                "\u1EA4": "A",
                "\u1EA7": "a",
                "\u1EA6": "A",
                "\u1EAD": "a",
                "\u1EAC": "A",
                "\u1EAB": "a",
                "\u1EAA": "A",
                // 'ă': 'a', // duplicate
                // 'Ă': 'A', // duplicate
                "\u1EAF": "a",
                "\u1EAE": "A",
                "\u1EB1": "a",
                "\u1EB0": "A",
                "\u1EB7": "a",
                "\u1EB6": "A",
                "\u1EB5": "a",
                "\u1EB4": "A",
                "\u24EA": "0",
                "\u2460": "1",
                "\u2461": "2",
                "\u2462": "3",
                "\u2463": "4",
                "\u2464": "5",
                "\u2465": "6",
                "\u2466": "7",
                "\u2467": "8",
                "\u2468": "9",
                "\u2469": "10",
                "\u246A": "11",
                "\u246B": "12",
                "\u246C": "13",
                "\u246D": "14",
                "\u246E": "15",
                "\u246F": "16",
                "\u2470": "17",
                "\u2471": "18",
                "\u2472": "18",
                "\u2473": "18",
                "\u24F5": "1",
                "\u24F6": "2",
                "\u24F7": "3",
                "\u24F8": "4",
                "\u24F9": "5",
                "\u24FA": "6",
                "\u24FB": "7",
                "\u24FC": "8",
                "\u24FD": "9",
                "\u24FE": "10",
                "\u24FF": "0",
                "\u24EB": "11",
                "\u24EC": "12",
                "\u24ED": "13",
                "\u24EE": "14",
                "\u24EF": "15",
                "\u24F0": "16",
                "\u24F1": "17",
                "\u24F2": "18",
                "\u24F3": "19",
                "\u24F4": "20",
                "\u24B6": "A",
                "\u24B7": "B",
                "\u24B8": "C",
                "\u24B9": "D",
                "\u24BA": "E",
                "\u24BB": "F",
                "\u24BC": "G",
                "\u24BD": "H",
                "\u24BE": "I",
                "\u24BF": "J",
                "\u24C0": "K",
                "\u24C1": "L",
                "\u24C2": "M",
                "\u24C3": "N",
                "\u24C4": "O",
                "\u24C5": "P",
                "\u24C6": "Q",
                "\u24C7": "R",
                "\u24C8": "S",
                "\u24C9": "T",
                "\u24CA": "U",
                "\u24CB": "V",
                "\u24CC": "W",
                "\u24CD": "X",
                "\u24CE": "Y",
                "\u24CF": "Z",
                "\u24D0": "a",
                "\u24D1": "b",
                "\u24D2": "c",
                "\u24D3": "d",
                "\u24D4": "e",
                "\u24D5": "f",
                "\u24D6": "g",
                "\u24D7": "h",
                "\u24D8": "i",
                "\u24D9": "j",
                "\u24DA": "k",
                "\u24DB": "l",
                "\u24DC": "m",
                "\u24DD": "n",
                "\u24DE": "o",
                "\u24DF": "p",
                "\u24E0": "q",
                "\u24E1": "r",
                "\u24E2": "s",
                "\u24E3": "t",
                "\u24E4": "u",
                "\u24E6": "v",
                "\u24E5": "w",
                "\u24E7": "x",
                "\u24E8": "y",
                "\u24E9": "z",
                // symbols
                "\u201C": '"',
                "\u201D": '"',
                "\u2018": "'",
                "\u2019": "'",
                "\u2202": "d",
                "\u0192": "f",
                "\u2122": "(TM)",
                "\xA9": "(C)",
                "\u0153": "oe",
                "\u0152": "OE",
                "\xAE": "(R)",
                "\u2020": "+",
                "\u2120": "(SM)",
                "\u2026": "...",
                "\u02DA": "o",
                "\xBA": "o",
                "\xAA": "a",
                "\u2022": "*",
                "\u104A": ",",
                "\u104B": ".",
                // currency
                "$": "USD",
                "\u20AC": "EUR",
                "\u20A2": "BRN",
                "\u20A3": "FRF",
                "\xA3": "GBP",
                "\u20A4": "ITL",
                "\u20A6": "NGN",
                "\u20A7": "ESP",
                "\u20A9": "KRW",
                "\u20AA": "ILS",
                "\u20AB": "VND",
                "\u20AD": "LAK",
                "\u20AE": "MNT",
                "\u20AF": "GRD",
                "\u20B1": "ARS",
                "\u20B2": "PYG",
                "\u20B3": "ARA",
                "\u20B4": "UAH",
                "\u20B5": "GHS",
                "\xA2": "cent",
                "\xA5": "CNY",
                "\u5143": "CNY",
                "\u5186": "YEN",
                "\uFDFC": "IRR",
                "\u20A0": "EWE",
                "\u0E3F": "THB",
                "\u20A8": "INR",
                "\u20B9": "INR",
                "\u20B0": "PF",
                "\u20BA": "TRY",
                "\u060B": "AFN",
                "\u20BC": "AZN",
                "\u043B\u0432": "BGN",
                "\u17DB": "KHR",
                "\u20A1": "CRC",
                "\u20B8": "KZT",
                "\u0434\u0435\u043D": "MKD",
                "z\u0142": "PLN",
                "\u20BD": "RUB",
                "\u20BE": "GEL"
            };
            var lookAheadCharArray = [
                // burmese
                "\u103A",
                // Dhivehi
                "\u07B0"
            ];
            var diatricMap = {
                // Burmese
                // dependent vowels
                "\u102C": "a",
                "\u102B": "a",
                "\u1031": "e",
                "\u1032": "e",
                "\u102D": "i",
                "\u102E": "i",
                "\u102D\u102F": "o",
                "\u102F": "u",
                "\u1030": "u",
                "\u1031\u102B\u1004\u103A": "aung",
                "\u1031\u102C": "aw",
                "\u1031\u102C\u103A": "aw",
                "\u1031\u102B": "aw",
                "\u1031\u102B\u103A": "aw",
                "\u103A": "\u103A",
                // this is special case but the character will be converted to latin in the code
                "\u1000\u103A": "et",
                "\u102D\u102F\u1000\u103A": "aik",
                "\u1031\u102C\u1000\u103A": "auk",
                "\u1004\u103A": "in",
                "\u102D\u102F\u1004\u103A": "aing",
                "\u1031\u102C\u1004\u103A": "aung",
                "\u1005\u103A": "it",
                "\u100A\u103A": "i",
                "\u1010\u103A": "at",
                "\u102D\u1010\u103A": "eik",
                "\u102F\u1010\u103A": "ok",
                "\u103D\u1010\u103A": "ut",
                "\u1031\u1010\u103A": "it",
                "\u1012\u103A": "d",
                "\u102D\u102F\u1012\u103A": "ok",
                "\u102F\u1012\u103A": "ait",
                "\u1014\u103A": "an",
                "\u102C\u1014\u103A": "an",
                "\u102D\u1014\u103A": "ein",
                "\u102F\u1014\u103A": "on",
                "\u103D\u1014\u103A": "un",
                "\u1015\u103A": "at",
                "\u102D\u1015\u103A": "eik",
                "\u102F\u1015\u103A": "ok",
                "\u103D\u1015\u103A": "ut",
                "\u1014\u103A\u102F\u1015\u103A": "nub",
                "\u1019\u103A": "an",
                "\u102D\u1019\u103A": "ein",
                "\u102F\u1019\u103A": "on",
                "\u103D\u1019\u103A": "un",
                "\u101A\u103A": "e",
                "\u102D\u102F\u101C\u103A": "ol",
                "\u1009\u103A": "in",
                "\u1036": "an",
                "\u102D\u1036": "ein",
                "\u102F\u1036": "on",
                // Dhivehi
                "\u07A6\u0787\u07B0": "ah",
                "\u07A6\u0781\u07B0": "ah"
            };
            var langCharMap = {
                "en": {},
                // default language
                "az": {
                    // Azerbaijani
                    "\xE7": "c",
                    "\u0259": "e",
                    "\u011F": "g",
                    "\u0131": "i",
                    "\xF6": "o",
                    "\u015F": "s",
                    "\xFC": "u",
                    "\xC7": "C",
                    "\u018F": "E",
                    "\u011E": "G",
                    "\u0130": "I",
                    "\xD6": "O",
                    "\u015E": "S",
                    "\xDC": "U"
                },
                "cs": {
                    // Czech
                    "\u010D": "c",
                    "\u010F": "d",
                    "\u011B": "e",
                    "\u0148": "n",
                    "\u0159": "r",
                    "\u0161": "s",
                    "\u0165": "t",
                    "\u016F": "u",
                    "\u017E": "z",
                    "\u010C": "C",
                    "\u010E": "D",
                    "\u011A": "E",
                    "\u0147": "N",
                    "\u0158": "R",
                    "\u0160": "S",
                    "\u0164": "T",
                    "\u016E": "U",
                    "\u017D": "Z"
                },
                "fi": {
                    // Finnish
                    // 'å': 'a', duplicate see charMap/latin
                    // 'Å': 'A', duplicate see charMap/latin
                    "\xE4": "a",
                    // ok
                    "\xC4": "A",
                    // ok
                    "\xF6": "o",
                    // ok
                    "\xD6": "O"
                },
                "hu": {
                    // Hungarian
                    "\xE4": "a",
                    // ok
                    "\xC4": "A",
                    // ok
                    // 'á': 'a', duplicate see charMap/latin
                    // 'Á': 'A', duplicate see charMap/latin
                    "\xF6": "o",
                    // ok
                    "\xD6": "O",
                    // ok
                    // 'ő': 'o', duplicate see charMap/latin
                    // 'Ő': 'O', duplicate see charMap/latin
                    "\xFC": "u",
                    "\xDC": "U",
                    "\u0171": "u",
                    "\u0170": "U"
                },
                "lt": {
                    // Lithuanian
                    "\u0105": "a",
                    "\u010D": "c",
                    "\u0119": "e",
                    "\u0117": "e",
                    "\u012F": "i",
                    "\u0161": "s",
                    "\u0173": "u",
                    "\u016B": "u",
                    "\u017E": "z",
                    "\u0104": "A",
                    "\u010C": "C",
                    "\u0118": "E",
                    "\u0116": "E",
                    "\u012E": "I",
                    "\u0160": "S",
                    "\u0172": "U",
                    "\u016A": "U"
                },
                "lv": {
                    // Latvian
                    "\u0101": "a",
                    "\u010D": "c",
                    "\u0113": "e",
                    "\u0123": "g",
                    "\u012B": "i",
                    "\u0137": "k",
                    "\u013C": "l",
                    "\u0146": "n",
                    "\u0161": "s",
                    "\u016B": "u",
                    "\u017E": "z",
                    "\u0100": "A",
                    "\u010C": "C",
                    "\u0112": "E",
                    "\u0122": "G",
                    "\u012A": "i",
                    "\u0136": "k",
                    "\u013B": "L",
                    "\u0145": "N",
                    "\u0160": "S",
                    "\u016A": "u",
                    "\u017D": "Z"
                },
                "pl": {
                    // Polish
                    "\u0105": "a",
                    "\u0107": "c",
                    "\u0119": "e",
                    "\u0142": "l",
                    "\u0144": "n",
                    "\xF3": "o",
                    "\u015B": "s",
                    "\u017A": "z",
                    "\u017C": "z",
                    "\u0104": "A",
                    "\u0106": "C",
                    "\u0118": "e",
                    "\u0141": "L",
                    "\u0143": "N",
                    "\xD3": "O",
                    "\u015A": "S",
                    "\u0179": "Z",
                    "\u017B": "Z"
                },
                "sv": {
                    // Swedish
                    // 'å': 'a', duplicate see charMap/latin
                    // 'Å': 'A', duplicate see charMap/latin
                    "\xE4": "a",
                    // ok
                    "\xC4": "A",
                    // ok
                    "\xF6": "o",
                    // ok
                    "\xD6": "O"
                },
                "sk": {
                    // Slovak
                    "\xE4": "a",
                    "\xC4": "A"
                },
                "sr": {
                    // Serbian
                    "\u0459": "lj",
                    "\u045A": "nj",
                    "\u0409": "Lj",
                    "\u040A": "Nj",
                    "\u0111": "dj",
                    "\u0110": "Dj"
                },
                "tr": {
                    // Turkish
                    "\xDC": "U",
                    "\xD6": "O",
                    "\xFC": "u",
                    "\xF6": "o"
                }
            };
            var symbolMap = {
                "ar": {
                    "\u2206": "delta",
                    "\u221E": "la-nihaya",
                    "\u2665": "hob",
                    "&": "wa",
                    "|": "aw",
                    "<": "aqal-men",
                    ">": "akbar-men",
                    "\u2211": "majmou",
                    "\xA4": "omla"
                },
                "az": {},
                "ca": {
                    "\u2206": "delta",
                    "\u221E": "infinit",
                    "\u2665": "amor",
                    "&": "i",
                    "|": "o",
                    "<": "menys que",
                    ">": "mes que",
                    "\u2211": "suma dels",
                    "\xA4": "moneda"
                },
                "cs": {
                    "\u2206": "delta",
                    "\u221E": "nekonecno",
                    "\u2665": "laska",
                    "&": "a",
                    "|": "nebo",
                    "<": "mensi nez",
                    ">": "vetsi nez",
                    "\u2211": "soucet",
                    "\xA4": "mena"
                },
                "de": {
                    "\u2206": "delta",
                    "\u221E": "unendlich",
                    "\u2665": "Liebe",
                    "&": "und",
                    "|": "oder",
                    "<": "kleiner als",
                    ">": "groesser als",
                    "\u2211": "Summe von",
                    "\xA4": "Waehrung"
                },
                "dv": {
                    "\u2206": "delta",
                    "\u221E": "kolunulaa",
                    "\u2665": "loabi",
                    "&": "aai",
                    "|": "noonee",
                    "<": "ah vure kuda",
                    ">": "ah vure bodu",
                    "\u2211": "jumula",
                    "\xA4": "faisaa"
                },
                "en": {
                    "\u2206": "delta",
                    "\u221E": "infinity",
                    "\u2665": "love",
                    "&": "and",
                    "|": "or",
                    "<": "less than",
                    ">": "greater than",
                    "\u2211": "sum",
                    "\xA4": "currency"
                },
                "es": {
                    "\u2206": "delta",
                    "\u221E": "infinito",
                    "\u2665": "amor",
                    "&": "y",
                    "|": "u",
                    "<": "menos que",
                    ">": "mas que",
                    "\u2211": "suma de los",
                    "\xA4": "moneda"
                },
                "fa": {
                    "\u2206": "delta",
                    "\u221E": "bi-nahayat",
                    "\u2665": "eshgh",
                    "&": "va",
                    "|": "ya",
                    "<": "kamtar-az",
                    ">": "bishtar-az",
                    "\u2211": "majmooe",
                    "\xA4": "vahed"
                },
                "fi": {
                    "\u2206": "delta",
                    "\u221E": "aarettomyys",
                    "\u2665": "rakkaus",
                    "&": "ja",
                    "|": "tai",
                    "<": "pienempi kuin",
                    ">": "suurempi kuin",
                    "\u2211": "summa",
                    "\xA4": "valuutta"
                },
                "fr": {
                    "\u2206": "delta",
                    "\u221E": "infiniment",
                    "\u2665": "Amour",
                    "&": "et",
                    "|": "ou",
                    "<": "moins que",
                    ">": "superieure a",
                    "\u2211": "somme des",
                    "\xA4": "monnaie"
                },
                "ge": {
                    "\u2206": "delta",
                    "\u221E": "usasruloba",
                    "\u2665": "siqvaruli",
                    "&": "da",
                    "|": "an",
                    "<": "naklebi",
                    ">": "meti",
                    "\u2211": "jami",
                    "\xA4": "valuta"
                },
                "gr": {},
                "hu": {
                    "\u2206": "delta",
                    "\u221E": "vegtelen",
                    "\u2665": "szerelem",
                    "&": "es",
                    "|": "vagy",
                    "<": "kisebb mint",
                    ">": "nagyobb mint",
                    "\u2211": "szumma",
                    "\xA4": "penznem"
                },
                "it": {
                    "\u2206": "delta",
                    "\u221E": "infinito",
                    "\u2665": "amore",
                    "&": "e",
                    "|": "o",
                    "<": "minore di",
                    ">": "maggiore di",
                    "\u2211": "somma",
                    "\xA4": "moneta"
                },
                "lt": {
                    "\u2206": "delta",
                    "\u221E": "begalybe",
                    "\u2665": "meile",
                    "&": "ir",
                    "|": "ar",
                    "<": "maziau nei",
                    ">": "daugiau nei",
                    "\u2211": "suma",
                    "\xA4": "valiuta"
                },
                "lv": {
                    "\u2206": "delta",
                    "\u221E": "bezgaliba",
                    "\u2665": "milestiba",
                    "&": "un",
                    "|": "vai",
                    "<": "mazak neka",
                    ">": "lielaks neka",
                    "\u2211": "summa",
                    "\xA4": "valuta"
                },
                "my": {
                    "\u2206": "kwahkhyaet",
                    "\u221E": "asaonasme",
                    "\u2665": "akhyait",
                    "&": "nhin",
                    "|": "tho",
                    "<": "ngethaw",
                    ">": "kyithaw",
                    "\u2211": "paungld",
                    "\xA4": "ngwekye"
                },
                "mk": {},
                "nl": {
                    "\u2206": "delta",
                    "\u221E": "oneindig",
                    "\u2665": "liefde",
                    "&": "en",
                    "|": "of",
                    "<": "kleiner dan",
                    ">": "groter dan",
                    "\u2211": "som",
                    "\xA4": "valuta"
                },
                "pl": {
                    "\u2206": "delta",
                    "\u221E": "nieskonczonosc",
                    "\u2665": "milosc",
                    "&": "i",
                    "|": "lub",
                    "<": "mniejsze niz",
                    ">": "wieksze niz",
                    "\u2211": "suma",
                    "\xA4": "waluta"
                },
                "pt": {
                    "\u2206": "delta",
                    "\u221E": "infinito",
                    "\u2665": "amor",
                    "&": "e",
                    "|": "ou",
                    "<": "menor que",
                    ">": "maior que",
                    "\u2211": "soma",
                    "\xA4": "moeda"
                },
                "ro": {
                    "\u2206": "delta",
                    "\u221E": "infinit",
                    "\u2665": "dragoste",
                    "&": "si",
                    "|": "sau",
                    "<": "mai mic ca",
                    ">": "mai mare ca",
                    "\u2211": "suma",
                    "\xA4": "valuta"
                },
                "ru": {
                    "\u2206": "delta",
                    "\u221E": "beskonechno",
                    "\u2665": "lubov",
                    "&": "i",
                    "|": "ili",
                    "<": "menshe",
                    ">": "bolshe",
                    "\u2211": "summa",
                    "\xA4": "valjuta"
                },
                "sk": {
                    "\u2206": "delta",
                    "\u221E": "nekonecno",
                    "\u2665": "laska",
                    "&": "a",
                    "|": "alebo",
                    "<": "menej ako",
                    ">": "viac ako",
                    "\u2211": "sucet",
                    "\xA4": "mena"
                },
                "sr": {},
                "tr": {
                    "\u2206": "delta",
                    "\u221E": "sonsuzluk",
                    "\u2665": "ask",
                    "&": "ve",
                    "|": "veya",
                    "<": "kucuktur",
                    ">": "buyuktur",
                    "\u2211": "toplam",
                    "\xA4": "para birimi"
                },
                "uk": {
                    "\u2206": "delta",
                    "\u221E": "bezkinechnist",
                    "\u2665": "lubov",
                    "&": "i",
                    "|": "abo",
                    "<": "menshe",
                    ">": "bilshe",
                    "\u2211": "suma",
                    "\xA4": "valjuta"
                },
                "vn": {
                    "\u2206": "delta",
                    "\u221E": "vo cuc",
                    "\u2665": "yeu",
                    "&": "va",
                    "|": "hoac",
                    "<": "nho hon",
                    ">": "lon hon",
                    "\u2211": "tong",
                    "\xA4": "tien te"
                }
            };
            var uricChars = [
                ";",
                "?",
                ":",
                "@",
                "&",
                "=",
                "+",
                "$",
                ",",
                "/"
            ].join("");
            var uricNoSlashChars = [
                ";",
                "?",
                ":",
                "@",
                "&",
                "=",
                "+",
                "$",
                ","
            ].join("");
            var markChars = [
                ".",
                "!",
                "~",
                "*",
                "'",
                "(",
                ")"
            ].join("");
            var getSlug = function getSlug2(input, opts) {
                var separator = "-";
                var result = "";
                var diatricString = "";
                var convertSymbols = true;
                var customReplacements = {};
                var maintainCase;
                var titleCase;
                var truncate;
                var uricFlag;
                var uricNoSlashFlag;
                var markFlag;
                var symbol;
                var langChar;
                var lucky;
                var i;
                var ch;
                var l;
                var lastCharWasSymbol;
                var lastCharWasDiatric;
                var allowedChars = "";
                if (typeof input !== "string") return "";
                if (typeof opts === "string") separator = opts;
                symbol = symbolMap.en;
                langChar = langCharMap.en;
                if (typeof opts === "object") {
                    maintainCase = opts.maintainCase || false;
                    customReplacements = opts.custom && typeof opts.custom === "object" ? opts.custom : customReplacements;
                    truncate = +opts.truncate > 1 && opts.truncate || false;
                    uricFlag = opts.uric || false;
                    uricNoSlashFlag = opts.uricNoSlash || false;
                    markFlag = opts.mark || false;
                    convertSymbols = opts.symbols === false || opts.lang === false ? false : true;
                    separator = opts.separator || separator;
                    if (uricFlag) allowedChars += uricChars;
                    if (uricNoSlashFlag) allowedChars += uricNoSlashChars;
                    if (markFlag) allowedChars += markChars;
                    symbol = opts.lang && symbolMap[opts.lang] && convertSymbols ? symbolMap[opts.lang] : convertSymbols ? symbolMap.en : {};
                    langChar = opts.lang && langCharMap[opts.lang] ? langCharMap[opts.lang] : opts.lang === false || opts.lang === true ? {} : langCharMap.en;
                    if (opts.titleCase && typeof opts.titleCase.length === "number" && Array.prototype.toString.call(opts.titleCase)) {
                        opts.titleCase.forEach(function(v) {
                            customReplacements[v + ""] = v + "";
                        });
                        titleCase = true;
                    } else titleCase = !!opts.titleCase;
                    if (opts.custom && typeof opts.custom.length === "number" && Array.prototype.toString.call(opts.custom)) opts.custom.forEach(function(v) {
                        customReplacements[v + ""] = v + "";
                    });
                    Object.keys(customReplacements).forEach(function(v) {
                        var r;
                        if (v.length > 1) r = new RegExp("\\b" + escapeChars(v) + "\\b", "gi");
                        else r = new RegExp(escapeChars(v), "gi");
                        input = input.replace(r, customReplacements[v]);
                    });
                    for(ch in customReplacements)allowedChars += ch;
                }
                allowedChars += separator;
                allowedChars = escapeChars(allowedChars);
                input = input.replace(/(^\s+|\s+$)/g, "");
                lastCharWasSymbol = false;
                lastCharWasDiatric = false;
                for(i = 0, l = input.length; i < l; i++){
                    ch = input[i];
                    if (isReplacedCustomChar(ch, customReplacements)) lastCharWasSymbol = false;
                    else if (langChar[ch]) {
                        ch = lastCharWasSymbol && langChar[ch].match(/[A-Za-z0-9]/) ? " " + langChar[ch] : langChar[ch];
                        lastCharWasSymbol = false;
                    } else if (ch in charMap) {
                        if (i + 1 < l && lookAheadCharArray.indexOf(input[i + 1]) >= 0) {
                            diatricString += ch;
                            ch = "";
                        } else if (lastCharWasDiatric === true) {
                            ch = diatricMap[diatricString] + charMap[ch];
                            diatricString = "";
                        } else ch = lastCharWasSymbol && charMap[ch].match(/[A-Za-z0-9]/) ? " " + charMap[ch] : charMap[ch];
                        lastCharWasSymbol = false;
                        lastCharWasDiatric = false;
                    } else if (ch in diatricMap) {
                        diatricString += ch;
                        ch = "";
                        if (i === l - 1) ch = diatricMap[diatricString];
                        lastCharWasDiatric = true;
                    } else if (// process symbol chars
                    symbol[ch] && !(uricFlag && uricChars.indexOf(ch) !== -1) && !(uricNoSlashFlag && uricNoSlashChars.indexOf(ch) !== -1)) {
                        ch = lastCharWasSymbol || result.substr(-1).match(/[A-Za-z0-9]/) ? separator + symbol[ch] : symbol[ch];
                        ch += input[i + 1] !== void 0 && input[i + 1].match(/[A-Za-z0-9]/) ? separator : "";
                        lastCharWasSymbol = true;
                    } else {
                        if (lastCharWasDiatric === true) {
                            ch = diatricMap[diatricString] + ch;
                            diatricString = "";
                            lastCharWasDiatric = false;
                        } else if (lastCharWasSymbol && (/[A-Za-z0-9]/.test(ch) || result.substr(-1).match(/A-Za-z0-9]/))) ch = " " + ch;
                        lastCharWasSymbol = false;
                    }
                    result += ch.replace(new RegExp("[^\\w\\s" + allowedChars + "_-]", "g"), separator);
                }
                if (titleCase) result = result.replace(/(\w)(\S*)/g, function(_, i2, r) {
                    var j = i2.toUpperCase() + (r !== null ? r : "");
                    return Object.keys(customReplacements).indexOf(j.toLowerCase()) < 0 ? j : j.toLowerCase();
                });
                result = result.replace(/\s+/g, separator).replace(new RegExp("\\" + separator + "+", "g"), separator).replace(new RegExp("(^\\" + separator + "+|\\" + separator + "+$)", "g"), "");
                if (truncate && result.length > truncate) {
                    lucky = result.charAt(truncate) === separator;
                    result = result.slice(0, truncate);
                    if (!lucky) result = result.slice(0, result.lastIndexOf(separator));
                }
                if (!maintainCase && !titleCase) result = result.toLowerCase();
                return result;
            };
            var createSlug = function createSlug2(opts) {
                return function getSlugWithConfig(input) {
                    return getSlug(input, opts);
                };
            };
            var escapeChars = function escapeChars2(input) {
                return input.replace(/[-\\^$*+?.()|[\]{}\/]/g, "\\$&");
            };
            var isReplacedCustomChar = function(ch, customReplacements) {
                for(var c in customReplacements){
                    if (customReplacements[c] === ch) return true;
                }
            };
            if (typeof module !== "undefined" && module.exports) {
                module.exports = getSlug;
                module.exports.createSlug = createSlug;
            } else if (typeof define !== "undefined" && define.amd) define([], function() {
                return getSlug;
            });
            else try {
                if (root.getSlug || root.createSlug) throw "speakingurl: globals exists /(getSlug|createSlug)/";
                else {
                    root.getSlug = getSlug;
                    root.createSlug = createSlug;
                }
            } catch (e) {}
        })(exports);
    }
});
// ../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/index.js
var $a52fad25e66add48$var$require_speakingurl2 = $a52fad25e66add48$var$__commonJS({
    "../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/index.js" (exports, module) {
        "use strict";
        $a52fad25e66add48$var$init_esm_shims();
        module.exports = $a52fad25e66add48$var$require_speakingurl();
    }
});
// src/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/compat/index.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$onLegacyDevToolsPluginApiAvailable(cb) {
    if ((0, $gNtJt.target).__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__) {
        cb();
        return;
    }
    Object.defineProperty((0, $gNtJt.target), "__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__", {
        set (value) {
            if (value) cb();
        },
        configurable: true
    });
}
// src/ctx/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/ctx/api.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/component-highlighter/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/component/state/bounding-rect.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/component/utils/index.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$getComponentTypeName(options) {
    var _a25;
    const name = options.name || options._componentTag || options.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || options.__name;
    if (name === "index" && ((_a25 = options.__file) == null ? void 0 : _a25.endsWith("index.vue"))) return "";
    return name;
}
function $a52fad25e66add48$var$getComponentFileName(options) {
    const file = options.__file;
    if (file) return (0, $gNtJt.classify)((0, $gNtJt.basename)(file, ".vue"));
}
function $a52fad25e66add48$var$getComponentName(options) {
    const name = options.displayName || options.name || options._componentTag;
    if (name) return name;
    return $a52fad25e66add48$var$getComponentFileName(options);
}
function $a52fad25e66add48$var$saveComponentGussedName(instance, name) {
    instance.type.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ = name;
    return name;
}
function $a52fad25e66add48$var$getAppRecord(instance) {
    if (instance.__VUE_DEVTOOLS_NEXT_APP_RECORD__) return instance.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
    else if (instance.root) return instance.appContext.app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
}
async function $a52fad25e66add48$var$getComponentId(options) {
    const { app: app, uid: uid, instance: instance } = options;
    try {
        if (instance.__VUE_DEVTOOLS_NEXT_UID__) return instance.__VUE_DEVTOOLS_NEXT_UID__;
        const appRecord = await $a52fad25e66add48$var$getAppRecord(app);
        if (!appRecord) return null;
        const isRoot = appRecord.rootInstance === instance;
        return `${appRecord.id}:${isRoot ? "root" : uid}`;
    } catch (e) {}
}
function $a52fad25e66add48$var$isFragment(instance) {
    var _a25, _b25;
    const subTreeType = (_a25 = instance.subTree) == null ? void 0 : _a25.type;
    const appRecord = $a52fad25e66add48$var$getAppRecord(instance);
    if (appRecord) return ((_b25 = appRecord == null ? void 0 : appRecord.types) == null ? void 0 : _b25.Fragment) === subTreeType;
    return false;
}
function $a52fad25e66add48$var$isBeingDestroyed(instance) {
    return instance._isBeingDestroyed || instance.isUnmounted;
}
function $a52fad25e66add48$var$getInstanceName(instance) {
    var _a25, _b25, _c;
    const name = $a52fad25e66add48$var$getComponentTypeName((instance == null ? void 0 : instance.type) || {});
    if (name) return name;
    if ((instance == null ? void 0 : instance.root) === instance) return "Root";
    for(const key in (_b25 = (_a25 = instance.parent) == null ? void 0 : _a25.type) == null ? void 0 : _b25.components){
        if (instance.parent.type.components[key] === (instance == null ? void 0 : instance.type)) return $a52fad25e66add48$var$saveComponentGussedName(instance, key);
    }
    for(const key in (_c = instance.appContext) == null ? void 0 : _c.components){
        if (instance.appContext.components[key] === (instance == null ? void 0 : instance.type)) return $a52fad25e66add48$var$saveComponentGussedName(instance, key);
    }
    const fileName = $a52fad25e66add48$var$getComponentFileName((instance == null ? void 0 : instance.type) || {});
    if (fileName) return fileName;
    return "Anonymous Component";
}
function $a52fad25e66add48$var$getUniqueComponentId(instance) {
    var _a25, _b25, _c;
    const appId = (_c = (_b25 = (_a25 = instance == null ? void 0 : instance.appContext) == null ? void 0 : _a25.app) == null ? void 0 : _b25.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__) != null ? _c : 0;
    const instanceId = instance === (instance == null ? void 0 : instance.root) ? "root" : instance.uid;
    return `${appId}:${instanceId}`;
}
function $a52fad25e66add48$var$getRenderKey(value) {
    if (value == null) return "";
    if (typeof value === "number") return value;
    else if (typeof value === "string") return `'${value}'`;
    else if (Array.isArray(value)) return "Array";
    else return "Object";
}
function $a52fad25e66add48$var$returnError(cb) {
    try {
        return cb();
    } catch (e) {
        return e;
    }
}
function $a52fad25e66add48$var$getComponentInstance(appRecord, instanceId) {
    instanceId = instanceId || `${appRecord.id}:root`;
    const instance = appRecord.instanceMap.get(instanceId);
    return instance || appRecord.instanceMap.get(":root");
}
function $a52fad25e66add48$var$ensurePropertyExists(obj, key, skipObjCheck = false) {
    return skipObjCheck ? key in obj : typeof obj === "object" && obj !== null ? key in obj : false;
}
// src/core/component/state/bounding-rect.ts
function $a52fad25e66add48$var$createRect() {
    const rect = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        get width () {
            return rect.right - rect.left;
        },
        get height () {
            return rect.bottom - rect.top;
        }
    };
    return rect;
}
var $a52fad25e66add48$var$range;
function $a52fad25e66add48$var$getTextRect(node) {
    if (!$a52fad25e66add48$var$range) $a52fad25e66add48$var$range = document.createRange();
    $a52fad25e66add48$var$range.selectNode(node);
    return $a52fad25e66add48$var$range.getBoundingClientRect();
}
function $a52fad25e66add48$var$getFragmentRect(vnode) {
    const rect = $a52fad25e66add48$var$createRect();
    if (!vnode.children) return rect;
    for(let i = 0, l = vnode.children.length; i < l; i++){
        const childVnode = vnode.children[i];
        let childRect;
        if (childVnode.component) childRect = $a52fad25e66add48$var$getComponentBoundingRect(childVnode.component);
        else if (childVnode.el) {
            const el = childVnode.el;
            if (el.nodeType === 1 || el.getBoundingClientRect) childRect = el.getBoundingClientRect();
            else if (el.nodeType === 3 && el.data.trim()) childRect = $a52fad25e66add48$var$getTextRect(el);
        }
        if (childRect) $a52fad25e66add48$var$mergeRects(rect, childRect);
    }
    return rect;
}
function $a52fad25e66add48$var$mergeRects(a, b) {
    if (!a.top || b.top < a.top) a.top = b.top;
    if (!a.bottom || b.bottom > a.bottom) a.bottom = b.bottom;
    if (!a.left || b.left < a.left) a.left = b.left;
    if (!a.right || b.right > a.right) a.right = b.right;
    return a;
}
var $a52fad25e66add48$var$DEFAULT_RECT = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0
};
function $a52fad25e66add48$var$getComponentBoundingRect(instance) {
    const el = instance.subTree.el;
    if (typeof window === "undefined") return $a52fad25e66add48$var$DEFAULT_RECT;
    if ($a52fad25e66add48$var$isFragment(instance)) return $a52fad25e66add48$var$getFragmentRect(instance.subTree);
    else if ((el == null ? void 0 : el.nodeType) === 1) return el == null ? void 0 : el.getBoundingClientRect();
    else if (instance.subTree.component) return $a52fad25e66add48$var$getComponentBoundingRect(instance.subTree.component);
    else return $a52fad25e66add48$var$DEFAULT_RECT;
}
// src/core/component/tree/el.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$getRootElementsFromComponentInstance(instance) {
    if ($a52fad25e66add48$var$isFragment(instance)) return $a52fad25e66add48$var$getFragmentRootElements(instance.subTree);
    if (!instance.subTree) return [];
    return [
        instance.subTree.el
    ];
}
function $a52fad25e66add48$var$getFragmentRootElements(vnode) {
    if (!vnode.children) return [];
    const list = [];
    vnode.children.forEach((childVnode)=>{
        if (childVnode.component) list.push(...$a52fad25e66add48$var$getRootElementsFromComponentInstance(childVnode.component));
        else if (childVnode == null ? void 0 : childVnode.el) list.push(childVnode.el);
    });
    return list;
}
// src/core/component-highlighter/index.ts
var $a52fad25e66add48$var$CONTAINER_ELEMENT_ID = "__vue-devtools-component-inspector__";
var $a52fad25e66add48$var$CARD_ELEMENT_ID = "__vue-devtools-component-inspector__card__";
var $a52fad25e66add48$var$COMPONENT_NAME_ELEMENT_ID = "__vue-devtools-component-inspector__name__";
var $a52fad25e66add48$var$INDICATOR_ELEMENT_ID = "__vue-devtools-component-inspector__indicator__";
var $a52fad25e66add48$var$containerStyles = {
    display: "block",
    zIndex: 2147483640,
    position: "fixed",
    backgroundColor: "#42b88325",
    border: "1px solid #42b88350",
    borderRadius: "5px",
    transition: "all 0.1s ease-in",
    pointerEvents: "none"
};
var $a52fad25e66add48$var$cardStyles = {
    fontFamily: "Arial, Helvetica, sans-serif",
    padding: "5px 8px",
    borderRadius: "4px",
    textAlign: "left",
    position: "absolute",
    left: 0,
    color: "#e9e9e9",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    backgroundColor: "#42b883",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)"
};
var $a52fad25e66add48$var$indicatorStyles = {
    display: "inline-block",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "12px",
    opacity: 0.7
};
function $a52fad25e66add48$var$getContainerElement() {
    return document.getElementById($a52fad25e66add48$var$CONTAINER_ELEMENT_ID);
}
function $a52fad25e66add48$var$getCardElement() {
    return document.getElementById($a52fad25e66add48$var$CARD_ELEMENT_ID);
}
function $a52fad25e66add48$var$getIndicatorElement() {
    return document.getElementById($a52fad25e66add48$var$INDICATOR_ELEMENT_ID);
}
function $a52fad25e66add48$var$getNameElement() {
    return document.getElementById($a52fad25e66add48$var$COMPONENT_NAME_ELEMENT_ID);
}
function $a52fad25e66add48$var$getStyles(bounds) {
    return {
        left: `${Math.round(bounds.left * 100) / 100}px`,
        top: `${Math.round(bounds.top * 100) / 100}px`,
        width: `${Math.round(bounds.width * 100) / 100}px`,
        height: `${Math.round(bounds.height * 100) / 100}px`
    };
}
function $a52fad25e66add48$var$create(options) {
    var _a25;
    const containerEl = document.createElement("div");
    containerEl.id = (_a25 = options.elementId) != null ? _a25 : $a52fad25e66add48$var$CONTAINER_ELEMENT_ID;
    Object.assign(containerEl.style, {
        ...$a52fad25e66add48$var$containerStyles,
        ...$a52fad25e66add48$var$getStyles(options.bounds),
        ...options.style
    });
    const cardEl = document.createElement("span");
    cardEl.id = $a52fad25e66add48$var$CARD_ELEMENT_ID;
    Object.assign(cardEl.style, {
        ...$a52fad25e66add48$var$cardStyles,
        top: options.bounds.top < 35 ? 0 : "-35px"
    });
    const nameEl = document.createElement("span");
    nameEl.id = $a52fad25e66add48$var$COMPONENT_NAME_ELEMENT_ID;
    nameEl.innerHTML = `&lt;${options.name}&gt;&nbsp;&nbsp;`;
    const indicatorEl = document.createElement("i");
    indicatorEl.id = $a52fad25e66add48$var$INDICATOR_ELEMENT_ID;
    indicatorEl.innerHTML = `${Math.round(options.bounds.width * 100) / 100} x ${Math.round(options.bounds.height * 100) / 100}`;
    Object.assign(indicatorEl.style, $a52fad25e66add48$var$indicatorStyles);
    cardEl.appendChild(nameEl);
    cardEl.appendChild(indicatorEl);
    containerEl.appendChild(cardEl);
    document.body.appendChild(containerEl);
    return containerEl;
}
function $a52fad25e66add48$var$update(options) {
    const containerEl = $a52fad25e66add48$var$getContainerElement();
    const cardEl = $a52fad25e66add48$var$getCardElement();
    const nameEl = $a52fad25e66add48$var$getNameElement();
    const indicatorEl = $a52fad25e66add48$var$getIndicatorElement();
    if (containerEl) {
        Object.assign(containerEl.style, {
            ...$a52fad25e66add48$var$containerStyles,
            ...$a52fad25e66add48$var$getStyles(options.bounds)
        });
        Object.assign(cardEl.style, {
            top: options.bounds.top < 35 ? 0 : "-35px"
        });
        nameEl.innerHTML = `&lt;${options.name}&gt;&nbsp;&nbsp;`;
        indicatorEl.innerHTML = `${Math.round(options.bounds.width * 100) / 100} x ${Math.round(options.bounds.height * 100) / 100}`;
    }
}
function $a52fad25e66add48$var$highlight(instance) {
    const bounds = $a52fad25e66add48$var$getComponentBoundingRect(instance);
    if (!bounds.width && !bounds.height) return;
    const name = $a52fad25e66add48$var$getInstanceName(instance);
    const container = $a52fad25e66add48$var$getContainerElement();
    container ? $a52fad25e66add48$var$update({
        bounds: bounds,
        name: name
    }) : $a52fad25e66add48$var$create({
        bounds: bounds,
        name: name
    });
}
function $a52fad25e66add48$var$unhighlight() {
    const el = $a52fad25e66add48$var$getContainerElement();
    if (el) el.style.display = "none";
}
var $a52fad25e66add48$var$inspectInstance = null;
function $a52fad25e66add48$var$inspectFn(e) {
    const target22 = e.target;
    if (target22) {
        const instance = target22.__vueParentComponent;
        if (instance) {
            $a52fad25e66add48$var$inspectInstance = instance;
            const el = instance.vnode.el;
            if (el) {
                const bounds = $a52fad25e66add48$var$getComponentBoundingRect(instance);
                const name = $a52fad25e66add48$var$getInstanceName(instance);
                const container = $a52fad25e66add48$var$getContainerElement();
                container ? $a52fad25e66add48$var$update({
                    bounds: bounds,
                    name: name
                }) : $a52fad25e66add48$var$create({
                    bounds: bounds,
                    name: name
                });
            }
        }
    }
}
function $a52fad25e66add48$var$selectComponentFn(e, cb) {
    e.preventDefault();
    e.stopPropagation();
    if ($a52fad25e66add48$var$inspectInstance) {
        const uniqueComponentId = $a52fad25e66add48$var$getUniqueComponentId($a52fad25e66add48$var$inspectInstance);
        cb(uniqueComponentId);
    }
}
var $a52fad25e66add48$var$inspectComponentHighLighterSelectFn = null;
function $a52fad25e66add48$var$cancelInspectComponentHighLighter() {
    $a52fad25e66add48$var$unhighlight();
    window.removeEventListener("mouseover", $a52fad25e66add48$var$inspectFn);
    window.removeEventListener("click", $a52fad25e66add48$var$inspectComponentHighLighterSelectFn, true);
    $a52fad25e66add48$var$inspectComponentHighLighterSelectFn = null;
}
function $a52fad25e66add48$var$inspectComponentHighLighter() {
    window.addEventListener("mouseover", $a52fad25e66add48$var$inspectFn);
    return new Promise((resolve)=>{
        function onSelect(e) {
            e.preventDefault();
            e.stopPropagation();
            $a52fad25e66add48$var$selectComponentFn(e, (id)=>{
                window.removeEventListener("click", onSelect, true);
                $a52fad25e66add48$var$inspectComponentHighLighterSelectFn = null;
                window.removeEventListener("mouseover", $a52fad25e66add48$var$inspectFn);
                const el = $a52fad25e66add48$var$getContainerElement();
                if (el) el.style.display = "none";
                resolve(JSON.stringify({
                    id: id
                }));
            });
        }
        $a52fad25e66add48$var$inspectComponentHighLighterSelectFn = onSelect;
        window.addEventListener("click", onSelect, true);
    });
}
function $a52fad25e66add48$var$scrollToComponent(options) {
    const instance = $a52fad25e66add48$var$getComponentInstance($a52fad25e66add48$export$162128841a7f2877.value, options.id);
    if (instance) {
        const [el] = $a52fad25e66add48$var$getRootElementsFromComponentInstance(instance);
        if (typeof el.scrollIntoView === "function") el.scrollIntoView({
            behavior: "smooth"
        });
        else {
            const bounds = $a52fad25e66add48$var$getComponentBoundingRect(instance);
            const scrollTarget = document.createElement("div");
            const styles = {
                ...$a52fad25e66add48$var$getStyles(bounds),
                position: "absolute"
            };
            Object.assign(scrollTarget.style, styles);
            document.body.appendChild(scrollTarget);
            scrollTarget.scrollIntoView({
                behavior: "smooth"
            });
            setTimeout(()=>{
                document.body.removeChild(scrollTarget);
            }, 2e3);
        }
        setTimeout(()=>{
            const bounds = $a52fad25e66add48$var$getComponentBoundingRect(instance);
            if (bounds.width || bounds.height) {
                const name = $a52fad25e66add48$var$getInstanceName(instance);
                const el2 = $a52fad25e66add48$var$getContainerElement();
                el2 ? $a52fad25e66add48$var$update({
                    ...options,
                    name: name,
                    bounds: bounds
                }) : $a52fad25e66add48$var$create({
                    ...options,
                    name: name,
                    bounds: bounds
                });
                setTimeout(()=>{
                    if (el2) el2.style.display = "none";
                }, 1500);
            }
        }, 1200);
    }
}
// src/core/component-inspector/index.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$_a, $a52fad25e66add48$var$_b;
($a52fad25e66add48$var$_b = ($a52fad25e66add48$var$_a = (0, $gNtJt.target)).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__) != null ? $a52fad25e66add48$var$_b : $a52fad25e66add48$var$_a.__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = true;
function $a52fad25e66add48$export$56455f68fb6e3b63(enabled) {
    (0, $gNtJt.target).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = enabled;
}
function $a52fad25e66add48$var$waitForInspectorInit(cb) {
    let total = 0;
    const timer = setInterval(()=>{
        if ((0, $gNtJt.target).__VUE_INSPECTOR__) {
            clearInterval(timer);
            total += 30;
            cb();
        }
        if (total >= /* 5s */ 5e3) clearInterval(timer);
    }, 30);
}
function $a52fad25e66add48$var$setupInspector() {
    const inspector = (0, $gNtJt.target).__VUE_INSPECTOR__;
    const _openInEditor = inspector.openInEditor;
    inspector.openInEditor = async (...params)=>{
        inspector.disable();
        _openInEditor(...params);
    };
}
function $a52fad25e66add48$var$getComponentInspector() {
    return new Promise((resolve)=>{
        function setup() {
            $a52fad25e66add48$var$setupInspector();
            resolve((0, $gNtJt.target).__VUE_INSPECTOR__);
        }
        if (!(0, $gNtJt.target).__VUE_INSPECTOR__) $a52fad25e66add48$var$waitForInspectorInit(()=>{
            setup();
        });
        else setup();
    });
}
// src/core/component/state/editor.ts
$a52fad25e66add48$var$init_esm_shims();
// src/shared/stub-vue.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$isReadonly(value) {
    return !!(value && value["__v_isReadonly" /* IS_READONLY */ ]);
}
function $a52fad25e66add48$var$isReactive(value) {
    if ($a52fad25e66add48$var$isReadonly(value)) return $a52fad25e66add48$var$isReactive(value["__v_raw" /* RAW */ ]);
    return !!(value && value["__v_isReactive" /* IS_REACTIVE */ ]);
}
function $a52fad25e66add48$var$isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function $a52fad25e66add48$var$toRaw(observed) {
    const raw = observed && observed["__v_raw" /* RAW */ ];
    return raw ? $a52fad25e66add48$var$toRaw(raw) : observed;
}
var $a52fad25e66add48$var$Fragment = Symbol.for("v-fgt");
// src/core/component/state/editor.ts
var $a52fad25e66add48$var$StateEditor = class {
    constructor(){
        this.refEditor = new $a52fad25e66add48$var$RefStateEditor();
    }
    set(object, path, value, cb) {
        const sections = Array.isArray(path) ? path : path.split(".");
        const markRef = false;
        while(sections.length > 1){
            const section = sections.shift();
            if (object instanceof Map) object = object.get(section);
            else if (object instanceof Set) object = Array.from(object.values())[section];
            else object = object[section];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
        }
        const field = sections[0];
        const item = this.refEditor.get(object)[field];
        if (cb) cb(object, field, value);
        else {
            if (this.refEditor.isRef(item)) this.refEditor.set(item, value);
            else if (markRef) object[field] = value;
            else object[field] = value;
        }
    }
    get(object, path) {
        const sections = Array.isArray(path) ? path : path.split(".");
        for(let i = 0; i < sections.length; i++){
            if (object instanceof Map) object = object.get(sections[i]);
            else object = object[sections[i]];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
            if (!object) return void 0;
        }
        return object;
    }
    has(object, path, parent = false) {
        if (typeof object === "undefined") return false;
        const sections = Array.isArray(path) ? path.slice() : path.split(".");
        const size = !parent ? 1 : 2;
        while(object && sections.length > size){
            const section = sections.shift();
            object = object[section];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
        }
        return object != null && Object.prototype.hasOwnProperty.call(object, sections[0]);
    }
    createDefaultSetCallback(state) {
        return (object, field, value)=>{
            if (state.remove || state.newKey) {
                if (Array.isArray(object)) object.splice(field, 1);
                else if ($a52fad25e66add48$var$toRaw(object) instanceof Map) object.delete(field);
                else if ($a52fad25e66add48$var$toRaw(object) instanceof Set) object.delete(Array.from(object.values())[field]);
                else Reflect.deleteProperty(object, field);
            }
            if (!state.remove) {
                const target22 = object[state.newKey || field];
                if (this.refEditor.isRef(target22)) this.refEditor.set(target22, value);
                else if ($a52fad25e66add48$var$toRaw(object) instanceof Map) object.set(state.newKey || field, value);
                else if ($a52fad25e66add48$var$toRaw(object) instanceof Set) object.add(value);
                else object[state.newKey || field] = value;
            }
        };
    }
};
var $a52fad25e66add48$var$RefStateEditor = class {
    set(ref, value) {
        if ($a52fad25e66add48$var$isRef(ref)) ref.value = value;
        else {
            if (ref instanceof Set && Array.isArray(value)) {
                ref.clear();
                value.forEach((v)=>ref.add(v));
                return;
            }
            const currentKeys = Object.keys(value);
            if (ref instanceof Map) {
                const previousKeysSet2 = new Set(ref.keys());
                currentKeys.forEach((key)=>{
                    ref.set(key, Reflect.get(value, key));
                    previousKeysSet2.delete(key);
                });
                previousKeysSet2.forEach((key)=>ref.delete(key));
                return;
            }
            const previousKeysSet = new Set(Object.keys(ref));
            currentKeys.forEach((key)=>{
                Reflect.set(ref, key, Reflect.get(value, key));
                previousKeysSet.delete(key);
            });
            previousKeysSet.forEach((key)=>Reflect.deleteProperty(ref, key));
        }
    }
    get(ref) {
        return $a52fad25e66add48$var$isRef(ref) ? ref.value : ref;
    }
    isRef(ref) {
        return $a52fad25e66add48$var$isRef(ref) || $a52fad25e66add48$var$isReactive(ref);
    }
};
async function $a52fad25e66add48$var$editComponentState(payload, stateEditor2) {
    const { path: path, nodeId: nodeId, state: state, type: type } = payload;
    const instance = $a52fad25e66add48$var$getComponentInstance($a52fad25e66add48$export$162128841a7f2877.value, nodeId);
    if (!instance) return;
    const targetPath = path.slice();
    let target22;
    if (Object.keys(instance.props).includes(path[0])) target22 = instance.props;
    else if (instance.devtoolsRawSetupState && Object.keys(instance.devtoolsRawSetupState).includes(path[0])) target22 = instance.devtoolsRawSetupState;
    else if (instance.data && Object.keys(instance.data).includes(path[0])) target22 = instance.data;
    else target22 = instance.proxy;
    if (target22 && targetPath) {
        state.type === "object" && type;
        stateEditor2.set(target22, targetPath, state.value, stateEditor2.createDefaultSetCallback(state));
    }
}
var $a52fad25e66add48$var$stateEditor = new $a52fad25e66add48$var$StateEditor();
async function $a52fad25e66add48$var$editState(payload) {
    $a52fad25e66add48$var$editComponentState(payload, $a52fad25e66add48$var$stateEditor);
}
// src/core/open-in-editor/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/ctx/state.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/timeline/storage.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$TIMELINE_LAYERS_STATE_STORAGE_ID = "__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS_STATE__";
function $a52fad25e66add48$var$addTimelineLayersStateToStorage(state) {
    if (!(0, $gNtJt.isBrowser) || typeof localStorage === "undefined" || localStorage === null) return;
    localStorage.setItem($a52fad25e66add48$var$TIMELINE_LAYERS_STATE_STORAGE_ID, JSON.stringify(state));
}
function $a52fad25e66add48$var$getTimelineLayersStateFromStorage() {
    if (!(0, $gNtJt.isBrowser) || typeof localStorage === "undefined" || localStorage === null) return {
        recordingState: false,
        mouseEventEnabled: false,
        keyboardEventEnabled: false,
        componentEventEnabled: false,
        performanceEventEnabled: false,
        selected: ""
    };
    const state = typeof localStorage.getItem !== "undefined" ? localStorage.getItem($a52fad25e66add48$var$TIMELINE_LAYERS_STATE_STORAGE_ID) : null;
    return state ? JSON.parse(state) : {
        recordingState: false,
        mouseEventEnabled: false,
        keyboardEventEnabled: false,
        componentEventEnabled: false,
        performanceEventEnabled: false,
        selected: ""
    };
}
// src/ctx/hook.ts
$a52fad25e66add48$var$init_esm_shims();
// src/ctx/inspector.ts
$a52fad25e66add48$var$init_esm_shims();
// src/ctx/timeline.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$_a2, $a52fad25e66add48$var$_b2;
($a52fad25e66add48$var$_b2 = ($a52fad25e66add48$var$_a2 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS) != null ? $a52fad25e66add48$var$_b2 : $a52fad25e66add48$var$_a2.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS = [];
var $a52fad25e66add48$var$devtoolsTimelineLayers = new Proxy((0, $gNtJt.target).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS, {
    get (target22, prop, receiver) {
        return Reflect.get(target22, prop, receiver);
    }
});
function $a52fad25e66add48$var$addTimelineLayer(options, descriptor) {
    $a52fad25e66add48$export$a67dd585df937baa.timelineLayersState[descriptor.id] = false;
    $a52fad25e66add48$var$devtoolsTimelineLayers.push({
        ...options,
        descriptorId: descriptor.id,
        appRecord: $a52fad25e66add48$var$getAppRecord(descriptor.app)
    });
}
function $a52fad25e66add48$export$736910b7e8839d93(state) {
    const updatedState = {
        ...$a52fad25e66add48$export$a67dd585df937baa.timelineLayersState,
        ...state
    };
    $a52fad25e66add48$var$addTimelineLayersStateToStorage(updatedState);
    $a52fad25e66add48$export$ee22a7aaf6b41ce2({
        timelineLayersState: updatedState
    });
}
// src/ctx/inspector.ts
var $a52fad25e66add48$var$_a3, $a52fad25e66add48$var$_b3;
($a52fad25e66add48$var$_b3 = ($a52fad25e66add48$var$_a3 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_INSPECTOR__) != null ? $a52fad25e66add48$var$_b3 : $a52fad25e66add48$var$_a3.__VUE_DEVTOOLS_KIT_INSPECTOR__ = [];
var $a52fad25e66add48$export$996e3c8abad0143f = new Proxy((0, $gNtJt.target).__VUE_DEVTOOLS_KIT_INSPECTOR__, {
    get (target22, prop, receiver) {
        return Reflect.get(target22, prop, receiver);
    }
});
var $a52fad25e66add48$export$17f8005932e80cc0 = (0, $bV4bh.debounce)(()=>{
    $a52fad25e66add48$export$4f1904c03898171b.hooks.callHook("sendInspectorToClient" /* SEND_INSPECTOR_TO_CLIENT */ , $a52fad25e66add48$export$2844c7432ba9d166());
});
function $a52fad25e66add48$export$e863e3b6c2ff029b(inspector, descriptor) {
    var _a25, _b25;
    $a52fad25e66add48$export$996e3c8abad0143f.push({
        options: inspector,
        descriptor: descriptor,
        treeFilterPlaceholder: (_a25 = inspector.treeFilterPlaceholder) != null ? _a25 : "Search tree...",
        stateFilterPlaceholder: (_b25 = inspector.stateFilterPlaceholder) != null ? _b25 : "Search state...",
        treeFilter: "",
        selectedNodeId: "",
        appRecord: $a52fad25e66add48$var$getAppRecord(descriptor.app)
    });
    $a52fad25e66add48$export$17f8005932e80cc0();
}
function $a52fad25e66add48$export$2844c7432ba9d166() {
    return $a52fad25e66add48$export$996e3c8abad0143f.filter((inspector)=>inspector.descriptor.app === $a52fad25e66add48$export$162128841a7f2877.value.app).filter((inspector)=>inspector.descriptor.id !== "components").map((inspector)=>{
        var _a25;
        const descriptor = inspector.descriptor;
        const options = inspector.options;
        return {
            id: options.id,
            label: options.label,
            logo: descriptor.logo,
            icon: `custom-ic-baseline-${(_a25 = options == null ? void 0 : options.icon) == null ? void 0 : _a25.replace(/_/g, "-")}`,
            packageName: descriptor.packageName,
            homepage: descriptor.homepage,
            pluginId: descriptor.id
        };
    });
}
function $a52fad25e66add48$export$5042bdc6f02e4304(id) {
    const inspector = $a52fad25e66add48$export$aa4140d0f5ce4bbe(id, $a52fad25e66add48$export$162128841a7f2877.value.app);
    if (!inspector) return;
    const descriptor = inspector.descriptor;
    const options = inspector.options;
    const timelineLayers = $a52fad25e66add48$var$devtoolsTimelineLayers.filter((layer)=>layer.descriptorId === descriptor.id).map((item)=>({
            id: item.id,
            label: item.label,
            color: item.color
        }));
    return {
        id: options.id,
        label: options.label,
        logo: descriptor.logo,
        packageName: descriptor.packageName,
        homepage: descriptor.homepage,
        timelineLayers: timelineLayers,
        treeFilterPlaceholder: inspector.treeFilterPlaceholder,
        stateFilterPlaceholder: inspector.stateFilterPlaceholder
    };
}
function $a52fad25e66add48$export$aa4140d0f5ce4bbe(id, app) {
    return $a52fad25e66add48$export$996e3c8abad0143f.find((inspector)=>inspector.options.id === id && (app ? inspector.descriptor.app === app : true));
}
function $a52fad25e66add48$export$54eb86d2eca92815(id) {
    const inspector = $a52fad25e66add48$export$aa4140d0f5ce4bbe(id);
    return inspector == null ? void 0 : inspector.options.actions;
}
function $a52fad25e66add48$export$eebdca42b352a0b2(id) {
    const inspector = $a52fad25e66add48$export$aa4140d0f5ce4bbe(id);
    return inspector == null ? void 0 : inspector.options.nodeActions;
}
// src/ctx/hook.ts
var $a52fad25e66add48$export$3936435a794cb908 = /* @__PURE__ */ ((DevToolsV6PluginAPIHookKeys2)=>{
    DevToolsV6PluginAPIHookKeys2["VISIT_COMPONENT_TREE"] = "visitComponentTree";
    DevToolsV6PluginAPIHookKeys2["INSPECT_COMPONENT"] = "inspectComponent";
    DevToolsV6PluginAPIHookKeys2["EDIT_COMPONENT_STATE"] = "editComponentState";
    DevToolsV6PluginAPIHookKeys2["GET_INSPECTOR_TREE"] = "getInspectorTree";
    DevToolsV6PluginAPIHookKeys2["GET_INSPECTOR_STATE"] = "getInspectorState";
    DevToolsV6PluginAPIHookKeys2["EDIT_INSPECTOR_STATE"] = "editInspectorState";
    DevToolsV6PluginAPIHookKeys2["INSPECT_TIMELINE_EVENT"] = "inspectTimelineEvent";
    DevToolsV6PluginAPIHookKeys2["TIMELINE_CLEARED"] = "timelineCleared";
    DevToolsV6PluginAPIHookKeys2["SET_PLUGIN_SETTINGS"] = "setPluginSettings";
    return DevToolsV6PluginAPIHookKeys2;
})($a52fad25e66add48$export$3936435a794cb908 || {});
var $a52fad25e66add48$export$4c35c03df042a977 = /* @__PURE__ */ ((DevToolsContextHookKeys2)=>{
    DevToolsContextHookKeys2["ADD_INSPECTOR"] = "addInspector";
    DevToolsContextHookKeys2["SEND_INSPECTOR_TREE"] = "sendInspectorTree";
    DevToolsContextHookKeys2["SEND_INSPECTOR_STATE"] = "sendInspectorState";
    DevToolsContextHookKeys2["CUSTOM_INSPECTOR_SELECT_NODE"] = "customInspectorSelectNode";
    DevToolsContextHookKeys2["TIMELINE_LAYER_ADDED"] = "timelineLayerAdded";
    DevToolsContextHookKeys2["TIMELINE_EVENT_ADDED"] = "timelineEventAdded";
    DevToolsContextHookKeys2["GET_COMPONENT_INSTANCES"] = "getComponentInstances";
    DevToolsContextHookKeys2["GET_COMPONENT_BOUNDS"] = "getComponentBounds";
    DevToolsContextHookKeys2["GET_COMPONENT_NAME"] = "getComponentName";
    DevToolsContextHookKeys2["COMPONENT_HIGHLIGHT"] = "componentHighlight";
    DevToolsContextHookKeys2["COMPONENT_UNHIGHLIGHT"] = "componentUnhighlight";
    return DevToolsContextHookKeys2;
})($a52fad25e66add48$export$4c35c03df042a977 || {});
var $a52fad25e66add48$export$12aa7e661bddec80 = /* @__PURE__ */ ((DevToolsMessagingHookKeys2)=>{
    DevToolsMessagingHookKeys2["SEND_INSPECTOR_TREE_TO_CLIENT"] = "sendInspectorTreeToClient";
    DevToolsMessagingHookKeys2["SEND_INSPECTOR_STATE_TO_CLIENT"] = "sendInspectorStateToClient";
    DevToolsMessagingHookKeys2["SEND_TIMELINE_EVENT_TO_CLIENT"] = "sendTimelineEventToClient";
    DevToolsMessagingHookKeys2["SEND_INSPECTOR_TO_CLIENT"] = "sendInspectorToClient";
    DevToolsMessagingHookKeys2["SEND_ACTIVE_APP_UNMOUNTED_TO_CLIENT"] = "sendActiveAppUpdatedToClient";
    DevToolsMessagingHookKeys2["DEVTOOLS_STATE_UPDATED"] = "devtoolsStateUpdated";
    DevToolsMessagingHookKeys2["DEVTOOLS_CONNECTED_UPDATED"] = "devtoolsConnectedUpdated";
    DevToolsMessagingHookKeys2["ROUTER_INFO_UPDATED"] = "routerInfoUpdated";
    return DevToolsMessagingHookKeys2;
})($a52fad25e66add48$export$12aa7e661bddec80 || {});
function $a52fad25e66add48$export$73be3ac6032ad9bb() {
    const hooks2 = (0, $55txk.createHooks)();
    hooks2.hook("addInspector" /* ADD_INSPECTOR */ , ({ inspector: inspector, plugin: plugin })=>{
        $a52fad25e66add48$export$e863e3b6c2ff029b(inspector, plugin.descriptor);
    });
    const debounceSendInspectorTree = (0, $bV4bh.debounce)(async ({ inspectorId: inspectorId, plugin: plugin })=>{
        var _a25;
        if (!inspectorId || !((_a25 = plugin == null ? void 0 : plugin.descriptor) == null ? void 0 : _a25.app) || $a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $a52fad25e66add48$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        const _payload = {
            app: plugin.descriptor.app,
            inspectorId: inspectorId,
            filter: (inspector == null ? void 0 : inspector.treeFilter) || "",
            rootNodes: []
        };
        await new Promise((resolve)=>{
            hooks2.callHookWith(async (callbacks)=>{
                await Promise.all(callbacks.map((cb)=>cb(_payload)));
                resolve();
            }, "getInspectorTree" /* GET_INSPECTOR_TREE */ );
        });
        hooks2.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb({
                    inspectorId: inspectorId,
                    rootNodes: _payload.rootNodes
                })));
        }, "sendInspectorTreeToClient" /* SEND_INSPECTOR_TREE_TO_CLIENT */ );
    }, 120);
    hooks2.hook("sendInspectorTree" /* SEND_INSPECTOR_TREE */ , debounceSendInspectorTree);
    const debounceSendInspectorState = (0, $bV4bh.debounce)(async ({ inspectorId: inspectorId, plugin: plugin })=>{
        var _a25;
        if (!inspectorId || !((_a25 = plugin == null ? void 0 : plugin.descriptor) == null ? void 0 : _a25.app) || $a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $a52fad25e66add48$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        const _payload = {
            app: plugin.descriptor.app,
            inspectorId: inspectorId,
            nodeId: (inspector == null ? void 0 : inspector.selectedNodeId) || "",
            state: null
        };
        const ctx = {
            currentTab: `custom-inspector:${inspectorId}`
        };
        if (_payload.nodeId) await new Promise((resolve)=>{
            hooks2.callHookWith(async (callbacks)=>{
                await Promise.all(callbacks.map((cb)=>cb(_payload, ctx)));
                resolve();
            }, "getInspectorState" /* GET_INSPECTOR_STATE */ );
        });
        hooks2.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb({
                    inspectorId: inspectorId,
                    nodeId: _payload.nodeId,
                    state: _payload.state
                })));
        }, "sendInspectorStateToClient" /* SEND_INSPECTOR_STATE_TO_CLIENT */ );
    }, 120);
    hooks2.hook("sendInspectorState" /* SEND_INSPECTOR_STATE */ , debounceSendInspectorState);
    hooks2.hook("customInspectorSelectNode" /* CUSTOM_INSPECTOR_SELECT_NODE */ , ({ inspectorId: inspectorId, nodeId: nodeId, plugin: plugin })=>{
        const inspector = $a52fad25e66add48$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        if (!inspector) return;
        inspector.selectedNodeId = nodeId;
    });
    hooks2.hook("timelineLayerAdded" /* TIMELINE_LAYER_ADDED */ , ({ options: options, plugin: plugin })=>{
        $a52fad25e66add48$var$addTimelineLayer(options, plugin.descriptor);
    });
    hooks2.hook("timelineEventAdded" /* TIMELINE_EVENT_ADDED */ , ({ options: options, plugin: plugin })=>{
        var _a25;
        const internalLayerIds = [
            "performance",
            "component-event",
            "keyboard",
            "mouse"
        ];
        if ($a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled || !((_a25 = $a52fad25e66add48$export$a67dd585df937baa.timelineLayersState) == null ? void 0 : _a25[plugin.descriptor.id]) && !internalLayerIds.includes(options.layerId)) return;
        hooks2.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb(options)));
        }, "sendTimelineEventToClient" /* SEND_TIMELINE_EVENT_TO_CLIENT */ );
    });
    hooks2.hook("getComponentInstances" /* GET_COMPONENT_INSTANCES */ , async ({ app: app })=>{
        const appRecord = app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
        if (!appRecord) return null;
        const appId = appRecord.id.toString();
        const instances = [
            ...appRecord.instanceMap
        ].filter(([key])=>key.split(":")[0] === appId).map(([, instance])=>instance);
        return instances;
    });
    hooks2.hook("getComponentBounds" /* GET_COMPONENT_BOUNDS */ , async ({ instance: instance })=>{
        const bounds = $a52fad25e66add48$var$getComponentBoundingRect(instance);
        return bounds;
    });
    hooks2.hook("getComponentName" /* GET_COMPONENT_NAME */ , ({ instance: instance })=>{
        const name = $a52fad25e66add48$var$getInstanceName(instance);
        return name;
    });
    hooks2.hook("componentHighlight" /* COMPONENT_HIGHLIGHT */ , ({ uid: uid })=>{
        const instance = $a52fad25e66add48$export$162128841a7f2877.value.instanceMap.get(uid);
        if (instance) $a52fad25e66add48$var$highlight(instance);
    });
    hooks2.hook("componentUnhighlight" /* COMPONENT_UNHIGHLIGHT */ , ()=>{
        $a52fad25e66add48$var$unhighlight();
    });
    return hooks2;
}
// src/ctx/state.ts
var $a52fad25e66add48$var$_a4, $a52fad25e66add48$var$_b4;
($a52fad25e66add48$var$_b4 = ($a52fad25e66add48$var$_a4 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_APP_RECORDS__) != null ? $a52fad25e66add48$var$_b4 : $a52fad25e66add48$var$_a4.__VUE_DEVTOOLS_KIT_APP_RECORDS__ = [];
var $a52fad25e66add48$var$_a5, $a52fad25e66add48$var$_b5;
($a52fad25e66add48$var$_b5 = ($a52fad25e66add48$var$_a5 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__) != null ? $a52fad25e66add48$var$_b5 : $a52fad25e66add48$var$_a5.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = {};
var $a52fad25e66add48$var$_a6, $a52fad25e66add48$var$_b6;
($a52fad25e66add48$var$_b6 = ($a52fad25e66add48$var$_a6 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__) != null ? $a52fad25e66add48$var$_b6 : $a52fad25e66add48$var$_a6.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = "";
var $a52fad25e66add48$var$_a7, $a52fad25e66add48$var$_b7;
($a52fad25e66add48$var$_b7 = ($a52fad25e66add48$var$_a7 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__) != null ? $a52fad25e66add48$var$_b7 : $a52fad25e66add48$var$_a7.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ = [];
var $a52fad25e66add48$var$_a8, $a52fad25e66add48$var$_b8;
($a52fad25e66add48$var$_b8 = ($a52fad25e66add48$var$_a8 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__) != null ? $a52fad25e66add48$var$_b8 : $a52fad25e66add48$var$_a8.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ = [];
var $a52fad25e66add48$var$STATE_KEY = "__VUE_DEVTOOLS_KIT_GLOBAL_STATE__";
function $a52fad25e66add48$var$initStateFactory() {
    return {
        connected: false,
        clientConnected: false,
        vitePluginDetected: true,
        appRecords: [],
        activeAppRecordId: "",
        tabs: [],
        commands: [],
        highPerfModeEnabled: true,
        devtoolsClientDetected: {},
        perfUniqueGroupId: 0,
        timelineLayersState: $a52fad25e66add48$var$getTimelineLayersStateFromStorage()
    };
}
var $a52fad25e66add48$var$_a9, $a52fad25e66add48$var$_b9;
($a52fad25e66add48$var$_b9 = ($a52fad25e66add48$var$_a9 = (0, $gNtJt.target))[$a52fad25e66add48$var$STATE_KEY]) != null ? $a52fad25e66add48$var$_b9 : $a52fad25e66add48$var$_a9[$a52fad25e66add48$var$STATE_KEY] = $a52fad25e66add48$var$initStateFactory();
var $a52fad25e66add48$export$ff4fc651602b9735 = (0, $bV4bh.debounce)((state)=>{
    $a52fad25e66add48$export$4f1904c03898171b.hooks.callHook("devtoolsStateUpdated" /* DEVTOOLS_STATE_UPDATED */ , {
        state: state
    });
});
var $a52fad25e66add48$export$ce292af96ab94f7c = (0, $bV4bh.debounce)((state, oldState)=>{
    $a52fad25e66add48$export$4f1904c03898171b.hooks.callHook("devtoolsConnectedUpdated" /* DEVTOOLS_CONNECTED_UPDATED */ , {
        state: state,
        oldState: oldState
    });
});
var $a52fad25e66add48$export$d3c0473489b1d63b = new Proxy((0, $gNtJt.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__, {
    get (_target, prop, receiver) {
        if (prop === "value") return (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__;
        return (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__[prop];
    }
});
var $a52fad25e66add48$export$c1761479e1420543 = (app)=>{
    (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__ = [
        ...(0, $gNtJt.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__,
        app
    ];
};
var $a52fad25e66add48$export$4d20c72f1da170ba = (app)=>{
    (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__ = $a52fad25e66add48$export$d3c0473489b1d63b.value.filter((record)=>record.app !== app);
};
var $a52fad25e66add48$export$162128841a7f2877 = new Proxy((0, $gNtJt.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__, {
    get (_target, prop, receiver) {
        if (prop === "value") return (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__;
        else if (prop === "id") return (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__;
        return (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__[prop];
    }
});
function $a52fad25e66add48$var$updateAllStates() {
    $a52fad25e66add48$export$ff4fc651602b9735({
        ...(0, $gNtJt.target)[$a52fad25e66add48$var$STATE_KEY],
        appRecords: $a52fad25e66add48$export$d3c0473489b1d63b.value,
        activeAppRecordId: $a52fad25e66add48$export$162128841a7f2877.id,
        tabs: (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__,
        commands: (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
    });
}
function $a52fad25e66add48$export$1574774def61bdf9(app) {
    (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = app;
    $a52fad25e66add48$var$updateAllStates();
}
function $a52fad25e66add48$export$1a7804ab8d8511d1(id) {
    (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = id;
    $a52fad25e66add48$var$updateAllStates();
}
var $a52fad25e66add48$export$a67dd585df937baa = new Proxy((0, $gNtJt.target)[$a52fad25e66add48$var$STATE_KEY], {
    get (target22, property) {
        if (property === "appRecords") return $a52fad25e66add48$export$d3c0473489b1d63b;
        else if (property === "activeAppRecordId") return $a52fad25e66add48$export$162128841a7f2877.id;
        else if (property === "tabs") return (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
        else if (property === "commands") return (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
        return (0, $gNtJt.target)[$a52fad25e66add48$var$STATE_KEY][property];
    },
    deleteProperty (target22, property) {
        delete target22[property];
        return true;
    },
    set (target22, property, value) {
        const oldState = {
            ...(0, $gNtJt.target)[$a52fad25e66add48$var$STATE_KEY]
        };
        target22[property] = value;
        (0, $gNtJt.target)[$a52fad25e66add48$var$STATE_KEY][property] = value;
        return true;
    }
});
function $a52fad25e66add48$export$ed70a0f71250535e() {
    Object.assign((0, $gNtJt.target)[$a52fad25e66add48$var$STATE_KEY], $a52fad25e66add48$var$initStateFactory());
}
function $a52fad25e66add48$export$ee22a7aaf6b41ce2(state) {
    const oldState = {
        ...(0, $gNtJt.target)[$a52fad25e66add48$var$STATE_KEY],
        appRecords: $a52fad25e66add48$export$d3c0473489b1d63b.value,
        activeAppRecordId: $a52fad25e66add48$export$162128841a7f2877.id
    };
    if (oldState.connected !== state.connected && state.connected || oldState.clientConnected !== state.clientConnected && state.clientConnected) $a52fad25e66add48$export$ce292af96ab94f7c((0, $gNtJt.target)[$a52fad25e66add48$var$STATE_KEY], oldState);
    Object.assign((0, $gNtJt.target)[$a52fad25e66add48$var$STATE_KEY], state);
    $a52fad25e66add48$var$updateAllStates();
}
function $a52fad25e66add48$export$814e9e34f2c01770(fn) {
    return new Promise((resolve)=>{
        if ($a52fad25e66add48$export$a67dd585df937baa.connected) {
            fn();
            resolve();
        }
        $a52fad25e66add48$export$4f1904c03898171b.hooks.hook("devtoolsConnectedUpdated" /* DEVTOOLS_CONNECTED_UPDATED */ , ({ state: state })=>{
            if (state.connected) {
                fn();
                resolve();
            }
        });
    });
}
var $a52fad25e66add48$var$resolveIcon = (icon)=>{
    if (!icon) return;
    if (icon.startsWith("baseline-")) return `custom-ic-${icon}`;
    if (icon.startsWith("i-") || (0, $gNtJt.isUrlString)(icon)) return icon;
    return `custom-ic-baseline-${icon}`;
};
function $a52fad25e66add48$export$9ce008646970742b(tab) {
    const tabs = (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
    if (tabs.some((t)=>t.name === tab.name)) return;
    tabs.push({
        ...tab,
        icon: $a52fad25e66add48$var$resolveIcon(tab.icon)
    });
    $a52fad25e66add48$var$updateAllStates();
}
function $a52fad25e66add48$export$faa8225e4ad5293(action) {
    const commands = (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
    if (commands.some((t)=>t.id === action.id)) return;
    commands.push({
        ...action,
        icon: $a52fad25e66add48$var$resolveIcon(action.icon),
        children: action.children ? action.children.map((child)=>({
                ...child,
                icon: $a52fad25e66add48$var$resolveIcon(child.icon)
            })) : void 0
    });
    $a52fad25e66add48$var$updateAllStates();
}
function $a52fad25e66add48$export$8791c0d68ff21044(actionId) {
    const commands = (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
    const index = commands.findIndex((t)=>t.id === actionId);
    if (index === -1) return;
    commands.splice(index, 1);
    $a52fad25e66add48$var$updateAllStates();
}
function $a52fad25e66add48$export$b2de3679515b1d6b(state) {
    $a52fad25e66add48$export$ee22a7aaf6b41ce2({
        clientConnected: state
    });
}
// src/core/open-in-editor/index.ts
function $a52fad25e66add48$export$d4398ad178564033(url) {
    (0, $gNtJt.target).__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__ = url;
}
function $a52fad25e66add48$var$openInEditor(options = {}) {
    var _a25, _b25, _c;
    const { file: file, host: host, baseUrl: baseUrl = window.location.origin, line: line = 0, column: column = 0 } = options;
    if (file) {
        if (host === "chrome-extension") {
            const fileName = file.replace(/\\/g, "\\\\");
            const _baseUrl = (_b25 = (_a25 = window.VUE_DEVTOOLS_CONFIG) == null ? void 0 : _a25.openInEditorHost) != null ? _b25 : "/";
            fetch(`${_baseUrl}__open-in-editor?file=${encodeURI(file)}`).then((response)=>{
                if (!response.ok) {
                    const msg = `Opening component ${fileName} failed`;
                    console.log(`%c${msg}`, "color:red");
                }
            });
        } else if ($a52fad25e66add48$export$a67dd585df937baa.vitePluginDetected) {
            const _baseUrl = (_c = (0, $gNtJt.target).__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__) != null ? _c : baseUrl;
            (0, $gNtJt.target).__VUE_INSPECTOR__.openInEditor(_baseUrl, file, line, column);
        }
    }
}
// src/core/plugin/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/api/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/api/v6/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/plugin/plugin-settings.ts
$a52fad25e66add48$var$init_esm_shims();
// src/ctx/plugin.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$_a10, $a52fad25e66add48$var$_b10;
($a52fad25e66add48$var$_b10 = ($a52fad25e66add48$var$_a10 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__) != null ? $a52fad25e66add48$var$_b10 : $a52fad25e66add48$var$_a10.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ = [];
var $a52fad25e66add48$export$df02dcb86618c10f = new Proxy((0, $gNtJt.target).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__, {
    get (target22, prop, receiver) {
        return Reflect.get(target22, prop, receiver);
    }
});
function $a52fad25e66add48$export$5158df7771943590(pluginDescriptor, setupFn) {
    $a52fad25e66add48$export$df02dcb86618c10f.push([
        pluginDescriptor,
        setupFn
    ]);
}
// src/core/plugin/plugin-settings.ts
function $a52fad25e66add48$var$_getSettings(settings) {
    const _settings = {};
    Object.keys(settings).forEach((key)=>{
        _settings[key] = settings[key].defaultValue;
    });
    return _settings;
}
function $a52fad25e66add48$var$getPluginLocalKey(pluginId) {
    return `__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__${pluginId}__`;
}
function $a52fad25e66add48$var$getPluginSettingsOptions(pluginId) {
    var _a25, _b25, _c;
    const item = (_b25 = (_a25 = $a52fad25e66add48$export$df02dcb86618c10f.find((item2)=>{
        var _a26;
        return item2[0].id === pluginId && !!((_a26 = item2[0]) == null ? void 0 : _a26.settings);
    })) == null ? void 0 : _a25[0]) != null ? _b25 : null;
    return (_c = item == null ? void 0 : item.settings) != null ? _c : null;
}
function $a52fad25e66add48$var$getPluginSettings(pluginId, fallbackValue) {
    var _a25, _b25, _c;
    const localKey = $a52fad25e66add48$var$getPluginLocalKey(pluginId);
    if (localKey) {
        const localSettings = localStorage.getItem(localKey);
        if (localSettings) return JSON.parse(localSettings);
    }
    if (pluginId) {
        const item = (_b25 = (_a25 = $a52fad25e66add48$export$df02dcb86618c10f.find((item2)=>item2[0].id === pluginId)) == null ? void 0 : _a25[0]) != null ? _b25 : null;
        return $a52fad25e66add48$var$_getSettings((_c = item == null ? void 0 : item.settings) != null ? _c : {});
    }
    return $a52fad25e66add48$var$_getSettings(fallbackValue);
}
function $a52fad25e66add48$var$initPluginSettings(pluginId, settings) {
    const localKey = $a52fad25e66add48$var$getPluginLocalKey(pluginId);
    const localSettings = localStorage.getItem(localKey);
    if (!localSettings) localStorage.setItem(localKey, JSON.stringify($a52fad25e66add48$var$_getSettings(settings)));
}
function $a52fad25e66add48$var$setPluginSettings(pluginId, key, value) {
    const localKey = $a52fad25e66add48$var$getPluginLocalKey(pluginId);
    const localSettings = localStorage.getItem(localKey);
    const parsedLocalSettings = JSON.parse(localSettings || "{}");
    const updated = {
        ...parsedLocalSettings,
        [key]: value
    };
    localStorage.setItem(localKey, JSON.stringify(updated));
    $a52fad25e66add48$export$4f1904c03898171b.hooks.callHookWith((callbacks)=>{
        callbacks.forEach((cb)=>cb({
                pluginId: pluginId,
                key: key,
                oldValue: parsedLocalSettings[key],
                newValue: value,
                settings: updated
            }));
    }, "setPluginSettings" /* SET_PLUGIN_SETTINGS */ );
}
// src/hook/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/types/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/types/app.ts
$a52fad25e66add48$var$init_esm_shims();
// src/types/command.ts
$a52fad25e66add48$var$init_esm_shims();
// src/types/component.ts
$a52fad25e66add48$var$init_esm_shims();
// src/types/hook.ts
$a52fad25e66add48$var$init_esm_shims();
// src/types/inspector.ts
$a52fad25e66add48$var$init_esm_shims();
// src/types/plugin.ts
$a52fad25e66add48$var$init_esm_shims();
// src/types/router.ts
$a52fad25e66add48$var$init_esm_shims();
// src/types/tab.ts
$a52fad25e66add48$var$init_esm_shims();
// src/types/timeline.ts
$a52fad25e66add48$var$init_esm_shims();
// src/hook/index.ts
var $a52fad25e66add48$var$_a11, $a52fad25e66add48$var$_b11;
var $a52fad25e66add48$var$devtoolsHooks = ($a52fad25e66add48$var$_b11 = ($a52fad25e66add48$var$_a11 = (0, $gNtJt.target)).__VUE_DEVTOOLS_HOOK) != null ? $a52fad25e66add48$var$_b11 : $a52fad25e66add48$var$_a11.__VUE_DEVTOOLS_HOOK = (0, $55txk.createHooks)();
var $a52fad25e66add48$var$on = {
    vueAppInit (fn) {
        $a52fad25e66add48$var$devtoolsHooks.hook("app:init" /* APP_INIT */ , fn);
    },
    vueAppUnmount (fn) {
        $a52fad25e66add48$var$devtoolsHooks.hook("app:unmount" /* APP_UNMOUNT */ , fn);
    },
    vueAppConnected (fn) {
        $a52fad25e66add48$var$devtoolsHooks.hook("app:connected" /* APP_CONNECTED */ , fn);
    },
    componentAdded (fn) {
        return $a52fad25e66add48$var$devtoolsHooks.hook("component:added" /* COMPONENT_ADDED */ , fn);
    },
    componentEmit (fn) {
        return $a52fad25e66add48$var$devtoolsHooks.hook("component:emit" /* COMPONENT_EMIT */ , fn);
    },
    componentUpdated (fn) {
        return $a52fad25e66add48$var$devtoolsHooks.hook("component:updated" /* COMPONENT_UPDATED */ , fn);
    },
    componentRemoved (fn) {
        return $a52fad25e66add48$var$devtoolsHooks.hook("component:removed" /* COMPONENT_REMOVED */ , fn);
    },
    setupDevtoolsPlugin (fn) {
        $a52fad25e66add48$var$devtoolsHooks.hook("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , fn);
    },
    perfStart (fn) {
        return $a52fad25e66add48$var$devtoolsHooks.hook("perf:start" /* PERFORMANCE_START */ , fn);
    },
    perfEnd (fn) {
        return $a52fad25e66add48$var$devtoolsHooks.hook("perf:end" /* PERFORMANCE_END */ , fn);
    }
};
function $a52fad25e66add48$var$createDevToolsHook() {
    return {
        id: "vue-devtools-next",
        devtoolsVersion: "7.0",
        enabled: false,
        appRecords: [],
        apps: [],
        events: /* @__PURE__ */ new Map(),
        on (event, fn) {
            var _a25;
            if (!this.events.has(event)) this.events.set(event, []);
            (_a25 = this.events.get(event)) == null || _a25.push(fn);
            return ()=>this.off(event, fn);
        },
        once (event, fn) {
            const onceFn = (...args)=>{
                this.off(event, onceFn);
                fn(...args);
            };
            this.on(event, onceFn);
            return [
                event,
                onceFn
            ];
        },
        off (event, fn) {
            if (this.events.has(event)) {
                const eventCallbacks = this.events.get(event);
                const index = eventCallbacks.indexOf(fn);
                if (index !== -1) eventCallbacks.splice(index, 1);
            }
        },
        emit (event, ...payload) {
            if (this.events.has(event)) this.events.get(event).forEach((fn)=>fn(...payload));
        }
    };
}
function $a52fad25e66add48$var$subscribeDevToolsHook(hook2) {
    hook2.on("app:init" /* APP_INIT */ , (app, version, types)=>{
        var _a25, _b25, _c;
        if ((_c = (_b25 = (_a25 = app == null ? void 0 : app._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) return;
        $a52fad25e66add48$var$devtoolsHooks.callHook("app:init" /* APP_INIT */ , app, version, types);
    });
    hook2.on("app:unmount" /* APP_UNMOUNT */ , (app)=>{
        $a52fad25e66add48$var$devtoolsHooks.callHook("app:unmount" /* APP_UNMOUNT */ , app);
    });
    hook2.on("component:added" /* COMPONENT_ADDED */ , async (app, uid, parentUid, component)=>{
        var _a25, _b25, _c;
        if (((_c = (_b25 = (_a25 = app == null ? void 0 : app._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) || $a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        if (!app || typeof uid !== "number" && !uid || !component) return;
        $a52fad25e66add48$var$devtoolsHooks.callHook("component:added" /* COMPONENT_ADDED */ , app, uid, parentUid, component);
    });
    hook2.on("component:updated" /* COMPONENT_UPDATED */ , (app, uid, parentUid, component)=>{
        if (!app || typeof uid !== "number" && !uid || !component || $a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        $a52fad25e66add48$var$devtoolsHooks.callHook("component:updated" /* COMPONENT_UPDATED */ , app, uid, parentUid, component);
    });
    hook2.on("component:removed" /* COMPONENT_REMOVED */ , async (app, uid, parentUid, component)=>{
        if (!app || typeof uid !== "number" && !uid || !component || $a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        $a52fad25e66add48$var$devtoolsHooks.callHook("component:removed" /* COMPONENT_REMOVED */ , app, uid, parentUid, component);
    });
    hook2.on("component:emit" /* COMPONENT_EMIT */ , async (app, instance, event, params)=>{
        if (!app || !instance || $a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        $a52fad25e66add48$var$devtoolsHooks.callHook("component:emit" /* COMPONENT_EMIT */ , app, instance, event, params);
    });
    hook2.on("perf:start" /* PERFORMANCE_START */ , (app, uid, vm, type, time)=>{
        if (!app || $a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        $a52fad25e66add48$var$devtoolsHooks.callHook("perf:start" /* PERFORMANCE_START */ , app, uid, vm, type, time);
    });
    hook2.on("perf:end" /* PERFORMANCE_END */ , (app, uid, vm, type, time)=>{
        if (!app || $a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        $a52fad25e66add48$var$devtoolsHooks.callHook("perf:end" /* PERFORMANCE_END */ , app, uid, vm, type, time);
    });
    hook2.on("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , (pluginDescriptor, setupFn, options)=>{
        if ((options == null ? void 0 : options.target) === "legacy") return;
        $a52fad25e66add48$var$devtoolsHooks.callHook("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , pluginDescriptor, setupFn);
    });
}
var $a52fad25e66add48$var$hook = {
    on: $a52fad25e66add48$var$on,
    setupDevToolsPlugin (pluginDescriptor, setupFn) {
        return $a52fad25e66add48$var$devtoolsHooks.callHook("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , pluginDescriptor, setupFn);
    }
};
// src/api/v6/index.ts
var $a52fad25e66add48$var$DevToolsV6PluginAPI = class {
    constructor({ plugin: plugin, ctx: ctx }){
        this.hooks = ctx.hooks;
        this.plugin = plugin;
    }
    get on() {
        return {
            // component inspector
            visitComponentTree: (handler)=>{
                this.hooks.hook("visitComponentTree" /* VISIT_COMPONENT_TREE */ , handler);
            },
            inspectComponent: (handler)=>{
                this.hooks.hook("inspectComponent" /* INSPECT_COMPONENT */ , handler);
            },
            editComponentState: (handler)=>{
                this.hooks.hook("editComponentState" /* EDIT_COMPONENT_STATE */ , handler);
            },
            // custom inspector
            getInspectorTree: (handler)=>{
                this.hooks.hook("getInspectorTree" /* GET_INSPECTOR_TREE */ , handler);
            },
            getInspectorState: (handler)=>{
                this.hooks.hook("getInspectorState" /* GET_INSPECTOR_STATE */ , handler);
            },
            editInspectorState: (handler)=>{
                this.hooks.hook("editInspectorState" /* EDIT_INSPECTOR_STATE */ , handler);
            },
            // timeline
            inspectTimelineEvent: (handler)=>{
                this.hooks.hook("inspectTimelineEvent" /* INSPECT_TIMELINE_EVENT */ , handler);
            },
            timelineCleared: (handler)=>{
                this.hooks.hook("timelineCleared" /* TIMELINE_CLEARED */ , handler);
            },
            // settings
            setPluginSettings: (handler)=>{
                this.hooks.hook("setPluginSettings" /* SET_PLUGIN_SETTINGS */ , handler);
            }
        };
    }
    // component inspector
    notifyComponentUpdate(instance) {
        var _a25;
        if ($a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $a52fad25e66add48$export$2844c7432ba9d166().find((i)=>i.packageName === this.plugin.descriptor.packageName);
        if (inspector == null ? void 0 : inspector.id) {
            if (instance) {
                const args = [
                    instance.appContext.app,
                    instance.uid,
                    (_a25 = instance.parent) == null ? void 0 : _a25.uid,
                    instance
                ];
                $a52fad25e66add48$var$devtoolsHooks.callHook("component:updated" /* COMPONENT_UPDATED */ , ...args);
            } else $a52fad25e66add48$var$devtoolsHooks.callHook("component:updated" /* COMPONENT_UPDATED */ );
            this.hooks.callHook("sendInspectorState" /* SEND_INSPECTOR_STATE */ , {
                inspectorId: inspector.id,
                plugin: this.plugin
            });
        }
    }
    // custom inspector
    addInspector(options) {
        this.hooks.callHook("addInspector" /* ADD_INSPECTOR */ , {
            inspector: options,
            plugin: this.plugin
        });
        if (this.plugin.descriptor.settings) $a52fad25e66add48$var$initPluginSettings(options.id, this.plugin.descriptor.settings);
    }
    sendInspectorTree(inspectorId) {
        if ($a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook("sendInspectorTree" /* SEND_INSPECTOR_TREE */ , {
            inspectorId: inspectorId,
            plugin: this.plugin
        });
    }
    sendInspectorState(inspectorId) {
        if ($a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook("sendInspectorState" /* SEND_INSPECTOR_STATE */ , {
            inspectorId: inspectorId,
            plugin: this.plugin
        });
    }
    selectInspectorNode(inspectorId, nodeId) {
        this.hooks.callHook("customInspectorSelectNode" /* CUSTOM_INSPECTOR_SELECT_NODE */ , {
            inspectorId: inspectorId,
            nodeId: nodeId,
            plugin: this.plugin
        });
    }
    visitComponentTree(payload) {
        return this.hooks.callHook("visitComponentTree" /* VISIT_COMPONENT_TREE */ , payload);
    }
    // timeline
    now() {
        if ($a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return 0;
        return Date.now();
    }
    addTimelineLayer(options) {
        this.hooks.callHook("timelineLayerAdded" /* TIMELINE_LAYER_ADDED */ , {
            options: options,
            plugin: this.plugin
        });
    }
    addTimelineEvent(options) {
        if ($a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook("timelineEventAdded" /* TIMELINE_EVENT_ADDED */ , {
            options: options,
            plugin: this.plugin
        });
    }
    // settings
    getSettings(pluginId) {
        return $a52fad25e66add48$var$getPluginSettings(pluginId != null ? pluginId : this.plugin.descriptor.id, this.plugin.descriptor.settings);
    }
    // utilities
    getComponentInstances(app) {
        return this.hooks.callHook("getComponentInstances" /* GET_COMPONENT_INSTANCES */ , {
            app: app
        });
    }
    getComponentBounds(instance) {
        return this.hooks.callHook("getComponentBounds" /* GET_COMPONENT_BOUNDS */ , {
            instance: instance
        });
    }
    getComponentName(instance) {
        return this.hooks.callHook("getComponentName" /* GET_COMPONENT_NAME */ , {
            instance: instance
        });
    }
    highlightElement(instance) {
        const uid = instance.__VUE_DEVTOOLS_NEXT_UID__;
        return this.hooks.callHook("componentHighlight" /* COMPONENT_HIGHLIGHT */ , {
            uid: uid
        });
    }
    unhighlightElement() {
        return this.hooks.callHook("componentUnhighlight" /* COMPONENT_UNHIGHLIGHT */ );
    }
};
// src/api/index.ts
var $a52fad25e66add48$var$DevToolsPluginAPI = $a52fad25e66add48$var$DevToolsV6PluginAPI;
// src/core/plugin/components.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/component/state/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/component/state/process.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/component/state/constants.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$vueBuiltins = /* @__PURE__ */ new Set([
    "nextTick",
    "defineComponent",
    "defineAsyncComponent",
    "defineCustomElement",
    "ref",
    "computed",
    "reactive",
    "readonly",
    "watchEffect",
    "watchPostEffect",
    "watchSyncEffect",
    "watch",
    "isRef",
    "unref",
    "toRef",
    "toRefs",
    "isProxy",
    "isReactive",
    "isReadonly",
    "shallowRef",
    "triggerRef",
    "customRef",
    "shallowReactive",
    "shallowReadonly",
    "toRaw",
    "markRaw",
    "effectScope",
    "getCurrentScope",
    "onScopeDispose",
    "onMounted",
    "onUpdated",
    "onUnmounted",
    "onBeforeMount",
    "onBeforeUpdate",
    "onBeforeUnmount",
    "onErrorCaptured",
    "onRenderTracked",
    "onRenderTriggered",
    "onActivated",
    "onDeactivated",
    "onServerPrefetch",
    "provide",
    "inject",
    "h",
    "mergeProps",
    "cloneVNode",
    "isVNode",
    "resolveComponent",
    "resolveDirective",
    "withDirectives",
    "withModifiers"
]);
var $a52fad25e66add48$var$symbolRE = /^\[native Symbol Symbol\((.*)\)\]$/;
var $a52fad25e66add48$var$rawTypeRE = /^\[object (\w+)\]$/;
var $a52fad25e66add48$var$specialTypeRE = /^\[native (\w+) (.*?)(<>(([\s\S])*))?\]$/;
var $a52fad25e66add48$var$fnTypeRE = /^(?:function|class) (\w+)/;
var $a52fad25e66add48$var$MAX_STRING_SIZE = 1e4;
var $a52fad25e66add48$var$MAX_ARRAY_SIZE = 5e3;
var $a52fad25e66add48$export$6db089fe7b26f5b6 = "__vue_devtool_undefined__";
var $a52fad25e66add48$export$b4bf424ed968e242 = "__vue_devtool_infinity__";
var $a52fad25e66add48$export$95cb88e357cbada8 = "__vue_devtool_negative_infinity__";
var $a52fad25e66add48$export$d7ae0f70ebb9e144 = "__vue_devtool_nan__";
var $a52fad25e66add48$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "&": "&amp;"
};
// src/core/component/state/util.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/component/state/is.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$isVueInstance(value) {
    if (!$a52fad25e66add48$var$ensurePropertyExists(value, "_")) return false;
    if (!$a52fad25e66add48$export$53b83ca8eaab0383(value._)) return false;
    return Object.keys(value._).includes("vnode");
}
function $a52fad25e66add48$export$53b83ca8eaab0383(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}
function $a52fad25e66add48$var$isPrimitive(data) {
    if (data == null) return true;
    const type = typeof data;
    return type === "string" || type === "number" || type === "boolean";
}
function $a52fad25e66add48$var$isRef2(raw) {
    return !!raw.__v_isRef;
}
function $a52fad25e66add48$var$isComputed(raw) {
    return $a52fad25e66add48$var$isRef2(raw) && !!raw.effect;
}
function $a52fad25e66add48$var$isReactive2(raw) {
    return !!raw.__v_isReactive;
}
function $a52fad25e66add48$var$isReadOnly(raw) {
    return !!raw.__v_isReadonly;
}
// src/core/component/state/util.ts
var $a52fad25e66add48$var$tokenMap = {
    [$a52fad25e66add48$export$6db089fe7b26f5b6]: "undefined",
    [$a52fad25e66add48$export$d7ae0f70ebb9e144]: "NaN",
    [$a52fad25e66add48$export$b4bf424ed968e242]: "Infinity",
    [$a52fad25e66add48$export$95cb88e357cbada8]: "-Infinity"
};
var $a52fad25e66add48$var$reversedTokenMap = Object.entries($a52fad25e66add48$var$tokenMap).reduce((acc, [key, value])=>{
    acc[value] = key;
    return acc;
}, {});
function $a52fad25e66add48$var$internalStateTokenToString(value) {
    if (value === null) return "null";
    return typeof value === "string" && $a52fad25e66add48$var$tokenMap[value] || false;
}
function $a52fad25e66add48$var$replaceTokenToString(value) {
    const replaceRegex = new RegExp(`"(${Object.keys($a52fad25e66add48$var$tokenMap).join("|")})"`, "g");
    return value.replace(replaceRegex, (_, g1)=>$a52fad25e66add48$var$tokenMap[g1]);
}
function $a52fad25e66add48$var$replaceStringToToken(value) {
    const literalValue = $a52fad25e66add48$var$reversedTokenMap[value.trim()];
    if (literalValue) return `"${literalValue}"`;
    const replaceRegex = new RegExp(`:\\s*(${Object.keys($a52fad25e66add48$var$reversedTokenMap).join("|")})`, "g");
    return value.replace(replaceRegex, (_, g1)=>`:"${$a52fad25e66add48$var$reversedTokenMap[g1]}"`);
}
function $a52fad25e66add48$var$getPropType(type) {
    if (Array.isArray(type)) return type.map((t)=>$a52fad25e66add48$var$getPropType(t)).join(" or ");
    if (type == null) return "null";
    const match = type.toString().match($a52fad25e66add48$var$fnTypeRE);
    return typeof type === "function" ? match && match[1] || "any" : "any";
}
function $a52fad25e66add48$var$sanitize(data) {
    if (!$a52fad25e66add48$var$isPrimitive(data) && !Array.isArray(data) && !$a52fad25e66add48$export$53b83ca8eaab0383(data)) return Object.prototype.toString.call(data);
    else return data;
}
function $a52fad25e66add48$var$getSetupStateType(raw) {
    try {
        return {
            ref: $a52fad25e66add48$var$isRef2(raw),
            computed: $a52fad25e66add48$var$isComputed(raw),
            reactive: $a52fad25e66add48$var$isReactive2(raw),
            readonly: $a52fad25e66add48$var$isReadOnly(raw)
        };
    } catch (e) {
        return {
            ref: false,
            computed: false,
            reactive: false,
            readonly: false
        };
    }
}
function $a52fad25e66add48$var$toRaw2(value) {
    if (value == null ? void 0 : value.__v_raw) return value.__v_raw;
    return value;
}
function $a52fad25e66add48$export$4e7f196112fea3c5(s) {
    return s.replace(/[<>"&]/g, (s2)=>{
        return $a52fad25e66add48$var$ESC[s2] || s2;
    });
}
// src/core/component/state/process.ts
function $a52fad25e66add48$var$mergeOptions(to, from, instance) {
    if (typeof from === "function") from = from.options;
    if (!from) return to;
    const { mixins: mixins, extends: extendsOptions } = from;
    extendsOptions && $a52fad25e66add48$var$mergeOptions(to, extendsOptions, instance);
    mixins && mixins.forEach((m)=>$a52fad25e66add48$var$mergeOptions(to, m, instance));
    for (const key of [
        "computed",
        "inject"
    ])if (Object.prototype.hasOwnProperty.call(from, key)) {
        if (!to[key]) to[key] = from[key];
        else Object.assign(to[key], from[key]);
    }
    return to;
}
function $a52fad25e66add48$var$resolveMergedOptions(instance) {
    const raw = instance == null ? void 0 : instance.type;
    if (!raw) return {};
    const { mixins: mixins, extends: extendsOptions } = raw;
    const globalMixins = instance.appContext.mixins;
    if (!globalMixins.length && !mixins && !extendsOptions) return raw;
    const options = {};
    globalMixins.forEach((m)=>$a52fad25e66add48$var$mergeOptions(options, m, instance));
    $a52fad25e66add48$var$mergeOptions(options, raw, instance);
    return options;
}
function $a52fad25e66add48$var$processProps(instance) {
    var _a25;
    const props = [];
    const propDefinitions = (_a25 = instance == null ? void 0 : instance.type) == null ? void 0 : _a25.props;
    for(const key in instance == null ? void 0 : instance.props){
        const propDefinition = propDefinitions ? propDefinitions[key] : null;
        const camelizeKey = (0, $gNtJt.camelize)(key);
        props.push({
            type: "props",
            key: camelizeKey,
            value: $a52fad25e66add48$var$returnError(()=>instance.props[key]),
            editable: true,
            meta: propDefinition ? {
                type: propDefinition.type ? $a52fad25e66add48$var$getPropType(propDefinition.type) : "any",
                required: !!propDefinition.required,
                ...propDefinition.default ? {
                    default: propDefinition.default.toString()
                } : {}
            } : {
                type: "invalid"
            }
        });
    }
    return props;
}
function $a52fad25e66add48$var$processState(instance) {
    const type = instance.type;
    const props = type == null ? void 0 : type.props;
    const getters = type.vuex && type.vuex.getters;
    const computedDefs = type.computed;
    const data = {
        ...instance.data,
        ...instance.renderContext
    };
    return Object.keys(data).filter((key)=>!(props && key in props) && !(getters && key in getters) && !(computedDefs && key in computedDefs)).map((key)=>({
            key: key,
            type: "data",
            value: $a52fad25e66add48$var$returnError(()=>data[key]),
            editable: true
        }));
}
function $a52fad25e66add48$var$getStateTypeAndName(info) {
    const stateType = info.computed ? "computed" : info.ref ? "ref" : info.reactive ? "reactive" : null;
    const stateTypeName = stateType ? `${stateType.charAt(0).toUpperCase()}${stateType.slice(1)}` : null;
    return {
        stateType: stateType,
        stateTypeName: stateTypeName
    };
}
function $a52fad25e66add48$var$processSetupState(instance) {
    const raw = instance.devtoolsRawSetupState || {};
    return Object.keys(instance.setupState).filter((key)=>!$a52fad25e66add48$var$vueBuiltins.has(key) && key.split(/(?=[A-Z])/)[0] !== "use").map((key)=>{
        var _a25, _b25, _c, _d;
        const value = $a52fad25e66add48$var$returnError(()=>$a52fad25e66add48$var$toRaw2(instance.setupState[key]));
        const accessError = value instanceof Error;
        const rawData = raw[key];
        let result;
        let isOtherType = accessError || typeof value === "function" || $a52fad25e66add48$var$ensurePropertyExists(value, "render") && typeof value.render === "function" || $a52fad25e66add48$var$ensurePropertyExists(value, "__asyncLoader") && typeof value.__asyncLoader === "function" || typeof value === "object" && value && ("setup" in value || "props" in value) || /^v[A-Z]/.test(key);
        if (rawData && !accessError) {
            const info = $a52fad25e66add48$var$getSetupStateType(rawData);
            const { stateType: stateType, stateTypeName: stateTypeName } = $a52fad25e66add48$var$getStateTypeAndName(info);
            const isState = info.ref || info.computed || info.reactive;
            const raw2 = $a52fad25e66add48$var$ensurePropertyExists(rawData, "effect") ? ((_b25 = (_a25 = rawData.effect) == null ? void 0 : _a25.raw) == null ? void 0 : _b25.toString()) || ((_d = (_c = rawData.effect) == null ? void 0 : _c.fn) == null ? void 0 : _d.toString()) : null;
            if (stateType) isOtherType = false;
            result = {
                ...stateType ? {
                    stateType: stateType,
                    stateTypeName: stateTypeName
                } : {},
                ...raw2 ? {
                    raw: raw2
                } : {},
                editable: isState && !info.readonly
            };
        }
        const type = isOtherType ? "setup (other)" : "setup";
        return {
            key: key,
            value: value,
            type: type,
            // @ts-expect-error ignore
            ...result
        };
    });
}
function $a52fad25e66add48$var$processComputed(instance, mergedType) {
    const type = mergedType;
    const computed = [];
    const defs = type.computed || {};
    for(const key in defs){
        const def = defs[key];
        const type2 = typeof def === "function" && def.vuex ? "vuex bindings" : "computed";
        computed.push({
            type: type2,
            key: key,
            value: $a52fad25e66add48$var$returnError(()=>{
                var _a25;
                return (_a25 = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a25[key];
            }),
            editable: typeof def.set === "function"
        });
    }
    return computed;
}
function $a52fad25e66add48$var$processAttrs(instance) {
    return Object.keys(instance.attrs).map((key)=>({
            type: "attrs",
            key: key,
            value: $a52fad25e66add48$var$returnError(()=>instance.attrs[key])
        }));
}
function $a52fad25e66add48$var$processProvide(instance) {
    return Reflect.ownKeys(instance.provides).map((key)=>({
            type: "provided",
            key: key.toString(),
            value: $a52fad25e66add48$var$returnError(()=>instance.provides[key])
        }));
}
function $a52fad25e66add48$var$processInject(instance, mergedType) {
    if (!(mergedType == null ? void 0 : mergedType.inject)) return [];
    let keys = [];
    let defaultValue;
    if (Array.isArray(mergedType.inject)) keys = mergedType.inject.map((key)=>({
            key: key,
            originalKey: key
        }));
    else keys = Reflect.ownKeys(mergedType.inject).map((key)=>{
        const value = mergedType.inject[key];
        let originalKey;
        if (typeof value === "string" || typeof value === "symbol") originalKey = value;
        else {
            originalKey = value.from;
            defaultValue = value.default;
        }
        return {
            key: key,
            originalKey: originalKey
        };
    });
    return keys.map(({ key: key, originalKey: originalKey })=>({
            type: "injected",
            key: originalKey && key !== originalKey ? `${originalKey.toString()} \u279E ${key.toString()}` : key.toString(),
            // eslint-disable-next-line no-prototype-builtins
            value: $a52fad25e66add48$var$returnError(()=>instance.ctx.hasOwnProperty(key) ? instance.ctx[key] : instance.provides.hasOwnProperty(originalKey) ? instance.provides[originalKey] : defaultValue)
        }));
}
function $a52fad25e66add48$var$processRefs(instance) {
    return Object.keys(instance.refs).map((key)=>({
            type: "template refs",
            key: key,
            value: $a52fad25e66add48$var$returnError(()=>instance.refs[key])
        }));
}
function $a52fad25e66add48$var$processEventListeners(instance) {
    var _a25, _b25;
    const emitsDefinition = instance.type.emits;
    const declaredEmits = Array.isArray(emitsDefinition) ? emitsDefinition : Object.keys(emitsDefinition != null ? emitsDefinition : {});
    const keys = Object.keys((_b25 = (_a25 = instance == null ? void 0 : instance.vnode) == null ? void 0 : _a25.props) != null ? _b25 : {});
    const result = [];
    for (const key of keys){
        const [prefix, ...eventNameParts] = key.split(/(?=[A-Z])/);
        if (prefix === "on") {
            const eventName = eventNameParts.join("-").toLowerCase();
            const isDeclared = declaredEmits.includes(eventName);
            result.push({
                type: "event listeners",
                key: eventName,
                value: {
                    _custom: {
                        displayText: isDeclared ? "\u2705 Declared" : "\u26A0\uFE0F Not declared",
                        key: isDeclared ? "\u2705 Declared" : "\u26A0\uFE0F Not declared",
                        value: isDeclared ? "\u2705 Declared" : "\u26A0\uFE0F Not declared",
                        tooltipText: !isDeclared ? `The event <code>${eventName}</code> is not declared in the <code>emits</code> option. It will leak into the component's attributes (<code>$attrs</code>).` : null
                    }
                }
            });
        }
    }
    return result;
}
function $a52fad25e66add48$var$processInstanceState(instance) {
    const mergedType = $a52fad25e66add48$var$resolveMergedOptions(instance);
    return $a52fad25e66add48$var$processProps(instance).concat($a52fad25e66add48$var$processState(instance), $a52fad25e66add48$var$processSetupState(instance), $a52fad25e66add48$var$processComputed(instance, mergedType), $a52fad25e66add48$var$processAttrs(instance), $a52fad25e66add48$var$processProvide(instance), $a52fad25e66add48$var$processInject(instance, mergedType), $a52fad25e66add48$var$processRefs(instance), $a52fad25e66add48$var$processEventListeners(instance));
}
// src/core/component/state/index.ts
function $a52fad25e66add48$var$getInstanceState(params) {
    var _a25;
    const instance = $a52fad25e66add48$var$getComponentInstance($a52fad25e66add48$export$162128841a7f2877.value, params.instanceId);
    const id = $a52fad25e66add48$var$getUniqueComponentId(instance);
    const name = $a52fad25e66add48$var$getInstanceName(instance);
    const file = (_a25 = instance == null ? void 0 : instance.type) == null ? void 0 : _a25.__file;
    const state = $a52fad25e66add48$var$processInstanceState(instance);
    return {
        id: id,
        name: name,
        file: file,
        state: state,
        instance: instance
    };
}
// src/core/component/tree/walker.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/component/tree/filter.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$ComponentFilter = class {
    constructor(filter){
        this.filter = filter || "";
    }
    /**
   * Check if an instance is qualified.
   *
   * @param {Vue|Vnode} instance
   * @return {boolean}
   */ isQualified(instance) {
        const name = $a52fad25e66add48$var$getInstanceName(instance);
        return (0, $gNtJt.classify)(name).toLowerCase().includes(this.filter) || (0, $gNtJt.kebabize)(name).toLowerCase().includes(this.filter);
    }
};
function $a52fad25e66add48$var$createComponentFilter(filterText) {
    return new $a52fad25e66add48$var$ComponentFilter(filterText);
}
// src/core/component/tree/walker.ts
var $a52fad25e66add48$var$ComponentWalker = class {
    constructor(options){
        // Dedupe instances (Some instances may be both on a component and on a child abstract/functional component)
        this.captureIds = /* @__PURE__ */ new Map();
        const { filterText: filterText = "", maxDepth: maxDepth, recursively: recursively, api: api } = options;
        this.componentFilter = $a52fad25e66add48$var$createComponentFilter(filterText);
        this.maxDepth = maxDepth;
        this.recursively = recursively;
        this.api = api;
    }
    getComponentTree(instance) {
        this.captureIds = /* @__PURE__ */ new Map();
        return this.findQualifiedChildren(instance, 0);
    }
    getComponentParents(instance) {
        this.captureIds = /* @__PURE__ */ new Map();
        const parents = [];
        this.captureId(instance);
        let parent = instance;
        while(parent = parent.parent){
            this.captureId(parent);
            parents.push(parent);
        }
        return parents;
    }
    captureId(instance) {
        if (!instance) return null;
        const id = instance.__VUE_DEVTOOLS_NEXT_UID__ != null ? instance.__VUE_DEVTOOLS_NEXT_UID__ : $a52fad25e66add48$var$getUniqueComponentId(instance);
        instance.__VUE_DEVTOOLS_NEXT_UID__ = id;
        if (this.captureIds.has(id)) return null;
        else this.captureIds.set(id, void 0);
        this.mark(instance);
        return id;
    }
    /**
   * Capture the meta information of an instance. (recursive)
   *
   * @param {Vue} instance
   * @return {object}
   */ async capture(instance, depth) {
        var _a25;
        if (!instance) return null;
        const id = this.captureId(instance);
        const name = $a52fad25e66add48$var$getInstanceName(instance);
        const children = this.getInternalInstanceChildren(instance.subTree).filter((child)=>!$a52fad25e66add48$var$isBeingDestroyed(child));
        const parents = this.getComponentParents(instance) || [];
        const inactive = !!instance.isDeactivated || parents.some((parent)=>parent.isDeactivated);
        const treeNode = {
            uid: instance.uid,
            id: id,
            name: name,
            renderKey: $a52fad25e66add48$var$getRenderKey(instance.vnode ? instance.vnode.key : null),
            inactive: inactive,
            children: [],
            isFragment: $a52fad25e66add48$var$isFragment(instance),
            tags: typeof instance.type !== "function" ? [] : [
                {
                    label: "functional",
                    textColor: 5592405,
                    backgroundColor: 15658734
                }
            ],
            autoOpen: this.recursively,
            file: instance.type.__file || ""
        };
        if (depth < this.maxDepth || instance.type.__isKeepAlive || parents.some((parent)=>parent.type.__isKeepAlive)) treeNode.children = await Promise.all(children.map((child)=>this.capture(child, depth + 1)).filter(Boolean));
        if (this.isKeepAlive(instance)) {
            const cachedComponents = this.getKeepAliveCachedInstances(instance);
            const childrenIds = children.map((child)=>child.__VUE_DEVTOOLS_NEXT_UID__);
            for (const cachedChild of cachedComponents)if (!childrenIds.includes(cachedChild.__VUE_DEVTOOLS_NEXT_UID__)) {
                const node = await this.capture({
                    ...cachedChild,
                    isDeactivated: true
                }, depth + 1);
                if (node) treeNode.children.push(node);
            }
        }
        const rootElements = $a52fad25e66add48$var$getRootElementsFromComponentInstance(instance);
        const firstElement = rootElements[0];
        if (firstElement == null ? void 0 : firstElement.parentElement) {
            const parentInstance = instance.parent;
            const parentRootElements = parentInstance ? $a52fad25e66add48$var$getRootElementsFromComponentInstance(parentInstance) : [];
            let el = firstElement;
            const indexList = [];
            do {
                indexList.push(Array.from(el.parentElement.childNodes).indexOf(el));
                el = el.parentElement;
            }while (el.parentElement && parentRootElements.length && !parentRootElements.includes(el));
            treeNode.domOrder = indexList.reverse();
        } else treeNode.domOrder = [
            -1
        ];
        if ((_a25 = instance.suspense) == null ? void 0 : _a25.suspenseKey) {
            treeNode.tags.push({
                label: instance.suspense.suspenseKey,
                backgroundColor: 14979812,
                textColor: 16777215
            });
            this.mark(instance, true);
        }
        this.api.visitComponentTree({
            treeNode: treeNode,
            componentInstance: instance,
            app: instance.appContext.app,
            filter: this.componentFilter.filter
        });
        return treeNode;
    }
    /**
   * Find qualified children from a single instance.
   * If the instance itself is qualified, just return itself.
   * This is ok because [].concat works in both cases.
   *
   * @param {Vue|Vnode} instance
   * @return {Vue|Array}
   */ async findQualifiedChildren(instance, depth) {
        var _a25;
        if (this.componentFilter.isQualified(instance) && !((_a25 = instance.type.devtools) == null ? void 0 : _a25.hide)) return [
            await this.capture(instance, depth)
        ];
        else if (instance.subTree) {
            const list = this.isKeepAlive(instance) ? this.getKeepAliveCachedInstances(instance) : this.getInternalInstanceChildren(instance.subTree);
            return this.findQualifiedChildrenFromList(list, depth);
        } else return [];
    }
    /**
   * Iterate through an array of instances and flatten it into
   * an array of qualified instances. This is a depth-first
   * traversal - e.g. if an instance is not matched, we will
   * recursively go deeper until a qualified child is found.
   *
   * @param {Array} instances
   * @return {Array}
   */ async findQualifiedChildrenFromList(instances, depth) {
        instances = instances.filter((child)=>{
            var _a25;
            return !$a52fad25e66add48$var$isBeingDestroyed(child) && !((_a25 = child.type.devtools) == null ? void 0 : _a25.hide);
        });
        if (!this.componentFilter.filter) return Promise.all(instances.map((child)=>this.capture(child, depth)));
        else return Array.prototype.concat.apply([], await Promise.all(instances.map((i)=>this.findQualifiedChildren(i, depth))));
    }
    /**
   * Get children from a component instance.
   */ getInternalInstanceChildren(subTree, suspense = null) {
        const list = [];
        if (subTree) {
            if (subTree.component) !suspense ? list.push(subTree.component) : list.push({
                ...subTree.component,
                suspense: suspense
            });
            else if (subTree.suspense) {
                const suspenseKey = !subTree.suspense.isInFallback ? "suspense default" : "suspense fallback";
                list.push(...this.getInternalInstanceChildren(subTree.suspense.activeBranch, {
                    ...subTree.suspense,
                    suspenseKey: suspenseKey
                }));
            } else if (Array.isArray(subTree.children)) subTree.children.forEach((childSubTree)=>{
                if (childSubTree.component) !suspense ? list.push(childSubTree.component) : list.push({
                    ...childSubTree.component,
                    suspense: suspense
                });
                else list.push(...this.getInternalInstanceChildren(childSubTree, suspense));
            });
        }
        return list.filter((child)=>{
            var _a25;
            return !$a52fad25e66add48$var$isBeingDestroyed(child) && !((_a25 = child.type.devtools) == null ? void 0 : _a25.hide);
        });
    }
    /**
   * Mark an instance as captured and store it in the instance map.
   *
   * @param {Vue} instance
   */ mark(instance, force = false) {
        const instanceMap = $a52fad25e66add48$var$getAppRecord(instance).instanceMap;
        if (force || !instanceMap.has(instance.__VUE_DEVTOOLS_NEXT_UID__)) {
            instanceMap.set(instance.__VUE_DEVTOOLS_NEXT_UID__, instance);
            $a52fad25e66add48$export$162128841a7f2877.value.instanceMap = instanceMap;
        }
    }
    isKeepAlive(instance) {
        return instance.type.__isKeepAlive && instance.__v_cache;
    }
    getKeepAliveCachedInstances(instance) {
        return Array.from(instance.__v_cache.values()).map((vnode)=>vnode.component).filter(Boolean);
    }
};
// src/core/timeline/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/timeline/perf.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$markEndQueue = /* @__PURE__ */ new Map();
var $a52fad25e66add48$var$PERFORMANCE_EVENT_LAYER_ID = "performance";
async function $a52fad25e66add48$var$performanceMarkStart(api, app, uid, vm, type, time) {
    const appRecord = await $a52fad25e66add48$var$getAppRecord(app);
    if (!appRecord) return;
    const componentName = $a52fad25e66add48$var$getInstanceName(vm) || "Unknown Component";
    const groupId = $a52fad25e66add48$export$a67dd585df937baa.perfUniqueGroupId++;
    const groupKey = `${uid}-${type}`;
    appRecord.perfGroupIds.set(groupKey, {
        groupId: groupId,
        time: time
    });
    await api.addTimelineEvent({
        layerId: $a52fad25e66add48$var$PERFORMANCE_EVENT_LAYER_ID,
        event: {
            time: Date.now(),
            data: {
                component: componentName,
                type: type,
                measure: "start"
            },
            title: componentName,
            subtitle: type,
            groupId: groupId
        }
    });
    if ($a52fad25e66add48$var$markEndQueue.has(groupKey)) {
        const { app: app2, uid: uid2, instance: instance, type: type2, time: time2 } = $a52fad25e66add48$var$markEndQueue.get(groupKey);
        $a52fad25e66add48$var$markEndQueue.delete(groupKey);
        await $a52fad25e66add48$var$performanceMarkEnd(api, app2, uid2, instance, type2, time2);
    }
}
function $a52fad25e66add48$var$performanceMarkEnd(api, app, uid, vm, type, time) {
    const appRecord = $a52fad25e66add48$var$getAppRecord(app);
    if (!appRecord) return;
    const componentName = $a52fad25e66add48$var$getInstanceName(vm) || "Unknown Component";
    const groupKey = `${uid}-${type}`;
    const groupInfo = appRecord.perfGroupIds.get(groupKey);
    if (groupInfo) {
        const groupId = groupInfo.groupId;
        const startTime = groupInfo.time;
        const duration = time - startTime;
        api.addTimelineEvent({
            layerId: $a52fad25e66add48$var$PERFORMANCE_EVENT_LAYER_ID,
            event: {
                time: Date.now(),
                data: {
                    component: componentName,
                    type: type,
                    measure: "end",
                    duration: {
                        _custom: {
                            type: "Duration",
                            value: duration,
                            display: `${duration} ms`
                        }
                    }
                },
                title: componentName,
                subtitle: type,
                groupId: groupId
            }
        });
    } else $a52fad25e66add48$var$markEndQueue.set(groupKey, {
        app: app,
        uid: uid,
        instance: vm,
        type: type,
        time: time
    });
}
// src/core/timeline/index.ts
var $a52fad25e66add48$var$COMPONENT_EVENT_LAYER_ID = "component-event";
function $a52fad25e66add48$var$setupBuiltinTimelineLayers(api) {
    if (!(0, $gNtJt.isBrowser)) return;
    api.addTimelineLayer({
        id: "mouse",
        label: "Mouse",
        color: 10768815
    });
    [
        "mousedown",
        "mouseup",
        "click",
        "dblclick"
    ].forEach((eventType)=>{
        if (!$a52fad25e66add48$export$a67dd585df937baa.timelineLayersState.recordingState || !$a52fad25e66add48$export$a67dd585df937baa.timelineLayersState.mouseEventEnabled) return;
        window.addEventListener(eventType, async (event)=>{
            await api.addTimelineEvent({
                layerId: "mouse",
                event: {
                    time: Date.now(),
                    data: {
                        type: eventType,
                        x: event.clientX,
                        y: event.clientY
                    },
                    title: eventType
                }
            });
        }, {
            capture: true,
            passive: true
        });
    });
    api.addTimelineLayer({
        id: "keyboard",
        label: "Keyboard",
        color: 8475055
    });
    [
        "keyup",
        "keydown",
        "keypress"
    ].forEach((eventType)=>{
        window.addEventListener(eventType, async (event)=>{
            if (!$a52fad25e66add48$export$a67dd585df937baa.timelineLayersState.recordingState || !$a52fad25e66add48$export$a67dd585df937baa.timelineLayersState.keyboardEventEnabled) return;
            await api.addTimelineEvent({
                layerId: "keyboard",
                event: {
                    time: Date.now(),
                    data: {
                        type: eventType,
                        key: event.key,
                        ctrlKey: event.ctrlKey,
                        shiftKey: event.shiftKey,
                        altKey: event.altKey,
                        metaKey: event.metaKey
                    },
                    title: event.key
                }
            });
        }, {
            capture: true,
            passive: true
        });
    });
    api.addTimelineLayer({
        id: $a52fad25e66add48$var$COMPONENT_EVENT_LAYER_ID,
        label: "Component events",
        color: 5226637
    });
    $a52fad25e66add48$var$hook.on.componentEmit(async (app, instance, event, params)=>{
        if (!$a52fad25e66add48$export$a67dd585df937baa.timelineLayersState.recordingState || !$a52fad25e66add48$export$a67dd585df937baa.timelineLayersState.componentEventEnabled) return;
        const appRecord = await $a52fad25e66add48$var$getAppRecord(app);
        if (!appRecord) return;
        const componentId = `${appRecord.id}:${instance.uid}`;
        const componentName = $a52fad25e66add48$var$getInstanceName(instance) || "Unknown Component";
        api.addTimelineEvent({
            layerId: $a52fad25e66add48$var$COMPONENT_EVENT_LAYER_ID,
            event: {
                time: Date.now(),
                data: {
                    component: {
                        _custom: {
                            type: "component-definition",
                            display: componentName
                        }
                    },
                    event: event,
                    params: params
                },
                title: event,
                subtitle: `by ${componentName}`,
                meta: {
                    componentId: componentId
                }
            }
        });
    });
    api.addTimelineLayer({
        id: "performance",
        label: $a52fad25e66add48$var$PERFORMANCE_EVENT_LAYER_ID,
        color: 4307050
    });
    $a52fad25e66add48$var$hook.on.perfStart((app, uid, vm, type, time)=>{
        if (!$a52fad25e66add48$export$a67dd585df937baa.timelineLayersState.recordingState || !$a52fad25e66add48$export$a67dd585df937baa.timelineLayersState.performanceEventEnabled) return;
        $a52fad25e66add48$var$performanceMarkStart(api, app, uid, vm, type, time);
    });
    $a52fad25e66add48$var$hook.on.perfEnd((app, uid, vm, type, time)=>{
        if (!$a52fad25e66add48$export$a67dd585df937baa.timelineLayersState.recordingState || !$a52fad25e66add48$export$a67dd585df937baa.timelineLayersState.performanceEventEnabled) return;
        $a52fad25e66add48$var$performanceMarkEnd(api, app, uid, vm, type, time);
    });
}
// src/core/vm/index.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$MAX_$VM = 10;
var $a52fad25e66add48$var$$vmQueue = [];
function $a52fad25e66add48$var$exposeInstanceToWindow(componentInstance) {
    if (typeof window === "undefined") return;
    const win = window;
    if (!componentInstance) return;
    win.$vm = componentInstance;
    if ($a52fad25e66add48$var$$vmQueue[0] !== componentInstance) {
        if ($a52fad25e66add48$var$$vmQueue.length >= $a52fad25e66add48$var$MAX_$VM) $a52fad25e66add48$var$$vmQueue.pop();
        for(let i = $a52fad25e66add48$var$$vmQueue.length; i > 0; i--)win[`$vm${i}`] = $a52fad25e66add48$var$$vmQueue[i] = $a52fad25e66add48$var$$vmQueue[i - 1];
        win.$vm0 = $a52fad25e66add48$var$$vmQueue[0] = componentInstance;
    }
}
// src/core/plugin/components.ts
var $a52fad25e66add48$var$INSPECTOR_ID = "components";
function $a52fad25e66add48$export$7e5554ded389d004(app) {
    const descriptor = {
        id: $a52fad25e66add48$var$INSPECTOR_ID,
        label: "Components",
        app: app
    };
    const setupFn = (api)=>{
        api.addInspector({
            id: $a52fad25e66add48$var$INSPECTOR_ID,
            label: "Components",
            treeFilterPlaceholder: "Search components"
        });
        $a52fad25e66add48$var$setupBuiltinTimelineLayers(api);
        api.on.getInspectorTree(async (payload)=>{
            if (payload.app === app && payload.inspectorId === $a52fad25e66add48$var$INSPECTOR_ID) {
                const instance = $a52fad25e66add48$var$getComponentInstance($a52fad25e66add48$export$162128841a7f2877.value, payload.instanceId);
                if (instance) {
                    const walker2 = new $a52fad25e66add48$var$ComponentWalker({
                        filterText: payload.filter,
                        // @TODO: should make this configurable?
                        maxDepth: 100,
                        recursively: false,
                        api: api
                    });
                    payload.rootNodes = await walker2.getComponentTree(instance);
                }
            }
        });
        api.on.getInspectorState(async (payload)=>{
            var _a25;
            if (payload.app === app && payload.inspectorId === $a52fad25e66add48$var$INSPECTOR_ID) {
                const result = $a52fad25e66add48$var$getInstanceState({
                    instanceId: payload.nodeId
                });
                const componentInstance = result.instance;
                const app2 = (_a25 = result.instance) == null ? void 0 : _a25.appContext.app;
                const _payload = {
                    componentInstance: componentInstance,
                    app: app2,
                    instanceData: result
                };
                $a52fad25e66add48$export$4f1904c03898171b.hooks.callHookWith((callbacks)=>{
                    callbacks.forEach((cb)=>cb(_payload));
                }, "inspectComponent" /* INSPECT_COMPONENT */ );
                payload.state = result;
                $a52fad25e66add48$var$exposeInstanceToWindow(componentInstance);
            }
        });
        api.on.editInspectorState(async (payload)=>{
            if (payload.app === app && payload.inspectorId === $a52fad25e66add48$var$INSPECTOR_ID) {
                $a52fad25e66add48$var$editState(payload);
                await api.sendInspectorState("components");
            }
        });
        const debounceSendInspectorTree = (0, $bV4bh.debounce)(()=>{
            api.sendInspectorTree($a52fad25e66add48$var$INSPECTOR_ID);
        }, 120);
        const debounceSendInspectorState = (0, $bV4bh.debounce)(()=>{
            api.sendInspectorState($a52fad25e66add48$var$INSPECTOR_ID);
        }, 120);
        const componentAddedCleanup = $a52fad25e66add48$var$hook.on.componentAdded(async (app2, uid, parentUid, component)=>{
            var _a25, _b25, _c;
            if ($a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
            if ((_c = (_b25 = (_a25 = app2 == null ? void 0 : app2._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) return;
            if (!app2 || typeof uid !== "number" && !uid || !component) return;
            const id = await $a52fad25e66add48$var$getComponentId({
                app: app2,
                uid: uid,
                instance: component
            });
            const appRecord = await $a52fad25e66add48$var$getAppRecord(app2);
            if (component) {
                if (component.__VUE_DEVTOOLS_NEXT_UID__ == null) component.__VUE_DEVTOOLS_NEXT_UID__ = id;
                if (!(appRecord == null ? void 0 : appRecord.instanceMap.has(id))) {
                    appRecord == null || appRecord.instanceMap.set(id, component);
                    if ($a52fad25e66add48$export$162128841a7f2877.value.id === (appRecord == null ? void 0 : appRecord.id)) $a52fad25e66add48$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                }
            }
            if (!appRecord) return;
            debounceSendInspectorTree();
        });
        const componentUpdatedCleanup = $a52fad25e66add48$var$hook.on.componentUpdated(async (app2, uid, parentUid, component)=>{
            var _a25, _b25, _c;
            if ($a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
            if ((_c = (_b25 = (_a25 = app2 == null ? void 0 : app2._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) return;
            if (!app2 || typeof uid !== "number" && !uid || !component) return;
            const id = await $a52fad25e66add48$var$getComponentId({
                app: app2,
                uid: uid,
                instance: component
            });
            const appRecord = await $a52fad25e66add48$var$getAppRecord(app2);
            if (component) {
                if (component.__VUE_DEVTOOLS_NEXT_UID__ == null) component.__VUE_DEVTOOLS_NEXT_UID__ = id;
                if (!(appRecord == null ? void 0 : appRecord.instanceMap.has(id))) {
                    appRecord == null || appRecord.instanceMap.set(id, component);
                    if ($a52fad25e66add48$export$162128841a7f2877.value.id === (appRecord == null ? void 0 : appRecord.id)) $a52fad25e66add48$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                }
            }
            if (!appRecord) return;
            debounceSendInspectorTree();
            debounceSendInspectorState();
        });
        const componentRemovedCleanup = $a52fad25e66add48$var$hook.on.componentRemoved(async (app2, uid, parentUid, component)=>{
            var _a25, _b25, _c;
            if ($a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
            if ((_c = (_b25 = (_a25 = app2 == null ? void 0 : app2._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) return;
            if (!app2 || typeof uid !== "number" && !uid || !component) return;
            const appRecord = await $a52fad25e66add48$var$getAppRecord(app2);
            if (!appRecord) return;
            const id = await $a52fad25e66add48$var$getComponentId({
                app: app2,
                uid: uid,
                instance: component
            });
            appRecord == null || appRecord.instanceMap.delete(id);
            if ($a52fad25e66add48$export$162128841a7f2877.value.id === (appRecord == null ? void 0 : appRecord.id)) $a52fad25e66add48$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
            debounceSendInspectorTree();
        });
    };
    return [
        descriptor,
        setupFn
    ];
}
// src/core/plugin/index.ts
var $a52fad25e66add48$var$_a12, $a52fad25e66add48$var$_b12;
($a52fad25e66add48$var$_b12 = ($a52fad25e66add48$var$_a12 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__) != null ? $a52fad25e66add48$var$_b12 : $a52fad25e66add48$var$_a12.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ = /* @__PURE__ */ new Set();
function $a52fad25e66add48$export$1f0daed17c8e64f(pluginDescriptor, setupFn) {
    return $a52fad25e66add48$var$hook.setupDevToolsPlugin(pluginDescriptor, setupFn);
}
function $a52fad25e66add48$export$873c261f47a243e7(plugin, app) {
    const [pluginDescriptor, setupFn] = plugin;
    if (pluginDescriptor.app !== app) return;
    const api = new $a52fad25e66add48$var$DevToolsPluginAPI({
        plugin: {
            setupFn: setupFn,
            descriptor: pluginDescriptor
        },
        ctx: $a52fad25e66add48$export$4f1904c03898171b
    });
    if (pluginDescriptor.packageName === "vuex") api.on.editInspectorState((payload)=>{
        api.sendInspectorState(payload.inspectorId);
    });
    setupFn(api);
}
function $a52fad25e66add48$export$7f52963080ec618f(app) {
    (0, $gNtJt.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.delete(app);
}
function $a52fad25e66add48$export$c357c87447719db2(app, options) {
    if ((0, $gNtJt.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.has(app)) return;
    if ($a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled && !(options == null ? void 0 : options.inspectingComponent)) return;
    (0, $gNtJt.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.add(app);
    $a52fad25e66add48$export$df02dcb86618c10f.forEach((plugin)=>{
        $a52fad25e66add48$export$873c261f47a243e7(plugin, app);
    });
}
// src/core/router/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/ctx/router.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$export$57206cad6442cbbb = "__VUE_DEVTOOLS_ROUTER__";
var $a52fad25e66add48$export$bcb936c2c1e0b8ba = "__VUE_DEVTOOLS_ROUTER_INFO__";
var $a52fad25e66add48$var$_a13, $a52fad25e66add48$var$_b13;
($a52fad25e66add48$var$_b13 = ($a52fad25e66add48$var$_a13 = (0, $gNtJt.target))[$a52fad25e66add48$export$bcb936c2c1e0b8ba]) != null ? $a52fad25e66add48$var$_b13 : $a52fad25e66add48$var$_a13[$a52fad25e66add48$export$bcb936c2c1e0b8ba] = {
    currentRoute: null,
    routes: []
};
var $a52fad25e66add48$var$_a14, $a52fad25e66add48$var$_b14;
($a52fad25e66add48$var$_b14 = ($a52fad25e66add48$var$_a14 = (0, $gNtJt.target))[$a52fad25e66add48$export$57206cad6442cbbb]) != null ? $a52fad25e66add48$var$_b14 : $a52fad25e66add48$var$_a14[$a52fad25e66add48$export$57206cad6442cbbb] = {};
var $a52fad25e66add48$export$10a28a01c0e59bea = new Proxy((0, $gNtJt.target)[$a52fad25e66add48$export$bcb936c2c1e0b8ba], {
    get (target22, property) {
        return (0, $gNtJt.target)[$a52fad25e66add48$export$bcb936c2c1e0b8ba][property];
    }
});
var $a52fad25e66add48$export$73b6e4968c970971 = new Proxy((0, $gNtJt.target)[$a52fad25e66add48$export$57206cad6442cbbb], {
    get (target22, property) {
        if (property === "value") return (0, $gNtJt.target)[$a52fad25e66add48$export$57206cad6442cbbb];
    }
});
// src/core/router/index.ts
function $a52fad25e66add48$var$getRoutes(router) {
    const routesMap = /* @__PURE__ */ new Map();
    return ((router == null ? void 0 : router.getRoutes()) || []).filter((i)=>!routesMap.has(i.path) && routesMap.set(i.path, 1));
}
function $a52fad25e66add48$var$filterRoutes(routes) {
    return routes.map((item)=>{
        let { path: path, name: name, children: children, meta: meta } = item;
        if (children == null ? void 0 : children.length) children = $a52fad25e66add48$var$filterRoutes(children);
        return {
            path: path,
            name: name,
            children: children,
            meta: meta
        };
    });
}
function $a52fad25e66add48$var$filterCurrentRoute(route) {
    if (route) {
        const { fullPath: fullPath, hash: hash, href: href, path: path, name: name, matched: matched, params: params, query: query } = route;
        return {
            fullPath: fullPath,
            hash: hash,
            href: href,
            path: path,
            name: name,
            params: params,
            query: query,
            matched: $a52fad25e66add48$var$filterRoutes(matched)
        };
    }
    return route;
}
function $a52fad25e66add48$var$normalizeRouterInfo(appRecord, activeAppRecord2) {
    function init() {
        var _a25;
        const router = (_a25 = appRecord.app) == null ? void 0 : _a25.config.globalProperties.$router;
        const currentRoute = $a52fad25e66add48$var$filterCurrentRoute(router == null ? void 0 : router.currentRoute.value);
        const routes = $a52fad25e66add48$var$filterRoutes($a52fad25e66add48$var$getRoutes(router));
        const c = console.warn;
        console.warn = ()=>{};
        (0, $gNtJt.target)[$a52fad25e66add48$export$bcb936c2c1e0b8ba] = {
            currentRoute: currentRoute ? (0, $gNtJt.deepClone)(currentRoute) : {},
            routes: (0, $gNtJt.deepClone)(routes)
        };
        (0, $gNtJt.target)[$a52fad25e66add48$export$57206cad6442cbbb] = router;
        console.warn = c;
    }
    init();
    $a52fad25e66add48$var$hook.on.componentUpdated((0, $bV4bh.debounce)(()=>{
        var _a25;
        if (((_a25 = activeAppRecord2.value) == null ? void 0 : _a25.app) !== appRecord.app) return;
        init();
        if ($a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled) return;
        $a52fad25e66add48$export$4f1904c03898171b.hooks.callHook("routerInfoUpdated" /* ROUTER_INFO_UPDATED */ , {
            state: (0, $gNtJt.target)[$a52fad25e66add48$export$bcb936c2c1e0b8ba]
        });
    }, 200));
}
// src/ctx/api.ts
function $a52fad25e66add48$export$bb51459158adb36b(hooks2) {
    return {
        // get inspector tree
        async getInspectorTree (payload) {
            const _payload = {
                ...payload,
                app: $a52fad25e66add48$export$162128841a7f2877.value.app,
                rootNodes: []
            };
            await new Promise((resolve)=>{
                hooks2.callHookWith(async (callbacks)=>{
                    await Promise.all(callbacks.map((cb)=>cb(_payload)));
                    resolve();
                }, "getInspectorTree" /* GET_INSPECTOR_TREE */ );
            });
            return _payload.rootNodes;
        },
        // get inspector state
        async getInspectorState (payload) {
            const _payload = {
                ...payload,
                app: $a52fad25e66add48$export$162128841a7f2877.value.app,
                state: null
            };
            const ctx = {
                currentTab: `custom-inspector:${payload.inspectorId}`
            };
            await new Promise((resolve)=>{
                hooks2.callHookWith(async (callbacks)=>{
                    await Promise.all(callbacks.map((cb)=>cb(_payload, ctx)));
                    resolve();
                }, "getInspectorState" /* GET_INSPECTOR_STATE */ );
            });
            return _payload.state;
        },
        // edit inspector state
        editInspectorState (payload) {
            const stateEditor2 = new $a52fad25e66add48$var$StateEditor();
            const _payload = {
                ...payload,
                app: $a52fad25e66add48$export$162128841a7f2877.value.app,
                set: (obj, path = payload.path, value = payload.state.value, cb)=>{
                    stateEditor2.set(obj, path, value, cb || stateEditor2.createDefaultSetCallback(payload.state));
                }
            };
            hooks2.callHookWith((callbacks)=>{
                callbacks.forEach((cb)=>cb(_payload));
            }, "editInspectorState" /* EDIT_INSPECTOR_STATE */ );
        },
        // send inspector state
        sendInspectorState (inspectorId) {
            const inspector = $a52fad25e66add48$export$aa4140d0f5ce4bbe(inspectorId);
            hooks2.callHook("sendInspectorState" /* SEND_INSPECTOR_STATE */ , {
                inspectorId: inspectorId,
                plugin: {
                    descriptor: inspector.descriptor,
                    setupFn: ()=>({})
                }
            });
        },
        // inspect component inspector
        inspectComponentInspector () {
            return $a52fad25e66add48$var$inspectComponentHighLighter();
        },
        // cancel inspect component inspector
        cancelInspectComponentInspector () {
            return $a52fad25e66add48$var$cancelInspectComponentHighLighter();
        },
        // get component render code
        getComponentRenderCode (id) {
            const instance = $a52fad25e66add48$var$getComponentInstance($a52fad25e66add48$export$162128841a7f2877.value, id);
            if (instance) return !(typeof (instance == null ? void 0 : instance.type) === "function") ? instance.render.toString() : instance.type.toString();
        },
        // scroll to component
        scrollToComponent (id) {
            return $a52fad25e66add48$var$scrollToComponent({
                id: id
            });
        },
        openInEditor: // open in editor
        $a52fad25e66add48$var$openInEditor,
        // get vue inspector
        getVueInspector: $a52fad25e66add48$var$getComponentInspector,
        // toggle app
        toggleApp (id, options) {
            const appRecord = $a52fad25e66add48$export$d3c0473489b1d63b.value.find((record)=>record.id === id);
            if (appRecord) {
                $a52fad25e66add48$export$1a7804ab8d8511d1(id);
                $a52fad25e66add48$export$1574774def61bdf9(appRecord);
                $a52fad25e66add48$var$normalizeRouterInfo(appRecord, $a52fad25e66add48$export$162128841a7f2877);
                $a52fad25e66add48$export$17f8005932e80cc0();
                $a52fad25e66add48$export$c357c87447719db2(appRecord.app, options);
            }
        },
        // inspect dom
        inspectDOM (instanceId) {
            const instance = $a52fad25e66add48$var$getComponentInstance($a52fad25e66add48$export$162128841a7f2877.value, instanceId);
            if (instance) {
                const [el] = $a52fad25e66add48$var$getRootElementsFromComponentInstance(instance);
                if (el) (0, $gNtJt.target).__VUE_DEVTOOLS_INSPECT_DOM_TARGET__ = el;
            }
        },
        updatePluginSettings (pluginId, key, value) {
            $a52fad25e66add48$var$setPluginSettings(pluginId, key, value);
        },
        getPluginSettings (pluginId) {
            return {
                options: $a52fad25e66add48$var$getPluginSettingsOptions(pluginId),
                values: $a52fad25e66add48$var$getPluginSettings(pluginId)
            };
        }
    };
}
// src/ctx/env.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$_a15, $a52fad25e66add48$var$_b15;
($a52fad25e66add48$var$_b15 = ($a52fad25e66add48$var$_a15 = (0, $gNtJt.target)).__VUE_DEVTOOLS_ENV__) != null ? $a52fad25e66add48$var$_b15 : $a52fad25e66add48$var$_a15.__VUE_DEVTOOLS_ENV__ = {
    vitePluginDetected: false
};
function $a52fad25e66add48$export$6fcf3c68ecb51939() {
    return (0, $gNtJt.target).__VUE_DEVTOOLS_ENV__;
}
function $a52fad25e66add48$export$b209b470d7c4ea55(env) {
    (0, $gNtJt.target).__VUE_DEVTOOLS_ENV__ = {
        ...(0, $gNtJt.target).__VUE_DEVTOOLS_ENV__,
        ...env
    };
}
// src/ctx/index.ts
var $a52fad25e66add48$var$hooks = $a52fad25e66add48$export$73be3ac6032ad9bb();
var $a52fad25e66add48$var$_a16, $a52fad25e66add48$var$_b16;
($a52fad25e66add48$var$_b16 = ($a52fad25e66add48$var$_a16 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_CONTEXT__) != null ? $a52fad25e66add48$var$_b16 : $a52fad25e66add48$var$_a16.__VUE_DEVTOOLS_KIT_CONTEXT__ = {
    hooks: $a52fad25e66add48$var$hooks,
    get state () {
        return {
            ...$a52fad25e66add48$export$a67dd585df937baa,
            activeAppRecordId: $a52fad25e66add48$export$162128841a7f2877.id,
            activeAppRecord: $a52fad25e66add48$export$162128841a7f2877.value,
            appRecords: $a52fad25e66add48$export$d3c0473489b1d63b.value
        };
    },
    api: $a52fad25e66add48$export$bb51459158adb36b($a52fad25e66add48$var$hooks)
};
var $a52fad25e66add48$export$4f1904c03898171b = (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_CONTEXT__;
// src/core/app/index.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$import_speakingurl = $a52fad25e66add48$var$__toESM($a52fad25e66add48$var$require_speakingurl2(), 1);
var $a52fad25e66add48$var$_a17, $a52fad25e66add48$var$_b17;
var $a52fad25e66add48$var$appRecordInfo = ($a52fad25e66add48$var$_b17 = ($a52fad25e66add48$var$_a17 = (0, $gNtJt.target)).__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__) != null ? $a52fad25e66add48$var$_b17 : $a52fad25e66add48$var$_a17.__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ = {
    id: 0,
    appIds: /* @__PURE__ */ new Set()
};
function $a52fad25e66add48$var$getAppRecordName(app, fallbackName) {
    var _a25;
    return ((_a25 = app == null ? void 0 : app._component) == null ? void 0 : _a25.name) || `App ${fallbackName}`;
}
function $a52fad25e66add48$var$getAppRootInstance(app) {
    var _a25, _b25, _c, _d;
    if (app._instance) return app._instance;
    else if ((_b25 = (_a25 = app._container) == null ? void 0 : _a25._vnode) == null ? void 0 : _b25.component) return (_d = (_c = app._container) == null ? void 0 : _c._vnode) == null ? void 0 : _d.component;
}
function $a52fad25e66add48$var$removeAppRecordId(app) {
    const id = app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    if (id != null) {
        $a52fad25e66add48$var$appRecordInfo.appIds.delete(id);
        $a52fad25e66add48$var$appRecordInfo.id--;
    }
}
function $a52fad25e66add48$var$getAppRecordId(app, defaultId) {
    if (app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ != null) return app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    let id = defaultId != null ? defaultId : ($a52fad25e66add48$var$appRecordInfo.id++).toString();
    if (defaultId && $a52fad25e66add48$var$appRecordInfo.appIds.has(id)) {
        let count = 1;
        while($a52fad25e66add48$var$appRecordInfo.appIds.has(`${defaultId}_${count}`))count++;
        id = `${defaultId}_${count}`;
    }
    $a52fad25e66add48$var$appRecordInfo.appIds.add(id);
    app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ = id;
    return id;
}
function $a52fad25e66add48$var$createAppRecord(app, types) {
    var _a25, _b25;
    const rootInstance = $a52fad25e66add48$var$getAppRootInstance(app);
    if (rootInstance) {
        $a52fad25e66add48$var$appRecordInfo.id++;
        const name = $a52fad25e66add48$var$getAppRecordName(app, $a52fad25e66add48$var$appRecordInfo.id.toString());
        const id = $a52fad25e66add48$var$getAppRecordId(app, (0, $a52fad25e66add48$var$import_speakingurl.default)(name));
        const [el] = $a52fad25e66add48$var$getRootElementsFromComponentInstance(rootInstance);
        const record = {
            id: id,
            name: name,
            types: types,
            instanceMap: /* @__PURE__ */ new Map(),
            perfGroupIds: /* @__PURE__ */ new Map(),
            rootInstance: rootInstance,
            iframe: (0, $gNtJt.isBrowser) && document !== (el == null ? void 0 : el.ownerDocument) ? (_b25 = (_a25 = el == null ? void 0 : el.ownerDocument) == null ? void 0 : _a25.location) == null ? void 0 : _b25.pathname : void 0
        };
        app.__VUE_DEVTOOLS_NEXT_APP_RECORD__ = record;
        const rootId = `${record.id}:root`;
        record.instanceMap.set(rootId, record.rootInstance);
        record.rootInstance.__VUE_DEVTOOLS_NEXT_UID__ = rootId;
        return record;
    } else return {};
}
// src/core/iframe/index.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$detectIframeApp(target22, inIframe = false) {
    if (inIframe) {
        let sendEventToParent2 = function(cb) {
            try {
                const hook3 = window.parent.__VUE_DEVTOOLS_GLOBAL_HOOK__;
                if (hook3) cb(hook3);
            } catch (e) {}
        };
        var sendEventToParent = sendEventToParent2;
        const hook2 = {
            id: "vue-devtools-next",
            devtoolsVersion: "7.0",
            on: (event, cb)=>{
                sendEventToParent2((hook3)=>{
                    hook3.on(event, cb);
                });
            },
            once: (event, cb)=>{
                sendEventToParent2((hook3)=>{
                    hook3.once(event, cb);
                });
            },
            off: (event, cb)=>{
                sendEventToParent2((hook3)=>{
                    hook3.off(event, cb);
                });
            },
            emit: (event, ...payload)=>{
                sendEventToParent2((hook3)=>{
                    hook3.emit(event, ...payload);
                });
            }
        };
        Object.defineProperty(target22, "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
            get () {
                return hook2;
            },
            configurable: true
        });
    }
    function injectVueHookToIframe(iframe) {
        if (iframe.__vdevtools__injected) return;
        try {
            iframe.__vdevtools__injected = true;
            const inject = ()=>{
                try {
                    iframe.contentWindow.__VUE_DEVTOOLS_IFRAME__ = iframe;
                    const script = iframe.contentDocument.createElement("script");
                    script.textContent = `;(${$a52fad25e66add48$var$detectIframeApp.toString()})(window, true)`;
                    iframe.contentDocument.documentElement.appendChild(script);
                    script.parentNode.removeChild(script);
                } catch (e) {}
            };
            inject();
            iframe.addEventListener("load", ()=>inject());
        } catch (e) {}
    }
    function injectVueHookToIframes() {
        if (typeof window === "undefined") return;
        const iframes = Array.from(document.querySelectorAll("iframe:not([data-vue-devtools-ignore])"));
        for (const iframe of iframes)injectVueHookToIframe(iframe);
    }
    injectVueHookToIframes();
    let iframeAppChecks = 0;
    const iframeAppCheckTimer = setInterval(()=>{
        injectVueHookToIframes();
        iframeAppChecks++;
        if (iframeAppChecks >= 5) clearInterval(iframeAppCheckTimer);
    }, 1e3);
}
// src/core/index.ts
function $a52fad25e66add48$export$93f430585c3f6d11() {
    var _a25;
    $a52fad25e66add48$var$detectIframeApp((0, $gNtJt.target));
    $a52fad25e66add48$export$ee22a7aaf6b41ce2({
        vitePluginDetected: $a52fad25e66add48$export$6fcf3c68ecb51939().vitePluginDetected
    });
    const isDevToolsNext = ((_a25 = (0, $gNtJt.target).__VUE_DEVTOOLS_GLOBAL_HOOK__) == null ? void 0 : _a25.id) === "vue-devtools-next";
    if ((0, $gNtJt.target).__VUE_DEVTOOLS_GLOBAL_HOOK__ && isDevToolsNext) return;
    const _devtoolsHook = $a52fad25e66add48$var$createDevToolsHook();
    if ((0, $gNtJt.target).__VUE_DEVTOOLS_HOOK_REPLAY__) try {
        (0, $gNtJt.target).__VUE_DEVTOOLS_HOOK_REPLAY__.forEach((cb)=>cb(_devtoolsHook));
        (0, $gNtJt.target).__VUE_DEVTOOLS_HOOK_REPLAY__ = [];
    } catch (e) {
        console.error("[vue-devtools] Error during hook replay", e);
    }
    _devtoolsHook.once("init", (Vue)=>{
        (0, $gNtJt.target).__VUE_DEVTOOLS_VUE2_APP_DETECTED__ = true;
        console.log("%c[_____Vue DevTools v7 log_____]", "color: red; font-bold: 600; font-size: 16px;");
        console.log("%cVue DevTools v7 detected in your Vue2 project. v7 only supports Vue3 and will not work.", "font-bold: 500; font-size: 14px;");
        const legacyChromeUrl = "https://chromewebstore.google.com/detail/vuejs-devtools/iaajmlceplecbljialhhkmedjlpdblhp";
        const legacyFirefoxUrl = "https://addons.mozilla.org/firefox/addon/vue-js-devtools-v6-legacy";
        console.log(`%cThe legacy version of chrome extension that supports both Vue 2 and Vue 3 has been moved to %c ${legacyChromeUrl}`, "font-size: 14px;", "text-decoration: underline; cursor: pointer;font-size: 14px;");
        console.log(`%cThe legacy version of firefox extension that supports both Vue 2 and Vue 3 has been moved to %c ${legacyFirefoxUrl}`, "font-size: 14px;", "text-decoration: underline; cursor: pointer;font-size: 14px;");
        console.log("%cPlease install and enable only the legacy version for your Vue2 app.", "font-bold: 500; font-size: 14px;");
        console.log("%c[_____Vue DevTools v7 log_____]", "color: red; font-bold: 600; font-size: 16px;");
    });
    $a52fad25e66add48$var$hook.on.setupDevtoolsPlugin((pluginDescriptor, setupFn)=>{
        var _a26;
        $a52fad25e66add48$export$5158df7771943590(pluginDescriptor, setupFn);
        const { app: app } = (_a26 = $a52fad25e66add48$export$162128841a7f2877) != null ? _a26 : {};
        if (pluginDescriptor.settings) $a52fad25e66add48$var$initPluginSettings(pluginDescriptor.id, pluginDescriptor.settings);
        if (!app) return;
        $a52fad25e66add48$export$873c261f47a243e7([
            pluginDescriptor,
            setupFn
        ], app);
    });
    $a52fad25e66add48$var$onLegacyDevToolsPluginApiAvailable(()=>{
        const normalizedPluginBuffer = $a52fad25e66add48$export$df02dcb86618c10f.filter(([item])=>item.id !== "components");
        normalizedPluginBuffer.forEach(([pluginDescriptor, setupFn])=>{
            _devtoolsHook.emit("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , pluginDescriptor, setupFn, {
                target: "legacy"
            });
        });
    });
    $a52fad25e66add48$var$hook.on.vueAppInit(async (app, version, types)=>{
        const appRecord = $a52fad25e66add48$var$createAppRecord(app, types);
        const normalizedAppRecord = {
            ...appRecord,
            app: app,
            version: version
        };
        $a52fad25e66add48$export$c1761479e1420543(normalizedAppRecord);
        if ($a52fad25e66add48$export$d3c0473489b1d63b.value.length === 1) {
            $a52fad25e66add48$export$1574774def61bdf9(normalizedAppRecord);
            $a52fad25e66add48$export$1a7804ab8d8511d1(normalizedAppRecord.id);
            $a52fad25e66add48$var$normalizeRouterInfo(normalizedAppRecord, $a52fad25e66add48$export$162128841a7f2877);
            $a52fad25e66add48$export$c357c87447719db2(normalizedAppRecord.app);
        }
        $a52fad25e66add48$export$1f0daed17c8e64f(...$a52fad25e66add48$export$7e5554ded389d004(normalizedAppRecord.app));
        $a52fad25e66add48$export$ee22a7aaf6b41ce2({
            connected: true
        });
        _devtoolsHook.apps.push(app);
    });
    $a52fad25e66add48$var$hook.on.vueAppUnmount(async (app)=>{
        const activeRecords = $a52fad25e66add48$export$d3c0473489b1d63b.value.filter((appRecord)=>appRecord.app !== app);
        if (activeRecords.length === 0) $a52fad25e66add48$export$ee22a7aaf6b41ce2({
            connected: false
        });
        $a52fad25e66add48$export$4d20c72f1da170ba(app);
        $a52fad25e66add48$var$removeAppRecordId(app);
        if ($a52fad25e66add48$export$162128841a7f2877.value.app === app) {
            $a52fad25e66add48$export$1574774def61bdf9(activeRecords[0]);
            $a52fad25e66add48$export$4f1904c03898171b.hooks.callHook("sendActiveAppUpdatedToClient" /* SEND_ACTIVE_APP_UNMOUNTED_TO_CLIENT */ );
        }
        (0, $gNtJt.target).__VUE_DEVTOOLS_GLOBAL_HOOK__.apps.splice((0, $gNtJt.target).__VUE_DEVTOOLS_GLOBAL_HOOK__.apps.indexOf(app), 1);
        $a52fad25e66add48$export$7f52963080ec618f(app);
    });
    $a52fad25e66add48$var$subscribeDevToolsHook(_devtoolsHook);
    if (!(0, $gNtJt.target).__VUE_DEVTOOLS_GLOBAL_HOOK__) Object.defineProperty((0, $gNtJt.target), "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
        get () {
            return _devtoolsHook;
        },
        configurable: true
    });
    else if (!(0, $gNtJt.isNuxtApp)) Object.assign(__VUE_DEVTOOLS_GLOBAL_HOOK__, _devtoolsHook);
}
function $a52fad25e66add48$export$cb42e76452729606(fn) {
    return new Promise((resolve)=>{
        if ($a52fad25e66add48$export$a67dd585df937baa.connected && $a52fad25e66add48$export$a67dd585df937baa.clientConnected) {
            fn();
            resolve();
            return;
        }
        $a52fad25e66add48$export$4f1904c03898171b.hooks.hook("devtoolsConnectedUpdated" /* DEVTOOLS_CONNECTED_UPDATED */ , ({ state: state })=>{
            if (state.connected && state.clientConnected) {
                fn();
                resolve();
            }
        });
    });
}
// src/core/high-perf-mode/index.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$export$6f15da7a796da26a(state) {
    $a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled = state != null ? state : !$a52fad25e66add48$export$a67dd585df937baa.highPerfModeEnabled;
    if (!state && $a52fad25e66add48$export$162128841a7f2877.value) $a52fad25e66add48$export$c357c87447719db2($a52fad25e66add48$export$162128841a7f2877.value.app);
}
// src/core/component/state/format.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/component/state/reviver.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$reviveSet(val) {
    const result = /* @__PURE__ */ new Set();
    const list = val._custom.value;
    for(let i = 0; i < list.length; i++){
        const value = list[i];
        result.add($a52fad25e66add48$var$revive(value));
    }
    return result;
}
function $a52fad25e66add48$var$reviveMap(val) {
    const result = /* @__PURE__ */ new Map();
    const list = val._custom.value;
    for(let i = 0; i < list.length; i++){
        const { key: key, value: value } = list[i];
        result.set(key, $a52fad25e66add48$var$revive(value));
    }
    return result;
}
function $a52fad25e66add48$var$revive(val) {
    if (val === $a52fad25e66add48$export$6db089fe7b26f5b6) return void 0;
    else if (val === $a52fad25e66add48$export$b4bf424ed968e242) return Number.POSITIVE_INFINITY;
    else if (val === $a52fad25e66add48$export$95cb88e357cbada8) return Number.NEGATIVE_INFINITY;
    else if (val === $a52fad25e66add48$export$d7ae0f70ebb9e144) return Number.NaN;
    else if (val && val._custom) {
        const { _custom: custom } = val;
        if (custom.type === "component") return $a52fad25e66add48$export$162128841a7f2877.value.instanceMap.get(custom.id);
        else if (custom.type === "map") return $a52fad25e66add48$var$reviveMap(val);
        else if (custom.type === "set") return $a52fad25e66add48$var$reviveSet(val);
        else if (custom.type === "bigint") return BigInt(custom.value);
        else return $a52fad25e66add48$var$revive(custom.value);
    } else if ($a52fad25e66add48$var$symbolRE.test(val)) {
        const [, string] = $a52fad25e66add48$var$symbolRE.exec(val);
        return Symbol.for(string);
    } else if ($a52fad25e66add48$var$specialTypeRE.test(val)) {
        const [, type, string, , details] = $a52fad25e66add48$var$specialTypeRE.exec(val);
        const result = new (0, $gNtJt.target)[type](string);
        if (type === "Error" && details) result.stack = details;
        return result;
    } else return val;
}
function $a52fad25e66add48$var$reviver(key, value) {
    return $a52fad25e66add48$var$revive(value);
}
// src/core/component/state/format.ts
function $a52fad25e66add48$export$a2acd0fde5480ad5(value, raw = true) {
    const type = typeof value;
    if (value == null || value === $a52fad25e66add48$export$6db089fe7b26f5b6 || value === "undefined") return "null";
    else if (type === "boolean" || type === "number" || value === $a52fad25e66add48$export$b4bf424ed968e242 || value === $a52fad25e66add48$export$95cb88e357cbada8 || value === $a52fad25e66add48$export$d7ae0f70ebb9e144) return "literal";
    else if (value == null ? void 0 : value._custom) {
        if (raw || value._custom.display != null || value._custom.displayText != null) return "custom";
        else return $a52fad25e66add48$export$a2acd0fde5480ad5(value._custom.value);
    } else if (typeof value === "string") {
        const typeMatch = $a52fad25e66add48$var$specialTypeRE.exec(value);
        if (typeMatch) {
            const [, type2] = typeMatch;
            return `native ${type2}`;
        } else return "string";
    } else if (Array.isArray(value) || (value == null ? void 0 : value._isArray)) return "array";
    else if ($a52fad25e66add48$export$53b83ca8eaab0383(value)) return "plain-object";
    else return "unknown";
}
function $a52fad25e66add48$export$6c635c17a78ff695(value, quotes = false, options) {
    var _a25, _b25, _c;
    const { customClass: customClass } = options != null ? options : {};
    let result;
    const type = $a52fad25e66add48$export$a2acd0fde5480ad5(value, false);
    if (type !== "custom" && (value == null ? void 0 : value._custom)) value = value._custom.value;
    if (result = $a52fad25e66add48$var$internalStateTokenToString(value)) return result;
    else if (type === "custom") {
        const nestedName = ((_a25 = value._custom.value) == null ? void 0 : _a25._custom) && $a52fad25e66add48$export$6c635c17a78ff695(value._custom.value, quotes, options);
        return nestedName || value._custom.displayText || value._custom.display;
    } else if (type === "array") return `Array[${value.length}]`;
    else if (type === "plain-object") return `Object${Object.keys(value).length ? "" : " (empty)"}`;
    else if (type == null ? void 0 : type.includes("native")) return $a52fad25e66add48$export$4e7f196112fea3c5((_b25 = $a52fad25e66add48$var$specialTypeRE.exec(value)) == null ? void 0 : _b25[2]);
    else if (typeof value === "string") {
        const typeMatch = value.match($a52fad25e66add48$var$rawTypeRE);
        if (typeMatch) value = $a52fad25e66add48$var$escapeString(typeMatch[1]);
        else if (quotes) value = `<span>"</span>${(customClass == null ? void 0 : customClass.string) ? `<span class=${customClass.string}>${$a52fad25e66add48$var$escapeString(value)}</span>` : $a52fad25e66add48$var$escapeString(value)}<span>"</span>`;
        else value = (customClass == null ? void 0 : customClass.string) ? `<span class="${(_c = customClass == null ? void 0 : customClass.string) != null ? _c : ""}">${$a52fad25e66add48$var$escapeString(value)}</span>` : $a52fad25e66add48$var$escapeString(value);
    }
    return value;
}
function $a52fad25e66add48$var$escapeString(value) {
    return $a52fad25e66add48$export$4e7f196112fea3c5(value).replace(/ /g, "&nbsp;").replace(/\n/g, "<span>\\n</span>");
}
function $a52fad25e66add48$export$d049e3525cb8af5d(value) {
    var _a25, _b25, _c;
    let customType;
    const isCustom = $a52fad25e66add48$export$a2acd0fde5480ad5(value) === "custom";
    let inherit = {};
    if (isCustom) {
        const data = value;
        const customValue = (_a25 = data._custom) == null ? void 0 : _a25.value;
        const currentCustomType = (_b25 = data._custom) == null ? void 0 : _b25.type;
        const nestedCustom = typeof customValue === "object" && customValue !== null && "_custom" in customValue ? $a52fad25e66add48$export$d049e3525cb8af5d(customValue) : {
            inherit: void 0,
            value: void 0,
            customType: void 0
        };
        inherit = nestedCustom.inherit || ((_c = data._custom) == null ? void 0 : _c.fields) || {};
        value = nestedCustom.value || customValue;
        customType = nestedCustom.customType || currentCustomType;
    }
    if (value && value._isArray) value = value.items;
    return {
        value: value,
        inherit: inherit,
        customType: customType
    };
}
function $a52fad25e66add48$export$b0067b146e5937f7(value, customType) {
    if (customType === "bigint") return value;
    if (customType === "date") return value;
    return $a52fad25e66add48$var$replaceTokenToString(JSON.stringify(value));
}
function $a52fad25e66add48$export$d61dc8d725d3735e(value, customType) {
    if (customType === "bigint") return BigInt(value);
    if (customType === "date") return new Date(value);
    return JSON.parse($a52fad25e66add48$var$replaceStringToToken(value), $a52fad25e66add48$var$reviver);
}
// src/core/devtools-client/detected.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$export$2fce292577290205(params) {
    $a52fad25e66add48$export$a67dd585df937baa.devtoolsClientDetected = {
        ...$a52fad25e66add48$export$a67dd585df937baa.devtoolsClientDetected,
        ...params
    };
    const devtoolsClientVisible = Object.values($a52fad25e66add48$export$a67dd585df937baa.devtoolsClientDetected).some(Boolean);
    $a52fad25e66add48$export$6f15da7a796da26a(!devtoolsClientVisible);
}
var $a52fad25e66add48$var$_a18, $a52fad25e66add48$var$_b18;
($a52fad25e66add48$var$_b18 = ($a52fad25e66add48$var$_a18 = (0, $gNtJt.target)).__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__) != null ? $a52fad25e66add48$var$_b18 : $a52fad25e66add48$var$_a18.__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ = $a52fad25e66add48$export$2fce292577290205;
// src/messaging/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/broadcast-channel/index.ts
$a52fad25e66add48$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/index.js
$a52fad25e66add48$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/class-registry.js
$a52fad25e66add48$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/registry.js
$a52fad25e66add48$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/double-indexed-kv.js
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$DoubleIndexedKV = class {
    constructor(){
        this.keyToValue = /* @__PURE__ */ new Map();
        this.valueToKey = /* @__PURE__ */ new Map();
    }
    set(key, value) {
        this.keyToValue.set(key, value);
        this.valueToKey.set(value, key);
    }
    getByKey(key) {
        return this.keyToValue.get(key);
    }
    getByValue(value) {
        return this.valueToKey.get(value);
    }
    clear() {
        this.keyToValue.clear();
        this.valueToKey.clear();
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/registry.js
var $a52fad25e66add48$var$Registry = class {
    constructor(generateIdentifier){
        this.generateIdentifier = generateIdentifier;
        this.kv = new $a52fad25e66add48$var$DoubleIndexedKV();
    }
    register(value, identifier) {
        if (this.kv.getByValue(value)) return;
        if (!identifier) identifier = this.generateIdentifier(value);
        this.kv.set(identifier, value);
    }
    clear() {
        this.kv.clear();
    }
    getIdentifier(value) {
        return this.kv.getByValue(value);
    }
    getValue(identifier) {
        return this.kv.getByKey(identifier);
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/class-registry.js
var $a52fad25e66add48$var$ClassRegistry = class extends $a52fad25e66add48$var$Registry {
    constructor(){
        super((c)=>c.name);
        this.classToAllowedProps = /* @__PURE__ */ new Map();
    }
    register(value, options) {
        if (typeof options === "object") {
            if (options.allowProps) this.classToAllowedProps.set(value, options.allowProps);
            super.register(value, options.identifier);
        } else super.register(value, options);
    }
    getAllowedProps(value) {
        return this.classToAllowedProps.get(value);
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/custom-transformer-registry.js
$a52fad25e66add48$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/util.js
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$valuesOfObj(record) {
    if ("values" in Object) return Object.values(record);
    const values = [];
    for(const key in record)if (record.hasOwnProperty(key)) values.push(record[key]);
    return values;
}
function $a52fad25e66add48$var$find(record, predicate) {
    const values = $a52fad25e66add48$var$valuesOfObj(record);
    if ("find" in values) return values.find(predicate);
    const valuesNotNever = values;
    for(let i = 0; i < valuesNotNever.length; i++){
        const value = valuesNotNever[i];
        if (predicate(value)) return value;
    }
    return void 0;
}
function $a52fad25e66add48$var$forEach(record, run) {
    Object.entries(record).forEach(([key, value])=>run(value, key));
}
function $a52fad25e66add48$var$includes(arr, value) {
    return arr.indexOf(value) !== -1;
}
function $a52fad25e66add48$var$findArr(record, predicate) {
    for(let i = 0; i < record.length; i++){
        const value = record[i];
        if (predicate(value)) return value;
    }
    return void 0;
}
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/custom-transformer-registry.js
var $a52fad25e66add48$var$CustomTransformerRegistry = class {
    constructor(){
        this.transfomers = {};
    }
    register(transformer) {
        this.transfomers[transformer.name] = transformer;
    }
    findApplicable(v) {
        return $a52fad25e66add48$var$find(this.transfomers, (transformer)=>transformer.isApplicable(v));
    }
    findByName(name) {
        return this.transfomers[name];
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/plainer.js
$a52fad25e66add48$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/is.js
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$getType = (payload)=>Object.prototype.toString.call(payload).slice(8, -1);
var $a52fad25e66add48$var$isUndefined = (payload)=>typeof payload === "undefined";
var $a52fad25e66add48$var$isNull = (payload)=>payload === null;
var $a52fad25e66add48$var$isPlainObject2 = (payload)=>{
    if (typeof payload !== "object" || payload === null) return false;
    if (payload === Object.prototype) return false;
    if (Object.getPrototypeOf(payload) === null) return true;
    return Object.getPrototypeOf(payload) === Object.prototype;
};
var $a52fad25e66add48$var$isEmptyObject = (payload)=>$a52fad25e66add48$var$isPlainObject2(payload) && Object.keys(payload).length === 0;
var $a52fad25e66add48$var$isArray = (payload)=>Array.isArray(payload);
var $a52fad25e66add48$var$isString = (payload)=>typeof payload === "string";
var $a52fad25e66add48$var$isNumber = (payload)=>typeof payload === "number" && !isNaN(payload);
var $a52fad25e66add48$var$isBoolean = (payload)=>typeof payload === "boolean";
var $a52fad25e66add48$var$isRegExp = (payload)=>payload instanceof RegExp;
var $a52fad25e66add48$var$isMap = (payload)=>payload instanceof Map;
var $a52fad25e66add48$var$isSet = (payload)=>payload instanceof Set;
var $a52fad25e66add48$var$isSymbol = (payload)=>$a52fad25e66add48$var$getType(payload) === "Symbol";
var $a52fad25e66add48$var$isDate = (payload)=>payload instanceof Date && !isNaN(payload.valueOf());
var $a52fad25e66add48$var$isError = (payload)=>payload instanceof Error;
var $a52fad25e66add48$var$isNaNValue = (payload)=>typeof payload === "number" && isNaN(payload);
var $a52fad25e66add48$var$isPrimitive2 = (payload)=>$a52fad25e66add48$var$isBoolean(payload) || $a52fad25e66add48$var$isNull(payload) || $a52fad25e66add48$var$isUndefined(payload) || $a52fad25e66add48$var$isNumber(payload) || $a52fad25e66add48$var$isString(payload) || $a52fad25e66add48$var$isSymbol(payload);
var $a52fad25e66add48$var$isBigint = (payload)=>typeof payload === "bigint";
var $a52fad25e66add48$var$isInfinite = (payload)=>payload === Infinity || payload === -Infinity;
var $a52fad25e66add48$var$isTypedArray = (payload)=>ArrayBuffer.isView(payload) && !(payload instanceof DataView);
var $a52fad25e66add48$var$isURL = (payload)=>payload instanceof URL;
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/pathstringifier.js
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$escapeKey = (key)=>key.replace(/\./g, "\\.");
var $a52fad25e66add48$var$stringifyPath = (path)=>path.map(String).map($a52fad25e66add48$var$escapeKey).join(".");
var $a52fad25e66add48$var$parsePath = (string)=>{
    const result = [];
    let segment = "";
    for(let i = 0; i < string.length; i++){
        let char = string.charAt(i);
        const isEscapedDot = char === "\\" && string.charAt(i + 1) === ".";
        if (isEscapedDot) {
            segment += ".";
            i++;
            continue;
        }
        const isEndOfSegment = char === ".";
        if (isEndOfSegment) {
            result.push(segment);
            segment = "";
            continue;
        }
        segment += char;
    }
    const lastSegment = segment;
    result.push(lastSegment);
    return result;
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/transformer.js
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$simpleTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var $a52fad25e66add48$var$simpleRules = [
    $a52fad25e66add48$var$simpleTransformation($a52fad25e66add48$var$isUndefined, "undefined", ()=>null, ()=>void 0),
    $a52fad25e66add48$var$simpleTransformation($a52fad25e66add48$var$isBigint, "bigint", (v)=>v.toString(), (v)=>{
        if (typeof BigInt !== "undefined") return BigInt(v);
        console.error("Please add a BigInt polyfill.");
        return v;
    }),
    $a52fad25e66add48$var$simpleTransformation($a52fad25e66add48$var$isDate, "Date", (v)=>v.toISOString(), (v)=>new Date(v)),
    $a52fad25e66add48$var$simpleTransformation($a52fad25e66add48$var$isError, "Error", (v, superJson)=>{
        const baseError = {
            name: v.name,
            message: v.message
        };
        superJson.allowedErrorProps.forEach((prop)=>{
            baseError[prop] = v[prop];
        });
        return baseError;
    }, (v, superJson)=>{
        const e = new Error(v.message);
        e.name = v.name;
        e.stack = v.stack;
        superJson.allowedErrorProps.forEach((prop)=>{
            e[prop] = v[prop];
        });
        return e;
    }),
    $a52fad25e66add48$var$simpleTransformation($a52fad25e66add48$var$isRegExp, "regexp", (v)=>"" + v, (regex)=>{
        const body = regex.slice(1, regex.lastIndexOf("/"));
        const flags = regex.slice(regex.lastIndexOf("/") + 1);
        return new RegExp(body, flags);
    }),
    $a52fad25e66add48$var$simpleTransformation($a52fad25e66add48$var$isSet, "set", // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    (v)=>[
            ...v.values()
        ], (v)=>new Set(v)),
    $a52fad25e66add48$var$simpleTransformation($a52fad25e66add48$var$isMap, "map", (v)=>[
            ...v.entries()
        ], (v)=>new Map(v)),
    $a52fad25e66add48$var$simpleTransformation((v)=>$a52fad25e66add48$var$isNaNValue(v) || $a52fad25e66add48$var$isInfinite(v), "number", (v)=>{
        if ($a52fad25e66add48$var$isNaNValue(v)) return "NaN";
        if (v > 0) return "Infinity";
        else return "-Infinity";
    }, Number),
    $a52fad25e66add48$var$simpleTransformation((v)=>v === 0 && 1 / v === -Infinity, "number", ()=>{
        return "-0";
    }, Number),
    $a52fad25e66add48$var$simpleTransformation($a52fad25e66add48$var$isURL, "URL", (v)=>v.toString(), (v)=>new URL(v))
];
function $a52fad25e66add48$var$compositeTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var $a52fad25e66add48$var$symbolRule = $a52fad25e66add48$var$compositeTransformation((s, superJson)=>{
    if ($a52fad25e66add48$var$isSymbol(s)) {
        const isRegistered = !!superJson.symbolRegistry.getIdentifier(s);
        return isRegistered;
    }
    return false;
}, (s, superJson)=>{
    const identifier = superJson.symbolRegistry.getIdentifier(s);
    return [
        "symbol",
        identifier
    ];
}, (v)=>v.description, (_, a, superJson)=>{
    const value = superJson.symbolRegistry.getValue(a[1]);
    if (!value) throw new Error("Trying to deserialize unknown symbol");
    return value;
});
var $a52fad25e66add48$var$constructorToName = [
    Int8Array,
    Uint8Array,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    Uint8ClampedArray
].reduce((obj, ctor)=>{
    obj[ctor.name] = ctor;
    return obj;
}, {});
var $a52fad25e66add48$var$typedArrayRule = $a52fad25e66add48$var$compositeTransformation($a52fad25e66add48$var$isTypedArray, (v)=>[
        "typed-array",
        v.constructor.name
    ], (v)=>[
        ...v
    ], (v, a)=>{
    const ctor = $a52fad25e66add48$var$constructorToName[a[1]];
    if (!ctor) throw new Error("Trying to deserialize unknown typed array");
    return new ctor(v);
});
function $a52fad25e66add48$var$isInstanceOfRegisteredClass(potentialClass, superJson) {
    if (potentialClass == null ? void 0 : potentialClass.constructor) {
        const isRegistered = !!superJson.classRegistry.getIdentifier(potentialClass.constructor);
        return isRegistered;
    }
    return false;
}
var $a52fad25e66add48$var$classRule = $a52fad25e66add48$var$compositeTransformation($a52fad25e66add48$var$isInstanceOfRegisteredClass, (clazz, superJson)=>{
    const identifier = superJson.classRegistry.getIdentifier(clazz.constructor);
    return [
        "class",
        identifier
    ];
}, (clazz, superJson)=>{
    const allowedProps = superJson.classRegistry.getAllowedProps(clazz.constructor);
    if (!allowedProps) return {
        ...clazz
    };
    const result = {};
    allowedProps.forEach((prop)=>{
        result[prop] = clazz[prop];
    });
    return result;
}, (v, a, superJson)=>{
    const clazz = superJson.classRegistry.getValue(a[1]);
    if (!clazz) throw new Error(`Trying to deserialize unknown class '${a[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`);
    return Object.assign(Object.create(clazz.prototype), v);
});
var $a52fad25e66add48$var$customRule = $a52fad25e66add48$var$compositeTransformation((value, superJson)=>{
    return !!superJson.customTransformerRegistry.findApplicable(value);
}, (value, superJson)=>{
    const transformer = superJson.customTransformerRegistry.findApplicable(value);
    return [
        "custom",
        transformer.name
    ];
}, (value, superJson)=>{
    const transformer = superJson.customTransformerRegistry.findApplicable(value);
    return transformer.serialize(value);
}, (v, a, superJson)=>{
    const transformer = superJson.customTransformerRegistry.findByName(a[1]);
    if (!transformer) throw new Error("Trying to deserialize unknown custom value");
    return transformer.deserialize(v);
});
var $a52fad25e66add48$var$compositeRules = [
    $a52fad25e66add48$var$classRule,
    $a52fad25e66add48$var$symbolRule,
    $a52fad25e66add48$var$customRule,
    $a52fad25e66add48$var$typedArrayRule
];
var $a52fad25e66add48$var$transformValue = (value, superJson)=>{
    const applicableCompositeRule = $a52fad25e66add48$var$findArr($a52fad25e66add48$var$compositeRules, (rule)=>rule.isApplicable(value, superJson));
    if (applicableCompositeRule) return {
        value: applicableCompositeRule.transform(value, superJson),
        type: applicableCompositeRule.annotation(value, superJson)
    };
    const applicableSimpleRule = $a52fad25e66add48$var$findArr($a52fad25e66add48$var$simpleRules, (rule)=>rule.isApplicable(value, superJson));
    if (applicableSimpleRule) return {
        value: applicableSimpleRule.transform(value, superJson),
        type: applicableSimpleRule.annotation
    };
    return void 0;
};
var $a52fad25e66add48$var$simpleRulesByAnnotation = {};
$a52fad25e66add48$var$simpleRules.forEach((rule)=>{
    $a52fad25e66add48$var$simpleRulesByAnnotation[rule.annotation] = rule;
});
var $a52fad25e66add48$var$untransformValue = (json, type, superJson)=>{
    if ($a52fad25e66add48$var$isArray(type)) switch(type[0]){
        case "symbol":
            return $a52fad25e66add48$var$symbolRule.untransform(json, type, superJson);
        case "class":
            return $a52fad25e66add48$var$classRule.untransform(json, type, superJson);
        case "custom":
            return $a52fad25e66add48$var$customRule.untransform(json, type, superJson);
        case "typed-array":
            return $a52fad25e66add48$var$typedArrayRule.untransform(json, type, superJson);
        default:
            throw new Error("Unknown transformation: " + type);
    }
    else {
        const transformation = $a52fad25e66add48$var$simpleRulesByAnnotation[type];
        if (!transformation) throw new Error("Unknown transformation: " + type);
        return transformation.untransform(json, superJson);
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/accessDeep.js
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$getNthKey = (value, n)=>{
    if (n > value.size) throw new Error("index out of bounds");
    const keys = value.keys();
    while(n > 0){
        keys.next();
        n--;
    }
    return keys.next().value;
};
function $a52fad25e66add48$var$validatePath(path) {
    if ($a52fad25e66add48$var$includes(path, "__proto__")) throw new Error("__proto__ is not allowed as a property");
    if ($a52fad25e66add48$var$includes(path, "prototype")) throw new Error("prototype is not allowed as a property");
    if ($a52fad25e66add48$var$includes(path, "constructor")) throw new Error("constructor is not allowed as a property");
}
var $a52fad25e66add48$var$getDeep = (object, path)=>{
    $a52fad25e66add48$var$validatePath(path);
    for(let i = 0; i < path.length; i++){
        const key = path[i];
        if ($a52fad25e66add48$var$isSet(object)) object = $a52fad25e66add48$var$getNthKey(object, +key);
        else if ($a52fad25e66add48$var$isMap(object)) {
            const row = +key;
            const type = +path[++i] === 0 ? "key" : "value";
            const keyOfRow = $a52fad25e66add48$var$getNthKey(object, row);
            switch(type){
                case "key":
                    object = keyOfRow;
                    break;
                case "value":
                    object = object.get(keyOfRow);
                    break;
            }
        } else object = object[key];
    }
    return object;
};
var $a52fad25e66add48$var$setDeep = (object, path, mapper)=>{
    $a52fad25e66add48$var$validatePath(path);
    if (path.length === 0) return mapper(object);
    let parent = object;
    for(let i = 0; i < path.length - 1; i++){
        const key = path[i];
        if ($a52fad25e66add48$var$isArray(parent)) {
            const index = +key;
            parent = parent[index];
        } else if ($a52fad25e66add48$var$isPlainObject2(parent)) parent = parent[key];
        else if ($a52fad25e66add48$var$isSet(parent)) {
            const row = +key;
            parent = $a52fad25e66add48$var$getNthKey(parent, row);
        } else if ($a52fad25e66add48$var$isMap(parent)) {
            const isEnd = i === path.length - 2;
            if (isEnd) break;
            const row = +key;
            const type = +path[++i] === 0 ? "key" : "value";
            const keyOfRow = $a52fad25e66add48$var$getNthKey(parent, row);
            switch(type){
                case "key":
                    parent = keyOfRow;
                    break;
                case "value":
                    parent = parent.get(keyOfRow);
                    break;
            }
        }
    }
    const lastKey = path[path.length - 1];
    if ($a52fad25e66add48$var$isArray(parent)) parent[+lastKey] = mapper(parent[+lastKey]);
    else if ($a52fad25e66add48$var$isPlainObject2(parent)) parent[lastKey] = mapper(parent[lastKey]);
    if ($a52fad25e66add48$var$isSet(parent)) {
        const oldValue = $a52fad25e66add48$var$getNthKey(parent, +lastKey);
        const newValue = mapper(oldValue);
        if (oldValue !== newValue) {
            parent.delete(oldValue);
            parent.add(newValue);
        }
    }
    if ($a52fad25e66add48$var$isMap(parent)) {
        const row = +path[path.length - 2];
        const keyToRow = $a52fad25e66add48$var$getNthKey(parent, row);
        const type = +lastKey === 0 ? "key" : "value";
        switch(type){
            case "key":
                {
                    const newKey = mapper(keyToRow);
                    parent.set(newKey, parent.get(keyToRow));
                    if (newKey !== keyToRow) parent.delete(keyToRow);
                    break;
                }
            case "value":
                parent.set(keyToRow, mapper(parent.get(keyToRow)));
                break;
        }
    }
    return object;
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/plainer.js
function $a52fad25e66add48$var$traverse(tree, walker2, origin = []) {
    if (!tree) return;
    if (!$a52fad25e66add48$var$isArray(tree)) {
        $a52fad25e66add48$var$forEach(tree, (subtree, key)=>$a52fad25e66add48$var$traverse(subtree, walker2, [
                ...origin,
                ...$a52fad25e66add48$var$parsePath(key)
            ]));
        return;
    }
    const [nodeValue, children] = tree;
    if (children) $a52fad25e66add48$var$forEach(children, (child, key)=>{
        $a52fad25e66add48$var$traverse(child, walker2, [
            ...origin,
            ...$a52fad25e66add48$var$parsePath(key)
        ]);
    });
    walker2(nodeValue, origin);
}
function $a52fad25e66add48$var$applyValueAnnotations(plain, annotations, superJson) {
    $a52fad25e66add48$var$traverse(annotations, (type, path)=>{
        plain = $a52fad25e66add48$var$setDeep(plain, path, (v)=>$a52fad25e66add48$var$untransformValue(v, type, superJson));
    });
    return plain;
}
function $a52fad25e66add48$var$applyReferentialEqualityAnnotations(plain, annotations) {
    function apply(identicalPaths, path) {
        const object = $a52fad25e66add48$var$getDeep(plain, $a52fad25e66add48$var$parsePath(path));
        identicalPaths.map($a52fad25e66add48$var$parsePath).forEach((identicalObjectPath)=>{
            plain = $a52fad25e66add48$var$setDeep(plain, identicalObjectPath, ()=>object);
        });
    }
    if ($a52fad25e66add48$var$isArray(annotations)) {
        const [root, other] = annotations;
        root.forEach((identicalPath)=>{
            plain = $a52fad25e66add48$var$setDeep(plain, $a52fad25e66add48$var$parsePath(identicalPath), ()=>plain);
        });
        if (other) $a52fad25e66add48$var$forEach(other, apply);
    } else $a52fad25e66add48$var$forEach(annotations, apply);
    return plain;
}
var $a52fad25e66add48$var$isDeep = (object, superJson)=>$a52fad25e66add48$var$isPlainObject2(object) || $a52fad25e66add48$var$isArray(object) || $a52fad25e66add48$var$isMap(object) || $a52fad25e66add48$var$isSet(object) || $a52fad25e66add48$var$isInstanceOfRegisteredClass(object, superJson);
function $a52fad25e66add48$var$addIdentity(object, path, identities) {
    const existingSet = identities.get(object);
    if (existingSet) existingSet.push(path);
    else identities.set(object, [
        path
    ]);
}
function $a52fad25e66add48$var$generateReferentialEqualityAnnotations(identitites, dedupe) {
    const result = {};
    let rootEqualityPaths = void 0;
    identitites.forEach((paths)=>{
        if (paths.length <= 1) return;
        if (!dedupe) paths = paths.map((path)=>path.map(String)).sort((a, b)=>a.length - b.length);
        const [representativePath, ...identicalPaths] = paths;
        if (representativePath.length === 0) rootEqualityPaths = identicalPaths.map($a52fad25e66add48$var$stringifyPath);
        else result[$a52fad25e66add48$var$stringifyPath(representativePath)] = identicalPaths.map($a52fad25e66add48$var$stringifyPath);
    });
    if (rootEqualityPaths) {
        if ($a52fad25e66add48$var$isEmptyObject(result)) return [
            rootEqualityPaths
        ];
        else return [
            rootEqualityPaths,
            result
        ];
    } else return $a52fad25e66add48$var$isEmptyObject(result) ? void 0 : result;
}
var $a52fad25e66add48$var$walker = (object, identities, superJson, dedupe, path = [], objectsInThisPath = [], seenObjects = /* @__PURE__ */ new Map())=>{
    var _a25;
    const primitive = $a52fad25e66add48$var$isPrimitive2(object);
    if (!primitive) {
        $a52fad25e66add48$var$addIdentity(object, path, identities);
        const seen = seenObjects.get(object);
        if (seen) return dedupe ? {
            transformedValue: null
        } : seen;
    }
    if (!$a52fad25e66add48$var$isDeep(object, superJson)) {
        const transformed2 = $a52fad25e66add48$var$transformValue(object, superJson);
        const result2 = transformed2 ? {
            transformedValue: transformed2.value,
            annotations: [
                transformed2.type
            ]
        } : {
            transformedValue: object
        };
        if (!primitive) seenObjects.set(object, result2);
        return result2;
    }
    if ($a52fad25e66add48$var$includes(objectsInThisPath, object)) return {
        transformedValue: null
    };
    const transformationResult = $a52fad25e66add48$var$transformValue(object, superJson);
    const transformed = (_a25 = transformationResult == null ? void 0 : transformationResult.value) != null ? _a25 : object;
    const transformedValue = $a52fad25e66add48$var$isArray(transformed) ? [] : {};
    const innerAnnotations = {};
    $a52fad25e66add48$var$forEach(transformed, (value, index)=>{
        if (index === "__proto__" || index === "constructor" || index === "prototype") throw new Error(`Detected property ${index}. This is a prototype pollution risk, please remove it from your object.`);
        const recursiveResult = $a52fad25e66add48$var$walker(value, identities, superJson, dedupe, [
            ...path,
            index
        ], [
            ...objectsInThisPath,
            object
        ], seenObjects);
        transformedValue[index] = recursiveResult.transformedValue;
        if ($a52fad25e66add48$var$isArray(recursiveResult.annotations)) innerAnnotations[index] = recursiveResult.annotations;
        else if ($a52fad25e66add48$var$isPlainObject2(recursiveResult.annotations)) $a52fad25e66add48$var$forEach(recursiveResult.annotations, (tree, key)=>{
            innerAnnotations[$a52fad25e66add48$var$escapeKey(index) + "." + key] = tree;
        });
    });
    const result = $a52fad25e66add48$var$isEmptyObject(innerAnnotations) ? {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type
        ] : void 0
    } : {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type,
            innerAnnotations
        ] : innerAnnotations
    };
    if (!primitive) seenObjects.set(object, result);
    return result;
};
// ../../node_modules/.pnpm/copy-anything@3.0.5/node_modules/copy-anything/dist/index.js
$a52fad25e66add48$var$init_esm_shims();
// ../../node_modules/.pnpm/is-what@4.1.16/node_modules/is-what/dist/index.js
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$getType2(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
function $a52fad25e66add48$var$isArray2(payload) {
    return $a52fad25e66add48$var$getType2(payload) === "Array";
}
function $a52fad25e66add48$var$isPlainObject3(payload) {
    if ($a52fad25e66add48$var$getType2(payload) !== "Object") return false;
    const prototype = Object.getPrototypeOf(payload);
    return !!prototype && prototype.constructor === Object && prototype === Object.prototype;
}
function $a52fad25e66add48$var$isNull2(payload) {
    return $a52fad25e66add48$var$getType2(payload) === "Null";
}
function $a52fad25e66add48$var$isOneOf(a, b, c, d, e) {
    return (value)=>a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
}
function $a52fad25e66add48$var$isUndefined2(payload) {
    return $a52fad25e66add48$var$getType2(payload) === "Undefined";
}
var $a52fad25e66add48$var$isNullOrUndefined = $a52fad25e66add48$var$isOneOf($a52fad25e66add48$var$isNull2, $a52fad25e66add48$var$isUndefined2);
// ../../node_modules/.pnpm/copy-anything@3.0.5/node_modules/copy-anything/dist/index.js
function $a52fad25e66add48$var$assignProp(carry, key, newVal, originalObject, includeNonenumerable) {
    const propType = ({}).propertyIsEnumerable.call(originalObject, key) ? "enumerable" : "nonenumerable";
    if (propType === "enumerable") carry[key] = newVal;
    if (includeNonenumerable && propType === "nonenumerable") Object.defineProperty(carry, key, {
        value: newVal,
        enumerable: false,
        writable: true,
        configurable: true
    });
}
function $a52fad25e66add48$var$copy(target22, options = {}) {
    if ($a52fad25e66add48$var$isArray2(target22)) return target22.map((item)=>$a52fad25e66add48$var$copy(item, options));
    if (!$a52fad25e66add48$var$isPlainObject3(target22)) return target22;
    const props = Object.getOwnPropertyNames(target22);
    const symbols = Object.getOwnPropertySymbols(target22);
    return [
        ...props,
        ...symbols
    ].reduce((carry, key)=>{
        if ($a52fad25e66add48$var$isArray2(options.props) && !options.props.includes(key)) return carry;
        const val = target22[key];
        const newVal = $a52fad25e66add48$var$copy(val, options);
        $a52fad25e66add48$var$assignProp(carry, key, newVal, target22, options.nonenumerable);
        return carry;
    }, {});
}
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/index.js
var $a52fad25e66add48$var$SuperJSON = class {
    /**
   * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
   */ constructor({ dedupe: dedupe = false } = {}){
        this.classRegistry = new $a52fad25e66add48$var$ClassRegistry();
        this.symbolRegistry = new $a52fad25e66add48$var$Registry((s)=>{
            var _a25;
            return (_a25 = s.description) != null ? _a25 : "";
        });
        this.customTransformerRegistry = new $a52fad25e66add48$var$CustomTransformerRegistry();
        this.allowedErrorProps = [];
        this.dedupe = dedupe;
    }
    serialize(object) {
        const identities = /* @__PURE__ */ new Map();
        const output = $a52fad25e66add48$var$walker(object, identities, this, this.dedupe);
        const res = {
            json: output.transformedValue
        };
        if (output.annotations) res.meta = {
            ...res.meta,
            values: output.annotations
        };
        const equalityAnnotations = $a52fad25e66add48$var$generateReferentialEqualityAnnotations(identities, this.dedupe);
        if (equalityAnnotations) res.meta = {
            ...res.meta,
            referentialEqualities: equalityAnnotations
        };
        return res;
    }
    deserialize(payload) {
        const { json: json, meta: meta } = payload;
        let result = $a52fad25e66add48$var$copy(json);
        if (meta == null ? void 0 : meta.values) result = $a52fad25e66add48$var$applyValueAnnotations(result, meta.values, this);
        if (meta == null ? void 0 : meta.referentialEqualities) result = $a52fad25e66add48$var$applyReferentialEqualityAnnotations(result, meta.referentialEqualities);
        return result;
    }
    stringify(object) {
        return JSON.stringify(this.serialize(object));
    }
    parse(string) {
        return this.deserialize(JSON.parse(string));
    }
    registerClass(v, options) {
        this.classRegistry.register(v, options);
    }
    registerSymbol(v, identifier) {
        this.symbolRegistry.register(v, identifier);
    }
    registerCustom(transformer, name) {
        this.customTransformerRegistry.register({
            name: name,
            ...transformer
        });
    }
    allowErrorProps(...props) {
        this.allowedErrorProps.push(...props);
    }
};
$a52fad25e66add48$var$SuperJSON.defaultInstance = new $a52fad25e66add48$var$SuperJSON();
$a52fad25e66add48$var$SuperJSON.serialize = $a52fad25e66add48$var$SuperJSON.defaultInstance.serialize.bind($a52fad25e66add48$var$SuperJSON.defaultInstance);
$a52fad25e66add48$var$SuperJSON.deserialize = $a52fad25e66add48$var$SuperJSON.defaultInstance.deserialize.bind($a52fad25e66add48$var$SuperJSON.defaultInstance);
$a52fad25e66add48$var$SuperJSON.stringify = $a52fad25e66add48$var$SuperJSON.defaultInstance.stringify.bind($a52fad25e66add48$var$SuperJSON.defaultInstance);
$a52fad25e66add48$var$SuperJSON.parse = $a52fad25e66add48$var$SuperJSON.defaultInstance.parse.bind($a52fad25e66add48$var$SuperJSON.defaultInstance);
$a52fad25e66add48$var$SuperJSON.registerClass = $a52fad25e66add48$var$SuperJSON.defaultInstance.registerClass.bind($a52fad25e66add48$var$SuperJSON.defaultInstance);
$a52fad25e66add48$var$SuperJSON.registerSymbol = $a52fad25e66add48$var$SuperJSON.defaultInstance.registerSymbol.bind($a52fad25e66add48$var$SuperJSON.defaultInstance);
$a52fad25e66add48$var$SuperJSON.registerCustom = $a52fad25e66add48$var$SuperJSON.defaultInstance.registerCustom.bind($a52fad25e66add48$var$SuperJSON.defaultInstance);
$a52fad25e66add48$var$SuperJSON.allowErrorProps = $a52fad25e66add48$var$SuperJSON.defaultInstance.allowErrorProps.bind($a52fad25e66add48$var$SuperJSON.defaultInstance);
var $a52fad25e66add48$var$serialize = $a52fad25e66add48$var$SuperJSON.serialize;
var $a52fad25e66add48$var$deserialize = $a52fad25e66add48$var$SuperJSON.deserialize;
var $a52fad25e66add48$var$stringify = $a52fad25e66add48$var$SuperJSON.stringify;
var $a52fad25e66add48$var$parse = $a52fad25e66add48$var$SuperJSON.parse;
var $a52fad25e66add48$var$registerClass = $a52fad25e66add48$var$SuperJSON.registerClass;
var $a52fad25e66add48$var$registerCustom = $a52fad25e66add48$var$SuperJSON.registerCustom;
var $a52fad25e66add48$var$registerSymbol = $a52fad25e66add48$var$SuperJSON.registerSymbol;
var $a52fad25e66add48$var$allowErrorProps = $a52fad25e66add48$var$SuperJSON.allowErrorProps;
// src/messaging/presets/broadcast-channel/context.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY = "__devtools-kit-broadcast-messaging-event-key__";
// src/messaging/presets/broadcast-channel/index.ts
var $a52fad25e66add48$var$BROADCAST_CHANNEL_NAME = "__devtools-kit:broadcast-channel__";
function $a52fad25e66add48$var$createBroadcastChannel() {
    const channel = new BroadcastChannel($a52fad25e66add48$var$BROADCAST_CHANNEL_NAME);
    return {
        post: (data)=>{
            channel.postMessage($a52fad25e66add48$var$SuperJSON.stringify({
                event: $a52fad25e66add48$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY,
                data: data
            }));
        },
        on: (handler)=>{
            channel.onmessage = (event)=>{
                const parsed = $a52fad25e66add48$var$SuperJSON.parse(event.data);
                if (parsed.event === $a52fad25e66add48$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY) handler(parsed.data);
            };
        }
    };
}
// src/messaging/presets/electron/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/electron/client.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/electron/context.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$__ELECTRON_CLIENT_CONTEXT__ = "electron:client-context";
var $a52fad25e66add48$var$__ELECTRON_RPOXY_CONTEXT__ = "electron:proxy-context";
var $a52fad25e66add48$var$__ELECTRON_SERVER_CONTEXT__ = "electron:server-context";
var $a52fad25e66add48$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__ = {
    // client
    CLIENT_TO_PROXY: "client->proxy",
    // on: proxy->client
    // proxy
    PROXY_TO_CLIENT: "proxy->client",
    // on: server->proxy
    PROXY_TO_SERVER: "proxy->server",
    // on: client->proxy
    // server
    SERVER_TO_PROXY: "server->proxy"
};
function $a52fad25e66add48$var$getElectronClientContext() {
    return (0, $gNtJt.target)[$a52fad25e66add48$var$__ELECTRON_CLIENT_CONTEXT__];
}
function $a52fad25e66add48$export$2837faaf25ee2c9a(context) {
    (0, $gNtJt.target)[$a52fad25e66add48$var$__ELECTRON_CLIENT_CONTEXT__] = context;
}
function $a52fad25e66add48$var$getElectronProxyContext() {
    return (0, $gNtJt.target)[$a52fad25e66add48$var$__ELECTRON_RPOXY_CONTEXT__];
}
function $a52fad25e66add48$export$f4b34d15f9836c97(context) {
    (0, $gNtJt.target)[$a52fad25e66add48$var$__ELECTRON_RPOXY_CONTEXT__] = context;
}
function $a52fad25e66add48$var$getElectronServerContext() {
    return (0, $gNtJt.target)[$a52fad25e66add48$var$__ELECTRON_SERVER_CONTEXT__];
}
function $a52fad25e66add48$export$d8c81043a9a1bbbe(context) {
    (0, $gNtJt.target)[$a52fad25e66add48$var$__ELECTRON_SERVER_CONTEXT__] = context;
}
// src/messaging/presets/electron/client.ts
function $a52fad25e66add48$var$createElectronClientChannel() {
    const socket = $a52fad25e66add48$var$getElectronClientContext();
    return {
        post: (data)=>{
            socket.emit($a52fad25e66add48$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.CLIENT_TO_PROXY, $a52fad25e66add48$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            socket.on($a52fad25e66add48$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_CLIENT, (e)=>{
                handler($a52fad25e66add48$var$SuperJSON.parse(e));
            });
        }
    };
}
// src/messaging/presets/electron/proxy.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$createElectronProxyChannel() {
    const socket = $a52fad25e66add48$var$getElectronProxyContext();
    return {
        post: (data)=>{},
        on: (handler)=>{
            socket.on($a52fad25e66add48$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY, (data)=>{
                socket.broadcast.emit($a52fad25e66add48$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_CLIENT, data);
            });
            socket.on($a52fad25e66add48$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.CLIENT_TO_PROXY, (data)=>{
                socket.broadcast.emit($a52fad25e66add48$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER, data);
            });
        }
    };
}
// src/messaging/presets/electron/server.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$createElectronServerChannel() {
    const socket = $a52fad25e66add48$var$getElectronServerContext();
    return {
        post: (data)=>{
            socket.emit($a52fad25e66add48$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY, $a52fad25e66add48$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            socket.on($a52fad25e66add48$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER, (data)=>{
                handler($a52fad25e66add48$var$SuperJSON.parse(data));
            });
        }
    };
}
// src/messaging/presets/extension/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/extension/client.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/extension/context.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$__EXTENSION_CLIENT_CONTEXT__ = "electron:client-context";
var $a52fad25e66add48$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__ = {
    // client
    CLIENT_TO_PROXY: "client->proxy",
    // on: proxy->client
    // proxy
    PROXY_TO_CLIENT: "proxy->client",
    // on: server->proxy
    PROXY_TO_SERVER: "proxy->server",
    // on: client->proxy
    // server
    SERVER_TO_PROXY: "server->proxy"
};
function $a52fad25e66add48$export$6c3de6c2be1b2806() {
    return (0, $gNtJt.target)[$a52fad25e66add48$var$__EXTENSION_CLIENT_CONTEXT__];
}
function $a52fad25e66add48$export$31a9a778785defb(context) {
    (0, $gNtJt.target)[$a52fad25e66add48$var$__EXTENSION_CLIENT_CONTEXT__] = context;
}
// src/messaging/presets/extension/client.ts
function $a52fad25e66add48$var$createExtensionClientChannel() {
    let disconnected = false;
    let port = null;
    let reconnectTimer = null;
    let onMessageHandler = null;
    function connect() {
        try {
            clearTimeout(reconnectTimer);
            port = chrome.runtime.connect({
                name: `${chrome.devtools.inspectedWindow.tabId}`
            });
            $a52fad25e66add48$export$31a9a778785defb(port);
            disconnected = false;
            port == null || port.onMessage.addListener(onMessageHandler);
            port.onDisconnect.addListener(()=>{
                disconnected = true;
                port == null || port.onMessage.removeListener(onMessageHandler);
                reconnectTimer = setTimeout(connect, 1e3);
            });
        } catch (e) {
            disconnected = true;
        }
    }
    connect();
    return {
        post: (data)=>{
            if (disconnected) return;
            port == null || port.postMessage($a52fad25e66add48$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            onMessageHandler = (data)=>{
                if (disconnected) return;
                handler($a52fad25e66add48$var$SuperJSON.parse(data));
            };
            port == null || port.onMessage.addListener(onMessageHandler);
        }
    };
}
// src/messaging/presets/extension/proxy.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$createExtensionProxyChannel() {
    const port = chrome.runtime.connect({
        name: "content-script"
    });
    function sendMessageToUserApp(payload) {
        window.postMessage({
            source: $a52fad25e66add48$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER,
            payload: payload
        }, "*");
    }
    function sendMessageToDevToolsClient(e) {
        if (e.data && e.data.source === $a52fad25e66add48$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY) try {
            port.postMessage(e.data.payload);
        } catch (e2) {}
    }
    port.onMessage.addListener(sendMessageToUserApp);
    window.addEventListener("message", sendMessageToDevToolsClient);
    port.onDisconnect.addListener(()=>{
        window.removeEventListener("message", sendMessageToDevToolsClient);
        sendMessageToUserApp($a52fad25e66add48$var$SuperJSON.stringify({
            event: "shutdown"
        }));
    });
    sendMessageToUserApp($a52fad25e66add48$var$SuperJSON.stringify({
        event: "init"
    }));
    return {
        post: (data)=>{},
        on: (handler)=>{}
    };
}
// src/messaging/presets/extension/server.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$createExtensionServerChannel() {
    return {
        post: (data)=>{
            window.postMessage({
                source: $a52fad25e66add48$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY,
                payload: $a52fad25e66add48$var$SuperJSON.stringify(data)
            }, "*");
        },
        on: (handler)=>{
            const listener = (event)=>{
                if (event.data.source === $a52fad25e66add48$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER && event.data.payload) handler($a52fad25e66add48$var$SuperJSON.parse(event.data.payload));
            };
            window.addEventListener("message", listener);
            return ()=>{
                window.removeEventListener("message", listener);
            };
        }
    };
}
// src/messaging/presets/iframe/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/iframe/client.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/iframe/context.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY = "__devtools-kit-iframe-messaging-event-key__";
var $a52fad25e66add48$var$__IFRAME_SERVER_CONTEXT__ = "iframe:server-context";
function $a52fad25e66add48$var$getIframeServerContext() {
    return (0, $gNtJt.target)[$a52fad25e66add48$var$__IFRAME_SERVER_CONTEXT__];
}
function $a52fad25e66add48$export$918b6d08f99ca1d5(context) {
    (0, $gNtJt.target)[$a52fad25e66add48$var$__IFRAME_SERVER_CONTEXT__] = context;
}
// src/messaging/presets/iframe/client.ts
function $a52fad25e66add48$var$createIframeClientChannel() {
    if (!(0, $gNtJt.isBrowser)) return {
        post: (data)=>{},
        on: (handler)=>{}
    };
    return {
        post: (data)=>window.parent.postMessage($a52fad25e66add48$var$SuperJSON.stringify({
                event: $a52fad25e66add48$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY,
                data: data
            }), "*"),
        on: (handler)=>window.addEventListener("message", (event)=>{
                try {
                    const parsed = $a52fad25e66add48$var$SuperJSON.parse(event.data);
                    if (event.source === window.parent && parsed.event === $a52fad25e66add48$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY) handler(parsed.data);
                } catch (e) {}
            })
    };
}
// src/messaging/presets/iframe/server.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$createIframeServerChannel() {
    if (!(0, $gNtJt.isBrowser)) return {
        post: (data)=>{},
        on: (handler)=>{}
    };
    return {
        post: (data)=>{
            var _a25;
            const iframe = $a52fad25e66add48$var$getIframeServerContext();
            (_a25 = iframe == null ? void 0 : iframe.contentWindow) == null || _a25.postMessage($a52fad25e66add48$var$SuperJSON.stringify({
                event: $a52fad25e66add48$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY,
                data: data
            }), "*");
        },
        on: (handler)=>{
            window.addEventListener("message", (event)=>{
                const iframe = $a52fad25e66add48$var$getIframeServerContext();
                try {
                    const parsed = $a52fad25e66add48$var$SuperJSON.parse(event.data);
                    if (event.source === (iframe == null ? void 0 : iframe.contentWindow) && parsed.event === $a52fad25e66add48$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY) handler(parsed.data);
                } catch (e) {}
            });
        }
    };
}
// src/messaging/presets/vite/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/vite/client.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/vite/context.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY = "__devtools-kit-vite-messaging-event-key__";
var $a52fad25e66add48$var$__VITE_CLIENT_CONTEXT__ = "vite:client-context";
var $a52fad25e66add48$var$__VITE_SERVER_CONTEXT__ = "vite:server-context";
function $a52fad25e66add48$var$getViteClientContext() {
    return (0, $gNtJt.target)[$a52fad25e66add48$var$__VITE_CLIENT_CONTEXT__];
}
function $a52fad25e66add48$export$8559d72d41937efd(context) {
    (0, $gNtJt.target)[$a52fad25e66add48$var$__VITE_CLIENT_CONTEXT__] = context;
}
function $a52fad25e66add48$var$getViteServerContext() {
    return (0, $gNtJt.target)[$a52fad25e66add48$var$__VITE_SERVER_CONTEXT__];
}
function $a52fad25e66add48$export$4c32fe701137877e(context) {
    (0, $gNtJt.target)[$a52fad25e66add48$var$__VITE_SERVER_CONTEXT__] = context;
}
// src/messaging/presets/vite/client.ts
function $a52fad25e66add48$var$createViteClientChannel() {
    const client = $a52fad25e66add48$var$getViteClientContext();
    return {
        post: (data)=>{
            client == null || client.send($a52fad25e66add48$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, $a52fad25e66add48$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            client == null || client.on($a52fad25e66add48$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, (event)=>{
                handler($a52fad25e66add48$var$SuperJSON.parse(event));
            });
        }
    };
}
// src/messaging/presets/vite/server.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$createViteServerChannel() {
    var _a25;
    const viteServer = $a52fad25e66add48$var$getViteServerContext();
    const ws = (_a25 = viteServer.hot) != null ? _a25 : viteServer.ws;
    return {
        post: (data)=>ws == null ? void 0 : ws.send($a52fad25e66add48$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, $a52fad25e66add48$var$SuperJSON.stringify(data)),
        on: (handler)=>ws == null ? void 0 : ws.on($a52fad25e66add48$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, (event)=>{
                handler($a52fad25e66add48$var$SuperJSON.parse(event));
            })
    };
}
// src/messaging/presets/ws/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/ws/client.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/ws/context.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/presets/ws/server.ts
$a52fad25e66add48$var$init_esm_shims();
// src/messaging/index.ts
var $a52fad25e66add48$var$_a19, $a52fad25e66add48$var$_b19;
($a52fad25e66add48$var$_b19 = ($a52fad25e66add48$var$_a19 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__) != null ? $a52fad25e66add48$var$_b19 : $a52fad25e66add48$var$_a19.__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ = [];
var $a52fad25e66add48$var$_a20, $a52fad25e66add48$var$_b20;
($a52fad25e66add48$var$_b20 = ($a52fad25e66add48$var$_a20 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_RPC_CLIENT__) != null ? $a52fad25e66add48$var$_b20 : $a52fad25e66add48$var$_a20.__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = null;
var $a52fad25e66add48$var$_a21, $a52fad25e66add48$var$_b21;
($a52fad25e66add48$var$_b21 = ($a52fad25e66add48$var$_a21 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_RPC_SERVER__) != null ? $a52fad25e66add48$var$_b21 : $a52fad25e66add48$var$_a21.__VUE_DEVTOOLS_KIT_RPC_SERVER__ = null;
var $a52fad25e66add48$var$_a22, $a52fad25e66add48$var$_b22;
($a52fad25e66add48$var$_b22 = ($a52fad25e66add48$var$_a22 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__) != null ? $a52fad25e66add48$var$_b22 : $a52fad25e66add48$var$_a22.__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = null;
var $a52fad25e66add48$var$_a23, $a52fad25e66add48$var$_b23;
($a52fad25e66add48$var$_b23 = ($a52fad25e66add48$var$_a23 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__) != null ? $a52fad25e66add48$var$_b23 : $a52fad25e66add48$var$_a23.__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = null;
var $a52fad25e66add48$var$_a24, $a52fad25e66add48$var$_b24;
($a52fad25e66add48$var$_b24 = ($a52fad25e66add48$var$_a24 = (0, $gNtJt.target)).__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__) != null ? $a52fad25e66add48$var$_b24 : $a52fad25e66add48$var$_a24.__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ = null;
function $a52fad25e66add48$var$setRpcClientToGlobal(rpc) {
    (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = rpc;
}
function $a52fad25e66add48$export$7f98be55f66c4a0d(rpc) {
    (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_RPC_SERVER__ = rpc;
}
function $a52fad25e66add48$export$9362d59e25b9feb1() {
    return (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_RPC_CLIENT__;
}
function $a52fad25e66add48$export$380718822fedc343() {
    return (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_RPC_SERVER__;
}
function $a52fad25e66add48$export$5f8b48d38df9666a(rpc) {
    (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = rpc;
}
function $a52fad25e66add48$export$5105f0908e5b2002(rpc) {
    (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = rpc;
}
function $a52fad25e66add48$export$c7310d0d7eeaac08() {
    return (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__;
}
function $a52fad25e66add48$export$97b242d29756c723() {
    return (0, $gNtJt.target).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__;
}
function $a52fad25e66add48$var$getChannel(preset, host = "client") {
    const channel = {
        iframe: {
            client: $a52fad25e66add48$var$createIframeClientChannel,
            server: $a52fad25e66add48$var$createIframeServerChannel
        }[host],
        electron: {
            client: $a52fad25e66add48$var$createElectronClientChannel,
            proxy: $a52fad25e66add48$var$createElectronProxyChannel,
            server: $a52fad25e66add48$var$createElectronServerChannel
        }[host],
        vite: {
            client: $a52fad25e66add48$var$createViteClientChannel,
            server: $a52fad25e66add48$var$createViteServerChannel
        }[host],
        broadcast: {
            client: $a52fad25e66add48$var$createBroadcastChannel,
            server: $a52fad25e66add48$var$createBroadcastChannel
        }[host],
        extension: {
            client: $a52fad25e66add48$var$createExtensionClientChannel,
            proxy: $a52fad25e66add48$var$createExtensionProxyChannel,
            server: $a52fad25e66add48$var$createExtensionServerChannel
        }[host]
    }[preset];
    return channel();
}
function $a52fad25e66add48$export$9c13c20c639717e6(functions, options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $a52fad25e66add48$var$getChannel(preset) : _channel;
    const rpc = (0, $5cFFA.createBirpc)(functions, {
        ..._options,
        ...channel,
        timeout: -1
    });
    if (preset === "vite") {
        $a52fad25e66add48$export$5f8b48d38df9666a(rpc);
        return;
    }
    $a52fad25e66add48$var$setRpcClientToGlobal(rpc);
    return rpc;
}
function $a52fad25e66add48$export$fbf8e1689a053c1c(functions, options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $a52fad25e66add48$var$getChannel(preset, "server") : _channel;
    const rpcServer = $a52fad25e66add48$export$380718822fedc343();
    if (!rpcServer) {
        const group = (0, $5cFFA.createBirpcGroup)(functions, [
            channel
        ], {
            ..._options,
            timeout: -1
        });
        if (preset === "vite") {
            $a52fad25e66add48$export$5105f0908e5b2002(group);
            return;
        }
        $a52fad25e66add48$export$7f98be55f66c4a0d(group);
    } else rpcServer.updateChannels((channels)=>{
        channels.push(channel);
    });
}
function $a52fad25e66add48$export$490df4aa0eb47722(options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $a52fad25e66add48$var$getChannel(preset, "proxy") : _channel;
    return (0, $5cFFA.createBirpc)({}, {
        ..._options,
        ...channel,
        timeout: -1
    });
}
// src/shared/index.ts
$a52fad25e66add48$var$init_esm_shims();
// src/shared/env.ts
$a52fad25e66add48$var$init_esm_shims();
// src/shared/time.ts
$a52fad25e66add48$var$init_esm_shims();
// src/shared/util.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/component/state/replacer.ts
$a52fad25e66add48$var$init_esm_shims();
// src/core/component/state/custom.ts
$a52fad25e66add48$var$init_esm_shims();
function $a52fad25e66add48$var$getFunctionDetails(func) {
    let string = "";
    let matches = null;
    try {
        string = Function.prototype.toString.call(func);
        matches = String.prototype.match.call(string, /\([\s\S]*?\)/);
    } catch (e) {}
    const match = matches && matches[0];
    const args = typeof match === "string" ? match : "(?)";
    const name = typeof func.name === "string" ? func.name : "";
    return {
        _custom: {
            type: "function",
            displayText: `<span style="opacity:.8;margin-right:5px;">function</span> <span style="white-space:nowrap;">${$a52fad25e66add48$export$4e7f196112fea3c5(name)}${args}</span>`,
            tooltipText: string.trim() ? `<pre>${string}</pre>` : null
        }
    };
}
function $a52fad25e66add48$var$getBigIntDetails(val) {
    const stringifiedBigInt = BigInt.prototype.toString.call(val);
    return {
        _custom: {
            type: "bigint",
            displayText: `BigInt(${stringifiedBigInt})`,
            value: stringifiedBigInt
        }
    };
}
function $a52fad25e66add48$var$getDateDetails(val) {
    const date = new Date(val.getTime());
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return {
        _custom: {
            type: "date",
            displayText: Date.prototype.toString.call(val),
            value: date.toISOString().slice(0, -1)
        }
    };
}
function $a52fad25e66add48$var$getMapDetails(val) {
    const list = Object.fromEntries(val);
    return {
        _custom: {
            type: "map",
            displayText: "Map",
            value: list,
            readOnly: true,
            fields: {
                abstract: true
            }
        }
    };
}
function $a52fad25e66add48$var$getSetDetails(val) {
    const list = Array.from(val);
    return {
        _custom: {
            type: "set",
            displayText: `Set[${list.length}]`,
            value: list,
            readOnly: true
        }
    };
}
function $a52fad25e66add48$var$getCaughtGetters(store) {
    const getters = {};
    const origGetters = store.getters || {};
    const keys = Object.keys(origGetters);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        Object.defineProperty(getters, key, {
            enumerable: true,
            get: ()=>{
                try {
                    return origGetters[key];
                } catch (e) {
                    return e;
                }
            }
        });
    }
    return getters;
}
function $a52fad25e66add48$var$reduceStateList(list) {
    if (!list.length) return void 0;
    return list.reduce((map, item)=>{
        const key = item.type || "data";
        const obj = map[key] = map[key] || {};
        obj[item.key] = item.value;
        return map;
    }, {});
}
function $a52fad25e66add48$var$namedNodeMapToObject(map) {
    const result = {};
    const l = map.length;
    for(let i = 0; i < l; i++){
        const node = map.item(i);
        result[node.name] = node.value;
    }
    return result;
}
function $a52fad25e66add48$var$getStoreDetails(store) {
    return {
        _custom: {
            type: "store",
            displayText: "Store",
            value: {
                state: store.state,
                getters: $a52fad25e66add48$var$getCaughtGetters(store)
            },
            fields: {
                abstract: true
            }
        }
    };
}
function $a52fad25e66add48$var$getRouterDetails(router) {
    return {
        _custom: {
            type: "router",
            displayText: "VueRouter",
            value: {
                options: router.options,
                currentRoute: router.currentRoute
            },
            fields: {
                abstract: true
            }
        }
    };
}
function $a52fad25e66add48$var$getInstanceDetails(instance) {
    if (instance._) instance = instance._;
    const state = $a52fad25e66add48$var$processInstanceState(instance);
    return {
        _custom: {
            type: "component",
            id: instance.__VUE_DEVTOOLS_NEXT_UID__,
            displayText: $a52fad25e66add48$var$getInstanceName(instance),
            tooltipText: "Component instance",
            value: $a52fad25e66add48$var$reduceStateList(state),
            fields: {
                abstract: true
            }
        }
    };
}
function $a52fad25e66add48$var$getComponentDefinitionDetails(definition) {
    let display = $a52fad25e66add48$var$getComponentName(definition);
    if (display) {
        if (definition.name && definition.__file) display += ` <span>(${definition.__file})</span>`;
    } else display = "<i>Unknown Component</i>";
    return {
        _custom: {
            type: "component-definition",
            displayText: display,
            tooltipText: "Component definition",
            ...definition.__file ? {
                file: definition.__file
            } : {}
        }
    };
}
function $a52fad25e66add48$var$getHTMLElementDetails(value) {
    try {
        return {
            _custom: {
                type: "HTMLElement",
                displayText: `<span class="opacity-30">&lt;</span><span class="text-blue-500">${value.tagName.toLowerCase()}</span><span class="opacity-30">&gt;</span>`,
                value: $a52fad25e66add48$var$namedNodeMapToObject(value.attributes)
            }
        };
    } catch (e) {
        return {
            _custom: {
                type: "HTMLElement",
                displayText: `<span class="text-blue-500">${String(value)}</span>`
            }
        };
    }
}
function $a52fad25e66add48$var$tryGetRefValue(ref) {
    if ($a52fad25e66add48$var$ensurePropertyExists(ref, "_value", true)) return ref._value;
    if ($a52fad25e66add48$var$ensurePropertyExists(ref, "value", true)) return ref.value;
}
function $a52fad25e66add48$var$getObjectDetails(object) {
    var _a25, _b25, _c, _d;
    const info = $a52fad25e66add48$var$getSetupStateType(object);
    const isState = info.ref || info.computed || info.reactive;
    if (isState) {
        const stateTypeName = info.computed ? "Computed" : info.ref ? "Ref" : info.reactive ? "Reactive" : null;
        const value = $a52fad25e66add48$var$toRaw2(info.reactive ? object : $a52fad25e66add48$var$tryGetRefValue(object));
        const raw = $a52fad25e66add48$var$ensurePropertyExists(object, "effect") ? ((_b25 = (_a25 = object.effect) == null ? void 0 : _a25.raw) == null ? void 0 : _b25.toString()) || ((_d = (_c = object.effect) == null ? void 0 : _c.fn) == null ? void 0 : _d.toString()) : null;
        return {
            _custom: {
                type: stateTypeName == null ? void 0 : stateTypeName.toLowerCase(),
                stateTypeName: stateTypeName,
                value: value,
                ...raw ? {
                    tooltipText: `<span class="font-mono">${raw}</span>`
                } : {}
            }
        };
    }
    if ($a52fad25e66add48$var$ensurePropertyExists(object, "__asyncLoader") && typeof object.__asyncLoader === "function") return {
        _custom: {
            type: "component-definition",
            display: "Async component definition"
        }
    };
}
// src/core/component/state/replacer.ts
function $a52fad25e66add48$var$stringifyReplacer(key, _value, depth, seenInstance) {
    var _a25;
    if (key === "compilerOptions") return;
    const val = this[key];
    const type = typeof val;
    if (Array.isArray(val)) {
        const l = val.length;
        if (l > $a52fad25e66add48$var$MAX_ARRAY_SIZE) return {
            _isArray: true,
            length: l,
            items: val.slice(0, $a52fad25e66add48$var$MAX_ARRAY_SIZE)
        };
        return val;
    } else if (typeof val === "string") {
        if (val.length > $a52fad25e66add48$var$MAX_STRING_SIZE) return `${val.substring(0, $a52fad25e66add48$var$MAX_STRING_SIZE)}... (${val.length} total length)`;
        else return val;
    } else if (type === "undefined") return $a52fad25e66add48$export$6db089fe7b26f5b6;
    else if (val === Number.POSITIVE_INFINITY) return $a52fad25e66add48$export$b4bf424ed968e242;
    else if (val === Number.NEGATIVE_INFINITY) return $a52fad25e66add48$export$95cb88e357cbada8;
    else if (typeof val === "function") return $a52fad25e66add48$var$getFunctionDetails(val);
    else if (type === "symbol") return `[native Symbol ${Symbol.prototype.toString.call(val)}]`;
    else if (typeof val === "bigint") return $a52fad25e66add48$var$getBigIntDetails(val);
    else if (val !== null && typeof val === "object") {
        const proto = Object.prototype.toString.call(val);
        if (proto === "[object Map]") return $a52fad25e66add48$var$getMapDetails(val);
        else if (proto === "[object Set]") return $a52fad25e66add48$var$getSetDetails(val);
        else if (proto === "[object RegExp]") return `[native RegExp ${RegExp.prototype.toString.call(val)}]`;
        else if (proto === "[object Date]") return $a52fad25e66add48$var$getDateDetails(val);
        else if (proto === "[object Error]") return `[native Error ${val.message}<>${val.stack}]`;
        else if ($a52fad25e66add48$var$ensurePropertyExists(val, "state", true) && $a52fad25e66add48$var$ensurePropertyExists(val, "_vm", true)) return $a52fad25e66add48$var$getStoreDetails(val);
        else if (val.constructor && val.constructor.name === "VueRouter") return $a52fad25e66add48$var$getRouterDetails(val);
        else if ($a52fad25e66add48$var$isVueInstance(val)) {
            const componentVal = $a52fad25e66add48$var$getInstanceDetails(val);
            const parentInstanceDepth = seenInstance == null ? void 0 : seenInstance.get(val);
            if (parentInstanceDepth && parentInstanceDepth < depth) return `[[CircularRef]] <${componentVal._custom.displayText}>`;
            seenInstance == null || seenInstance.set(val, depth);
            return componentVal;
        } else if ($a52fad25e66add48$var$ensurePropertyExists(val, "render", true) && typeof val.render === "function") return $a52fad25e66add48$var$getComponentDefinitionDetails(val);
        else if (val.constructor && val.constructor.name === "VNode") return `[native VNode <${val.tag}>]`;
        else if (typeof HTMLElement !== "undefined" && val instanceof HTMLElement) return $a52fad25e66add48$var$getHTMLElementDetails(val);
        else if (((_a25 = val.constructor) == null ? void 0 : _a25.name) === "Store" && "_wrappedGetters" in val) return "[object Store]";
        else if ($a52fad25e66add48$var$ensurePropertyExists(val, "currentRoute", true)) return "[object Router]";
        const customDetails = $a52fad25e66add48$var$getObjectDetails(val);
        if (customDetails != null) return customDetails;
    } else if (Number.isNaN(val)) return $a52fad25e66add48$export$d7ae0f70ebb9e144;
    return $a52fad25e66add48$var$sanitize(val);
}
// src/shared/transfer.ts
$a52fad25e66add48$var$init_esm_shims();
var $a52fad25e66add48$var$MAX_SERIALIZED_SIZE = 2097152;
function $a52fad25e66add48$var$isObject(_data, proto) {
    return proto === "[object Object]";
}
function $a52fad25e66add48$var$isArray3(_data, proto) {
    return proto === "[object Array]";
}
function $a52fad25e66add48$var$isVueReactiveLinkNode(node) {
    var _a25;
    const constructorName = (_a25 = node == null ? void 0 : node.constructor) == null ? void 0 : _a25.name;
    return constructorName === "Dep" && "activeLink" in node || constructorName === "Link" && "dep" in node;
}
function $a52fad25e66add48$var$encode(data, replacer, list, seen, depth = 0, seenVueInstance = /* @__PURE__ */ new Map()) {
    let stored;
    let key;
    let value;
    let i;
    let l;
    const seenIndex = seen.get(data);
    if (seenIndex != null) return seenIndex;
    const index = list.length;
    const proto = Object.prototype.toString.call(data);
    if ($a52fad25e66add48$var$isObject(data, proto)) {
        if ($a52fad25e66add48$var$isVueReactiveLinkNode(data)) return index;
        stored = {};
        seen.set(data, index);
        list.push(stored);
        const keys = Object.keys(data);
        for(i = 0, l = keys.length; i < l; i++){
            key = keys[i];
            if (key === "compilerOptions") return index;
            value = data[key];
            const isVm = value != null && $a52fad25e66add48$var$isObject(value, Object.prototype.toString.call(data)) && $a52fad25e66add48$var$isVueInstance(value);
            try {
                if (replacer) value = replacer.call(data, key, value, depth, seenVueInstance);
            } catch (e) {
                value = e;
            }
            stored[key] = $a52fad25e66add48$var$encode(value, replacer, list, seen, depth + 1, seenVueInstance);
            if (isVm) seenVueInstance.delete(value);
        }
    } else if ($a52fad25e66add48$var$isArray3(data, proto)) {
        stored = [];
        seen.set(data, index);
        list.push(stored);
        for(i = 0, l = data.length; i < l; i++){
            try {
                value = data[i];
                if (replacer) value = replacer.call(data, i, value, depth, seenVueInstance);
            } catch (e) {
                value = e;
            }
            stored[i] = $a52fad25e66add48$var$encode(value, replacer, list, seen, depth + 1, seenVueInstance);
        }
    } else list.push(data);
    return index;
}
function $a52fad25e66add48$var$decode(list, reviver2 = null) {
    let i = list.length;
    let j, k, data, key, value, proto;
    while(i--){
        data = list[i];
        proto = Object.prototype.toString.call(data);
        if (proto === "[object Object]") {
            const keys = Object.keys(data);
            for(j = 0, k = keys.length; j < k; j++){
                key = keys[j];
                value = list[data[key]];
                if (reviver2) value = reviver2.call(data, key, value);
                data[key] = value;
            }
        } else if (proto === "[object Array]") for(j = 0, k = data.length; j < k; j++){
            value = list[data[j]];
            if (reviver2) value = reviver2.call(data, j, value);
            data[j] = value;
        }
    }
}
function $a52fad25e66add48$var$stringifyCircularAutoChunks(data, replacer = null, space = null) {
    let result;
    try {
        result = arguments.length === 1 ? JSON.stringify(data) : JSON.stringify(data, (k, v)=>{
            var _a25;
            return (_a25 = replacer == null ? void 0 : replacer(k, v)) == null ? void 0 : _a25.call(this);
        }, space);
    } catch (e) {
        result = $a52fad25e66add48$var$stringifyStrictCircularAutoChunks(data, replacer, space);
    }
    if (result.length > $a52fad25e66add48$var$MAX_SERIALIZED_SIZE) {
        const chunkCount = Math.ceil(result.length / $a52fad25e66add48$var$MAX_SERIALIZED_SIZE);
        const chunks = [];
        for(let i = 0; i < chunkCount; i++)chunks.push(result.slice(i * $a52fad25e66add48$var$MAX_SERIALIZED_SIZE, (i + 1) * $a52fad25e66add48$var$MAX_SERIALIZED_SIZE));
        return chunks;
    }
    return result;
}
function $a52fad25e66add48$var$stringifyStrictCircularAutoChunks(data, replacer = null, space = null) {
    const list = [];
    $a52fad25e66add48$var$encode(data, replacer, list, /* @__PURE__ */ new Map());
    return space ? ` ${JSON.stringify(list, null, space)}` : ` ${JSON.stringify(list)}`;
}
function $a52fad25e66add48$var$parseCircularAutoChunks(data, reviver2 = null) {
    if (Array.isArray(data)) data = data.join("");
    const hasCircular = /^\s/.test(data);
    if (!hasCircular) return arguments.length === 1 ? JSON.parse(data) : JSON.parse(data, reviver2);
    else {
        const list = JSON.parse(data);
        $a52fad25e66add48$var$decode(list, reviver2);
        return list[0];
    }
}
// src/shared/util.ts
function $a52fad25e66add48$export$fac44ee5b035f737(data) {
    return $a52fad25e66add48$var$stringifyCircularAutoChunks(data, $a52fad25e66add48$var$stringifyReplacer);
}
function $a52fad25e66add48$export$98e6a39c04603d36(data, revive2 = false) {
    if (data == void 0) return {};
    return revive2 ? $a52fad25e66add48$var$parseCircularAutoChunks(data, $a52fad25e66add48$var$reviver) : $a52fad25e66add48$var$parseCircularAutoChunks(data);
}
// src/index.ts
var $a52fad25e66add48$export$6922d3b3a607469e = {
    hook: $a52fad25e66add48$var$hook,
    init: ()=>{
        $a52fad25e66add48$export$93f430585c3f6d11();
    },
    get ctx () {
        return $a52fad25e66add48$export$4f1904c03898171b;
    },
    get api () {
        return $a52fad25e66add48$export$4f1904c03898171b.api;
    }
};

});
parcelRegister("gNtJt", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $c3a84935ae81a360$export$4e09c449d6c407f7);
$parcel$export(module.exports, "target", () => $c3a84935ae81a360$export$44271b4f0c6a3563);
$parcel$export(module.exports, "isNuxtApp", () => $c3a84935ae81a360$export$e34a31924fd64105);
$parcel$export(module.exports, "classify", () => $c3a84935ae81a360$export$b04d9b8d414ba5e8);
$parcel$export(module.exports, "camelize", () => $c3a84935ae81a360$export$161d051f5dd25de7);
$parcel$export(module.exports, "kebabize", () => $c3a84935ae81a360$export$3b2e9c066cbbdd4c);
$parcel$export(module.exports, "basename", () => $c3a84935ae81a360$export$9bf319d8f74f51d1);
$parcel$export(module.exports, "isUrlString", () => $c3a84935ae81a360$export$8092cb61b2731942);
$parcel$export(module.exports, "deepClone", () => $c3a84935ae81a360$export$b7d58db314e0ac27);

var $N0o3H = parcelRequire("N0o3H");
var $c3a84935ae81a360$require$Buffer = $N0o3H.Buffer;
var $c3a84935ae81a360$var$__create = Object.create;
var $c3a84935ae81a360$var$__defProp = Object.defineProperty;
var $c3a84935ae81a360$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $c3a84935ae81a360$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $c3a84935ae81a360$var$__getProtoOf = Object.getPrototypeOf;
var $c3a84935ae81a360$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c3a84935ae81a360$var$__esm = (fn, res)=>function __init() {
        return fn && (res = (0, fn[$c3a84935ae81a360$var$__getOwnPropNames(fn)[0]])(fn = 0)), res;
    };
var $c3a84935ae81a360$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$c3a84935ae81a360$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $c3a84935ae81a360$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $c3a84935ae81a360$var$__getOwnPropNames(from))if (!$c3a84935ae81a360$var$__hasOwnProp.call(to, key) && key !== except) $c3a84935ae81a360$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $c3a84935ae81a360$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $c3a84935ae81a360$var$__toESM = (mod, isNodeMode, target2)=>(target2 = mod != null ? $c3a84935ae81a360$var$__create($c3a84935ae81a360$var$__getProtoOf(mod)) : {}, $c3a84935ae81a360$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $c3a84935ae81a360$var$__defProp(target2, "default", {
        value: mod,
        enumerable: true
    }) : target2, mod));
// ../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js
var $c3a84935ae81a360$var$init_esm_shims = $c3a84935ae81a360$var$__esm({
    "../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js" () {
        "use strict";
    }
});
// ../../node_modules/.pnpm/rfdc@1.4.1/node_modules/rfdc/index.js
var $c3a84935ae81a360$var$require_rfdc = $c3a84935ae81a360$var$__commonJS({
    "../../node_modules/.pnpm/rfdc@1.4.1/node_modules/rfdc/index.js" (exports, module) {
        "use strict";
        $c3a84935ae81a360$var$init_esm_shims();
        module.exports = rfdc2;
        function copyBuffer(cur) {
            if (cur instanceof $c3a84935ae81a360$require$Buffer) return $c3a84935ae81a360$require$Buffer.from(cur);
            return new cur.constructor(cur.buffer.slice(), cur.byteOffset, cur.length);
        }
        function rfdc2(opts) {
            opts = opts || {};
            if (opts.circles) return rfdcCircles(opts);
            const constructorHandlers = /* @__PURE__ */ new Map();
            constructorHandlers.set(Date, (o)=>new Date(o));
            constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
            constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
            if (opts.constructorHandlers) for (const handler2 of opts.constructorHandlers)constructorHandlers.set(handler2[0], handler2[1]);
            let handler = null;
            return opts.proto ? cloneProto : clone;
            function cloneArray(a, fn) {
                const keys = Object.keys(a);
                const a2 = new Array(keys.length);
                for(let i = 0; i < keys.length; i++){
                    const k = keys[i];
                    const cur = a[k];
                    if (typeof cur !== "object" || cur === null) a2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
                    else if (ArrayBuffer.isView(cur)) a2[k] = copyBuffer(cur);
                    else a2[k] = fn(cur);
                }
                return a2;
            }
            function clone(o) {
                if (typeof o !== "object" || o === null) return o;
                if (Array.isArray(o)) return cloneArray(o, clone);
                if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
                const o2 = {};
                for(const k in o){
                    if (Object.hasOwnProperty.call(o, k) === false) continue;
                    const cur = o[k];
                    if (typeof cur !== "object" || cur === null) o2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
                    else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                    else o2[k] = clone(cur);
                }
                return o2;
            }
            function cloneProto(o) {
                if (typeof o !== "object" || o === null) return o;
                if (Array.isArray(o)) return cloneArray(o, cloneProto);
                if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
                const o2 = {};
                for(const k in o){
                    const cur = o[k];
                    if (typeof cur !== "object" || cur === null) o2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
                    else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                    else o2[k] = cloneProto(cur);
                }
                return o2;
            }
        }
        function rfdcCircles(opts) {
            const refs = [];
            const refsNew = [];
            const constructorHandlers = /* @__PURE__ */ new Map();
            constructorHandlers.set(Date, (o)=>new Date(o));
            constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
            constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
            if (opts.constructorHandlers) for (const handler2 of opts.constructorHandlers)constructorHandlers.set(handler2[0], handler2[1]);
            let handler = null;
            return opts.proto ? cloneProto : clone;
            function cloneArray(a, fn) {
                const keys = Object.keys(a);
                const a2 = new Array(keys.length);
                for(let i = 0; i < keys.length; i++){
                    const k = keys[i];
                    const cur = a[k];
                    if (typeof cur !== "object" || cur === null) a2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
                    else if (ArrayBuffer.isView(cur)) a2[k] = copyBuffer(cur);
                    else {
                        const index = refs.indexOf(cur);
                        if (index !== -1) a2[k] = refsNew[index];
                        else a2[k] = fn(cur);
                    }
                }
                return a2;
            }
            function clone(o) {
                if (typeof o !== "object" || o === null) return o;
                if (Array.isArray(o)) return cloneArray(o, clone);
                if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
                const o2 = {};
                refs.push(o);
                refsNew.push(o2);
                for(const k in o){
                    if (Object.hasOwnProperty.call(o, k) === false) continue;
                    const cur = o[k];
                    if (typeof cur !== "object" || cur === null) o2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
                    else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                    else {
                        const i = refs.indexOf(cur);
                        if (i !== -1) o2[k] = refsNew[i];
                        else o2[k] = clone(cur);
                    }
                }
                refs.pop();
                refsNew.pop();
                return o2;
            }
            function cloneProto(o) {
                if (typeof o !== "object" || o === null) return o;
                if (Array.isArray(o)) return cloneArray(o, cloneProto);
                if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
                const o2 = {};
                refs.push(o);
                refsNew.push(o2);
                for(const k in o){
                    const cur = o[k];
                    if (typeof cur !== "object" || cur === null) o2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
                    else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                    else {
                        const i = refs.indexOf(cur);
                        if (i !== -1) o2[k] = refsNew[i];
                        else o2[k] = cloneProto(cur);
                    }
                }
                refs.pop();
                refsNew.pop();
                return o2;
            }
        }
    }
});
// src/index.ts
$c3a84935ae81a360$var$init_esm_shims();
// src/constants.ts
$c3a84935ae81a360$var$init_esm_shims();
var $c3a84935ae81a360$export$a13f7f627010bccd = "__vue-devtools-view-mode__";
var $c3a84935ae81a360$export$cb85e77fef76bd8b = "__vue-devtools-vite-plugin-detected__";
var $c3a84935ae81a360$export$45e7092a470efb27 = "__vue-devtools-vite-plugin-client-url__";
var $c3a84935ae81a360$export$a7ca7371bc63510e = "__vue-devtools-broadcast-channel__";
// src/env.ts
$c3a84935ae81a360$var$init_esm_shims();
var $c3a84935ae81a360$export$4e09c449d6c407f7 = typeof navigator !== "undefined";
var $c3a84935ae81a360$export$44271b4f0c6a3563 = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : typeof $parcel$global !== "undefined" ? $parcel$global : {};
var $c3a84935ae81a360$export$2a47bd138bf4827c = typeof $c3a84935ae81a360$export$44271b4f0c6a3563.chrome !== "undefined" && !!$c3a84935ae81a360$export$44271b4f0c6a3563.chrome.devtools;
var $c3a84935ae81a360$export$9f140ed41af5108c = $c3a84935ae81a360$export$4e09c449d6c407f7 && $c3a84935ae81a360$export$44271b4f0c6a3563.self !== $c3a84935ae81a360$export$44271b4f0c6a3563.top;
var $c3a84935ae81a360$var$_a;
var $c3a84935ae81a360$export$6272d088ce0bd5ee = typeof navigator !== "undefined" && (($c3a84935ae81a360$var$_a = navigator.userAgent) == null ? void 0 : $c3a84935ae81a360$var$_a.toLowerCase().includes("electron"));
var $c3a84935ae81a360$export$e34a31924fd64105 = typeof window !== "undefined" && !!window.__NUXT__;
var $c3a84935ae81a360$export$cd24a69e3c9a51c8 = !$c3a84935ae81a360$export$9f140ed41af5108c && !$c3a84935ae81a360$export$2a47bd138bf4827c && !$c3a84935ae81a360$export$6272d088ce0bd5ee;
// src/general.ts
$c3a84935ae81a360$var$init_esm_shims();
var $c3a84935ae81a360$var$import_rfdc = $c3a84935ae81a360$var$__toESM($c3a84935ae81a360$var$require_rfdc(), 1);
function $c3a84935ae81a360$export$5702a91a6f42969f() {}
var $c3a84935ae81a360$export$e90fb89750dba83f = (str)=>`${+str}` === str;
var $c3a84935ae81a360$export$6159e43e50a41987 = ()=>(navigator == null ? void 0 : navigator.platform) ? navigator == null ? void 0 : navigator.platform.toLowerCase().includes("mac") : /Macintosh/.test(navigator.userAgent);
var $c3a84935ae81a360$var$classifyRE = /(?:^|[-_/])(\w)/g;
var $c3a84935ae81a360$var$camelizeRE = /-(\w)/g;
var $c3a84935ae81a360$var$kebabizeRE = /([a-z0-9])([A-Z])/g;
function $c3a84935ae81a360$var$toUpper(_, c) {
    return c ? c.toUpperCase() : "";
}
function $c3a84935ae81a360$export$b04d9b8d414ba5e8(str) {
    return str && `${str}`.replace($c3a84935ae81a360$var$classifyRE, $c3a84935ae81a360$var$toUpper);
}
function $c3a84935ae81a360$export$161d051f5dd25de7(str) {
    return str && str.replace($c3a84935ae81a360$var$camelizeRE, $c3a84935ae81a360$var$toUpper);
}
function $c3a84935ae81a360$export$3b2e9c066cbbdd4c(str) {
    return str && str.replace($c3a84935ae81a360$var$kebabizeRE, (_, lowerCaseCharacter, upperCaseLetter)=>{
        return `${lowerCaseCharacter}-${upperCaseLetter}`;
    }).toLowerCase();
}
function $c3a84935ae81a360$export$9bf319d8f74f51d1(filename, ext) {
    let normalizedFilename = filename.replace(/^[a-z]:/i, "").replace(/\\/g, "/");
    if (normalizedFilename.endsWith(`index${ext}`)) normalizedFilename = normalizedFilename.replace(`/index${ext}`, ext);
    const lastSlashIndex = normalizedFilename.lastIndexOf("/");
    const baseNameWithExt = normalizedFilename.substring(lastSlashIndex + 1);
    if (ext) {
        const extIndex = baseNameWithExt.lastIndexOf(ext);
        return baseNameWithExt.substring(0, extIndex);
    }
    return "";
}
function $c3a84935ae81a360$export$584200199479c807(state) {
    return state && state.slice().sort((a, b)=>{
        if (a.key < b.key) return -1;
        if (a.key > b.key) return 1;
        return 0;
    });
}
var $c3a84935ae81a360$var$HTTP_URL_RE = /^https?:\/\//;
function $c3a84935ae81a360$export$8092cb61b2731942(str) {
    return str.startsWith("/") || $c3a84935ae81a360$var$HTTP_URL_RE.test(str);
}
var $c3a84935ae81a360$export$b7d58db314e0ac27 = (0, $c3a84935ae81a360$var$import_rfdc.default)({
    circles: true
});
function $c3a84935ae81a360$export$e700e91d2b9349e8() {
    return Math.random().toString(36).slice(2);
}
function $c3a84935ae81a360$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && !Array.isArray(value) && value !== null;
}
function $c3a84935ae81a360$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $c3a84935ae81a360$export$6750766a7c7ec627(value) {
    return value instanceof Set;
}
function $c3a84935ae81a360$export$5c90113a285f2241(value) {
    return value instanceof Map;
}

});
parcelRegister("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
'use strict';

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case 'base64':
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0934e0939605d48c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("bQMRt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
'use strict';
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup['-'.charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup['_'.charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("bV4bh", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $fee48cad4a6ef698$export$61fc7d43ac8f84b0);
const $fee48cad4a6ef698$var$DEBOUNCE_DEFAULTS = {
    trailing: true
};
function $fee48cad4a6ef698$export$61fc7d43ac8f84b0(fn, wait = 25, options = {}) {
    options = {
        ...$fee48cad4a6ef698$var$DEBOUNCE_DEFAULTS,
        ...options
    };
    if (!Number.isFinite(wait)) throw new TypeError("Expected `wait` to be a finite number");
    let leadingValue;
    let timeout;
    let resolveList = [];
    let currentPromise;
    let trailingArgs;
    const applyFn = (_this, args)=>{
        currentPromise = $fee48cad4a6ef698$var$_applyPromised(fn, _this, args);
        currentPromise.finally(()=>{
            currentPromise = null;
            if (options.trailing && trailingArgs && !timeout) {
                const promise = applyFn(_this, trailingArgs);
                trailingArgs = null;
                return promise;
            }
        });
        return currentPromise;
    };
    return function(...args) {
        if (currentPromise) {
            if (options.trailing) trailingArgs = args;
            return currentPromise;
        }
        return new Promise((resolve)=>{
            const shouldCallNow = !timeout && options.leading;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                timeout = null;
                const promise = options.leading ? leadingValue : applyFn(this, args);
                for (const _resolve of resolveList)_resolve(promise);
                resolveList = [];
            }, wait);
            if (shouldCallNow) {
                leadingValue = applyFn(this, args);
                resolve(leadingValue);
            } else resolveList.push(resolve);
        });
    };
}
async function $fee48cad4a6ef698$var$_applyPromised(fn, _this, args) {
    return await fn.apply(_this, args);
}

});

parcelRegister("55txk", function(module, exports) {

$parcel$export(module.exports, "createHooks", () => $69003061c4ed7b0f$export$39c6a2b4dbabca5d);
function $69003061c4ed7b0f$export$9089e2fc8ae509cd(configHooks, hooks = {}, parentName) {
    for(const key in configHooks){
        const subHook = configHooks[key];
        const name = parentName ? `${parentName}:${key}` : key;
        if (typeof subHook === "object" && subHook !== null) $69003061c4ed7b0f$export$9089e2fc8ae509cd(subHook, hooks, name);
        else if (typeof subHook === "function") hooks[name] = subHook;
    }
    return hooks;
}
function $69003061c4ed7b0f$export$3de1ffbf114b9f2d(...hooks) {
    const finalHooks = {};
    for (const hook of hooks){
        const flatenHook = $69003061c4ed7b0f$export$9089e2fc8ae509cd(hook);
        for(const key in flatenHook)if (finalHooks[key]) finalHooks[key].push(flatenHook[key]);
        else finalHooks[key] = [
            flatenHook[key]
        ];
    }
    for(const key in finalHooks)if (finalHooks[key].length > 1) {
        const array = finalHooks[key];
        finalHooks[key] = (...arguments_)=>$69003061c4ed7b0f$export$6c2c9a00e27c07e8(array, (function_)=>function_(...arguments_));
    } else finalHooks[key] = finalHooks[key][0];
    return finalHooks;
}
function $69003061c4ed7b0f$export$6c2c9a00e27c07e8(tasks, function_) {
    return tasks.reduce((promise, task)=>promise.then(()=>function_(task)), Promise.resolve());
}
const $69003061c4ed7b0f$var$defaultTask = {
    run: (function_)=>function_()
};
const $69003061c4ed7b0f$var$_createTask = ()=>$69003061c4ed7b0f$var$defaultTask;
const $69003061c4ed7b0f$var$createTask = typeof console.createTask !== "undefined" ? console.createTask : $69003061c4ed7b0f$var$_createTask;
function $69003061c4ed7b0f$var$serialTaskCaller(hooks, args) {
    const name = args.shift();
    const task = $69003061c4ed7b0f$var$createTask(name);
    return hooks.reduce((promise, hookFunction)=>promise.then(()=>task.run(()=>hookFunction(...args))), Promise.resolve());
}
function $69003061c4ed7b0f$var$parallelTaskCaller(hooks, args) {
    const name = args.shift();
    const task = $69003061c4ed7b0f$var$createTask(name);
    return Promise.all(hooks.map((hook)=>task.run(()=>hook(...args))));
}
function $69003061c4ed7b0f$export$e1dd809e3137c513(hooks, arguments_) {
    return hooks.reduce((promise, hookFunction)=>promise.then(()=>hookFunction(...arguments_ || [])), Promise.resolve());
}
function $69003061c4ed7b0f$export$23b1f1c6efb4a44a(hooks, args) {
    return Promise.all(hooks.map((hook)=>hook(...args || [])));
}
function $69003061c4ed7b0f$var$callEachWith(callbacks, arg0) {
    for (const callback of [
        ...callbacks
    ])callback(arg0);
}
class $69003061c4ed7b0f$export$f26845e0fc859724 {
    constructor(){
        this._hooks = {};
        this._before = void 0;
        this._after = void 0;
        this._deprecatedMessages = void 0;
        this._deprecatedHooks = {};
        this.hook = this.hook.bind(this);
        this.callHook = this.callHook.bind(this);
        this.callHookWith = this.callHookWith.bind(this);
    }
    hook(name, function_, options = {}) {
        if (!name || typeof function_ !== "function") return ()=>{};
        const originalName = name;
        let dep;
        while(this._deprecatedHooks[name]){
            dep = this._deprecatedHooks[name];
            name = dep.to;
        }
        if (dep && !options.allowDeprecated) {
            let message = dep.message;
            if (!message) message = `${originalName} hook has been deprecated` + (dep.to ? `, please use ${dep.to}` : "");
            if (!this._deprecatedMessages) this._deprecatedMessages = /* @__PURE__ */ new Set();
            if (!this._deprecatedMessages.has(message)) {
                console.warn(message);
                this._deprecatedMessages.add(message);
            }
        }
        if (!function_.name) try {
            Object.defineProperty(function_, "name", {
                get: ()=>"_" + name.replace(/\W+/g, "_") + "_hook_cb",
                configurable: true
            });
        } catch  {}
        this._hooks[name] = this._hooks[name] || [];
        this._hooks[name].push(function_);
        return ()=>{
            if (function_) {
                this.removeHook(name, function_);
                function_ = void 0;
            }
        };
    }
    hookOnce(name, function_) {
        let _unreg;
        let _function = (...arguments_)=>{
            if (typeof _unreg === "function") _unreg();
            _unreg = void 0;
            _function = void 0;
            return function_(...arguments_);
        };
        _unreg = this.hook(name, _function);
        return _unreg;
    }
    removeHook(name, function_) {
        if (this._hooks[name]) {
            const index = this._hooks[name].indexOf(function_);
            if (index !== -1) this._hooks[name].splice(index, 1);
            if (this._hooks[name].length === 0) delete this._hooks[name];
        }
    }
    deprecateHook(name, deprecated) {
        this._deprecatedHooks[name] = typeof deprecated === "string" ? {
            to: deprecated
        } : deprecated;
        const _hooks = this._hooks[name] || [];
        delete this._hooks[name];
        for (const hook of _hooks)this.hook(name, hook);
    }
    deprecateHooks(deprecatedHooks) {
        Object.assign(this._deprecatedHooks, deprecatedHooks);
        for(const name in deprecatedHooks)this.deprecateHook(name, deprecatedHooks[name]);
    }
    addHooks(configHooks) {
        const hooks = $69003061c4ed7b0f$export$9089e2fc8ae509cd(configHooks);
        const removeFns = Object.keys(hooks).map((key)=>this.hook(key, hooks[key]));
        return ()=>{
            for (const unreg of removeFns.splice(0, removeFns.length))unreg();
        };
    }
    removeHooks(configHooks) {
        const hooks = $69003061c4ed7b0f$export$9089e2fc8ae509cd(configHooks);
        for(const key in hooks)this.removeHook(key, hooks[key]);
    }
    removeAllHooks() {
        for(const key in this._hooks)delete this._hooks[key];
    }
    callHook(name, ...arguments_) {
        arguments_.unshift(name);
        return this.callHookWith($69003061c4ed7b0f$var$serialTaskCaller, name, ...arguments_);
    }
    callHookParallel(name, ...arguments_) {
        arguments_.unshift(name);
        return this.callHookWith($69003061c4ed7b0f$var$parallelTaskCaller, name, ...arguments_);
    }
    callHookWith(caller, name, ...arguments_) {
        const event = this._before || this._after ? {
            name: name,
            args: arguments_,
            context: {}
        } : void 0;
        if (this._before) $69003061c4ed7b0f$var$callEachWith(this._before, event);
        const result = caller(name in this._hooks ? [
            ...this._hooks[name]
        ] : [], arguments_);
        if (result instanceof Promise) return result.finally(()=>{
            if (this._after && event) $69003061c4ed7b0f$var$callEachWith(this._after, event);
        });
        if (this._after && event) $69003061c4ed7b0f$var$callEachWith(this._after, event);
        return result;
    }
    beforeEach(function_) {
        this._before = this._before || [];
        this._before.push(function_);
        return ()=>{
            if (this._before !== void 0) {
                const index = this._before.indexOf(function_);
                if (index !== -1) this._before.splice(index, 1);
            }
        };
    }
    afterEach(function_) {
        this._after = this._after || [];
        this._after.push(function_);
        return ()=>{
            if (this._after !== void 0) {
                const index = this._after.indexOf(function_);
                if (index !== -1) this._after.splice(index, 1);
            }
        };
    }
}
function $69003061c4ed7b0f$export$39c6a2b4dbabca5d() {
    return new $69003061c4ed7b0f$export$f26845e0fc859724();
}
const $69003061c4ed7b0f$var$isBrowser = typeof window !== "undefined";
function $69003061c4ed7b0f$export$acfdf6f45fa21f5e(hooks, _options = {}) {
    const options = {
        inspect: $69003061c4ed7b0f$var$isBrowser,
        group: $69003061c4ed7b0f$var$isBrowser,
        filter: ()=>true,
        ..._options
    };
    const _filter = options.filter;
    const filter = typeof _filter === "string" ? (name)=>name.startsWith(_filter) : _filter;
    const _tag = options.tag ? `[${options.tag}] ` : "";
    const logPrefix = (event)=>_tag + event.name + "".padEnd(event._id, "\0");
    const _idCtr = {};
    const unsubscribeBefore = hooks.beforeEach((event)=>{
        if (filter !== void 0 && !filter(event.name)) return;
        _idCtr[event.name] = _idCtr[event.name] || 0;
        event._id = _idCtr[event.name]++;
        console.time(logPrefix(event));
    });
    const unsubscribeAfter = hooks.afterEach((event)=>{
        if (filter !== void 0 && !filter(event.name)) return;
        if (options.group) console.groupCollapsed(event.name);
        if (options.inspect) console.timeLog(logPrefix(event), event.args);
        else console.timeEnd(logPrefix(event));
        if (options.group) console.groupEnd();
        _idCtr[event.name]--;
    });
    return {
        /** Stop debugging and remove listeners */ close: ()=>{
            unsubscribeBefore();
            unsubscribeAfter();
        }
    };
}

});

parcelRegister("5cFFA", function(module, exports) {

$parcel$export(module.exports, "createBirpc", () => $e8fb92ca21f9e2f9$export$8de909a09ac6851a);
$parcel$export(module.exports, "createBirpcGroup", () => $e8fb92ca21f9e2f9$export$ec516731f3c62ae5);
const $e8fb92ca21f9e2f9$var$TYPE_REQUEST = "q";
const $e8fb92ca21f9e2f9$var$TYPE_RESPONSE = "s";
const $e8fb92ca21f9e2f9$export$7bd623b29ec8e1eb = 6e4;
function $e8fb92ca21f9e2f9$var$defaultSerialize(i) {
    return i;
}
const $e8fb92ca21f9e2f9$var$defaultDeserialize = $e8fb92ca21f9e2f9$var$defaultSerialize;
const { clearTimeout: $e8fb92ca21f9e2f9$var$clearTimeout, setTimeout: $e8fb92ca21f9e2f9$var$setTimeout } = globalThis;
const $e8fb92ca21f9e2f9$var$random = Math.random.bind(Math);
function $e8fb92ca21f9e2f9$export$8de909a09ac6851a($functions, options) {
    const { post: post, on: on, off: off = ()=>{}, eventNames: eventNames = [], serialize: serialize = $e8fb92ca21f9e2f9$var$defaultSerialize, deserialize: deserialize = $e8fb92ca21f9e2f9$var$defaultDeserialize, resolver: resolver, bind: bind = "rpc", timeout: timeout = $e8fb92ca21f9e2f9$export$7bd623b29ec8e1eb } = options;
    let $closed = false;
    const _rpcPromiseMap = /* @__PURE__ */ new Map();
    let _promiseInit;
    async function _call(method, args, event, optional) {
        if ($closed) throw new Error(`[birpc] rpc is closed, cannot call "${method}"`);
        const req = {
            m: method,
            a: args,
            t: $e8fb92ca21f9e2f9$var$TYPE_REQUEST
        };
        if (optional) req.o = true;
        const send = async (_req)=>post(serialize(_req));
        if (event) {
            await send(req);
            return;
        }
        if (_promiseInit) try {
            await _promiseInit;
        } finally{
            _promiseInit = void 0;
        }
        let { promise: promise, resolve: resolve, reject: reject } = $e8fb92ca21f9e2f9$var$createPromiseWithResolvers();
        const id = $e8fb92ca21f9e2f9$var$nanoid();
        req.i = id;
        let timeoutId;
        async function handler(newReq = req) {
            if (timeout >= 0) {
                timeoutId = $e8fb92ca21f9e2f9$var$setTimeout(()=>{
                    try {
                        const handleResult = options.onTimeoutError?.(method, args);
                        if (handleResult !== true) throw new Error(`[birpc] timeout on calling "${method}"`);
                    } catch (e) {
                        reject(e);
                    }
                    _rpcPromiseMap.delete(id);
                }, timeout);
                if (typeof timeoutId === "object") timeoutId = timeoutId.unref?.();
            }
            _rpcPromiseMap.set(id, {
                resolve: resolve,
                reject: reject,
                timeoutId: timeoutId,
                method: method
            });
            await send(newReq);
            return promise;
        }
        try {
            if (options.onRequest) await options.onRequest(req, handler, resolve);
            else await handler();
        } catch (e) {
            if (options.onGeneralError?.(e) !== true) throw e;
            return;
        } finally{
            $e8fb92ca21f9e2f9$var$clearTimeout(timeoutId);
            _rpcPromiseMap.delete(id);
        }
        return promise;
    }
    const $call = (method, ...args)=>_call(method, args, false);
    const $callOptional = (method, ...args)=>_call(method, args, false, true);
    const $callEvent = (method, ...args)=>_call(method, args, true);
    const $callRaw = (options2)=>_call(options2.method, options2.args, options2.event, options2.optional);
    const builtinMethods = {
        $call: $call,
        $callOptional: $callOptional,
        $callEvent: $callEvent,
        $callRaw: $callRaw,
        $rejectPendingCalls: $rejectPendingCalls,
        get $closed () {
            return $closed;
        },
        $close: $close,
        $functions: $functions
    };
    const rpc = new Proxy({}, {
        get (_, method) {
            if (Object.prototype.hasOwnProperty.call(builtinMethods, method)) return builtinMethods[method];
            if (method === "then" && !eventNames.includes("then") && !("then" in $functions)) return void 0;
            const sendEvent = (...args)=>_call(method, args, true);
            if (eventNames.includes(method)) {
                sendEvent.asEvent = sendEvent;
                return sendEvent;
            }
            const sendCall = (...args)=>_call(method, args, false);
            sendCall.asEvent = sendEvent;
            return sendCall;
        }
    });
    function $close(customError) {
        $closed = true;
        _rpcPromiseMap.forEach(({ reject: reject, method: method })=>{
            const error = new Error(`[birpc] rpc is closed, cannot call "${method}"`);
            if (customError) {
                customError.cause ??= error;
                return reject(customError);
            }
            reject(error);
        });
        _rpcPromiseMap.clear();
        off(onMessage);
    }
    function $rejectPendingCalls(handler) {
        const entries = Array.from(_rpcPromiseMap.values());
        const handlerResults = entries.map(({ method: method, reject: reject })=>{
            if (!handler) return reject(new Error(`[birpc]: rejected pending call "${method}".`));
            return handler({
                method: method,
                reject: reject
            });
        });
        _rpcPromiseMap.clear();
        return handlerResults;
    }
    async function onMessage(data, ...extra) {
        let msg;
        try {
            msg = deserialize(data);
        } catch (e) {
            if (options.onGeneralError?.(e) !== true) throw e;
            return;
        }
        if (msg.t === $e8fb92ca21f9e2f9$var$TYPE_REQUEST) {
            const { m: method, a: args, o: optional } = msg;
            let result, error;
            let fn = await (resolver ? resolver(method, $functions[method]) : $functions[method]);
            if (optional) fn ||= ()=>void 0;
            if (!fn) error = new Error(`[birpc] function "${method}" not found`);
            else try {
                result = await fn.apply(bind === "rpc" ? rpc : $functions, args);
            } catch (e) {
                error = e;
            }
            if (msg.i) {
                if (error && options.onError) options.onError(error, method, args);
                if (error && options.onFunctionError) {
                    if (options.onFunctionError(error, method, args) === true) return;
                }
                if (!error) try {
                    await post(serialize({
                        t: $e8fb92ca21f9e2f9$var$TYPE_RESPONSE,
                        i: msg.i,
                        r: result
                    }), ...extra);
                    return;
                } catch (e) {
                    error = e;
                    if (options.onGeneralError?.(e, method, args) !== true) throw e;
                }
                try {
                    await post(serialize({
                        t: $e8fb92ca21f9e2f9$var$TYPE_RESPONSE,
                        i: msg.i,
                        e: error
                    }), ...extra);
                } catch (e) {
                    if (options.onGeneralError?.(e, method, args) !== true) throw e;
                }
            }
        } else {
            const { i: ack, r: result, e: error } = msg;
            const promise = _rpcPromiseMap.get(ack);
            if (promise) {
                $e8fb92ca21f9e2f9$var$clearTimeout(promise.timeoutId);
                if (error) promise.reject(error);
                else promise.resolve(result);
            }
            _rpcPromiseMap.delete(ack);
        }
    }
    _promiseInit = on(onMessage);
    return rpc;
}
const $e8fb92ca21f9e2f9$var$cacheMap = /* @__PURE__ */ new WeakMap();
function $e8fb92ca21f9e2f9$export$c26b4cbcfe84a428(items, fn) {
    return items.map((i)=>{
        let r = $e8fb92ca21f9e2f9$var$cacheMap.get(i);
        if (!r) {
            r = fn(i);
            $e8fb92ca21f9e2f9$var$cacheMap.set(i, r);
        }
        return r;
    });
}
function $e8fb92ca21f9e2f9$export$ec516731f3c62ae5(functions, channels, options = {}) {
    const getChannels = ()=>typeof channels === "function" ? channels() : channels;
    const getClients = (channels2 = getChannels())=>$e8fb92ca21f9e2f9$export$c26b4cbcfe84a428(channels2, (s)=>$e8fb92ca21f9e2f9$export$8de909a09ac6851a(functions, {
                ...options,
                ...s
            }));
    function _boardcast(method, args, event, optional) {
        const clients = getClients();
        return Promise.all(clients.map((c)=>c.$callRaw({
                method: method,
                args: args,
                event: event,
                optional: optional
            })));
    }
    function $call(method, ...args) {
        return _boardcast(method, args, false);
    }
    function $callOptional(method, ...args) {
        return _boardcast(method, args, false, true);
    }
    function $callEvent(method, ...args) {
        return _boardcast(method, args, true);
    }
    const broadcastBuiltin = {
        $call: $call,
        $callOptional: $callOptional,
        $callEvent: $callEvent
    };
    const broadcastProxy = new Proxy({}, {
        get (_, method) {
            if (Object.prototype.hasOwnProperty.call(broadcastBuiltin, method)) return broadcastBuiltin[method];
            const client = getClients();
            const callbacks = client.map((c)=>c[method]);
            const sendCall = (...args)=>{
                return Promise.all(callbacks.map((i)=>i(...args)));
            };
            sendCall.asEvent = async (...args)=>{
                await Promise.all(callbacks.map((i)=>i.asEvent(...args)));
            };
            return sendCall;
        }
    });
    function updateChannels(fn) {
        const channels2 = getChannels();
        fn?.(channels2);
        return getClients(channels2);
    }
    getClients();
    return {
        get clients () {
            return getClients();
        },
        functions: functions,
        updateChannels: updateChannels,
        broadcast: broadcastProxy,
        /**
     * @deprecated use `broadcast`
     */ // @ts-expect-error deprecated
        boardcast: broadcastProxy
    };
}
function $e8fb92ca21f9e2f9$var$createPromiseWithResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
const $e8fb92ca21f9e2f9$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
function $e8fb92ca21f9e2f9$var$nanoid(size = 21) {
    let id = "";
    let i = size;
    while(i--)id += $e8fb92ca21f9e2f9$var$urlAlphabet[$e8fb92ca21f9e2f9$var$random() * 64 | 0];
    return id;
}

});





parcelRegister("9w9TI", function(module, exports) {

$parcel$export(module.exports, "useFormTopics", () => $93ee1e8a4cb7b060$export$dad1bbf6fb94b1e5);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");

var $4qljO = parcelRequire("4qljO");
const $93ee1e8a4cb7b060$var$QUERY_PARAM_Q = 'q';
const $93ee1e8a4cb7b060$var$PRIVACY_QUERY_VALUE = 'privacy';
const $93ee1e8a4cb7b060$var$isPrivacyOptionPriority = ()=>{
    return new URLSearchParams(window.location.search).get($93ee1e8a4cb7b060$var$QUERY_PARAM_Q)?.toLowerCase() === $93ee1e8a4cb7b060$var$PRIVACY_QUERY_VALUE;
};
const $93ee1e8a4cb7b060$export$dad1bbf6fb94b1e5 = ()=>{
    const contactFormStore = (0, $4qljO.useContactFormStore)();
    const currentTopic = (0, $8bTPG.ref)('');
    if ($93ee1e8a4cb7b060$var$isPrivacyOptionPriority()) currentTopic.value = contactFormStore.getFirstFormItem?.topicPrivacyOption ?? '';
    const allTopics = (0, $8bTPG.computed)(()=>{
        const privacy = contactFormStore.getFirstFormItem?.topicPrivacyOption ?? '';
        const contactList = contactFormStore.getFirstFormItem?.topicContactListOption ?? '';
        const otherTopics = contactFormStore.getFirstFormItem?.otherFormTopics ?? [];
        return [
            privacy,
            contactList,
            ...otherTopics
        ].filter(Boolean);
    });
    const privacyActive = (0, $8bTPG.computed)(()=>currentTopic.value === contactFormStore.getFirstFormItem?.topicPrivacyOption);
    const contactListActive = (0, $8bTPG.computed)(()=>currentTopic.value === contactFormStore.getFirstFormItem?.topicContactListOption);
    const otherTopicActive = (0, $8bTPG.computed)(()=>{
        const otherTopics = contactFormStore.getFirstFormItem?.otherFormTopics ?? [];
        return otherTopics.includes(currentTopic.value);
    });
    return {
        currentTopic: currentTopic,
        allTopics: allTopics,
        privacyActive: privacyActive,
        contactListActive: contactListActive,
        otherTopicActive: otherTopicActive
    };
};

});

parcelRegister("cLmPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $94ab9539cca5b434$export$2e2bcd8739ae039);
let $94ab9539cca5b434$var$script;




let $94ab9539cca5b434$var$initialize = ()=>{
    $94ab9539cca5b434$var$script = (parcelRequire("bgxtE"));
    if ($94ab9539cca5b434$var$script.__esModule) $94ab9539cca5b434$var$script = $94ab9539cca5b434$var$script.default;
    $94ab9539cca5b434$var$script.render = (parcelRequire("i8zSM")).render;
    $94ab9539cca5b434$var$script.__cssModules = {};
    (parcelRequire("eKwmW")).default($94ab9539cca5b434$var$script);
    $94ab9539cca5b434$var$script.__scopeId = 'data-v-0fbf09';
    $94ab9539cca5b434$var$script.__file = "ContactFormPrivacyOption.vue";
};
$94ab9539cca5b434$var$initialize();
var $94ab9539cca5b434$export$2e2bcd8739ae039 = $94ab9539cca5b434$var$script;

});
parcelRegister("bgxtE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0713c14043e3a50a$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $Xyp3G = parcelRequire("Xyp3G");

var $aEW9o = parcelRequire("aEW9o");
var $0713c14043e3a50a$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $ani5R.defineComponent)({
    __name: 'ContactFormPrivacyOption',
    props: {
        formItem: {},
        rtlItem: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const { currentCountry: currentCountry, countrySelectionMade: countrySelectionMade, countryNameList: countryNameList, selectedCountryItem: selectedCountryItem } = (0, $Xyp3G.useCountrySelection)();
        const __returned__ = {
            currentCountry: currentCountry,
            countrySelectionMade: countrySelectionMade,
            countryNameList: countryNameList,
            selectedCountryItem: selectedCountryItem,
            ContactFormPrivacyInfo: $aEW9o.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("Xyp3G", function(module, exports) {

$parcel$export(module.exports, "useCountrySelection", () => $47ec25ecb42c096e$export$a03dc7e16bd82498);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");

var $4qljO = parcelRequire("4qljO");
const $47ec25ecb42c096e$var$getCountryNameList = (countryItems)=>{
    return countryItems.map((countryItem)=>countryItem.countryName);
};
const $47ec25ecb42c096e$export$a03dc7e16bd82498 = ()=>{
    const contactFormStore = (0, $4qljO.useContactFormStore)();
    const currentCountry = (0, $8bTPG.ref)('');
    const countryNameList = (0, $8bTPG.computed)(()=>$47ec25ecb42c096e$var$getCountryNameList(contactFormStore.getCountryItems ?? []));
    const countrySelectionMade = (0, $8bTPG.computed)(()=>currentCountry.value !== '');
    const selectedCountryItem = (0, $8bTPG.computed)(()=>{
        const items = contactFormStore.getCountryItems ?? [];
        return items.find((item)=>item.countryName === currentCountry.value) ?? null;
    });
    return {
        currentCountry: currentCountry,
        countrySelectionMade: countrySelectionMade,
        countryNameList: countryNameList,
        selectedCountryItem: selectedCountryItem
    };
};

});

parcelRegister("aEW9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2abf4c9e67833e$export$2e2bcd8739ae039);
let $7c2abf4c9e67833e$var$script;




let $7c2abf4c9e67833e$var$initialize = ()=>{
    $7c2abf4c9e67833e$var$script = (parcelRequire("e4d9l"));
    if ($7c2abf4c9e67833e$var$script.__esModule) $7c2abf4c9e67833e$var$script = $7c2abf4c9e67833e$var$script.default;
    $7c2abf4c9e67833e$var$script.render = (parcelRequire("f58OY")).render;
    $7c2abf4c9e67833e$var$script.__cssModules = {};
    (parcelRequire("i97ww")).default($7c2abf4c9e67833e$var$script);
    $7c2abf4c9e67833e$var$script.__scopeId = 'data-v-1040d5';
    $7c2abf4c9e67833e$var$script.__file = "ContactFormPrivacyInfo.vue";
};
$7c2abf4c9e67833e$var$initialize();
var $7c2abf4c9e67833e$export$2e2bcd8739ae039 = $7c2abf4c9e67833e$var$script;

});
parcelRegister("e4d9l", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e5b128b702ac1305$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $8bTPG = parcelRequire("8bTPG");

var $2TTF4 = parcelRequire("2TTF4");

var $KO22c = parcelRequire("KO22c");

var $7hLIV = parcelRequire("7hLIV");
var $e5b128b702ac1305$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $ani5R.defineComponent)({
    __name: 'ContactFormPrivacyInfo',
    props: {
        isActive: {
            type: Boolean
        },
        formItem: {},
        countryItem: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const countryItemRef = (0, $8bTPG.toRef)(props, 'countryItem');
        const { clearCss: clearCss } = (0, $KO22c.useClearCss)();
        const { currentRole: currentRole, isRoles: isRoles, getRoleOptions: getRoleOptions, showSecondInfo: showSecondInfo, getSecondInfo: getSecondInfo, showCTA: showCTA, getCTAInfo: getCTAInfo } = (0, $2TTF4.usePrivacySelection)(props.formItem, countryItemRef);
        const __returned__ = {
            props: props,
            countryItemRef: countryItemRef,
            clearCss: clearCss,
            currentRole: currentRole,
            isRoles: isRoles,
            getRoleOptions: getRoleOptions,
            showSecondInfo: showSecondInfo,
            getSecondInfo: getSecondInfo,
            showCTA: showCTA,
            getCTAInfo: getCTAInfo,
            ContactFormPrivacyCTA: $7hLIV.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("2TTF4", function(module, exports) {

$parcel$export(module.exports, "usePrivacySelection", () => $d153b9c9650c31ac$export$278e015949ace6b5);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
const $d153b9c9650c31ac$var$generateLabel = (label, value)=>{
    return {
        label: label,
        value: value
    };
};
const $d153b9c9650c31ac$export$278e015949ace6b5 = (formItem, countryItem)=>{
    const currentRole = (0, $8bTPG.ref)('');
    const currentDecision = (0, $8bTPG.computed)(()=>countryItem.value?.countryJourneyDecision);
    const isRoles = (0, $8bTPG.computed)(()=>currentDecision.value === 'ROLES');
    const isCta = (0, $8bTPG.computed)(()=>currentDecision.value === 'CTA');
    const isEnd = (0, $8bTPG.computed)(()=>currentDecision.value === 'END');
    const getRoleOptions = (0, $8bTPG.computed)(()=>{
        const roleOptions = [];
        if (countryItem.value?.consumerRoleShowRoleOption) roleOptions.push($d153b9c9650c31ac$var$generateLabel(formItem.roleOptionConsumer, '0'));
        if (countryItem.value?.businessRoleShowRoleOption) roleOptions.push($d153b9c9650c31ac$var$generateLabel(formItem.roleOptionBusiness, '1'));
        if (countryItem.value?.formerRoleShowRoleOption) roleOptions.push($d153b9c9650c31ac$var$generateLabel(formItem.roleOptionFormer, '2'));
        if (countryItem.value?.employeeRoleShowRoleOption) roleOptions.push($d153b9c9650c31ac$var$generateLabel(formItem.roleOptionEmployee, '3'));
        return roleOptions;
    });
    const getCurrentRoleIndex = (0, $8bTPG.computed)(()=>{
        return typeof currentRole.value === 'string' && currentRole.value !== '' ? parseInt(currentRole.value, 10) : -1;
    });
    const getSecondInfoRoleChoice = (0, $8bTPG.computed)(()=>{
        const roleChoices = [
            countryItem.value?.consumerRoleShowInformation,
            countryItem.value?.businessRoleShowInformation,
            countryItem.value?.formerRoleShowInformation,
            countryItem.value?.employeeRoleShowInformation
        ];
        return roleChoices[getCurrentRoleIndex.value];
    });
    const showSecondInfo = (0, $8bTPG.computed)(()=>{
        if (isEnd.value || isCta.value) return false;
        return isRoles.value && getSecondInfoRoleChoice.value;
    });
    const getSecondInfo = (0, $8bTPG.computed)(()=>{
        const secondPanelHtmlOptions = [
            countryItem.value?.consumerRoleInformation?.html,
            countryItem.value?.businessRoleInformation?.html,
            countryItem.value?.formerRoleInformation?.html,
            countryItem.value?.employeeRoleInformation?.html
        ];
        const secondPanelHtml = secondPanelHtmlOptions[getCurrentRoleIndex.value];
        return secondPanelHtml ?? '';
    });
    const getCtaRoleChoice = (0, $8bTPG.computed)(()=>{
        const roleChoices = [
            countryItem.value?.consumerRoleShowCTA,
            countryItem.value?.businessRoleShowCTA,
            countryItem.value?.formerRoleShowCTA,
            countryItem.value?.employeeRoleShowCTA
        ];
        return roleChoices[getCurrentRoleIndex.value];
    });
    const getRolesCtaInfo = (0, $8bTPG.computed)(()=>{
        const urlChoices = [
            countryItem.value?.consumerRoleFormUrl,
            countryItem.value?.businessRoleFormUrl,
            countryItem.value?.formerRoleFormUrl,
            countryItem.value?.employeeRoleFormUrl
        ];
        const ctaChoices = [
            countryItem.value?.consumerRoleFormCTA,
            countryItem.value?.businessRoleFormCTA,
            countryItem.value?.formerRoleFormCTA,
            countryItem.value?.employeeRoleFormCTA
        ];
        const urlChoice = urlChoices[getCurrentRoleIndex.value] ?? '';
        const ctaChoice = ctaChoices[getCurrentRoleIndex.value] ?? '';
        return {
            urlChoice: urlChoice,
            ctaChoice: ctaChoice
        };
    });
    const getCtaInfoFromNoRole = (0, $8bTPG.computed)(()=>{
        return {
            urlChoice: countryItem.value?.noRoleFormUrl ?? '',
            ctaChoice: countryItem.value?.noRoleFormCTA ?? ''
        };
    });
    const showCTA = (0, $8bTPG.computed)(()=>{
        return isCta.value || isRoles.value && getCtaRoleChoice.value;
    });
    const getCTAInfo = (0, $8bTPG.computed)(()=>{
        if (isRoles.value) return getRolesCtaInfo.value;
        if (isCta.value) return getCtaInfoFromNoRole.value;
        return {
            urlChoice: '',
            ctaChoice: ''
        };
    });
    (0, $8bTPG.watch)(countryItem, ()=>{
        currentRole.value = '';
    });
    return {
        currentRole: currentRole,
        isRoles: isRoles,
        getRoleOptions: getRoleOptions,
        showSecondInfo: showSecondInfo,
        getSecondInfo: getSecondInfo,
        showCTA: showCTA,
        getCTAInfo: getCTAInfo
    };
};

});

parcelRegister("KO22c", function(module, exports) {

$parcel$export(module.exports, "useClearCss", () => $1e5737815987e4da$export$fbc323a8e69500d);

var $8Wkn8 = parcelRequire("8Wkn8");
const $1e5737815987e4da$export$fbc323a8e69500d = ()=>{
    const clearCss = (htmlStr)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($8Wkn8))).sanitize(htmlStr, {
            FORBID_ATTR: [
                'style'
            ]
        });
    };
    return {
        clearCss: clearCss
    };
};

});
parcelRegister("8Wkn8", function(module, exports) {
/*! @license DOMPurify 3.4.16 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.16/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _OverloadYield(e, d) {
        this.v = e, this.k = d;
    }
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    function AsyncGenerator(e) {
        var t, n;
        function resume(t, n) {
            try {
                var r = e[t](n), o = r.value, u = o instanceof _OverloadYield;
                Promise.resolve(u ? o.v : o).then(function(n) {
                    if (u) {
                        var i = "return" === t && o.k ? t : "next";
                        if (!o.k || n.done) return resume(i, n);
                        n = e[i](n).value;
                    }
                    settle(!!r.done, n);
                }, function(e) {
                    resume("throw", e);
                });
            } catch (e) {
                settle(2, e);
            }
        }
        function settle(e, r) {
            2 === e ? t.reject(r) : t.resolve({
                value: r,
                done: e
            }), (t = t.next) ? resume(t.key, t.arg) : n = null;
        }
        this._invoke = function(e, r) {
            return new Promise(function(o, u) {
                var i = {
                    key: e,
                    arg: r,
                    resolve: o,
                    reject: u,
                    next: null
                };
                n ? n = n.next = i : (t = n = i, resume(e, r));
            });
        }, "function" != typeof e.return && (this.return = void 0);
    }
    AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
        return this;
    }, AsyncGenerator.prototype.next = function(e) {
        return this._invoke("next", e);
    }, AsyncGenerator.prototype.throw = function(e) {
        return this._invoke("throw", e);
    }, AsyncGenerator.prototype.return = function(e) {
        return this._invoke("return", e);
    };
    const entries = Object.entries;
    const setPrototypeOf = Object.setPrototypeOf;
    const isFrozen = Object.isFrozen;
    const getPrototypeOf = Object.getPrototypeOf;
    const getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    let freeze = Object.freeze;
    let seal = Object.seal;
    let create = Object.create;
    let _ref = typeof Reflect !== "undefined" && Reflect;
    let apply = _ref.apply;
    let construct = _ref.construct;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    Array.prototype.indexOf;
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    Array.prototype.slice;
    const arraySplice = unapply(Array.prototype.splice);
    const arrayIsArray = Array.isArray;
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const numberToString = unapply(Number.prototype.toString);
    const booleanToString = unapply(Boolean.prototype.toString);
    const bigintToString = typeof BigInt === "undefined" ? null : unapply(BigInt.prototype.toString);
    const symbolToString = typeof Symbol === "undefined" ? null : unapply(Symbol.prototype.toString);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const objectToString = unapply(Object.prototype.toString);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
	* Creates a new function that calls the given function with a specified thisArg and arguments.
	*
	* @param func - The function to be wrapped and called.
	* @returns A new function that calls the given function with a specified thisArg and arguments.
	*/ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
	* Creates a new function that constructs an instance of the given constructor function with the provided arguments.
	*
	* @param func - The constructor function to be wrapped and called.
	* @returns A new function that constructs an instance of the given constructor function with the provided arguments.
	*/ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
	* Add properties to a lookup table
	*
	* @param set - The set to which elements will be added.
	* @param array - The array containing elements to be added to the set.
	* @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
	* @returns The modified set with added elements.
	*/ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) setPrototypeOf(set, null);
        if (!arrayIsArray(array)) return set;
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === "string") {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
	* Clean up an array to harden against CSPP
	*
	* @param array - The array to be cleaned.
	* @returns The cleaned version of the array
	*/ function cleanArray(array) {
        for(let index = 0; index < array.length; index++)if (!objectHasOwnProperty(array, index)) array[index] = null;
        return array;
    }
    /**
	* Shallow clone an object
	*
	* @param object - The object to be cloned.
	* @returns A new object that copies the original.
	*/ function clone(object) {
        const newObject = create(null);
        for (const _ref2 of entries(object)){
            var _ref3 = _slicedToArray(_ref2, 2);
            const property = _ref3[0];
            const value = _ref3[1];
            if (objectHasOwnProperty(object, property)) {
                if (arrayIsArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === "object" && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
	* Convert non-node values into strings without depending on direct property access.
	*
	* @param value - The value to stringify.
	* @returns A string representation of the provided value.
	*/ function stringifyValue(value) {
        switch(typeof value){
            case "string":
                return value;
            case "number":
                return numberToString(value);
            case "boolean":
                return booleanToString(value);
            case "bigint":
                return bigintToString ? bigintToString(value) : "0";
            case "symbol":
                return symbolToString ? symbolToString(value) : "Symbol()";
            case "undefined":
                return objectToString(value);
            case "function":
            case "object":
                {
                    if (value === null) return objectToString(value);
                    const valueAsRecord = value;
                    const valueToString = lookupGetter(valueAsRecord, "toString");
                    if (typeof valueToString === "function") {
                        const stringified = valueToString(valueAsRecord);
                        return typeof stringified === "string" ? stringified : objectToString(stringified);
                    }
                    return objectToString(value);
                }
            default:
                return objectToString(value);
        }
    }
    /**
	* This method automatically checks if the prop is function or getter and behaves accordingly.
	*
	* @param object - The object to look up the getter function in its prototype chain.
	* @param prop - The property name for which to find the getter function.
	* @returns The getter function found in the prototype chain or a fallback function.
	*/ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    function isRegex(value) {
        try {
            regExpTest(value, "");
            return true;
        } catch (_unused) {
            return false;
        }
    }
    const html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "search",
        "section",
        "select",
        "shadow",
        "slot",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]);
    const svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "enterkeyhint",
        "exportparts",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "inputmode",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "part",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    const svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feDropShadow",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]);
    const svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    const mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover",
        "mprescripts"
    ]);
    const mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    const text = freeze([
        "#text"
    ]);
    const html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "command",
        "commandfor",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "exportparts",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inert",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "part",
        "pattern",
        "placeholder",
        "playsinline",
        "popover",
        "popovertarget",
        "popovertargetaction",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "slot",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "wrap",
        "xmlns"
    ]);
    const svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "amplitude",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dominant-baseline",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "exponent",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "intercept",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "mask-type",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "pointer-events",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "slope",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "tablevalues",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-orientation",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "vector-effect",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    const mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnalign",
        "columnlines",
        "columnspacing",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lquote",
        "lspace",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    const xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    const MUSTACHE_EXPR = seal(/{{[\w\W]*|^[\w\W]*}}/g);
    const ERB_EXPR = seal(/<%[\w\W]*|^[\w\W]*%>/g);
    const TMPLIT_EXPR = seal(/\${[\w\W]*/g);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/);
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/);
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i);
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g);
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    const ELEMENT_MARKUP_PROBE = seal(/<[/\w!]/g);
    const COMMENT_MARKUP_PROBE = seal(/<[/\w]/g);
    const FALLBACK_TAG_CLOSE = seal(/<\/no(script|embed|frames)/i);
    const SELF_CLOSING_TAG = seal(/\/>/i);
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        entityNode: 6,
        processingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12
    };
    const LITERAL_TEXT_ELEMENT_NAMES = [
        "style",
        "script",
        "xmp",
        "iframe",
        "noembed",
        "noframes",
        "plaintext",
        "noscript"
    ];
    const LITERAL_TEXT_ELEMENTS = freeze(addToSet({}, LITERAL_TEXT_ELEMENT_NAMES));
    const LITERAL_TEXT_CLOSE = function() {
        const map = {};
        arrayForEach(LITERAL_TEXT_ELEMENT_NAMES, (name)=>{
            map[name] = seal(new RegExp("</" + name + "(?=[\\t\\n\\f\\r />])", "i"));
        });
        return freeze(map);
    }();
    const getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
	* Creates a no-op policy for internal use only.
	* Don't export this function outside this module!
	* @param trustedTypes The policy factory.
	* @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
	* @return The policy created (or null, if Trusted Types
	* are not supported or creating the policy failed).
	*/ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
        let suffix = null;
        const ATTR_NAME = "data-tt-policy-suffix";
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    /**
	* Resolve a set-valued configuration option: a fresh set built from
	* cfg[key] when it is an own array property (seeded with a clone of
	* options.base when given, case-normalized via options.transform),
	* the fallback set otherwise.
	*
	* @param cfg the cloned, prototype-free configuration object
	* @param key the configuration property to read
	* @param fallback the set to use when the option is absent or not an array
	* @param options transform and optional base set to merge into
	* @returns the resolved set
	*/ const _resolveSetOption = function _resolveSetOption(cfg, key, fallback, options) {
        return objectHasOwnProperty(cfg, key) && arrayIsArray(cfg[key]) ? addToSet(options.base ? clone(options.base) : {}, cfg[key], options.transform) : fallback;
    };
    /**
	* Resolve an object-valued configuration option: a prototype-free clone
	* of cfg[key] when it is an own, truthy object property, else a fresh
	* fallback built by makeFallback (fresh on every parse, so a previous
	* parse can never leak state into the next one).
	*
	* @param cfg the cloned, prototype-free configuration object
	* @param key the configuration property to read
	* @param makeFallback builds the fallback value when the option is absent
	* @returns the resolved object
	*/ const _resolveObjectOption = function _resolveObjectOption(cfg, key, makeFallback) {
        const value = objectHasOwnProperty(cfg, key) ? cfg[key] : void 0;
        return value && typeof value === "object" ? clone(value) : makeFallback();
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = "3.4.16";
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let document = window1.document;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        window1.DocumentFragment;
        const HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter;
        window1.NamedNodeMap === void 0 && (window1.NamedNodeMap || window1.MozNamedAttrMap);
        window1.HTMLFormElement;
        const DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        const remove = lookupGetter(ElementPrototype, "remove");
        const removeAttributeNode = lookupGetter(ElementPrototype, "removeAttributeNode");
        const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        const getParentNode = lookupGetter(ElementPrototype, "parentNode");
        const getShadowRoot = lookupGetter(ElementPrototype, "shadowRoot");
        const getAttributes = lookupGetter(ElementPrototype, "attributes");
        const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, "nodeType") : null;
        const getNodeName = Node && Node.prototype ? lookupGetter(Node.prototype, "nodeName") : null;
        const getOwnerDocument = Node && Node.prototype ? lookupGetter(Node.prototype, "ownerDocument") : null;
        const _readNodeType = function _readNodeType(node) {
            return getNodeType ? getNodeType(node) : node.nodeType;
        };
        const _readNodeName = function _readNodeName(node) {
            return getNodeName ? getNodeName(node) : node.nodeName;
        };
        if (typeof HTMLTemplateElement === "function") {
            const template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = "";
        let defaultTrustedTypesPolicy;
        let defaultTrustedTypesPolicyResolved = false;
        let IN_TRUSTED_TYPES_POLICY = 0;
        const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy() {
            if (IN_TRUSTED_TYPES_POLICY > 0) throw typeErrorCreate("A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the \"DOMPurify and Trusted Types\" section of the README.");
        };
        const _createTrustedHTML = function _createTrustedHTML(html) {
            _assertNotInTrustedTypesPolicy();
            IN_TRUSTED_TYPES_POLICY++;
            try {
                return trustedTypesPolicy.createHTML(html);
            } finally{
                IN_TRUSTED_TYPES_POLICY--;
            }
        };
        const _createTrustedScriptURL = function _createTrustedScriptURL(scriptUrl) {
            _assertNotInTrustedTypesPolicy();
            IN_TRUSTED_TYPES_POLICY++;
            try {
                return trustedTypesPolicy.createScriptURL(scriptUrl);
            } finally{
                IN_TRUSTED_TYPES_POLICY--;
            }
        };
        const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy() {
            if (!defaultTrustedTypesPolicyResolved) {
                defaultTrustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                defaultTrustedTypesPolicyResolved = true;
            }
            return defaultTrustedTypesPolicy;
        };
        const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        const importNode = originalDocument.importNode;
        let hooks = _createHooksMap();
        /**
		* Expose whether this browser supports running the full DOMPurify.
		*/ DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== void 0;
        const MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
		* We consider the elements and attributes below to be safe. Ideally
		* don't add any new ones but feel free to remove unwanted ones.
		*/ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        let FORBID_TAGS = null;
        let FORBID_ATTR = null;
        const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        let ALLOW_ARIA_ATTR = true;
        let ALLOW_DATA_ATTR = true;
        let ALLOW_UNKNOWN_PROTOCOLS = false;
        let ALLOW_SELF_CLOSE_IN_ATTR = true;
        let SAFE_FOR_TEMPLATES = false;
        let SAFE_FOR_XML = true;
        let WHOLE_DOCUMENT = false;
        let SET_CONFIG = false;
        let SET_CONFIG_ALLOWED_TAGS = null;
        let SET_CONFIG_ALLOWED_ATTR = null;
        let FORCE_BODY = false;
        let RETURN_DOM = false;
        let RETURN_DOM_FRAGMENT = false;
        let RETURN_TRUSTED_TYPE = false;
        let SANITIZE_DOM = true;
        let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        let KEEP_CONTENT = true;
        let IN_PLACE = false;
        let USE_PROFILES = {};
        let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "selectedcontent",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = freeze([
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
        const DEFAULT_HTML_INTEGRATION_POINTS = freeze([
            "annotation-xml"
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        let transformCaseFunc = null;
        let CONFIG = null;
        const formElement = document.createElement("form");
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
		* _parseConfig
		*
		* @param cfg optional config literal
		*/ const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            if (!cfg || typeof cfg !== "object") cfg = {};
            cfg = clone(cfg);
            PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            ALLOWED_TAGS = _resolveSetOption(cfg, "ALLOWED_TAGS", DEFAULT_ALLOWED_TAGS, {
                transform: transformCaseFunc
            });
            ALLOWED_ATTR = _resolveSetOption(cfg, "ALLOWED_ATTR", DEFAULT_ALLOWED_ATTR, {
                transform: transformCaseFunc
            });
            ALLOWED_NAMESPACES = _resolveSetOption(cfg, "ALLOWED_NAMESPACES", DEFAULT_ALLOWED_NAMESPACES, {
                transform: stringToString
            });
            URI_SAFE_ATTRIBUTES = _resolveSetOption(cfg, "ADD_URI_SAFE_ATTR", DEFAULT_URI_SAFE_ATTRIBUTES, {
                transform: transformCaseFunc,
                base: DEFAULT_URI_SAFE_ATTRIBUTES
            });
            DATA_URI_TAGS = _resolveSetOption(cfg, "ADD_DATA_URI_TAGS", DEFAULT_DATA_URI_TAGS, {
                transform: transformCaseFunc,
                base: DEFAULT_DATA_URI_TAGS
            });
            FORBID_CONTENTS = _resolveSetOption(cfg, "FORBID_CONTENTS", DEFAULT_FORBID_CONTENTS, {
                transform: transformCaseFunc
            });
            FORBID_TAGS = _resolveSetOption(cfg, "FORBID_TAGS", clone({}), {
                transform: transformCaseFunc
            });
            FORBID_ATTR = _resolveSetOption(cfg, "FORBID_ATTR", clone({}), {
                transform: transformCaseFunc
            });
            USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === "object" ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
            RETURN_DOM = cfg.RETURN_DOM || false;
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
            FORCE_BODY = cfg.FORCE_BODY || false;
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
            IN_PLACE = cfg.IN_PLACE || false;
            IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI;
            NAMESPACE = typeof cfg.NAMESPACE === "string" ? cfg.NAMESPACE : HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = _resolveObjectOption(cfg, "MATHML_TEXT_INTEGRATION_POINTS", ()=>addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS));
            HTML_INTEGRATION_POINTS = _resolveObjectOption(cfg, "HTML_INTEGRATION_POINTS", ()=>addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS));
            const customElementHandling = _resolveObjectOption(cfg, "CUSTOM_ELEMENT_HANDLING", ()=>create(null));
            CUSTOM_ELEMENT_HANDLING = create(null);
            if (objectHasOwnProperty(customElementHandling, "tagNameCheck") && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck;
            if (objectHasOwnProperty(customElementHandling, "attributeNameCheck") && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck;
            if (objectHasOwnProperty(customElementHandling, "allowCustomizedBuiltInElements") && typeof customElementHandling.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements;
            seal(CUSTOM_ELEMENT_HANDLING);
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = create(null);
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            EXTRA_ELEMENT_HANDLING.tagCheck = null;
            EXTRA_ELEMENT_HANDLING.attributeCheck = null;
            if (objectHasOwnProperty(cfg, "ADD_TAGS")) {
                if (typeof cfg.ADD_TAGS === "function") EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else if (arrayIsArray(cfg.ADD_TAGS)) {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, "ADD_ATTR")) {
                if (typeof cfg.ADD_ATTR === "function") EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else if (arrayIsArray(cfg.ADD_ATTR)) {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, "ADD_FORBID_CONTENTS") && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw typeErrorCreate("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw typeErrorCreate("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
                const previousTrustedTypesPolicy = trustedTypesPolicy;
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                try {
                    emptyHTML = _createTrustedHTML("");
                } catch (error) {
                    trustedTypesPolicy = previousTrustedTypesPolicy;
                    throw error;
                }
            } else if (cfg.TRUSTED_TYPES_POLICY === null) {
                trustedTypesPolicy = void 0;
                emptyHTML = "";
            } else {
                if (trustedTypesPolicy === void 0) trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
                if (trustedTypesPolicy && typeof emptyHTML === "string") emptyHTML = _createTrustedHTML("");
            }
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
		* Namespace rules for an element in the SVG namespace.
		*
		* @param tagName the element's lowercase tag name
		* @param parent the (possibly simulated) parent node
		* @param parentTagName the parent's lowercase tag name
		* @returns true if a spec-compliant parser could produce this element
		*/ const _checkSvgNamespace = function _checkSvgNamespace(tagName, parent, parentTagName) {
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
            if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
            return Boolean(ALL_SVG_TAGS[tagName]);
        };
        /**
		* Namespace rules for an element in the MathML namespace.
		*
		* @param tagName the element's lowercase tag name
		* @param parent the (possibly simulated) parent node
		* @param parentTagName the parent's lowercase tag name
		* @returns true if a spec-compliant parser could produce this element
		*/ const _checkMathMlNamespace = function _checkMathMlNamespace(tagName, parent, parentTagName) {
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
            if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
            return Boolean(ALL_MATHML_TAGS[tagName]);
        };
        /**
		* Namespace rules for an element in the HTML namespace.
		*
		* @param tagName the element's lowercase tag name
		* @param parent the (possibly simulated) parent node
		* @param parentTagName the parent's lowercase tag name
		* @returns true if a spec-compliant parser could produce this element
		*/ const _checkHtmlNamespace = function _checkHtmlNamespace(tagName, parent, parentTagName) {
            if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
            if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
            return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        };
        /**
		* @param element a DOM element whose namespace is being checked
		* @returns Return false if the element has a
		*  namespace that a spec-compliant parser would never
		*  return. Return true otherwise.
		*/ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: "template"
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) return _checkSvgNamespace(tagName, parent, parentTagName);
            if (element.namespaceURI === MATHML_NAMESPACE) return _checkMathMlNamespace(tagName, parent, parentTagName);
            if (element.namespaceURI === HTML_NAMESPACE) return _checkHtmlNamespace(tagName, parent, parentTagName);
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            return false;
        };
        /**
		* _forceRemove
		*
		* @param node a DOM node
		*/ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
                if (!getParentNode(node)) throw typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
            }
        };
        /**
		* _stripAttributeNode
		*
		* Remove a single Attr node case/namespace-exactly on an attribute-teardown
		* path. Name-based removeAttribute() ASCII-lowercases its lookup key for an
		* HTML element in an HTML document and so silently misses a case-preserved
		* handler (e.g. `ONERROR` off an XML/XHTML import) - the same defect
		* _removeAttribute() was fixed for, which a name-based call would reintroduce
		* on these IN_PLACE teardown paths. Unlike _removeAttribute this does not
		* record into DOMPurify.removed: the neutralize passes intentionally do not
		* book-keep. A clobbered/detached node falls back to best-effort name-based
		* removal.
		*
		* @param element the element to strip the attribute from
		* @param attribute the Attr node to remove
		* @param name the attribute's name, for the fallback path
		*/ const _stripAttributeNode = function _stripAttributeNode(element, attribute, name) {
            try {
                removeAttributeNode(element, attribute);
            } catch (_) {
                try {
                    element.removeAttribute(name);
                } catch (_) {}
            }
        };
        /**
		* _neutralizeRoot
		*
		* Fail-closed teardown of an in-place root after the sanitize walk aborts
		* (campaign-3 F2). An internal throw mid-walk — e.g. a page-registered
		* custom element's reaction detaches a node so `_forceRemove`'s deliberate
		* parentless guard throws, or any other re-entrant engine mutation — would
		* otherwise leave the caller's *live* tree half-sanitized, with everything
		* after the abort point still carrying its handlers. There is no safe way
		* to resume the walk (the tree mutated under us), so we strip the root bare:
		* remove every child and every attribute, then let the caller's catch see
		* the original error. Clobber-safe (cached `remove`/`childNodes`/`attributes`
		* getters; the root was already clobber-pre-flighted at the IN_PLACE entry).
		*
		* @param root the in-place root to empty
		*/ const _neutralizeRoot = function _neutralizeRoot(root) {
            _neutralizeSubtree(root);
            const childNodes = getChildNodes(root);
            if (childNodes) {
                const snapshot = [];
                arrayForEach(childNodes, (child)=>{
                    arrayPush(snapshot, child);
                });
                arrayForEach(snapshot, (child)=>{
                    try {
                        remove(child);
                    } catch (_) {}
                });
            }
            const attributes = getAttributes(root);
            if (attributes) for(let i = attributes.length - 1; i >= 0; --i){
                const attribute = attributes[i];
                const name = attribute && attribute.name;
                if (typeof name === "string") _stripAttributeNode(root, attribute, name);
            }
        };
        /**
		* _removeAttribute
		*
		* Name-based getAttributeNode()/removeAttribute() ASCII-lowercase their
		* lookup key for HTML elements in an HTML document, so they silently miss an
		* attribute whose stored qualified name still contains uppercase ASCII
		* letters. That happens when the node came from a case-preserving source
		* (an XML/XHTML document imported via importNode(), or createAttributeNS()),
		* where e.g. `ONERROR` survives the walk: the policy check lowercases to
		* `onerror` and rejects it, but `removeAttribute('ONERROR')` looks up
		* `onerror` and finds nothing. Remove the exact Attr node instead, which is
		* case- and namespace-exact, and fall back to name-based removal only when
		* the caller could not supply the node.
		*
		* @param name an Attribute name
		* @param element a DOM node
		* @param attr the exact Attr node to remove, when the caller has it
		*/ const _removeAttribute = function _removeAttribute(name, element, attr) {
            if (!attr) try {
                attr = element.getAttributeNode(name);
            } catch (_) {
                attr = null;
            }
            arrayPush(DOMPurify.removed, {
                attribute: attr || null,
                from: element
            });
            try {
                if (attr) removeAttributeNode(element, attr);
                else element.removeAttribute(name);
            } catch (_) {
                try {
                    element.removeAttribute(name);
                } catch (_) {}
            }
            if (name === "is") {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
		* _stripDisallowedAttributes
		*
		* Removes every attribute the active configuration does not allow from a
		* single element, using the same allowlist as the main attribute pass (so
		* `on*` handlers go, but no `/^on/` blocklist is introduced). Used only to
		* neutralise nodes that are being discarded from an in-place tree.
		*
		* @param element the element to strip
		*/ const _stripDisallowedAttributes = function _stripDisallowedAttributes(element) {
            const attributes = getAttributes(element);
            if (!attributes) return;
            for(let i = attributes.length - 1; i >= 0; --i){
                const attribute = attributes[i];
                const name = attribute && attribute.name;
                if (typeof name !== "string" || ALLOWED_ATTR[transformCaseFunc(name)]) continue;
                _stripAttributeNode(element, attribute, name);
            }
        };
        /**
		* _neutralizeSubtree
		*
		* Completes the audit-5 F1 fix across every removal path. The KEEP_CONTENT
		* move-hoist neutralises only disallowed-tag removals; clobber, mXSS-canary,
		* namespace, comment, processing-instruction and KEEP_CONTENT:false removals
		* all drop their subtree wholesale via `_forceRemove`. On the IN_PLACE path
		* those dropped nodes are detached from the caller's LIVE tree but a
		* handler-bearing original among them (an `<img onerror>`/`<video>` that was
		* loading) keeps its queued resource event, which fires in page scope after
		* sanitize returns. This walks a removed subtree and strips every attribute
		* the active configuration does not allow — so `on*` handlers are cancelled
		* through the SAME allowlist that governs kept nodes, not a separate `/^on/`
		* blocklist. Run synchronously before sanitize returns, i.e. before any
		* queued event can fire. Hook-free by design: these nodes leave the output,
		* so firing attribute hooks for them would be surprising. Clobber-safe reads;
		* a doomed clobbered node may shadow `removeAttribute` (its own attributes are
		* irrelevant — it is discarded — while its non-clobbered descendants, e.g.
		* the `<img>`, are reached and scrubbed).
		*
		* @param root the root of a removed subtree to neutralise
		*/ const _neutralizeSubtree = function _neutralizeSubtree(root) {
            const stack = [
                root
            ];
            while(stack.length > 0){
                const node = stack.pop();
                if (_readNodeType(node) === NODE_TYPE.element) _stripDisallowedAttributes(node);
                const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
            }
        };
        /**
		* _neutralizePatchLinkage
		*
		* IN_PLACE entry pre-pass (declarative-partial-updates / streaming
		* hardening, https://github.com/WICG/declarative-partial-updates).
		*
		* The main walk strips patch linkage (`for`/`patchsrc`) and removes range
		* markers (PIs / markup comments) node-by-node, in document order, AS it
		* reaches each node. On a live in-place root that leaves a window: from the
		* moment the root is connected until the walk arrives at a given node, that
		* node's linkage is live. A patch applied on connection/stream can fire as
		* a microtask during the walk and inject or teleport an unsanitized DOM
		* range into a region the iterator has already passed and will not revisit,
		* so the post-return "tree is sanitized" contract is violated. Sweep the
		* whole tree once up front and sever every linkage before the walk begins,
		* closing that window.
		*
		* This CANNOT undo a patch that already fired before sanitize ran — that is
		* the irreducible "do not IN_PLACE a live-connected attacker tree" caveat —
		* but it closes everything from sanitize-start onward. Gated on SAFE_FOR_XML
		* to group with the rest of the declarative-partial-updates handling and
		* stay overridable, consistent with the codebase.
		*
		* Clobber-safe traversal (cached childNodes getter); per-node try/catch so a
		* clobbered root cannot defeat the sweep of its non-clobbered descendants.
		*
		* NOTE (pending real-Chrome confirmation, see test/declarative-patch-probe
		* .html Q1): this mirrors the existing policy of keeping `for` on
		* <label>/<output>. If the shipping feature can drive a patch through a
		* surviving `for`-on-label/output + `id` pair, this pre-pass and the
		* attribute check at _isBasicCustomElement's caller must additionally drop
		* that pair on the IN_PLACE path. Left as-is until the taxonomy is verified.
		*
		* @param root the in-place root to sweep
		*/ /**
		* Central policy for declarative-partial-updates patch-linkage attributes,
		* shared by the _neutralizePatchLinkage pre-pass and _isValidAttribute so
		* the two sites cannot drift: `patchsrc` always links, `for` links
		* everywhere except on <label>/<output>, and the whole policy is gated on
		* SAFE_FOR_XML (see the rationale block in _isValidAttribute).
		*
		* @param lcName the transformCaseFunc'd attribute name
		* @param lcTag the transformCaseFunc'd tag name of the carrying element
		* @return true if the attribute is patch linkage and must be dropped
		*/ const _isPatchLinkageAttribute = function _isPatchLinkageAttribute(lcName, lcTag) {
            if (!SAFE_FOR_XML) return false;
            if (lcName === "patchsrc") return true;
            return lcName === "for" && lcTag !== "label" && lcTag !== "output";
        };
        const _neutralizePatchLinkage = function _neutralizePatchLinkage(root) {
            if (!SAFE_FOR_XML) return;
            const stack = [
                root
            ];
            while(stack.length > 0){
                const node = stack.pop();
                const nodeType = _readNodeType(node);
                if (nodeType === NODE_TYPE.processingInstruction || nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, node.data)) {
                    try {
                        remove(node);
                    } catch (_) {}
                    continue;
                }
                if (nodeType === NODE_TYPE.element) {
                    const element = node;
                    const lcTag = transformCaseFunc(_readNodeName(node));
                    try {
                        if (element.hasAttribute && element.hasAttribute("patchsrc")) element.removeAttribute("patchsrc");
                        if (element.hasAttribute && element.hasAttribute("for") && _isPatchLinkageAttribute("for", lcTag)) element.removeAttribute("for");
                    } catch (_) {}
                }
                const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
            }
        };
        /**
		* _initDocument
		*
		* @param dirty - a string of dirty markup
		* @return a DOM, filled with the dirty markup
		*/ const _initDocument = function _initDocument(dirty) {
            let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) dirty = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + dirty + "</body></html>";
            const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
            if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {}
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
		* Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
		*
		* @param root The root element or node to start traversing on.
		* @return The created NodeIterator
		*/ const _createNodeIterator = function _createNodeIterator(root) {
            const doc = getOwnerDocument ? getOwnerDocument(root) : root.ownerDocument;
            return createNodeIterator.call(doc || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
		* Replace template expression syntax (mustache, ERB, template
		* literal) with a space; shared by all SAFE_FOR_TEMPLATES scrub
		* sites. Order matters: mustache, then ERB, then template literal.
		*
		* @param value the string to scrub
		* @returns the scrubbed string
		*/ const _stripTemplateExpressions = function _stripTemplateExpressions(value) {
            value = stringReplace(value, MUSTACHE_EXPR$1, " ");
            value = stringReplace(value, ERB_EXPR$1, " ");
            value = stringReplace(value, TMPLIT_EXPR$1, " ");
            return value;
        };
        /**
		* Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
		* character data of an element subtree. Used as the final safety net for
		* SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
		* which only form after text-node normalization (e.g. fragments split across
		* stripped elements) cannot survive into a template-evaluating framework.
		*
		* Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
		* in place rather than round-tripping through innerHTML. This preserves
		* descendant node references (important for IN_PLACE callers), avoids a
		* serialize/reparse cycle, and reads literal character data — which means
		* `<%...%>` in text content matches the ERB regex against its real bytes
		* instead of the HTML-entity-escaped form innerHTML would produce.
		*
		* Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
		* attributes is performed during the per-node `_sanitizeAttributes` pass.
		*
		* @param node The root element whose character data should be scrubbed.
		*/ const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
            var _node$querySelectorAl;
            node.normalize();
            const doc = getOwnerDocument ? getOwnerDocument(node) : node.ownerDocument;
            const walker = createNodeIterator.call(doc || node, node, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
            let currentNode = walker.nextNode();
            while(currentNode){
                currentNode.data = _stripTemplateExpressions(currentNode.data);
                currentNode = walker.nextNode();
            }
            const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, "template");
            if (templates) arrayForEach(templates, (tmpl)=>{
                if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
            });
        };
        /**
		* _isClobbered
		*
		* Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
		* interface with [LegacyOverrideBuiltIns]; a descendant element with a
		* `name` attribute matching a prototype property shadows that property
		* on direct reads. We use this check at the IN_PLACE entry-point and
		* during attribute sanitization to refuse clobbered forms.
		*
		* @param element element to check for clobbering attacks
		* @return true if clobbered, false if safe
		*/ const _isClobbered = function _isClobbered(element) {
            const realTagName = getNodeName ? getNodeName(element) : null;
            if (typeof realTagName !== "string") return false;
            if (transformCaseFunc(realTagName) !== "form") return false;
            return typeof element.nodeName !== "string" || typeof element.textContent !== "string" || typeof element.removeChild !== "function" || element.attributes !== getAttributes(element) || typeof element.removeAttribute !== "function" || typeof element.removeAttributeNode !== "function" || typeof element.getAttributeNode !== "function" || typeof element.setAttribute !== "function" || typeof element.namespaceURI !== "string" || typeof element.insertBefore !== "function" || typeof element.hasChildNodes !== "function" || element.nodeType !== getNodeType(element) || element.childNodes !== getChildNodes(element);
        };
        /**
		* Checks whether the given value is a DocumentFragment from any realm.
		*
		* The realm-independent replacement reads `nodeType` through the cached
		* Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
		* constant (11). nodeType is a numeric value resolved from the node's
		* internal slot, identical across realms for the same kind of node.
		*
		* @param value object to check
		* @return true if value is a DocumentFragment-shaped node from any realm
		*/ const _isDocumentFragment = function _isDocumentFragment(value) {
            if (!getNodeType || typeof value !== "object" || value === null) return false;
            try {
                return getNodeType(value) === NODE_TYPE.documentFragment;
            } catch (_) {
                return false;
            }
        };
        /**
		* Checks whether the given object is a DOM node, including nodes that
		* originate from a different window/realm (e.g. an iframe's
		* contentDocument). The previous `value instanceof Node` check was
		* realm-bound: nodes from a different window failed it, causing
		* sanitize() to silently stringify them and reset IN_PLACE to false,
		* returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
		*
		* @param value object to check whether it's a DOM node
		* @return true if value is a DOM node from any realm
		*/ const _isNode = function _isNode(value) {
            if (!getNodeType || typeof value !== "object" || value === null) return false;
            try {
                return typeof getNodeType(value) === "number";
            } catch (_) {
                return false;
            }
        };
        function _executeHooks(hooks, currentNode, data) {
            if (hooks.length === 0) return;
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
		* Structural-threat checks that condemn a node regardless of the
		* allowlists: mXSS via namespace confusion, risky CSS construction,
		* processing instructions, markup-bearing comments. Pure predicate;
		* the caller removes. Check order is load-bearing.
		*
		* @param currentNode the node to inspect
		* @param tagName the node's transformCaseFunc'd tag name
		* @return true if the node must be removed
		*/ const _isUnsafeNode = function _isUnsafeNode(currentNode, tagName) {
            if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.textContent) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) return true;
            if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && LITERAL_TEXT_ELEMENTS[tagName] && (_isNode(currentNode.firstElementChild) || typeof currentNode.textContent === "string" && regExpTest(LITERAL_TEXT_CLOSE[tagName], currentNode.textContent))) return true;
            if (currentNode.nodeType === NODE_TYPE.processingInstruction) return true;
            if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, currentNode.data)) return true;
            return false;
        };
        /**
		* Evaluate a CUSTOM_ELEMENT_HANDLING check (a RegExp or a predicate
		* function, per the validation in _parseConfig) against a name.
		* Additional arguments are forwarded to predicate functions - the
		* attributeNameCheck predicate receives the tag name as its second
		* argument. A null/absent check never matches.
		*
		* @param check the configured tagNameCheck / attributeNameCheck value
		* @param name the name to test
		* @param args extra arguments forwarded to a predicate function
		* @return true if the check matches the name
		*/ const _matchesNameCheck = function _matchesNameCheck(check, name) {
            if (check instanceof RegExp) return regExpTest(check, name);
            if (check instanceof Function) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                return Boolean(check(name, ...args));
            }
            return false;
        };
        /**
		* Handle a node whose tag is forbidden or not allowlisted: keep
		* allowed custom elements (false return exits _sanitizeElements
		* early - the namespace and fallback-tag removal checks are
		* intentionally skipped for kept custom elements), else hoist
		* content per KEEP_CONTENT and remove.
		*
		* A kept custom element is the ONLY case in which this function
		* returns false, so the caller uses that return value to run the
		* afterSanitizeElements hook on the kept element and keep the
		* element-hook lifecycle consistent with normal allowlisted
		* elements (GHSA-c2j3-45gr-mqc4).
		*
		* @param currentNode the disallowed node
		* @param tagName the node's transformCaseFunc'd tag name
		* @return true if the node was removed, false if kept
		*/ const _sanitizeDisallowedNode = function _sanitizeDisallowedNode(currentNode, tagName, root) {
            if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
            if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                const parentNode = getParentNode(currentNode);
                const childNodes = getChildNodes(currentNode);
                if (childNodes && parentNode) {
                    const childCount = childNodes.length;
                    for(let i = childCount - 1; i >= 0; --i){
                        const hoisted = currentNode === root ? cloneNode(childNodes[i], true) : childNodes[i];
                        parentNode.insertBefore(hoisted, getNextSibling(currentNode));
                    }
                }
            }
            _forceRemove(currentNode);
            return true;
        };
        /**
		* Fork a hook-mutable allowlist off its shared binding the first time a
		* (possibly lazily-installed) uponSanitize* hook is about to see it, so the
		* hook cannot widen the per-instance default or the setConfig binding by
		* reference and leak past the call. Returns the set unchanged once it is
		* already call-local, so repeated calls across elements are idempotent.
		*
		* @param hookList the uponSanitize* hook array for this event
		* @param set the current ALLOWED_TAGS / ALLOWED_ATTR binding
		* @param defaultSet the per-instance DEFAULT_ALLOWED_* constant
		* @param setConfigSet the captured setConfig() binding, or null
		* @return a call-local clone if a hook is present and set is still shared,
		*   else set unchanged
		*/ const _forkSharedAllowlist = function _forkSharedAllowlist(hookList, set, defaultSet, setConfigSet) {
            if (hookList.length === 0) return set;
            return set === defaultSet || set === setConfigSet ? clone(set) : set;
        };
        /**
		* Shared guard for a node that a hook has detached from the walk tree,
		* used after each element-hook site in _sanitizeElements. Detaching is a
		* long-standing user pattern (issue #469; draw.io-style foreignObject
		* filtering). Per the cached, unclobberable parentNode getter the node is
		* genuinely out of the tree, so it can reach neither the serialized
		* output nor an IN_PLACE live tree; treat it as removed and stop
		* processing it. Without this guard, the unsafe-node / namespace checks
		* would call _forceRemove on a parentless node and hit the REPORT-3
		* fail-closed throw — which exists for nodes DOMPurify wants gone but
		* *cannot* detach (clobbered / parentless roots), the opposite of a node
		* that is already safely gone. The walk root is exempt: a detached
		* IN_PLACE root is legitimate input and must still be fully sanitized,
		* and a kill-decision on it must keep hitting the REPORT-3 throw.
		*
		* Nodes detached by hooks stay the hook's responsibility for placement:
		* they are not recorded in DOMPurify.removed, so the post-walk IN_PLACE
		* pass (which iterates DOMPurify.removed) does not reach them. But a
		* hook-detached subtree can still hold a queued resource-event handler -
		* e.g. an <img onload> that began loading when the caller built the live
		* tree - which fires in page scope after sanitize returns even though the
		* handler never reached the returned tree. That is the audit-5 F1 hazard,
		* and the documented node.remove() hook pattern walks straight into it.
		* So on the IN_PLACE path we neutralize the detached subtree inline,
		* stripping its non-allow-listed attributes before returning, exactly as
		* the post-walk pass does for _forceRemove'd subtrees.
		*
		* @param currentNode the node a hook may have detached
		* @param root the current walk root
		* @return true if the node is detached and now handled, false otherwise
		*/ const _handleHookDetachedNode = function _handleHookDetachedNode(currentNode, root) {
            if (currentNode === root || getParentNode(currentNode) !== null) return false;
            if (IN_PLACE) _neutralizeSubtree(currentNode);
            return true;
        };
        /**
		* _sanitizeElements
		*
		* @protect nodeName
		* @protect textContent
		* @protect removeChild
		* @param currentNode to check for permission to exist
		* @return true if node was killed, false if left alive
		*/ const _sanitizeElements = function _sanitizeElements(currentNode, root) {
            _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            if (_handleHookDetachedNode(currentNode, root)) return true;
            if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            const tagName = transformCaseFunc(_readNodeName(currentNode));
            ALLOWED_TAGS = _forkSharedAllowlist(hooks.uponSanitizeElement, ALLOWED_TAGS, DEFAULT_ALLOWED_TAGS, SET_CONFIG_ALLOWED_TAGS);
            _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            if (_handleHookDetachedNode(currentNode, root)) return true;
            if (_isUnsafeNode(currentNode, tagName)) {
                _forceRemove(currentNode);
                return true;
            }
            if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
                const removed = _sanitizeDisallowedNode(currentNode, tagName, root);
                if (removed === false) {
                    _executeHooks(hooks.afterSanitizeElements, currentNode, null);
                    if (_handleHookDetachedNode(currentNode, root)) return true;
                }
                return removed;
            }
            if (_readNodeType(currentNode) === NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                const content = _stripTemplateExpressions(currentNode.textContent);
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return _handleHookDetachedNode(currentNode, root);
        };
        /**
		* _isValidAttribute
		*
		* @param lcTag Lowercase tag name of containing element.
		* @param lcName Lowercase attribute name.
		* @param value Attribute value.
		* @return Returns true if `value` is valid, otherwise false.
		*/ const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            if (FORBID_ATTR[lcName]) return false;
            if (_isPatchLinkageAttribute(lcName, lcTag)) return false;
            if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
            if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$1, lcName)) return true;
            if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) return true;
            if (!nameIsPermitted) return _isBasicCustomElement(lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName, lcTag) || lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value);
            if (URI_SAFE_ATTRIBUTES[lcName]) return true;
            if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) return true;
            if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) return true;
            if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) return true;
            return !value;
        };
        const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, [
            "annotation-xml",
            "color-profile",
            "font-face",
            "font-face-format",
            "font-face-name",
            "font-face-src",
            "font-face-uri",
            "missing-glyph"
        ]);
        /**
		* _isBasicCustomElement
		* checks if at least one dash is included in tagName, and it's not the first char
		* for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
		*
		* @param tagName name of the tag of the node to sanitize
		* @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
		*/ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
        };
        /**
		* Wrap an attribute value in the matching Trusted Types object when
		* the active policy requires it. Namespaced attributes pass through
		* unchanged (no TT support yet, see
		* https://bugs.chromium.org/p/chromium/issues/detail?id=1305293).
		*
		* @param lcTag lowercase tag name of the containing element
		* @param lcName lowercase attribute name
		* @param namespaceURI the attribute's namespace, if any
		* @param value the attribute value to wrap
		* @return the value, wrapped when Trusted Types demand it
		*/ const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value) {
            if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function" && !namespaceURI) switch(trustedTypes.getAttributeType(lcTag, lcName)){
                case "TrustedHTML":
                    return _createTrustedHTML(value);
                case "TrustedScriptURL":
                    return _createTrustedScriptURL(value);
            }
            return value;
        };
        /**
		* Write a modified attribute value back onto the element. On
		* success, re-probe for clobbering introduced by the new value and
		* remove the element when found; otherwise, when this writeback is the
		* recreate half of the SANITIZE_NAMED_PROPS remove-and-recreate, pop the
		* removal entry that path recorded so it does not show as removed. On
		* failure, remove the attribute instead.
		*
		* Returns true only on a clean write (the value was set and the new value
		* introduced no clobbering). The caller uses that, together with its own
		* knowledge of whether this attribute pushed a DOMPurify.removed record, to
		* decide whether to pop that record. The pop must happen ONLY for the
		* named-prop remove-and-recreate; popping on any other value change (trim,
		* template scrubbing, Trusted Types) would consume an unrelated _forceRemove
		* subtree-cleanup record and let that detached subtree keep a live event
		* handler through the IN_PLACE neutralization pass (SO-001).
		*
		* @param currentNode the element carrying the attribute
		* @param name the attribute name as present on the element
		* @param namespaceURI the attribute's namespace, if any
		* @param value the new attribute value
		* @return true if the value was written without introducing clobbering
		*/ const _setAttributeValue = function _setAttributeValue(currentNode, name, namespaceURI, value) {
            try {
                if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                else currentNode.setAttribute(name, value);
                if (_isClobbered(currentNode)) {
                    _forceRemove(currentNode);
                    return false;
                }
                return true;
            } catch (_) {
                _removeAttribute(name, currentNode);
                return false;
            }
        };
        /**
		* _sanitizeAttributes
		*
		* @protect attributes
		* @protect nodeName
		* @protect removeAttribute
		* @protect setAttribute
		*
		* @param currentNode to sanitize
		* @param root the current walk root
		*/ const _sanitizeAttributes = function _sanitizeAttributes(currentNode, root) {
            _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            if (_handleHookDetachedNode(currentNode, root)) return;
            const attributes = currentNode.attributes;
            if (!attributes || _isClobbered(currentNode)) return;
            ALLOWED_ATTR = _forkSharedAllowlist(hooks.uponSanitizeAttribute, ALLOWED_ATTR, DEFAULT_ALLOWED_ATTR, SET_CONFIG_ALLOWED_ATTR);
            const hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: void 0
            };
            let l = attributes.length;
            const lcTag = transformCaseFunc(currentNode.nodeName);
            while(l--){
                const attr = attributes[l];
                const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === "value" ? initValue : stringTrim(initValue);
                let recreatedNamedProp = false;
                hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = void 0;
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name") && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                    _removeAttribute(name, currentNode, attr);
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                    recreatedNamedProp = true;
                }
                if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                if (lcName === "attributename" && stringMatch(value, "href")) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                if (hookEvent.forceKeepAttr) continue;
                if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(SELF_CLOSING_TAG, value)) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                if (SAFE_FOR_TEMPLATES) value = _stripTemplateExpressions(value);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
                if (value !== initValue) {
                    if (_setAttributeValue(currentNode, name, namespaceURI, value) && recreatedNamedProp) arrayPop(DOMPurify.removed);
                }
            }
            _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
            _handleHookDetachedNode(currentNode, root);
        };
        /**
		* _sanitizeShadowDOM
		*
		* @param fragment to iterate over recursively
		*/ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                _sanitizeElements(shadowNode, fragment);
                _sanitizeAttributes(shadowNode, fragment);
                if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
                if (_readNodeType(shadowNode) === NODE_TYPE.element) {
                    const innerSr = getShadowRoot(shadowNode);
                    if (_isDocumentFragment(innerSr)) {
                        _sanitizeAttachedShadowRoots(innerSr);
                        _sanitizeShadowDOM2(innerSr);
                    }
                }
            }
            _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        /**
		* _sanitizeAttachedShadowRoots
		*
		* Walks `root` and feeds every attached shadow root we encounter into
		* the existing _sanitizeShadowDOM pipeline. The default node iterator
		* does not descend into shadow trees, so nodes inside an attached
		* shadow root would otherwise be skipped entirely.
		*
		* Two real input paths put attached shadow roots in front of us:
		*   1. IN_PLACE on a DOM node that already has shadow roots attached.
		*   2. DOM-node input where importNode(dirty, true) deep-clones the
		*      shadow root because it was created with `clonable: true`.
		*
		* This pass runs once, up front, so the main iteration loop (and the
		* existing _sanitizeShadowDOM template-content recursion) stay
		* untouched — string-input paths are not affected.
		*
		* @param root the subtree root to walk for attached shadow roots
		*/ const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots(root) {
            const stack = [
                {
                    node: root,
                    shadow: null
                }
            ];
            while(stack.length > 0){
                const item = stack.pop();
                if (item.shadow) {
                    _sanitizeShadowDOM2(item.shadow);
                    continue;
                }
                const node = item.node;
                const isElement = _readNodeType(node) === NODE_TYPE.element;
                const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push({
                    node: childNodes[i],
                    shadow: null
                });
                if (isElement) {
                    const rootName = getNodeName ? getNodeName(node) : null;
                    if (typeof rootName === "string" && transformCaseFunc(rootName) === "template") {
                        const content = node.content;
                        if (_isDocumentFragment(content)) stack.push({
                            node: content,
                            shadow: null
                        });
                    }
                }
                if (isElement) {
                    const sr = getShadowRoot(node);
                    if (_isDocumentFragment(sr)) stack.push({
                        node: null,
                        shadow: sr
                    }, {
                        node: sr,
                        shadow: null
                    });
                }
            }
        };
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            if (typeof dirty !== "string" && !_isNode(dirty)) {
                dirty = stringifyValue(dirty);
                if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
            }
            if (!DOMPurify.isSupported) return dirty;
            if (SET_CONFIG) {
                ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
                ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
            } else _parseConfig(cfg);
            if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) ALLOWED_TAGS = clone(ALLOWED_TAGS);
            if (hooks.uponSanitizeAttribute.length > 0) ALLOWED_ATTR = clone(ALLOWED_ATTR);
            DOMPurify.removed = [];
            const inPlace = IN_PLACE && typeof dirty !== "string" && _isNode(dirty);
            if (inPlace) {
                _neutralizePatchLinkage(dirty);
                const nn = _readNodeName(dirty);
                if (typeof nn === "string") {
                    const tagName = transformCaseFunc(nn);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                        _neutralizeRoot(dirty);
                        throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                    }
                }
                if (_isClobbered(dirty)) {
                    _neutralizeRoot(dirty);
                    throw typeErrorCreate("root node is clobbered and cannot be sanitized in-place");
                }
                try {
                    _sanitizeAttachedShadowRoots(dirty);
                } catch (error) {
                    _neutralizeRoot(dirty);
                    throw error;
                }
            } else if (_isNode(dirty)) {
                body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else body.appendChild(importedNode);
                _sanitizeAttachedShadowRoots(body);
            } else {
                if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
                body = _initDocument(dirty);
                if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            if (body && FORCE_BODY) _forceRemove(body.firstChild);
            const walkRoot = inPlace ? dirty : body;
            try {
                const nodeIterator = _createNodeIterator(walkRoot);
                while(currentNode = nodeIterator.nextNode()){
                    _sanitizeElements(currentNode, walkRoot);
                    _sanitizeAttributes(currentNode, walkRoot);
                    if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
                }
            } catch (error) {
                if (inPlace) {
                    _neutralizeRoot(dirty);
                    arrayForEach(DOMPurify.removed, (entry)=>{
                        if (entry.element) _neutralizeSubtree(entry.element);
                    });
                }
                throw error;
            }
            if (inPlace) {
                let rootWasRemoved = false;
                arrayForEach(DOMPurify.removed, (entry)=>{
                    if (entry.element) {
                        if (entry.element === dirty) rootWasRemoved = true;
                        _neutralizeSubtree(entry.element);
                    }
                });
                if (rootWasRemoved) throw typeErrorCreate("a node selected for removal could not be safely returned; refusing to sanitize in place");
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
                return dirty;
            }
            if (RETURN_DOM) {
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            if (SAFE_FOR_TEMPLATES) serializedHTML = _stripTemplateExpressions(serializedHTML);
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
            SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
            SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
            SET_CONFIG_ALLOWED_TAGS = null;
            SET_CONFIG_ALLOWED_ATTR = null;
            trustedTypesPolicy = defaultTrustedTypesPolicy;
            emptyHTML = "";
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            if (!objectHasOwnProperty(hooks, entryPoint)) return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (!objectHasOwnProperty(hooks, entryPoint)) return;
            if (hookFunction !== void 0) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? void 0 : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            if (!objectHasOwnProperty(hooks, entryPoint)) return;
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    return createDOMPurify();
});

});


parcelRegister("7hLIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $54df23d4d9eaab01$export$2e2bcd8739ae039);
let $54df23d4d9eaab01$var$script;




let $54df23d4d9eaab01$var$initialize = ()=>{
    $54df23d4d9eaab01$var$script = (parcelRequire("fbxBy"));
    if ($54df23d4d9eaab01$var$script.__esModule) $54df23d4d9eaab01$var$script = $54df23d4d9eaab01$var$script.default;
    $54df23d4d9eaab01$var$script.render = (parcelRequire("cq9dH")).render;
    $54df23d4d9eaab01$var$script.__cssModules = {};
    (parcelRequire("hQayD")).default($54df23d4d9eaab01$var$script);
    $54df23d4d9eaab01$var$script.__scopeId = 'data-v-4a3f72';
    $54df23d4d9eaab01$var$script.__file = "ContactFormPrivacyCTA.vue";
};
$54df23d4d9eaab01$var$initialize();
var $54df23d4d9eaab01$export$2e2bcd8739ae039 = $54df23d4d9eaab01$var$script;

});
parcelRegister("fbxBy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $457cd330a9a4137b$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $457cd330a9a4137b$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $ani5R.defineComponent)({
    __name: 'ContactFormPrivacyCTA',
    props: {
        href: {},
        linkMessage: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const __returned__ = {};
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("cq9dH", function(module, exports) {

$parcel$export(module.exports, "render", () => $90af109f940a7371$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $90af109f940a7371$var$_hoisted_1 = {
    class: "privacy-cta"
};
const $90af109f940a7371$var$_hoisted_2 = [
    "href"
];
function $90af109f940a7371$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $90af109f940a7371$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("a", {
            class: "button",
            href: $props.href,
            target: "_blank",
            rel: "noopener noreferrer",
            "data-pw-form": "privacy-cta"
        }, (0, $X5A94.toDisplayString)($props.linkMessage), 9, $90af109f940a7371$var$_hoisted_2)
    ]);
}

});

parcelRegister("hQayD", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfcf7b7fb52f1efa$export$2e2bcd8739ae039);
let $cfcf7b7fb52f1efa$var$NOOP = ()=>{};
var $cfcf7b7fb52f1efa$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("f58OY", function(module, exports) {

$parcel$export(module.exports, "render", () => $afae2a5700f56689$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $dDLnc = parcelRequire("dDLnc");
const $afae2a5700f56689$var$_hoisted_1 = {
    class: "privacy-info-container"
};
const $afae2a5700f56689$var$_hoisted_2 = [
    "innerHTML"
];
const $afae2a5700f56689$var$_hoisted_3 = {
    class: "role-container"
};
const $afae2a5700f56689$var$_hoisted_4 = [
    "innerHTML"
];
function $afae2a5700f56689$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormKit = (0, $ani5R.resolveComponent)("FormKit");
    return (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $afae2a5700f56689$var$_hoisted_1, [
        $props.countryItem?.countryInformationShowInformation ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
            key: 0,
            innerHTML: $setup.clearCss($props.countryItem?.countryInformation.html),
            class: "information-panel",
            "data-pw-form": "privacy-country-information"
        }, null, 8, $afae2a5700f56689$var$_hoisted_2)) : (0, $ani5R.createCommentVNode)("", true),
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", $afae2a5700f56689$var$_hoisted_3, [
            (0, $ani5R.createVNode)(_component_FormKit, {
                type: "select",
                name: "roles",
                modelValue: $setup.currentRole,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.currentRole = $event),
                label: $props.formItem.roleQuestion,
                placeholder: $props.formItem.rolePlaceholder,
                options: $setup.getRoleOptions,
                validation: "required",
                "validation-messages": {
                    required: $props.formItem.roleErrorMessage
                },
                "data-pw-form": "privacy-roles"
            }, null, 8, [
                "modelValue",
                "label",
                "placeholder",
                "options",
                "validation-messages"
            ])
        ], 512), [
            [
                (0, $dDLnc.vShow),
                $setup.isRoles
            ]
        ]),
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", {
            innerHTML: $setup.clearCss($setup.getSecondInfo),
            class: "information-panel",
            "data-pw-form": "privacy-second-information"
        }, null, 8, $afae2a5700f56689$var$_hoisted_4), [
            [
                (0, $dDLnc.vShow),
                $setup.showSecondInfo
            ]
        ]),
        (0, $ani5R.withDirectives)((0, $ani5R.createVNode)($setup["ContactFormPrivacyCTA"], {
            href: $setup.getCTAInfo.urlChoice,
            linkMessage: $setup.getCTAInfo.ctaChoice
        }, null, 8, [
            "href",
            "linkMessage"
        ]), [
            [
                (0, $dDLnc.vShow),
                $setup.showCTA
            ]
        ])
    ], 512)), [
        [
            (0, $dDLnc.vShow),
            $props.isActive
        ]
    ]);
}

});

parcelRegister("i97ww", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35ee7434e33b67a$export$2e2bcd8739ae039);
let $d35ee7434e33b67a$var$NOOP = ()=>{};
var $d35ee7434e33b67a$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("i8zSM", function(module, exports) {

$parcel$export(module.exports, "render", () => $d344cedefaefc31a$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $d344cedefaefc31a$var$_hoisted_1 = {
    class: "privacy-options-container"
};
const $d344cedefaefc31a$var$_hoisted_2 = {
    class: "country-selection"
};
const $d344cedefaefc31a$var$_hoisted_3 = {
    class: "dropdown-intro"
};
const $d344cedefaefc31a$var$_hoisted_4 = {
    class: "privacy-info"
};
function $d344cedefaefc31a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = (0, $ani5R.resolveComponent)("v-select");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $d344cedefaefc31a$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("div", $d344cedefaefc31a$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("div", $d344cedefaefc31a$var$_hoisted_3, (0, $X5A94.toDisplayString)($props.formItem.formCountryLabel), 1),
            (0, $ani5R.createVNode)(_component_v_select, {
                options: $setup.countryNameList,
                modelValue: $setup.currentCountry,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.currentCountry = $event),
                "aria-label": $props.formItem.formCountryLabel,
                placeholder: $props.formItem.formCountryPlaceholder,
                dir: $props.rtlItem.currentDirection,
                class: (0, $X5A94.normalizeClass)({
                    'text-rtl': $props.rtlItem.useRtl
                }),
                "data-pw-form": "privacy-country"
            }, {
                "no-options": (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.createElementVNode)("div", null, (0, $X5A94.toDisplayString)($props.formItem.formCountryErrorMessage), 1)
                    ]),
                _: 1
            }, 8, [
                "options",
                "modelValue",
                "aria-label",
                "placeholder",
                "dir",
                "class"
            ])
        ]),
        (0, $ani5R.createElementVNode)("div", $d344cedefaefc31a$var$_hoisted_4, [
            (0, $ani5R.createVNode)($setup["ContactFormPrivacyInfo"], {
                isActive: $setup.countrySelectionMade,
                formItem: $props.formItem,
                "country-item": $setup.selectedCountryItem
            }, null, 8, [
                "isActive",
                "formItem",
                "country-item"
            ])
        ])
    ]);
}

});

parcelRegister("eKwmW", function(module, exports) {

$parcel$export(module.exports, "default", () => $abce785ce1848c55$export$2e2bcd8739ae039);
let $abce785ce1848c55$var$NOOP = ()=>{};
var $abce785ce1848c55$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("gPyYa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c40c88fb1a7520e1$export$2e2bcd8739ae039);
let $c40c88fb1a7520e1$var$script;




let $c40c88fb1a7520e1$var$initialize = ()=>{
    $c40c88fb1a7520e1$var$script = (parcelRequire("46Std"));
    if ($c40c88fb1a7520e1$var$script.__esModule) $c40c88fb1a7520e1$var$script = $c40c88fb1a7520e1$var$script.default;
    $c40c88fb1a7520e1$var$script.render = (parcelRequire("5bcJf")).render;
    $c40c88fb1a7520e1$var$script.__cssModules = {};
    (parcelRequire("a3Ggv")).default($c40c88fb1a7520e1$var$script);
    $c40c88fb1a7520e1$var$script.__scopeId = 'data-v-b96f26';
    $c40c88fb1a7520e1$var$script.__file = "ContactFormContactList.vue";
};
$c40c88fb1a7520e1$var$initialize();
var $c40c88fb1a7520e1$export$2e2bcd8739ae039 = $c40c88fb1a7520e1$var$script;

});
parcelRegister("46Std", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $78d7101cf4c68f12$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $d5S99 = parcelRequire("d5S99");
var $78d7101cf4c68f12$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $ani5R.defineComponent)({
    __name: 'ContactFormContactList',
    props: {
        rtlItem: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const { currentMarket: currentMarket, getContactListOptions: getContactListOptions, getContactListToShow: getContactListToShow, showLocalSection: showLocalSection, showOtherSection: showOtherSection, showOtherWebsite: showOtherWebsite } = (0, $d5S99.useContactList)();
        const reduceOption = (option)=>option.value;
        const __returned__ = {
            currentMarket: currentMarket,
            getContactListOptions: getContactListOptions,
            getContactListToShow: getContactListToShow,
            showLocalSection: showLocalSection,
            showOtherSection: showOtherSection,
            showOtherWebsite: showOtherWebsite,
            reduceOption: reduceOption
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("d5S99", function(module, exports) {

$parcel$export(module.exports, "useContactList", () => $9409e73b098b6889$export$7b2728038cb4ff2a);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");

var $eDEd3 = parcelRequire("eDEd3");
const $9409e73b098b6889$var$getInitialCurrentMarket = ()=>{
    const match = window.location.pathname.match(/\/([a-z]{2})\/([a-z]{2})\//);
    if (match) return `${match[1]}/${match[2]}`;
    return null;
};
const $9409e73b098b6889$var$getBlankContactListItem = ()=>{
    return {
        market: '',
        countryName: '',
        countryLanguage: '',
        showMarketInOptions: '',
        redirectToMarketOrMessage: '',
        localInfo: '',
        localName: '',
        localEmail: '',
        localPhone: '',
        localAddress: '',
        otherInfo: '',
        otherName: '',
        otherEmail: '',
        otherPhone: '',
        otherAddress: '',
        otherWebsiteName: '',
        otherWebsiteUrl: '',
        dropdownIntroduction: '',
        dropdownError: '',
        dropdownLabel: ''
    };
};
const $9409e73b098b6889$export$7b2728038cb4ff2a = ()=>{
    const contactListStore = (0, $eDEd3.useContactListStore)();
    const initialMarket = $9409e73b098b6889$var$getInitialCurrentMarket() ?? '';
    const currentMarket = (0, $8bTPG.ref)(initialMarket);
    const getActiveContactList = (0, $8bTPG.computed)(()=>{
        const foundMarket = contactListStore.getContactListItems.filter((contactListItem)=>contactListItem.market === currentMarket.value);
        return foundMarket.length > 0 ? foundMarket[0] : $9409e73b098b6889$var$getBlankContactListItem();
    });
    const activeContactListIsOption = (0, $8bTPG.computed)(()=>{
        return getActiveContactList.value.showMarketInOptions === 'true';
    });
    const activeContactListIsRedirect = (0, $8bTPG.computed)(()=>{
        return getActiveContactList.value.redirectToMarketOrMessage !== '';
    });
    const getRedirectMarket = (0, $8bTPG.computed)(()=>{
        return getActiveContactList.value.redirectToMarketOrMessage;
    });
    const getContactListOptions = (0, $8bTPG.computed)(()=>{
        const currentList = contactListStore.getContactListItems.filter((contactListItem)=>contactListItem.showMarketInOptions === 'true');
        const finalContactListOptions = !activeContactListIsOption.value ? [
            ...currentList,
            getActiveContactList.value
        ] : currentList;
        return finalContactListOptions.map((contactListItem)=>({
                label: `${contactListItem.countryName} - ${contactListItem.countryLanguage}`,
                value: contactListItem.market
            }));
    });
    const getContactListToShow = (0, $8bTPG.computed)(()=>{
        if (activeContactListIsRedirect.value) {
            const contactListToShow = contactListStore.getContactListItems.filter((contactListItem)=>contactListItem.market === getRedirectMarket.value);
            return contactListToShow.length > 0 ? contactListToShow[0] : getActiveContactList.value;
        }
        return getActiveContactList.value;
    });
    const showLocalSection = (0, $8bTPG.computed)(()=>{
        return !!getContactListToShow.value.localInfo || !!getContactListToShow.value.localName || !!getContactListToShow.value.localEmail || !!getContactListToShow.value.localPhone || !!getContactListToShow.value.localAddress;
    });
    const showOtherSection = (0, $8bTPG.computed)(()=>{
        return !!getContactListToShow.value.otherInfo || !!getContactListToShow.value.otherName || !!getContactListToShow.value.otherEmail || !!getContactListToShow.value.otherPhone || !!getContactListToShow.value.otherAddress || !!getContactListToShow.value.otherWebsiteUrl;
    });
    const showOtherWebsite = (0, $8bTPG.computed)(()=>{
        return !!getContactListToShow.value.otherWebsiteName && !!getContactListToShow.value.otherWebsiteUrl;
    });
    return {
        currentMarket: currentMarket,
        getContactListOptions: getContactListOptions,
        getContactListToShow: getContactListToShow,
        showLocalSection: showLocalSection,
        showOtherSection: showOtherSection,
        showOtherWebsite: showOtherWebsite
    };
};

});
parcelRegister("eDEd3", function(module, exports) {

$parcel$export(module.exports, "useContactListStore", () => $0607488b9a75ba9b$export$48cc185a80152a34);

var $gqFxE = parcelRequire("gqFxE");
const $0607488b9a75ba9b$export$48cc185a80152a34 = (0, $gqFxE.defineStore)('contactListStore', {
    state: ()=>({
            apiError: false,
            dataError: false,
            dataReady: false,
            contactListItems: []
        }),
    getters: {
        getContactListItems: (state)=>state.contactListItems
    },
    actions: {
        loadContactListItems (contactListItems) {
            this.contactListItems = contactListItems;
            this.dataReady = true;
            this.apiError = false;
            this.dataError = false;
        }
    }
});

});



parcelRegister("5bcJf", function(module, exports) {

$parcel$export(module.exports, "render", () => $3c57da823f97dd12$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $3c57da823f97dd12$var$_hoisted_1 = {
    class: "contact-list-container"
};
const $3c57da823f97dd12$var$_hoisted_2 = {
    class: "dropdown-intro",
    "data-pw-form": "contact-list-dropdown-intro"
};
const $3c57da823f97dd12$var$_hoisted_3 = {
    class: "contact-list-details"
};
const $3c57da823f97dd12$var$_hoisted_4 = {
    key: 0,
    class: "contact-list-group local-contact",
    "data-pw-form": "contact-list-local-contact-section"
};
const $3c57da823f97dd12$var$_hoisted_5 = {
    key: 0,
    class: "contact-list-section",
    "data-pw-form": "contact-list-local-info"
};
const $3c57da823f97dd12$var$_hoisted_6 = {
    key: 1,
    class: "contact-list-section",
    "data-pw-form": "contact-list-local-name"
};
const $3c57da823f97dd12$var$_hoisted_7 = {
    class: "contact-list-section"
};
const $3c57da823f97dd12$var$_hoisted_8 = [
    "href"
];
const $3c57da823f97dd12$var$_hoisted_9 = {
    class: "contact-list-section"
};
const $3c57da823f97dd12$var$_hoisted_10 = [
    "href"
];
const $3c57da823f97dd12$var$_hoisted_11 = {
    key: 2,
    class: "contact-list-section",
    "data-pw-form": "contact-list-local-address"
};
const $3c57da823f97dd12$var$_hoisted_12 = {
    key: 1,
    class: "contact-list-group other-contact",
    "data-pw-form": "contact-list-other-contact-section"
};
const $3c57da823f97dd12$var$_hoisted_13 = {
    key: 0,
    class: "contact-list-section",
    "data-pw-form": "contact-list-other-info"
};
const $3c57da823f97dd12$var$_hoisted_14 = {
    key: 1,
    class: "contact-list-section",
    "data-pw-form": "contact-list-other-website"
};
const $3c57da823f97dd12$var$_hoisted_15 = [
    "href",
    "aria-label"
];
const $3c57da823f97dd12$var$_hoisted_16 = {
    key: 2,
    class: "contact-list-section",
    "data-pw-form": "contact-list-other-name"
};
const $3c57da823f97dd12$var$_hoisted_17 = {
    class: "contact-list-section"
};
const $3c57da823f97dd12$var$_hoisted_18 = [
    "href"
];
const $3c57da823f97dd12$var$_hoisted_19 = {
    class: "contact-list-section"
};
const $3c57da823f97dd12$var$_hoisted_20 = [
    "href"
];
const $3c57da823f97dd12$var$_hoisted_21 = {
    key: 3,
    class: "contact-list-section",
    "data-pw-form": "contact-list-other-address"
};
function $3c57da823f97dd12$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = (0, $ani5R.resolveComponent)("v-select");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
        (0, $ani5R.createElementVNode)("div", $3c57da823f97dd12$var$_hoisted_1, [
            (0, $ani5R.createElementVNode)("div", $3c57da823f97dd12$var$_hoisted_2, (0, $X5A94.toDisplayString)($setup.getContactListToShow.dropdownIntroduction), 1),
            (0, $ani5R.createVNode)(_component_v_select, {
                options: $setup.getContactListOptions,
                label: "label",
                reduce: $setup.reduceOption,
                modelValue: $setup.currentMarket,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.currentMarket = $event),
                "aria-label": $setup.getContactListToShow.dropdownLabel,
                dir: $props.rtlItem.currentDirection,
                class: (0, $X5A94.normalizeClass)({
                    'text-rtl': $props.rtlItem.useRtl
                }),
                "data-pw-form": "contact-list-options"
            }, {
                "no-options": (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.createElementVNode)("div", null, (0, $X5A94.toDisplayString)($setup.getContactListToShow.dropdownError), 1)
                    ]),
                _: 1
            }, 8, [
                "options",
                "modelValue",
                "aria-label",
                "dir",
                "class"
            ])
        ]),
        (0, $ani5R.createElementVNode)("div", $3c57da823f97dd12$var$_hoisted_3, [
            $setup.showLocalSection ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $3c57da823f97dd12$var$_hoisted_4, [
                $setup.getContactListToShow.localInfo ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $3c57da823f97dd12$var$_hoisted_5, (0, $X5A94.toDisplayString)($setup.getContactListToShow.localInfo), 1)) : (0, $ani5R.createCommentVNode)("", true),
                $setup.getContactListToShow.localName ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $3c57da823f97dd12$var$_hoisted_6, (0, $X5A94.toDisplayString)($setup.getContactListToShow.localName), 1)) : (0, $ani5R.createCommentVNode)("", true),
                (0, $ani5R.createElementVNode)("div", $3c57da823f97dd12$var$_hoisted_7, [
                    $setup.getContactListToShow.localEmail ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                        key: 0,
                        "data-pw-form": "contact-list-local-email",
                        href: `mailto:${$setup.getContactListToShow.localEmail}`
                    }, (0, $X5A94.toDisplayString)($setup.getContactListToShow.localEmail), 9, $3c57da823f97dd12$var$_hoisted_8)) : (0, $ani5R.createCommentVNode)("", true)
                ]),
                (0, $ani5R.createElementVNode)("div", $3c57da823f97dd12$var$_hoisted_9, [
                    $setup.getContactListToShow.localPhone ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                        key: 0,
                        "data-pw-form": "contact-list-local-phone",
                        href: `tel:${$setup.getContactListToShow.localPhone}`
                    }, (0, $X5A94.toDisplayString)($setup.getContactListToShow.localPhone), 9, $3c57da823f97dd12$var$_hoisted_10)) : (0, $ani5R.createCommentVNode)("", true)
                ]),
                $setup.getContactListToShow.localAddress ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $3c57da823f97dd12$var$_hoisted_11, (0, $X5A94.toDisplayString)($setup.getContactListToShow.localAddress), 1)) : (0, $ani5R.createCommentVNode)("", true)
            ])) : (0, $ani5R.createCommentVNode)("", true),
            $setup.showOtherSection ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $3c57da823f97dd12$var$_hoisted_12, [
                $setup.getContactListToShow.otherInfo ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $3c57da823f97dd12$var$_hoisted_13, (0, $X5A94.toDisplayString)($setup.getContactListToShow.otherInfo), 1)) : (0, $ani5R.createCommentVNode)("", true),
                $setup.showOtherWebsite ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $3c57da823f97dd12$var$_hoisted_14, [
                    (0, $ani5R.createElementVNode)("a", {
                        href: $setup.getContactListToShow.otherWebsiteUrl,
                        "aria-label": $setup.getContactListToShow.otherWebsiteName,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, (0, $X5A94.toDisplayString)($setup.getContactListToShow.otherWebsiteName), 9, $3c57da823f97dd12$var$_hoisted_15)
                ])) : (0, $ani5R.createCommentVNode)("", true),
                $setup.getContactListToShow.otherName ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $3c57da823f97dd12$var$_hoisted_16, (0, $X5A94.toDisplayString)($setup.getContactListToShow.otherName), 1)) : (0, $ani5R.createCommentVNode)("", true),
                (0, $ani5R.createElementVNode)("div", $3c57da823f97dd12$var$_hoisted_17, [
                    $setup.getContactListToShow.otherEmail ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                        key: 0,
                        href: `mailto:${$setup.getContactListToShow.otherEmail}`,
                        "data-pw-form": "contact-list-other-email"
                    }, (0, $X5A94.toDisplayString)($setup.getContactListToShow.otherEmail), 9, $3c57da823f97dd12$var$_hoisted_18)) : (0, $ani5R.createCommentVNode)("", true)
                ]),
                (0, $ani5R.createElementVNode)("div", $3c57da823f97dd12$var$_hoisted_19, [
                    $setup.getContactListToShow.otherPhone ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                        key: 0,
                        href: `tel:${$setup.getContactListToShow.otherPhone}`,
                        "data-pw-form": "contact-list-other-phone"
                    }, (0, $X5A94.toDisplayString)($setup.getContactListToShow.otherPhone), 9, $3c57da823f97dd12$var$_hoisted_20)) : (0, $ani5R.createCommentVNode)("", true)
                ]),
                $setup.getContactListToShow.otherAddress ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $3c57da823f97dd12$var$_hoisted_21, (0, $X5A94.toDisplayString)($setup.getContactListToShow.otherAddress), 1)) : (0, $ani5R.createCommentVNode)("", true)
            ])) : (0, $ani5R.createCommentVNode)("", true)
        ])
    ], 64);
}

});

parcelRegister("a3Ggv", function(module, exports) {

$parcel$export(module.exports, "default", () => $752af82f785d3ecd$export$2e2bcd8739ae039);
let $752af82f785d3ecd$var$NOOP = ()=>{};
var $752af82f785d3ecd$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("fdBZp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b14589d2319b8796$export$2e2bcd8739ae039);
let $b14589d2319b8796$var$script;



let $b14589d2319b8796$var$initialize = ()=>{
    $b14589d2319b8796$var$script = (parcelRequire("7zG5z"));
    if ($b14589d2319b8796$var$script.__esModule) $b14589d2319b8796$var$script = $b14589d2319b8796$var$script.default;
    $b14589d2319b8796$var$script.render = (parcelRequire("3QhK9")).render;
    (parcelRequire("bH9zQ")).default($b14589d2319b8796$var$script);
    $b14589d2319b8796$var$script.__scopeId = 'data-v-53265b';
    $b14589d2319b8796$var$script.__file = "ContactFormOtherOptions.vue";
};
$b14589d2319b8796$var$initialize();
var $b14589d2319b8796$export$2e2bcd8739ae039 = $b14589d2319b8796$var$script;

});
parcelRegister("7zG5z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b0720a053b39d266$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $KO22c = parcelRequire("KO22c");
var $b0720a053b39d266$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $ani5R.defineComponent)({
    __name: 'ContactFormOtherOptions',
    props: {
        formItem: {},
        rtlItem: {}
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const { clearCss: clearCss } = (0, $KO22c.useClearCss)();
        const __returned__ = {
            clearCss: clearCss
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("3QhK9", function(module, exports) {

$parcel$export(module.exports, "render", () => $2cc3fde33513e247$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
const $2cc3fde33513e247$var$_hoisted_1 = {
    class: "other-options-container",
    "data-pw-form": "contact-form-other-options"
};
const $2cc3fde33513e247$var$_hoisted_2 = {
    class: "form-details"
};
const $2cc3fde33513e247$var$_hoisted_3 = {
    class: "form-details-two-columns"
};
const $2cc3fde33513e247$var$_hoisted_4 = {
    class: "form-message"
};
const $2cc3fde33513e247$var$_hoisted_5 = [
    "innerHTML"
];
const $2cc3fde33513e247$var$_hoisted_6 = {
    class: "form-submit"
};
function $2cc3fde33513e247$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormKit = (0, $ani5R.resolveComponent)("FormKit");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2cc3fde33513e247$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("div", $2cc3fde33513e247$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("div", $2cc3fde33513e247$var$_hoisted_3, [
                (0, $ani5R.createVNode)(_component_FormKit, {
                    type: "text",
                    name: "firstName",
                    "input-class": {
                        'text-rtl': $props.rtlItem.useRtl
                    },
                    dir: $props.rtlItem.currentDirection,
                    label: $props.formItem.firstNameLabel,
                    validation: "required",
                    "validation-messages": {
                        required: $props.formItem.firstNameErrorMessage
                    },
                    "data-pw-form": "contact-form-first-name"
                }, null, 8, [
                    "input-class",
                    "dir",
                    "label",
                    "validation-messages"
                ]),
                (0, $ani5R.createVNode)(_component_FormKit, {
                    type: "text",
                    name: "lastName",
                    "input-class": {
                        'text-rtl': $props.rtlItem.useRtl
                    },
                    dir: $props.rtlItem.currentDirection,
                    label: $props.formItem.lastNameLabel,
                    validation: "required",
                    "validation-messages": {
                        required: $props.formItem.lastNameErrorMessage
                    },
                    "data-pw-form": "contact-form-last-name"
                }, null, 8, [
                    "input-class",
                    "dir",
                    "label",
                    "validation-messages"
                ])
            ]),
            (0, $ani5R.createVNode)(_component_FormKit, {
                type: "email",
                name: "email",
                label: $props.formItem.emailLabel,
                validation: "required|email",
                "validation-messages": {
                    required: $props.formItem.emailAddressErrorMessage,
                    email: $props.formItem.emailAddressErrorMessage
                },
                "input-class": "email-input",
                "data-pw-form": "contact-form-email"
            }, null, 8, [
                "label",
                "validation-messages"
            ])
        ]),
        (0, $ani5R.createElementVNode)("div", $2cc3fde33513e247$var$_hoisted_4, [
            (0, $ani5R.createVNode)(_component_FormKit, {
                type: "textarea",
                name: "message",
                "input-class": {
                    'text-rtl': $props.rtlItem.useRtl
                },
                dir: $props.rtlItem.currentDirection,
                label: $props.formItem.messageLabel,
                validation: "required",
                "validation-messages": {
                    required: $props.formItem.messageErrorMessage
                },
                "data-pw-form": "contact-form-message"
            }, null, 8, [
                "input-class",
                "dir",
                "label",
                "validation-messages"
            ])
        ]),
        (0, $ani5R.createElementVNode)("div", {
            innerHTML: $setup.clearCss($props.formItem.recaptchaInformationalMessage.html),
            class: "form-recaptcha-message",
            "data-pw-form": "contact-form-recaptcha-message"
        }, null, 8, $2cc3fde33513e247$var$_hoisted_5),
        (0, $ani5R.createElementVNode)("div", $2cc3fde33513e247$var$_hoisted_6, [
            (0, $ani5R.createVNode)(_component_FormKit, {
                type: "submit",
                label: $props.formItem.formSubmitLabel,
                "data-pw-form": "contact-form-submit"
            }, null, 8, [
                "label"
            ])
        ])
    ]);
}

});

parcelRegister("bH9zQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $883b23b2b5a17bf6$export$2e2bcd8739ae039);
let $883b23b2b5a17bf6$var$NOOP = ()=>{};
var $883b23b2b5a17bf6$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("7TBpe", function(module, exports) {

$parcel$export(module.exports, "render", () => $5bfaaf7b1a08f99d$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $5bfaaf7b1a08f99d$var$_hoisted_1 = {
    class: "form-title",
    "data-pw-form": "form-title"
};
const $5bfaaf7b1a08f99d$var$_hoisted_2 = {
    class: "form-intro"
};
function $5bfaaf7b1a08f99d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormKit = (0, $ani5R.resolveComponent)("FormKit");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_FormKit, {
        type: "form",
        class: "contact-form-container",
        actions: false,
        id: "contact-us-form",
        onSubmit: $setup.onSubmitForm
    }, {
        default: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("h1", $5bfaaf7b1a08f99d$var$_hoisted_1, (0, $X5A94.toDisplayString)($props.formItem.formIntroductionTitle), 1),
                (0, $ani5R.createElementVNode)("div", $5bfaaf7b1a08f99d$var$_hoisted_2, [
                    (0, $ani5R.createVNode)(_component_FormKit, {
                        type: "select",
                        name: "topic",
                        modelValue: $setup.currentTopic,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.currentTopic = $event),
                        label: $props.formItem.formTopicIntro,
                        placeholder: $props.formItem.formTopicPlaceholder,
                        options: $setup.allTopics,
                        validation: "required",
                        "validation-messages": {
                            required: $props.formItem.formTopicsErrorMessage
                        },
                        "data-pw-form": "topic"
                    }, null, 8, [
                        "modelValue",
                        "label",
                        "placeholder",
                        "options",
                        "validation-messages"
                    ])
                ]),
                $setup.privacyActive ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["ContactFormPrivacyOption"], {
                    key: 0,
                    formItem: $props.formItem,
                    rtlItem: {
                        useRtl: $props.formItem.setFormRtl,
                        currentDirection: $setup.isRTL
                    }
                }, null, 8, [
                    "formItem",
                    "rtlItem"
                ])) : (0, $ani5R.createCommentVNode)("", true),
                $setup.contactListActive ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["ContactFormContactList"], {
                    key: 1,
                    rtlItem: {
                        useRtl: $props.formItem.setFormRtl,
                        currentDirection: $setup.isRTL
                    }
                }, null, 8, [
                    "rtlItem"
                ])) : (0, $ani5R.createCommentVNode)("", true),
                $setup.otherTopicActive ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["ContactFormOtherOptions"], {
                    key: 2,
                    formItem: $props.formItem,
                    rtlItem: {
                        useRtl: $props.formItem.setFormRtl,
                        currentDirection: $setup.isRTL
                    }
                }, null, 8, [
                    "formItem",
                    "rtlItem"
                ])) : (0, $ani5R.createCommentVNode)("", true)
            ]),
        _: 1
    }, 8, [
        "onSubmit"
    ]);
}

});

parcelRegister("e5Ad9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a41d9f1c5227b3ed$export$2e2bcd8739ae039);
let $a41d9f1c5227b3ed$var$NOOP = ()=>{};
var $a41d9f1c5227b3ed$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("lwv2V", function(module, exports) {

$parcel$export(module.exports, "default", () => $fab4ab42c00756f7$export$2e2bcd8739ae039);
let $fab4ab42c00756f7$var$script;




let $fab4ab42c00756f7$var$initialize = ()=>{
    $fab4ab42c00756f7$var$script = (parcelRequire("fNxsk"));
    if ($fab4ab42c00756f7$var$script.__esModule) $fab4ab42c00756f7$var$script = $fab4ab42c00756f7$var$script.default;
    $fab4ab42c00756f7$var$script.render = (parcelRequire("6vOW5")).render;
    $fab4ab42c00756f7$var$script.__cssModules = {};
    (parcelRequire("XgYz9")).default($fab4ab42c00756f7$var$script);
    $fab4ab42c00756f7$var$script.__scopeId = 'data-v-9d1229';
    $fab4ab42c00756f7$var$script.__file = "ContactFormResult.vue";
};
$fab4ab42c00756f7$var$initialize();
var $fab4ab42c00756f7$export$2e2bcd8739ae039 = $fab4ab42c00756f7$var$script;

});
parcelRegister("fNxsk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1b620f6b3b412eac$export$2e2bcd8739ae039);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");

var $KO22c = parcelRequire("KO22c");
var $1b620f6b3b412eac$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $ani5R.defineComponent)({
    __name: 'ContactFormResult',
    props: {
        formItem: {},
        showSuccess: {
            type: Boolean
        },
        showError: {
            type: Boolean
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const { clearCss: clearCss } = (0, $KO22c.useClearCss)();
        const __returned__ = {
            clearCss: clearCss
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("6vOW5", function(module, exports) {

$parcel$export(module.exports, "render", () => $4bdd26283db9eb9d$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $dDLnc = parcelRequire("dDLnc");
const $4bdd26283db9eb9d$var$_hoisted_1 = {
    class: "form-result-container"
};
const $4bdd26283db9eb9d$var$_hoisted_2 = [
    "innerHTML"
];
const $4bdd26283db9eb9d$var$_hoisted_3 = [
    "innerHTML"
];
function $4bdd26283db9eb9d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $4bdd26283db9eb9d$var$_hoisted_1, [
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", {
            innerHTML: $setup.clearCss($props.formItem.formSuccessMessage.html),
            class: "form-result-success",
            "data-pw-form": "result-success"
        }, null, 8, $4bdd26283db9eb9d$var$_hoisted_2), [
            [
                (0, $dDLnc.vShow),
                $props.showSuccess
            ]
        ]),
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", {
            innerHTML: $setup.clearCss($props.formItem.formFailureMessage.html),
            class: "form-result-error",
            "data-pw-form": "result-error"
        }, null, 8, $4bdd26283db9eb9d$var$_hoisted_3), [
            [
                (0, $dDLnc.vShow),
                $props.showError
            ]
        ])
    ]);
}

});

parcelRegister("XgYz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b22addb5537754c$export$2e2bcd8739ae039);
let $0b22addb5537754c$var$NOOP = ()=>{};
var $0b22addb5537754c$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("bzn4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $86c4db61b0f6b957$export$2e2bcd8739ae039);
let $86c4db61b0f6b957$var$script;



let $86c4db61b0f6b957$var$initialize = ()=>{
    $86c4db61b0f6b957$var$script = {};
    $86c4db61b0f6b957$var$script.render = (parcelRequire("60xWz")).render;
    $86c4db61b0f6b957$var$script.__cssModules = {};
    (parcelRequire("hQHM5")).default($86c4db61b0f6b957$var$script);
    $86c4db61b0f6b957$var$script.__scopeId = 'data-v-9d78c8';
    $86c4db61b0f6b957$var$script.__file = "ContactFormLoading.vue";
};
$86c4db61b0f6b957$var$initialize();
var $86c4db61b0f6b957$export$2e2bcd8739ae039 = $86c4db61b0f6b957$var$script;

});
parcelRegister("60xWz", function(module, exports) {

$parcel$export(module.exports, "render", () => $45fd12ac023e3d85$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
const $45fd12ac023e3d85$var$_hoisted_1 = {
    class: "contact-form-loading",
    "data-pw-form": "contact-form-loading",
    role: "status",
    "aria-live": "polite",
    "aria-label": "Loading contact form"
};
function $45fd12ac023e3d85$export$b3890eb0ae9dca99(_ctx, _cache) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $45fd12ac023e3d85$var$_hoisted_1, [
        ..._cache[0] || (_cache[0] = [
            (0, $ani5R.createElementVNode)("svg", {
                class: "contact-form-loading__spinner",
                "data-pw-form": "contact-form-spinner",
                width: "50",
                height: "50",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true"
            }, [
                (0, $ani5R.createElementVNode)("path", {
                    d: "M20.0001 12C20.0001 13.3811 19.6425 14.7386 18.9623 15.9405C18.282 17.1424 17.3022 18.1477 16.1182 18.8587C14.9341 19.5696 13.5862 19.9619 12.2056 19.9974C10.825 20.0328 9.45873 19.7103 8.23975 19.0612",
                    stroke: "#000000",
                    "stroke-width": "3.55556",
                    "stroke-linecap": "round"
                })
            ], -1)
        ])
    ]);
}

});

parcelRegister("hQHM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfe93fb2ee09ff6f$export$2e2bcd8739ae039);
let $cfe93fb2ee09ff6f$var$NOOP = ()=>{};
var $cfe93fb2ee09ff6f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("jQXUZ", function(module, exports) {

$parcel$export(module.exports, "useInitialiseForm", () => $e6ab7a9a9dd5b884$export$584dac9d732ee998);

var $4qljO = parcelRequire("4qljO");
/**
 * The API is hosted in AWS CloudFront. API requests are GET requests.
 * The CloudFront has a cache by path policy. Therefore, to avoid getting the same cached requests
 * from AEM preview, AEM publish and AWS pages, this method tries to add defunct params, 
 * so that the requests between each of these environments are cached separately.
 * 
 * @param originalQuery 
 * @returns Query with extra params
 */ const $e6ab7a9a9dd5b884$var$adaptQueryForPreviewHosts = (originalQuery)=>{
    const preview = 'preview';
    const publish = 'publish';
    const aws = 'aws';
    const extraParam = ';env=';
    const currentHost = window.location.host;
    let hostParam;
    // Regex for preview domain
    const previewDomainRegex = /^preview-[\w-]+\.adobeaemcloud\.com$/;
    // Regex for publish domain
    const publishDomainRegex = /^publish-[\w-]+\.adobeaemcloud\.com$/;
    // Regex for AWS privacyhub domains (dev, stage, prod)
    const awsDomainRegex = /^privacyhub\.(dev|stage|prod)\.tccc-nextgen\.com$/;
    if (previewDomainRegex.test(currentHost)) {
        hostParam = encodeURIComponent(extraParam.concat(preview));
        return originalQuery.concat(hostParam);
    }
    if (publishDomainRegex.test(currentHost)) {
        hostParam = encodeURIComponent(extraParam.concat(publish));
        return originalQuery.concat(hostParam);
    }
    if (awsDomainRegex.test(currentHost)) {
        hostParam = encodeURIComponent(extraParam.concat(aws));
        return originalQuery.concat(hostParam);
    }
    return originalQuery;
};
const $e6ab7a9a9dd5b884$var$isQueryAmended = (originalQuery, amendedQuery)=>{
    return originalQuery !== amendedQuery;
};
const $e6ab7a9a9dd5b884$var$getGcpQueryPath = (query)=>{
    const basePath = '/api/content';
    const querypath = new URL(query).pathname;
    return basePath.concat(querypath);
};
const $e6ab7a9a9dd5b884$var$checkForBadParams = (query, folder)=>{
    return !query || !folder;
};
const $e6ab7a9a9dd5b884$var$getFormItems = (apiData)=>{
    const formItems = apiData?.data?.contactFormData?.items;
    return formItems ?? false;
};
const $e6ab7a9a9dd5b884$var$getCountryItems = (apiData)=>{
    const countryItems = apiData?.data?.contactFormCountries?.items;
    return countryItems ?? false;
};
const $e6ab7a9a9dd5b884$var$loadRecaptcha = (recaptchaUrl)=>{
    const headSection = document.head;
    const reCaptchaScript = document.createElement('script');
    reCaptchaScript.src = recaptchaUrl;
    headSection.append(reCaptchaScript);
};
const $e6ab7a9a9dd5b884$export$584dac9d732ee998 = (query, folder)=>{
    const contactFormStore = (0, $4qljO.useContactFormStore)();
    const folderParam = ";folderPath=".concat(folder);
    const encodedFolderParam = encodeURIComponent(folderParam);
    const queryWithFolder = query.concat(encodedFolderParam);
    const completeQuery = $e6ab7a9a9dd5b884$var$adaptQueryForPreviewHosts(queryWithFolder);
    const finalQuery = $e6ab7a9a9dd5b884$var$isQueryAmended(queryWithFolder, completeQuery) ? completeQuery : $e6ab7a9a9dd5b884$var$getGcpQueryPath(queryWithFolder);
    const fetchFormData = ()=>{
        if ($e6ab7a9a9dd5b884$var$checkForBadParams(query, folder)) {
            contactFormStore.pathError = true;
            return;
        }
        fetch(finalQuery).then((response)=>response.json()).then((responseData)=>{
            const formItems = $e6ab7a9a9dd5b884$var$getFormItems(responseData);
            const countryItems = $e6ab7a9a9dd5b884$var$getCountryItems(responseData);
            if (!formItems || !formItems.length || !countryItems || !countryItems.length) {
                contactFormStore.dataError = true;
                return;
            }
            contactFormStore.loadFormAndCountryItems(formItems, countryItems);
            $e6ab7a9a9dd5b884$var$loadRecaptcha(contactFormStore.getRecaptchaUrl);
        }).catch(()=>{
            contactFormStore.apiError = true;
        });
    };
    return {
        fetchFormData: fetchFormData
    };
};

});

parcelRegister("kH4va", function(module, exports) {

$parcel$export(module.exports, "useInitialiseContactList", () => $0ae13665b41b3da8$export$d17a91a36e6b6a1);
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");

var $gqFxE = parcelRequire("gqFxE");

var $4qljO = parcelRequire("4qljO");

var $eDEd3 = parcelRequire("eDEd3");
const $0ae13665b41b3da8$var$getContactListItems = (apiData)=>{
    const contactListItems = apiData?.data;
    return contactListItems ?? null;
};
const $0ae13665b41b3da8$export$d17a91a36e6b6a1 = ()=>{
    const contactFormStore = (0, $4qljO.useContactFormStore)();
    const contactListStore = (0, $eDEd3.useContactListStore)();
    const { dataReady: dataReady } = (0, $gqFxE.storeToRefs)(contactFormStore);
    const getContactData = ()=>{
        const contactListApiUrl = contactFormStore.getContactListApiEndPoint ?? '';
        if (!contactListApiUrl) {
            contactListStore.apiError = true;
            return;
        }
        fetch(contactListApiUrl).then((response)=>{
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        }).then((responseData)=>{
            const contactListItems = $0ae13665b41b3da8$var$getContactListItems(responseData);
            if (!contactListItems || !contactListItems.length) {
                contactListStore.dataError = true;
                return;
            }
            contactListStore.loadContactListItems(contactListItems);
        }).catch(()=>{
            contactListStore.apiError = true;
        });
    };
    const stopContactFormDataWatcher = (0, $8bTPG.watch)(dataReady, (newDataReady)=>{
        if (newDataReady) {
            getContactData();
            stopContactFormDataWatcher();
        }
    }, {
        immediate: true
    });
};

});


parcelRegister("5Uig2", function(module, exports) {

$parcel$export(module.exports, "render", () => $44d0584c1e09e3d8$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
const $44d0584c1e09e3d8$var$_hoisted_1 = {
    class: "contact-us-vue-page"
};
function $44d0584c1e09e3d8$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $44d0584c1e09e3d8$var$_hoisted_1, [
        $setup.showLoading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["ContactFormLoading"], {
            key: 0
        })) : (0, $ani5R.createCommentVNode)("", true),
        $setup.showForm && $setup.formItem ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["ContactFormContainer"], {
            key: 1,
            formItem: $setup.formItem
        }, null, 8, [
            "formItem"
        ])) : (0, $ani5R.createCommentVNode)("", true),
        $setup.showResult && $setup.formItem ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)($setup["ContactFormResult"], {
            key: 2,
            formItem: $setup.formItem,
            showSuccess: $setup.showSuccess,
            showError: $setup.showError
        }, null, 8, [
            "formItem",
            "showSuccess",
            "showError"
        ])) : (0, $ani5R.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("9oGFb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d7772f87e52572d$export$2e2bcd8739ae039);
let $6d7772f87e52572d$var$NOOP = ()=>{};
var $6d7772f87e52572d$export$2e2bcd8739ae039 = (script)=>{};

});

// VueJs
parcelRequire("ey4ci");
var $dDLnc = parcelRequire("dDLnc");
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
var $16dcc0d2591159e5$var$E = Object.defineProperty, $16dcc0d2591159e5$var$M = Object.defineProperties;
var $16dcc0d2591159e5$var$x = Object.getOwnPropertyDescriptors;
var $16dcc0d2591159e5$var$V = Object.getOwnPropertySymbols;
var $16dcc0d2591159e5$var$I = Object.prototype.hasOwnProperty, $16dcc0d2591159e5$var$N = Object.prototype.propertyIsEnumerable;
var $16dcc0d2591159e5$var$C = (e, t, s)=>t in e ? $16dcc0d2591159e5$var$E(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $16dcc0d2591159e5$var$f = (e, t)=>{
    for(var s in t || (t = {}))$16dcc0d2591159e5$var$I.call(t, s) && $16dcc0d2591159e5$var$C(e, s, t[s]);
    if ($16dcc0d2591159e5$var$V) for (var s of $16dcc0d2591159e5$var$V(t))$16dcc0d2591159e5$var$N.call(t, s) && $16dcc0d2591159e5$var$C(e, s, t[s]);
    return e;
}, $16dcc0d2591159e5$var$m = (e, t)=>$16dcc0d2591159e5$var$M(e, $16dcc0d2591159e5$var$x(t));
const $16dcc0d2591159e5$var$U = {
    props: {
        autoscroll: {
            type: Boolean,
            default: !0
        }
    },
    watch: {
        typeAheadPointer () {
            this.autoscroll && this.maybeAdjustScroll();
        },
        open (e) {
            this.autoscroll && e && this.$nextTick(()=>this.maybeAdjustScroll());
        }
    },
    methods: {
        maybeAdjustScroll () {
            var t;
            const e = ((t = this.$refs.dropdownMenu) == null ? void 0 : t.children[this.typeAheadPointer]) || !1;
            if (e) {
                const s = this.getDropdownViewport(), { top: n, bottom: l, height: i } = e.getBoundingClientRect();
                if (n < s.top) return this.$refs.dropdownMenu.scrollTop = e.offsetTop;
                if (l > s.bottom) return this.$refs.dropdownMenu.scrollTop = e.offsetTop - (s.height - i);
            }
        },
        getDropdownViewport () {
            return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
                height: 0,
                top: 0,
                bottom: 0
            };
        }
    }
}, $16dcc0d2591159e5$var$q = {
    data () {
        return {
            typeAheadPointer: -1
        };
    },
    watch: {
        filteredOptions () {
            for(let e = 0; e < this.filteredOptions.length; e++)if (this.selectable(this.filteredOptions[e])) {
                this.typeAheadPointer = e;
                break;
            }
        },
        open (e) {
            e && this.typeAheadToLastSelected();
        },
        selectedValue () {
            this.open && this.typeAheadToLastSelected();
        }
    },
    methods: {
        typeAheadUp () {
            for(let e = this.typeAheadPointer - 1; e >= 0; e--)if (this.selectable(this.filteredOptions[e])) {
                this.typeAheadPointer = e;
                break;
            }
        },
        typeAheadDown () {
            for(let e = this.typeAheadPointer + 1; e < this.filteredOptions.length; e++)if (this.selectable(this.filteredOptions[e])) {
                this.typeAheadPointer = e;
                break;
            }
        },
        typeAheadSelect () {
            const e = this.filteredOptions[this.typeAheadPointer];
            e && this.selectable(e) && this.select(e);
        },
        typeAheadToLastSelected () {
            this.typeAheadPointer = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
        }
    }
}, $16dcc0d2591159e5$var$J = {
    props: {
        loading: {
            type: Boolean,
            default: !1
        }
    },
    data () {
        return {
            mutableLoading: !1
        };
    },
    watch: {
        search () {
            this.$emit("search", this.search, this.toggleLoading);
        },
        loading (e) {
            this.mutableLoading = e;
        }
    },
    methods: {
        toggleLoading (e = null) {
            return e == null ? this.mutableLoading = !this.mutableLoading : this.mutableLoading = e;
        }
    }
}, $16dcc0d2591159e5$var$S = (e, t)=>{
    const s = e.__vccOpts || e;
    for (const [n, l] of t)s[n] = l;
    return s;
}, $16dcc0d2591159e5$var$H = {}, $16dcc0d2591159e5$var$X = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10"
}, $16dcc0d2591159e5$var$Y = /* @__PURE__ */ (0, $ani5R.createElementVNode)("path", {
    d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"
}, null, -1), $16dcc0d2591159e5$var$Q = [
    $16dcc0d2591159e5$var$Y
];
function $16dcc0d2591159e5$var$G(e, t) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", $16dcc0d2591159e5$var$X, $16dcc0d2591159e5$var$Q);
}
const $16dcc0d2591159e5$var$W = /* @__PURE__ */ $16dcc0d2591159e5$var$S($16dcc0d2591159e5$var$H, [
    [
        "render",
        $16dcc0d2591159e5$var$G
    ]
]), $16dcc0d2591159e5$var$Z = {}, $16dcc0d2591159e5$var$ee = {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "10"
}, $16dcc0d2591159e5$var$te = /* @__PURE__ */ (0, $ani5R.createElementVNode)("path", {
    d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
}, null, -1), $16dcc0d2591159e5$var$se = [
    $16dcc0d2591159e5$var$te
];
function $16dcc0d2591159e5$var$ie(e, t) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", $16dcc0d2591159e5$var$ee, $16dcc0d2591159e5$var$se);
}
const $16dcc0d2591159e5$var$oe = /* @__PURE__ */ $16dcc0d2591159e5$var$S($16dcc0d2591159e5$var$Z, [
    [
        "render",
        $16dcc0d2591159e5$var$ie
    ]
]), $16dcc0d2591159e5$var$T = {
    Deselect: $16dcc0d2591159e5$var$W,
    OpenIndicator: $16dcc0d2591159e5$var$oe
}, $16dcc0d2591159e5$var$ne = {
    mounted (e, { instance: t }) {
        if (t.appendToBody) {
            const { height: s, top: n, left: l, width: i } = t.$refs.toggle.getBoundingClientRect();
            let y = window.scrollX || window.pageXOffset, o = window.scrollY || window.pageYOffset;
            e.unbindPosition = t.calculatePosition(e, t, {
                width: i + "px",
                left: y + l + "px",
                top: o + n + s + "px"
            }), document.body.appendChild(e);
        }
    },
    unmounted (e, { instance: t }) {
        t.appendToBody && (e.unbindPosition && typeof e.unbindPosition == "function" && e.unbindPosition(), e.parentNode && e.parentNode.removeChild(e));
    }
};
function $16dcc0d2591159e5$var$le(e) {
    const t = {};
    return Object.keys(e).sort().forEach((s)=>{
        t[s] = e[s];
    }), JSON.stringify(t);
}
let $16dcc0d2591159e5$var$ae = 0;
function $16dcc0d2591159e5$var$re() {
    return ++$16dcc0d2591159e5$var$ae;
}
const $16dcc0d2591159e5$var$de = {
    components: $16dcc0d2591159e5$var$f({}, $16dcc0d2591159e5$var$T),
    directives: {
        appendToBody: $16dcc0d2591159e5$var$ne
    },
    mixins: [
        $16dcc0d2591159e5$var$U,
        $16dcc0d2591159e5$var$q,
        $16dcc0d2591159e5$var$J
    ],
    compatConfig: {
        MODE: 3
    },
    emits: [
        "open",
        "close",
        "update:modelValue",
        "search",
        "search:compositionstart",
        "search:compositionend",
        "search:keydown",
        "search:blur",
        "search:focus",
        "search:input",
        "option:created",
        "option:selecting",
        "option:selected",
        "option:deselecting",
        "option:deselected"
    ],
    props: {
        modelValue: {},
        components: {
            type: Object,
            default: ()=>({})
        },
        options: {
            type: Array,
            default () {
                return [];
            }
        },
        disabled: {
            type: Boolean,
            default: !1
        },
        clearable: {
            type: Boolean,
            default: !0
        },
        deselectFromDropdown: {
            type: Boolean,
            default: !1
        },
        searchable: {
            type: Boolean,
            default: !0
        },
        multiple: {
            type: Boolean,
            default: !1
        },
        placeholder: {
            type: String,
            default: ""
        },
        transition: {
            type: String,
            default: "vs__fade"
        },
        clearSearchOnSelect: {
            type: Boolean,
            default: !0
        },
        closeOnSelect: {
            type: Boolean,
            default: !0
        },
        label: {
            type: String,
            default: "label"
        },
        autocomplete: {
            type: String,
            default: "off"
        },
        reduce: {
            type: Function,
            default: (e)=>e
        },
        selectable: {
            type: Function,
            default: (e)=>!0
        },
        getOptionLabel: {
            type: Function,
            default (e) {
                return typeof e == "object" ? e.hasOwnProperty(this.label) ? e[this.label] : console.warn(`[vue-select warn]: Label key "option.${this.label}" does not exist in options object ${JSON.stringify(e)}.
https://vue-select.org/api/props.html#getoptionlabel`) : e;
            }
        },
        getOptionKey: {
            type: Function,
            default (e) {
                if (typeof e != "object") return e;
                try {
                    return e.hasOwnProperty("id") ? e.id : $16dcc0d2591159e5$var$le(e);
                } catch (t) {
                    return console.warn(`[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.
https://vue-select.org/api/props.html#getoptionkey`, e, t);
                }
            }
        },
        onTab: {
            type: Function,
            default: function() {
                this.selectOnTab && !this.isComposing && this.typeAheadSelect();
            }
        },
        taggable: {
            type: Boolean,
            default: !1
        },
        tabindex: {
            type: Number,
            default: null
        },
        pushTags: {
            type: Boolean,
            default: !1
        },
        filterable: {
            type: Boolean,
            default: !0
        },
        filterBy: {
            type: Function,
            default (e, t, s) {
                return (t || "").toLocaleLowerCase().indexOf(s.toLocaleLowerCase()) > -1;
            }
        },
        filter: {
            type: Function,
            default (e, t) {
                return e.filter((s)=>{
                    let n = this.getOptionLabel(s);
                    return typeof n == "number" && (n = n.toString()), this.filterBy(s, n, t);
                });
            }
        },
        createOption: {
            type: Function,
            default (e) {
                return typeof this.optionList[0] == "object" ? {
                    [this.label]: e
                } : e;
            }
        },
        resetOnOptionsChange: {
            default: !1,
            validator: (e)=>[
                    "function",
                    "boolean"
                ].includes(typeof e)
        },
        clearSearchOnBlur: {
            type: Function,
            default: function({ clearSearchOnSelect: e, multiple: t }) {
                return e && !t;
            }
        },
        noDrop: {
            type: Boolean,
            default: !1
        },
        inputId: {
            type: String
        },
        dir: {
            type: String,
            default: "auto"
        },
        selectOnTab: {
            type: Boolean,
            default: !1
        },
        selectOnKeyCodes: {
            type: Array,
            default: ()=>[
                    13
                ]
        },
        searchInputQuerySelector: {
            type: String,
            default: "[type=search]"
        },
        mapKeydown: {
            type: Function,
            default: (e, t)=>e
        },
        appendToBody: {
            type: Boolean,
            default: !1
        },
        calculatePosition: {
            type: Function,
            default (e, t, { width: s, top: n, left: l }) {
                e.style.top = n, e.style.left = l, e.style.width = s;
            }
        },
        dropdownShouldOpen: {
            type: Function,
            default ({ noDrop: e, open: t, mutableLoading: s }) {
                return e ? !1 : t && !s;
            }
        },
        uid: {
            type: [
                String,
                Number
            ],
            default: ()=>$16dcc0d2591159e5$var$re()
        }
    },
    data () {
        return {
            search: "",
            open: !1,
            isComposing: !1,
            pushedTags: [],
            _value: [],
            deselectButtons: []
        };
    },
    computed: {
        isReducingValues () {
            return this.$props.reduce !== this.$options.props.reduce.default;
        },
        isTrackingValues () {
            return typeof this.modelValue == "undefined" || this.isReducingValues;
        },
        selectedValue () {
            let e = this.modelValue;
            return this.isTrackingValues && (e = this.$data._value), e != null && e !== "" ? [].concat(e) : [];
        },
        optionList () {
            return this.options.concat(this.pushTags ? this.pushedTags : []);
        },
        searchEl () {
            return this.$slots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
        },
        scope () {
            const e = {
                search: this.search,
                loading: this.loading,
                searching: this.searching,
                filteredOptions: this.filteredOptions
            };
            return {
                search: {
                    attributes: $16dcc0d2591159e5$var$f({
                        disabled: this.disabled,
                        placeholder: this.searchPlaceholder,
                        tabindex: this.tabindex,
                        readonly: !this.searchable,
                        id: this.inputId,
                        "aria-autocomplete": "list",
                        "aria-labelledby": `vs${this.uid}__combobox`,
                        "aria-controls": `vs${this.uid}__listbox`,
                        ref: "search",
                        type: "search",
                        autocomplete: this.autocomplete,
                        value: this.search
                    }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
                        "aria-activedescendant": `vs${this.uid}__option-${this.typeAheadPointer}`
                    } : {}),
                    events: {
                        compositionstart: ()=>this.isComposing = !0,
                        compositionend: ()=>this.isComposing = !1,
                        keydown: this.onSearchKeyDown,
                        blur: this.onSearchBlur,
                        focus: this.onSearchFocus,
                        input: (t)=>this.search = t.target.value
                    }
                },
                spinner: {
                    loading: this.mutableLoading
                },
                noOptions: {
                    search: this.search,
                    loading: this.mutableLoading,
                    searching: this.searching
                },
                openIndicator: {
                    attributes: {
                        ref: "openIndicator",
                        role: "presentation",
                        class: "vs__open-indicator"
                    }
                },
                listHeader: e,
                listFooter: e,
                header: $16dcc0d2591159e5$var$m($16dcc0d2591159e5$var$f({}, e), {
                    deselect: this.deselect
                }),
                footer: $16dcc0d2591159e5$var$m($16dcc0d2591159e5$var$f({}, e), {
                    deselect: this.deselect
                })
            };
        },
        childComponents () {
            return $16dcc0d2591159e5$var$f($16dcc0d2591159e5$var$f({}, $16dcc0d2591159e5$var$T), this.components);
        },
        stateClasses () {
            return {
                "vs--open": this.dropdownOpen,
                "vs--single": !this.multiple,
                "vs--multiple": this.multiple,
                "vs--searching": this.searching && !this.noDrop,
                "vs--searchable": this.searchable && !this.noDrop,
                "vs--unsearchable": !this.searchable,
                "vs--loading": this.mutableLoading,
                "vs--disabled": this.disabled
            };
        },
        searching () {
            return !!this.search;
        },
        dropdownOpen () {
            return this.dropdownShouldOpen(this);
        },
        searchPlaceholder () {
            return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
        },
        filteredOptions () {
            const e = [].concat(this.optionList);
            if (!this.filterable && !this.taggable) return e;
            const t = this.search.length ? this.filter(e, this.search, this) : e;
            if (this.taggable && this.search.length) {
                const s = this.createOption(this.search);
                this.optionExists(s) || t.unshift(s);
            }
            return t;
        },
        isValueEmpty () {
            return this.selectedValue.length === 0;
        },
        showClearButton () {
            return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
        }
    },
    watch: {
        options (e, t) {
            const s = ()=>typeof this.resetOnOptionsChange == "function" ? this.resetOnOptionsChange(e, t, this.selectedValue) : this.resetOnOptionsChange;
            !this.taggable && s() && this.clearSelection(), this.modelValue && this.isTrackingValues && this.setInternalValueFromOptions(this.modelValue);
        },
        modelValue: {
            immediate: !0,
            handler (e) {
                this.isTrackingValues && this.setInternalValueFromOptions(e);
            }
        },
        multiple () {
            this.clearSelection();
        },
        open (e) {
            this.$emit(e ? "open" : "close");
        }
    },
    created () {
        this.mutableLoading = this.loading;
    },
    methods: {
        setInternalValueFromOptions (e) {
            Array.isArray(e) ? this.$data._value = e.map((t)=>this.findOptionFromReducedValue(t)) : this.$data._value = this.findOptionFromReducedValue(e);
        },
        select (e) {
            this.$emit("option:selecting", e), this.isOptionSelected(e) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(e) : (this.taggable && !this.optionExists(e) && (this.$emit("option:created", e), this.pushTag(e)), this.multiple && (e = this.selectedValue.concat(e)), this.updateValue(e), this.$emit("option:selected", e)), this.onAfterSelect(e);
        },
        deselect (e) {
            this.$emit("option:deselecting", e), this.updateValue(this.selectedValue.filter((t)=>!this.optionComparator(t, e))), this.$emit("option:deselected", e);
        },
        clearSelection () {
            this.updateValue(this.multiple ? [] : null);
        },
        onAfterSelect (e) {
            this.closeOnSelect && (this.open = !this.open, this.searchEl.blur()), this.clearSearchOnSelect && (this.search = "");
        },
        updateValue (e) {
            typeof this.modelValue == "undefined" && (this.$data._value = e), e !== null && (Array.isArray(e) ? e = e.map((t)=>this.reduce(t)) : e = this.reduce(e)), this.$emit("update:modelValue", e);
        },
        toggleDropdown (e) {
            const t = e.target !== this.searchEl;
            t && e.preventDefault();
            const s = [
                ...this.deselectButtons || [],
                this.$refs.clearButton
            ];
            if (this.searchEl === void 0 || s.filter(Boolean).some((n)=>n.contains(e.target) || n === e.target)) {
                e.preventDefault();
                return;
            }
            this.open && t ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
        },
        isOptionSelected (e) {
            return this.selectedValue.some((t)=>this.optionComparator(t, e));
        },
        isOptionDeselectable (e) {
            return this.isOptionSelected(e) && this.deselectFromDropdown;
        },
        optionComparator (e, t) {
            return this.getOptionKey(e) === this.getOptionKey(t);
        },
        findOptionFromReducedValue (e) {
            const t = (n)=>JSON.stringify(this.reduce(n)) === JSON.stringify(e), s = [
                ...this.options,
                ...this.pushedTags
            ].filter(t);
            return s.length === 1 ? s[0] : s.find((n)=>this.optionComparator(n, this.$data._value)) || e;
        },
        closeSearchOptions () {
            this.open = !1, this.$emit("search:blur");
        },
        maybeDeleteValue () {
            if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
                let e = null;
                this.multiple && (e = [
                    ...this.selectedValue.slice(0, this.selectedValue.length - 1)
                ]), this.updateValue(e);
            }
        },
        optionExists (e) {
            return this.optionList.some((t)=>this.optionComparator(t, e));
        },
        normalizeOptionForSlot (e) {
            return typeof e == "object" ? e : {
                [this.label]: e
            };
        },
        pushTag (e) {
            this.pushedTags.push(e);
        },
        onEscape () {
            this.search.length ? this.search = "" : this.searchEl.blur();
        },
        onSearchBlur () {
            if (this.mousedown && !this.searching) this.mousedown = !1;
            else {
                const { clearSearchOnSelect: e, multiple: t } = this;
                this.clearSearchOnBlur({
                    clearSearchOnSelect: e,
                    multiple: t
                }) && (this.search = ""), this.closeSearchOptions();
                return;
            }
            if (this.search.length === 0 && this.options.length === 0) {
                this.closeSearchOptions();
                return;
            }
        },
        onSearchFocus () {
            this.open = !0, this.$emit("search:focus");
        },
        onMousedown () {
            this.mousedown = !0;
        },
        onMouseUp () {
            this.mousedown = !1;
        },
        onSearchKeyDown (e) {
            const t = (l)=>(l.preventDefault(), !this.isComposing && this.typeAheadSelect()), s = {
                8: (l)=>this.maybeDeleteValue(),
                9: (l)=>this.onTab(),
                27: (l)=>this.onEscape(),
                38: (l)=>(l.preventDefault(), this.typeAheadUp()),
                40: (l)=>(l.preventDefault(), this.typeAheadDown())
            };
            this.selectOnKeyCodes.forEach((l)=>s[l] = t);
            const n = this.mapKeydown(s, this);
            if (typeof n[e.keyCode] == "function") return n[e.keyCode](e);
        }
    }
}, $16dcc0d2591159e5$var$he = [
    "dir"
], $16dcc0d2591159e5$var$ce = [
    "id",
    "aria-expanded",
    "aria-owns"
], $16dcc0d2591159e5$var$ue = {
    ref: "selectedOptions",
    class: "vs__selected-options"
}, $16dcc0d2591159e5$var$pe = [
    "disabled",
    "title",
    "aria-label",
    "onClick"
], $16dcc0d2591159e5$var$fe = {
    ref: "actions",
    class: "vs__actions"
}, $16dcc0d2591159e5$var$ge = [
    "disabled"
], $16dcc0d2591159e5$var$ye = {
    class: "vs__spinner"
}, $16dcc0d2591159e5$var$me = [
    "id"
], $16dcc0d2591159e5$var$be = [
    "id",
    "aria-selected",
    "onMouseover",
    "onClick"
], $16dcc0d2591159e5$var$_e = {
    key: 0,
    class: "vs__no-options"
}, $16dcc0d2591159e5$var$Oe = /* @__PURE__ */ (0, $ani5R.createTextVNode)(" Sorry, no matching options. "), $16dcc0d2591159e5$var$we = [
    "id"
];
function $16dcc0d2591159e5$var$ve(e, t, s, n, l, i) {
    const y = (0, $ani5R.resolveDirective)("append-to-body");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        dir: s.dir,
        class: (0, $X5A94.normalizeClass)([
            "v-select",
            i.stateClasses
        ])
    }, [
        (0, $ani5R.renderSlot)(e.$slots, "header", (0, $X5A94.normalizeProps)((0, $ani5R.guardReactiveProps)(i.scope.header))),
        (0, $ani5R.createElementVNode)("div", {
            id: `vs${s.uid}__combobox`,
            ref: "toggle",
            class: "vs__dropdown-toggle",
            role: "combobox",
            "aria-expanded": i.dropdownOpen.toString(),
            "aria-owns": `vs${s.uid}__listbox`,
            "aria-label": "Search for option",
            onMousedown: t[1] || (t[1] = (o)=>i.toggleDropdown(o))
        }, [
            (0, $ani5R.createElementVNode)("div", $16dcc0d2591159e5$var$ue, [
                ((0, $ani5R.openBlock)(!0), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(i.selectedValue, (o, p)=>(0, $ani5R.renderSlot)(e.$slots, "selected-option-container", {
                        option: i.normalizeOptionForSlot(o),
                        deselect: i.deselect,
                        multiple: s.multiple,
                        disabled: s.disabled
                    }, ()=>[
                            ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                                key: s.getOptionKey(o),
                                class: "vs__selected"
                            }, [
                                (0, $ani5R.renderSlot)(e.$slots, "selected-option", (0, $X5A94.normalizeProps)((0, $ani5R.guardReactiveProps)(i.normalizeOptionForSlot(o))), ()=>[
                                        (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)(s.getOptionLabel(o)), 1)
                                    ]),
                                s.multiple ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("button", {
                                    key: 0,
                                    ref_for: !0,
                                    ref: (g)=>l.deselectButtons[p] = g,
                                    disabled: s.disabled,
                                    type: "button",
                                    class: "vs__deselect",
                                    title: `Deselect ${s.getOptionLabel(o)}`,
                                    "aria-label": `Deselect ${s.getOptionLabel(o)}`,
                                    onClick: (g)=>i.deselect(o)
                                }, [
                                    ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(i.childComponents.Deselect)))
                                ], 8, $16dcc0d2591159e5$var$pe)) : (0, $ani5R.createCommentVNode)("", !0)
                            ]))
                        ])), 256)),
                (0, $ani5R.renderSlot)(e.$slots, "search", (0, $X5A94.normalizeProps)((0, $ani5R.guardReactiveProps)(i.scope.search)), ()=>[
                        (0, $ani5R.createElementVNode)("input", (0, $ani5R.mergeProps)({
                            class: "vs__search"
                        }, i.scope.search.attributes, (0, $ani5R.toHandlers)(i.scope.search.events)), null, 16)
                    ])
            ], 512),
            (0, $ani5R.createElementVNode)("div", $16dcc0d2591159e5$var$fe, [
                (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("button", {
                    ref: "clearButton",
                    disabled: s.disabled,
                    type: "button",
                    class: "vs__clear",
                    title: "Clear Selected",
                    "aria-label": "Clear Selected",
                    onClick: t[0] || (t[0] = (...o)=>i.clearSelection && i.clearSelection(...o))
                }, [
                    ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(i.childComponents.Deselect)))
                ], 8, $16dcc0d2591159e5$var$ge), [
                    [
                        (0, $dDLnc.vShow),
                        i.showClearButton
                    ]
                ]),
                (0, $ani5R.renderSlot)(e.$slots, "open-indicator", (0, $X5A94.normalizeProps)((0, $ani5R.guardReactiveProps)(i.scope.openIndicator)), ()=>[
                        s.noDrop ? (0, $ani5R.createCommentVNode)("", !0) : ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(i.childComponents.OpenIndicator), (0, $X5A94.normalizeProps)((0, $ani5R.mergeProps)({
                            key: 0
                        }, i.scope.openIndicator.attributes)), null, 16))
                    ]),
                (0, $ani5R.renderSlot)(e.$slots, "spinner", (0, $X5A94.normalizeProps)((0, $ani5R.guardReactiveProps)(i.scope.spinner)), ()=>[
                        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", $16dcc0d2591159e5$var$ye, "Loading...", 512), [
                            [
                                (0, $dDLnc.vShow),
                                e.mutableLoading
                            ]
                        ])
                    ])
            ], 512)
        ], 40, $16dcc0d2591159e5$var$ce),
        (0, $ani5R.createVNode)((0, $dDLnc.Transition), {
            name: s.transition
        }, {
            default: (0, $ani5R.withCtx)(()=>[
                    i.dropdownOpen ? (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("ul", {
                        id: `vs${s.uid}__listbox`,
                        ref: "dropdownMenu",
                        key: `vs${s.uid}__listbox`,
                        class: "vs__dropdown-menu",
                        role: "listbox",
                        tabindex: "-1",
                        onMousedown: t[2] || (t[2] = (0, $dDLnc.withModifiers)((...o)=>i.onMousedown && i.onMousedown(...o), [
                            "prevent"
                        ])),
                        onMouseup: t[3] || (t[3] = (...o)=>i.onMouseUp && i.onMouseUp(...o))
                    }, [
                        (0, $ani5R.renderSlot)(e.$slots, "list-header", (0, $X5A94.normalizeProps)((0, $ani5R.guardReactiveProps)(i.scope.listHeader))),
                        ((0, $ani5R.openBlock)(!0), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(i.filteredOptions, (o, p)=>((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
                                id: `vs${s.uid}__option-${p}`,
                                key: s.getOptionKey(o),
                                role: "option",
                                class: (0, $X5A94.normalizeClass)([
                                    "vs__dropdown-option",
                                    {
                                        "vs__dropdown-option--deselect": i.isOptionDeselectable(o) && p === e.typeAheadPointer,
                                        "vs__dropdown-option--selected": i.isOptionSelected(o),
                                        "vs__dropdown-option--highlight": p === e.typeAheadPointer,
                                        "vs__dropdown-option--disabled": !s.selectable(o)
                                    }
                                ]),
                                "aria-selected": p === e.typeAheadPointer ? !0 : null,
                                onMouseover: (g)=>s.selectable(o) ? e.typeAheadPointer = p : null,
                                onClick: (0, $dDLnc.withModifiers)((g)=>s.selectable(o) ? i.select(o) : null, [
                                    "prevent",
                                    "stop"
                                ])
                            }, [
                                (0, $ani5R.renderSlot)(e.$slots, "option", (0, $X5A94.normalizeProps)((0, $ani5R.guardReactiveProps)(i.normalizeOptionForSlot(o))), ()=>[
                                        (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)(s.getOptionLabel(o)), 1)
                                    ])
                            ], 42, $16dcc0d2591159e5$var$be))), 128)),
                        i.filteredOptions.length === 0 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", $16dcc0d2591159e5$var$_e, [
                            (0, $ani5R.renderSlot)(e.$slots, "no-options", (0, $X5A94.normalizeProps)((0, $ani5R.guardReactiveProps)(i.scope.noOptions)), ()=>[
                                    $16dcc0d2591159e5$var$Oe
                                ])
                        ])) : (0, $ani5R.createCommentVNode)("", !0),
                        (0, $ani5R.renderSlot)(e.$slots, "list-footer", (0, $X5A94.normalizeProps)((0, $ani5R.guardReactiveProps)(i.scope.listFooter)))
                    ], 40, $16dcc0d2591159e5$var$me)), [
                        [
                            y
                        ]
                    ]) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("ul", {
                        key: 1,
                        id: `vs${s.uid}__listbox`,
                        role: "listbox",
                        style: {
                            display: "none",
                            visibility: "hidden"
                        }
                    }, null, 8, $16dcc0d2591159e5$var$we))
                ]),
            _: 3
        }, 8, [
            "name"
        ]),
        (0, $ani5R.renderSlot)(e.$slots, "footer", (0, $X5A94.normalizeProps)((0, $ani5R.guardReactiveProps)(i.scope.footer)))
    ], 10, $16dcc0d2591159e5$var$he);
}
const $16dcc0d2591159e5$export$2e2bcd8739ae039 = /* @__PURE__ */ $16dcc0d2591159e5$var$S($16dcc0d2591159e5$var$de, [
    [
        "render",
        $16dcc0d2591159e5$var$ve
    ]
]);


var $4e74f275bd5b5b89$exports = {};
'use strict';
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");
var $0deed543ccab4a3d$export$a65c7cc2c8845330;
var $0deed543ccab4a3d$export$c9e5a085bf83f8b;
var $0deed543ccab4a3d$export$69c7a77cf657af8f;
var $0deed543ccab4a3d$export$ef7acd7185315e22;
var $0deed543ccab4a3d$export$1f803343cd5d268d;
var $0deed543ccab4a3d$export$45a69314cf48a3eb;
var $0deed543ccab4a3d$export$62651879628e0c4c;
var $0deed543ccab4a3d$export$270e7ba5936d3c48;
var $0deed543ccab4a3d$export$598ddf5ea05e86ce;
var $0deed543ccab4a3d$export$7f75b77267f1fa35;
var $0deed543ccab4a3d$export$b4570ea00533c3e5;
var $0deed543ccab4a3d$export$a3bc9b8ed74fc;
var $0deed543ccab4a3d$export$cc3fdd528b56c4a9;
var $0deed543ccab4a3d$export$fe64dbc167601fe7;
var $0deed543ccab4a3d$export$3f778c4e796a1f9c;
var $0deed543ccab4a3d$export$3b2d240469e38cce;
var $0deed543ccab4a3d$export$33d5b72ec833fd5f;
var $0deed543ccab4a3d$export$41e30d8dd0ba7a50;
var $0deed543ccab4a3d$export$ead95ff48ba53ffd;
var $0deed543ccab4a3d$export$8ee0fc9ee280b4ee;
var $0deed543ccab4a3d$export$2047bcc885291b3f;
var $0deed543ccab4a3d$export$47a97cb489ea6411;
var $0deed543ccab4a3d$export$e4b2ac9215619f8d;
var $0deed543ccab4a3d$export$6503ec6e8aabbaf;
var $0deed543ccab4a3d$export$aad8462122ac592b;
var $0deed543ccab4a3d$export$218404c250ebcb05;
var $0deed543ccab4a3d$export$b668408ac8206d2f;
var $0deed543ccab4a3d$export$8b2e7eab72dc3481;
var $0deed543ccab4a3d$export$d38475e6e890fc63;
var $0deed543ccab4a3d$export$e02251cfbe407ee6;
var $0deed543ccab4a3d$export$e970e05fc1e8bae;
var $0deed543ccab4a3d$export$1f96ae73734a86cc;
var $0deed543ccab4a3d$export$bb0968b4d41ab5a0;
var $0deed543ccab4a3d$export$2f9e0b9e6f218a71;
var $0deed543ccab4a3d$export$fc96cc4f823ff664;
var $0deed543ccab4a3d$export$b47d29d1be32fa3d;
var $0deed543ccab4a3d$export$c106dd0671a0fc2d;
var $0deed543ccab4a3d$export$3d46431aec5d0165;
var $0deed543ccab4a3d$export$e6fd047a0a0a675b;
'use strict';
var $639fe8cc1eae7e21$export$9dfe4a9b3485997f;
var $639fe8cc1eae7e21$export$da3eca551f501a9a;
var $639fe8cc1eae7e21$export$ddab50941423df32;
var $639fe8cc1eae7e21$export$9cd59f9826255e47;
var $639fe8cc1eae7e21$export$359e5dfb2bfaf73a;
var $639fe8cc1eae7e21$export$f3a259b74a77132f;
var $639fe8cc1eae7e21$export$6e22c362a0406a2c;
var $639fe8cc1eae7e21$export$9663ddc1cf085b32;
var $639fe8cc1eae7e21$export$a655378fbd298adf;
var $639fe8cc1eae7e21$export$f2b2628ba3e2a5d3;
var $639fe8cc1eae7e21$export$67aba9fb222c5e1d;
var $639fe8cc1eae7e21$export$8b58be045bf06082;
var $639fe8cc1eae7e21$export$b2379508bf8b684a;
var $639fe8cc1eae7e21$export$a4f4bb6b1453fff5;
var $639fe8cc1eae7e21$export$2cd8252107eb640b;
var $639fe8cc1eae7e21$export$a6cdc56e425d0d0a;
var $639fe8cc1eae7e21$export$d4c25d8e0539e508;
var $639fe8cc1eae7e21$export$56a96871fc26791a;
var $639fe8cc1eae7e21$export$6ba840931da50680;
var $639fe8cc1eae7e21$export$28a4dff995472450;
var $639fe8cc1eae7e21$export$db0c04b6ea9f34a0;
var $639fe8cc1eae7e21$export$4debbe1037afe35e;
var $639fe8cc1eae7e21$export$16a9f4045037bb61;
var $639fe8cc1eae7e21$export$fe98000b1ab912f3;
var $639fe8cc1eae7e21$export$7300a92932ee17a3;
var $639fe8cc1eae7e21$export$15aa749a72b8e26d;
var $639fe8cc1eae7e21$export$f14dae2add6bfcb0;
var $639fe8cc1eae7e21$export$597b9003fa63c16a;
var $639fe8cc1eae7e21$export$370e8311c3cdebd9;
var $639fe8cc1eae7e21$export$c383cdd2a518017a;
var $639fe8cc1eae7e21$export$3ae0fd4797ed47c8;
var $639fe8cc1eae7e21$export$9e1725a4cfeada27;
var $639fe8cc1eae7e21$export$96e6ef1411d879b1;
var $639fe8cc1eae7e21$export$931efcf1eab6c91c;
'use strict';
// packages/utils/src/index.ts
var $639fe8cc1eae7e21$var$isBrowser = typeof window !== "undefined";
var $639fe8cc1eae7e21$var$explicitKeys = [
    "__key",
    "__init",
    "__shim",
    "__original",
    "__index",
    "__prevKey"
];
function $639fe8cc1eae7e21$var$token() {
    return Math.random().toString(36).substring(2, 15);
}
function $639fe8cc1eae7e21$var$setify(items) {
    return items instanceof Set ? items : new Set(items);
}
function $639fe8cc1eae7e21$var$dedupe(arr1, arr2) {
    const original = arr1 instanceof Set ? arr1 : new Set(arr1);
    if (arr2) arr2.forEach((item)=>original.add(item));
    return [
        ...original
    ];
}
function $639fe8cc1eae7e21$var$has(obj, property) {
    return Object.prototype.hasOwnProperty.call(obj, property);
}
function $639fe8cc1eae7e21$var$eq(valA, valB, deep = true, explicit = [
    "__key"
]) {
    if (valA === valB) return true;
    if (typeof valB === "object" && typeof valA === "object") {
        if (valA instanceof Map) return false;
        if (valA instanceof Set) return false;
        if (valA instanceof Date && valB instanceof Date) return valA.getTime() === valB.getTime();
        if (valA instanceof RegExp && valB instanceof RegExp) return $639fe8cc1eae7e21$var$eqRegExp(valA, valB);
        if (valA === null || valB === null) return false;
        if (Object.keys(valA).length !== Object.keys(valB).length) return false;
        for (const k of explicit){
            if ((k in valA || k in valB) && valA[k] !== valB[k]) return false;
        }
        for(const key in valA){
            if (!(key in valB)) return false;
            if (valA[key] !== valB[key] && !deep) return false;
            if (deep && !$639fe8cc1eae7e21$var$eq(valA[key], valB[key], deep, explicit)) return false;
        }
        return true;
    }
    return false;
}
function $639fe8cc1eae7e21$var$eqRegExp(x, y) {
    return x.source === y.source && x.flags.split("").sort().join("") === y.flags.split("").sort().join("");
}
function $639fe8cc1eae7e21$var$empty(value) {
    const type = typeof value;
    if (type === "number") return false;
    if (value === void 0) return true;
    if (type === "string") return value === "";
    if (type === "object") {
        if (value === null) return true;
        for(const _i in value)return false;
        if (value instanceof RegExp) return false;
        if (value instanceof Date) return false;
        return true;
    }
    return false;
}
function $639fe8cc1eae7e21$var$escapeExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $639fe8cc1eae7e21$var$regexForFormat(format) {
    const escaped = `^${$639fe8cc1eae7e21$var$escapeExp(format)}$`;
    const formats = {
        MM: "(0[1-9]|1[012])",
        M: "([1-9]|1[012])",
        DD: "([012][0-9]|3[01])",
        D: "([012]?[0-9]|3[01])",
        YYYY: "\\d{4}",
        YY: "\\d{2}"
    };
    const tokens = Object.keys(formats);
    return new RegExp(tokens.reduce((regex, format2)=>{
        return regex.replace(format2, formats[format2]);
    }, escaped));
}
function $639fe8cc1eae7e21$var$nodeType(type) {
    const t = type.toLowerCase();
    if (t === "list") return "list";
    if (t === "group") return "group";
    return "input";
}
function $639fe8cc1eae7e21$var$isRecord(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $639fe8cc1eae7e21$var$isObject(o) {
    return $639fe8cc1eae7e21$var$isRecord(o) || Array.isArray(o);
}
function $639fe8cc1eae7e21$var$isPojo(o) {
    if ($639fe8cc1eae7e21$var$isRecord(o) === false) return false;
    if (o.__FKNode__ || o.__POJO__ === false) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if ($639fe8cc1eae7e21$var$isRecord(prot) === false) return false;
    if (prot.hasOwnProperty("isPrototypeOf") === false) return false;
    return true;
}
var $639fe8cc1eae7e21$var$extend = /* @__NO_SIDE_EFFECTS__ */ (original, additional, extendArrays = false, ignoreUndefined = false)=>{
    if (additional === null) return null;
    const merged = {};
    if (typeof additional === "string") return additional;
    for(const key in original)if ($639fe8cc1eae7e21$var$has(additional, key) && (additional[key] !== void 0 || !ignoreUndefined)) {
        if (extendArrays && Array.isArray(original[key]) && Array.isArray(additional[key])) {
            merged[key] = original[key].concat(additional[key]);
            continue;
        }
        if (additional[key] === void 0) continue;
        if ($639fe8cc1eae7e21$var$isPojo(original[key]) && $639fe8cc1eae7e21$var$isPojo(additional[key])) merged[key] = /* @__PURE__ */ $639fe8cc1eae7e21$var$extend(original[key], additional[key], extendArrays, ignoreUndefined);
        else merged[key] = additional[key];
    } else merged[key] = original[key];
    for(const key in additional)if (!$639fe8cc1eae7e21$var$has(merged, key) && additional[key] !== void 0) merged[key] = additional[key];
    return merged;
};
function $639fe8cc1eae7e21$var$isQuotedString(str) {
    if (str[0] !== '"' && str[0] !== "'") return false;
    if (str[0] !== str[str.length - 1]) return false;
    const quoteType = str[0];
    for(let p = 1; p < str.length; p++){
        if (str[p] === quoteType && (p === 1 || str[p - 1] !== "\\") && p !== str.length - 1) return false;
    }
    return true;
}
function $639fe8cc1eae7e21$var$rmEscapes(str) {
    if (!str.length) return "";
    let clean = "";
    let lastChar = "";
    for(let p = 0; p < str.length; p++){
        const char = str.charAt(p);
        if (char !== "\\" || lastChar === "\\") clean += char;
        lastChar = char;
    }
    return clean;
}
function $639fe8cc1eae7e21$var$assignDeep(a, b) {
    for(const key in a){
        if ($639fe8cc1eae7e21$var$has(b, key) && a[key] !== b[key] && !($639fe8cc1eae7e21$var$isPojo(a[key]) && $639fe8cc1eae7e21$var$isPojo(b[key]))) a[key] = b[key];
        else if ($639fe8cc1eae7e21$var$isPojo(a[key]) && $639fe8cc1eae7e21$var$isPojo(b[key])) $639fe8cc1eae7e21$var$assignDeep(a[key], b[key]);
    }
    for(const key in b)if (!$639fe8cc1eae7e21$var$has(a, key)) a[key] = b[key];
    return a;
}
function $639fe8cc1eae7e21$var$nodeProps(...sets) {
    return sets.reduce((valid, props)=>{
        const { value: value, name: name, modelValue: modelValue, config: config, plugins: plugins, ...validProps } = props;
        return Object.assign(valid, validProps);
    }, {});
}
function $639fe8cc1eae7e21$var$parseArgs(str) {
    const args = [];
    let arg = "";
    let depth = 0;
    let quote = "";
    let lastChar = "";
    for(let p = 0; p < str.length; p++){
        const char = str.charAt(p);
        if (char === quote && lastChar !== "\\") quote = "";
        else if ((char === "'" || char === '"') && !quote && lastChar !== "\\") quote = char;
        else if (char === "(" && !quote) depth++;
        else if (char === ")" && !quote) depth--;
        if (char === "," && !quote && depth === 0) {
            args.push(arg);
            arg = "";
        } else if (char !== " " || quote) arg += char;
        lastChar = char;
    }
    if (arg) args.push(arg);
    return args;
}
function $639fe8cc1eae7e21$var$except(obj, toRemove) {
    const clean = {};
    const exps = toRemove.filter((n)=>n instanceof RegExp);
    const keysToRemove = new Set(toRemove);
    for(const key in obj)if (!keysToRemove.has(key) && !exps.some((exp)=>exp.test(key))) clean[key] = obj[key];
    return clean;
}
function $639fe8cc1eae7e21$var$only(obj, include) {
    const clean = {};
    const exps = include.filter((n)=>n instanceof RegExp);
    include.forEach((key)=>{
        if (!(key instanceof RegExp)) clean[key] = obj[key];
    });
    Object.keys(obj).forEach((key)=>{
        if (exps.some((exp)=>exp.test(key))) clean[key] = obj[key];
    });
    return clean;
}
function $639fe8cc1eae7e21$var$camel(str) {
    return str.replace(/-([a-z0-9])/gi, (_s, g)=>g.toUpperCase());
}
function $639fe8cc1eae7e21$var$kebab(str) {
    return str.replace(/([a-z0-9])([A-Z])/g, (_s, trail, cap)=>trail + "-" + cap.toLowerCase()).replace(" ", "-").toLowerCase();
}
function $639fe8cc1eae7e21$var$shallowClone(obj, explicit = $639fe8cc1eae7e21$var$explicitKeys) {
    if (obj !== null && typeof obj === "object") {
        let returnObject;
        if (Array.isArray(obj)) returnObject = [
            ...obj
        ];
        else if ($639fe8cc1eae7e21$var$isPojo(obj)) returnObject = {
            ...obj
        };
        if (returnObject) {
            $639fe8cc1eae7e21$var$applyExplicit(obj, returnObject, explicit);
            return returnObject;
        }
    }
    return obj;
}
function $639fe8cc1eae7e21$var$clone(obj, explicit = $639fe8cc1eae7e21$var$explicitKeys) {
    if (obj === null || obj instanceof RegExp || obj instanceof Date || obj instanceof Map || obj instanceof Set || typeof File === "function" && obj instanceof File) return obj;
    let returnObject;
    if (Array.isArray(obj)) returnObject = obj.map((value)=>{
        if (typeof value === "object") return $639fe8cc1eae7e21$var$clone(value, explicit);
        return value;
    });
    else returnObject = Object.keys(obj).reduce((newObj, key)=>{
        newObj[key] = typeof obj[key] === "object" ? $639fe8cc1eae7e21$var$clone(obj[key], explicit) : obj[key];
        return newObj;
    }, {});
    for (const key of explicit)if (key in obj) Object.defineProperty(returnObject, key, {
        enumerable: false,
        value: obj[key]
    });
    return returnObject;
}
function $639fe8cc1eae7e21$var$cloneAny(obj) {
    return typeof obj === "object" ? $639fe8cc1eae7e21$var$clone(obj) : obj;
}
function $639fe8cc1eae7e21$var$getAt(obj, addr) {
    if (!obj || typeof obj !== "object") return null;
    const segments = addr.split(".");
    let o = obj;
    for(const i in segments){
        const segment = segments[i];
        if ($639fe8cc1eae7e21$var$has(o, segment)) o = o[segment];
        if (+i === segments.length - 1) return o;
        if (!o || typeof o !== "object") return null;
    }
    return null;
}
function $639fe8cc1eae7e21$var$undefine(value) {
    return value !== void 0 && value !== "false" && value !== false ? true : void 0;
}
function $639fe8cc1eae7e21$var$init(obj) {
    return !Object.isFrozen(obj) ? Object.defineProperty(obj, "__init", {
        enumerable: false,
        value: true
    }) : obj;
}
function $639fe8cc1eae7e21$var$slugify(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
}
function $639fe8cc1eae7e21$var$spread(obj, explicit = $639fe8cc1eae7e21$var$explicitKeys) {
    if (obj && typeof obj === "object") {
        if (obj instanceof RegExp) return obj;
        if (obj instanceof Date) return obj;
        let spread2;
        if (Array.isArray(obj)) spread2 = [
            ...obj
        ];
        else spread2 = {
            ...obj
        };
        return $639fe8cc1eae7e21$var$applyExplicit(obj, spread2, explicit);
    }
    return obj;
}
function $639fe8cc1eae7e21$var$applyExplicit(original, obj, explicit) {
    for (const key of explicit)if (key in original) Object.defineProperty(obj, key, {
        enumerable: false,
        value: original[key]
    });
    return obj;
}
function $639fe8cc1eae7e21$var$whenAvailable(childId, callback, root) {
    if (!$639fe8cc1eae7e21$var$isBrowser) return;
    if (!root) root = document;
    const el = root.getElementById(childId);
    if (el) return callback(el);
    const observer = new MutationObserver(()=>{
        const el2 = root?.getElementById(childId);
        if (el2) {
            observer?.disconnect();
            callback(el2);
        }
    });
    observer.observe(root, {
        childList: true,
        subtree: true
    });
}
function $639fe8cc1eae7e21$var$oncePerTick(fn) {
    let called = false;
    return (...args)=>{
        if (called) return;
        called = true;
        queueMicrotask(()=>called = false);
        return fn(...args);
    };
}
function $639fe8cc1eae7e21$var$boolGetter(value) {
    if (value === "false" || value === false) return void 0;
    return true;
}
$639fe8cc1eae7e21$export$9dfe4a9b3485997f = $639fe8cc1eae7e21$var$assignDeep;
$639fe8cc1eae7e21$export$da3eca551f501a9a = $639fe8cc1eae7e21$var$boolGetter;
$639fe8cc1eae7e21$export$ddab50941423df32 = $639fe8cc1eae7e21$var$camel;
$639fe8cc1eae7e21$export$9cd59f9826255e47 = $639fe8cc1eae7e21$var$clone;
$639fe8cc1eae7e21$export$359e5dfb2bfaf73a = $639fe8cc1eae7e21$var$cloneAny;
$639fe8cc1eae7e21$export$f3a259b74a77132f = $639fe8cc1eae7e21$var$dedupe;
$639fe8cc1eae7e21$export$6e22c362a0406a2c = $639fe8cc1eae7e21$var$empty;
$639fe8cc1eae7e21$export$9663ddc1cf085b32 = $639fe8cc1eae7e21$var$eq;
$639fe8cc1eae7e21$export$a655378fbd298adf = $639fe8cc1eae7e21$var$eqRegExp;
$639fe8cc1eae7e21$export$f2b2628ba3e2a5d3 = $639fe8cc1eae7e21$var$escapeExp;
$639fe8cc1eae7e21$export$67aba9fb222c5e1d = $639fe8cc1eae7e21$var$except;
$639fe8cc1eae7e21$export$8b58be045bf06082 = $639fe8cc1eae7e21$var$extend;
$639fe8cc1eae7e21$export$b2379508bf8b684a = $639fe8cc1eae7e21$var$getAt;
$639fe8cc1eae7e21$export$a4f4bb6b1453fff5 = $639fe8cc1eae7e21$var$has;
$639fe8cc1eae7e21$export$2cd8252107eb640b = $639fe8cc1eae7e21$var$init;
$639fe8cc1eae7e21$export$a6cdc56e425d0d0a = $639fe8cc1eae7e21$var$isObject;
$639fe8cc1eae7e21$export$d4c25d8e0539e508 = $639fe8cc1eae7e21$var$isPojo;
$639fe8cc1eae7e21$export$56a96871fc26791a = $639fe8cc1eae7e21$var$isQuotedString;
$639fe8cc1eae7e21$export$6ba840931da50680 = $639fe8cc1eae7e21$var$isRecord;
$639fe8cc1eae7e21$export$28a4dff995472450 = $639fe8cc1eae7e21$var$kebab;
$639fe8cc1eae7e21$export$db0c04b6ea9f34a0 = $639fe8cc1eae7e21$var$nodeProps;
$639fe8cc1eae7e21$export$4debbe1037afe35e = $639fe8cc1eae7e21$var$nodeType;
$639fe8cc1eae7e21$export$16a9f4045037bb61 = $639fe8cc1eae7e21$var$oncePerTick;
$639fe8cc1eae7e21$export$fe98000b1ab912f3 = $639fe8cc1eae7e21$var$only;
$639fe8cc1eae7e21$export$7300a92932ee17a3 = $639fe8cc1eae7e21$var$parseArgs;
$639fe8cc1eae7e21$export$15aa749a72b8e26d = $639fe8cc1eae7e21$var$regexForFormat;
$639fe8cc1eae7e21$export$f14dae2add6bfcb0 = $639fe8cc1eae7e21$var$rmEscapes;
$639fe8cc1eae7e21$export$597b9003fa63c16a = $639fe8cc1eae7e21$var$setify;
$639fe8cc1eae7e21$export$370e8311c3cdebd9 = $639fe8cc1eae7e21$var$shallowClone;
$639fe8cc1eae7e21$export$c383cdd2a518017a = $639fe8cc1eae7e21$var$slugify;
$639fe8cc1eae7e21$export$3ae0fd4797ed47c8 = $639fe8cc1eae7e21$var$spread;
$639fe8cc1eae7e21$export$9e1725a4cfeada27 = $639fe8cc1eae7e21$var$token;
$639fe8cc1eae7e21$export$96e6ef1411d879b1 = $639fe8cc1eae7e21$var$undefine;
$639fe8cc1eae7e21$export$931efcf1eab6c91c = $639fe8cc1eae7e21$var$whenAvailable; //# sourceMappingURL=out.js.map
 //# sourceMappingURL=index.cjs.map


// packages/core/src/dispatcher.ts
function $0deed543ccab4a3d$var$createDispatcher() {
    const middleware = [];
    let currentIndex = 0;
    const use2 = (dispatchable)=>middleware.push(dispatchable);
    const dispatch = (payload)=>{
        const current = middleware[currentIndex];
        if (typeof current === "function") return current(payload, (explicitPayload)=>{
            currentIndex++;
            return dispatch(explicitPayload);
        });
        currentIndex = 0;
        return payload;
    };
    use2.dispatch = dispatch;
    use2.unshift = (dispatchable)=>middleware.unshift(dispatchable);
    use2.remove = (dispatchable)=>{
        const index = middleware.indexOf(dispatchable);
        if (index > -1) middleware.splice(index, 1);
    };
    return use2;
}
function $0deed543ccab4a3d$var$createEmitter() {
    const listeners = /* @__PURE__ */ new Map();
    const receipts2 = /* @__PURE__ */ new Map();
    let buffer = void 0;
    const emitter = (node, event)=>{
        if (buffer) {
            buffer.set(event.name, [
                node,
                event
            ]);
            return;
        }
        if (listeners.has(event.name)) listeners.get(event.name).forEach((wrapper)=>{
            if (event.origin === node || wrapper.modifiers.includes("deep")) wrapper.listener(event);
        });
        if (event.bubble) node.bubble(event);
    };
    emitter.flush = ()=>{
        listeners.clear();
        receipts2.clear();
        buffer?.clear();
    };
    emitter.on = (eventName, listener, pos = "push")=>{
        const [event, ...modifiers] = eventName.split(".");
        const receipt = listener.receipt || $639fe8cc1eae7e21$export$9e1725a4cfeada27();
        const wrapper = {
            modifiers: modifiers,
            event: event,
            listener: listener,
            receipt: receipt
        };
        listeners.has(event) ? listeners.get(event)[pos](wrapper) : listeners.set(event, [
            wrapper
        ]);
        receipts2.has(receipt) ? receipts2.get(receipt)[pos](event) : receipts2.set(receipt, [
            event
        ]);
        return receipt;
    };
    emitter.off = (receipt)=>{
        if (receipts2.has(receipt)) {
            receipts2.get(receipt)?.forEach((event)=>{
                const eventListeners = listeners.get(event);
                if (Array.isArray(eventListeners)) listeners.set(event, eventListeners.filter((wrapper)=>wrapper.receipt !== receipt));
            });
            receipts2.delete(receipt);
        }
    };
    emitter.pause = (node)=>{
        if (!buffer) buffer = /* @__PURE__ */ new Map();
        if (node) node.walk((child)=>child._e.pause());
    };
    emitter.play = (node)=>{
        if (!buffer) return;
        const events = buffer;
        buffer = void 0;
        events.forEach(([node2, event])=>emitter(node2, event));
        if (node) node.walk((child)=>child._e.play());
    };
    return emitter;
}
function $0deed543ccab4a3d$var$emit(node, context, name, payload, bubble2 = true, meta) {
    context._e(node, {
        payload: payload,
        name: name,
        bubble: bubble2,
        origin: node,
        meta: meta
    });
    return node;
}
function $0deed543ccab4a3d$var$bubble(node, _context, event) {
    if ($0deed543ccab4a3d$var$isNode(node.parent)) node.parent._e(node.parent, event);
    return node;
}
function $0deed543ccab4a3d$var$on(_node, context, name, listener, pos) {
    return context._e.on(name, listener, pos);
}
function $0deed543ccab4a3d$var$off(node, context, receipt) {
    context._e.off(receipt);
    return node;
}
// packages/core/src/errors.ts
var $0deed543ccab4a3d$var$errorHandler = $0deed543ccab4a3d$var$createDispatcher();
$0deed543ccab4a3d$var$errorHandler((error2, next)=>{
    if (!error2.message) error2.message = String(`E${error2.code}`);
    return next(error2);
});
var $0deed543ccab4a3d$var$warningHandler = $0deed543ccab4a3d$var$createDispatcher();
$0deed543ccab4a3d$var$warningHandler((warning, next)=>{
    if (!warning.message) warning.message = String(`W${warning.code}`);
    const result = next(warning);
    if (console && typeof console.warn === "function") console.warn(result.message);
    return result;
});
function $0deed543ccab4a3d$var$warn(code, data = {}) {
    $0deed543ccab4a3d$var$warningHandler.dispatch({
        code: code,
        data: data
    });
}
function $0deed543ccab4a3d$var$error(code, data = {}) {
    throw Error($0deed543ccab4a3d$var$errorHandler.dispatch({
        code: code,
        data: data
    }).message);
}
function $0deed543ccab4a3d$var$createMessage(conf, node) {
    const m = {
        blocking: false,
        key: $639fe8cc1eae7e21$export$9e1725a4cfeada27(),
        meta: {},
        type: "state",
        visible: true,
        ...conf
    };
    if (node && m.value && m.meta.localize !== false) {
        m.value = node.t(m);
        m.meta.locale = node.config.locale;
    }
    return m;
}
var $0deed543ccab4a3d$var$storeTraps = {
    apply: $0deed543ccab4a3d$var$applyMessages,
    set: $0deed543ccab4a3d$var$setMessage,
    remove: $0deed543ccab4a3d$var$removeMessage,
    filter: $0deed543ccab4a3d$var$filterMessages,
    reduce: $0deed543ccab4a3d$var$reduceMessages,
    release: $0deed543ccab4a3d$var$releaseBuffer,
    touch: $0deed543ccab4a3d$var$touchMessages
};
function $0deed543ccab4a3d$var$createStore(_buffer = false) {
    const messages = {};
    let node;
    let buffer = _buffer;
    let _b = [];
    const _m = /* @__PURE__ */ new Map();
    let _r = void 0;
    const store = new Proxy(messages, {
        get (...args) {
            const [_target, property] = args;
            if (property === "buffer") return buffer;
            if (property === "_b") return _b;
            if (property === "_m") return _m;
            if (property === "_r") return _r;
            if ($639fe8cc1eae7e21$export$a4f4bb6b1453fff5($0deed543ccab4a3d$var$storeTraps, property)) return $0deed543ccab4a3d$var$storeTraps[property].bind(null, messages, store, node);
            return Reflect.get(...args);
        },
        set (_t, prop, value) {
            if (prop === "_n") {
                node = value;
                if (_r === "__n") $0deed543ccab4a3d$var$releaseMissed(node, store);
                return true;
            } else if (prop === "_b") {
                _b = value;
                return true;
            } else if (prop === "buffer") {
                buffer = value;
                return true;
            } else if (prop === "_r") {
                _r = value;
                return true;
            }
            $0deed543ccab4a3d$var$error(101, node);
            return false;
        }
    });
    return store;
}
function $0deed543ccab4a3d$var$setMessage(messageStore, store, node, message) {
    if (store.buffer) {
        store._b.push([
            [
                message
            ]
        ]);
        return store;
    }
    if (messageStore[message.key] !== message) {
        if (typeof message.value === "string" && message.meta.localize !== false) {
            const previous = message.value;
            message.value = node.t(message);
            if (message.value !== previous) message.meta.locale = node.props.locale;
        }
        const e = `message-${$639fe8cc1eae7e21$export$a4f4bb6b1453fff5(messageStore, message.key) ? "updated" : "added"}`;
        messageStore[message.key] = Object.freeze(node.hook.message.dispatch(message));
        node.emit(e, message);
    }
    return store;
}
function $0deed543ccab4a3d$var$touchMessages(messageStore, store) {
    for(const key in messageStore){
        const message = {
            ...messageStore[key]
        };
        store.set(message);
    }
}
function $0deed543ccab4a3d$var$removeMessage(messageStore, store, node, key) {
    if ($639fe8cc1eae7e21$export$a4f4bb6b1453fff5(messageStore, key)) {
        const message = messageStore[key];
        delete messageStore[key];
        node.emit("message-removed", message);
    }
    if (store.buffer === true) store._b = store._b.filter((buffered)=>{
        buffered[0] = buffered[0].filter((m)=>m.key !== key);
        return buffered[1] || buffered[0].length;
    });
    return store;
}
function $0deed543ccab4a3d$var$filterMessages(messageStore, store, node, callback, type) {
    for(const key in messageStore){
        const message = messageStore[key];
        if ((!type || message.type === type) && !callback(message)) $0deed543ccab4a3d$var$removeMessage(messageStore, store, node, key);
    }
}
function $0deed543ccab4a3d$var$reduceMessages(messageStore, _store, _node, reducer, accumulator) {
    for(const key in messageStore){
        const message = messageStore[key];
        accumulator = reducer(accumulator, message);
    }
    return accumulator;
}
function $0deed543ccab4a3d$var$applyMessages(_messageStore, store, node, messages, clear) {
    if (Array.isArray(messages)) {
        if (store.buffer) {
            store._b.push([
                messages,
                clear
            ]);
            return;
        }
        const applied = new Set(messages.map((message)=>{
            store.set(message);
            return message.key;
        }));
        if (typeof clear === "string") store.filter((message)=>message.type !== clear || applied.has(message.key));
        else if (typeof clear === "function") store.filter((message)=>!clear(message) || applied.has(message.key));
    } else for(const address in messages){
        const child = node.at(address);
        if (child) child.store.apply(messages[address], clear);
        else $0deed543ccab4a3d$var$missed(node, store, address, messages[address], clear);
    }
}
function $0deed543ccab4a3d$var$createMessages(node, ...errors) {
    const sourceKey = `${node.name}-set`;
    const make = (error2)=>/* @__PURE__ */ $0deed543ccab4a3d$var$createMessage({
            key: $639fe8cc1eae7e21$export$c383cdd2a518017a(error2),
            type: "error",
            value: error2,
            meta: {
                source: sourceKey,
                autoClear: true
            }
        });
    return errors.filter((m)=>!!m).map((errorSet)=>{
        if (typeof errorSet === "string") errorSet = [
            errorSet
        ];
        if (Array.isArray(errorSet)) return errorSet.map((error2)=>make(error2));
        else {
            const errors2 = {};
            for(const key in errorSet)if (Array.isArray(errorSet[key])) errors2[key] = errorSet[key].map((error2)=>make(error2));
            else errors2[key] = [
                make(errorSet[key])
            ];
            return errors2;
        }
    });
}
function $0deed543ccab4a3d$var$missed(node, store, address, messages, clear) {
    const misses = store._m;
    if (!misses.has(address)) misses.set(address, []);
    if (!store._r) store._r = $0deed543ccab4a3d$var$releaseMissed(node, store);
    misses.get(address)?.push([
        messages,
        clear
    ]);
}
function $0deed543ccab4a3d$var$releaseMissed(node, store) {
    return node.on("child.deep", ({ payload: child })=>{
        store._m.forEach((misses, address)=>{
            if (node.at(address) === child) {
                misses.forEach(([messages, clear])=>{
                    child.store.apply(messages, clear);
                });
                store._m.delete(address);
            }
        });
        if (store._m.size === 0 && store._r) {
            node.off(store._r);
            store._r = void 0;
        }
    });
}
function $0deed543ccab4a3d$var$releaseBuffer(_messageStore, store) {
    store.buffer = false;
    store._b.forEach(([messages, clear])=>store.apply(messages, clear));
    store._b = [];
}
function $0deed543ccab4a3d$var$createLedger() {
    const ledger = {};
    let n;
    return {
        count: (...args)=>$0deed543ccab4a3d$var$createCounter(n, ledger, ...args),
        init (node) {
            n = node;
            node.on("message-added.deep", $0deed543ccab4a3d$var$add(ledger, 1));
            node.on("message-removed.deep", $0deed543ccab4a3d$var$add(ledger, -1));
        },
        merge: (child)=>$0deed543ccab4a3d$var$merge(n, ledger, child),
        settled (counterName) {
            return $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(ledger, counterName) ? ledger[counterName].promise : Promise.resolve();
        },
        unmerge: (child)=>$0deed543ccab4a3d$var$merge(n, ledger, child, true),
        value (counterName) {
            return $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(ledger, counterName) ? ledger[counterName].count : 0;
        }
    };
}
function $0deed543ccab4a3d$var$createCounter(node, ledger, counterName, condition, increment = 0) {
    condition = $0deed543ccab4a3d$var$parseCondition(condition || counterName);
    if (!$639fe8cc1eae7e21$export$a4f4bb6b1453fff5(ledger, counterName)) {
        const counter = {
            condition: condition,
            count: 0,
            name: counterName,
            node: node,
            promise: Promise.resolve(),
            resolve: ()=>{}
        };
        ledger[counterName] = counter;
        increment = node.store.reduce((sum, m)=>sum + counter.condition(m) * 1, increment);
        node.each((child)=>{
            child.ledger.count(counter.name, counter.condition);
            increment += child.ledger.value(counter.name);
        });
    }
    return $0deed543ccab4a3d$var$count(ledger[counterName], increment).promise;
}
function $0deed543ccab4a3d$var$parseCondition(condition) {
    if (typeof condition === "function") return condition;
    return (m)=>m.type === condition;
}
function $0deed543ccab4a3d$var$count(counter, increment) {
    const initial = counter.count;
    const post = counter.count + increment;
    counter.count = post;
    if (initial === 0 && post !== 0) {
        counter.node.emit(`unsettled:${counter.name}`, counter.count, false);
        counter.promise = new Promise((r)=>counter.resolve = r);
    } else if (initial !== 0 && post === 0) {
        counter.node.emit(`settled:${counter.name}`, counter.count, false);
        counter.resolve();
    }
    counter.node.emit(`count:${counter.name}`, counter.count, false);
    return counter;
}
function $0deed543ccab4a3d$var$add(ledger, delta) {
    return (e)=>{
        for(const name in ledger){
            const counter = ledger[name];
            if (counter.condition(e.payload)) $0deed543ccab4a3d$var$count(counter, delta);
        }
    };
}
function $0deed543ccab4a3d$var$merge(parent, ledger, child, remove = false) {
    const originalParent = parent;
    for(const key in ledger){
        const condition = ledger[key].condition;
        if (!remove) child.ledger.count(key, condition);
        const increment = child.ledger.value(key) * (remove ? -1 : 1);
        if (!parent) continue;
        do {
            parent.ledger.count(key, condition, increment);
            parent = parent.parent;
        }while (parent);
        parent = originalParent;
    }
}
// packages/core/src/registry.ts
var $0deed543ccab4a3d$var$registry = /* @__PURE__ */ new Map();
var $0deed543ccab4a3d$var$reflected = /* @__PURE__ */ new Map();
var $0deed543ccab4a3d$var$emit2 = $0deed543ccab4a3d$var$createEmitter();
var $0deed543ccab4a3d$var$receipts = [];
function $0deed543ccab4a3d$var$register(node) {
    if (node.props.id) {
        $0deed543ccab4a3d$var$registry.set(node.props.id, node);
        $0deed543ccab4a3d$var$reflected.set(node, node.props.id);
        $0deed543ccab4a3d$var$emit2(node, {
            payload: node,
            name: node.props.id,
            bubble: false,
            origin: node
        });
    }
}
function $0deed543ccab4a3d$var$deregister(node) {
    if ($0deed543ccab4a3d$var$reflected.has(node)) {
        const id = $0deed543ccab4a3d$var$reflected.get(node);
        $0deed543ccab4a3d$var$reflected.delete(node);
        $0deed543ccab4a3d$var$registry.delete(id);
        $0deed543ccab4a3d$var$emit2(node, {
            payload: null,
            name: id,
            bubble: false,
            origin: node
        });
    }
}
function $0deed543ccab4a3d$var$getNode(id) {
    return $0deed543ccab4a3d$var$registry.get(id);
}
function $0deed543ccab4a3d$var$resetRegistry() {
    $0deed543ccab4a3d$var$registry.forEach((node)=>{
        $0deed543ccab4a3d$var$deregister(node);
    });
    $0deed543ccab4a3d$var$receipts.forEach((receipt)=>$0deed543ccab4a3d$var$emit2.off(receipt));
}
function $0deed543ccab4a3d$var$watchRegistry(id, callback) {
    const receipt = $0deed543ccab4a3d$var$emit2.on(id, callback);
    $0deed543ccab4a3d$var$receipts.push(receipt);
    return receipt;
}
function $0deed543ccab4a3d$var$stopWatch(receipt) {
    $0deed543ccab4a3d$var$emit2.off(receipt);
}
// packages/core/src/config.ts
function $0deed543ccab4a3d$var$configChange(node, prop, value) {
    let usingFallback = true;
    !(prop in node.config._t) ? node.emit(`config:${prop}`, value, false) : usingFallback = false;
    if (!(prop in node.props)) {
        node.emit("prop", {
            prop: prop,
            value: value
        });
        node.emit(`prop:${prop}`, value);
    }
    return usingFallback;
}
function $0deed543ccab4a3d$var$createConfig(options = {}) {
    const nodes = /* @__PURE__ */ new Set();
    const target = {
        ...options,
        _add: (node)=>nodes.add(node),
        _rm: (node)=>nodes.delete(node)
    };
    const rootConfig = new Proxy(target, {
        set (t, prop, value, r) {
            if (typeof prop === "string") nodes.forEach((node)=>$0deed543ccab4a3d$var$configChange(node, prop, value));
            return Reflect.set(t, prop, value, r);
        }
    });
    return rootConfig;
}
// packages/core/src/submitForm.ts
function $0deed543ccab4a3d$var$submitForm(id, root) {
    const formElement = (root || document).getElementById(id);
    if (formElement instanceof HTMLFormElement) {
        const event = new Event("submit", {
            cancelable: true,
            bubbles: true
        });
        formElement.dispatchEvent(event);
        return;
    }
    $0deed543ccab4a3d$var$warn(151, id);
}
function $0deed543ccab4a3d$var$clearState(node) {
    const clear = (n)=>{
        for(const key in n.store){
            const message = n.store[key];
            if (message.type === "error" || message.type === "ui" && key === "incomplete") n.store.remove(key);
            else if (message.type === "state") n.store.set({
                ...message,
                value: false
            });
        }
    };
    clear(node);
    node.walk(clear);
}
function $0deed543ccab4a3d$var$reset(id, resetTo) {
    const node = typeof id === "string" ? $0deed543ccab4a3d$var$getNode(id) : id;
    if (node) {
        const initial = (n)=>{
            const initial2 = $639fe8cc1eae7e21$export$359e5dfb2bfaf73a(n.props.initial);
            if (initial2 !== void 0) return initial2;
            return n.type === "group" ? {} : n.type === "list" ? [] : void 0;
        };
        node._e.pause(node);
        const resetValue2 = $639fe8cc1eae7e21$export$359e5dfb2bfaf73a(resetTo);
        if (resetTo && !$639fe8cc1eae7e21$export$6e22c362a0406a2c(resetTo)) {
            node.props.initial = $639fe8cc1eae7e21$export$a6cdc56e425d0d0a(resetValue2) ? $639fe8cc1eae7e21$export$2cd8252107eb640b(resetValue2) : resetValue2;
            node.props._init = node.props.initial;
        }
        node.input(initial(node), false);
        node.walk((child)=>{
            if (child.type === "list" && child.sync) return;
            child.input(initial(child), false);
        });
        node.input($639fe8cc1eae7e21$export$6e22c362a0406a2c(resetValue2) && resetValue2 ? resetValue2 : initial(node), false);
        const isDeepReset = node.type !== "input" && resetTo && !$639fe8cc1eae7e21$export$6e22c362a0406a2c(resetTo) && $639fe8cc1eae7e21$export$a6cdc56e425d0d0a(resetTo);
        if (isDeepReset) node.walk((child)=>{
            child.props.initial = $639fe8cc1eae7e21$export$a6cdc56e425d0d0a(child.value) ? $639fe8cc1eae7e21$export$2cd8252107eb640b(child.value) : child.value;
            child.props._init = child.props.initial;
        });
        node._e.play(node);
        $0deed543ccab4a3d$var$clearState(node);
        node.emit("reset", node);
        return node;
    }
    $0deed543ccab4a3d$var$warn(152, id);
    return;
}
// packages/core/src/node.ts
var $0deed543ccab4a3d$var$defaultConfig = {
    delimiter: ".",
    delay: 0,
    locale: "en",
    rootClasses: (key)=>({
            [`formkit-${$639fe8cc1eae7e21$export$28a4dff995472450(key)}`]: true
        })
};
var $0deed543ccab4a3d$var$useIndex = Symbol("index");
var $0deed543ccab4a3d$var$valueRemoved = Symbol("removed");
var $0deed543ccab4a3d$var$valueMoved = Symbol("moved");
var $0deed543ccab4a3d$var$valueInserted = Symbol("inserted");
function $0deed543ccab4a3d$var$isList(arg) {
    return arg.type === "list" && Array.isArray(arg._value);
}
function $0deed543ccab4a3d$var$isNode(node) {
    return node && typeof node === "object" && node.__FKNode__ === true;
}
var $0deed543ccab4a3d$var$invalidSetter = (node, _context, property)=>{
    $0deed543ccab4a3d$var$error(102, [
        node,
        property
    ]);
};
var $0deed543ccab4a3d$var$traps = {
    _c: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$getContext, $0deed543ccab4a3d$var$invalidSetter, false),
    add: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$addChild),
    addProps: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$addProps),
    address: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$getAddress, $0deed543ccab4a3d$var$invalidSetter, false),
    at: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$getNode2),
    bubble: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$bubble),
    clearErrors: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$clearErrors),
    calm: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$calm),
    config: $0deed543ccab4a3d$var$trap(false),
    define: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$define),
    disturb: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$disturb),
    destroy: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$destroy),
    extend: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$extend),
    hydrate: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$hydrate),
    index: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$getIndex, $0deed543ccab4a3d$var$setIndex, false),
    input: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$input),
    each: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$eachChild),
    emit: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$emit),
    find: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$find),
    on: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$on),
    off: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$off),
    parent: $0deed543ccab4a3d$var$trap(false, $0deed543ccab4a3d$var$setParent),
    plugins: $0deed543ccab4a3d$var$trap(false),
    remove: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$removeChild),
    root: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$getRoot, $0deed543ccab4a3d$var$invalidSetter, false),
    reset: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$resetValue),
    resetConfig: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$resetConfig),
    setErrors: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$setErrors),
    submit: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$submit),
    t: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$text),
    use: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$use),
    name: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$getName, false, false),
    walk: $0deed543ccab4a3d$var$trap($0deed543ccab4a3d$var$walkTree)
};
function $0deed543ccab4a3d$var$createTraps() {
    return new Map(Object.entries($0deed543ccab4a3d$var$traps));
}
function $0deed543ccab4a3d$var$trap(getter, setter, curryGetter = true) {
    return {
        get: getter ? (node, context)=>curryGetter ? (...args)=>getter(node, context, ...args) : getter(node, context) : false,
        set: setter !== void 0 ? setter : $0deed543ccab4a3d$var$invalidSetter.bind(null)
    };
}
function $0deed543ccab4a3d$var$createHooks() {
    const hooks = /* @__PURE__ */ new Map();
    return new Proxy(hooks, {
        get (_, property) {
            if (!hooks.has(property)) hooks.set(property, $0deed543ccab4a3d$var$createDispatcher());
            return hooks.get(property);
        }
    });
}
var $0deed543ccab4a3d$var$nameCount = 0;
var $0deed543ccab4a3d$var$idCount = 0;
function $0deed543ccab4a3d$var$resetCount() {
    $0deed543ccab4a3d$var$nameCount = 0;
    $0deed543ccab4a3d$var$idCount = 0;
}
function $0deed543ccab4a3d$var$names(children) {
    return children.reduce((named, child)=>Object.assign(named, {
            [child.name]: child
        }), {});
}
function $0deed543ccab4a3d$var$createName(options) {
    if (options.parent?.type === "list") return $0deed543ccab4a3d$var$useIndex;
    return options.name || `${options.props?.type || "input"}_${++$0deed543ccab4a3d$var$nameCount}`;
}
function $0deed543ccab4a3d$var$createValue(options) {
    if (options.type === "group") return $639fe8cc1eae7e21$export$2cd8252107eb640b(options.value && typeof options.value === "object" && !Array.isArray(options.value) ? options.value : {});
    else if (options.type === "list") return $639fe8cc1eae7e21$export$2cd8252107eb640b(Array.isArray(options.value) ? options.value : []);
    return options.value;
}
function $0deed543ccab4a3d$var$input(node, context, value, async = true) {
    context._value = $0deed543ccab4a3d$var$validateInput(node, node.hook.input.dispatch(value));
    node.emit("input", context._value);
    if (node.isCreated && node.type === "input" && $639fe8cc1eae7e21$export$9663ddc1cf085b32(context._value, context.value) && !node.props.mergeStrategy) {
        node.emit("commitRaw", context.value);
        return context.settled;
    }
    if (context.isSettled) node.disturb();
    if (async) {
        if (context._tmo) clearTimeout(context._tmo);
        context._tmo = setTimeout($0deed543ccab4a3d$var$commit, node.props.delay, node, context);
    } else $0deed543ccab4a3d$var$commit(node, context);
    return context.settled;
}
function $0deed543ccab4a3d$var$validateInput(node, value) {
    switch(node.type){
        case "input":
            break;
        case "group":
            if (!value || typeof value !== "object") $0deed543ccab4a3d$var$error(107, [
                node,
                value
            ]);
            break;
        case "list":
            if (!Array.isArray(value)) $0deed543ccab4a3d$var$error(108, [
                node,
                value
            ]);
            break;
    }
    return value;
}
function $0deed543ccab4a3d$var$commit(node, context, calm2 = true, hydrate2 = true) {
    context._value = context.value = node.hook.commit.dispatch(context._value);
    if (node.type !== "input" && hydrate2) node.hydrate();
    node.emit("commitRaw", context.value);
    node.emit("commit", context.value);
    if (calm2) node.calm();
}
function $0deed543ccab4a3d$var$partial(context, { name: name, value: value, from: from }) {
    if (Object.isFrozen(context._value)) return;
    if ($0deed543ccab4a3d$var$isList(context)) {
        const insert = value === $0deed543ccab4a3d$var$valueRemoved ? [] : value === $0deed543ccab4a3d$var$valueMoved && typeof from === "number" ? context._value.splice(from, 1) : [
            value
        ];
        context._value.splice(name, value === $0deed543ccab4a3d$var$valueMoved || from === $0deed543ccab4a3d$var$valueInserted ? 0 : 1, ...insert);
        return;
    }
    if (value !== $0deed543ccab4a3d$var$valueRemoved) context._value[name] = value;
    else delete context._value[name];
}
function $0deed543ccab4a3d$var$hydrate(node, context) {
    const _value = context._value;
    if (node.type === "list" && node.sync) $0deed543ccab4a3d$var$syncListNodes(node, context);
    context.children.forEach((child)=>{
        if (typeof _value !== "object") return;
        if (child.name in _value) {
            const childValue = child.type !== "input" || _value[child.name] && typeof _value[child.name] === "object" ? $639fe8cc1eae7e21$export$2cd8252107eb640b(_value[child.name]) : _value[child.name];
            if (!child.isSettled || (!$639fe8cc1eae7e21$export$a6cdc56e425d0d0a(childValue) || child.props.mergeStrategy) && $639fe8cc1eae7e21$export$9663ddc1cf085b32(childValue, child._value)) return;
            child.input(childValue, false);
        } else {
            if (node.type !== "list" || typeof child.name === "number") $0deed543ccab4a3d$var$partial(context, {
                name: child.name,
                value: child.value
            });
            if (!_value.__init) {
                if (child.type === "group") child.input({}, false);
                else if (child.type === "list") child.input([], false);
                else child.input(void 0, false);
            }
        }
    });
    return node;
}
function $0deed543ccab4a3d$var$syncListNodes(node, context) {
    const _value = node._value;
    if (!Array.isArray(_value)) return;
    const newChildren = [];
    const unused = new Set(context.children);
    const placeholderValues = /* @__PURE__ */ new Map();
    _value.forEach((value, i)=>{
        if (context.children[i] && context.children[i]._value === value) {
            newChildren.push(context.children[i]);
            unused.delete(context.children[i]);
        } else {
            newChildren.push(null);
            const indexes = placeholderValues.get(value) || [];
            indexes.push(i);
            placeholderValues.set(value, indexes);
        }
    });
    if (unused.size && placeholderValues.size) unused.forEach((child)=>{
        if (placeholderValues.has(child._value)) {
            const indexes = placeholderValues.get(child._value);
            const index = indexes.shift();
            newChildren[index] = child;
            unused.delete(child);
            if (!indexes.length) placeholderValues.delete(child._value);
        }
    });
    const emptyIndexes = [];
    placeholderValues.forEach((indexes)=>{
        emptyIndexes.push(...indexes);
    });
    while(unused.size && emptyIndexes.length){
        const child = unused.values().next().value;
        const index = emptyIndexes.shift();
        if (index === void 0) break;
        newChildren[index] = child;
        unused.delete(child);
    }
    emptyIndexes.forEach((index, value)=>{
        newChildren[index] = $0deed543ccab4a3d$var$createPlaceholder({
            value: value
        });
    });
    if (unused.size) unused.forEach((child)=>{
        if (!("__FKP" in child)) {
            const parent = child._c.parent;
            if (!parent || $0deed543ccab4a3d$var$isPlaceholder(parent)) return;
            parent.ledger.unmerge(child);
            child._c.parent = null;
            child.destroy();
        }
    });
    context.children = newChildren;
}
function $0deed543ccab4a3d$var$disturb(node, context) {
    if (context._d <= 0) {
        context.isSettled = false;
        node.emit("settled", false, false);
        context.settled = new Promise((resolve)=>{
            context._resolve = resolve;
        });
        if (node.parent) node.parent?.disturb();
    }
    context._d++;
    return node;
}
function $0deed543ccab4a3d$var$calm(node, context, value) {
    if (value !== void 0 && node.type !== "input") {
        $0deed543ccab4a3d$var$partial(context, value);
        const shouldHydrate = !!(node.config.mergeStrategy && node.config.mergeStrategy[value.name]);
        return $0deed543ccab4a3d$var$commit(node, context, true, shouldHydrate);
    }
    if (context._d > 0) context._d--;
    if (context._d === 0) {
        context.isSettled = true;
        node.emit("settled", true, false);
        if (node.parent) node.parent?.calm({
            name: node.name,
            value: context.value
        });
        if (context._resolve) context._resolve(context.value);
    }
}
function $0deed543ccab4a3d$var$destroy(node, context) {
    node.emit("destroying", node);
    node.store.filter(()=>false);
    if (node.parent) node.parent.remove(node);
    $0deed543ccab4a3d$var$deregister(node);
    node.emit("destroyed", node);
    context._e.flush();
    context._value = context.value = void 0;
    for(const property in context.context)delete context.context[property];
    context.plugins.clear();
    context.context = null;
}
function $0deed543ccab4a3d$var$define(node, context, definition) {
    context.type = definition.type;
    const clonedDef = $639fe8cc1eae7e21$export$9cd59f9826255e47(definition);
    node.props.__propDefs = $0deed543ccab4a3d$var$mergeProps(node.props.__propDefs ?? [], clonedDef?.props || []);
    clonedDef.props = node.props.__propDefs;
    context.props.definition = clonedDef;
    context.value = context._value = $0deed543ccab4a3d$var$createValue({
        type: node.type,
        value: context.value
    });
    if (definition.forceTypeProp) {
        if (node.props.type) node.props.originalType = node.props.type;
        context.props.type = definition.forceTypeProp;
    }
    if (definition.family) context.props.family = definition.family;
    if (definition.features) definition.features.forEach((feature)=>feature(node));
    if (definition.props) node.addProps(definition.props);
    node.emit("defined", definition);
}
function $0deed543ccab4a3d$var$addProps(node, context, props) {
    const propNames = Array.isArray(props) ? props : Object.keys(props);
    const defaults = !Array.isArray(props) ? propNames.reduce((defaults2, name)=>{
        if ("default" in props[name]) defaults2[name] = props[name].default;
        return defaults2;
    }, {}) : {};
    if (node.props.attrs) {
        const attrs = {
            ...node.props.attrs
        };
        node.props._emit = false;
        for(const attr in attrs){
            const camelName = $639fe8cc1eae7e21$export$ddab50941423df32(attr);
            if (propNames.includes(camelName)) {
                node.props[camelName] = attrs[attr];
                delete attrs[attr];
            }
        }
        if (!Array.isArray(props)) propNames.forEach((prop)=>{
            if ("default" in props[prop] && node.props[prop] === void 0) node.props[prop] = defaults[prop];
        });
        const initial = $639fe8cc1eae7e21$export$359e5dfb2bfaf73a(context._value);
        node.props.initial = node.type !== "input" ? $639fe8cc1eae7e21$export$2cd8252107eb640b(initial) : initial;
        node.props._emit = true;
        node.props.attrs = attrs;
    }
    const mergedProps = $0deed543ccab4a3d$var$mergeProps(node.props.__propDefs ?? [], props);
    if (node.props.definition) node.props.definition.props = mergedProps;
    node.props.__propDefs = mergedProps;
    node.emit("added-props", props);
    return node;
}
function $0deed543ccab4a3d$var$toPropsObj(props) {
    return !Array.isArray(props) ? props : props.reduce((props2, prop)=>{
        props2[prop] = {};
        return props2;
    }, {});
}
function $0deed543ccab4a3d$var$mergeProps(props, newProps) {
    if (Array.isArray(props) && Array.isArray(newProps)) return props.concat(newProps);
    return $639fe8cc1eae7e21$export$8b58be045bf06082($0deed543ccab4a3d$var$toPropsObj(props), $0deed543ccab4a3d$var$toPropsObj(newProps));
}
function $0deed543ccab4a3d$var$addChild(parent, parentContext, child, listIndex) {
    if (parent.type === "input") $0deed543ccab4a3d$var$error(100, parent);
    if (child.parent && child.parent !== parent) child.parent.remove(child);
    if (!parentContext.children.includes(child)) {
        if (listIndex !== void 0 && parent.type === "list") {
            const existingNode = parentContext.children[listIndex];
            if (existingNode && "__FKP" in existingNode) {
                child._c.uid = existingNode.uid;
                parentContext.children.splice(listIndex, 1, child);
            } else parentContext.children.splice(listIndex, 0, child);
            if (Array.isArray(parent.value) && parent.value.length < parentContext.children.length) parent.disturb().calm({
                name: listIndex,
                value: child.value,
                from: $0deed543ccab4a3d$var$valueInserted
            });
        } else parentContext.children.push(child);
        if (!child.isSettled) parent.disturb();
    }
    if (child.parent !== parent) {
        child.parent = parent;
        if (child.parent !== parent) {
            parent.remove(child);
            child.parent.add(child);
            return parent;
        }
    } else child.use(parent.plugins);
    $0deed543ccab4a3d$var$commit(parent, parentContext, false);
    parent.ledger.merge(child);
    parent.emit("child", child);
    return parent;
}
function $0deed543ccab4a3d$var$setParent(child, context, _property, parent) {
    if ($0deed543ccab4a3d$var$isNode(parent)) {
        if (child.parent && child.parent !== parent) child.parent.remove(child);
        context.parent = parent;
        child.resetConfig();
        !parent.children.includes(child) ? parent.add(child) : child.use(parent.plugins);
        return true;
    }
    if (parent === null) {
        context.parent = null;
        return true;
    }
    return false;
}
function $0deed543ccab4a3d$var$removeChild(node, context, child) {
    const childIndex = context.children.indexOf(child);
    if (childIndex !== -1) {
        if (child.isSettled) node.disturb();
        context.children.splice(childIndex, 1);
        let preserve = $639fe8cc1eae7e21$export$96e6ef1411d879b1(child.props.preserve);
        let parent = child.parent;
        while(preserve === void 0 && parent){
            preserve = $639fe8cc1eae7e21$export$96e6ef1411d879b1(parent.props.preserve);
            parent = parent.parent;
        }
        if (!preserve) node.calm({
            name: node.type === "list" ? childIndex : child.name,
            value: $0deed543ccab4a3d$var$valueRemoved
        });
        else node.calm();
        child.parent = null;
        child.config._rmn = child;
    }
    node.ledger.unmerge(child);
    node.emit("childRemoved", child);
    return node;
}
function $0deed543ccab4a3d$var$eachChild(_node, context, callback) {
    context.children.forEach((child)=>!("__FKP" in child) && callback(child));
}
function $0deed543ccab4a3d$var$walkTree(_node, context, callback, stopIfFalse = false, skipSubtreeOnFalse = false) {
    context.children.some((child)=>{
        if ("__FKP" in child) return false;
        const val = callback(child);
        if (stopIfFalse && val === false) return true;
        if (skipSubtreeOnFalse && val === false) return false;
        return child.walk(callback, stopIfFalse, skipSubtreeOnFalse);
    });
}
function $0deed543ccab4a3d$var$resetConfig(node, context) {
    const parent = node.parent || void 0;
    context.config = $0deed543ccab4a3d$var$createConfig2(node.config._t, parent);
    node.walk((n)=>n.resetConfig());
}
function $0deed543ccab4a3d$var$use(node, context, plugin, run = true, library = true) {
    if (Array.isArray(plugin) || plugin instanceof Set) {
        plugin.forEach((p)=>$0deed543ccab4a3d$var$use(node, context, p));
        return node;
    }
    if (!context.plugins.has(plugin)) {
        if (library && typeof plugin.library === "function") plugin.library(node);
        if (run && plugin(node) !== false) {
            context.plugins.add(plugin);
            node.children.forEach((child)=>child.use(plugin));
        }
    }
    return node;
}
function $0deed543ccab4a3d$var$setIndex(node, _context, _property, setIndex2) {
    if ($0deed543ccab4a3d$var$isNode(node.parent)) {
        const children = node.parent.children;
        const index = setIndex2 >= children.length ? children.length - 1 : setIndex2 < 0 ? 0 : setIndex2;
        const oldIndex = children.indexOf(node);
        if (oldIndex === -1) return false;
        children.splice(oldIndex, 1);
        children.splice(index, 0, node);
        node.parent.children = children;
        if (node.parent.type === "list") node.parent.disturb().calm({
            name: index,
            value: $0deed543ccab4a3d$var$valueMoved,
            from: oldIndex
        });
        return true;
    }
    return false;
}
function $0deed543ccab4a3d$var$getIndex(node) {
    if (node.parent) {
        const index = [
            ...node.parent.children
        ].indexOf(node);
        return index === -1 ? node.parent.children.length : index;
    }
    return -1;
}
function $0deed543ccab4a3d$var$getContext(_node, context) {
    return context;
}
function $0deed543ccab4a3d$var$getName(node, context) {
    if (node.parent?.type === "list") return node.index;
    return context.name !== $0deed543ccab4a3d$var$useIndex ? context.name : node.index;
}
function $0deed543ccab4a3d$var$getAddress(node, context) {
    return context.parent ? context.parent.address.concat([
        node.name
    ]) : [
        node.name
    ];
}
function $0deed543ccab4a3d$var$getNode2(node, _context, locator) {
    const address = typeof locator === "string" ? locator.split(node.config.delimiter) : locator;
    if (!address.length) return void 0;
    const first = address[0];
    let pointer = node.parent;
    if (!pointer) {
        if (String(address[0]) === String(node.name)) address.shift();
        pointer = node;
    }
    if (first === "$parent") address.shift();
    while(pointer && address.length){
        const name = address.shift();
        switch(name){
            case "$root":
                pointer = node.root;
                break;
            case "$parent":
                pointer = pointer.parent;
                break;
            case "$self":
                pointer = node;
                break;
            default:
                pointer = pointer.children.find((c)=>!("__FKP" in c) && String(c.name) === String(name)) || $0deed543ccab4a3d$var$select(pointer, name);
        }
    }
    return pointer || void 0;
}
function $0deed543ccab4a3d$var$select(node, selector) {
    const matches = String(selector).match(/^(find)\((.*)\)$/);
    if (matches) {
        const [, action, argStr] = matches;
        const args = argStr.split(",").map((arg)=>arg.trim());
        switch(action){
            case "find":
                return node.find(args[0], args[1]);
            default:
                return void 0;
        }
    }
    return void 0;
}
function $0deed543ccab4a3d$var$find(node, _context, searchTerm, searcher) {
    return $0deed543ccab4a3d$var$bfs(node, searchTerm, searcher);
}
function $0deed543ccab4a3d$var$bfs(tree, searchValue, searchGoal = "name") {
    const search = typeof searchGoal === "string" ? (n)=>n[searchGoal] == searchValue : searchGoal;
    const stack = [
        tree
    ];
    while(stack.length){
        const node = stack.shift();
        if ("__FKP" in node) continue;
        if (search(node, searchValue)) return node;
        stack.push(...node.children);
    }
    return void 0;
}
function $0deed543ccab4a3d$var$getRoot(n) {
    let node = n;
    while(node.parent)node = node.parent;
    return node;
}
function $0deed543ccab4a3d$var$createConfig2(target = {}, parent) {
    let node = void 0;
    return new Proxy(target, {
        get (...args) {
            const prop = args[1];
            if (prop === "_t") return target;
            const localValue = Reflect.get(...args);
            if (localValue !== void 0) return localValue;
            if (parent) {
                const parentVal = parent.config[prop];
                if (parentVal !== void 0) return parentVal;
            }
            if (target.rootConfig && typeof prop === "string") {
                const rootValue = target.rootConfig[prop];
                if (rootValue !== void 0) return rootValue;
            }
            if (prop === "delay" && node?.type === "input") return 20;
            return $0deed543ccab4a3d$var$defaultConfig[prop];
        },
        set (...args) {
            const prop = args[1];
            const value = args[2];
            if (prop === "_n") {
                node = value;
                if (target.rootConfig) target.rootConfig._add(node);
                return true;
            }
            if (prop === "_rmn") {
                if (target.rootConfig) target.rootConfig._rm(node);
                node = void 0;
                return true;
            }
            if (!$639fe8cc1eae7e21$export$9663ddc1cf085b32(target[prop], value, false)) {
                const didSet = Reflect.set(...args);
                if (node) {
                    node.emit(`config:${prop}`, value, false);
                    $0deed543ccab4a3d$var$configChange(node, prop, value);
                    node.walk((n)=>$0deed543ccab4a3d$var$configChange(n, prop, value), false, true);
                }
                return didSet;
            }
            return true;
        }
    });
}
function $0deed543ccab4a3d$var$text(node, _context, key, type = "ui") {
    const fragment = typeof key === "string" ? {
        key: key,
        value: key,
        type: type
    } : key;
    const value = node.hook.text.dispatch(fragment);
    node.emit("text", value, false);
    return value.value;
}
function $0deed543ccab4a3d$var$submit(node) {
    const name = node.name;
    do {
        if (node.props.isForm === true) break;
        if (!node.parent) $0deed543ccab4a3d$var$error(106, name);
        node = node.parent;
    }while (node);
    if (node.props.id) $0deed543ccab4a3d$var$submitForm(node.props.id, node.props.__root);
}
function $0deed543ccab4a3d$var$resetValue(node, _context, value) {
    return $0deed543ccab4a3d$var$reset(node, value);
}
function $0deed543ccab4a3d$var$setErrors(node, _context, localErrors, childErrors) {
    const sourceKey = `${node.name}-set`;
    const errors = node.hook.setErrors.dispatch({
        localErrors: localErrors,
        childErrors: childErrors
    });
    $0deed543ccab4a3d$var$createMessages(node, errors.localErrors, errors.childErrors).forEach((errors2)=>{
        node.store.apply(errors2, (message)=>message.meta.source === sourceKey);
    });
    return node;
}
function $0deed543ccab4a3d$var$clearErrors(node, _context, clearChildErrors = true, sourceKey) {
    node.store.filter((m)=>{
        return !(sourceKey === void 0 || m.meta.source === sourceKey);
    }, "error");
    if (clearChildErrors) {
        sourceKey = sourceKey || `${node.name}-set`;
        node.walk((child)=>{
            child.store.filter((message)=>{
                return !(message.type === "error" && message.meta && message.meta.source === sourceKey);
            });
        });
    }
    return node;
}
function $0deed543ccab4a3d$var$createProps(initial) {
    const props = {
        initial: typeof initial === "object" ? $639fe8cc1eae7e21$export$359e5dfb2bfaf73a(initial) : initial
    };
    let node;
    let isEmitting = true;
    let propDefs = {};
    return new Proxy(props, {
        get (...args) {
            const [_t, prop] = args;
            let val;
            if ($639fe8cc1eae7e21$export$a4f4bb6b1453fff5(props, prop)) {
                val = Reflect.get(...args);
                if (propDefs[prop]?.boolean) val = $639fe8cc1eae7e21$export$da3eca551f501a9a(val);
            } else if (node && typeof prop === "string" && node.config[prop] !== void 0) {
                val = node.config[prop];
                if (prop === "mergeStrategy" && node?.type === "input" && $639fe8cc1eae7e21$export$6ba840931da50680(val) && node.name in val) val = val[node.name];
            } else val = propDefs[prop]?.default;
            const getter = propDefs[prop]?.getter;
            if (propDefs[prop]?.boolean) val = !!val;
            return getter ? getter(val, node) : val;
        },
        set (target, property, originalValue, receiver) {
            if (property === "_n") {
                node = originalValue;
                return true;
            }
            if (property === "_emit") {
                isEmitting = originalValue;
                return true;
            }
            let { prop: prop, value: value } = node.hook.prop.dispatch({
                prop: property,
                value: originalValue
            });
            const setter = propDefs[prop]?.setter;
            value = setter ? setter(value, node) : value;
            if (!$639fe8cc1eae7e21$export$9663ddc1cf085b32(props[prop], value, false) || typeof value === "object") {
                const didSet = Reflect.set(target, prop, value, receiver);
                if (prop === "__propDefs") propDefs = $0deed543ccab4a3d$var$toPropsObj(value);
                if (isEmitting) {
                    node.emit("prop", {
                        prop: prop,
                        value: value
                    });
                    if (typeof prop === "string") node.emit(`prop:${prop}`, value);
                }
                return didSet;
            }
            return true;
        }
    });
}
function $0deed543ccab4a3d$var$extend(node, context, property, trap2) {
    context.traps.set(property, trap2);
    return node;
}
function $0deed543ccab4a3d$var$findDefinition(node, plugins) {
    if (node.props.definition) return node.define(node.props.definition);
    for (const plugin of plugins){
        if (node.props.definition) return;
        if (typeof plugin.library === "function") plugin.library(node);
    }
}
function $0deed543ccab4a3d$var$createContext(options) {
    const value = $0deed543ccab4a3d$var$createValue(options);
    const config = $0deed543ccab4a3d$var$createConfig2(options.config || {}, options.parent);
    return {
        _d: 0,
        _e: $0deed543ccab4a3d$var$createEmitter(),
        uid: Symbol(),
        _resolve: false,
        _tmo: false,
        _value: value,
        children: $639fe8cc1eae7e21$export$f3a259b74a77132f(options.children || []),
        config: config,
        hook: $0deed543ccab4a3d$var$createHooks(),
        isCreated: false,
        isSettled: true,
        ledger: $0deed543ccab4a3d$var$createLedger(),
        name: $0deed543ccab4a3d$var$createName(options),
        parent: options.parent || null,
        plugins: /* @__PURE__ */ new Set(),
        props: $0deed543ccab4a3d$var$createProps(value),
        settled: Promise.resolve(value),
        store: $0deed543ccab4a3d$var$createStore(true),
        sync: options.sync || false,
        traps: $0deed543ccab4a3d$var$createTraps(),
        type: options.type || "input",
        value: value
    };
}
function $0deed543ccab4a3d$var$nodeInit(node, options) {
    const hasInitialId = options.props?.id;
    if (!hasInitialId) delete options.props?.id;
    node.ledger.init(node.store._n = node.props._n = node.config._n = node);
    node.props._emit = false;
    Object.assign(node.props, hasInitialId ? {} : {
        id: `input_${$0deed543ccab4a3d$var$idCount++}`
    }, options.props ?? {});
    node.props._emit = true;
    $0deed543ccab4a3d$var$findDefinition(node, /* @__PURE__ */ new Set([
        ...options.plugins || [],
        ...node.parent ? node.parent.plugins : []
    ]));
    if (options.plugins) for (const plugin of options.plugins)$0deed543ccab4a3d$var$use(node, node._c, plugin, true, false);
    node.each((child)=>node.add(child));
    if (node.parent) node.parent.add(node, options.index);
    if (node.type === "input" && node.children.length) $0deed543ccab4a3d$var$error(100, node);
    $0deed543ccab4a3d$var$input(node, node._c, node._value, false);
    node.store.release();
    if (hasInitialId) $0deed543ccab4a3d$var$register(node);
    node.emit("created", node);
    node.isCreated = true;
    return node;
}
function $0deed543ccab4a3d$var$createPlaceholder(options) {
    return {
        __FKP: true,
        uid: Symbol(),
        name: options?.name ?? `p_${$0deed543ccab4a3d$var$nameCount++}`,
        value: options?.value ?? null,
        _value: options?.value ?? null,
        type: options?.type ?? "input",
        props: {},
        use: ()=>{},
        input (value) {
            this._value = value;
            this.value = value;
            return Promise.resolve();
        },
        isSettled: true
    };
}
function $0deed543ccab4a3d$var$isPlaceholder(node) {
    return "__FKP" in node;
}
function $0deed543ccab4a3d$var$createNode(options) {
    const ops = options || {};
    const context = $0deed543ccab4a3d$var$createContext(ops);
    const node = new Proxy(context, {
        get (...args) {
            const [, property] = args;
            if (property === "__FKNode__") return true;
            const trap2 = context.traps.get(property);
            if (trap2 && trap2.get) return trap2.get(node, context);
            return Reflect.get(...args);
        },
        set (...args) {
            const [, property, value] = args;
            const trap2 = context.traps.get(property);
            if (trap2 && trap2.set) return trap2.set(node, context, property, value);
            return Reflect.set(...args);
        }
    });
    return $0deed543ccab4a3d$var$nodeInit(node, ops);
}
function $0deed543ccab4a3d$var$isDOM(node) {
    return typeof node !== "string" && $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(node, "$el");
}
function $0deed543ccab4a3d$var$isComponent(node) {
    return typeof node !== "string" && $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(node, "$cmp");
}
function $0deed543ccab4a3d$var$isConditional(node) {
    if (!node || typeof node === "string") return false;
    return $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(node, "if") && $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(node, "then");
}
function $0deed543ccab4a3d$var$isSugar(node) {
    return typeof node !== "string" && "$formkit" in node;
}
function $0deed543ccab4a3d$var$sugar(node) {
    if (typeof node === "string") return {
        $el: "text",
        children: node
    };
    if ($0deed543ccab4a3d$var$isSugar(node)) {
        const { $formkit: type, for: iterator, if: condition, children: children, bind: bind, ...props } = node;
        return Object.assign({
            $cmp: "FormKit",
            props: {
                ...props,
                type: type
            }
        }, condition ? {
            if: condition
        } : {}, iterator ? {
            for: iterator
        } : {}, children ? {
            children: children
        } : {}, bind ? {
            bind: bind
        } : {});
    }
    return node;
}
function $0deed543ccab4a3d$var$compile(expr) {
    let provideTokens;
    const requirements = /* @__PURE__ */ new Set();
    const x = function expand(operand, tokens) {
        return typeof operand === "function" ? operand(tokens) : operand;
    };
    const operatorRegistry = [
        {
            "&&": (l, r, t)=>x(l, t) && x(r, t),
            "||": (l, r, t)=>x(l, t) || x(r, t)
        },
        {
            "===": (l, r, t)=>!!(x(l, t) === x(r, t)),
            "!==": (l, r, t)=>!!(x(l, t) !== x(r, t)),
            "==": (l, r, t)=>!!(x(l, t) == x(r, t)),
            "!=": (l, r, t)=>!!(x(l, t) != x(r, t)),
            ">=": (l, r, t)=>!!(x(l, t) >= x(r, t)),
            "<=": (l, r, t)=>!!(x(l, t) <= x(r, t)),
            ">": (l, r, t)=>!!(x(l, t) > x(r, t)),
            "<": (l, r, t)=>!!(x(l, t) < x(r, t))
        },
        {
            "+": (l, r, t)=>x(l, t) + x(r, t),
            "-": (l, r, t)=>x(l, t) - x(r, t)
        },
        {
            "*": (l, r, t)=>x(l, t) * x(r, t),
            "/": (l, r, t)=>x(l, t) / x(r, t),
            "%": (l, r, t)=>x(l, t) % x(r, t)
        }
    ];
    const operatorSymbols = operatorRegistry.reduce((s, g)=>{
        return s.concat(Object.keys(g));
    }, []);
    const operatorChars = new Set(operatorSymbols.map((key)=>key.charAt(0)));
    function getOp(symbols, char, p, expression) {
        const candidates = symbols.filter((s)=>s.startsWith(char));
        if (!candidates.length) return false;
        return candidates.find((symbol)=>{
            if (expression.length >= p + symbol.length) {
                const nextChars = expression.substring(p, p + symbol.length);
                if (nextChars === symbol) return symbol;
            }
            return false;
        });
    }
    function getStep(p, expression, direction = 1) {
        let next = direction ? expression.substring(p + 1).trim() : expression.substring(0, p).trim();
        if (!next.length) return -1;
        if (!direction) {
            const reversed = next.split("").reverse();
            const start = reversed.findIndex((char2)=>operatorChars.has(char2));
            next = reversed.slice(start).join("");
        }
        const char = next[0];
        return operatorRegistry.findIndex((operators)=>{
            const symbols = Object.keys(operators);
            return !!getOp(symbols, char, 0, next);
        });
    }
    function getTail(pos, expression) {
        let tail = "";
        const length = expression.length;
        let depth = 0;
        for(let p = pos; p < length; p++){
            const char = expression.charAt(p);
            if (char === "(") depth++;
            else if (char === ")") depth--;
            else if (depth === 0 && char === " ") continue;
            if (depth === 0 && getOp(operatorSymbols, char, p, expression)) return [
                tail,
                p - 1
            ];
            else tail += char;
        }
        return [
            tail,
            expression.length - 1
        ];
    }
    function parseLogicals(expression, step = 0) {
        const operators = operatorRegistry[step];
        const length = expression.length;
        const symbols = Object.keys(operators);
        let depth = 0;
        let quote = false;
        let op = null;
        let operand = "";
        let left = null;
        let operation;
        let lastChar = "";
        let char = "";
        let parenthetical = "";
        let parenQuote = "";
        let startP = 0;
        const addTo = (depth2, char2)=>{
            depth2 ? parenthetical += char2 : operand += char2;
        };
        for(let p = 0; p < length; p++){
            lastChar = char;
            char = expression.charAt(p);
            if ((char === "'" || char === '"') && lastChar !== "\\" && (depth === 0 && !quote || depth && !parenQuote)) {
                if (depth) parenQuote = char;
                else quote = char;
                addTo(depth, char);
                continue;
            } else if (quote && (char !== quote || lastChar === "\\") || parenQuote && (char !== parenQuote || lastChar === "\\")) {
                addTo(depth, char);
                continue;
            } else if (quote === char) {
                quote = false;
                addTo(depth, char);
                continue;
            } else if (parenQuote === char) {
                parenQuote = false;
                addTo(depth, char);
                continue;
            } else if (char === " ") continue;
            else if (char === "(") {
                if (depth === 0) startP = p;
                else parenthetical += char;
                depth++;
            } else if (char === ")") {
                depth--;
                if (depth === 0) {
                    const fn = typeof operand === "string" && operand.startsWith("$") ? operand : void 0;
                    const hasTail = fn && expression.charAt(p + 1) === ".";
                    let tail = "";
                    if (hasTail) [tail, p] = getTail(p + 2, expression);
                    const lStep = op ? step : getStep(startP, expression, 0);
                    const rStep = getStep(p, expression);
                    if (lStep === -1 && rStep === -1) {
                        operand = evaluate(parenthetical, -1, fn, tail);
                        if (typeof operand === "string") operand = parenthetical;
                    } else if (op && (lStep >= rStep || rStep === -1) && step === lStep) {
                        left = op.bind(null, evaluate(parenthetical, -1, fn, tail));
                        op = null;
                        operand = "";
                    } else if (rStep > lStep && step === rStep) operand = evaluate(parenthetical, -1, fn, tail);
                    else operand += `(${parenthetical})${hasTail ? `.${tail}` : ""}`;
                    parenthetical = "";
                } else parenthetical += char;
            } else if (depth === 0 && (operation = getOp(symbols, char, p, expression))) {
                if (p === 0) $0deed543ccab4a3d$var$error(103, [
                    operation,
                    expression
                ]);
                p += operation.length - 1;
                if (p === expression.length - 1) $0deed543ccab4a3d$var$error(104, [
                    operation,
                    expression
                ]);
                if (!op) {
                    if (left) {
                        op = operators[operation].bind(null, evaluate(left, step));
                        left = null;
                    } else {
                        op = operators[operation].bind(null, evaluate(operand, step));
                        operand = "";
                    }
                } else if (operand) {
                    left = op.bind(null, evaluate(operand, step));
                    op = operators[operation].bind(null, left);
                    operand = "";
                }
                continue;
            } else addTo(depth, char);
        }
        if (operand && op) op = op.bind(null, evaluate(operand, step));
        op = !op && left ? left : op;
        if (!op && operand) {
            op = (v, t)=>{
                return typeof v === "function" ? v(t) : v;
            };
            op = op.bind(null, evaluate(operand, step));
        }
        if (!op && !operand) $0deed543ccab4a3d$var$error(105, expression);
        return op;
    }
    function evaluate(operand, step, fnToken, tail) {
        if (fnToken) {
            const fn = evaluate(fnToken, operatorRegistry.length);
            let userFuncReturn;
            let tailCall = tail ? $0deed543ccab4a3d$var$compile(`$${tail}`) : false;
            if (typeof fn === "function") {
                const args = $639fe8cc1eae7e21$export$7300a92932ee17a3(String(operand)).map((arg)=>evaluate(arg, -1));
                return (tokens)=>{
                    const userFunc = fn(tokens);
                    if (typeof userFunc !== "function") {
                        $0deed543ccab4a3d$var$warn(150, fnToken);
                        return userFunc;
                    }
                    userFuncReturn = userFunc(...args.map((arg)=>typeof arg === "function" ? arg(tokens) : arg));
                    if (tailCall) tailCall = tailCall.provide((subTokens)=>{
                        const rootTokens = provideTokens(subTokens);
                        const t = subTokens.reduce((tokenSet, token3)=>{
                            const isTail = token3 === tail || tail?.startsWith(`${token3}(`);
                            if (isTail) {
                                const value = $639fe8cc1eae7e21$export$b2379508bf8b684a(userFuncReturn, token3);
                                tokenSet[token3] = ()=>value;
                            } else tokenSet[token3] = rootTokens[token3];
                            return tokenSet;
                        }, {});
                        return t;
                    });
                    return tailCall ? tailCall() : userFuncReturn;
                };
            }
        } else if (typeof operand === "string") {
            if (operand === "true") return true;
            if (operand === "false") return false;
            if (operand === "undefined") return void 0;
            if ($639fe8cc1eae7e21$export$56a96871fc26791a(operand)) return $639fe8cc1eae7e21$export$f14dae2add6bfcb0(operand.substring(1, operand.length - 1));
            if (!isNaN(+operand)) return Number(operand);
            if (step < operatorRegistry.length - 1) return parseLogicals(operand, step + 1);
            else {
                if (operand.startsWith("$")) {
                    const cleaned = operand.substring(1);
                    requirements.add(cleaned);
                    return function getToken(tokens) {
                        return cleaned in tokens ? tokens[cleaned]() : void 0;
                    };
                }
                return operand;
            }
        }
        return operand;
    }
    const compiled = parseLogicals(expr.startsWith("$:") ? expr.substring(2) : expr);
    const reqs = Array.from(requirements);
    function provide(callback) {
        provideTokens = callback;
        return Object.assign(// @ts-ignore - @rollup/plugin-typescript doesn't like this
        compiled.bind(null, callback(reqs)), {
            provide: provide
        });
    }
    return Object.assign(compiled, {
        provide: provide
    });
}
// packages/core/src/classes.ts
function $0deed543ccab4a3d$var$createClasses(propertyKey, node, sectionClassList) {
    if (!sectionClassList) return {};
    if (typeof sectionClassList === "string") {
        const classKeys = sectionClassList.split(" ");
        return classKeys.reduce((obj, key)=>Object.assign(obj, {
                [key]: true
            }), {});
    } else if (typeof sectionClassList === "function") return $0deed543ccab4a3d$var$createClasses(propertyKey, node, sectionClassList(node, propertyKey));
    return sectionClassList;
}
function $0deed543ccab4a3d$var$generateClassList(node, property, ...args) {
    const combinedClassList = args.reduce((finalClassList, currentClassList)=>{
        if (!currentClassList) return $0deed543ccab4a3d$var$handleNegativeClasses(finalClassList);
        const { $reset: $reset, ...classList } = currentClassList;
        if ($reset) return $0deed543ccab4a3d$var$handleNegativeClasses(classList);
        return $0deed543ccab4a3d$var$handleNegativeClasses(Object.assign(finalClassList, classList));
    }, {});
    return Object.keys(node.hook.classes.dispatch({
        property: property,
        classes: combinedClassList
    }).classes).filter((key)=>combinedClassList[key]).join(" ") || null;
}
function $0deed543ccab4a3d$var$handleNegativeClasses(classList) {
    const removalToken = "$remove:";
    let hasNegativeClassValue = false;
    const applicableClasses = Object.keys(classList).filter((className)=>{
        if (classList[className] && className.startsWith(removalToken)) hasNegativeClassValue = true;
        return classList[className];
    });
    if (applicableClasses.length > 1 && hasNegativeClassValue) {
        const negativeClasses = applicableClasses.filter((className)=>className.startsWith(removalToken));
        negativeClasses.map((negativeClass)=>{
            const targetClass = negativeClass.substring(removalToken.length);
            classList[targetClass] = false;
            classList[negativeClass] = false;
        });
    }
    return classList;
}
// packages/core/src/setErrors.ts
function $0deed543ccab4a3d$var$setErrors2(id, localErrors, childErrors) {
    const node = $0deed543ccab4a3d$var$getNode(id);
    if (node) node.setErrors(localErrors, childErrors);
    else $0deed543ccab4a3d$var$warn(651, id);
}
function $0deed543ccab4a3d$var$clearErrors2(id, clearChildren = true) {
    const node = $0deed543ccab4a3d$var$getNode(id);
    if (node) node.clearErrors(clearChildren);
    else $0deed543ccab4a3d$var$warn(652, id);
}
// packages/core/src/index.ts
var $0deed543ccab4a3d$var$FORMKIT_VERSION = "1.6.9";
$0deed543ccab4a3d$export$a65c7cc2c8845330 = $0deed543ccab4a3d$var$FORMKIT_VERSION;
$0deed543ccab4a3d$export$c9e5a085bf83f8b = $0deed543ccab4a3d$var$bfs;
$0deed543ccab4a3d$export$69c7a77cf657af8f = $0deed543ccab4a3d$var$clearErrors2;
$0deed543ccab4a3d$export$ef7acd7185315e22 = $0deed543ccab4a3d$var$compile;
$0deed543ccab4a3d$export$1f803343cd5d268d = $0deed543ccab4a3d$var$createClasses;
$0deed543ccab4a3d$export$45a69314cf48a3eb = $0deed543ccab4a3d$var$createConfig;
$0deed543ccab4a3d$export$62651879628e0c4c = $0deed543ccab4a3d$var$createMessage;
$0deed543ccab4a3d$export$270e7ba5936d3c48 = $0deed543ccab4a3d$var$createNode;
$0deed543ccab4a3d$export$598ddf5ea05e86ce = $0deed543ccab4a3d$var$createPlaceholder;
$0deed543ccab4a3d$export$7f75b77267f1fa35 = $0deed543ccab4a3d$var$createValue;
$0deed543ccab4a3d$export$b4570ea00533c3e5 = $0deed543ccab4a3d$var$deregister;
$0deed543ccab4a3d$export$a3bc9b8ed74fc = $0deed543ccab4a3d$var$error;
$0deed543ccab4a3d$export$cc3fdd528b56c4a9 = $0deed543ccab4a3d$var$errorHandler;
$0deed543ccab4a3d$export$fe64dbc167601fe7 = $0deed543ccab4a3d$var$generateClassList;
$0deed543ccab4a3d$export$3f778c4e796a1f9c = $0deed543ccab4a3d$var$getNode;
$0deed543ccab4a3d$export$3b2d240469e38cce = $0deed543ccab4a3d$var$isComponent;
$0deed543ccab4a3d$export$33d5b72ec833fd5f = $0deed543ccab4a3d$var$isConditional;
$0deed543ccab4a3d$export$41e30d8dd0ba7a50 = $0deed543ccab4a3d$var$isDOM;
$0deed543ccab4a3d$export$ead95ff48ba53ffd = $0deed543ccab4a3d$var$isList;
$0deed543ccab4a3d$export$8ee0fc9ee280b4ee = $0deed543ccab4a3d$var$isNode;
$0deed543ccab4a3d$export$2047bcc885291b3f = $0deed543ccab4a3d$var$isPlaceholder;
$0deed543ccab4a3d$export$47a97cb489ea6411 = $0deed543ccab4a3d$var$isSugar;
$0deed543ccab4a3d$export$e4b2ac9215619f8d = $0deed543ccab4a3d$var$names;
$0deed543ccab4a3d$export$6503ec6e8aabbaf = $0deed543ccab4a3d$var$register;
$0deed543ccab4a3d$export$aad8462122ac592b = $0deed543ccab4a3d$var$reset;
$0deed543ccab4a3d$export$218404c250ebcb05 = $0deed543ccab4a3d$var$resetCount;
$0deed543ccab4a3d$export$b668408ac8206d2f = $0deed543ccab4a3d$var$resetRegistry;
$0deed543ccab4a3d$export$8b2e7eab72dc3481 = $0deed543ccab4a3d$var$setErrors2;
$0deed543ccab4a3d$export$d38475e6e890fc63 = $0deed543ccab4a3d$var$stopWatch;
$0deed543ccab4a3d$export$e02251cfbe407ee6 = $0deed543ccab4a3d$var$submitForm;
$0deed543ccab4a3d$export$e970e05fc1e8bae = $0deed543ccab4a3d$var$sugar;
$0deed543ccab4a3d$export$1f96ae73734a86cc = $0deed543ccab4a3d$var$use;
$0deed543ccab4a3d$export$bb0968b4d41ab5a0 = $0deed543ccab4a3d$var$useIndex;
$0deed543ccab4a3d$export$2f9e0b9e6f218a71 = $0deed543ccab4a3d$var$valueInserted;
$0deed543ccab4a3d$export$fc96cc4f823ff664 = $0deed543ccab4a3d$var$valueMoved;
$0deed543ccab4a3d$export$b47d29d1be32fa3d = $0deed543ccab4a3d$var$valueRemoved;
$0deed543ccab4a3d$export$c106dd0671a0fc2d = $0deed543ccab4a3d$var$warn;
$0deed543ccab4a3d$export$3d46431aec5d0165 = $0deed543ccab4a3d$var$warningHandler;
$0deed543ccab4a3d$export$e6fd047a0a0a675b = $0deed543ccab4a3d$var$watchRegistry; //# sourceMappingURL=out.js.map
 //# sourceMappingURL=index.cjs.map



var $e098f7e2ce93da90$export$26dcee9266ec3174;
var $e098f7e2ce93da90$export$9e6a5ff84f57576;
var $e098f7e2ce93da90$export$8cff67e4740afa09;
var $e098f7e2ce93da90$export$3b2cc45ba5082e2;
var $e098f7e2ce93da90$export$5073839cf61ff85c;
'use strict';


// packages/observer/src/index.ts
var $e098f7e2ce93da90$var$revokedObservers = /* @__PURE__ */ new WeakSet();
function $e098f7e2ce93da90$var$createObserver(node, dependencies) {
    const deps = dependencies || Object.assign(/* @__PURE__ */ new Map(), {
        active: false
    });
    const receipts = /* @__PURE__ */ new Map();
    const addDependency = function(event) {
        if (!deps.active) return;
        if (!deps.has(node)) deps.set(node, /* @__PURE__ */ new Set());
        deps.get(node)?.add(event);
    };
    const observeProps = function(props) {
        return new Proxy(props, {
            get (...args) {
                typeof args[1] === "string" && addDependency(`prop:${args[1]}`);
                return Reflect.get(...args);
            }
        });
    };
    const observeLedger = function(ledger) {
        return new Proxy(ledger, {
            get (...args) {
                if (args[1] === "value") return (key)=>{
                    addDependency(`count:${key}`);
                    return ledger.value(key);
                };
                return Reflect.get(...args);
            }
        });
    };
    const observe = function(value, property) {
        if ($0deed543ccab4a3d$export$8ee0fc9ee280b4ee(value)) return $e098f7e2ce93da90$var$createObserver(value, deps);
        if (property === "value") addDependency("commit");
        if (property === "_value") addDependency("input");
        if (property === "props") return observeProps(value);
        if (property === "ledger") return observeLedger(value);
        if (property === "children") {
            addDependency("child");
            addDependency("childRemoved");
        }
        return value;
    };
    const { proxy: observed, revoke: revoke } = Proxy.revocable(node, {
        get (...args) {
            switch(args[1]){
                case "_node":
                    return node;
                case "deps":
                    return deps;
                case "watch":
                    return (block, after, pos)=>$e098f7e2ce93da90$var$watch(observed, block, after, pos);
                case "observe":
                    return ()=>{
                        const old = new Map(deps);
                        deps.clear();
                        deps.active = true;
                        return old;
                    };
                case "stopObserve":
                    return ()=>{
                        const newDeps = new Map(deps);
                        deps.active = false;
                        return newDeps;
                    };
                case "receipts":
                    return receipts;
                case "kill":
                    return ()=>{
                        $e098f7e2ce93da90$var$removeListeners(receipts);
                        $e098f7e2ce93da90$var$revokedObservers.add(args[2]);
                        revoke();
                        return void 0;
                    };
            }
            const value = Reflect.get(...args);
            if (typeof value === "function") return (...subArgs)=>{
                const subValue = value(...subArgs);
                return observe(subValue, args[1]);
            };
            return observe(value, args[1]);
        }
    });
    return observed;
}
function $e098f7e2ce93da90$var$applyListeners(node, [toAdd, toRemove], callback, pos) {
    toAdd.forEach((events, depNode)=>{
        events.forEach((event)=>{
            node.receipts.has(depNode) || node.receipts.set(depNode, {});
            const events2 = node.receipts.get(depNode) ?? {};
            events2[event] = events2[event] ?? [];
            events2[event].push(depNode.on(event, callback, pos));
            node.receipts.set(depNode, events2);
        });
    });
    toRemove.forEach((events, depNode)=>{
        events.forEach((event)=>{
            if (node.receipts.has(depNode)) {
                const nodeReceipts = node.receipts.get(depNode);
                if (nodeReceipts && $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(nodeReceipts, event)) {
                    nodeReceipts[event].map(depNode.off);
                    delete nodeReceipts[event];
                    node.receipts.set(depNode, nodeReceipts);
                }
            }
        });
    });
}
function $e098f7e2ce93da90$var$removeListeners(receipts) {
    receipts.forEach((events, node)=>{
        for(const event in events)events[event].map(node.off);
    });
    receipts.clear();
}
function $e098f7e2ce93da90$var$watch(node, block, after, pos) {
    const doAfterObservation = (res2)=>{
        const newDeps = node.stopObserve();
        $e098f7e2ce93da90$var$applyListeners(node, $e098f7e2ce93da90$var$diffDeps(oldDeps, newDeps), ()=>$e098f7e2ce93da90$var$watch(node, block, after, pos), pos);
        if (after) after(res2);
    };
    const oldDeps = new Map(node.deps);
    node.observe();
    const res = block(node);
    if (res instanceof Promise) res.then((val)=>doAfterObservation(val));
    else doAfterObservation(res);
}
function $e098f7e2ce93da90$var$diffDeps(previous, current) {
    const toAdd = /* @__PURE__ */ new Map();
    const toRemove = /* @__PURE__ */ new Map();
    current.forEach((events, node)=>{
        if (!previous.has(node)) toAdd.set(node, events);
        else {
            const eventsToAdd = /* @__PURE__ */ new Set();
            const previousEvents = previous.get(node);
            events.forEach((event)=>!previousEvents?.has(event) && eventsToAdd.add(event));
            toAdd.set(node, eventsToAdd);
        }
    });
    previous.forEach((events, node)=>{
        if (!current.has(node)) toRemove.set(node, events);
        else {
            const eventsToRemove = /* @__PURE__ */ new Set();
            const newEvents = current.get(node);
            events.forEach((event)=>!newEvents?.has(event) && eventsToRemove.add(event));
            toRemove.set(node, eventsToRemove);
        }
    });
    return [
        toAdd,
        toRemove
    ];
}
function $e098f7e2ce93da90$var$isKilled(node) {
    return $e098f7e2ce93da90$var$revokedObservers.has(node);
}
$e098f7e2ce93da90$export$26dcee9266ec3174 = $e098f7e2ce93da90$var$applyListeners;
$e098f7e2ce93da90$export$9e6a5ff84f57576 = $e098f7e2ce93da90$var$createObserver;
$e098f7e2ce93da90$export$8cff67e4740afa09 = $e098f7e2ce93da90$var$diffDeps;
$e098f7e2ce93da90$export$3b2cc45ba5082e2 = $e098f7e2ce93da90$var$isKilled;
$e098f7e2ce93da90$export$5073839cf61ff85c = $e098f7e2ce93da90$var$removeListeners; //# sourceMappingURL=out.js.map
 //# sourceMappingURL=index.cjs.map


var $10427b96296db38b$exports = {};

$parcel$export($10427b96296db38b$exports, "accepted", () => $10427b96296db38b$export$c48ab6e83c00e71f, (v) => $10427b96296db38b$export$c48ab6e83c00e71f = v);
$parcel$export($10427b96296db38b$exports, "alpha", () => $10427b96296db38b$export$58f0f39f63f3cf42, (v) => $10427b96296db38b$export$58f0f39f63f3cf42 = v);
$parcel$export($10427b96296db38b$exports, "alpha_spaces", () => $10427b96296db38b$export$9068f62484588943, (v) => $10427b96296db38b$export$9068f62484588943 = v);
$parcel$export($10427b96296db38b$exports, "alphanumeric", () => $10427b96296db38b$export$ec6fd95514ae461e, (v) => $10427b96296db38b$export$ec6fd95514ae461e = v);
$parcel$export($10427b96296db38b$exports, "between", () => $10427b96296db38b$export$cf95c51b03f10bae, (v) => $10427b96296db38b$export$cf95c51b03f10bae = v);
$parcel$export($10427b96296db38b$exports, "confirm", () => $10427b96296db38b$export$715f9d76bb8c1fea, (v) => $10427b96296db38b$export$715f9d76bb8c1fea = v);
$parcel$export($10427b96296db38b$exports, "contains_alpha", () => $10427b96296db38b$export$ffc5c88f7b7d973a, (v) => $10427b96296db38b$export$ffc5c88f7b7d973a = v);
$parcel$export($10427b96296db38b$exports, "contains_alpha_spaces", () => $10427b96296db38b$export$41261df9a770e151, (v) => $10427b96296db38b$export$41261df9a770e151 = v);
$parcel$export($10427b96296db38b$exports, "contains_alphanumeric", () => $10427b96296db38b$export$8f53774d70d98c71, (v) => $10427b96296db38b$export$8f53774d70d98c71 = v);
$parcel$export($10427b96296db38b$exports, "contains_lowercase", () => $10427b96296db38b$export$fd972a723896d95c, (v) => $10427b96296db38b$export$fd972a723896d95c = v);
$parcel$export($10427b96296db38b$exports, "contains_numeric", () => $10427b96296db38b$export$b9a815a014bdd3c, (v) => $10427b96296db38b$export$b9a815a014bdd3c = v);
$parcel$export($10427b96296db38b$exports, "contains_symbol", () => $10427b96296db38b$export$2aef40e6176fb8de, (v) => $10427b96296db38b$export$2aef40e6176fb8de = v);
$parcel$export($10427b96296db38b$exports, "contains_uppercase", () => $10427b96296db38b$export$746fa9f9e1d18c25, (v) => $10427b96296db38b$export$746fa9f9e1d18c25 = v);
$parcel$export($10427b96296db38b$exports, "date_after", () => $10427b96296db38b$export$58cc154bd611e939, (v) => $10427b96296db38b$export$58cc154bd611e939 = v);
$parcel$export($10427b96296db38b$exports, "date_after_node", () => $10427b96296db38b$export$ab64f5a584e33426, (v) => $10427b96296db38b$export$ab64f5a584e33426 = v);
$parcel$export($10427b96296db38b$exports, "date_after_or_equal", () => $10427b96296db38b$export$2e7f8e2b9ab1dee5, (v) => $10427b96296db38b$export$2e7f8e2b9ab1dee5 = v);
$parcel$export($10427b96296db38b$exports, "date_before", () => $10427b96296db38b$export$4af688e6c9d2c823, (v) => $10427b96296db38b$export$4af688e6c9d2c823 = v);
$parcel$export($10427b96296db38b$exports, "date_before_node", () => $10427b96296db38b$export$1ec6055397bf5346, (v) => $10427b96296db38b$export$1ec6055397bf5346 = v);
$parcel$export($10427b96296db38b$exports, "date_before_or_equal", () => $10427b96296db38b$export$b33622af24a53fc5, (v) => $10427b96296db38b$export$b33622af24a53fc5 = v);
$parcel$export($10427b96296db38b$exports, "date_between", () => $10427b96296db38b$export$403b41960e3611b3, (v) => $10427b96296db38b$export$403b41960e3611b3 = v);
$parcel$export($10427b96296db38b$exports, "date_format", () => $10427b96296db38b$export$e26910cb1209c4eb, (v) => $10427b96296db38b$export$e26910cb1209c4eb = v);
$parcel$export($10427b96296db38b$exports, "email", () => $10427b96296db38b$export$d290fa47940df19d, (v) => $10427b96296db38b$export$d290fa47940df19d = v);
$parcel$export($10427b96296db38b$exports, "ends_with", () => $10427b96296db38b$export$99408c5ecd0be2d, (v) => $10427b96296db38b$export$99408c5ecd0be2d = v);
$parcel$export($10427b96296db38b$exports, "is", () => $10427b96296db38b$export$226b3eccf92c9ed9, (v) => $10427b96296db38b$export$226b3eccf92c9ed9 = v);
$parcel$export($10427b96296db38b$exports, "length", () => $10427b96296db38b$export$f24224f1c91d8156, (v) => $10427b96296db38b$export$f24224f1c91d8156 = v);
$parcel$export($10427b96296db38b$exports, "lowercase", () => $10427b96296db38b$export$5b1f80f3c282648c, (v) => $10427b96296db38b$export$5b1f80f3c282648c = v);
$parcel$export($10427b96296db38b$exports, "matches", () => $10427b96296db38b$export$de994efd351b291c, (v) => $10427b96296db38b$export$de994efd351b291c = v);
$parcel$export($10427b96296db38b$exports, "max", () => $10427b96296db38b$export$8960430cfd85939f, (v) => $10427b96296db38b$export$8960430cfd85939f = v);
$parcel$export($10427b96296db38b$exports, "min", () => $10427b96296db38b$export$96ec731ed4dcb222, (v) => $10427b96296db38b$export$96ec731ed4dcb222 = v);
$parcel$export($10427b96296db38b$exports, "not", () => $10427b96296db38b$export$6003a5f097c73977, (v) => $10427b96296db38b$export$6003a5f097c73977 = v);
$parcel$export($10427b96296db38b$exports, "number", () => $10427b96296db38b$export$98e628dec113755e, (v) => $10427b96296db38b$export$98e628dec113755e = v);
$parcel$export($10427b96296db38b$exports, "require_one", () => $10427b96296db38b$export$49bd784bd5062411, (v) => $10427b96296db38b$export$49bd784bd5062411 = v);
$parcel$export($10427b96296db38b$exports, "required", () => $10427b96296db38b$export$a7a0278c004aac3f, (v) => $10427b96296db38b$export$a7a0278c004aac3f = v);
$parcel$export($10427b96296db38b$exports, "starts_with", () => $10427b96296db38b$export$855d3e393144ecda, (v) => $10427b96296db38b$export$855d3e393144ecda = v);
$parcel$export($10427b96296db38b$exports, "symbol", () => $10427b96296db38b$export$8f701197936bc2a6, (v) => $10427b96296db38b$export$8f701197936bc2a6 = v);
$parcel$export($10427b96296db38b$exports, "uppercase", () => $10427b96296db38b$export$6cfe151e6b925e83, (v) => $10427b96296db38b$export$6cfe151e6b925e83 = v);
$parcel$export($10427b96296db38b$exports, "url", () => $10427b96296db38b$export$128fa18b7194ef, (v) => $10427b96296db38b$export$128fa18b7194ef = v);
var $10427b96296db38b$export$c48ab6e83c00e71f;
var $10427b96296db38b$export$58f0f39f63f3cf42;
var $10427b96296db38b$export$9068f62484588943;
var $10427b96296db38b$export$ec6fd95514ae461e;
var $10427b96296db38b$export$cf95c51b03f10bae;
var $10427b96296db38b$export$715f9d76bb8c1fea;
var $10427b96296db38b$export$ffc5c88f7b7d973a;
var $10427b96296db38b$export$41261df9a770e151;
var $10427b96296db38b$export$8f53774d70d98c71;
var $10427b96296db38b$export$fd972a723896d95c;
var $10427b96296db38b$export$b9a815a014bdd3c;
var $10427b96296db38b$export$2aef40e6176fb8de;
var $10427b96296db38b$export$746fa9f9e1d18c25;
var $10427b96296db38b$export$58cc154bd611e939;
var $10427b96296db38b$export$ab64f5a584e33426;
var $10427b96296db38b$export$2e7f8e2b9ab1dee5;
var $10427b96296db38b$export$4af688e6c9d2c823;
var $10427b96296db38b$export$1ec6055397bf5346;
var $10427b96296db38b$export$b33622af24a53fc5;
var $10427b96296db38b$export$403b41960e3611b3;
var $10427b96296db38b$export$e26910cb1209c4eb;
var $10427b96296db38b$export$d290fa47940df19d;
var $10427b96296db38b$export$99408c5ecd0be2d;
var $10427b96296db38b$export$226b3eccf92c9ed9;
var $10427b96296db38b$export$f24224f1c91d8156;
var $10427b96296db38b$export$5b1f80f3c282648c;
var $10427b96296db38b$export$de994efd351b291c;
var $10427b96296db38b$export$8960430cfd85939f;
var $10427b96296db38b$export$96ec731ed4dcb222;
var $10427b96296db38b$export$6003a5f097c73977;
var $10427b96296db38b$export$98e628dec113755e;
var $10427b96296db38b$export$49bd784bd5062411;
var $10427b96296db38b$export$a7a0278c004aac3f;
var $10427b96296db38b$export$855d3e393144ecda;
var $10427b96296db38b$export$8f701197936bc2a6;
var $10427b96296db38b$export$6cfe151e6b925e83;
var $10427b96296db38b$export$128fa18b7194ef;
'use strict';

// packages/rules/src/accepted.ts
var $10427b96296db38b$var$accepted = function accepted2({ value: value }) {
    return [
        "yes",
        "on",
        "1",
        1,
        true,
        "true"
    ].includes(value);
};
$10427b96296db38b$var$accepted.skipEmpty = false;
var $10427b96296db38b$var$accepted_default = $10427b96296db38b$var$accepted;
// packages/rules/src/date_after.ts
var $10427b96296db38b$var$date_after = function({ value: value }, compare = false) {
    const timestamp = Date.parse(compare || /* @__PURE__ */ new Date());
    const fieldValue = Date.parse(String(value));
    return isNaN(fieldValue) ? false : fieldValue > timestamp;
};
var $10427b96296db38b$var$date_after_default = $10427b96296db38b$var$date_after;
// packages/rules/src/date_after_or_equal.ts
var $10427b96296db38b$var$date_after_or_equal = function({ value: value }, compare = false) {
    const timestamp = Date.parse(compare || /* @__PURE__ */ new Date());
    const fieldValue = Date.parse(String(value));
    return isNaN(fieldValue) ? false : fieldValue > timestamp || fieldValue === timestamp;
};
var $10427b96296db38b$var$date_after_or_equal_default = $10427b96296db38b$var$date_after_or_equal;
// packages/rules/src/date_after_node.ts
var $10427b96296db38b$var$date_after_node = function(node, address) {
    if (!address) return false;
    const fieldValue = Date.parse(String(node.value));
    const foreignValue = Date.parse(String(node.at(address)?.value));
    if (isNaN(foreignValue)) return true;
    return isNaN(fieldValue) ? false : fieldValue > foreignValue;
};
var $10427b96296db38b$var$date_after_node_default = $10427b96296db38b$var$date_after_node;
var $10427b96296db38b$var$alpha = function({ value: value }, set = "default") {
    const sets = {
        default: /^\p{L}+$/u,
        latin: /^[a-z]+$/i
    };
    const selectedSet = $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
};
var $10427b96296db38b$var$alpha_default = $10427b96296db38b$var$alpha;
var $10427b96296db38b$var$alpha_spaces = function({ value: value }, set = "default") {
    const sets = {
        default: /^[\p{L} ]+$/u,
        latin: /^[a-z ]+$/i
    };
    const selectedSet = $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
};
var $10427b96296db38b$var$alpha_spaces_default = $10427b96296db38b$var$alpha_spaces;
var $10427b96296db38b$var$alphanumeric = function({ value: value }, set = "default") {
    const sets = {
        default: /^[0-9\p{L}]+$/u,
        latin: /^[0-9a-z]+$/i
    };
    const selectedSet = $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
};
var $10427b96296db38b$var$alphanumeric_default = $10427b96296db38b$var$alphanumeric;
// packages/rules/src/date_before.ts
var $10427b96296db38b$var$date_before = function({ value: value }, compare = false) {
    const timestamp = Date.parse(compare || /* @__PURE__ */ new Date());
    const fieldValue = Date.parse(String(value));
    return isNaN(fieldValue) ? false : fieldValue < timestamp;
};
var $10427b96296db38b$var$date_before_default = $10427b96296db38b$var$date_before;
// packages/rules/src/date_before_node.ts
var $10427b96296db38b$var$date_before_node = function(node, address) {
    if (!address) return false;
    const fieldValue = Date.parse(String(node.value));
    const foreignValue = Date.parse(String(node.at(address)?.value));
    if (isNaN(foreignValue)) return true;
    return isNaN(fieldValue) ? false : fieldValue < foreignValue;
};
var $10427b96296db38b$var$date_before_node_default = $10427b96296db38b$var$date_before_node;
// packages/rules/src/date_before_or_equal.ts
var $10427b96296db38b$var$date_before_or_equal = function({ value: value }, compare = false) {
    const timestamp = Date.parse(compare || /* @__PURE__ */ new Date());
    const fieldValue = Date.parse(String(value));
    return isNaN(fieldValue) ? false : fieldValue < timestamp || fieldValue === timestamp;
};
var $10427b96296db38b$var$date_before_or_equal_default = $10427b96296db38b$var$date_before_or_equal;
// packages/rules/src/between.ts
var $10427b96296db38b$var$between = function between2({ value: value }, from, to) {
    if (!isNaN(value) && !isNaN(from) && !isNaN(to)) {
        const val = 1 * value;
        from = Number(from);
        to = Number(to);
        const [a, b] = from <= to ? [
            from,
            to
        ] : [
            to,
            from
        ];
        return val >= 1 * a && val <= 1 * b;
    }
    return false;
};
var $10427b96296db38b$var$between_default = $10427b96296db38b$var$between;
// packages/rules/src/confirm.ts
var $10427b96296db38b$var$hasConfirm = /(_confirm(?:ed)?)$/;
var $10427b96296db38b$var$confirm = function confirm2(node, address, comparison = "loose") {
    if (!address) address = $10427b96296db38b$var$hasConfirm.test(node.name) ? node.name.replace($10427b96296db38b$var$hasConfirm, "") : `${node.name}_confirm`;
    const foreignValue = node.at(address)?.value;
    return comparison === "strict" ? node.value === foreignValue : node.value == foreignValue;
};
var $10427b96296db38b$var$confirm_default = $10427b96296db38b$var$confirm;
var $10427b96296db38b$var$contains_alpha = function({ value: value }, set = "default") {
    const sets = {
        default: /\p{L}/u,
        latin: /[a-z]/i
    };
    const selectedSet = $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
};
var $10427b96296db38b$var$contains_alpha_default = $10427b96296db38b$var$contains_alpha;
var $10427b96296db38b$var$contains_alpha_spaces = function({ value: value }, set = "default") {
    const sets = {
        default: /[\p{L} ]/u,
        latin: /[a-z ]/i
    };
    const selectedSet = $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
};
var $10427b96296db38b$var$contains_alpha_spaces_default = $10427b96296db38b$var$contains_alpha_spaces;
var $10427b96296db38b$var$contains_alphanumeric = function({ value: value }, set = "default") {
    const sets = {
        default: /[0-9\p{L}]/u,
        latin: /[0-9a-z]/i
    };
    const selectedSet = $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
};
var $10427b96296db38b$var$contains_alphanumeric_default = $10427b96296db38b$var$contains_alphanumeric;
var $10427b96296db38b$var$contains_lowercase = function({ value: value }, set = "default") {
    const sets = {
        default: /\p{Ll}/u,
        latin: /[a-z]/
    };
    const selectedSet = $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
};
var $10427b96296db38b$var$contains_lowercase_default = $10427b96296db38b$var$contains_lowercase;
// packages/rules/src/contains_numeric.ts
var $10427b96296db38b$var$contains_numeric = function number({ value: value }) {
    return /[0-9]/.test(String(value));
};
var $10427b96296db38b$var$contains_numeric_default = $10427b96296db38b$var$contains_numeric;
// packages/rules/src/contains_symbol.ts
var $10427b96296db38b$var$contains_symbol = function({ value: value }) {
    return /[!-/:-@[-`{-~]/.test(String(value));
};
var $10427b96296db38b$var$contains_symbol_default = $10427b96296db38b$var$contains_symbol;
var $10427b96296db38b$var$contains_uppercase = function({ value: value }, set = "default") {
    const sets = {
        default: /\p{Lu}/u,
        latin: /[A-Z]/
    };
    const selectedSet = $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
};
var $10427b96296db38b$var$contains_uppercase_default = $10427b96296db38b$var$contains_uppercase;
// packages/rules/src/date_between.ts
var $10427b96296db38b$var$date_between = function date_between2({ value: value }, dateA, dateB) {
    dateA = dateA instanceof Date ? dateA.getTime() : Date.parse(dateA);
    dateB = dateB instanceof Date ? dateB.getTime() : Date.parse(dateB);
    const compareTo = value instanceof Date ? value.getTime() : Date.parse(String(value));
    if (dateA && !dateB) {
        dateB = dateA;
        dateA = Date.now();
    } else if (!dateA || !compareTo) return false;
    return compareTo >= dateA && compareTo <= dateB;
};
var $10427b96296db38b$var$date_between_default = $10427b96296db38b$var$date_between;
var $10427b96296db38b$var$date_format = function date({ value: value }, format) {
    if (format && typeof format === "string") return $639fe8cc1eae7e21$export$15aa749a72b8e26d(format).test(String(value));
    return !isNaN(Date.parse(String(value)));
};
var $10427b96296db38b$var$date_format_default = $10427b96296db38b$var$date_format;
// packages/rules/src/email.ts
var $10427b96296db38b$var$email = function email2({ value: value }) {
    const isEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return isEmail.test(String(value));
};
var $10427b96296db38b$var$email_default = $10427b96296db38b$var$email;
// packages/rules/src/ends_with.ts
var $10427b96296db38b$var$ends_with = function ends_with2({ value: value }, ...stack) {
    if (typeof value === "string" && stack.length) return stack.some((item)=>{
        return value.endsWith(item);
    });
    else if (typeof value === "string" && stack.length === 0) return true;
    return false;
};
var $10427b96296db38b$var$ends_with_default = $10427b96296db38b$var$ends_with;
var $10427b96296db38b$var$is = function is2({ value: value }, ...stack) {
    return stack.some((item)=>{
        if (typeof item === "object") return $639fe8cc1eae7e21$export$9663ddc1cf085b32(item, value);
        return item == value;
    });
};
var $10427b96296db38b$var$is_default = $10427b96296db38b$var$is;
// packages/rules/src/length.ts
var $10427b96296db38b$var$length = function length2({ value: value }, first = 0, second = Infinity) {
    first = parseInt(first);
    second = isNaN(parseInt(second)) ? Infinity : parseInt(second);
    const min3 = first <= second ? first : second;
    const max3 = second >= first ? second : first;
    if (typeof value === "string" || Array.isArray(value)) return value.length >= min3 && value.length <= max3;
    else if (value && typeof value === "object") {
        const length3 = Object.keys(value).length;
        return length3 >= min3 && length3 <= max3;
    }
    return false;
};
var $10427b96296db38b$var$length_default = $10427b96296db38b$var$length;
var $10427b96296db38b$var$lowercase = function({ value: value }, set = "default") {
    const sets = {
        default: /^\p{Ll}+$/u,
        allow_non_alpha: /^[0-9\p{Ll}!-/:-@[-`{-~]+$/u,
        allow_numeric: /^[0-9\p{Ll}]+$/u,
        allow_numeric_dashes: /^[0-9\p{Ll}-]+$/u,
        latin: /^[a-z]+$/
    };
    const selectedSet = $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
};
var $10427b96296db38b$var$lowercase_default = $10427b96296db38b$var$lowercase;
// packages/rules/src/matches.ts
var $10427b96296db38b$var$matches = function matches2({ value: value }, ...stack) {
    return stack.some((pattern)=>{
        if (typeof pattern === "string" && pattern.substr(0, 1) === "/" && pattern.substr(-1) === "/") pattern = new RegExp(pattern.substr(1, pattern.length - 2));
        if (pattern instanceof RegExp) return pattern.test(String(value));
        return pattern === value;
    });
};
var $10427b96296db38b$var$matches_default = $10427b96296db38b$var$matches;
// packages/rules/src/max.ts
var $10427b96296db38b$var$max = function max2({ value: value }, maximum = 10) {
    if (Array.isArray(value)) return value.length <= maximum;
    return Number(value) <= Number(maximum);
};
var $10427b96296db38b$var$max_default = $10427b96296db38b$var$max;
// packages/rules/src/min.ts
var $10427b96296db38b$var$min = function min2({ value: value }, minimum = 1) {
    if (Array.isArray(value)) return value.length >= minimum;
    return Number(value) >= Number(minimum);
};
var $10427b96296db38b$var$min_default = $10427b96296db38b$var$min;
var $10427b96296db38b$var$not = function not2({ value: value }, ...stack) {
    return !stack.some((item)=>{
        if (typeof item === "object") return $639fe8cc1eae7e21$export$9663ddc1cf085b32(item, value);
        return item === value;
    });
};
var $10427b96296db38b$var$not_default = $10427b96296db38b$var$not;
// packages/rules/src/number.ts
var $10427b96296db38b$var$number2 = function number3({ value: value }) {
    return !isNaN(value);
};
var $10427b96296db38b$var$number_default = $10427b96296db38b$var$number2;
var $10427b96296db38b$var$require_one = function(node, ...inputNames) {
    if (!$639fe8cc1eae7e21$export$6e22c362a0406a2c(node.value)) return true;
    const values = inputNames.map((name)=>node.at(name)?.value);
    return values.some((value)=>!$639fe8cc1eae7e21$export$6e22c362a0406a2c(value));
};
$10427b96296db38b$var$require_one.skipEmpty = false;
var $10427b96296db38b$var$require_one_default = $10427b96296db38b$var$require_one;
var $10427b96296db38b$var$required = function required2({ value: value }, action = "default") {
    return action === "trim" && typeof value === "string" ? !$639fe8cc1eae7e21$export$6e22c362a0406a2c(value.trim()) : !$639fe8cc1eae7e21$export$6e22c362a0406a2c(value);
};
$10427b96296db38b$var$required.skipEmpty = false;
var $10427b96296db38b$var$required_default = $10427b96296db38b$var$required;
// packages/rules/src/starts_with.ts
var $10427b96296db38b$var$starts_with = function starts_with2({ value: value }, ...stack) {
    if (typeof value === "string" && stack.length) return stack.some((item)=>{
        return value.startsWith(item);
    });
    else if (typeof value === "string" && stack.length === 0) return true;
    return false;
};
var $10427b96296db38b$var$starts_with_default = $10427b96296db38b$var$starts_with;
// packages/rules/src/symbol.ts
var $10427b96296db38b$var$symbol = function({ value: value }) {
    return /^[!-/:-@[-`{-~]+$/.test(String(value));
};
var $10427b96296db38b$var$symbol_default = $10427b96296db38b$var$symbol;
var $10427b96296db38b$var$uppercase = function({ value: value }, set = "default") {
    const sets = {
        default: /^\p{Lu}+$/u,
        latin: /^[A-Z]+$/
    };
    const selectedSet = $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
};
var $10427b96296db38b$var$uppercase_default = $10427b96296db38b$var$uppercase;
// packages/rules/src/url.ts
var $10427b96296db38b$var$url = function url2({ value: value }, ...stack) {
    try {
        const protocols = stack.length ? stack : [
            "http:",
            "https:"
        ];
        const url3 = new URL(String(value));
        return protocols.includes(url3.protocol);
    } catch  {
        return false;
    }
};
var $10427b96296db38b$var$url_default = $10427b96296db38b$var$url;
$10427b96296db38b$export$c48ab6e83c00e71f = $10427b96296db38b$var$accepted_default;
$10427b96296db38b$export$58f0f39f63f3cf42 = $10427b96296db38b$var$alpha_default;
$10427b96296db38b$export$9068f62484588943 = $10427b96296db38b$var$alpha_spaces_default;
$10427b96296db38b$export$ec6fd95514ae461e = $10427b96296db38b$var$alphanumeric_default;
$10427b96296db38b$export$cf95c51b03f10bae = $10427b96296db38b$var$between_default;
$10427b96296db38b$export$715f9d76bb8c1fea = $10427b96296db38b$var$confirm_default;
$10427b96296db38b$export$ffc5c88f7b7d973a = $10427b96296db38b$var$contains_alpha_default;
$10427b96296db38b$export$41261df9a770e151 = $10427b96296db38b$var$contains_alpha_spaces_default;
$10427b96296db38b$export$8f53774d70d98c71 = $10427b96296db38b$var$contains_alphanumeric_default;
$10427b96296db38b$export$fd972a723896d95c = $10427b96296db38b$var$contains_lowercase_default;
$10427b96296db38b$export$b9a815a014bdd3c = $10427b96296db38b$var$contains_numeric_default;
$10427b96296db38b$export$2aef40e6176fb8de = $10427b96296db38b$var$contains_symbol_default;
$10427b96296db38b$export$746fa9f9e1d18c25 = $10427b96296db38b$var$contains_uppercase_default;
$10427b96296db38b$export$58cc154bd611e939 = $10427b96296db38b$var$date_after_default;
$10427b96296db38b$export$ab64f5a584e33426 = $10427b96296db38b$var$date_after_node_default;
$10427b96296db38b$export$2e7f8e2b9ab1dee5 = $10427b96296db38b$var$date_after_or_equal_default;
$10427b96296db38b$export$4af688e6c9d2c823 = $10427b96296db38b$var$date_before_default;
$10427b96296db38b$export$1ec6055397bf5346 = $10427b96296db38b$var$date_before_node_default;
$10427b96296db38b$export$b33622af24a53fc5 = $10427b96296db38b$var$date_before_or_equal_default;
$10427b96296db38b$export$403b41960e3611b3 = $10427b96296db38b$var$date_between_default;
$10427b96296db38b$export$e26910cb1209c4eb = $10427b96296db38b$var$date_format_default;
$10427b96296db38b$export$d290fa47940df19d = $10427b96296db38b$var$email_default;
$10427b96296db38b$export$99408c5ecd0be2d = $10427b96296db38b$var$ends_with_default;
$10427b96296db38b$export$226b3eccf92c9ed9 = $10427b96296db38b$var$is_default;
$10427b96296db38b$export$f24224f1c91d8156 = $10427b96296db38b$var$length_default;
$10427b96296db38b$export$5b1f80f3c282648c = $10427b96296db38b$var$lowercase_default;
$10427b96296db38b$export$de994efd351b291c = $10427b96296db38b$var$matches_default;
$10427b96296db38b$export$8960430cfd85939f = $10427b96296db38b$var$max_default;
$10427b96296db38b$export$96ec731ed4dcb222 = $10427b96296db38b$var$min_default;
$10427b96296db38b$export$6003a5f097c73977 = $10427b96296db38b$var$not_default;
$10427b96296db38b$export$98e628dec113755e = $10427b96296db38b$var$number_default;
$10427b96296db38b$export$49bd784bd5062411 = $10427b96296db38b$var$require_one_default;
$10427b96296db38b$export$a7a0278c004aac3f = $10427b96296db38b$var$required_default;
$10427b96296db38b$export$855d3e393144ecda = $10427b96296db38b$var$starts_with_default;
$10427b96296db38b$export$8f701197936bc2a6 = $10427b96296db38b$var$symbol_default;
$10427b96296db38b$export$6cfe151e6b925e83 = $10427b96296db38b$var$uppercase_default;
$10427b96296db38b$export$128fa18b7194ef = $10427b96296db38b$var$url_default; //# sourceMappingURL=out.js.map
 //# sourceMappingURL=index.cjs.map


var $06f542080289832c$export$543f455c924f61d5;
var $06f542080289832c$export$3d3614fdf24c7f55;
var $06f542080289832c$export$4d541efe2bacf59;
'use strict';



// packages/validation/src/validation.ts
var $06f542080289832c$var$validatingMessage = /* @__PURE__ */ $0deed543ccab4a3d$export$62651879628e0c4c({
    type: "state",
    blocking: true,
    visible: false,
    value: true,
    key: "validating"
});
function $06f542080289832c$var$createValidationPlugin(baseRules = {}) {
    return function validationPlugin(node) {
        let propRules = $639fe8cc1eae7e21$export$359e5dfb2bfaf73a(node.props.validationRules || {});
        let availableRules = {
            ...baseRules,
            ...propRules
        };
        const state = {
            input: $639fe8cc1eae7e21$export$9e1725a4cfeada27(),
            rerun: null,
            isPassing: true
        };
        let validation = $639fe8cc1eae7e21$export$359e5dfb2bfaf73a(node.props.validation);
        node.on("prop:validation", ({ payload: payload })=>reboot(payload, propRules));
        node.on("prop:validationRules", ({ payload: payload })=>reboot(validation, payload));
        function reboot(newValidation, newRules) {
            if ($639fe8cc1eae7e21$export$9663ddc1cf085b32(Object.keys(propRules || {}), Object.keys(newRules || {})) && $639fe8cc1eae7e21$export$9663ddc1cf085b32(validation, newValidation)) return;
            propRules = $639fe8cc1eae7e21$export$359e5dfb2bfaf73a(newRules);
            validation = $639fe8cc1eae7e21$export$359e5dfb2bfaf73a(newValidation);
            availableRules = {
                ...baseRules,
                ...propRules
            };
            node.props.parsedRules?.forEach((validation2)=>{
                $06f542080289832c$var$removeMessage(validation2);
                $e098f7e2ce93da90$export$5073839cf61ff85c(validation2.observer.receipts);
                validation2.observer.kill();
            });
            node.store.filter(()=>false, "validation");
            node.props.parsedRules = $06f542080289832c$var$parseRules(newValidation, availableRules, node);
            state.isPassing = true;
            $06f542080289832c$var$validate(node, node.props.parsedRules, state);
        }
        node.props.parsedRules = $06f542080289832c$var$parseRules(validation, availableRules, node);
        $06f542080289832c$var$validate(node, node.props.parsedRules, state);
    };
}
function $06f542080289832c$var$validate(node, validations, state) {
    if ($e098f7e2ce93da90$export$3b2cc45ba5082e2(node)) return;
    state.input = $639fe8cc1eae7e21$export$9e1725a4cfeada27();
    node.store.set(/* @__PURE__ */ $0deed543ccab4a3d$export$62651879628e0c4c({
        key: "failing",
        value: !state.isPassing,
        visible: false
    }));
    state.isPassing = true;
    node.store.filter((message)=>!message.meta.removeImmediately, "validation");
    validations.forEach((validation)=>validation.debounce && clearTimeout(validation.timer));
    if (validations.length) {
        node.store.set($06f542080289832c$var$validatingMessage);
        $06f542080289832c$var$run(0, validations, state, false, ()=>{
            node.store.remove($06f542080289832c$var$validatingMessage.key);
            node.store.set(/* @__PURE__ */ $0deed543ccab4a3d$export$62651879628e0c4c({
                key: "failing",
                value: !state.isPassing,
                visible: false
            }));
        });
    }
}
function $06f542080289832c$var$run(current, validations, state, removeImmediately, complete) {
    const validation = validations[current];
    if (!validation) return complete();
    const node = validation.observer;
    if ($e098f7e2ce93da90$export$3b2cc45ba5082e2(node)) return;
    const currentRun = state.input;
    validation.state = null;
    function next(async, result) {
        if (state.input !== currentRun) return;
        state.isPassing = state.isPassing && !!result;
        validation.queued = false;
        const newDeps = node.stopObserve();
        const diff = $e098f7e2ce93da90$export$8cff67e4740afa09(validation.deps, newDeps);
        $e098f7e2ce93da90$export$26dcee9266ec3174(node, diff, function revalidate() {
            try {
                node.store.set($06f542080289832c$var$validatingMessage);
            } catch (e) {}
            validation.queued = true;
            if (state.rerun) clearTimeout(state.rerun);
            state.rerun = setTimeout($06f542080289832c$var$validate, 0, node, validations, state);
        }, "unshift");
        validation.deps = newDeps;
        validation.state = result;
        if (result === false) $06f542080289832c$var$createFailedMessage(validation, removeImmediately || async);
        else $06f542080289832c$var$removeMessage(validation);
        if (validations.length > current + 1) {
            const nextValidation = validations[current + 1];
            if ((result || nextValidation.force || !nextValidation.skipEmpty) && nextValidation.state === null) nextValidation.queued = true;
            $06f542080289832c$var$run(current + 1, validations, state, removeImmediately || async, complete);
        } else complete();
    }
    if ((!$639fe8cc1eae7e21$export$6e22c362a0406a2c(node.value) || !validation.skipEmpty) && (state.isPassing || validation.force)) {
        if (validation.queued) $06f542080289832c$var$runRule(validation, node, (result)=>{
            result instanceof Promise ? result.then((r)=>next(true, r)) : next(false, result);
        });
        else $06f542080289832c$var$run(current + 1, validations, state, removeImmediately, complete);
    } else if ($639fe8cc1eae7e21$export$6e22c362a0406a2c(node.value) && validation.skipEmpty && state.isPassing) {
        node.observe();
        node.value;
        next(false, state.isPassing);
    } else next(false, null);
}
function $06f542080289832c$var$runRule(validation, node, after) {
    if (validation.debounce) validation.timer = setTimeout(()=>{
        node.observe();
        after(validation.rule(node, ...validation.args));
    }, validation.debounce);
    else {
        node.observe();
        after(validation.rule(node, ...validation.args));
    }
}
function $06f542080289832c$var$removeMessage(validation) {
    const key = `rule_${validation.name}`;
    if (validation.messageObserver) validation.messageObserver = validation.messageObserver.kill();
    if ($639fe8cc1eae7e21$export$a4f4bb6b1453fff5(validation.observer.store, key)) validation.observer.store.remove(key);
}
function $06f542080289832c$var$createFailedMessage(validation, removeImmediately) {
    const node = validation.observer;
    if ($e098f7e2ce93da90$export$3b2cc45ba5082e2(node)) return;
    if (!validation.messageObserver) validation.messageObserver = $e098f7e2ce93da90$export$9e6a5ff84f57576(node._node);
    validation.messageObserver.watch((node2)=>{
        const i18nArgs = $06f542080289832c$var$createI18nArgs(node2, validation);
        return i18nArgs;
    }, (i18nArgs)=>{
        const customMessage = $06f542080289832c$var$createCustomMessage(node, validation, i18nArgs);
        const message = /* @__PURE__ */ $0deed543ccab4a3d$export$62651879628e0c4c({
            blocking: validation.blocking,
            key: `rule_${validation.name}`,
            meta: {
                /**
           * Use this key instead of the message root key to produce i18n validation
           * messages.
           */ messageKey: validation.name,
                removeImmediately: /**
           * For messages that were created *by or after* a debounced or async
           * validation rule — we make note of it so we can immediately remove them
           * as soon as the next commit happens.
           */ removeImmediately,
                /**
           * Determines if this message should be passed to localization.
           */ localize: !customMessage,
                i18nArgs: /**
           * The arguments that will be passed to the validation rules
           */ i18nArgs
            },
            type: "validation",
            value: customMessage || "This field is not valid."
        });
        node.store.set(message);
    });
}
function $06f542080289832c$var$createCustomMessage(node, validation, i18nArgs) {
    const customMessage = node.props.validationMessages && $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(node.props.validationMessages, validation.name) ? node.props.validationMessages[validation.name] : void 0;
    if (typeof customMessage === "function") return customMessage(...i18nArgs);
    return customMessage;
}
function $06f542080289832c$var$createI18nArgs(node, validation) {
    return [
        {
            node: node,
            name: $06f542080289832c$var$createMessageName(node),
            args: validation.args
        }
    ];
}
function $06f542080289832c$var$createMessageName(node) {
    if (typeof node.props.validationLabel === "function") return node.props.validationLabel(node);
    return node.props.validationLabel || node.props.label || node.props.name || String(node.name);
}
var $06f542080289832c$var$hintPattern = "(?:[\\*+?()0-9]+)";
var $06f542080289832c$var$rulePattern = "[a-zA-Z][a-zA-Z0-9_]+";
var $06f542080289832c$var$ruleExtractor = new RegExp(`^(${$06f542080289832c$var$hintPattern}?${$06f542080289832c$var$rulePattern})(?:\\:(.*)+)?$`, "i");
var $06f542080289832c$var$hintExtractor = new RegExp(`^(${$06f542080289832c$var$hintPattern})(${$06f542080289832c$var$rulePattern})$`, "i");
var $06f542080289832c$var$debounceExtractor = /([\*+?]+)?(\(\d+\))([\*+?]+)?/;
var $06f542080289832c$var$hasDebounce = /\(\d+\)/;
var $06f542080289832c$var$defaultHints = {
    blocking: true,
    debounce: 0,
    force: false,
    skipEmpty: true,
    name: ""
};
function $06f542080289832c$var$parseRules(validation, rules, node) {
    if (!validation) return [];
    const intents = typeof validation === "string" ? $06f542080289832c$var$extractRules(validation) : $639fe8cc1eae7e21$export$9cd59f9826255e47(validation);
    return intents.reduce((validations, args)=>{
        let rule = args.shift();
        const hints = {};
        if (typeof rule === "string") {
            const [ruleName, parsedHints] = $06f542080289832c$var$parseHints(rule);
            if ($639fe8cc1eae7e21$export$a4f4bb6b1453fff5(rules, ruleName)) {
                rule = rules[ruleName];
                Object.assign(hints, parsedHints);
            }
        }
        if (typeof rule === "function") validations.push({
            observer: $e098f7e2ce93da90$export$9e6a5ff84f57576(node),
            rule: rule,
            args: args,
            timer: 0,
            state: null,
            queued: true,
            deps: /* @__PURE__ */ new Map(),
            ...$06f542080289832c$var$defaultHints,
            ...$06f542080289832c$var$fnHints(hints, rule)
        });
        return validations;
    }, []);
}
function $06f542080289832c$var$extractRules(validation) {
    return validation.split("|").reduce((rules, rule)=>{
        const parsedRule = $06f542080289832c$var$parseRule(rule);
        if (parsedRule) rules.push(parsedRule);
        return rules;
    }, []);
}
function $06f542080289832c$var$parseRule(rule) {
    const trimmed = rule.trim();
    if (trimmed) {
        const matches = trimmed.match($06f542080289832c$var$ruleExtractor);
        if (matches && typeof matches[1] === "string") {
            const ruleName = matches[1].trim();
            const args = matches[2] && typeof matches[2] === "string" ? matches[2].split(",").map((s)=>s.trim()) : [];
            return [
                ruleName,
                ...args
            ];
        }
    }
    return false;
}
function $06f542080289832c$var$parseHints(ruleName) {
    const matches = ruleName.match($06f542080289832c$var$hintExtractor);
    if (!matches) return [
        ruleName,
        {
            name: ruleName
        }
    ];
    const map = {
        "*": {
            force: true
        },
        "+": {
            skipEmpty: false
        },
        "?": {
            blocking: false
        }
    };
    const [, hints, rule] = matches;
    const hintGroups = $06f542080289832c$var$hasDebounce.test(hints) ? hints.match($06f542080289832c$var$debounceExtractor) || [] : [
        ,
        hints
    ];
    return [
        rule,
        [
            hintGroups[1],
            hintGroups[2],
            hintGroups[3]
        ].reduce((hints2, group)=>{
            if (!group) return hints2;
            if ($06f542080289832c$var$hasDebounce.test(group)) hints2.debounce = parseInt(group.substr(1, group.length - 1));
            else group.split("").forEach((hint)=>$639fe8cc1eae7e21$export$a4f4bb6b1453fff5(map, hint) && Object.assign(hints2, map[hint]));
            return hints2;
        }, {
            name: rule
        })
    ];
}
function $06f542080289832c$var$fnHints(existingHints, rule) {
    if (!existingHints.name) existingHints.name = rule.ruleName || rule.name;
    return [
        "skipEmpty",
        "force",
        "debounce",
        "blocking"
    ].reduce((hints, hint)=>{
        if ($639fe8cc1eae7e21$export$a4f4bb6b1453fff5(rule, hint) && !$639fe8cc1eae7e21$export$a4f4bb6b1453fff5(hints, hint)) Object.assign(hints, {
            [hint]: rule[hint]
        });
        return hints;
    }, existingHints);
}
function $06f542080289832c$var$getValidationMessages(node) {
    const messages = /* @__PURE__ */ new Map();
    const extract = (n)=>{
        const nodeMessages = [];
        for(const key in n.store){
            const message = n.store[key];
            if (message.type === "validation" && message.visible && typeof message.value === "string") nodeMessages.push(message);
        }
        if (nodeMessages.length) messages.set(n, nodeMessages);
        return n;
    };
    extract(node).walk(extract);
    return messages;
}
$06f542080289832c$export$543f455c924f61d5 = $06f542080289832c$var$createMessageName;
$06f542080289832c$export$3d3614fdf24c7f55 = $06f542080289832c$var$createValidationPlugin;
$06f542080289832c$export$4d541efe2bacf59 = $06f542080289832c$var$getValidationMessages; //# sourceMappingURL=out.js.map
 //# sourceMappingURL=index.cjs.map


var $a262a7e50e5a100c$export$d24c54395ce0c509;
var $a262a7e50e5a100c$export$3d12bd131bb975d1;
var $a262a7e50e5a100c$export$136fd86de524d3c2;
var $a262a7e50e5a100c$export$4e222d082f82ee97;
var $a262a7e50e5a100c$export$89e9012e902952b6;
var $a262a7e50e5a100c$export$7343075cd7f756c5;
var $a262a7e50e5a100c$export$c69ea711f447870e;
var $a262a7e50e5a100c$export$bde1ed0f60b38f2f;
var $a262a7e50e5a100c$export$8c8450b83b664ba4;
var $a262a7e50e5a100c$export$324d90190a8b822a;
var $a262a7e50e5a100c$export$2fa162a495d26869;
var $a262a7e50e5a100c$export$c3da0dad1b44eea9;
var $a262a7e50e5a100c$export$84584c2a98eb6753;
var $a262a7e50e5a100c$export$ca5e4045a55e76d2;
var $a262a7e50e5a100c$export$48a262eaf0aadda2;
var $a262a7e50e5a100c$export$ed5179c818622fb;
var $a262a7e50e5a100c$export$acb2a88f7d552ebf;
var $a262a7e50e5a100c$export$c0dcd1f2238f086d;
var $a262a7e50e5a100c$export$10cc7d172bb7969;
var $a262a7e50e5a100c$export$b4adb3f464574dcf;
var $a262a7e50e5a100c$export$9901d21957972d53;
var $a262a7e50e5a100c$export$d560c7e4a29451c2;
var $a262a7e50e5a100c$export$226b3eccf92c9ed9;
var $a262a7e50e5a100c$export$3486a10f30cf1ee4;
var $a262a7e50e5a100c$export$8c6f505e9474ce90;
var $a262a7e50e5a100c$export$4b04b6f14f77e727;
var $a262a7e50e5a100c$export$798cf677954c9533;
var $a262a7e50e5a100c$export$8837f4fc672e936d;
var $a262a7e50e5a100c$export$df1c34db1371eeed;
var $a262a7e50e5a100c$export$b961576059b7aeb6;
var $a262a7e50e5a100c$export$54ca4d1eb7926f1;
var $a262a7e50e5a100c$export$e78c44be168181dc;
var $a262a7e50e5a100c$export$38ef0e3f791a121e;
var $a262a7e50e5a100c$export$9c64ee4d84d79ce1;
var $a262a7e50e5a100c$export$aaaeab0fac9a3ccb;
var $a262a7e50e5a100c$export$6ea5311eda92944f;
var $a262a7e50e5a100c$export$84175d5f1cb4e39d;
var $a262a7e50e5a100c$export$ea30ec7f37fb148d;
var $a262a7e50e5a100c$export$cf48009033a0126b;
var $a262a7e50e5a100c$export$ae6a5ab41f356242;
var $a262a7e50e5a100c$export$d608fa5b5bfd2021;
var $a262a7e50e5a100c$export$c48c9775cb5125a6;
var $a262a7e50e5a100c$export$187592e8a03966af;
var $a262a7e50e5a100c$export$65540e5f7f6e7dce;
var $a262a7e50e5a100c$export$caa0a79844f1a673;
var $a262a7e50e5a100c$export$fe45ecdd3e49b545;
var $a262a7e50e5a100c$export$d657bc098992a431;
var $a262a7e50e5a100c$export$72451b88a72ad9c2;
var $a262a7e50e5a100c$export$312745a8a3013c00;
var $a262a7e50e5a100c$export$461e3962c82dff4f;
var $a262a7e50e5a100c$export$e3786bf10a8abdf2;
var $a262a7e50e5a100c$export$b65a7f08f2280505;
var $a262a7e50e5a100c$export$3991fdf1bb6f66b9;
'use strict';


// packages/i18n/src/locales/ar.ts
// packages/i18n/src/formatters.ts
function $a262a7e50e5a100c$var$sentence(str) {
    return str[0].toUpperCase() + str.substr(1);
}
function $a262a7e50e5a100c$var$list(items, conjunction = "or") {
    return items.reduce((oxford, item, index)=>{
        oxford += item;
        if (index <= items.length - 2 && items.length > 2) oxford += ", ";
        if (index === items.length - 2) oxford += `${items.length === 2 ? " " : ""}${conjunction} `;
        return oxford;
    }, "");
}
function $a262a7e50e5a100c$var$date(date2) {
    const dateTime = typeof date2 === "string" ? new Date(Date.parse(date2)) : date2;
    if (!(dateTime instanceof Date)) return "(unknown)";
    return new Intl.DateTimeFormat(void 0, {
        dateStyle: "medium",
        timeZone: "UTC"
    }).format(dateTime);
}
function $a262a7e50e5a100c$var$order(first, second) {
    return Number(first) >= Number(second) ? [
        second,
        first
    ] : [
        first,
        second
    ];
}
// packages/i18n/src/locales/ar.ts
var $a262a7e50e5a100c$var$ui = {
    /**
   * Shown on buttons for adding new items.
   */ add: "\u0625\u0636\u0627\u0641\u0629",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u0625\u0632\u0627\u0644\u0629",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0643\u0644",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u0639\u0630\u0631\u0627\u060C \u0644\u0645 \u064A\u062A\u0645 \u062A\u0639\u0628\u0626\u0629 \u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0642\u0648\u0644 \u0628\u0634\u0643\u0644 \u0635\u062D\u064A\u062D.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u0625\u0631\u0633\u0627\u0644",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0644\u0641 \u0645\u062E\u062A\u0627\u0631",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u062A\u062D\u0631\u0643 \u0644\u0623\u0639\u0644\u0649",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u0627\u0646\u062A\u0642\u0644 \u0644\u0623\u0633\u0641\u0644",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u064A\u062A\u0645 \u0627\u0644\u0622\u0646 \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0632\u064A\u062F",
    /**
   * Shown on buttons that navigate state forward
   */ next: "\u0627\u0644\u062A\u0627\u0644\u064A",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\u0627\u0644\u0633\u0627\u0628\u0642",
    /**
   * Shown when transferring items between lists.
   */ addAllValues: "\u0623\u0636\u0641 \u062C\u0645\u064A\u0639 \u0627\u0644\u0642\u064A\u0645",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u0625\u0636\u0627\u0641\u0629 \u0642\u064A\u0645 \u0645\u062D\u062F\u062F\u0629",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u0642\u0645 \u0628\u0625\u0632\u0627\u0644\u0629 \u062C\u0645\u064A\u0639 \u0627\u0644\u0642\u064A\u0645",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0642\u064A\u0645 \u0627\u0644\u0645\u062D\u062F\u062F\u0629",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u063A\u064A\u064A\u0631",
    /**
   * Shown when there is something to close
   */ close: "\u0623\u063A\u0644\u0642",
    /**
   * Shown when there is something to open.
   */ open: "\u0627\u0641\u062A\u062D"
};
var $a262a7e50e5a100c$var$validation = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `\u{627}\u{644}\u{631}\u{62C}\u{627}\u{621} \u{642}\u{628}\u{648}\u{644} ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{639}\u{62F} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{633}\u{62A}\u{642}\u{628}\u{644}.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `\u{64A}\u{645}\u{643}\u{646} \u{623}\u{646} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{623}\u{62D}\u{631}\u{641} \u{623}\u{628}\u{62C}\u{62F}\u{64A}\u{629} \u{641}\u{642}\u{637}.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `\u{64A}\u{645}\u{643}\u{646} \u{623}\u{646} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{623}\u{62D}\u{631}\u{641} \u{648}\u{623}\u{631}\u{642}\u{627}\u{645} \u{641}\u{642}\u{637}.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `\u{64A}\u{645}\u{643}\u{646} \u{623}\u{646} \u{62A}\u{62D}\u{62A}\u{648}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{623}\u{62D}\u{631}\u{641} \u{648}\u{645}\u{633}\u{627}\u{641}\u{627}\u{62A} \u{641}\u{642}\u{637}.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{623}\u{62D}\u{631}\u{641} \u{623}\u{628}\u{62C}\u{62F}\u{64A}\u{629}.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{623}\u{62D}\u{631}\u{641} \u{623}\u{648} \u{623}\u{631}\u{642}\u{627}\u{645}.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{623}\u{62D}\u{631}\u{641} \u{623}\u{648} \u{645}\u{633}\u{627}\u{641}\u{627}\u{62A}.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{631}\u{645}\u{632}.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{623}\u{62D}\u{631}\u{641} \u{643}\u{628}\u{64A}\u{631}\u{629}.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{623}\u{62D}\u{631}\u{641} \u{635}\u{63A}\u{64A}\u{631}\u{629}.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{623}\u{631}\u{642}\u{627}\u{645}.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{631}\u{645}\u{632}\u{64B}\u{627}.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `\u{64A}\u{645}\u{643}\u{646} \u{623}\u{646} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{623}\u{62D}\u{631}\u{641} \u{643}\u{628}\u{64A}\u{631}\u{629} \u{641}\u{642}\u{637}.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `\u{64A}\u{645}\u{643}\u{646} \u{623}\u{646} \u{64A}\u{62D}\u{62A}\u{648}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{623}\u{62D}\u{631}\u{641} \u{635}\u{63A}\u{64A}\u{631}\u{629} \u{641}\u{642}\u{637}.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{642}\u{628}\u{644} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{641}\u{64A} \u{627}\u{644}\u{645}\u{627}\u{636}\u{64A}.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{62A}\u{645}\u{62A} \u{62A}\u{647}\u{64A}\u{626}\u{629} \u{647}\u{630}\u{627} \u{627}\u{644}\u{62D}\u{642}\u{644} \u{628}\u{634}\u{643}\u{644} \u{63A}\u{64A}\u{631} \u{635}\u{62D}\u{64A}\u{62D} \u{648}\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{625}\u{631}\u{633}\u{627}\u{644}\u{647}.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{645}\u{627} \u{628}\u{64A}\u{646} ${a} \u{648} ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{63A}\u{64A}\u{631} \u{645}\u{62A}\u{637}\u{627}\u{628}\u{642}.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{644}\u{64A}\u{633} \u{62A}\u{627}\u{631}\u{64A}\u{62E}\u{64B}\u{627} \u{635}\u{627}\u{644}\u{62D}\u{64B}\u{627} \u{60C} \u{64A}\u{631}\u{62C}\u{649} \u{627}\u{633}\u{62A}\u{62E}\u{62F}\u{627}\u{645} \u{627}\u{644}\u{62A}\u{646}\u{633}\u{64A}\u{642} ${args[0]}`;
        return "\u062A\u0645\u062A \u062A\u0647\u064A\u0626\u0629 \u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0628\u0634\u0643\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D \u0648\u0644\u0627 \u064A\u0645\u0643\u0646 \u0625\u0631\u0633\u0627\u0644\u0647";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{64A}\u{646} ${$a262a7e50e5a100c$var$date(args[0])} \u{648} ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u0627\u0644\u0631\u062C\u0627\u0621 \u0623\u062F\u062E\u0627\u0644 \u0628\u0631\u064A\u062F \u0625\u0644\u064A\u0643\u062A\u0631\u0648\u0646\u064A \u0635\u0627\u0644\u062D.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `\u{644}\u{627} \u{64A}\u{646}\u{62A}\u{647}\u{64A} ${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{640} ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{644}\u{64A}\u{633}\u{62A} \u{642}\u{64A}\u{645}\u{629} \u{645}\u{633}\u{645}\u{648}\u{62D} \u{628}\u{647}\u{627}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{62D}\u{631}\u{641}\u{64B}\u{627} \u{648}\u{627}\u{62D}\u{62F}\u{64B}\u{627} \u{639}\u{644}\u{649} \u{627}\u{644}\u{623}\u{642}\u{644}.`;
        if (min == 0 && max) return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{623}\u{642}\u{644} \u{645}\u{646} \u{623}\u{648} \u{64A}\u{633}\u{627}\u{648}\u{64A} ${max} \u{62D}\u{631}\u{641}\u{64B}\u{627}.`;
        if (min === max) return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{62A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{645}\u{646} \u{627}\u{644}\u{623}\u{62D}\u{631}\u{641} ${max}.`;
        if (min && max === Infinity) return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{623}\u{643}\u{628}\u{631} \u{645}\u{646} \u{623}\u{648} \u{64A}\u{633}\u{627}\u{648}\u{64A} ${min} \u{62D}\u{631}\u{641}\u{64B}\u{627}.`;
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{64A}\u{646} ${min} \u{648} ${max} \u{62D}\u{631}\u{641}\u{64B}\u{627}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{644}\u{64A}\u{633}\u{62A} \u{642}\u{64A}\u{645}\u{629} \u{645}\u{633}\u{645}\u{648}\u{62D} \u{628}\u{647}\u{627}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} \u{623}\u{643}\u{62B}\u{631} \u{645}\u{646} ${args[0]} ${name}.`;
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{623}\u{642}\u{644} \u{645}\u{646} \u{623}\u{648} \u{64A}\u{633}\u{627}\u{648}\u{64A} ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u0644\u0627 \u064A\u0633\u0645\u062D \u0628\u062A\u0646\u0633\u064A\u0642\u0627\u062A \u0627\u0644\u0645\u0644\u0641\u0627\u062A.";
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{645}\u{646} \u{627}\u{644}\u{646}\u{648}\u{639}: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{644}\u{627} \u{64A}\u{645}\u{643}\u{646} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} \u{623}\u{642}\u{644} \u{645}\u{646} ${args[0]} ${name}.`;
        return `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{64A}\u{643}\u{648}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{639}\u{644}\u{649} \u{627}\u{644}\u{623}\u{642}\u{644} ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} \u{644}\u{64A}\u{633} ${name} \u{645}\u{633}\u{645}\u{648}\u{62D}\u{64B}\u{627} \u{628}\u{647}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{64A}\u{62C}\u{628} \u{627}\u{646} \u{64A}\u{643}\u{648}\u{646} \u{631}\u{642}\u{645}\u{627}\u{64B}`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" \u0623\u0648 ")} \u{645}\u{637}\u{644}\u{648}\u{628}.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{645}\u{637}\u{644}\u{648}\u{628}.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `\u{644}\u{627} \u{64A}\u{628}\u{62F}\u{623} ${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{640} ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{64A}\u{631}\u{62C}\u{649} \u{625}\u{62F}\u{62E}\u{627}\u{644} \u{639}\u{646}\u{648}\u{627}\u{646} URL \u{635}\u{627}\u{644}\u{62D}.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u062D\u062F\u062F \u063A\u064A\u0631 \u0635\u0627\u0644\u062D."
};
var $a262a7e50e5a100c$var$ar = {
    ui: $a262a7e50e5a100c$var$ui,
    validation: $a262a7e50e5a100c$var$validation
};
var $a262a7e50e5a100c$var$ui2 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "\u0259lav\u0259 edin",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\xe7\u0131xarmaq",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Ham\u0131s\u0131n\u0131 silin",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\xdczr ist\u0259yirik, b\xfct\xfcn sah\u0259l\u0259r d\xfczg\xfcn doldurulmay\u0131b.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "T\u0259qdim et",
    /**
   * Shown when no files are selected.
   */ noFiles: "He\xe7 bir fayl se\xe7ilm\u0259yib",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "yuxar\u0131 h\u0259r\u0259k\u0259t",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "A\u015Fa\u011F\u0131 h\u0259r\u0259k\u0259t",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Y\xfckl\u0259m\u0259...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Daha \xe7ox y\xfckl\u0259",
    /**
   * Shown on buttons that navigate state forward
   */ next: "N\xf6vb\u0259ti",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\u018Fvv\u0259lki",
    /**
   * Shown when adding all values.
   */ addAllValues: "B\xfct\xfcn d\u0259y\u0259rl\u0259ri \u0259lav\u0259 edin",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Se\xe7ilmi\u015F d\u0259y\u0259rl\u0259ri \u0259lav\u0259 edin",
    /**
   * Shown when removing all values.
   */ removeAllValues: "B\xfct\xfcn d\u0259y\u0259rl\u0259ri sil",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Se\xe7ilmi\u015F d\u0259y\u0259rl\u0259ri sil",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Tarixi se\xe7in",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Tarixi d\u0259yi\u015Fdirin",
    /**
   * Shown when there is something to close
   */ close: "Ba\u011Flay\u0131n",
    /**
   * Shown when there is something to open.
   */ open: "A\xe7\u0131q"
};
var $a262a7e50e5a100c$var$validation2 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `${name} q\u{259}bul edin.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$date(args[0])} sonra olmal\u{131}d\u{131}r.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} g\u{259}l\u{259}c\u{259}kd\u{259} olmal\u{131}d\u{131}r.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} yaln\u{131}z \u{259}lifba s\u{131}ras\u{131} simvollar\u{131}ndan ibar\u{259}t ola bil\u{259}r.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} yaln\u{131}z h\u{259}rf v\u{259} r\u{259}q\u{259}ml\u{259}rd\u{259}n ibar\u{259}t ola bil\u{259}r.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} yaln\u{131}z h\u{259}rfl\u{259}rd\u{259}n v\u{259} bo\u{15F}luqlardan ibar\u{259}t ola bil\u{259}r.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{259}lifba s\u{131}ras\u{131} simvollar\u{131} ehtiva etm\u{259}lidir.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} h\u{259}rfl\u{259}ri v\u{259} ya n\xf6mr\u{259}l\u{259}ri ehtiva etm\u{259}lidir.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} h\u{259}rfl\u{259}ri v\u{259} ya bo\u{15F}luqlar\u{131} ehtiva etm\u{259}lidir.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} simvolu ehtiva etm\u{259}lidir.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} b\xf6y\xfck olmal\u{131}d\u{131}r.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ki\xe7ik olmal\u{131}d\u{131}r.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} n\xf6mr\u{259}l\u{259}ri ehtiva etm\u{259}lidir.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} simvol olmal\u{131}d\u{131}r.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} yaln\u{131}z b\xf6y\xfck h\u{259}rfl\u{259}ri ehtiva ed\u{259} bil\u{259}r.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} yaln\u{131}z ki\xe7ik h\u{259}rfl\u{259}ri ehtiva ed\u{259} bil\u{259}r.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$date(args[0])} \u{259}vv\u{259}l olmal\u{131}d\u{131}r.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ke\xe7mi\u{15F}d\u{259} olmal\u{131}d\u{131}r.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Bu sah\u{259} s\u{259}hv konfiqurasiya edilib v\u{259} onu t\u{259}qdim etm\u{259}k m\xfcmk\xfcn deyil.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} ${a} v\u{259} ${b} aras\u{131}nda olmal\u{131}d\u{131}r.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} uy\u{11F}un g\u{259}lmir.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} etibarl\u{131} tarix deyil, ${args[0]} format\u{131}ndan istifad\u{259} edin`;
        return "Bu sah\u0259 s\u0259hv konfiqurasiya edilib v\u0259 onu t\u0259qdim etm\u0259k m\xfcmk\xfcn deyil";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$date(args[0])} v\u{259} ${$a262a7e50e5a100c$var$date(args[1])} aras\u{131}nda olmal\u{131}d\u{131}r`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Etibarl\u0131 e-po\xe7t \xfcnvan\u0131 daxil edin.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$list(args)} il\u{259} bitmir.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} icaz\u{259} veril\u{259}n d\u{259}y\u{259}r deyil.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{259}n az\u{131} bir simvol olmal\u{131}d\u{131}r.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} ${max} simvoldan ki\xe7ik v\u{259} ya ona b\u{259}rab\u{259}r olmal\u{131}d\u{131}r.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} ${max} simvol uzunlu\u{11F}unda olmal\u{131}d\u{131}r.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} ${min} simvoldan b\xf6y\xfck v\u{259} ya ona b\u{259}rab\u{259}r olmal\u{131}d\u{131}r.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ${min} v\u{259} ${max} simvol aras\u{131}nda olmal\u{131}d\u{131}r.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} icaz\u{259} veril\u{259}n d\u{259}y\u{259}r deyil.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${args[0]} ${name}-d\u{259}n \xe7ox ola bilm\u{259}z.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ${args[0]} d\u{259}y\u{259}rind\u{259}n ki\xe7ik v\u{259} ya ona b\u{259}rab\u{259}r olmal\u{131}d\u{131}r.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Fayl formatlar\u0131na icaz\u0259 verilmir.";
        return `${$a262a7e50e5a100c$var$sentence(name)} a\u{15F}a\u{11F}\u{131}dak\u{131} tipd\u{259} olmal\u{131}d\u{131}r: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${args[0]} ${name}-d\u{259}n az ola bilm\u{259}z.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{259}n az\u{131} ${args[0]} olmal\u{131}d\u{131}r.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} icaz\u{259} veril\u{259}n ${name} deyil.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} r\u{259}q\u{259}m olmal\u{131}d\u{131}r.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" v\u0259 ya ")} t\u{259}l\u{259}b olunur.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} t\u{259}l\u{259}b olunur.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$list(args)} il\u{259} ba\u{15F}lam\u{131}r.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Xahi\u{15F} edirik, d\xfczg\xfcn URL daxil edin.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Se\xe7ilmi\u015F tarix etibars\u0131zd\u0131r."
};
var $a262a7e50e5a100c$var$az = {
    ui: $a262a7e50e5a100c$var$ui2,
    validation: $a262a7e50e5a100c$var$validation2
};
var $a262a7e50e5a100c$var$ui3 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "\u0414\u043E\u0431\u0430\u0432\u0438",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0438 \u0432\u0441\u0438\u0447\u043A\u0438",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u0418\u0437\u0432\u0438\u043D\u0435\u0442\u0435, \u043D\u0435 \u0432\u0441\u0438\u0447\u043A\u0438 \u043F\u043E\u043B\u0435\u0442\u0430 \u0441\u0430 \u043F\u043E\u043F\u044A\u043B\u043D\u0435\u043D\u0438 \u043F\u0440\u0430\u0432\u0438\u043B\u043D\u043E.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u0418\u0437\u043F\u0440\u0430\u0442\u0438",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u041D\u044F\u043C\u0430 \u0438\u0437\u0431\u0440\u0430\u043D \u0444\u0430\u0439\u043B",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u041F\u0440\u0435\u043C\u0435\u0441\u0442\u0432\u0430\u043D\u0435 \u043D\u0430\u0433\u043E\u0440\u0435",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u041F\u0440\u0435\u043C\u0435\u0441\u0442\u0435\u0442\u0435 \u0441\u0435 \u043D\u0430\u0434\u043E\u043B\u0443",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u0417\u0430\u0440\u0435\u0434\u0435\u0442\u0435 \u043F\u043E\u0432\u0435\u0447\u0435",
    /**
   * Shown on buttons that navigate state forward
   */ next: "\u0421\u043B\u0435\u0434\u0432\u0430\u0449",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\u041F\u0440\u0435\u0434\u0438\u0448\u0435\u043D",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u0414\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0432\u0441\u0438\u0447\u043A\u0438 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442\u0438",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442\u0438",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u041F\u0440\u0435\u043C\u0430\u0445\u043D\u0435\u0442\u0435 \u0432\u0441\u0438\u0447\u043A\u0438 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442\u0438",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435 \u043D\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438\u0442\u0435 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442\u0438",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u0418\u0437\u0431\u0435\u0440\u0438 \u0434\u0430\u0442\u0430",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u041F\u0440\u043E\u043C\u044F\u043D\u0430 \u043D\u0430 \u0434\u0430\u0442\u0430\u0442\u0430",
    /**
   * Shown when there is something to close
   */ close: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438",
    /**
   * Shown when there is something to open.
   */ open: "\u041E\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
};
var $a262a7e50e5a100c$var$validation3 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `\u{41C}\u{43E}\u{43B}\u{44F} \u{43F}\u{440}\u{438}\u{435}\u{43C}\u{435}\u{442}\u{435} ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} \u{441}\u{43B}\u{435}\u{434} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{432} \u{431}\u{44A}\u{434}\u{435}\u{449}\u{435}\u{442}\u{43E}.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} \u{441}\u{430}\u{43C}\u{43E} \u{431}\u{443}\u{43A}\u{432}\u{438}.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} \u{441}\u{430}\u{43C}\u{43E} \u{431}\u{443}\u{43A}\u{432}\u{438} \u{438} \u{446}\u{438}\u{444}\u{440}\u{438}.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} \u{441}\u{430}\u{43C}\u{43E} \u{431}\u{443}\u{43A}\u{432}\u{438} \u{438} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{432}\u{430}\u{43B}\u{438}.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} \u{430}\u{437}\u{431}\u{443}\u{447}\u{43D}\u{438} \u{437}\u{43D}\u{430}\u{446}\u{438}.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} \u{431}\u{443}\u{43A}\u{432}\u{438} \u{438}\u{43B}\u{438} \u{446}\u{438}\u{444}\u{440}\u{438}.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} \u{431}\u{443}\u{43A}\u{432}\u{438} \u{438}\u{43B}\u{438} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{432}\u{430}\u{43B}\u{438}.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} \u{433}\u{43B}\u{430}\u{432}\u{43D}\u{438} \u{431}\u{443}\u{43A}\u{432}\u{438}.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} \u{43C}\u{430}\u{43B}\u{43A}\u{438} \u{431}\u{443}\u{43A}\u{432}\u{438}.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} \u{447}\u{438}\u{441}\u{43B}\u{430}.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} \u{441}\u{430}\u{43C}\u{43E} \u{433}\u{43B}\u{430}\u{432}\u{43D}\u{438} \u{431}\u{443}\u{43A}\u{432}\u{438}.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435} \u{434}\u{430} \u{441}\u{44A}\u{434}\u{44A}\u{440}\u{436}\u{430} \u{441}\u{430}\u{43C}\u{43E} \u{43C}\u{430}\u{43B}\u{43A}\u{438} \u{431}\u{443}\u{43A}\u{432}\u{438}.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} \u{43F}\u{440}\u{435}\u{434}\u{438} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{432} \u{43C}\u{438}\u{43D}\u{430}\u{43B}\u{43E}\u{442}\u{43E}.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{422}\u{43E}\u{432}\u{430} \u{43F}\u{43E}\u{43B}\u{435} \u{435} \u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{438}\u{440}\u{430}\u{43D}\u{43E} \u{43D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{43D}\u{43E} \u{438} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{438}\u{437}\u{43F}\u{440}\u{430}\u{442}\u{435}\u{43D}\u{43E}`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{43C}\u{435}\u{436}\u{434}\u{443} ${a} \u{438} ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{435} \u{441}\u{44A}\u{432}\u{43F}\u{430}\u{434}\u{430}.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{435} \u{43D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{43D}\u{430} \u{434}\u{430}\u{442}\u{430}. \u{41C}\u{43E}\u{43B}\u{44F}, \u{438}\u{437}\u{43F}\u{43E}\u{43B}\u{437}\u{432}\u{430}\u{439}\u{442}\u{435} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{430} ${args[0]}`;
        return "\u0422\u043E\u0432\u0430 \u043F\u043E\u043B\u0435 \u0435 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0438\u0440\u0430\u043D\u043E \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u043D\u043E \u0438 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D\u043E";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{43C}\u{435}\u{436}\u{434}\u{443} ${$a262a7e50e5a100c$var$date(args[0])} \u{438} ${$a262a7e50e5a100c$var$date(args[1])}.`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u041C\u043E\u043B\u044F, \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0432\u0430\u043B\u0438\u0434\u0435\u043D \u0438\u043C\u0435\u0439\u043B \u0430\u0434\u0440\u0435\u0441.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{435} \u{437}\u{430}\u{432}\u{44A}\u{440}\u{448}\u{432}\u{430} \u{43D}\u{430} ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{435} \u{43D}\u{435}\u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{430} \u{441}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{438}\u{43C}\u{430} \u{43F}\u{43E}\u{43D}\u{435} \u{435}\u{434}\u{438}\u{43D} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{43F}\u{43E}-\u{43C}\u{430}\u{43B}\u{43A}\u{43E} \u{438}\u{43B}\u{438} \u{440}\u{430}\u{432}\u{43D}\u{43E} \u{43D}\u{430} ${max} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{430}.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} ${max} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{438} \u{434}\u{44A}\u{43B}\u{433}\u{43E}.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{43F}\u{43E}-\u{433}\u{43E}\u{43B}\u{44F}\u{43C}\u{43E} \u{438}\u{43B}\u{438} \u{440}\u{430}\u{432}\u{43D}\u{43E} \u{43D}\u{430} ${min} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{430}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{43C}\u{435}\u{436}\u{434}\u{443} ${min} \u{438} ${max} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{430}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{435} \u{43D}\u{435}\u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{430} \u{441}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{41D}\u{435} \u{43C}\u{43E}\u{436}\u{435} \u{434}\u{430} \u{438}\u{43C}\u{430} \u{43F}\u{43E}\u{432}\u{435}\u{447}\u{435} \u{43E}\u{442} ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{43F}\u{43E}-\u{43C}\u{430}\u{43B}\u{43A}\u{43E} \u{438}\u{43B}\u{438} \u{440}\u{430}\u{432}\u{43D}\u{43E} \u{43D}\u{430} ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u041D\u0435 \u0441\u0430 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438 \u043D\u0438\u043A\u0430\u043A\u0432\u0438 \u0444\u0430\u0439\u043B\u043E\u0432\u0438 \u0444\u043E\u0440\u043C\u0430\u0442\u0438.";
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{43E}\u{442} \u{442}\u{438}\u{43F}: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{41D}\u{435} \u{43C}\u{43E}\u{436}\u{435} \u{434}\u{430} \u{438}\u{43C}\u{430} \u{43F}\u{43E}-\u{43C}\u{430}\u{43B}\u{43A}\u{43E} \u{43E}\u{442} ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{43F}\u{43E}\u{43D}\u{435} ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} \u{435} \u{43D}\u{435}\u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D} ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{431}\u{44A}\u{434}\u{435} \u{447}\u{438}\u{441}\u{43B}\u{43E}.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" \u0438\u043B\u0438 ")} \u{438}\u{437}\u{438}\u{441}\u{43A}\u{432}\u{430} \u{441}\u{435}.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{435} \u{437}\u{430}\u{434}\u{44A}\u{43B}\u{436}\u{438}\u{442}\u{435}\u{43B}\u{43D}\u{43E}.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{435} \u{437}\u{430}\u{43F}\u{43E}\u{447}\u{432}\u{430} \u{441} ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{41C}\u{43E}\u{43B}\u{44F}, \u{432}\u{44A}\u{432}\u{435}\u{434}\u{435}\u{442}\u{435} \u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D} URL \u{430}\u{434}\u{440}\u{435}\u{441}.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u0418\u0437\u0431\u0440\u0430\u043D\u0430\u0442\u0430 \u0434\u0430\u0442\u0430 \u0435 \u043D\u0435\u0432\u0430\u043B\u0438\u0434\u043D\u0430."
};
var $a262a7e50e5a100c$var$bg = {
    ui: $a262a7e50e5a100c$var$ui3,
    validation: $a262a7e50e5a100c$var$validation3
};
var $a262a7e50e5a100c$var$ui4 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "Dodaj",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Ukloni",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Ukloni sve",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Na\u017Ealost, nisu sva polja ispravno popunjena.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Po\u0161alji",
    /**
   * Shown when no files are selected.
   */ noFiles: "Nije odabran nijedan fajl",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Pomjeri gore",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Pomjeri dole",
    /**
   * Shown when something is actively loading.
   */ isLoading: "U\u010Ditavanje...",
    /**
   * Shown when there is more to load.
   */ loadMore: "U\u010Ditaj vi\u0161e",
    /**
   * Show on buttons that navigate state forward
   */ next: "Sljede\u0107i",
    /**
   * Show on buttons that navigate state backward
   */ prev: "Prethodni",
    /**
   * Shown when adding all values.
   */ addAllValues: "Dodajte sve vrijednosti",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Dodajte odabrane vrijednosti",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Uklonite sve vrijednosti",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Uklonite odabrane vrijednosti",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Odaberite datum",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Promjenite datum",
    /**
   * Shown when there is something to close
   */ close: "Zatvori",
    /**
   * Shown when there is something to open.
   */ open: "Otvoreno"
};
var $a262a7e50e5a100c$var$validation4 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Molimo prihvatite ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti poslije ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti u budu\u{107}nosti.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17E}e sadr\u{17E}avati samo abecedne karaktere.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17E}e sadr\u{17E}avati samo slova i brojeve.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17E}e sadr\u{17E}avati samo slova i razmake.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati abecedne karaktere.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati slova ili brojeve.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati slova ili razmake.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati simbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati veliko slovo.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati malo slovo.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati brojeve.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti simbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17E}e sadr\u{17E}avati samo velika slova.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17E}e sadr\u{17E}avati samo mala slova.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti prije ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti u pro\u{161}losti.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Ovo polje je pogre\u{161}no konfigurirano i ne mo\u{17E}e se poslati.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti izme\u{111}u ${a} i ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne podudara se.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} nije ispravan datum, molimo koristite format ${args[0]}`;
        return "Ovo polje je pogre\u0161no konfigurirano i ne mo\u017Ee se poslati";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti izme\u{111}u ${$a262a7e50e5a100c$var$date(args[0])} i ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Molimo Vas da unesete validnu email adresu.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne zavr\u{161}ava sa ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nije dozvoljena vrijednost.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti najmanje jedan karakter.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti manje od ili jednako ${max} karaktera.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} treba imati ${max} karaktera.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti ve\u{107}i od ili jednak ${min} karaktera.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti izme\u{111}u ${min} i ${max} karaktera.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nije dozvoljena vrijednost.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Ne mo\u{17E}e imati vi\u{161}e od ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti manji ili jednak ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Nisu dozvoljeni formati datoteka.";
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti tipa: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Ne mo\u{17E}e imati manje od ${args[0]} ${name}.`;
        return `Mora biti barem ${args[0]} ${name} .`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} nije dozvoljeno ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti broj.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" ili ")} je obavezno.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} je obavezno.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne po\u{10D}inje sa ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Unesite va\u{17E}e\u{107}i link.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Odabrani datum je neva\u017Ee\u0107i."
};
var $a262a7e50e5a100c$var$bs = {
    ui: $a262a7e50e5a100c$var$ui4,
    validation: $a262a7e50e5a100c$var$validation4
};
var $a262a7e50e5a100c$var$ui5 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "Afegir",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Eliminar",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Eliminar tot",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Disculpi, no tots els camps estan omplerts correctament.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Enviar",
    /**
   * Shown when no files are selected.
   */ noFiles: "Cap fitxer triat",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Moure amunt",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Moure avall",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Carregant...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Carregar m\xe9s",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Seg\xfcent",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Anterior",
    /**
   * Shown when adding all values.
   */ addAllValues: "Afegir tots els valors",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Afegeix els valors seleccionats",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Eliminar tots els valors",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Elimina els valors seleccionats",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Trieu la data",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Canviar data",
    /**
   * Shown when there is something to close
   */ close: "Tancar",
    /**
   * Shown when there is something to open.
   */ open: "Obert"
};
var $a262a7e50e5a100c$var$validation5 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://docs.formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Si us plau accepti ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://docs.formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ha de ser posterior a ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de succe\xefr al futur.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://docs.formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nom\xe9s pot contenir car\xe0cters alfab\xe8tics.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://docs.formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nom\xe9s pot contenir lletres i n\xfameros.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://docs.formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nom\xe9s pot contenir lletres i espais.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de contenir car\xe0cters alfab\xe8tics.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de contenir lletres o n\xfameros.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de contenir lletres o espais.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de contenir s\xedmbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de contenir maj\xfascules.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de contenir min\xfascules.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de contenir n\xfameros.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de ser un s\xedmbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nom\xe9s pot contenir lletres maj\xfascules.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nom\xe9s pot contenir lletres min\xfascules.`;
    },
    /**
   * The date is not before
   * @see {@link https://docs.formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ha de ser anterior a ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ha d'estar al passat.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://docs.formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Aquest camp est\xe0 configurat incorrectament i no pot \xe9sser enviat.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} ha d'estar entre ${a} i ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://docs.formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} no concorda.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://docs.formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} no \xe9s una data v\xe0lida, si us plau empri el format ${args[0]}`;
        return "Aquest camp est\xe0 configurat incorrectament i no pot \xe9sser enviat";
    },
    /**
   * Is not within expected date range
   * @see {@link https://docs.formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ha d'estar entre ${$a262a7e50e5a100c$var$date(args[0])} i ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://docs.formkit.com/essentials/validation#email}
   */ email: `Si us plau, entri una adre\xe7a d'e-mail v\xe0lida.`,
    /**
   * Does not end with the specified value
   * @see {@link https://docs.formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} no acaba amb ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://docs.formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} no \xe9s un valor acceptat.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://docs.formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} ha de tenir com a m\xednim un car\xe0cter.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} ha de ser inferior o igual a ${max} car\xe0cters.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} ha de tenir una longitud de ${max} car\xe0cters.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} ha de ser major que o igual a ${min} car\xe0cters.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ha d'estar entre ${min} i ${max} car\xe0cters.`;
    },
    /**
   * Value is not a match
   * @see {@link https://docs.formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} no \xe9s un valor perm\xe8s.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://docs.formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `No pot tenir m\xe9s de ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de ser menys que o igual a ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://docs.formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "No hi ha cap format de fitxer acceptat.";
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de ser del tipus: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://docs.formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `No pot tenir menys de ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de ser com a m\xednim ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://docs.formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} no s'accepta com a ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://docs.formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ha de ser un n\xfamero.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" o ")} es requereix.`;
    },
    /**
   * Required field.
   * @see {@link https://docs.formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \xe9s obligatori.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://docs.formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} no comen\xe7a amb ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://docs.formkit.com/essentials/validation#url}
   */ url () {
        return `Si us plau inclogui una url v\xe0lida.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "La data seleccionada no \xe9s v\xe0lida."
};
var $a262a7e50e5a100c$var$ca = {
    ui: $a262a7e50e5a100c$var$ui5,
    validation: $a262a7e50e5a100c$var$validation5
};
var $a262a7e50e5a100c$var$ui6 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "P\u0159idat",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Odebrat",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Odebrat v\u0161e",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Pardon, ale ne v\u0161echna pole jsou vypln\u011Bna spr\xe1vn\u011B.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Odeslat",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u017D\xe1dn\xfd soubor nebyl vybr\xe1n",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Pohyb nahoru",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Posunout dol\u016F",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Na\u010D\xedt\xe1n\xed...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Na\u010D\xedst v\xedce",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Dal\u0161\xed",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "P\u0159edchoz\xed",
    /**
   * Shown when adding all values.
   */ addAllValues: "P\u0159idat v\u0161echny hodnoty",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "P\u0159id\xe1n\xed vybran\xfdch hodnot",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Odstra\u0148te v\u0161echny hodnoty",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Odstran\u011Bn\xed vybran\xfdch hodnot",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Zvolte datum",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Zm\u011Bnit datum",
    /**
   * Shown when there is something to close
   */ close: "Zav\u0159\xedt",
    /**
   * Shown when there is something to open.
   */ open: "Otev\u0159eno"
};
var $a262a7e50e5a100c$var$validation6 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Pros\xedm, za\u{161}krtn\u{11B}te ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed b\xfdt po ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed b\xfdt v budoucnosti.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\u{16F}\u{17E}e obsahovat pouze p\xedsmena.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\u{16F}\u{17E}e obsahovat pouze p\xedsmena a \u{10D}\xedsla.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahovat abecedn\xed znaky.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahovat p\xedsmena nebo \u{10D}\xedslice.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahovat p\xedsmena nebo mezery.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahovat symbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahovat velk\xe1 p\xedsmena.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahovat mal\xe1 p\xedsmena.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahovat \u{10D}\xedsla.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed b\xfdt symbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\u{16F}\u{17E}e obsahovat pouze velk\xe1 p\xedsmena.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\u{16F}\u{17E}e obsahovat pouze mal\xe1 p\xedsmena.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed b\xfdt p\u{159}ed ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed b\xfdt v minulosti.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Toto pole bylo \u{161}patn\u{11B} nakonfigurov\xe1no a nem\u{16F}\u{17E}e b\xfdt odesl\xe1no.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed b\xfdt mezi ${a} a ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nejsou shodn\xe1.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} nen\xed platn\xe9 datum, pros\xedm, pou\u{17E}ijte form\xe1t ${args[0]}`;
        return "Toto pole bylo \u0161patn\u011B nakonfigurov\xe1no a nem\u016F\u017Ee b\xfdt odesl\xe1no.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed b\xfdt mezi ${$a262a7e50e5a100c$var$date(args[0])} a ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Pros\xedm, zadejte platnou e-mailovou adresu.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nekon\u{10D}\xed na ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nen\xed povolen\xe1 hodnota.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed m\xedt nejm\xe9n\u{11B} jeden znak.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} m\u{16F}\u{17E}e m\xedt maxim\xe1ln\u{11B} ${max} znak\u{16F}.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} by m\u{11B}lo b\xfdt ${max} znak\u{16F} dlouh\xe9.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahovat minim\xe1ln\u{11B} ${min} znak\u{16F}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed b\xfdt dlouh\xe9 ${min} a\u{17E} ${max} znak\u{16F}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nen\xed povolen\xe1 hodnota.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Nelze pou\u{17E}\xedt v\xedce ne\u{17E} ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed m\xedt men\u{161}\xed nebo rovno ne\u{17E} ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Nejsou nakonfigurov\xe1ny povolen\xe9 typy soubor\u016F.";
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed b\xfdt typu: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Nelze m\xedt m\xe9n\u{11B} ne\u{17E} ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed b\xfdt minim\xe1ln\u{11B} ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} nen\xed dovolen\xe1 hodnota pro ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed b\xfdt \u{10D}\xedslo.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" nebo ")} je vy\u{17E}adov\xe1n.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} je povinn\xe9.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} neza\u{10D}\xedn\xe1 na ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Zadejte pros\xedm platnou adresu URL.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Vybran\xe9 datum je neplatn\xe9."
};
var $a262a7e50e5a100c$var$cs = {
    ui: $a262a7e50e5a100c$var$ui6,
    validation: $a262a7e50e5a100c$var$validation6
};
var $a262a7e50e5a100c$var$ui7 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Tilf\xf8j",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Fjern",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Fjern alle",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Alle felter er ikke korrekt udfyldt.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Send",
    /**
   * Shown when no files are selected.
   */ noFiles: "Ingen filer valgt",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Flyt op",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Flyt ned",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Indl\xe6ser...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Indl\xe6s mere",
    /**
   * Shown on buttons that navigate state forward
   */ next: "N\xe6ste",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Forrige",
    /**
   * Shown when adding all values.
   */ addAllValues: "Tilf\xf8j alle v\xe6rdier",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Tilf\xf8j valgte v\xe6rdier",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Fjern alle v\xe6rdier",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Fjern valgte v\xe6rdier",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "V\xe6lg dato",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Skift dato",
    /**
   * Shown when there is something to close
   */ close: "Luk",
    /**
   * Shown when there is something to open.
   */ open: "\xc5bn"
};
var $a262a7e50e5a100c$var$validation7 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Accepter venligst ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re senere end ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re i fremtiden.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan kun indeholde bogstaver.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan kun indeholde bogstaver og tal.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan kun indeholde bogstaver og mellemrum.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} skal indeholde alfabetiske tegn.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} skal indeholde bogstaver eller tal.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} skal indeholde bogstaver eller mellemrum.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} skal indeholde symbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} skal indeholde store bogstaver.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} skal indeholde sm\xe5 bogstaver.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} skal indeholde tal.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re et symbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan kun indeholde store bogstaver.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan kun indeholde sm\xe5 bogstaver.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re f\xf8r ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re f\xf8r i dag.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Dette felt er ikke konfigureret korrekt og kan derfor ikke blive sendt.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re mellem ${a} og ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} matcher ikke.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} er ikke gyldig, brug venligst formatet ${args[0]}`;
        return "Dette felt er ikke konfigureret korrekt og kan derfor ikke blive sendt.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re mellem ${$a262a7e50e5a100c$var$date(args[0])} og ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Indtast venligst en gyldig email-adresse.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} slutter ikke med ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} er ikke en gyldig v\xe6rdi.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re p\xe5 mindst \xe9t tegn.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re p\xe5 h\xf8jst ${max} tegn.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re ${max} tegn lange.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re p\xe5 mindst ${min} tegn.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re p\xe5 mindst ${min} og h\xf8jst ${max} tegn.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} er ikke en gyldig v\xe6rdi.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Kan ikke have flere end ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re mindre eller lig med ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Ingen filformater tilladt.";
        return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re af filtypen: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Kan ikke have mindre end ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re mindst ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} er ikke en tilladt ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re et tal.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" eller ")} er p\xe5kr\xe6vet.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} er p\xe5kr\xe6vet.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} starter ikke med ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Indtast en gyldig URL.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Den valgte dato er ugyldig."
};
var $a262a7e50e5a100c$var$da = {
    ui: $a262a7e50e5a100c$var$ui7,
    validation: $a262a7e50e5a100c$var$validation7
};
var $a262a7e50e5a100c$var$ui8 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Hinzuf\xfcgen",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Entfernen",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Alles entfernen",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Entschuldigung, nicht alle Felder wurden korrekt ausgef\xfcllt.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Senden",
    /**
   * Shown when no files are selected.
   */ noFiles: "Keine Datei ausgew\xe4hlt",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Gehe nach oben",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Gehen Sie nach unten",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Wird geladen...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Mehr laden",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Weiter",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Zur\xfcck",
    /**
   * Shown when adding all values.
   */ addAllValues: "Alle Werte hinzuf\xfcgen",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Ausgew\xe4hlte Werte hinzuf\xfcgen",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Alle Werte entfernen",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Ausgew\xe4hlte Werte entfernen",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Datum w\xe4hlen",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Datum \xe4ndern",
    /**
   * Shown when there is something to close
   */ close: "Schliessen",
    /**
   * Shown when there is something to open.
   */ open: "Offen"
};
var $a262a7e50e5a100c$var$validation8 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Bitte ${name} akzeptieren.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} muss nach dem ${$a262a7e50e5a100c$var$date(args[0])} liegen.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} muss in der Zukunft liegen.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} darf nur Buchstaben enthalten.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} darf nur Buchstaben und Zahlen enthalten.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} d\xfcrfen nur Buchstaben und Leerzeichen enthalten.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} muss alphabetische Zeichen enthalten.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} muss Buchstaben oder Zahlen enthalten.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} muss Buchstaben oder Leerzeichen enthalten.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} muss ein Symbol enthalten.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} muss Gro\xdfbuchstaben enthalten.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} muss Kleinbuchstaben enthalten.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} muss Zahlen enthalten.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} muss ein Symbol sein.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kann nur Gro\xdfbuchstaben enthalten.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kann nur Kleinbuchstaben enthalten.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} muss vor dem ${$a262a7e50e5a100c$var$date(args[0])} liegen.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} muss in der Vergangenheit liegen.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Dieses Feld wurde falsch konfiguriert und kann nicht \xfcbermittelt werden.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} muss zwischen ${args[0]} und ${args[1]} sein.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} stimmt nicht \xfcberein.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ist kein g\xfcltiges Datum im Format ${args[0]}.`;
        return "Dieses Feld wurde falsch konfiguriert und kann nicht \xfcbermittelt werden.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} muss zwischen ${$a262a7e50e5a100c$var$date(args[0])} und ${$a262a7e50e5a100c$var$date(args[1])} liegen.`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "E-Mail Adresse ist ung\xfcltig.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} endet nicht mit ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} enth\xe4lt einen ung\xfcltigen Wert.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = first <= second ? first : second;
        const max = second >= first ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} muss mindestens ein Zeichen enthalten.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} darf maximal ${max} Zeichen enthalten.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} sollte ${max} Zeichen lang sein.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} muss mindestens ${min} Zeichen enthalten.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} muss zwischen ${min} und ${max} Zeichen enthalten.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} enth\xe4lt einen ung\xfcltigen Wert.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Darf maximal ${args[0]} ${name} haben.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} darf maximal ${args[0]} sein.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Keine Dateiformate konfiguriert.";
        return `${$a262a7e50e5a100c$var$sentence(name)} muss vom Typ ${args[0]} sein.`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Mindestens ${args[0]} ${name} erforderlich.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} muss mindestens ${args[0]} sein.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} ist kein g\xfcltiger Wert f\xfcr ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} muss eine Zahl sein.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" oder ")} ist erforderlich.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ist erforderlich.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} beginnt nicht mit ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Bitte geben Sie eine g\xfcltige URL ein.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Das gew\xe4hlte Datum ist ung\xfcltig."
};
var $a262a7e50e5a100c$var$de = {
    ui: $a262a7e50e5a100c$var$ui8,
    validation: $a262a7e50e5a100c$var$validation8
};
var $a262a7e50e5a100c$var$ui9 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03CC\u03BB\u03C9\u03BD",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u039B\u03C5\u03C0\u03BF\u03CD\u03BC\u03B1\u03C3\u03C4\u03B5, \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03C0\u03B5\u03B4\u03AF\u03B1 \u03C0\u03BF\u03C5 \u03B4\u03B5\u03BD \u03AD\u03C7\u03BF\u03C5\u03BD \u03C3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03C9\u03B8\u03B5\u03AF \u03C3\u03C9\u03C3\u03C4\u03AC.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u039A\u03B1\u03BD\u03AD\u03BD\u03B1 \u03B1\u03C1\u03C7\u03B5\u03AF\u03BF \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03B5\u03AF",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u03A0\u03C1\u03BF\u03C2 \u03C4\u03B1 \u03B5\u03C0\u03AC\u03BD\u03C9",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u03A0\u03C1\u03BF\u03C2 \u03C4\u03B1 \u03BA\u03AC\u03C4\u03C9",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u03A6\u03BF\u03C1\u03C4\u03CE\u03BD\u03B5\u03B9...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03C9\u03BD",
    /**
   * Shown on buttons that navigate state forward
   */ next: "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03CC\u03BB\u03C9\u03BD \u03C4\u03C9\u03BD \u03C4\u03B9\u03BC\u03CE\u03BD",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03C9\u03BD \u03C4\u03B9\u03BC\u03CE\u03BD",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u039A\u03B1\u03C4\u03AC\u03C1\u03B3\u03B7\u03C3\u03B7 \u03CC\u03BB\u03C9\u03BD \u03C4\u03C9\u03BD \u03C4\u03B9\u03BC\u03CE\u03BD",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03C9\u03BD \u03C4\u03B9\u03BC\u03CE\u03BD",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1\u03C2",
    /**
   * Shown when there is something to close
   */ close: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF",
    /**
   * Shown when there is something to open.
   */ open: "\u0391\u03BD\u03BF\u03B9\u03C7\u03C4\u03CC"
};
var $a262a7e50e5a100c$var$validation9 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `\u{3A0}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3B1}\u{3BB}\u{3CE} \u{3B1}\u{3C0}\u{3BF}\u{3B4}\u{3B5}\u{3C7}\u{3C4}\u{3B5}\u{3AF}\u{3C4}\u{3B5} \u{3C4}\u{3BF} ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3BC}\u{3B5}\u{3C4}\u{3AC} \u{3C4}\u{3B7}\u{3C2} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3C3}\u{3C4}\u{3BF} \u{3BC}\u{3AD}\u{3BB}\u{3BB}\u{3BF}\u{3BD}.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3BC}\u{3C0}\u{3BF}\u{3C1}\u{3B5}\u{3AF} \u{3BD}\u{3B1} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3BC}\u{3CC}\u{3BD}\u{3BF} \u{3B1}\u{3BB}\u{3C6}\u{3B1}\u{3B2}\u{3B7}\u{3C4}\u{3B9}\u{3BA}\u{3BF}\u{3CD}\u{3C2} \u{3C7}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3C4}\u{3AE}\u{3C1}\u{3B5}\u{3C2}.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3BC}\u{3C0}\u{3BF}\u{3C1}\u{3B5}\u{3AF} \u{3BD}\u{3B1} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3BC}\u{3CC}\u{3BD}\u{3BF} \u{3B3}\u{3C1}\u{3AC}\u{3BC}\u{3BC}\u{3B1}\u{3C4}\u{3B1} \u{3BA}\u{3B1}\u{3B9} \u{3B1}\u{3C1}\u{3B9}\u{3B8}\u{3BC}\u{3BF}\u{3CD}\u{3C2}.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3BC}\u{3C0}\u{3BF}\u{3C1}\u{3B5}\u{3AF} \u{3BD}\u{3B1} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3BC}\u{3CC}\u{3BD}\u{3BF} \u{3B3}\u{3C1}\u{3AC}\u{3BC}\u{3BC}\u{3B1}\u{3C4}\u{3B1} \u{3BA}\u{3B1}\u{3B9} \u{3BA}\u{3B5}\u{3BD}\u{3AC}.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `\u{3A4}\u{3BF} ${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3B1}\u{3BB}\u{3C6}\u{3B1}\u{3B2}\u{3B7}\u{3C4}\u{3B9}\u{3BA}\u{3BF}\u{3CD}\u{3C2} \u{3C7}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3C4}\u{3AE}\u{3C1}\u{3B5}\u{3C2}.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `\u{3A4}\u{3BF} ${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3B3}\u{3C1}\u{3AC}\u{3BC}\u{3BC}\u{3B1}\u{3C4}\u{3B1} \u{3AE} \u{3B1}\u{3C1}\u{3B9}\u{3B8}\u{3BC}\u{3BF}\u{3CD}\u{3C2}.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3B3}\u{3C1}\u{3AC}\u{3BC}\u{3BC}\u{3B1}\u{3C4}\u{3B1} \u{3AE} \u{3BA}\u{3B5}\u{3BD}\u{3AC}.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `\u{3A4}\u{3BF} ${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3C4}\u{3BF} \u{3C3}\u{3CD}\u{3BC}\u{3B2}\u{3BF}\u{3BB}\u{3BF}.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `\u{3A4}\u{3BF} ${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3BA}\u{3B5}\u{3C6}\u{3B1}\u{3BB}\u{3B1}\u{3AF}\u{3B1} \u{3B3}\u{3C1}\u{3AC}\u{3BC}\u{3BC}\u{3B1}\u{3C4}\u{3B1}.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `\u{3A4}\u{3BF} ${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3C0}\u{3B5}\u{3B6}\u{3AC} \u{3B3}\u{3C1}\u{3AC}\u{3BC}\u{3BC}\u{3B1}\u{3C4}\u{3B1}.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `\u{3A4}\u{3BF} ${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3B1}\u{3C1}\u{3B9}\u{3B8}\u{3BC}\u{3BF}\u{3CD}\u{3C2}.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `\u{3A4}\u{3BF} ${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3AD}\u{3BD}\u{3B1} \u{3C3}\u{3CD}\u{3BC}\u{3B2}\u{3BF}\u{3BB}\u{3BF}.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `\u{3A4}\u{3BF} ${$a262a7e50e5a100c$var$sentence(name)} \u{3BC}\u{3C0}\u{3BF}\u{3C1}\u{3B5}\u{3AF} \u{3BD}\u{3B1} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3BC}\u{3CC}\u{3BD}\u{3BF} \u{3BA}\u{3B5}\u{3C6}\u{3B1}\u{3BB}\u{3B1}\u{3AF}\u{3B1} \u{3B3}\u{3C1}\u{3AC}\u{3BC}\u{3BC}\u{3B1}\u{3C4}\u{3B1}.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `\u{3A4}\u{3BF} ${$a262a7e50e5a100c$var$sentence(name)} \u{3BC}\u{3C0}\u{3BF}\u{3C1}\u{3B5}\u{3AF} \u{3BD}\u{3B1} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3BC}\u{3CC}\u{3BD}\u{3BF} \u{3C0}\u{3B5}\u{3B6}\u{3AC} \u{3B3}\u{3C1}\u{3AC}\u{3BC}\u{3BC}\u{3B1}\u{3C4}\u{3B1}.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3C0}\u{3C1}\u{3B9}\u{3BD} \u{3C4}\u{3B7}\u{3C2} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3C3}\u{3C4}\u{3BF} \u{3C0}\u{3B1}\u{3C1}\u{3B5}\u{3BB}\u{3B8}\u{3CC}\u{3BD}.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{391}\u{3C5}\u{3C4}\u{3CC} \u{3C4}\u{3BF} \u{3C0}\u{3B5}\u{3B4}\u{3AF}\u{3BF} \u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3C1}\u{3C5}\u{3B8}\u{3BC}\u{3B9}\u{3C3}\u{3C4}\u{3B5}\u{3AF} \u{3BB}\u{3B1}\u{3BD}\u{3B8}\u{3B1}\u{3C3}\u{3BC}\u{3AD}\u{3BD}\u{3B1} \u{3BA}\u{3B1}\u{3B9} \u{3B4}\u{3B5}\u{3BD} \u{3BC}\u{3C0}\u{3BF}\u{3C1}\u{3B5}\u{3AF} \u{3BD}\u{3B1} \u{3C5}\u{3C0}\u{3BF}\u{3B2}\u{3BB}\u{3B7}\u{3B8}\u{3B5}\u{3AF}.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3BE}\u{3CD} ${a} \u{3BA}\u{3B1}\u{3B9} ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3B4}\u{3B5}\u{3BD} \u{3C4}\u{3B1}\u{3B9}\u{3C1}\u{3B9}\u{3AC}\u{3B6}\u{3B5}\u{3B9}.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{3B4}\u{3B5}\u{3BD} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3AD}\u{3B3}\u{3C5}\u{3C1}\u{3B7} \u{3B7}\u{3BC}\u{3B5}\u{3C1}\u{3BF}\u{3BC}\u{3B7}\u{3BD}\u{3AF}\u{3B1}, \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3B1}\u{3BB}\u{3CE} \u{3B1}\u{3BA}\u{3BF}\u{3BB}\u{3BF}\u{3C5}\u{3B8}\u{3AE}\u{3C3}\u{3C4}\u{3B5} \u{3C4}\u{3B7}\u{3BD} \u{3B4}\u{3B9}\u{3B1}\u{3BC}\u{3CC}\u{3C1}\u{3C6}\u{3C9}\u{3C3}\u{3B7} ${args[0]}`;
        return "\u0391\u03C5\u03C4\u03CC \u03C4\u03BF \u03C0\u03B5\u03B4\u03AF\u03BF \u03AD\u03C7\u03B5\u03B9 \u03C1\u03C5\u03B8\u03BC\u03B9\u03C3\u03C4\u03B5\u03AF \u03BB\u03B1\u03BD\u03B8\u03B1\u03C3\u03BC\u03AD\u03BD\u03B1 \u03BA\u03B1\u03B9 \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C5\u03C0\u03BF\u03B2\u03BB\u03B7\u03B8\u03B5\u03AF";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3BE}\u{3CD} ${$a262a7e50e5a100c$var$date(args[0])} \u{3BA}\u{3B1}\u{3B9} ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 email \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7. ",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3B4}\u{3B5}\u{3BD} \u{3BA}\u{3B1}\u{3C4}\u{3B1}\u{3BB}\u{3AE}\u{3B3}\u{3B5}\u{3B9} \u{3BC}\u{3B5} ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3B4}\u{3B5}\u{3BD} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3BC}\u{3B9}\u{3B1} \u{3B5}\u{3C0}\u{3B9}\u{3C4}\u{3C1}\u{3B5}\u{3C0}\u{3C4}\u{3AE} \u{3C4}\u{3B9}\u{3BC}\u{3AE}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3C4}\u{3BF}\u{3C5}\u{3BB}\u{3AC}\u{3C7}\u{3B9}\u{3C3}\u{3C4}\u{3BF}\u{3BD} \u{3B5}\u{3BD}\u{3CC}\u{3C2} \u{3C7}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3C4}\u{3AE}\u{3C1}\u{3B1}.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3BB}\u{3B9}\u{3B3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3BF}\u{3B9} \u{3AE} \u{3AF}\u{3C3}\u{3BF}\u{3B9} \u{3BC}\u{3B5} ${max} \u{3C7}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3C4}\u{3AE}\u{3C1}\u{3B5}\u{3C2}.`;
        if (min === max) return `\u{3A4}\u{3BF} ${$a262a7e50e5a100c$var$sentence(name)} \u{3B8}\u{3B1} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3BC}\u{3AE}\u{3BA}\u{3BF}\u{3C2} ${max} \u{3C7}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3C4}\u{3AE}\u{3C1}\u{3B5}\u{3C2}.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3C0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3BF}\u{3B9} \u{3AE} \u{3AF}\u{3C3}\u{3BF}\u{3B9} \u{3BC}\u{3B5} ${min} \u{3C7}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3C4}\u{3AE}\u{3C1}\u{3B5}\u{3C2}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3BE}\u{3CD} ${min} \u{3BA}\u{3B1}\u{3B9} ${max} \u{3C7}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3C4}\u{3AE}\u{3C1}\u{3B5}\u{3C2}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3B4}\u{3B5}\u{3BD} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3BC}\u{3B9}\u{3B1} \u{3B5}\u{3C0}\u{3B9}\u{3C4}\u{3C1}\u{3B5}\u{3C0}\u{3C4}\u{3AE} \u{3C4}\u{3B9}\u{3BC}\u{3AE}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{394}\u{3B5}\u{3BD} \u{3BC}\u{3C0}\u{3BF}\u{3C1}\u{3B5}\u{3AF} \u{3BD}\u{3B1} \u{3AD}\u{3C7}\u{3B5}\u{3B9} \u{3C0}\u{3B1}\u{3C1}\u{3B1}\u{3C0}\u{3AC}\u{3BD}\u{3C9} \u{3B1}\u{3C0}\u{3CC} ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3B1}\u{3BD} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3BB}\u{3B9}\u{3B3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3BF} \u{3AE} \u{3AF}\u{3C3}\u{3BF} \u{3BC}\u{3B5} \u{3C4}\u{3BF} ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u0394\u03B5\u03BD \u03B5\u03C0\u03B9\u03C4\u03C1\u03AD\u03C0\u03BF\u03BD\u03C4\u03B1\u03B9 \u03B1\u03C1\u03C7\u03B5\u03AF\u03B1.";
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3C4}\u{3CD}\u{3C0}\u{3BF}\u{3C5}: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{394}\u{3B5}\u{3BD} \u{3BC}\u{3C0}\u{3BF}\u{3C1}\u{3B5}\u{3AF} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3BB}\u{3B9}\u{3B3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3BF} \u{3B1}\u{3C0}\u{3CC} ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3C4}\u{3BF}\u{3C5}\u{3BB}\u{3AC}\u{3C7}\u{3B9}\u{3C3}\u{3C4}\u{3BF}\u{3BD} ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} \u{3B4}\u{3B5}\u{3BD} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3BC}\u{3B9}\u{3B1} \u{3B5}\u{3C0}\u{3B9}\u{3C4}\u{3C1}\u{3B5}\u{3C0}\u{3C4}\u{3AE} ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3B1}\u{3C1}\u{3B9}\u{3B8}\u{3BC}\u{3CC}\u{3C2}.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" \u03AE ")} \u{3B1}\u{3C0}\u{3B1}\u{3B9}\u{3C4}\u{3B5}\u{3AF}\u{3C4}\u{3B1}\u{3B9}.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} \u{3C5}\u{3C0}\u{3BF}\u{3C7}\u{3C1}\u{3B5}\u{3C9}\u{3C4}\u{3B9}\u{3BA}\u{3CC}.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{3B4}\u{3B5}\u{3BD} \u{3B1}\u{3C1}\u{3C7}\u{3AF}\u{3B6}\u{3B5}\u{3B9} \u{3BC}\u{3B5} ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{3A0}\u{3B1}\u{3C1}\u{3B1}\u{3BA}\u{3B1}\u{3BB}\u{3CE} \u{3B5}\u{3B9}\u{3C3}\u{3AC}\u{3B3}\u{3B5}\u{3C4}\u{3B5} \u{3AD}\u{3BD}\u{3B1} \u{3AD}\u{3B3}\u{3BA}\u{3C5}\u{3C1}\u{3BF} URL.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u0397 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7."
};
var $a262a7e50e5a100c$var$el = {
    ui: $a262a7e50e5a100c$var$ui9,
    validation: $a262a7e50e5a100c$var$validation9
};
var $a262a7e50e5a100c$var$ui10 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "Add",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Remove",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Remove all",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Sorry, not all fields are filled out correctly.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Submit",
    /**
   * Shown when no files are selected.
   */ noFiles: "No file chosen",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Move up",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Move down",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Loading...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Load more",
    /**
   * Show on buttons that navigate state forward
   */ next: "Next",
    /**
   * Show on buttons that navigate state backward
   */ prev: "Previous",
    /**
   * Shown when adding all values.
   */ addAllValues: "Add all values",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Add selected values",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Remove all values",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Remove selected values",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Choose date",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Change date",
    /**
   * Shown above error summaries when someone attempts to submit a form with
   * errors and the developer has implemented `<FormKitSummary />`.
   */ summaryHeader: "There were errors in your form.",
    /*
   * Shown when there is something to close
   */ close: "Close",
    /**
   * Shown when there is something to open.
   */ open: "Open"
};
var $a262a7e50e5a100c$var$validation10 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Please accept the ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} must be after ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} must be in the future.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain alphabetical characters.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain letters and numbers.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain letters and spaces.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain alphabetical characters.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain letters or numbers.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain letters or spaces.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain a symbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain an uppercase letter.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain a lowercase letter.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain numbers.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must be a symbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain uppercase letters.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name, args: args }) {
        let postfix = "";
        if (Array.isArray(args) && args.length) {
            if (args[0] === "allow_non_alpha") postfix = ", numbers and symbols";
            if (args[0] === "allow_numeric") postfix = " and numbers";
            if (args[0] === "allow_numeric_dashes") postfix = ", numbers and dashes";
        }
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain lowercase letters${postfix}.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} must be before ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} must be in the past.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `This field was configured incorrectly and can\u{2019}t be submitted.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} must be between ${a} and ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} does not match.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} is not a valid date, please use the format ${args[0]}`;
        return "This field was configured incorrectly and can\u2019t be submitted";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must be between ${$a262a7e50e5a100c$var$date(args[0])} and ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Please enter a valid email address.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} doesn\u{2019}t end with ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} is not an allowed value.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} must be at least one character.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} must be less than or equal to ${max} characters.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} should be ${max} characters long.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} must be greater than or equal to ${min} characters.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} must be between ${min} and ${max} characters.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} is not an allowed value.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Cannot have more than ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} must be no more than ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "No file formats allowed.";
        return `${$a262a7e50e5a100c$var$sentence(name)} must be of the type: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Cannot have fewer than ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} must be at least ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} is not an allowed ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must be a number.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" or ")} is required.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} is required.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} doesn\u{2019}t start with ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Please enter a valid URL.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "The selected date is invalid."
};
var $a262a7e50e5a100c$var$en = {
    ui: $a262a7e50e5a100c$var$ui10,
    validation: $a262a7e50e5a100c$var$validation10
};
var $a262a7e50e5a100c$var$ui11 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "A\xf1adir",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Quitar",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Quitar todos",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Disc\xfalpe, los campos no fueron completados correctamente.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Enviar",
    /**
   * Shown when no files are selected.
   */ noFiles: "Archivo no seleccionado",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Moverse hacia arriba",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Moverse hacia abajo",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Cargando...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Cargar m\xe1s",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Pr\xf3ximo",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Anterior",
    /**
   * Shown when adding all values.
   */ addAllValues: "A\xf1adir todos los valores",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "A\xf1adir valores seleccionados",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Eliminar todos los valores",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Eliminar los valores seleccionados",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Elige fecha",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Cambiar fecha",
    /**
   * Shown when there is something to close
   */ close: "Cerrar",
    /**
   * Shown when there is something to open.
   */ open: "Abrir"
};
var $a262a7e50e5a100c$var$validation11 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Acepte el ${name} por favor.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} debe ser posterior a ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} debe ser una fecha futura.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe contener solo caract\xe9res alfab\xe9ticos.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe ser alfanum\xe9rico.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} espacios alfa solo pueden contener letras y espacios.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe contener caracteres alfab\xe9ticos.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe contener letras o n\xfameros.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe contener letras o espacios.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe contener un s\xedmbolo.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe estar en may\xfasculas.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe contener min\xfasculas.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe contener n\xfameros.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe ser un s\xedmbolo.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} solo puede contener letras may\xfasculas.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} solo puede contener letras min\xfasculas.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} debe ser anterior a ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} debe ser una fecha pasada.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `El campo no fue completado correctamente y no puede ser enviado.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} debe estar entre ${a} y ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} no coincide.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} no es una fecha v\xe1lida, por favor utilice el formato ${args[0]}`;
        return "El campo no fue completado correctamente y no puede ser enviado.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe estar entre ${$a262a7e50e5a100c$var$date(args[0])} y ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Ingrese una direcci\xf3n de correo electr\xf3nico v\xe1lida por favor.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} no termina con ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} no es un valor permitido.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} debe tener al menos una letra.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} debe tener como m\xe1ximo ${max} caract\xe9res.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} debe tener ${max} caracteres.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} debe tener como m\xednimo ${min} caract\xe9res.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} debe tener entre ${min} y ${max} caract\xe9res.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} no es un valor permitido.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `No puede tener m\xe1s de ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} debe ser menor o igual a ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "No existen formatos de archivos permitidos.";
        return `${$a262a7e50e5a100c$var$sentence(name)} debe ser del tipo: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `No puede tener menos de ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} debe ser de al menos ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} no es un valor permitido de ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe ser un n\xfamero.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" o ")} se requiere estar.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} es requerido.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} debe comenzar con ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Introduce una URL v\xe1lida.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "La fecha seleccionada no es v\xe1lida."
};
var $a262a7e50e5a100c$var$es = {
    ui: $a262a7e50e5a100c$var$ui11,
    validation: $a262a7e50e5a100c$var$validation11
};
var $a262a7e50e5a100c$var$ui12 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "\u0627\u0641\u0632\u0648\u062F\u0646",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u062D\u0630\u0641",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u0647\u0645\u0647 \u0631\u0627 \u062D\u0630\u0641 \u06A9\u0646\u06CC\u062F",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u0647\u0645\u0647 \u0641\u06CC\u0644\u062F\u0647\u0627 \u0628\u0647\u200C\u062F\u0631\u0633\u062A\u06CC \u067E\u0631 \u0646\u0634\u062F\u0647\u200C\u0627\u0646\u062F",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u062B\u0628\u062A",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u0647\u06CC\u0686 \u0641\u0627\u06CC\u0644\u06CC \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u062D\u0631\u06A9\u062A \u0628\u0647 \u0628\u0627\u0644\u0627",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u062D\u0631\u06A9\u062A \u0628\u0647 \u067E\u0627\u06CC\u06CC\u0646",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0628\u06CC\u0634\u062A\u0631",
    /**
   * Shown on buttons that navigate state forward
   */ next: "\u0628\u0639\u062F\u06CC",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\u0642\u0628\u0644\u06CC",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u062A\u0645\u0627\u0645 \u0645\u0642\u0627\u062F\u06CC\u0631 \u0631\u0627 \u0627\u0636\u0627\u0641\u0647 \u06A9\u0646\u06CC\u062F",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u0645\u0642\u0627\u062F\u06CC\u0631 \u0627\u0646\u062A\u062E\u0627\u0628 \u0634\u062F\u0647 \u0631\u0627 \u0627\u0636\u0627\u0641\u0647 \u06A9\u0646\u06CC\u062F",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u062A\u0645\u0627\u0645 \u0645\u0642\u0627\u062F\u06CC\u0631 \u0631\u0627 \u062D\u0630\u0641 \u06A9\u0646\u06CC\u062F",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u062D\u0630\u0641 \u0645\u0642\u0627\u062F\u06CC\u0631 \u0627\u0646\u062A\u062E\u0627\u0628 \u0634\u062F\u0647",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u062A\u063A\u06CC\u06CC\u0631 \u062A\u0627\u0631\u06CC\u062E",
    /**
   * Shown when there is something to close
   */ close: "\u0628\u0633\u062A\u0646",
    /**
   * Shown when there is something to open.
   */ open: "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646"
};
var $a262a7e50e5a100c$var$validation12 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `\u{644}\u{637}\u{641}\u{627}\u{64B} ${name} \u{631}\u{627} \u{628}\u{67E}\u{630}\u{6CC}\u{631}\u{6CC}\u{62F}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{639}\u{62F} \u{627}\u{632} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} ${$a262a7e50e5a100c$var$date(args[0])} \u{628}\u{627}\u{634}\u{62F}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{645}\u{631}\u{628}\u{648}\u{637} \u{628}\u{647} \u{622}\u{6CC}\u{646}\u{62F}\u{647} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{641}\u{642}\u{637} \u{645}\u{6CC}\u{62A}\u{648}\u{627}\u{646}\u{62F} \u{634}\u{627}\u{645}\u{644} \u{62D}\u{631}\u{648}\u{641} \u{627}\u{644}\u{641}\u{628}\u{627} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{641}\u{642}\u{637} \u{645}\u{6CC}\u{62A}\u{648}\u{627}\u{646}\u{62F} \u{634}\u{627}\u{645}\u{644} \u{62D}\u{631}\u{648}\u{641} \u{648} \u{627}\u{639}\u{62F}\u{627}\u{62F} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{641}\u{642}\u{637} \u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{634}\u{627}\u{645}\u{644} \u{62D}\u{631}\u{648}\u{641} \u{648} \u{641}\u{627}\u{635}\u{644}\u{647} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{62D}\u{627}\u{648}\u{6CC} \u{62D}\u{631}\u{648}\u{641} \u{627}\u{644}\u{641}\u{628}\u{627} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{62D}\u{627}\u{648}\u{6CC} \u{62D}\u{631}\u{648}\u{641} \u{6CC}\u{627} \u{627}\u{639}\u{62F}\u{627}\u{62F} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{62D}\u{627}\u{648}\u{6CC} \u{62D}\u{631}\u{648}\u{641} \u{6CC}\u{627} \u{641}\u{627}\u{635}\u{644}\u{647} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{62D}\u{627}\u{648}\u{6CC} \u{646}\u{645}\u{627}\u{62F} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{62F}\u{627}\u{631}\u{627}\u{6CC} \u{62D}\u{631}\u{648}\u{641} \u{628}\u{632}\u{631}\u{6AF} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{62D}\u{627}\u{648}\u{6CC} \u{62D}\u{631}\u{648}\u{641} \u{6A9}\u{648}\u{686}\u{6A9} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{62D}\u{627}\u{648}\u{6CC} \u{627}\u{639}\u{62F}\u{627}\u{62F} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{6CC}\u{6A9} \u{646}\u{645}\u{627}\u{62F} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{62A}\u{646}\u{647}\u{627} \u{645}\u{6CC}\u{200C}\u{62A}\u{648}\u{627}\u{646}\u{62F} \u{634}\u{627}\u{645}\u{644} \u{62D}\u{631}\u{648}\u{641} \u{628}\u{632}\u{631}\u{6AF} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{62A}\u{646}\u{647}\u{627} \u{645}\u{6CC}\u{200C}\u{62A}\u{648}\u{627}\u{646}\u{62F} \u{634}\u{627}\u{645}\u{644} \u{62D}\u{631}\u{648}\u{641} \u{6A9}\u{648}\u{686}\u{6A9} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{642}\u{628}\u{644} \u{627}\u{632} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} ${$a262a7e50e5a100c$var$date(args[0])} \u{628}\u{627}\u{634}\u{62F}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{645}\u{631}\u{628}\u{648}\u{637} \u{628}\u{647} \u{6AF}\u{630}\u{634}\u{62A}\u{647} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{627}\u{6CC}\u{646} \u{641}\u{6CC}\u{644}\u{62F} \u{628}\u{647} \u{627}\u{634}\u{62A}\u{628}\u{627}\u{647} \u{67E}\u{6CC}\u{6A9}\u{631}\u{628}\u{646}\u{62F}\u{6CC} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A} \u{648} \u{642}\u{627}\u{628}\u{644} \u{627}\u{631}\u{633}\u{627}\u{644} \u{646}\u{6CC}\u{633}\u{62A}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{6CC}\u{646} ${args[0]} \u{648} ${args[1]} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{645}\u{637}\u{627}\u{628}\u{642}\u{62A} \u{646}\u{62F}\u{627}\u{631}\u{62F}.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} \u{645}\u{639}\u{62A}\u{628}\u{631}\u{6CC} \u{646}\u{6CC}\u{633}\u{62A}\u{60C} \u{644}\u{637}\u{641}\u{627}\u{64B} \u{627}\u{632} \u{642}\u{627}\u{644}\u{628} ${args[0]} \u{627}\u{633}\u{62A}\u{641}\u{627}\u{62F}\u{647} \u{6A9}\u{646}\u{6CC}\u{62F}
`;
        return "\u0627\u06CC\u0646 \u0641\u06CC\u0644\u062F \u0628\u0647 \u0627\u0634\u062A\u0628\u0627\u0647 \u067E\u06CC\u06A9\u0631\u0628\u0646\u062F\u06CC \u0634\u062F\u0647 \u0627\u0633\u062A \u0648 \u0642\u0627\u0628\u0644 \u0627\u0631\u0633\u0627\u0644 \u0646\u06CC\u0633\u062A";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{6CC}\u{646} ${$a262a7e50e5a100c$var$date(args[0])} \u{648} ${$a262a7e50e5a100c$var$date(args[1])} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u0644\u0637\u0641\u0627 \u0622\u062F\u0631\u0633 \u0627\u06CC\u0645\u06CC\u0644 \u0645\u0639\u062A\u0628\u0631 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{647} ${$a262a7e50e5a100c$var$list(args)} \u{62E}\u{62A}\u{645} \u{634}\u{648}\u{62F}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{645}\u{62C}\u{627}\u{632} \u{646}\u{6CC}\u{633}\u{62A}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = first <= second ? first : second;
        const max = second >= first ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{62D}\u{62F}\u{627}\u{642}\u{644} \u{6CC}\u{6A9} \u{6A9}\u{627}\u{631}\u{627}\u{6A9}\u{62A}\u{631} \u{628}\u{627}\u{634}\u{62F}.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{6A9}\u{645}\u{62A}\u{631} \u{6CC}\u{627} \u{628}\u{631}\u{627}\u{628}\u{631} \u{628}\u{627} ${max} \u{6A9}\u{627}\u{631}\u{627}\u{6A9}\u{62A}\u{631} \u{628}\u{627}\u{634}\u{62F}.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} ${max} \u{6A9}\u{627}\u{631}\u{627}\u{6A9}\u{62A}\u{631} \u{637}\u{648}\u{644}\u{627}\u{646}\u{6CC} \u{628}\u{627}\u{634}\u{62F}.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{632}\u{631}\u{6AF}\u{62A}\u{631} \u{6CC}\u{627} \u{628}\u{631}\u{627}\u{628}\u{631} \u{628}\u{627} ${min} \u{6A9}\u{627}\u{631}\u{627}\u{6A9}\u{62A}\u{631} \u{628}\u{627}\u{634}\u{62F}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{6CC}\u{646} ${min} \u{648} ${max} \u{6A9}\u{627}\u{631}\u{627}\u{6A9}\u{62A}\u{631} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{645}\u{62C}\u{627}\u{632} \u{646}\u{6CC}\u{633}\u{62A}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{628}\u{6CC}\u{634} \u{627}\u{632} ${args[0]} \u{628}\u{627}\u{634}\u{62F}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{6A9}\u{645}\u{62A}\u{631} \u{6CC}\u{627} \u{628}\u{631}\u{627}\u{628}\u{631} \u{628}\u{627} ${args[0]} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u0641\u0631\u0645\u062A \u0641\u0627\u06CC\u0644 \u0645\u062C\u0627\u0632 \u0646\u06CC\u0633\u062A.";
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{627}\u{632} \u{627}\u{6CC}\u{646} \u{646}\u{648}\u{639} \u{628}\u{627}\u{634}\u{62F}: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name} \u{646}\u{645}\u{6CC} \u{62A}\u{648}\u{627}\u{646}\u{62F} \u{6A9}\u{645}\u{62A}\u{631} \u{627}\u{632} ${args[0]} \u{628}\u{627}\u{634}\u{62F}.
`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{62D}\u{62F}\u{627}\u{642}\u{644} ${args[0]} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `"${value}" \u{6CC}\u{6A9} ${name} \u{645}\u{62C}\u{627}\u{632} \u{646}\u{6CC}\u{633}\u{62A}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{639}\u{62F}\u{62F} \u{628}\u{627}\u{634}\u{62F}.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" \u06CC\u0627 ")} \u{645}\u{648}\u{631}\u{62F} \u{646}\u{6CC}\u{627}\u{632} \u{627}\u{633}\u{62A}.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `\u{67E}\u{631} \u{6A9}\u{631}\u{62F}\u{646} ${$a262a7e50e5a100c$var$sentence(name)} \u{627}\u{62C}\u{628}\u{627}\u{631}\u{6CC} \u{627}\u{633}\u{62A}.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{628}\u{627}\u{6CC}\u{62F} \u{628}\u{627} ${$a262a7e50e5a100c$var$list(args)} \u{634}\u{631}\u{648}\u{639} \u{634}\u{648}\u{62F}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{644}\u{637}\u{641}\u{627} \u{6CC}\u{6A9} URL \u{645}\u{639}\u{62A}\u{628}\u{631} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u062A\u0627\u0631\u06CC\u062E \u0627\u0646\u062A\u062E\u0627\u0628 \u0634\u062F\u0647 \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A"
};
var $a262a7e50e5a100c$var$fa = {
    ui: $a262a7e50e5a100c$var$ui12,
    validation: $a262a7e50e5a100c$var$validation12
};
var $a262a7e50e5a100c$var$ui13 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Lis\xe4\xe4",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Poista",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Poista kaikki",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Kaikkia kentti\xe4 ei ole t\xe4ytetty oikein.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Tallenna",
    /**
   * Shown when no files are selected.
   */ noFiles: "Ei valittuja tiedostoja",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Siirr\xe4 yl\xf6s",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Siirr\xe4 alas",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Ladataan...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Lataa lis\xe4\xe4",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Seuraava",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Edellinen",
    /**
   * Shown when adding all values.
   */ addAllValues: "Lis\xe4\xe4 kaikki arvot",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Lis\xe4\xe4 valitut arvot",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Poista kaikki arvot",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Poista valitut arvot",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Valitse p\xe4iv\xe4m\xe4\xe4r\xe4",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Vaihda p\xe4iv\xe4m\xe4\xe4r\xe4",
    /**
   * Shown when there is something to close
   */ close: "Sulje",
    /**
   * Shown when there is something to open.
   */ open: "Avoinna"
};
var $a262a7e50e5a100c$var$validation13 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Ole hyv\xe4 ja hyv\xe4ksy ${name}`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} tulee olla ${$a262a7e50e5a100c$var$date(args[0])} j\xe4lkeen.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} on oltava tulevaisuudessa.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} saa sis\xe4lt\xe4\xe4 vain kirjaimia.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} saa sis\xe4lt\xe4\xe4 vain kirjaimia ja numeroita.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} voivat sis\xe4lt\xe4\xe4 vain kirjaimia ja v\xe4lily\xf6ntej\xe4.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} on sis\xe4llett\xe4v\xe4 aakkoselliset merkit.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} t\xe4ytyy sis\xe4lt\xe4\xe4 kirjaimia tai numeroita.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} t\xe4ytyy sis\xe4lt\xe4\xe4 kirjaimia tai v\xe4lily\xf6ntej\xe4.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} t\xe4ytyy sis\xe4lt\xe4\xe4 symboli.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} t\xe4ytyy sis\xe4lt\xe4\xe4 isoja kirjaimia.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} t\xe4ytyy sis\xe4lt\xe4\xe4 pieni\xe4 kirjaimia.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} t\xe4ytyy sis\xe4lt\xe4\xe4 numeroita.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} on oltava symboli.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} voi sis\xe4lt\xe4\xe4 vain isoja kirjaimia.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} voi sis\xe4lt\xe4\xe4 vain pieni\xe4 kirjaimia.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} tulee olla ennen: ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} on oltava menneisyydess\xe4.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `T\xe4m\xe4 kentt\xe4 on t\xe4ytetty virheellisesti joten sit\xe4 ei voitu l\xe4hett\xe4\xe4.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} on oltava v\xe4lill\xe4 ${a} - ${b} `;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ei t\xe4sm\xe4\xe4.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ei ole validi p\xe4iv\xe4m\xe4\xe4r\xe4, ole hyv\xe4 ja sy\xf6t\xe4 muodossa: ${args[0]}`;
        return "T\xe4m\xe4 kentt\xe4 on t\xe4ytetty virheellisesti joten sit\xe4 ei voitu l\xe4hett\xe4\xe4.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} on oltava v\xe4lill\xe4 ${$a262a7e50e5a100c$var$date(args[0])} - ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Sy\xf6t\xe4 validi s\xe4hk\xf6postiosoite.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} tulee p\xe4\xe4tty\xe4 ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ei ole sallittu vaihtoehto.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} on oltava v\xe4hint\xe4\xe4n yksi merkki.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} on oltava ${max} tai alle merkki\xe4.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} pit\xe4isi olla ${max} merkki\xe4 pitk\xe4.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} on oltava v\xe4hint\xe4\xe4n ${min} merkki\xe4.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} on oltava v\xe4hint\xe4\xe4n ${min}, enint\xe4\xe4n ${max} merkki\xe4.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ei ole sallittu arvo.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Valitse enint\xe4\xe4n ${args[0]} ${name} vaihtoehtoa.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} on oltava ${args[0]} tai alle.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Tiedostoja ei sallita.";
        return `${$a262a7e50e5a100c$var$sentence(name)} tulee olla ${args[0]}-tiedostotyyppi\xe4.`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Valitse v\xe4hint\xe4\xe4n ${args[0]} ${name} vaihtoehtoa.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} tulee olla ${args[0]} tai suurempi.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} ei ole sallittu ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `Kent\xe4n ${$a262a7e50e5a100c$var$sentence(name)} tulee olla numero.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" tai ")} vaaditaan.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} vaaditaan.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} on alettava ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Anna kelvollinen URL-osoite.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Valittu p\xe4iv\xe4m\xe4\xe4r\xe4 on virheellinen."
};
var $a262a7e50e5a100c$var$fi = {
    ui: $a262a7e50e5a100c$var$ui13,
    validation: $a262a7e50e5a100c$var$validation13
};
var $a262a7e50e5a100c$var$ui14 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Ajouter",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Supprimer",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Enlever tout",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "D\xe9sol\xe9, tous les champs ne sont pas remplis correctement.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Valider",
    /**
   * Shown when no files are selected.
   */ noFiles: "Aucun fichier choisi",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "D\xe9placez-vous",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "D\xe9placez-vous",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Chargement...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Chargez plus",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Suivant",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Pr\xe9c\xe9dent",
    /**
   * Shown when adding all values.
   */ addAllValues: "Ajouter toutes les valeurs",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Ajouter les valeurs s\xe9lectionn\xe9es",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Supprimer toutes les valeurs",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Supprimer les valeurs s\xe9lectionn\xe9es",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Choisissez la date",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Modifier la date",
    /**
   * Shown when there is something to close
   */ close: "Fermer",
    /**
   * Shown when there is something to open.
   */ open: "Ouvrir"
};
var $a262a7e50e5a100c$var$validation14 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Veuillez accepter le ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre post\xe9rieure au ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre dans le futur.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne peut contenir que des caract\xe8res alphab\xe9tiques.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne peut contenir que des lettres et des chiffres.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne peuvent contenir que des lettres et des espaces.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} doit contenir des caract\xe8res alphab\xe9tiques.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} doit contenir au moins un lettre ou nombre.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} doit contenir des lettres ou des espaces.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} doit contenir un symbole.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} doit contenir au moins une majuscule.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} doit contenir au moins une minuscule.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} doit contenir des chiffres.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre un symbole.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne peuvent contenir que des majuscules.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne peut contenir que des lettres minuscules.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre ant\xe9rieure au ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre dans le pass\xe9.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Ce champ a \xe9t\xe9 configur\xe9 de mani\xe8re incorrecte et ne peut pas \xeatre soumis.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre comprise entre ${a} et ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne correspond pas.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} n'est pas une date valide, veuillez utiliser le format ${args[0]}`;
        return "Ce champ a \xe9t\xe9 configur\xe9 de mani\xe8re incorrecte et ne peut pas \xeatre soumis.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre comprise entre ${$a262a7e50e5a100c$var$date(args[0])} et ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Veuillez saisir une adresse email valide.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne se termine pas par ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} n'est pas une valeur autoris\xe9e.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} doit comporter au moins un caract\xe8re.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre inf\xe9rieur ou \xe9gal \xe0 ${max} caract\xe8res.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} doit contenir ${max} caract\xe8res.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre sup\xe9rieur ou \xe9gal \xe0 ${min} caract\xe8res.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre comprise entre ${min} et ${max} caract\xe8res.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} n'est pas une valeur autoris\xe9e.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Ne peut pas avoir plus de ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre inf\xe9rieur ou \xe9gal \xe0 ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Aucun format de fichier n\u2019est autoris\xe9";
        return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre du type: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Ne peut pas avoir moins de ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre au moins de ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} n'est pas un ${name} autoris\xe9.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} doit \xeatre un nombre.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" ou ")} est requis.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} est requis.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne commence pas par ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Entrez une URL valide.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: `La date s\xe9lectionn\xe9e n'est pas valide.`
};
var $a262a7e50e5a100c$var$fr = {
    ui: $a262a7e50e5a100c$var$ui14,
    validation: $a262a7e50e5a100c$var$validation14
};
var $a262a7e50e5a100c$var$ui15 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "Foeg ta",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Ferwider",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Ferwider alles",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Sorry, net alle fjilden binne korrekt ynfolle.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Ferstjoere",
    /**
   * Shown when no files are selected.
   */ noFiles: "Gjin best\xe2n keazen",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Gean omheech",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Nei \xfbnderen",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Lade\u2026",
    /**
   * Shown when there is more to load.
   */ loadMore: "Mear lade",
    /**
   * Show on buttons that navigate state forward
   */ next: "Folgende",
    /**
   * Show on buttons that navigate state backward
   */ prev: "Foarige",
    /**
   * Shown when adding all values.
   */ addAllValues: "Foegje alle wearden ta",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Foegje selektearre wearden ta",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Fuortsmite alle wearden",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Fuortsmite selektearre wearden",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Kies datum",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Feroarje datum"
};
var $a262a7e50e5a100c$var$validation15 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Akseptearje de ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} moat nei ${$a262a7e50e5a100c$var$date(args[0])} w\xeaze.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} moat yn de takomst lizze.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mei allinne alfabetyske tekens befetsje.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mei allinne letters en sifers befetsje.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mei allinne letters en spaasjes befetsje.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain alphabetical characters.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain letters and numbers.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain letters and spaces.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain symbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain uppercase.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain lowercase.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain number.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain symbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain uppercase.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain lowercase.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} moat foar ${$a262a7e50e5a100c$var$date(args[0])} falle.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} moat yn it ferline w\xeaze.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Dit fjild is ferkeard konfigurearre en kin net ferstjoerd wurde.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} moat tusken ${a} en ${b} lizze.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} komt net oerien.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} is gjin jildige datum, br\xfbk de notaasje ${args[0]}`;
        return "Dit fjild is ferkeard konfigurearre en kin net ferstjoerd wurde";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} moat tusken ${$a262a7e50e5a100c$var$date(args[0])} en ${$a262a7e50e5a100c$var$date(args[1])} lizze`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Folje in jildich e-mailadres yn.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} einiget net mei ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} is gjin tastiene wearde.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} moat minimaal ien teken w\xeaze.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} moat lytser w\xeaze as of gelyk w\xeaze oan ${max} tekens.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} moat ${max} tekens lang w\xeaze.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} moat grutter w\xeaze as of gelyk w\xeaze oan ${min} tekens.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} moat tusken de ${min} en ${max} tekens befetsje.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} is gjin tastiene wearde.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Mei net mear as ${args[0]} ${name} hawwe.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} moat lytser w\xeaze as of gelyk w\xeaze oan ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Gjin best\xe2nsnotaasjes tastien.";
        return `${$a262a7e50e5a100c$var$sentence(name)} moat fan it type: ${args[0]} w\xeaze`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Mei net minder as ${args[0]} ${name} hawwe.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} moat minimaal ${args[0]} w\xeaze.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `"${value}" is gjin tastiene ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} moat in getal w\xeaze.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" of ")} is ferplichte.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} is ferplicht.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} begjint net mei ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Doch der in jildige url by.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "De selektearre datum is \xfbnjildich."
};
var $a262a7e50e5a100c$var$fy = {
    ui: $a262a7e50e5a100c$var$ui15,
    validation: $a262a7e50e5a100c$var$validation15
};
var $a262a7e50e5a100c$var$ui16 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "\u05D4\u05D5\u05E1\u05E3",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u05DE\u05D7\u05E7",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u05DE\u05D7\u05E7 \u05D4\u05DB\u05DC",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u05E9\u05D9\u05DD \u05DC\u05D1, \u05DC\u05D0 \u05DB\u05DC \u05D4\u05E9\u05D3\u05D5\u05EA \u05DE\u05DC\u05D0\u05D9\u05DD \u05DB\u05E8\u05D0\u05D5\u05D9.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u05E9\u05DC\u05D7",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u05DC\u05D0 \u05E0\u05D1\u05D7\u05E8 \u05E7\u05D5\u05D1\u05E5..",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u05D4\u05D6\u05D6 \u05DC\u05DE\u05E2\u05DC\u05D4",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u05D4\u05D6\u05D6 \u05DC\u05DE\u05D8\u05D4",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u05D8\u05D5\u05E2\u05DF...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u05D8\u05E2\u05DF \u05D9\u05D5\u05EA\u05E8",
    /**
   * Shown on buttons that navigate state forward
   */ next: "\u05D4\u05D1\u05D0",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\u05D4\u05E7\u05D5\u05D3\u05DD",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u05D4\u05D5\u05E1\u05E3 \u05D0\u05EA \u05DB\u05DC \u05D4\u05E2\u05E8\u05DB\u05D9\u05DD",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u05D4\u05D5\u05E1\u05E4\u05EA \u05E2\u05E8\u05DB\u05D9\u05DD \u05E0\u05D1\u05D7\u05E8\u05D9\u05DD",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u05D4\u05E1\u05E8 \u05D0\u05EA \u05DB\u05DC \u05D4\u05E2\u05E8\u05DB\u05D9\u05DD",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u05D4\u05E1\u05E8 \u05E2\u05E8\u05DB\u05D9\u05DD \u05E0\u05D1\u05D7\u05E8\u05D9\u05DD",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u05D1\u05D7\u05E8 \u05EA\u05D0\u05E8\u05D9\u05DA",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u05E9\u05D9\u05E0\u05D5\u05D9 \u05EA\u05D0\u05E8\u05D9\u05DA",
    /**
   * Shown when there is something to close
   */ close: "\u05E1\u05D2\u05D5\u05E8",
    /**
   * Shown when there is something to open.
   */ open: "\u05E4\u05EA\u05D5\u05D7"
};
var $a262a7e50e5a100c$var$validation16 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `\u{5D0}\u{5E0}\u{5D0} \u{5D0}\u{5E9}\u{5E8} \u{5D0}\u{5EA} ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5D0}\u{5D7}\u{5E8}\u{5D9} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5D1}\u{5E2}\u{5EA}\u{5D9}\u{5D3}.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} \u{5D0}\u{5D5}\u{5EA}\u{5D9}\u{5D5}\u{5EA} \u{5D0}\u{5DC}\u{5E4}\u{5D1}\u{5EA}.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D9}\u{5DB}\u{5D5}\u{5DC} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} \u{5E8}\u{5E7} \u{5DE}\u{5E1}\u{5E4}\u{5E8}\u{5D9}\u{5DD} \u{5D5}\u{5D0}\u{5D5}\u{5EA}\u{5D9}\u{5D5}\u{5EA}.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D9}\u{5DB}\u{5D5}\u{5DC} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} \u{5E8}\u{5E7} \u{5D0}\u{5D5}\u{5EA}\u{5D9}\u{5D5}\u{5EA} \u{5D5}\u{5E8}\u{5D5}\u{5D5}\u{5D7}\u{5D9}\u{5DD}.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} \u{5EA}\u{5D5}\u{5D5}\u{5D9}\u{5DD} \u{5D0}\u{5DC}\u{5E4}\u{5D1}\u{5D9}\u{5EA}\u{5D9}\u{5D9}\u{5DD}.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} \u{5D0}\u{5D5}\u{5EA}\u{5D9}\u{5D5}\u{5EA} \u{5D0}\u{5D5} \u{5DE}\u{5E1}\u{5E4}\u{5E8}\u{5D9}\u{5DD}.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} \u{5D0}\u{5D5}\u{5EA}\u{5D9}\u{5D5}\u{5EA} \u{5D0}\u{5D5} \u{5E8}\u{5D5}\u{5D5}\u{5D7}\u{5D9}\u{5DD}.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} \u{5E1}\u{5DE}\u{5DC}.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} \u{5D0}\u{5D5}\u{5EA}\u{5D9}\u{5D5}\u{5EA} \u{5E8}\u{5D9}\u{5E9}\u{5D9}\u{5D5}\u{5EA}.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} \u{5D0}\u{5D5}\u{5EA}\u{5D9}\u{5D5}\u{5EA} \u{5E7}\u{5D8}\u{5E0}\u{5D5}\u{5EA}.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} \u{5DE}\u{5E1}\u{5E4}\u{5E8}\u{5D9}\u{5DD}.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5E1}\u{5DE}\u{5DC}.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D9}\u{5DB}\u{5D5}\u{5DC} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} \u{5D0}\u{5D5}\u{5EA}\u{5D9}\u{5D5}\u{5EA} \u{5E8}\u{5D9}\u{5E9}\u{5D9}\u{5D5}\u{5EA} \u{5D1}\u{5DC}\u{5D1}\u{5D3}.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D9}\u{5DB}\u{5D5}\u{5DC} \u{5DC}\u{5D4}\u{5DB}\u{5D9}\u{5DC} \u{5E8}\u{5E7} \u{5D0}\u{5D5}\u{5EA}\u{5D9}\u{5D5}\u{5EA} \u{5E7}\u{5D8}\u{5E0}\u{5D5}\u{5EA}.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5DC}\u{5E4}\u{5E0}\u{5D9} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5D1}\u{5E2}\u{5D1}\u{5E8}`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{5E9}\u{5D3}\u{5D4} \u{5D6}\u{5D4} \u{5DC}\u{5D0} \u{5D4}\u{5D5}\u{5D2}\u{5D3}\u{5E8} \u{5DB}\u{5E8}\u{5D0}\u{5D5}\u{5D9} \u{5D5}\u{5DC}\u{5D0} \u{5D9}\u{5DB}\u{5D5}\u{5DC} \u{5DC}\u{5D4}\u{5D9}\u{5E9}\u{5DC}\u{5D7}.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5D1}\u{5D9}\u{5DF} ${a} \u{5D5}- ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5DC}\u{5D0} \u{5DE}\u{5EA}\u{5D0}\u{5D9}\u{5DD}.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D4}\u{5D5}\u{5D0} \u{5DC}\u{5D0} \u{5EA}\u{5D0}\u{5E8}\u{5D9}\u{5DA} \u{5EA}\u{5E7}\u{5D9}\u{5DF}, \u{5D0}\u{5E0}\u{5D0} \u{5D4}\u{5E9}\u{5EA}\u{5DE}\u{5E9} \u{5D1}\u{5E4}\u{5D5}\u{5E8}\u{5DE}\u{5D8} ${args[0]}`;
        return "\u05E9\u05D3\u05D4 \u05D6\u05D4 \u05DC\u05D0 \u05D4\u05D5\u05D2\u05D3\u05E8 \u05DB\u05E8\u05D0\u05D5\u05D9 \u05D5\u05DC\u05D0 \u05D9\u05DB\u05D5\u05DC \u05DC\u05D4\u05D9\u05E9\u05DC\u05D7.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5D1}\u{5D9}\u{5DF} ${$a262a7e50e5a100c$var$date(args[0])} \u{5D5}- ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u05D0\u05E0\u05D0 \u05D4\u05E7\u05DC\u05D3 \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05EA\u05E7\u05D9\u05DF.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5DC}\u{5D0} \u{5DE}\u{5E1}\u{5EA}\u{5D9}\u{5D9}\u{5DD} \u{5D1}- ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D4}\u{5D5}\u{5D0} \u{5DC}\u{5D0} \u{5E2}\u{5E8}\u{5DA} \u{5DE}\u{5D5}\u{5E8}\u{5E9}\u{5D4}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5DC}\u{5E4}\u{5D7}\u{5D5}\u{5EA} \u{5EA}\u{5D5} \u{5D0}\u{5D7}\u{5D3}.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5E4}\u{5D7}\u{5D5}\u{5EA} \u{5D0}\u{5D5} \u{5E9}\u{5D5}\u{5D5}\u{5D4} \u{5DC}- ${max} \u{5EA}\u{5D5}\u{5D5}\u{5D9}\u{5DD}.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{5E6}\u{5E8}\u{5D9}\u{5DA} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${max} \u{5EA}\u{5D5}\u{5D5}\u{5D9}\u{5DD} \u{5D0}\u{5E8}\u{5D5}\u{5DB}\u{5D9}\u{5DD}.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5D2}\u{5D3}\u{5D5}\u{5DC} \u{5D0}\u{5D5} \u{5E9}\u{5D5}\u{5D5}\u{5D4} \u{5DC}- ${min} \u{5EA}\u{5D5}\u{5D5}\u{5D9}\u{5DD}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5D1}\u{5D9}\u{5DF} ${min} \u{5D5}- ${max} \u{5EA}\u{5D5}\u{5D5}\u{5D9}\u{5DD}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D4}\u{5D5}\u{5D0} \u{5DC}\u{5D0} \u{5E2}\u{5E8}\u{5DA} \u{5EA}\u{5E7}\u{5D9}\u{5DF}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name} \u{5DC}\u{5D0} \u{5D9}\u{5DB}\u{5D5}\u{5DC} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5E2}\u{5DD} \u{5D9}\u{5D5}\u{5EA}\u{5E8} \u{5DE}- ${args[0]}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5E4}\u{5D7}\u{5D5}\u{5EA} \u{5D0}\u{5D5} \u{5E9}\u{5D5}\u{5D5}\u{5D4} \u{5DC}- ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u05E4\u05D5\u05E8\u05DE\u05D8 \u05D4\u05E7\u05D5\u05D1\u05E5 \u05DC\u05D0 \u05DE\u05D5\u05E8\u05E9\u05D4.";
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5DE}\u{5E1}\u{5D5}\u{5D2}: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name} \u{5DC}\u{5D0} \u{5D9}\u{5DB}\u{5D5}\u{5DC} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5E2}\u{5DD} \u{5E4}\u{5D7}\u{5D5}\u{5EA} \u{5DE}- ${args[0]}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5DC}\u{5E4}\u{5D7}\u{5D5}\u{5EA} ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} \u{5DC}\u{5D0} \u{5DE}\u{5EA}\u{5D0}\u{5D9}\u{5DD} \u{5DC}- ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} \u{5DE}\u{5E1}\u{5E4}\u{5E8}.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" \u05D0\u05D5 ")} \u{5E0}\u{5D3}\u{5E8}\u{5E9}.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5D4}\u{5D9}\u{5E0}\u{5D5} \u{5D7}\u{5D5}\u{5D1}\u{5D4}.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5DC}\u{5D0} \u{5DE}\u{5EA}\u{5D7}\u{5D9}\u{5DC} \u{5D1}- ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{5D4}\u{5D6}\u{5DF} \u{5DB}\u{5EA}\u{5D5}\u{5D1}\u{5EA} URL \u{5D7}\u{5D5}\u{5E7}\u{5D9}\u{5EA}.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u05D4\u05EA\u05D0\u05E8\u05D9\u05DA \u05E9\u05E0\u05D1\u05D7\u05E8 \u05D0\u05D9\u05E0\u05D5 \u05D7\u05D5\u05E7\u05D9."
};
var $a262a7e50e5a100c$var$he = {
    ui: $a262a7e50e5a100c$var$ui16,
    validation: $a262a7e50e5a100c$var$validation16
};
var $a262a7e50e5a100c$var$ui17 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Dodaj",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Ukloni",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Pojedina polja nisu ispravno ispunjena.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Predaj",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Pomaknite se gore",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Pomakni se dolje",
    /**
   * Shown when something is actively loading.
   */ isLoading: "U\u010Ditavanje...",
    /**
   * Shown when there is more to load.
   */ loadMore: "U\u010Ditaj vi\u0161e",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Sljede\u0107i",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "prija\u0161nji",
    /**
   * Shown when adding all values.
   */ addAllValues: "Dodajte sve vrijednosti",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Dodavanje odabranih vrijednosti",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Ukloni sve vrijednosti",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Ukloni odabrane vrijednosti",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Odaberite datum",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Promijeni datum",
    /**
   * Shown when there is something to close
   */ close: "Zatvoriti",
    /**
   * Shown when there is something to open.
   */ open: "Otvori"
};
var $a262a7e50e5a100c$var$validation17 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Potrebno je potvrditi ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti u periodu poslije ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti u budu\u{107}nosti.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati samo slova.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati slova i brojeve.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mogu sadr\u{17E}avati samo slova i razmake..`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati abecedne znakove.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati slova ili brojeve.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati slova ili razmake.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati simbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati velika slova.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati mala slova.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati brojeve.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti simbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17E}e sadr\u{17E}avati samo velika slova.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17E}e sadr\u{17E}avati samo mala slova.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti prije ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti u pro\u{161}losti.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Format sadr\u{17E}aja nije ispravan i ne mo\u{17E}e biti predan.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti izme\u{111}u ${args[0]} i ${args[1]}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne odgovara zadanoj vrijednosti.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} nije ispravan format datuma. Molimo koristite sljede\u{107}i format: ${args[0]}`;
        return "Ovo polje nije ispravno postavljeno i ne mo\u017Ee biti predano.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti vrijednost izme\u{111}u ${$a262a7e50e5a100c$var$date(args[0])} i ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Molimo upi\u0161ite ispravnu email adresu.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne zavr\u{161}ava s ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nije dopu\u{161}tena vrijednost.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = first <= second ? first : second;
        const max = second >= first ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mora sadr\u{17E}avati barem jedan znak.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} mora imati ${max} ili manje znakova.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} trebao bi biti duga\u{10D}ak ${max} znakova.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mora imati barem ${min} znakova.`;
        return `Broj znakova za polje ${$a262a7e50e5a100c$var$sentence(name)} mora biti izme\u{111}u ${min} i ${max}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nije dozvoljena vrijednost.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Ne smije imati vi\u{161}e od ${args[0]} ${name} polja.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora imati vrijednost manju ili jednaku ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Format datoteke nije dozvoljen.";
        return `Format datoteke na polju ${$a262a7e50e5a100c$var$sentence(name)} mora odgovarati: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Broj upisanih vrijednosti na polju ${name} mora biti barem ${args[0]}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti barem ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} nije dozvoljena vrijednost na polju ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti broj.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" ili ")} je potreban.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} je obavezno.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne po\u{10D}inje s ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Unesite valjanu URL adresu.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Odabrani datum je neva\u017Ee\u0107i."
};
var $a262a7e50e5a100c$var$hr = {
    ui: $a262a7e50e5a100c$var$ui17,
    validation: $a262a7e50e5a100c$var$validation17
};
var $a262a7e50e5a100c$var$ui18 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "Hozz\xe1ad\xe1s",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Elt\xe1vol\xedt\xe1s",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\xd6sszes elt\xe1vol\xedt\xe1sa",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Sajn\xe1ljuk, nem minden mez\u0151 lett helyesen kit\xf6ltve.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Bek\xfcld\xe9s",
    /**
   * Shown when no files are selected.
   */ noFiles: "Nincs f\xe1jl kiv\xe1lasztva",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Mozg\xe1s felfel\xe9",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Mozg\xe1s lefel\xe9",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Bet\xf6lt\xe9s...",
    /**
   * Shown when there is more to load.
   */ loadMore: "T\xf6lts\xf6n be t\xf6bbet",
    /**
   * Shown on buttons that navigate state forward
   */ next: "K\xf6vetkez\u0151",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "El\u0151z\u0151",
    /**
   * Shown when adding all values.
   */ addAllValues: "Adja hozz\xe1 az \xf6sszes \xe9rt\xe9ket",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Kiv\xe1lasztott \xe9rt\xe9kek hozz\xe1ad\xe1sa",
    /**
   * Shown when removing all values.
   */ removeAllValues: "T\xe1vol\xedtsa el az \xf6sszes \xe9rt\xe9ket",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "A kiv\xe1lasztott \xe9rt\xe9kek elt\xe1vol\xedt\xe1sa",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "V\xe1lassza ki a d\xe1tumot",
    /**
   * Shown when there is a date to change.
   */ changeDate: "D\xe1tum m\xf3dos\xedt\xe1sa",
    /**
   * Shown when there is something to close
   */ close: "Bez\xe1r\xe1s",
    /**
   * Shown when there is something to open.
   */ open: "Nyitott"
};
var $a262a7e50e5a100c$var$validation18 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Fogadja el a ${name} mez\u{151}t.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mez\u{151}nek ${$a262a7e50e5a100c$var$date(args[0])} ut\xe1n kell lennie.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mez\u{151}nek a j\xf6v\u{151}ben kell lennie.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} csak alfanumerikus karaktereket tartalmazhat.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} csak bet\u{171}ket \xe9s sz\xe1mokat tartalmazhat.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} csak bet\u{171}ket \xe9s sz\xf3k\xf6z\xf6ket tartalmazhat.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `A ${$a262a7e50e5a100c$var$sentence(name)} bet\u{171}rendes karaktereket kell tartalmaznia.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `A ${$a262a7e50e5a100c$var$sentence(name)} bet\u{171}ket vagy sz\xe1mokat kell tartalmaznia.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `A ${$a262a7e50e5a100c$var$sentence(name)} bet\u{171}ket vagy sz\xf3k\xf6z\xf6ket kell tartalmaznia.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `A ${$a262a7e50e5a100c$var$sentence(name)} szimb\xf3lumot kell tartalmaznia.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `A ${$a262a7e50e5a100c$var$sentence(name)} nagybet\u{171}t kell tartalmaznia.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `A ${$a262a7e50e5a100c$var$sentence(name)} kisbet\u{171}t kell tartalmaznia.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `A ${$a262a7e50e5a100c$var$sentence(name)} sz\xe1mot kell tartalmaznia.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `A ${$a262a7e50e5a100c$var$sentence(name)} szimb\xf3lumnak kell lennie.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `A ${$a262a7e50e5a100c$var$sentence(name)} csak nagybet\u{171}ket tartalmazhat.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `A ${$a262a7e50e5a100c$var$sentence(name)} csak kisbet\u{171}ket tartalmazhat.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mez\u{151}nek ${$a262a7e50e5a100c$var$date(args[0])} el\u{151}tt kell lennie.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mez\u{151}nek a m\xfaltban kell lennie.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Ez a mez\u{151} hib\xe1san lett konfigur\xe1lva, \xedgy nem lehet bek\xfcldeni.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `A ${$a262a7e50e5a100c$var$sentence(name)} mez\u{151}nek ${a} \xe9s ${b} k\xf6z\xf6tt kell lennie.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nem egyezik.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} nem \xe9rv\xe9nyes d\xe1tum, ${args[0]} form\xe1tumot haszn\xe1lj`;
        return "Ez a mez\u0151 hib\xe1san lett konfigur\xe1lva, \xedgy nem lehet bek\xfcldeni.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mez\u{151}nek ${$a262a7e50e5a100c$var$date(args[0])} \xe9s ${args[1]} k\xf6z\xf6tt kell lennie`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "K\xe9rj\xfck, \xe9rv\xe9nyes email c\xedmet adjon meg.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mez\u{151} nem a kijel\xf6lt (${$a262a7e50e5a100c$var$list(args)}) m\xf3don \xe9r v\xe9get.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nem enged\xe9lyezett \xe9rt\xe9k.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mez\u{151}nek legal\xe1bb egy karakteresnek kell lennie.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} mez\u{151}nek maximum ${max} karakteresnek kell lennie.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} ${max} karakter hossz\xfanak kell lennie.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mez\u{151}nek minimum ${min} karakteresnek kell lennie.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mez\u{151}nek ${min} \xe9s ${max} karakter k\xf6z\xf6tt kell lennie.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nem enged\xe9lyezett \xe9rt\xe9k.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Nem lehet t\xf6bb mint ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} nem lehet nagyobb, mint ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Nincsenek t\xe1mogatott f\xe1jlform\xe1tumok.";
        return `${$a262a7e50e5a100c$var$sentence(name)}-nak/nek a k\xf6vetkez\u{151}nek kell lennie: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Nem lehet kevesebb, mint ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)}-nak/nek minimum ${args[0]}-nak/nek kell lennie.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `"${value}" nem enged\xe9lyezett ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mez\u{151}nek sz\xe1mnak kell lennie.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" vagy ")} sz\xfcks\xe9ges.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mez\u{151} k\xf6telez\u{151}.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nem a k\xf6vetkez\u{151}vel kezd\u{151}dik: ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `K\xe9rj\xfck, adjon meg egy \xe9rv\xe9nyes URL-t.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "A kiv\xe1lasztott d\xe1tum \xe9rv\xe9nytelen."
};
var $a262a7e50e5a100c$var$hu = {
    ui: $a262a7e50e5a100c$var$ui18,
    validation: $a262a7e50e5a100c$var$validation18
};
var $a262a7e50e5a100c$var$ui19 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Tambah",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Hapus",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Hapus semua",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Maaf, tidak semua bidang formulir terisi dengan benar",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Kirim",
    /**
   * Shown when no files are selected.
   */ noFiles: "Tidak ada file yang dipilih",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Pindah ke atas",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Pindah ke bawah",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Memuat...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Muat lebih",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Berikutnya",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Sebelumnya",
    /**
   * Shown when adding all values.
   */ addAllValues: "Tambahkan semua nilai",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Tambahkan nilai yang dipilih",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Hapus semua nilai",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Hapus nilai yang dipilih",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Pilih tanggal",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Ubah tanggal",
    /**
   * Shown when there is something to close
   */ close: "Tutup",
    /**
   * Shown when there is something to open.
   */ open: "Buka"
};
var $a262a7e50e5a100c$var$validation19 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Tolong terima kolom ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} nilainya harus lebih dari waktu ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} harus berisi waktu di masa depan.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} hanya bisa diisi huruf alfabet.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} hanya bisa diisi huruf dan angka.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} hanya boleh berisi huruf dan spasi..`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harus berisi karakter abjad.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harus mengandung huruf atau angka.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harus berisi huruf atau spasi.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harus berisi simbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harus berisi huruf besar.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harus berisi huruf kecil.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harus berisi angka.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harus berupa simbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} hanya dapat berisi huruf besar.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} hanya dapat berisi huruf kecil.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} nilainya harus kurang dari waktu ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} harus berisi waktu yang sudah lampau.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Kolom ini tidak diisi dengan benar sehingga tidak bisa dikirim`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} harus bernilai diantara ${a} dan ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nilainya tidak cocok.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} waktu tidak cocok, mohon gunakan format waktu ${args[0]}`;
        return "Kolom ini tidak diisi dengan benar sehingga tidak bisa dikirim";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harus diantara waktu ${$a262a7e50e5a100c$var$date(args[0])} dan waktu ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Tolong tulis alamat email yang benar.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nilainya tidak berakhiran dengan ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} adalah nilai yang tidak diizinkan.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} nilainya setidaknya berisi satu karakter.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} jumlah karakternya harus kurang dari atau sama dengan ${max} karakter.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} harus ${max} karakter panjang.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} jumlah karakternya harus lebih dari atau sama dengan ${min} karakter.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} jumlah karakternya hanya bisa antara ${min} dan ${max} karakter.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nilainya tidak diizinkan.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Tidak bisa memiliki lebih dari ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} harus lebih kecil atau sama dengan ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Format file tidak diizinkan";
        return `${$a262a7e50e5a100c$var$sentence(name)} hanya bisa bertipe: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Tidak boleh kurang dari ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} setidaknya harus berisi ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} adalah nilai yang tidak diperbolehkan untuk ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harus berupa angka.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" atau ")} diperlukan`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harus diisi.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} tidak dimulai dengan ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Harap masukkan URL yang valid.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Tanggal yang dipilih tidak valid."
};
var $a262a7e50e5a100c$var$id = {
    ui: $a262a7e50e5a100c$var$ui19,
    validation: $a262a7e50e5a100c$var$validation19
};
var $a262a7e50e5a100c$var$ui20 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "B\xe6ta vi\xf0",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Fjarl\xe6gja",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Fjarl\xe6gja allt",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\xdev\xed mi\xf0ur, \xfea\xf0 er ekki b\xfai\xf0 a\xf0 fylla r\xe9tt inn \xed alla reiti.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Senda",
    /**
   * Shown when no files are selected.
   */ noFiles: "Engin skr\xe1 valin",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "F\xe6ra upp",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "F\xe6ra ni\xf0ur",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Hle\xf0sla...",
    /**
   * Shown when there is more to load.
   */ loadMore: "S\xe6kja meira",
    /**
   * Show on buttons that navigate state forward
   */ next: "\xc1fram",
    /**
   * Show on buttons that navigate state backward
   */ prev: "Til baka",
    /**
   * Shown when adding all values.
   */ addAllValues: "B\xe6ta vi\xf0 \xf6llum gildum",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "B\xe6ta vi\xf0 v\xf6ldum gildum",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Fjarl\xe6gja \xf6ll gildi",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Fjarl\xe6gja valin gildi",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Velja dagsetningu",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Breyta dagsetningu",
    /**
   * Shown when there is something to close
   */ close: "Loka",
    /**
   * Shown when there is something to open.
   */ open: "Opi\xf0"
};
var $a262a7e50e5a100c$var$validation20 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Vinsamlegast sam\xfeykktu ${name}`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera eftir ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera \xed framt\xed\xf0inni.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe1 einungis innihalda b\xf3kstafi.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe1 einungis innihalda b\xf3kstafi og t\xf6lur.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe1 einungis innihalda b\xf3kstafi og bil.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ver\xf0ur a\xf0 innihalda b\xf3kstafi.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ver\xf0ur a\xf0 innihalda b\xf3kstafi e\xf0a t\xf6lur.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ver\xf0ur a\xf0 innihalda b\xf3kstafi e\xf0a bil.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ver\xf0ur a\xf0 innihalda t\xe1kn.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ver\xf0ur a\xf0 innihalda h\xe1staf.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ver\xf0ur a\xf0 innihalda l\xe1gstaf.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ver\xf0ur a\xf0 innihalda t\xf6lur.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ver\xf0ur a\xf0 vera t\xe1kn.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe1 einungis innihalda h\xe1stafi.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe1 einungis innihalda l\xe1gstafi.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera \xe1 undan ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera li\xf0in.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\xdeessi reitur var ekki r\xe9tt stilltur.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera \xe1 milli ${a} og ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} passar ekki.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} er ekki gild dagsetning, vinsamlegast hafi\xf0 dagsetninguna \xed formi ${args[0]}`;
        return "\xdeessi reitur var ekki r\xe9tt stilltur";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera \xe1 milli ${$a262a7e50e5a100c$var$date(args[0])} og ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Vinsamlegast sl\xe1\xf0u inn gilt netfang.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} endar ekki \xe1 ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} er ekki leyfilegt gildi.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera a\xf0 minnsta kosti einn stafur.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera f\xe6rri en e\xf0a n\xe1kv\xe6mlega ${max} stafir.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera ${max} stafir a\xf0 lengd.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera fleiri en e\xf0a n\xe1kv\xe6mlega ${min} stafir.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera \xe1 milli ${min} og ${max} stafir.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} er ekki leyfilegt gildi.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Ekki h\xe6gt a\xf0 hafa fleiri en ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera minna en e\xf0a n\xe1kv\xe6mlega ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Ekki leyfileg tegund skr\xe1ar.";
        return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera af tegundinni: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Ekki h\xe6gt a\xf0 hafa f\xe6rri en ${args[0]} ${name}.`;
        return `\xdearf a\xf0 vera a\xf0 minnsta kosti ${args[0]} ${name}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} er ekki leyfilegt fyrir ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \xfearf a\xf0 vera tala.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" or ")} is required.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} er skilyrt.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} byrjar ekki \xe1 ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Vinsamlegast sl\xe1\xf0u inn gilda sl\xf3\xf0.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Valin dagsetning er \xf3gild"
};
var $a262a7e50e5a100c$var$is = {
    ui: $a262a7e50e5a100c$var$ui20,
    validation: $a262a7e50e5a100c$var$validation20
};
var $a262a7e50e5a100c$var$ui21 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Inserisci",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Rimuovi",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Rimuovi tutti",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Ci dispiace, non tutti i campi sono compilati correttamente.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Invia",
    /**
   * Shown when no files are selected.
   */ noFiles: "Nessun file selezionato",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Sposta in alto",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Sposta gi\xf9",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Caricamento...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Carica altro",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Prossimo",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Precedente",
    /**
   * Shown when adding all values.
   */ addAllValues: "Aggiungi tutti i valori",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Aggiungi valori selezionati",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Rimuovi tutti i valori",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Rimuovi i valori selezionati",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Scegli la data",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Cambia data",
    /**
   * Shown when there is something to close
   */ close: "Chiudi",
    /**
   * Shown when there is something to open.
   */ open: "Aperta"
};
var $a262a7e50e5a100c$var$validation21 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Si prega di accettare ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `la data ${$a262a7e50e5a100c$var$sentence(name)} deve essere successiva ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `la data ${$a262a7e50e5a100c$var$sentence(name)} deve essere nel futuro.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} pu\xf2 contenere solo caratteri alfanumerici.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} pu\xf2 contenere solo lettere e numeri.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} pu\xf2 contenere solo lettere e spazi.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve contenere caratteri alfabetici.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve contenere lettere o numeri.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve contenere lettere o spazi.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve contenere un simbolo.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain uppercase.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve contenere lettere minuscole.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve contenere numeri.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve essere un simbolo.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} pu\xf2 contenere solo lettere maiuscole.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} pu\xf2 contenere solo lettere minuscole.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `la data ${$a262a7e50e5a100c$var$sentence(name)} deve essere antecedente ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} deve essere nel passato.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Questo campo \xe8 stato configurato male e non pu\xf2 essere inviato.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} deve essere tra ${a} e ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} non corrisponde.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} non \xe8 una data valida, per favore usa il formato ${args[0]}`;
        return "Questo campo \xe8 stato configurato in modo errato e non pu\xf2 essere inviato.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve essere tra ${$a262a7e50e5a100c$var$date(args[0])} e ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Per favore inserire un indirizzo email valido.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} non termina con ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} non \xe8 un valore consentito.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} deve contenere almeno un carattere.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} deve essere minore o uguale a ${max} caratteri.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} deve contenere ${max} caratteri.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} deve essere maggiore o uguale a ${min} caratteri.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} deve essere tra ${min} e ${max} caratteri.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} non \xe8 un valore consentito.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Non pu\xf2 avere pi\xf9 di ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} deve essere minore o uguale a ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Formato file non consentito.";
        return `${$a262a7e50e5a100c$var$sentence(name)} deve essere di tipo: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Non pu\xf2 avere meno di ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} deve essere almeno ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `"${value}" non \xe8 un ${name} consentito.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve essere un numero.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" o ")} \xe8 richiesto.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \xe8 richiesto.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} non inizia con ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Inserisci un URL valido.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "La data selezionata non \xe8 valida."
};
var $a262a7e50e5a100c$var$it = {
    ui: $a262a7e50e5a100c$var$ui21,
    validation: $a262a7e50e5a100c$var$validation21
};
var $a262a7e50e5a100c$var$ui22 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "\u8FFD\u52A0",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u524A\u9664",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u5168\u3066\u524A\u9664",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u9805\u76EE\u304C\u6B63\u3057\u304F\u5165\u529B\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u9001\u4FE1",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u30D5\u30A1\u30A4\u30EB\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u4E0A\u306B\u79FB\u52D5",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u4E0B\u3078\u79FB\u52D5",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u8AAD\u307F\u8FBC\u307F\u4E2D...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u3055\u3089\u306B\u8AAD\u307F\u8FBC\u3080",
    /**
   * Shown on buttons that navigate state forward
   */ next: "[\u6B21\u3078]",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\u524D\u3078",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u3059\u3079\u3066\u306E\u5024\u3092\u8FFD\u52A0",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u9078\u629E\u3057\u305F\u5024\u3092\u8FFD\u52A0",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u3059\u3079\u3066\u306E\u5024\u3092\u524A\u9664",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u9078\u629E\u3057\u305F\u5024\u3092\u524A\u9664",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u65E5\u4ED8\u3092\u9078\u629E",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u65E5\u4ED8\u3092\u5909\u66F4",
    /**
   * Shown when there is something to close
   */ close: "\u9589\u3058\u308B",
    /**
   * Shown when there is something to open.
   */ open: "[\u958B\u304F]"
};
var $a262a7e50e5a100c$var$validation22 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `${name}\u{306E}\u{540C}\u{610F}\u{304C}\u{5FC5}\u{8981}\u{3067}\u{3059}\u{3002}`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}${$a262a7e50e5a100c$var$date(args[0])}\u{3088}\u{308A}\u{5F8C}\u{306E}\u{65E5}\u{4ED8}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}\u{5C06}\u{6765}\u{306E}\u{65E5}\u{4ED8}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306B}\u{306F}\u{82F1}\u{5B57}\u{306E}\u{307F}\u{3092}\u{542B}\u{3081}\u{308B}\u{3053}\u{3068}\u{304C}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306B}\u{306F}\u{3001}\u{6587}\u{5B57}\u{3068}\u{6570}\u{5B57}\u{306E}\u{307F}\u{3092}\u{542B}\u{3081}\u{308B}\u{3053}\u{3068}\u{304C}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306B}\u{306F}\u{3001}\u{6587}\u{5B57}\u{3068}\u{30B9}\u{30DA}\u{30FC}\u{30B9}\u{306E}\u{307F}\u{3092}\u{542B}\u{3081}\u{308B}\u{3053}\u{3068}\u{304C}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{306B}\u{306F}\u{30A2}\u{30EB}\u{30D5}\u{30A1}\u{30D9}\u{30C3}\u{30C8}\u{6587}\u{5B57}\u{304C}\u{542B}\u{307E}\u{308C}\u{3066}\u{3044}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{306B}\u{306F}\u{6587}\u{5B57}\u{307E}\u{305F}\u{306F}\u{6570}\u{5B57}\u{3092}\u{542B}\u{3081}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{306B}\u{306F}\u{6587}\u{5B57}\u{307E}\u{305F}\u{306F}\u{30B9}\u{30DA}\u{30FC}\u{30B9}\u{3092}\u{542B}\u{3081}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{306B}\u{306F}\u{8A18}\u{53F7}\u{304C}\u{542B}\u{307E}\u{308C}\u{3066}\u{3044}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{306B}\u{306F}\u{5927}\u{6587}\u{5B57}\u{3092}\u{542B}\u{3081}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{306B}\u{306F}\u{5C0F}\u{6587}\u{5B57}\u{3092}\u{542B}\u{3081}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{306B}\u{306F}\u{6570}\u{5B57}\u{304C}\u{542B}\u{307E}\u{308C}\u{3066}\u{3044}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{306F}\u{30B7}\u{30F3}\u{30DC}\u{30EB}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{306B}\u{306F}\u{5927}\u{6587}\u{5B57}\u{3057}\u{304B}\u{4F7F}\u{7528}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{306B}\u{306F}\u{5C0F}\u{6587}\u{5B57}\u{3057}\u{304B}\u{4F7F}\u{7528}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}${$a262a7e50e5a100c$var$date(args[0])}\u{3088}\u{308A}\u{524D}\u{306E}\u{65E5}\u{4ED8}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}\u{904E}\u{53BB}\u{306E}\u{65E5}\u{4ED8}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{3053}\u{306E}\u{30D5}\u{30A3}\u{30FC}\u{30EB}\u{30C9}\u{306F}\u{6B63}\u{3057}\u{304F}\u{69CB}\u{6210}\u{3055}\u{308C}\u{3066}\u{3044}\u{306A}\u{3044}\u{305F}\u{3081}\u{3001}\u{9001}\u{4FE1}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}${a}\u{3068}${b}\u{306E}\u{9593}\u{306B}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{304C}\u{4E00}\u{81F4}\u{3057}\u{307E}\u{305B}\u{3093}\u{3002}`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}\u{6709}\u{52B9}\u{306A}\u{65E5}\u{4ED8}\u{3067}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}${args[0]}\u{306E}\u{5F62}\u{5F0F}\u{3092}\u{4F7F}\u{7528}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`;
        return "\u3053\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306F\u6B63\u3057\u304F\u69CB\u6210\u3055\u308C\u3066\u304A\u3089\u305A\u3001\u9001\u4FE1\u3067\u304D\u307E\u305B\u3093\u3002";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}${$a262a7e50e5a100c$var$date(args[0])}\u{3068}${$a262a7e50e5a100c$var$date(args[1])}\u{306E}\u{9593}\u{306B}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u6709\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}${$a262a7e50e5a100c$var$list(args)}\u{3067}\u{7D42}\u{308F}\u{3063}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}\u{8A31}\u{53EF}\u{3055}\u{308C}\u{305F}\u{5024}\u{3067}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}\u{5C11}\u{306A}\u{304F}\u{3068}\u{3082}1\u{6587}\u{5B57}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}${max}\u{6587}\u{5B57}\u{4EE5}\u{4E0B}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{306E}\u{9577}\u{3055}\u{306F} ${max} \u{6587}\u{5B57}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}${min}\u{6587}\u{5B57}\u{4EE5}\u{4E0A}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}${min}\u{304B}\u{3089}${max}\u{6587}\u{5B57}\u{306E}\u{9593}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}\u{8A31}\u{53EF}\u{3055}\u{308C}\u{305F}\u{5024}\u{3067}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name}\u{306F}${args[0]}\u{3092}\u{8D85}\u{3048}\u{308B}\u{3053}\u{3068}\u{306F}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`;
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}${args[0]}\u{4EE5}\u{4E0B}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u30D5\u30A1\u30A4\u30EB\u5F62\u5F0F\u306F\u8A31\u53EF\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002";
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}${args[0]}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name}\u{306F}${args[0]}\u{672A}\u{6E80}\u{306B}\u{3059}\u{308B}\u{3053}\u{3068}\u{306F}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}`;
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}\u{5C11}\u{306A}\u{304F}\u{3068}\u{3082}${args[0]}\u{3067}\u{3042}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D}\u{306F}\u{8A31}\u{53EF}\u{3055}\u{308C}\u{305F}${name}\u{3067}\u{306F}\u{3042}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}\u{6570}\u{5024}\u{3067}\u{306A}\u{3051}\u{308C}\u{3070}\u{306A}\u{308A}\u{307E}\u{305B}\u{3093}\u{3002}`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join("\u307E\u305F\u306F")}${labels}\u{304C}\u{5FC5}\u{8981}\u{3067}\u{3059}\u{3002}`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}\u{5FC5}\u{9808}\u{3067}\u{3059}\u{3002}`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{306F}${$a262a7e50e5a100c$var$list(args)}\u{3067}\u{59CB}\u{307E}\u{3063}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}\u{3002}`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{6709}\u{52B9}\u{306A} URL \u{3092}\u{5165}\u{529B}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u9078\u629E\u3057\u305F\u65E5\u4ED8\u306F\u7121\u52B9\u3067\u3059\u3002"
};
var $a262a7e50e5a100c$var$ja = {
    ui: $a262a7e50e5a100c$var$ui22,
    validation: $a262a7e50e5a100c$var$validation22
};
var $a262a7e50e5a100c$var$ui23 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "\u049B\u043E\u0441\u0443",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u0416\u043E\u044E",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u0411\u0430\u0440\u043B\u044B\u0493\u044B\u043D \u0436\u043E\u044E",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u041A\u0435\u0448\u0456\u0440\u0456\u04A3\u0456\u0437, \u0431\u0430\u0440\u043B\u044B\u049B \u04E9\u0440\u0456\u0441\u0442\u0435\u0440 \u0434\u04B1\u0440\u044B\u0441 \u0442\u043E\u043B\u0442\u044B\u0440\u044B\u043B\u043C\u0430\u0493\u0430\u043D.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u0416\u0456\u0431\u0435\u0440\u0443",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u0415\u0448\u0431\u0456\u0440 \u0444\u0430\u0439\u043B \u0442\u0430\u04A3\u0434\u0430\u043B\u043C\u0430\u0434\u044B",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u0416\u043E\u0493\u0430\u0440\u044B \u0436\u044B\u043B\u0436\u0443",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u0422\u04E9\u043C\u0435\u043D \u0436\u044B\u043B\u0436\u044B\u0442\u044B\u04A3\u044B\u0437",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u0416\u04AF\u043A\u0442\u0435\u0443...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u041A\u04E9\u0431\u0456\u0440\u0435\u043A \u0436\u04AF\u043A\u0442\u0435\u04A3\u0456\u0437",
    /**
   * Shown on buttons that navigate state forward
   */ next: "\u041A\u0435\u043B\u0435\u0441\u0456",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\u0410\u043B\u0434\u044B\u04A3\u0493\u044B",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u0411\u0430\u0440\u043B\u044B\u049B \u043C\u04D9\u043D\u0434\u0435\u0440\u0434\u0456 \u049B\u043E\u0441\u044B\u04A3\u044B\u0437",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u0422\u0430\u04A3\u0434\u0430\u043B\u0493\u0430\u043D \u043C\u04D9\u043D\u0434\u0435\u0440\u0434\u0456 \u049B\u043E\u0441\u044B\u04A3\u044B\u0437",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u0411\u0430\u0440\u043B\u044B\u049B \u043C\u04D9\u043D\u0434\u0435\u0440\u0434\u0456 \u0430\u043B\u044B\u043F \u0442\u0430\u0441\u0442\u0430\u04A3\u044B\u0437",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u0422\u0430\u04A3\u0434\u0430\u043B\u0493\u0430\u043D \u043C\u04D9\u043D\u0434\u0435\u0440\u0434\u0456 \u0430\u043B\u044B\u043F \u0442\u0430\u0441\u0442\u0430\u04A3\u044B\u0437",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u041A\u04AF\u043D\u0434\u0456 \u0442\u0430\u04A3\u0434\u0430\u04A3\u044B\u0437",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u04E8\u0437\u0433\u0435\u0440\u0442\u0443 \u043A\u04AF\u043D\u0456",
    /**
   * Shown when there is something to close
   */ close: "\u0416\u0430\u0431\u0443",
    /**
   * Shown when there is something to open.
   */ open: "\u0410\u0448\u044B\u049B"
};
var $a262a7e50e5a100c$var$validation23 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `\u{49B}\u{430}\u{431}\u{44B}\u{43B}\u{434}\u{430}\u{4A3}\u{44B}\u{437} ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{43A}\u{435}\u{439}\u{456}\u{43D} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{43B}\u{430}\u{448}\u{430}\u{49B}\u{442}\u{430} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{435}\u{43A} \u{430}\u{43B}\u{444}\u{430}\u{432}\u{438}\u{442}\u{442}\u{456}\u{43A} \u{442}\u{430}\u{4A3}\u{431}\u{430}\u{43B}\u{430}\u{440}\u{434}\u{44B} \u{49B}\u{430}\u{43C}\u{442}\u{443}\u{44B} \u{43C}\u{4AF}\u{43C}\u{43A}\u{456}\u{43D}.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{435}\u{43A} \u{4D9}\u{440}\u{456}\u{43F}\u{442}\u{435}\u{440} \u{43C}\u{435}\u{43D} \u{441}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{434}\u{430}\u{43D} \u{442}\u{4B1}\u{440}\u{443}\u{44B} \u{43C}\u{4AF}\u{43C}\u{43A}\u{456}\u{43D}.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{435}\u{43A} \u{4D9}\u{440}\u{456}\u{43F}\u{442}\u{435}\u{440} \u{43C}\u{435}\u{43D} \u{431}\u{43E}\u{441} \u{43E}\u{440}\u{44B}\u{43D}\u{434}\u{430}\u{440} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43C}\u{4AF}\u{43C}\u{43A}\u{456}\u{43D}.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{430}\u{43B}\u{444}\u{430}\u{432}\u{438}\u{442}\u{442}\u{456}\u{43A} \u{442}\u{430}\u{4A3}\u{431}\u{430}\u{43B}\u{430}\u{440}\u{434}\u{430}\u{43D} \u{442}\u{4B1}\u{440}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{49B}\u{4B1}\u{440}\u{430}\u{43C}\u{44B}\u{43D}\u{434}\u{430} \u{4D9}\u{440}\u{456}\u{43F}\u{442}\u{435}\u{440} \u{43D}\u{435}\u{43C}\u{435}\u{441}\u{435} \u{441}\u{430}\u{43D}\u{434}\u{430}\u{440} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{49B}\u{4B1}\u{440}\u{430}\u{43C}\u{44B}\u{43D}\u{434}\u{430} \u{4D9}\u{440}\u{456}\u{43F}\u{442}\u{435}\u{440} \u{43D}\u{435}\u{43C}\u{435}\u{441}\u{435} \u{431}\u{43E}\u{441} \u{43E}\u{440}\u{44B}\u{43D}\u{434}\u{430}\u{440} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{44B} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{49B}\u{4B1}\u{440}\u{430}\u{43C}\u{44B}\u{43D}\u{434}\u{430} \u{431}\u{430}\u{441} \u{4D9}\u{440}\u{456}\u{43F}\u{442}\u{435}\u{440} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43A}\u{456}\u{448}\u{456} \u{4D9}\u{440}\u{456}\u{43F} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{441}\u{430}\u{43D}\u{434}\u{430}\u{440}\u{434}\u{430}\u{43D} \u{442}\u{4B1}\u{440}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{44B} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{435}\u{43A} \u{431}\u{430}\u{441} \u{4D9}\u{440}\u{456}\u{43F}\u{442}\u{435}\u{440}\u{434}\u{435}\u{43D} \u{442}\u{4B1}\u{440}\u{443}\u{44B} \u{43C}\u{4AF}\u{43C}\u{43A}\u{456}\u{43D}.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{49B}\u{4B1}\u{440}\u{430}\u{43C}\u{44B}\u{43D}\u{434}\u{430} \u{442}\u{435}\u{43A} \u{43A}\u{456}\u{448}\u{456} \u{4D9}\u{440}\u{456}\u{43F}\u{442}\u{435}\u{440} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43C}\u{4AF}\u{43C}\u{43A}\u{456}\u{43D}.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{4B1}\u{440}\u{44B}\u{43D} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{4E9}\u{442}\u{43A}\u{435}\u{43D}\u{434}\u{435} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{411}\u{4B1}\u{43B} \u{4E9}\u{440}\u{456}\u{441} \u{49B}\u{430}\u{442}\u{435} \u{43A}\u{43E}\u{43D}\u{444}\u{438}\u{433}\u{443}\u{440}\u{430}\u{446}\u{438}\u{44F}\u{43B}\u{430}\u{43D}\u{493}\u{430}\u{43D} \u{436}\u{4D9}\u{43D}\u{435} \u{43E}\u{43D}\u{44B} \u{436}\u{456}\u{431}\u{435}\u{440}\u{443} \u{43C}\u{4AF}\u{43C}\u{43A}\u{456}\u{43D} \u{435}\u{43C}\u{435}\u{441}.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{430}\u{440}\u{430}\u{441}\u{44B}\u{43D}\u{434}\u{430} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A} ${a} \u{436}\u{4D9}\u{43D}\u{435} ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{441}\u{4D9}\u{439}\u{43A}\u{435}\u{441} \u{43A}\u{435}\u{43B}\u{43C}\u{435}\u{439}\u{434}\u{456}.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{436}\u{430}\u{440}\u{430}\u{43C}\u{434}\u{44B} \u{43A}\u{4AF}\u{43D} \u{435}\u{43C}\u{435}\u{441}, \u{43F}\u{456}\u{448}\u{456}\u{43C}\u{434}\u{456} \u{43F}\u{430}\u{439}\u{434}\u{430}\u{43B}\u{430}\u{43D}\u{44B}\u{4A3}\u{44B}\u{437} ${args[0]}`;
        return "\u0411\u04B1\u043B \u04E9\u0440\u0456\u0441 \u049B\u0430\u0442\u0435 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F\u043B\u0430\u043D\u0493\u0430\u043D \u0436\u04D9\u043D\u0435 \u043E\u043D\u044B \u0436\u0456\u0431\u0435\u0440\u0443 \u043C\u04AF\u043C\u043A\u0456\u043D \u0435\u043C\u0435\u0441";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{430}\u{440}\u{430}\u{441}\u{44B}\u{43D}\u{434}\u{430} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A} ${$a262a7e50e5a100c$var$date(args[0])} \u{436}\u{4D9}\u{43D}\u{435} ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u04E8\u0442\u0456\u043D\u0435\u043C\u0456\u0437 \u049B\u043E\u043B\u0434\u0430\u043D\u044B\u0441\u0442\u0430\u0493\u044B \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u0434\u044B \u043F\u043E\u0448\u0442\u0430 \u0430\u0434\u0440\u0435\u0441\u0456\u043D \u0435\u043D\u0433\u0456\u0437\u0456\u04A3\u0456\u0437.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} -\u{43C}\u{435}\u{43D} \u{431}\u{456}\u{442}\u{43F}\u{435}\u{439}\u{434}\u{456} ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{440}\u{4B1}\u{49B}\u{441}\u{430}\u{442} \u{435}\u{442}\u{456}\u{43B}\u{433}\u{435}\u{43D} \u{43C}\u{4D9}\u{43D} \u{435}\u{43C}\u{435}\u{441}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{43A}\u{435}\u{43C} \u{434}\u{435}\u{433}\u{435}\u{43D}\u{434}\u{435} \u{431}\u{456}\u{440} \u{442}\u{430}\u{4A3}\u{431}\u{430} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{43A}\u{435}\u{43C} \u{43D}\u{435}\u{43C}\u{435}\u{441}\u{435} \u{442}\u{435}\u{4A3} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A} ${max} \u{43A}\u{435}\u{439}\u{456}\u{43F}\u{43A}\u{435}\u{440}\u{43B}\u{435}\u{440}.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} ${max} \u{442}\u{430}\u{4A3}\u{431}\u{430}\u{43B}\u{430}\u{440}\u{44B} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{430}\u{440}\u{442}\u{44B}\u{49B} \u{43D}\u{435}\u{43C}\u{435}\u{441}\u{435} \u{442}\u{435}\u{4A3} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A} ${min} \u{43A}\u{435}\u{439}\u{456}\u{43F}\u{43A}\u{435}\u{440}\u{43B}\u{435}\u{440}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{430}\u{440}\u{430}\u{441}\u{44B}\u{43D}\u{434}\u{430} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A} ${min} \u{436}\u{4D9}\u{43D}\u{435} ${max} \u{43A}\u{435}\u{439}\u{456}\u{43F}\u{43A}\u{435}\u{440}\u{43B}\u{435}\u{440}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{440}\u{4B1}\u{49B}\u{441}\u{430}\u{442} \u{435}\u{442}\u{456}\u{43B}\u{433}\u{435}\u{43D} \u{43C}\u{4D9}\u{43D} \u{435}\u{43C}\u{435}\u{441}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{430}\u{440}\u{442}\u{44B}\u{49B} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43C}\u{4AF}\u{43C}\u{43A}\u{456}\u{43D} \u{435}\u{43C}\u{435}\u{441} ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43A}\u{435}\u{43C} \u{43D}\u{435}\u{43C}\u{435}\u{441}\u{435} \u{442}\u{435}\u{4A3} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A} ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u0424\u0430\u0439\u043B \u043F\u0456\u0448\u0456\u043C\u0434\u0435\u0440\u0456 \u0440\u04B1\u049B\u0441\u0430\u0442 \u0435\u0442\u0456\u043B\u043C\u0435\u0439\u0434\u0456.";
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{438}\u{43F}\u{442}\u{435} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{43A}\u{435}\u{43C} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43C}\u{4AF}\u{43C}\u{43A}\u{456}\u{43D} \u{435}\u{43C}\u{435}\u{441} ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43A}\u{435}\u{43C} \u{434}\u{435}\u{433}\u{435}\u{43D}\u{434}\u{435} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A} ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} \u{440}\u{4B1}\u{49B}\u{441}\u{430}\u{442} \u{435}\u{442}\u{456}\u{43B}\u{43C}\u{435}\u{439}\u{434}\u{456} ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{441}\u{430}\u{43D} \u{431}\u{43E}\u{43B}\u{443}\u{44B} \u{43A}\u{435}\u{440}\u{435}\u{43A}.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" \u043D\u0435 ")} \u{49B}\u{430}\u{436}\u{435}\u{442}.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{430}\u{43B}\u{430}\u{43F} \u{435}\u{442}\u{456}\u{43B}\u{435}\u{434}\u{456}.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} -\u{434}\u{435}\u{43D} \u{431}\u{430}\u{441}\u{442}\u{430}\u{43B}\u{43C}\u{430}\u{439}\u{434}\u{44B} ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{416}\u{430}\u{440}\u{430}\u{43C}\u{434}\u{44B} URL \u{43C}\u{435}\u{43A}\u{435}\u{43D}\u{436}\u{430}\u{439}\u{44B}\u{43D} \u{435}\u{43D}\u{433}\u{456}\u{437}\u{456}\u{4A3}\u{456}\u{437}.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u0422\u0430\u04A3\u0434\u0430\u043B\u0493\u0430\u043D \u043A\u04AF\u043D \u0436\u0430\u0440\u0430\u043C\u0441\u044B\u0437."
};
var $a262a7e50e5a100c$var$kk = {
    ui: $a262a7e50e5a100c$var$ui23,
    validation: $a262a7e50e5a100c$var$validation23
};
var $a262a7e50e5a100c$var$ui24 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "\uCD94\uAC00",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\uC81C\uAC70",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\uBAA8\uB450 \uC81C\uAC70",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\uBAA8\uB4E0 \uAC12\uC744 \uCC44\uC6CC\uC8FC\uC138\uC694",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\uC81C\uCD9C\uD558\uAE30",
    /**
   * Shown when no files are selected.
   */ noFiles: "\uC120\uD0DD\uB41C \uD30C\uC77C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\uC704\uB85C \uC774\uB3D9",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\uC544\uB798\uB85C \uC774\uB3D9",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\uB85C\uB4DC \uC911...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\uB354 \uBD88\uB7EC\uC624\uAE30",
    /**
   * Shown on buttons that navigate state forward
   */ next: "\uB2E4\uC74C",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\uC774\uC804",
    /**
   * Shown when adding all values.
   */ addAllValues: "\uBAA8\uB4E0 \uAC12 \uCD94\uAC00",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\uC120\uD0DD\uD55C \uAC12 \uCD94\uAC00",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\uBAA8\uB4E0 \uAC12 \uC81C\uAC70",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\uC120\uD0DD\uD55C \uAC12 \uC81C\uAC70",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\uB0A0\uC9DC \uC120\uD0DD",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\uB0A0\uC9DC \uBCC0\uACBD",
    /**
   * Shown when there is something to close
   */ close: "\uB2EB\uAE30",
    /**
   * Shown when there is something to open.
   */ open: "\uC5F4\uAE30"
};
var $a262a7e50e5a100c$var$validation24 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `${name} \u{C62C}\u{BC14}\u{B978} \u{AC12}\u{C744} \u{C120}\u{D0DD} \u{D574}\u{C8FC}\u{C138}\u{C694}`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$date(args[0])} \u{C774}\u{D6C4}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{BBF8}\u{B798}\u{C758} \u{B0A0}\u{C9DC}\u{C5EC}\u{C57C}\u{D569}\u{B2C8}\u{B2E4}`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{C54C}\u{D30C}\u{BCB3} \u{BB38}\u{C790}\u{B9CC} \u{D3EC}\u{D568}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{BB38}\u{C790}\u{C640} \u{C22B}\u{C790}\u{B9CC} \u{D3EC}\u{D568}\u{B420} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{BB38}\u{C790}\u{C640} \u{ACF5}\u{BC31}\u{B9CC} \u{D3EC}\u{D568}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{C5D0}\u{B294} \u{C54C}\u{D30C}\u{BCB3} \u{BB38}\u{C790}\u{AC00} \u{D3EC}\u{D568}\u{B418}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{C5D0}\u{B294} \u{BB38}\u{C790}\u{B098} \u{C22B}\u{C790}\u{AC00} \u{D3EC}\u{D568}\u{B418}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{C5D0}\u{B294} \u{BB38}\u{C790}\u{B098} \u{ACF5}\u{BC31}\u{C774} \u{D3EC}\u{D568}\u{B418}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{C5D0}\u{B294} \u{AE30}\u{D638}\u{B97C} \u{D3EC}\u{D568}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{B294} \u{B300}\u{BB38}\u{C790}\u{B97C} \u{D3EC}\u{D568}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{B294} \u{C18C}\u{BB38}\u{C790}\u{B97C} \u{D3EC}\u{D568}\u{D574}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{C5D0}\u{B294} \u{C22B}\u{C790}\u{AC00} \u{D3EC}\u{D568}\u{B418}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{B294} \u{AE30}\u{D638}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{B294} \u{B300}\u{BB38}\u{C790}\u{B9CC} \u{D3EC}\u{D568}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{B294} \u{C18C}\u{BB38}\u{C790}\u{B9CC} \u{D3EC}\u{D568}\u{D560} \u{C218} \u{C788}\u{C2B5}\u{B2C8}\u{B2E4}.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$date(args[0])} \u{C774}\u{C804}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{ACFC}\u{AC70}\u{C758} \u{B0A0}\u{C9DC}\u{C5EC}\u{C57C}\u{D569}\u{B2C8}\u{B2E4}`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{C798}\u{BABB}\u{B41C} \u{AD6C}\u{C131}\u{C73C}\u{B85C} \u{C81C}\u{CD9C}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} ${a}\u{C640} ${b} \u{C0AC}\u{C774}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{C77C}\u{CE58}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{C720}\u{D6A8}\u{D55C} \u{B0A0}\u{C9DC}\u{AC00} \u{C544}\u{B2D9}\u{B2C8}\u{B2E4}. ${args[0]}\u{ACFC} \u{AC19}\u{C740} \u{D615}\u{C2DD}\u{C744} \u{C0AC}\u{C6A9}\u{D574}\u{C8FC}\u{C138}\u{C694}`;
        return "\uC798\uBABB\uB41C \uAD6C\uC131\uC73C\uB85C \uC81C\uCD9C\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$date(args[0])}\u{C5D0}\u{C11C} ${$a262a7e50e5a100c$var$date(args[1])} \u{C0AC}\u{C774}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\uC62C\uBC14\uB978 \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$list(args)}\u{B85C} \u{B05D}\u{B098}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{D5C8}\u{C6A9}\u{B418}\u{B294} \u{AC12}\u{C774} \u{C544}\u{B2D9}\u{B2C8}\u{B2E4}`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{D558}\u{B098} \u{C774}\u{C0C1}\u{C758} \u{BB38}\u{C790}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} ${max}\u{C790} \u{C774}\u{D558}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{B294} ${max} \u{C790} \u{AE38}\u{C774}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} ${min} \u{BB38}\u{C790}\u{BCF4}\u{B2E4} \u{D06C}\u{AC70}\u{B098} \u{AC19}\u{C544}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ${min}\u{C5D0}\u{C11C} ${max}\u{C790} \u{C0AC}\u{C774}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{D5C8}\u{C6A9}\u{B418}\u{B294} \u{AC12}\u{C774} \u{C544}\u{B2D9}\u{B2C8}\u{B2E4}`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${args[0]} ${name} \u{CD08}\u{ACFC}\u{D560} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ${args[0]}\u{BCF4}\u{B2E4} \u{C791}\u{AC70}\u{B098} \u{AC19}\u{C544}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\uD30C\uC77C \uD615\uC2DD\uC774 \uD5C8\uC6A9\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4";
        return `${$a262a7e50e5a100c$var$sentence(name)} ${args[0]} \u{C720}\u{D615}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${args[0]} ${name}\u{BCF4}\u{B2E4} \u{C791}\u{C744} \u{C218} \u{C5C6}\u{C2B5}\u{B2C8}\u{B2E4}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ${args[0]} \u{C774}\u{C0C1}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `${value}" \u{D5C8}\u{C6A9}\u{B418}\u{C9C0} \u{C54A}\u{B294} ${name}\u{C785}\u{B2C8}\u{B2E4}`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{C22B}\u{C790}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" \uB610\uB294 ")}\u{AC00} \u{D544}\u{C694}\u{D569}\u{B2C8}\u{B2E4}.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{D544}\u{C218} \u{AC12}\u{C785}\u{B2C8}\u{B2E4}`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$list(args)}\u{B85C} \u{C2DC}\u{C791}\u{D558}\u{C9C0} \u{C54A}\u{C2B5}\u{B2C8}\u{B2E4}`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{C720}\u{D6A8}\u{D55C} URL\u{C744} \u{C785}\u{B825}\u{D558}\u{C2ED}\u{C2DC}\u{C624}.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\uC120\uD0DD\uD55C \uB0A0\uC9DC\uAC00 \uC798\uBABB\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
};
var $a262a7e50e5a100c$var$ko = {
    ui: $a262a7e50e5a100c$var$ui24,
    validation: $a262a7e50e5a100c$var$validation24
};
function $a262a7e50e5a100c$var$getByQuantity(quantity, vienetas, vienetai, vienetu) {
    const lastTwoDigits = quantity.toString().slice(-2);
    const parsedQuantity = parseInt(lastTwoDigits);
    if (parsedQuantity > 10 && parsedQuantity < 20 || parsedQuantity % 10 === 0) return vienetu;
    if (parsedQuantity === 1 || parsedQuantity % 10 === 1) return vienetas;
    return vienetai;
}
var $a262a7e50e5a100c$var$ui25 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "Prid\u0117ti",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Pa\u0161alinti",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Pa\u0161alinti visus",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Atsipra\u0161ome, ne visi laukai u\u017Epildyti teisingai.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Pateikti",
    /**
   * Shown when no files are selected.
   */ noFiles: "Nepasirinktas joks failas",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Auk\u0161tyn",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u017Demyn",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Kraunama...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Daugiau",
    /**
   * Show on buttons that navigate state forward
   */ next: "Kitas",
    /**
   * Show on buttons that navigate state backward
   */ prev: "Ankstesnis",
    /**
   * Shown when adding all values.
   */ addAllValues: "Prid\u0117ti visas reik\u0161mes",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Prid\u0117ti pasirinktas reik\u0161mes",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Pa\u0161alinti visas reik\u0161mes",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Pa\u0161alinti pasirinktas reik\u0161mes",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Pasirinkti dat\u0105",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Pakeisti dat\u0105",
    /**
   * Shown when there is something to close
   */ close: "U\u017Edaryti",
    /**
   * Shown when there is something to open.
   */ open: "Atidaryti"
};
var $a262a7e50e5a100c$var$validation25 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Pra\u{161}ome priimti ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti po ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti ateityje.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} gali b\u{16B}ti tik ab\u{117}c\u{117}l\u{117}s simboliai.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} gali b\u{16B}ti tik raid\u{117}s ir skai\u{10D}iai.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} gali b\u{16B}ti tik raid\u{117}s ir tarpai.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti ab\u{117}c\u{117}l\u{117}s simboli\u{173}.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti raid\u{17E}i\u{173} arba skai\u{10D}i\u{173}.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti raid\u{17E}i\u{173} arba tarp\u{173}.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti simboli\u{173}.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti did\u{17E}ioji raid\u{117}.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti ma\u{17E}oji raid\u{117}.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti skai\u{10D}i\u{173}.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti simbolis.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti tik did\u{17E}iosios raid\u{117}s.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti tik ma\u{17E}osios raid\u{117}s.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti prie\u{161} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti praeityje.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{160}is laukas buvo sukonfig\u{16B}ruotas neteisingai ir jo negalima pateikti.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti tarp ${a} ir ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nesutampa.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} n\u{117}ra tinkama data, naudokite format\u{105} ${args[0]}`;
        return "\u0160is laukas buvo sukonfig\u016Bruotas neteisingai ir jo negalima pateikti";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti tarp ${$a262a7e50e5a100c$var$date(args[0])} ir ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u012Eveskite teising\u0105 el. pa\u0161to adres\u0105.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nesibaigia su ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} n\u{117}ra leistina reik\u{161}m\u{117}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti bent vienas simbolis.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti ma\u{17E}iau arba lygiai ${max} ${$a262a7e50e5a100c$var$getByQuantity(max, "simbolis", "simboliai", "simboli\u0173")}.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti i\u{161} ${max} ${$a262a7e50e5a100c$var$getByQuantity(max, "simbolio", "simboli\u0173", "simboli\u0173")}.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti daugiau arba lygiai ${min} ${$a262a7e50e5a100c$var$getByQuantity(min, "simbolis", "simboliai", "simboli\u0173")}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti tarp ${min} ir ${max} simboli\u{173}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} n\u{117}ra leistina reik\u{161}m\u{117}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Negali tur\u{117}ti daugiau nei ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti ma\u{17E}iau arba lygiai ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Neleid\u017Eiami jokie fail\u0173 formatai.";
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti tokio tipo: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Negali tur\u{117}ti ma\u{17E}iau nei ${args[0]} ${name}.`;
        return `Turi b\u{16B}ti bent ${args[0]} ${name} .`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} n\u{117}ra leid\u{17E}iamas ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} turi b\u{16B}ti skai\u{10D}ius.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" arba ")} yra privaloma.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} yra privaloma.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} neprasideda su ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{12E}veskite teising\u{105} URL.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Pasirinkta data yra netinkama."
};
var $a262a7e50e5a100c$var$lt = {
    ui: $a262a7e50e5a100c$var$ui25,
    validation: $a262a7e50e5a100c$var$validation25
};
// packages/i18n/src/locales/lv.ts
var $a262a7e50e5a100c$var$ui26 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "Pievienot",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "No\u0146emt",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "No\u0146emt visus",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Piedodiet, visi lauki nav aizpild\u012Bti.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Iesniegt",
    /**
   * Shown when no files are selected.
   */ noFiles: "Nav izv\u0113l\u0113ts fails",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Uz aug\u0161u",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Uz leju",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Iel\u0101d\u0113jas...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Iel\u0101d\u0113t v\u0113l",
    /**
   * Show on buttons that navigate state forward
   */ next: "T\u0101l\u0101k",
    /**
   * Show on buttons that navigate state backward
   */ prev: "Atpaka\u013C",
    /**
   * Shown when adding all values.
   */ addAllValues: "Pievienot visas v\u0113rt\u012Bbas",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Pievienojiet izv\u0113l\u0113to v\u0113rt\u012Bbu",
    /**
   * Shown when removing all values.
   */ removeAllValues: "No\u0146emt visas v\u0113rt\u012Bbas",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "No\u0146emt izv\u0113l\u0113t\u0101s v\u0113rt\u012Bbas",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Izv\u0113lieties datumu",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Main\u012Bt datumu",
    /**
   * Shown when there is something to close
   */ close: "Aizv\u0113rt",
    /**
   * Shown when there is something to open.
   */ open: "Atv\u0113rt"
};
var $a262a7e50e5a100c$var$validation26 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `L\u{16B}dzu apstipriniet ${name}`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${name} j\u{101}b\u{16B}t p\u{113}c ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${name} j\u{101}b\u{16B}t p\u{113}c \u{161}odienas datuma.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${name} var satur\u{113}t tikai alfab\u{113}tisk\u{101}s rakstz\u{12B}mes.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${name} var satur\u{113}t tikai burtus un ciparus.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${name} var satur\u{113}t tikai burtus un atstarpes.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${name} j\u{101}b\u{16B}t pirms ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${name} j\u{101}b\u{16B}t pirms \u{161}odienas datuma.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{160}is lauks tika aizpild\u{12B}ts nepareizi un nevar tikt iesniegts.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${name} j\u{101}b\u{16B}t starp ${a} un ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${name} nesakr\u{12B}t.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${name} nav pareizs datums, l\u{16B}dzu lietojiet form\u{101}tu ${args[0]}`;
        return "\u0160is lauks tika aizpild\u012Bts nepareizi un nevar tikt iesniegts.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${name} j\u{101}b\u{16B}t starp ${$a262a7e50e5a100c$var$date(args[0])} un ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "L\u016Bdzu ierakstiet pareizu e-pasta adresi.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${name} nebeidzas ar ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${name} nav at\u{13C}auta v\u{113}rt\u{12B}ba.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${name} j\u{101}b\u{16B}t vismaz vienam simbolam.`;
        if (min == 0 && max) return `${name} j\u{101}b\u{16B}t maz\u{101}k par vai ${max} simboliem.`;
        if (min === max) return `${name} j\u{101}b\u{16B}t ${max} simbolu garum\u{101}.`;
        if (min && max === Infinity) return `${name} j\u{101}b\u{16B}t vismaz ${min} simboliem.`;
        return `${name} j\u{101}b\u{16B}t starp ${min} un ${max} simboliem.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${name} nav at\u{13C}auta v\u{113}rt\u{12B}ba.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Nevar b\u{16B}t vair\u{101}k par ${args[0]} ${name}.`;
        return `${name} nevar b\u{16B}t maz\u{101}k par ${args[0]} vai ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "At\u013Cauti nenoteikti faila form\u0101ti.";
        return `${$a262a7e50e5a100c$var$sentence(name)} faila form\u{101}ti var b\u{16B}t \u{161}\u{101}di: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Nevar b\u{16B}t maz\u{101}k par ${args[0]} ${name}.`;
        return `J\u{101}b\u{16B}t vismaz ${args[0]} ${name}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} nav at\u{13C}auta v\u{113}rt\u{12B}ba iek\u{161} ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${name} j\u{101}b\u{16B}t ciparam.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${name} ir oblig\u{101}ti j\u{101}aizpilda`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${name} nes\u{101}kas ar ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `L\u{16B}dzu pievienojiet pareizu URL.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Izv\u0113l\u0113tais datums ir nepareizs."
};
var $a262a7e50e5a100c$var$lv = {
    ui: $a262a7e50e5a100c$var$ui26,
    validation: $a262a7e50e5a100c$var$validation26
};
// packages/i18n/src/locales/mn.ts
var $a262a7e50e5a100c$var$ui27 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "\u041D\u044D\u043C\u044D\u0445",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u0425\u0430\u0441\u0430\u0445",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u0411\u04AF\u0433\u0434\u0438\u0439\u0433 \u0445\u0430\u0441\u0430\u0445",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u0423\u0443\u0447\u043B\u0440\u0430\u0430\u0440\u0430\u0439, \u0437\u0430\u0440\u0438\u043C \u043D\u04AF\u0434\u044D\u043D \u0434\u0430\u0445\u044C \u04E9\u0433\u04E9\u0433\u0434\u04E9\u043B \u0434\u0443\u0442\u0443\u0443 \u0431\u0430\u0439\u043D\u0430.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u0418\u043B\u0433\u044D\u044D\u0445",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u0424\u0430\u0439\u043B \u0441\u043E\u043D\u0433\u043E\u043E\u0433\u04AF\u0439 \u0431\u0430\u0439\u043D\u0430",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u0414\u044D\u044D\u0448\u044D\u044D",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u0414\u043E\u043E\u0448\u043E\u043E",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u0410\u0447\u0430\u0430\u043B\u043B\u0430\u0436 \u0431\u0430\u0439\u043D\u0430...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u041D\u044D\u043C\u0436 \u0430\u0447\u0430\u0430\u043B\u043B\u0430\u0445",
    /**
   * Show on buttons that navigate state forward
   */ next: "\u0414\u0430\u0440\u0430\u0430\u0433\u0438\u0439\u043D",
    /**
   * Show on buttons that navigate state backward
   */ prev: "\u04E8\u043C\u043D\u04E9\u0445",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u0411\u04AF\u0445 \u0443\u0442\u0433\u0443\u0443\u0434\u044B\u0433 \u043D\u044D\u043C\u044D\u0445",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u0421\u043E\u043D\u0433\u043E\u0433\u0434\u0441\u043E\u043D \u0443\u0442\u0433\u0443\u0443\u0434\u044B\u0433 \u043D\u044D\u043C\u044D\u0445",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u0411\u04AF\u0445 \u0443\u0442\u0433\u0443\u0443\u0434\u044B\u0433 \u0443\u0441\u0442\u0433\u0430\u0445",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u0421\u043E\u043D\u0433\u043E\u0433\u0434\u0441\u043E\u043D \u0443\u0442\u0433\u0443\u0443\u0434\u044B\u0433 \u0445\u0430\u0441\u0430\u0445",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u041E\u0433\u043D\u043E\u043E \u0441\u043E\u043D\u0433\u043E\u0445",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u041E\u0433\u043D\u043E\u043E \u04E9\u04E9\u0440\u0447\u043B\u04E9\u0445",
    /**
   * Shown when there is something to close
   */ close: "\u0425\u0430\u0430\u0445",
    /**
   * Shown when there is something to open.
   */ open: "\u041D\u044D\u044D\u043B\u0442\u0442\u044D\u0439"
};
var $a262a7e50e5a100c$var$validation27 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `${name} \u{443}\u{442}\u{433}\u{44B}\u{433} \u{437}\u{4E9}\u{432}\u{448}\u{4E9}\u{4E9}\u{440}\u{43D}\u{4E9} \u{4AF}\u{4AF}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{44C} ${$a262a7e50e5a100c$var$date(args[0])}-\u{43D}\u{44B} \u{434}\u{430}\u{440}\u{430}\u{430} \u{43E}\u{440}\u{43E}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{443}\u{442}\u{433}\u{430} \u{438}\u{440}\u{44D}\u{44D}\u{434}\u{4AF}\u{439}\u{433} \u{437}\u{430}\u{430}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{437}\u{4E9}\u{432}\u{445}\u{4E9}\u{43D} \u{4AF}\u{441}\u{44D}\u{433} \u{430}\u{433}\u{443}\u{443}\u{43B}\u{430}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{437}\u{4E9}\u{432}\u{445}\u{4E9}\u{43D} \u{4AF}\u{441}\u{44D}\u{433} \u{431}\u{43E}\u{43B}\u{43E}\u{43D} \u{442}\u{43E}\u{43E}\u{433} \u{430}\u{433}\u{443}\u{443}\u{43B}\u{430}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{437}\u{4E9}\u{432}\u{445}\u{4E9}\u{43D} \u{4AF}\u{441}\u{44D}\u{433} \u{431}\u{43E}\u{43B}\u{43E}\u{43D} \u{437}\u{430}\u{439} \u{430}\u{433}\u{443}\u{443}\u{43B}\u{430}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{44C} ${$a262a7e50e5a100c$var$date(args[0])}-\u{43D}\u{44B} \u{4E9}\u{43C}\u{43D}\u{4E9} \u{431}\u{430}\u{439}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{4E9}\u{43D}\u{433}\u{4E9}\u{440}\u{441}\u{4E9}\u{43D} \u{43E}\u{433}\u{43D}\u{43E}\u{43E} \u{431}\u{430}\u{439}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{42D}\u{43D}\u{44D} \u{43D}\u{4AF}\u{434}\u{44D}\u{43D} \u{434}\u{44D}\u{445}\u{44C} \u{4E9}\u{433}\u{4E9}\u{433}\u{434}\u{4E9}\u{43B} \u{431}\u{443}\u{440}\u{443}\u{443} \u{443}\u{447}\u{440}\u{430}\u{430}\u{441} \u{438}\u{43B}\u{433}\u{44D}\u{44D}\u{445} \u{431}\u{43E}\u{43B}\u{43E}\u{43C}\u{436}\u{433}\u{4AF}\u{439}.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{44C} \u{437}\u{430}\u{430}\u{432}\u{430}\u{43B} ${a}, ${b} \u{445}\u{43E}\u{451}\u{440}\u{44B}\u{43D} \u{434}\u{443}\u{43D}\u{434} \u{431}\u{430}\u{439}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{430}\u{430}\u{440}\u{430}\u{445}\u{433}\u{4AF}\u{439} \u{431}\u{430}\u{439}\u{43D}\u{430}.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{44C} \u{445}\u{4AF}\u{447}\u{438}\u{43D}\u{442}\u{44D}\u{439} \u{43E}\u{433}\u{43D}\u{43E}\u{43E} \u{431}\u{438}\u{448} \u{442}\u{443}\u{43B} ${args[0]} \u{433}\u{44D}\u{441}\u{44D}\u{43D} \u{43E}\u{433}\u{43D}\u{43E}\u{43E}\u{433} \u{430}\u{448}\u{438}\u{433}\u{43B}\u{430}\u{430}\u{440}\u{430}\u{439}.`;
        return "\u042D\u043D\u044D\u0445\u04AF\u04AF \u043D\u04AF\u0434 \u0431\u0443\u0440\u0443\u0443 \u0442\u0443\u043B \u0446\u0430\u0430\u0448 \u0438\u043B\u0433\u044D\u044D\u0445 \u0431\u043E\u043B\u043E\u043C\u0436\u0433\u04AF\u0439.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{44C} \u{437}\u{430}\u{430}\u{432}\u{430}\u{43B} ${$a262a7e50e5a100c$var$date(args[0])}, ${$a262a7e50e5a100c$var$date(args[1])} \u{445}\u{43E}\u{451}\u{440} \u{43E}\u{433}\u{43D}\u{43E}\u{43E}\u{43D} \u{434}\u{443}\u{43D}\u{434} \u{431}\u{430}\u{439}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u0422\u0430 \u0445\u04AF\u0447\u0438\u043D\u0442\u044D\u0439 \u0438\u043C\u0435\u0439\u043B \u0445\u0430\u044F\u0433\u0430\u0430 \u043E\u0440\u0443\u0443\u043B\u043D\u0430 \u0443\u0443.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{44C} ${$a262a7e50e5a100c$var$list(args)} \u{433}\u{44D}\u{441}\u{44D}\u{43D} \u{443}\u{442}\u{433}\u{430}\u{430}\u{440} \u{442}\u{4E9}\u{433}\u{441}\u{4E9}\u{4E9}\u{433}\u{4AF}\u{439} \u{431}\u{430}\u{439}\u{43D}\u{430}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{44C} \u{437}\u{4E9}\u{432}\u{448}\u{4E9}\u{4E9}\u{440}\u{4E9}\u{433}\u{434}\u{4E9}\u{445} \u{443}\u{442}\u{433}\u{430} \u{431}\u{438}\u{448}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{44D}\u{44D}\u{440} \u{445}\u{430}\u{44F}\u{436} \u{43D}\u{44D}\u{433} \u{4AF}\u{441}\u{44D}\u{433} \u{431}\u{430}\u{439}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)}-\u{43D} \u{443}\u{440}\u{442} \u{43D}\u{44C} ${max}-\u{44D}\u{44D}\u{441} \u{438}\u{445}\u{433}\u{4AF}\u{439} \u{431}\u{430}\u{439}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{44C} ${max} \u{443}\u{440}\u{442} \u{431}\u{430}\u{439}\u{432}\u{430}\u{43B} \u{437}\u{4AF}\u{433}\u{44D}\u{44D}\u{440}.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)}-\u{43D} \u{443}\u{440}\u{442} \u{43D}\u{44C} ${min}-\u{44D}\u{44D}\u{441} \u{438}\u{445} \u{431}\u{443}\u{44E}\u{443} \u{442}\u{44D}\u{43D}\u{446}\u{4AF}\u{4AF} \u{431}\u{430}\u{439}\u{436} \u{431}\u{43E}\u{43B}\u{43D}\u{43E}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)}-\u{43D} \u{443}\u{440}\u{442} \u{43D}\u{44C} ${min}, ${max} \u{445}\u{43E}\u{451}\u{440}\u{44B}\u{43D} \u{434}\u{443}\u{43D}\u{434} \u{431}\u{430}\u{439}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{44C} \u{437}\u{4E9}\u{432}\u{448}\u{4E9}\u{4E9}\u{440}\u{4E9}\u{433}\u{434}\u{4E9}\u{445} \u{443}\u{442}\u{433}\u{430} \u{431}\u{438}\u{448}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name} \u{43D}\u{44C} ${args[0]}-\u{430}\u{430}\u{441} \u{438}\u{445} \u{431}\u{430}\u{439}\u{436} \u{431}\u{43E}\u{43B}\u{43E}\u{445}\u{433}\u{4AF}\u{439}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{44C} ${args[0]}-\u{442}\u{430}\u{439} \u{442}\u{44D}\u{43D}\u{446}\u{4AF}\u{4AF} \u{44D}\u{441}\u{432}\u{44D}\u{43B} \u{431}\u{430}\u{433}\u{430} \u{431}\u{430}\u{439}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u0424\u0430\u0439\u043B\u044B\u043D \u0444\u043E\u0440\u043C\u0430\u0442 \u0431\u0443\u0440\u0443\u0443.";
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{442}\u{4E9}\u{440}\u{4E9}\u{43B} \u{43D}\u{44C} ${args[0]} \u{431}\u{430}\u{439}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name} \u{43D}\u{44C} ${args[0]}-\u{430}\u{430}\u{441} \u{438}\u{445} \u{431}\u{430}\u{439}\u{436} \u{431}\u{43E}\u{43B}\u{43E}\u{445}\u{433}\u{4AF}\u{439}.`;
        return `${name} \u{43D}\u{44C} \u{434}\u{43E}\u{440} \u{445}\u{430}\u{44F}\u{436} ${args[0]}-\u{442}\u{430}\u{439} \u{442}\u{44D}\u{43D}\u{446}\u{4AF}\u{4AF} \u{431}\u{430}\u{439}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} \u{431}\u{43E}\u{43B} \u{437}\u{4E9}\u{432}\u{448}\u{4E9}\u{4E9}\u{440}\u{4E9}\u{433}\u{434}\u{4E9}\u{445} ${name} \u{433}\u{44D}\u{441}\u{44D}\u{43D} \u{443}\u{442}\u{433}\u{430} \u{431}\u{438}\u{448}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{437}\u{4E9}\u{432}\u{445}\u{4E9}\u{43D} \u{442}\u{43E}\u{43E} \u{431}\u{430}\u{439}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{430}\u{439}\u{445} \u{451}\u{441}\u{442}\u{43E}\u{439}.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{44C} ${$a262a7e50e5a100c$var$list(args)}-\u{44D}\u{44D}\u{440} \u{44D}\u{445}\u{43B}\u{44D}\u{44D}\u{433}\u{4AF}\u{439} \u{431}\u{430}\u{439}\u{43D}\u{430}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{425}\u{4AF}\u{447}\u{43D}\u{43D}\u{442}\u{430}\u{439} URL \u{43E}\u{440}\u{443}\u{443}\u{43B}\u{43D}\u{430} \u{443}\u{443}.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u0421\u043E\u043D\u0433\u043E\u0441\u043E\u043D \u043E\u0433\u043D\u043E\u043E \u0431\u0443\u0440\u0443\u0443 \u0431\u0430\u0439\u043D\u0430."
};
var $a262a7e50e5a100c$var$mn = {
    ui: $a262a7e50e5a100c$var$ui27,
    validation: $a262a7e50e5a100c$var$validation27
};
var $a262a7e50e5a100c$var$ui28 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "Legg til",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Fjern",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Fjern alle",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Beklager, noen felter er ikke fylt ut korrekt.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Send inn",
    /**
   * Shown when no files are selected.
   */ noFiles: "Ingen fil valgt",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Flytt opp",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Flytt ned",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Laster...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Last mer",
    /**
   * Show on buttons that navigate state forward
   */ next: "Neste",
    /**
   * Show on buttons that navigate state backward
   */ prev: "Forrige",
    /**
   * Shown when adding all values.
   */ addAllValues: "Legg til alle verdier",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Legg til valgte verdier",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Fjern alle verdier",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Fjern valgte verdier",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Velg dato",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Endre dato"
};
var $a262a7e50e5a100c$var$validation28 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Vennligst aksepter ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 v\xe6re senere enn ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 v\xe6re i fremtiden.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan bare inneholde alfabetiske tegn.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan bare inneholde bokstaver og tall.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan bare inneholde bokstaver og mellomrom.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain alphabetical characters.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain letters and numbers.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain letters and spaces.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain symbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain uppercase.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain lowercase.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain number.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain symbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain uppercase.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain lowercase.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 v\xe6re tidligere enn ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 v\xe6re i fortiden.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Dette feltet er feilkonfigurert og kan ikke innsendes.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 v\xe6re mellom ${a} og ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} stemmer ikke overens.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} er ikke en gyldig dato, vennligst bruk formatet ${args[0]}`;
        return "Dette feltet er feilkonfigurert og kan ikke innsendes.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 v\xe6re mellom ${$a262a7e50e5a100c$var$date(args[0])} og ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Vennligst oppgi en gyldig epostadresse.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} slutter ikke med ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} er ikke en tillatt verdi.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 ha minst ett tegn.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 ha mindre enn eller n\xf8yaktig ${max} tegn.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} skal v\xe6re ${max} tegn langt.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 ha mer enn eller n\xf8yaktig ${min} tegn.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 ha mellom ${min} og ${max} tegn.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} er ikke en tillatt verdi.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Kan ikke ha mer enn ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 v\xe6re mindre enn eller n\xf8yaktig ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Ingen tillatte filformater.";
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 v\xe6re av typen: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Kan ikke ha mindre enn ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 v\xe6re minst ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} er ikke en tillatt ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5 v\xe6re et tall.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" eller ")} er n\xf8dvendig.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} er p\xe5krevd.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} starter ikke med ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Vennligst inkluder en gyldig url.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Den valgte datoen er ugyldig."
};
var $a262a7e50e5a100c$var$nb = {
    ui: $a262a7e50e5a100c$var$ui28,
    validation: $a262a7e50e5a100c$var$validation28
};
var $a262a7e50e5a100c$var$ui29 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Toevoegen",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Verwijderen",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Alles verwijderen",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Sorry, niet alle velden zijn correct ingevuld.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Versturen",
    /**
   * Shown when no files are selected.
   */ noFiles: "Geen bestand gekozen",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Naar boven gaan",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Naar beneden verplaatsen",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Aan het laden...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Meer laden",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Vervolgens",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Voorgaand",
    /**
   * Shown when adding all values.
   */ addAllValues: "Alle waarden toevoegen",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Geselecteerde waarden toevoegen",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Alle waarden verwijderen",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Geselecteerde waarden verwijderen",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Kies een datum",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Datum wijzigen",
    /**
   * Shown when there is something to close
   */ close: "Sluiten",
    /**
   * Shown when there is something to open.
   */ open: "Open"
};
var $a262a7e50e5a100c$var$validation29 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Accepteer de ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} moet na ${$a262a7e50e5a100c$var$date(args[0])} zijn.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} moet in de toekomst liggen.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mag alleen alfabetische tekens bevatten.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mag alleen letters en cijfers bevatten.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mag alleen letters en spaties bevatten.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} moet alfabetische tekens bevatten.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} moet letters of cijfers bevatten.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} moet letters of spaties bevatten.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} moet een symbool bevatten.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} moet hoofdletters bevatten.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} moet kleine letters bevatten.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} moet cijfers bevatten.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} moet een symbool zijn.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mag alleen hoofdletters bevatten.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mag alleen kleine letters bevatten.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} moet v\xf3\xf3r ${$a262a7e50e5a100c$var$date(args[0])} vallen.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} moet in het verleden liggen.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Dit veld is onjuist geconfigureerd en kan niet worden verzonden.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} moet tussen ${a} en ${b} liggen.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} komt niet overeen.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} is geen geldige datum, gebruik de notatie ${args[0]}`;
        return "Dit veld is onjuist geconfigureerd en kan niet worden verzonden";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} moet tussen ${$a262a7e50e5a100c$var$date(args[0])} en ${$a262a7e50e5a100c$var$date(args[1])} liggen`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Vul een geldig e-mailadres in.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} eindigt niet met ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} is geen toegestane waarde.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} moet minimaal \xe9\xe9n teken zijn.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} mag maximaal ${max} tekens lang zijn.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} moet ${max} tekens lang zijn.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} moet minimaal ${min} tekens lang zijn.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} moet tussen de ${min} en ${max} tekens zijn.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} is geen toegestane waarde.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Mag niet meer dan ${args[0]} ${name} hebben.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} moet kleiner zijn dan of gelijk zijn aan ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Geen bestandsformaten toegestaan.";
        return `${$a262a7e50e5a100c$var$sentence(name)} moet van het type: ${args[0]} zijn`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Mag niet minder dan ${args[0]} ${name} hebben.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} moet minimaal ${args[0]} zijn.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `"${value}" is geen toegestane ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} moet een getal zijn.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" of ")} is vereist.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} is verplicht.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} begint niet met ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Voer een geldige URL in.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "De geselecteerde datum is ongeldig."
};
var $a262a7e50e5a100c$var$nl = {
    ui: $a262a7e50e5a100c$var$ui29,
    validation: $a262a7e50e5a100c$var$validation29
};
var $a262a7e50e5a100c$var$ui30 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Dodaj",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Usu\u0144",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Usu\u0144 wszystko",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Nie wszystkie pola zosta\u0142y wype\u0142nione poprawnie.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Wy\u015Blij",
    /**
   * Shown when no files are selected.
   */ noFiles: "Nie wybrano pliku",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Przesu\u0144 w g\xf3r\u0119",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Przesu\u0144 w d\xf3\u0142",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u0141adowanie...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Za\u0142aduj wi\u0119cej",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Kolejny",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Poprzednia",
    /**
   * Shown when adding all values.
   */ addAllValues: "Dodaj wszystkie warto\u015Bci",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Dodaj wybrane warto\u015Bci",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Usu\u0144 wszystkie warto\u015Bci",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Usu\u0144 wybrane warto\u015Bci",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Wybierz dat\u0119",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Zmie\u0144 dat\u0119",
    /**
   * Shown when there is something to close
   */ close: "Zamknij",
    /**
   * Shown when there is something to open.
   */ open: "Otw\xf3rz"
};
var $a262a7e50e5a100c$var$validation30 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Prosz\u{119} zaakceptowa\u{107} ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} musi by\u{107} po ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} musi by\u{107} w przysz\u{142}o\u{15B}ci.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `Pole ${$a262a7e50e5a100c$var$sentence(name)} mo\u{17C}e zawiera\u{107} tylko znaki alfabetyczne.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `Pole ${$a262a7e50e5a100c$var$sentence(name)} mo\u{17C}e zawiera\u{107} tylko znaki alfanumeryczne.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `Pole ${$a262a7e50e5a100c$var$sentence(name)} mog\u{105} zawiera\u{107} tylko litery i spacje.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} musi zawiera\u{107} znaki alfabetyczne.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} musi zawiera\u{107} litery lub cyfry.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} musi zawiera\u{107} litery lub spacje.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} musi zawiera\u{107} symbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} musi zawiera\u{107} wielkie litery.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} musi zawiera\u{107} ma\u{142}e litery.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} musi zawiera\u{107} liczby.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} musi by\u{107} symbolem.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17C}e zawiera\u{107} tylko wielkie litery.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17C}e zawiera\u{107} tylko ma\u{142}e litery.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} musi by\u{107} przed ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} musi by\u{107} w przesz\u{142}o\u{15B}ci.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Pole zosta\u{142}o wype\u{142}nione niepoprawnie i nie mo\u{17C}e zosta\u{107} wys\u{142}ane.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `Warto\u{15B}\u{107} pola ${$a262a7e50e5a100c$var$sentence(name)} musi by\u{107} pomi\u{119}dzy ${a} i ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nie pokrywa si\u{119}.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `Warto\u{15B}\u{107} pola ${$a262a7e50e5a100c$var$sentence(name)} nie jest poprawn\u{105} dat\u{105}, prosz\u{119} u\u{17C}y\u{107} formatu ${args[0]}`;
        return "To pole zosta\u0142o wype\u0142nione niepoprawnie i nie mo\u017Ce zosta\u0107 wys\u0142ane";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `Data w polu ${$a262a7e50e5a100c$var$sentence(name)} musi by\u{107} pomi\u{119}dzy ${$a262a7e50e5a100c$var$date(args[0])} i ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Prosz\u0119 wpisa\u0107 poprawny adres email.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `Pole ${$a262a7e50e5a100c$var$sentence(name)} nie ko\u{144}czy si\u{119} na ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `Pole ${$a262a7e50e5a100c$var$sentence(name)} nie jest dozwolon\u{105} warto\u{15B}ci\u{105}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `Pole ${$a262a7e50e5a100c$var$sentence(name)} musi posiada\u{107} minimum jeden znak.`;
        if (min == 0 && max) return `Pole ${$a262a7e50e5a100c$var$sentence(name)} musi zawiera\u{107} ${max} lub mniej znak\xf3w.`;
        if (min && max === Infinity) return `Pole ${$a262a7e50e5a100c$var$sentence(name)} musi zawiera\u{107} ${min} lub wi\u{119}cej znak\xf3w.`;
        if (min === max) return `Pole ${$a262a7e50e5a100c$var$sentence(name)} musi mie\u{107} ${min} znak\xf3w.`;
        return `Pole ${$a262a7e50e5a100c$var$sentence(name)} musi mie\u{107} ${min}-${max} znak\xf3w.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `Pole ${$a262a7e50e5a100c$var$sentence(name)} zawiera niedozwolone znaki.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Nie mo\u{17C}na mie\u{107} wi\u{119}cej ni\u{17C} ${args[0]} ${name}.`;
        return `Warto\u{15B}\u{107} pola ${$a262a7e50e5a100c$var$sentence(name)} musi by\u{107} mniejsza lub r\xf3wna ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Nie podano dozwolonych typ\xf3w plik\xf3w.";
        return `${$a262a7e50e5a100c$var$sentence(name)} musi by\u{107} typem: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Musisz poda\u{107} wi\u{119}cej ni\u{17C} ${args[0]} ${name}.`;
        return ` Musisz poda\u{107} conajmniej ${args[0]} ${$a262a7e50e5a100c$var$sentence(name)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name }) {
        return `Warto\u{15B}\u{107} pola ${name} jest niedozwolona.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} musi by\u{107} numerem.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" lub ")} wymagany jest.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `Pole ${$a262a7e50e5a100c$var$sentence(name)} jest wymagane.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `Warto\u{15B}c pola ${$a262a7e50e5a100c$var$sentence(name)} nie zaczyna si\u{119} od ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Wprowad\u{17A} prawid\u{142}owy adres URL.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Wybrana data jest nieprawid\u0142owa."
};
var $a262a7e50e5a100c$var$pl = {
    ui: $a262a7e50e5a100c$var$ui30,
    validation: $a262a7e50e5a100c$var$validation30
};
var $a262a7e50e5a100c$var$ui31 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Incluir",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Remover",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Remover todos",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Desculpe, alguns campos n\xe3o foram preenchidos corretamente.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Enviar",
    /**
   * Shown when no files are selected.
   */ noFiles: "Nenhum arquivo selecionado.",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Mover para cima",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Mover para baixo",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Carregando...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Carregar mais",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Pr\xf3ximo",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Anterior",
    /**
   * Shown when adding all values.
   */ addAllValues: "Adicione todos os valores",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Adicionar valores selecionados",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Remover todos os valores",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Remover valores selecionados",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Escolha a data",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Data da altera\xe7\xe3o",
    /**
   * Shown when there is something to close
   */ close: "Fechar",
    /**
   * Shown when there is something to open.
   */ open: "Aberto"
};
var $a262a7e50e5a100c$var$validation31 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Por favor aceite o ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} precisa ser depois de ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} precisa ser no futuro.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} precisa conter apenas letras.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} pode conter apenas letras e n\xfameros.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} pode conter apenas n\xfameros e espa\xe7os.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve conter caracteres alfab\xe9ticos.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve conter letras ou n\xfameros.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve conter letras ou espa\xe7os.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve conter um s\xedmbolo.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve conter letras mai\xfasculas.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve conter letras min\xfasculas.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve conter n\xfameros.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} deve ser um s\xedmbolo.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} s\xf3 pode conter letras mai\xfasculas.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} s\xf3 pode conter letras min\xfasculas.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} precisa ser antes de ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} precisa ser no passado.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Este campo n\xe3o foi configurado corretamente e n\xe3o pode ser submetido.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} precisa ser entre ${a} e ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} n\xe3o \xe9 igual.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} n\xe3o \xe9 uma data v\xe1lida, por favor use este formato ${args[0]}`;
        return "Este campo n\xe3o foi configurado corretamente e n\xe3o pode ser submetido.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} precisa ser entre ${$a262a7e50e5a100c$var$date(args[0])} e ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Por favor, insira um endere\xe7o de email v\xe1lido.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} n\xe3o termina com ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} n\xe3o \xe9 um valor permitido.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = first <= second ? first : second;
        const max = second >= first ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} precisa conter ao menos um caractere.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} precisa ser menor ou igual a ${max} caracteres.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} precisa conter ${max} caracteres.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} precisa ser maior ou igual a ${min} caracteres.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} precisa ter entre ${min} e ${max} caracteres.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} n\xe3o \xe9 um valor permitido.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `N\xe3o pode ter mais de ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} precisa ser menor ou igual a ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "N\xe3o h\xe1 formatos de arquivos permitidos.";
        return `${$a262a7e50e5a100c$var$sentence(name)} precisa ser do tipo: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `N\xe3o pode ter menos de ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} precisa ser pelo menos ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} n\xe3o \xe9 um(a) ${name} permitido(a).`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} precisa ser um n\xfamero.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" ou ")} \xe9 necess\xe1rio.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \xe9 obrigat\xf3rio.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} n\xe3o come\xe7a com ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Por favor, insira uma url v\xe1lida.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "A data selecionada \xe9 inv\xe1lida."
};
var $a262a7e50e5a100c$var$pt = {
    ui: $a262a7e50e5a100c$var$ui31,
    validation: $a262a7e50e5a100c$var$validation31
};
var $a262a7e50e5a100c$var$ui32 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Ad\u0103ugare",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Elimin\u0103",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Elimin\u0103 tot",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Pare r\u0103u, unele c\xe2mpuri nu sunt corect completate.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Trimite",
    /**
   * Shown when no files are selected.
   */ noFiles: "Nu este selectat nici un fi\u0219ier",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Mutare \xeen sus",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Mutare \xeen jos",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Se \xeencarc\u0103...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\xcenc\u0103rca\u021Bi mai mult",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Urmatorul",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Precedent",
    /**
   * Shown when adding all values.
   */ addAllValues: "Ad\u0103uga\u021Bi toate valorile",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Ad\u0103ugarea valorilor selectate",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Elimina\u021Bi toate valorile",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Elimina\u021Bi valorile selectate",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Alege data",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Modifica\u021Bi data",
    /**
   * Shown when there is something to close
   */ close: "\xcenchide",
    /**
   * Shown when there is something to open.
   */ open: "Deschis"
};
var $a262a7e50e5a100c$var$validation32 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Te rog accept\u{103} ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} fie dup\u{103} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie sa fie \xeen viitor.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} poate con\u{21B}ine doar caractere alafetice.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} poate con\u{21B}ine doar litere \u{219}i numere.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} poate con\u{21B}ine doar litere \u{219}i spa\u{21B}ii.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} con\u{21B}in\u{103} caractere alfabetice.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} con\u{21B}in\u{103} litere sau numere.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} con\u{21B}in\u{103} litere sau spa\u{21B}ii.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} con\u{21B}in\u{103} simbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} con\u{21B}in\u{103} majuscule.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} con\u{21B}in\u{103} litere mici.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} con\u{21B}in\u{103} numere.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} fie un simbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} poate con\u{21B}ine doar litere mari.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} poate con\u{21B}ine doar litere mici.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} precead\u{103} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} fie \xeen trecut.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `C\xe2mpul a fost configurat incorect \u{219}i nu poate fi trimis.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} fie \xeentre ${a} \u{219}i ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nu se potrive\u{219}te.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} nu este valid\u{103}, te rog folo\u{219}te formatul ${args[0]}`;
        return "C\xe2mpul a fost incorect configurat \u0219i nu poate fi trimis.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} fie \xeentre ${$a262a7e50e5a100c$var$date(args[0])} \u{219}i ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Te rog folose\u0219te o adres\u0103 de email valid\u0103.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nu se termin\u{103} cu ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nu este o valoare acceptat\u{103}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} trebuie sa con\u{21B}in\u{103} cel pu\u{21B}in un caracter.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} trebuie sa aib\u{103} cel mult ${max} caractere.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} ar trebui s\u{103} aib\u{103} ${max} caractere lungi.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} aib\u{103} cel pu\u{21B}in ${min} caractere.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} aib\u{103} \xeentre ${min} \u{219}i ${max} caractere.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nu este o valoare acceptat\u{103}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Nu poate avea mai mult decat ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} fie cel mult egal cu ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Tipul de fi\u0219ier neacceptat.";
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} fie de tipul: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Nu poate avea mai pu\u{21B}in dec\xe2t ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} fie cel pu\u{21B}in ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} nu este o valoare accept\u{103} pentru ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} trebuie s\u{103} fie un num\u{103}r.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" sau ")} este necesar.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} este necesar.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nu \xeencepe cu ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Introduce\u{21B}i o adres\u{103} URL valid\u{103}.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Data selectat\u0103 este nevalid\u0103."
};
var $a262a7e50e5a100c$var$ro = {
    ui: $a262a7e50e5a100c$var$ui32,
    validation: $a262a7e50e5a100c$var$validation32
};
var $a262a7e50e5a100c$var$ui33 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u0423\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u0418\u0437\u0432\u0438\u043D\u0438\u0442\u0435, \u043D\u0435 \u0432\u0441\u0435 \u043F\u043E\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u044B \u0432\u0435\u0440\u043D\u043E.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u0424\u0430\u0439\u043B \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0432\u0432\u0435\u0440\u0445",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0432\u043D\u0438\u0437",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435",
    /**
   * Shown on buttons that navigate state forward
   */ next: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u0441\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0441\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0430\u0442\u0443",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u0430\u0442\u0443",
    /**
   * Shown when there is something to close
   */ close: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    /**
   * Shown when there is something to open.
   */ open: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C"
};
var $a262a7e50e5a100c$var$validation33 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `\u{41F}\u{43E}\u{436}\u{430}\u{43B}\u{443}\u{439}\u{441}\u{442}\u{430}, \u{43F}\u{440}\u{438}\u{43C}\u{438}\u{442}\u{435} ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `\u{414}\u{430}\u{442}\u{430} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{43F}\u{43E}\u{437}\u{436}\u{435} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `\u{414}\u{430}\u{442}\u{430} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{432} \u{431}\u{443}\u{434}\u{443}\u{449}\u{435}\u{43C}.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{431}\u{443}\u{43A}\u{432}\u{44B}.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{431}\u{443}\u{43A}\u{432}\u{44B} \u{438} \u{446}\u{438}\u{444}\u{440}\u{44B}.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{433}\u{443}\u{442} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{431}\u{443}\u{43A}\u{432}\u{44B} \u{438} \u{43F}\u{440}\u{43E}\u{431}\u{435}\u{43B}\u{44B}.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{435}\u{43D} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{430}\u{43B}\u{444}\u{430}\u{432}\u{438}\u{442}\u{43D}\u{44B}\u{435} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{44B}.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{435}\u{43D} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{431}\u{443}\u{43A}\u{432}\u{44B} \u{438}\u{43B}\u{438} \u{446}\u{438}\u{444}\u{440}\u{44B}.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{431}\u{443}\u{43A}\u{432}\u{44B} \u{438}\u{43B}\u{438} \u{43F}\u{440}\u{43E}\u{431}\u{435}\u{43B}\u{44B}.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{435}\u{43D} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{43F}\u{440}\u{43E}\u{43F}\u{438}\u{441}\u{43D}\u{44B}\u{435} \u{431}\u{443}\u{43A}\u{432}\u{44B}.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{441}\u{442}\u{440}\u{43E}\u{447}\u{43D}\u{44B}\u{435} \u{431}\u{443}\u{43A}\u{432}\u{44B}.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{435}\u{43D} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{447}\u{438}\u{441}\u{43B}\u{430}.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{435}\u{43D} \u{431}\u{44B}\u{442}\u{44C} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{43C}.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{43F}\u{440}\u{43E}\u{43F}\u{438}\u{441}\u{43D}\u{44B}\u{435} \u{431}\u{443}\u{43A}\u{432}\u{44B}.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{442}\u{43E}\u{43B}\u{44C}\u{43A}\u{43E} \u{431}\u{443}\u{43A}\u{432}\u{44B} \u{43D}\u{438}\u{436}\u{43D}\u{435}\u{433}\u{43E} \u{440}\u{435}\u{433}\u{438}\u{441}\u{442}\u{440}\u{430}.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `\u{414}\u{430}\u{442}\u{430} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{440}\u{430}\u{43D}\u{44C}\u{448}\u{435} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `\u{414}\u{430}\u{442}\u{430} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{432} \u{43F}\u{440}\u{43E}\u{448}\u{43B}\u{43E}\u{43C}.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{42D}\u{442}\u{43E} \u{43F}\u{43E}\u{43B}\u{435} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{43E} \u{43D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{43E} \u{438} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{43E}\u{442}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{435}\u{43D}\u{43E}.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{436}\u{434}\u{443} ${a} \u{438} ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{435} \u{441}\u{43E}\u{432}\u{43F}\u{430}\u{434}\u{430}\u{435}\u{442}.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{438}\u{43C}\u{435}\u{435}\u{442} \u{43D}\u{435}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{44E} \u{434}\u{430}\u{442}\u{443}. \u{41F}\u{43E}\u{436}\u{430}\u{43B}\u{443}\u{439}\u{441}\u{442}\u{430}, \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{443}\u{439}\u{442}\u{435} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442} ${args[0]}`;
        return "\u042D\u0442\u043E \u043F\u043E\u043B\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u043D\u0435\u0432\u0435\u0440\u043D\u043E \u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `\u{414}\u{430}\u{442}\u{430} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{436}\u{434}\u{443} ${$a262a7e50e5a100c$var$date(args[0])} \u{438} ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{437}\u{430}\u{43A}\u{430}\u{43D}\u{447}\u{438}\u{432}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{43D}\u{430} ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{438}\u{43C}\u{435}\u{435}\u{442} \u{43D}\u{435}\u{43F}\u{43E}\u{434}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{441}\u{43E}\u{434}\u{435}\u{440}\u{436}\u{430}\u{442}\u{44C} \u{43C}\u{438}\u{43D}\u{438}\u{43C}\u{443}\u{43C} \u{43E}\u{434}\u{438}\u{43D} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}.`;
        if (min == 0 && max) return `\u{414}\u{43B}\u{438}\u{43D}\u{430} \u{43F}\u{43E}\u{43B}\u{44F} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44C}\u{448}\u{435} \u{438}\u{43B}\u{438} \u{440}\u{430}\u{432}\u{43D}\u{430} ${max} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{430}\u{43C}.`;
        if (min === max) return `\u{414}\u{43B}\u{438}\u{43D}\u{430} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{441}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{442}\u{44C} ${max} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{432}.`;
        if (min && max === Infinity) return `\u{414}\u{43B}\u{438}\u{43D}\u{430} \u{43F}\u{43E}\u{43B}\u{44F} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435} \u{438}\u{43B}\u{438} \u{440}\u{430}\u{432}\u{43D}\u{430} ${min} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{430}\u{43C}.`;
        return `\u{414}\u{43B}\u{438}\u{43D}\u{430} \u{43F}\u{43E}\u{43B}\u{44F} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{430} \u{431}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{436}\u{434}\u{443} ${min} \u{438} ${max} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{430}\u{43C}\u{438}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{438}\u{43C}\u{435}\u{435}\u{442} \u{43D}\u{435}\u{434}\u{43E}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{43E}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{41D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{431}\u{43E}\u{43B}\u{44C}\u{448}\u{435}, \u{447}\u{435}\u{43C} ${args[0]} ${name}.`;
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43C}\u{435}\u{43D}\u{44C}\u{448}\u{435} \u{438}\u{43B}\u{438} \u{440}\u{430}\u{432}\u{43D}\u{43E} ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u041D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0430\u0432\u0435\u043C\u044B\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u044B \u0444\u0430\u0439\u043B\u0430.";
        return `\u{424}\u{43E}\u{440}\u{43C}\u{430}\u{442} \u{444}\u{430}\u{439}\u{43B}\u{430} \u{432} \u{43F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{435}\u{43D} \u{431}\u{44B}\u{442}\u{44C}: ${args[0]}.`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{41D}\u{435} \u{43C}\u{43E}\u{436}\u{435}\u{442} \u{431}\u{44B}\u{442}\u{44C} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{43C}\u{435}\u{43D}\u{44C}\u{448}\u{435}, \u{447}\u{435}\u{43C} ${args[0]} ${name}.`;
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{435} \u{43C}\u{435}\u{43D}\u{435}\u{435}, \u{447}\u{435}\u{43C} ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} \u{43D}\u{435} \u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{438}\u{432}\u{430}\u{435}\u{442}\u{441}\u{44F} \u{432} \u{43F}\u{43E}\u{43B}\u{435} ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{447}\u{438}\u{441}\u{43B}\u{43E}\u{43C}.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" \u0438\u043B\u0438 ")} \u{442}\u{440}\u{435}\u{431}\u{443}\u{435}\u{442}\u{441}\u{44F}.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43E}\u{431}\u{44F}\u{437}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E} \u{434}\u{43B}\u{44F} \u{437}\u{430}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F}.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{43D}\u{430}\u{447}\u{438}\u{43D}\u{430}\u{442}\u{44C}\u{441}\u{44F} \u{441} ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{41F}\u{43E}\u{436}\u{430}\u{43B}\u{443}\u{439}\u{441}\u{442}\u{430}, \u{432}\u{432}\u{435}\u{434}\u{438}\u{442}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{439} URL-\u{430}\u{434}\u{440}\u{435}\u{441}.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0434\u0430\u0442\u0430 \u043D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u0430."
};
var $a262a7e50e5a100c$var$ru = {
    ui: $a262a7e50e5a100c$var$ui33,
    validation: $a262a7e50e5a100c$var$validation33
};
var $a262a7e50e5a100c$var$ui34 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "Prida\u0165",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Odstr\xe1ni\u0165",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Odstr\xe1ni\u0165 v\u0161etko",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Prep\xe1\u010Dte, ale nie v\u0161etky polia s\xfa vyplnen\xe9 spr\xe1vne.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Odosla\u0165",
    /**
   * Shown when no files are selected.
   */ noFiles: "Nebol vybran\xfd \u017Eiadny s\xfabor",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Posun\xfa\u0165 hore",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Posun\xfa\u0165 dole",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Na\u010D\xedtavanie...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Na\u010D\xedta\u0165 viac",
    /**
   * Shown on buttons that navigate state forward
   */ next: "\u010Eal\u0161ie",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Predo\u0161l\xfd",
    /**
   * Shown when adding all values.
   */ addAllValues: "Pridajte v\u0161etky hodnoty",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Pridajte vybran\xe9 hodnoty",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Odstr\xe1ni\u0165 v\u0161etky hodnoty",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Odstr\xe1ni\u0165 vybran\xe9 hodnoty",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Vyberte d\xe1tum",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Zmena d\xe1tumu",
    /**
   * Shown when there is something to close
   */ close: "Zavrie\u0165",
    /**
   * Shown when there is something to open.
   */ open: "Otvoren\xe9"
};
var $a262a7e50e5a100c$var$validation34 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Pros\xedm za\u{161}krtnite ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} za ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} v bud\xfacnosti.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xf4\u{17E}e obsahova\u{165} iba p\xedsmen\xe1.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xf4\u{17E}e obsahova\u{165} iba p\xedsmen\xe1 a \u{10D}\xedsla.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xf4\u{17E}e obsahova\u{165} iba p\xedsmen\xe1 a medzery.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahova\u{165} abecedn\xe9 znaky.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahova\u{165} p\xedsmen\xe1 alebo \u{10D}\xedslice.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahova\u{165} p\xedsmen\xe1 alebo medzery.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahova\u{165} symbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahova\u{165} ve\u{13E}k\xe9 p\xedsmen\xe1.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahova\u{165} mal\xe9 p\xedsmen\xe1.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed obsahova\u{165} \u{10D}\xedsla.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} symbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xf4\u{17E}e obsahova\u{165} iba ve\u{13E}k\xe9 p\xedsmen\xe1.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xf4\u{17E}e obsahova\u{165} len mal\xe9 p\xedsmen\xe1.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} pred ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} v minulosti.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Toto pole bolo nespr\xe1vne nakonfigurovan\xe9 a nem\xf4\u{17E}e by\u{165} odoslan\xe9.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} medzi ${a} and ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} does not match.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} nie je platn\xfdm d\xe1tumom, pros\xedm, pou\u{17E}ite form\xe1t ${args[0]}`;
        return "Toto pole bolo nespr\xe1vne nakonfigurovan\xe9 a nem\xf4\u017Ee by\u0165 odoslan\xe9.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} medzi ${$a262a7e50e5a100c$var$date(args[0])} a ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Pros\xedm, zadajte platn\xfa emailov\xfa adresu.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nekon\u{10D}\xed na ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nie je povolen\xe1 hodnota.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed ma\u{165} najmenej jeden znak.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} men\u{161}ie alebo rovn\xe9 ako ${max} znakov.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} by mala ma\u{165} d\u{13A}\u{17E}ku ${max} znakov.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} v\xe4\u{10D}\u{161}ie alebo rovn\xe9 ako ${min} znakov.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} medzi ${min} a\u{17E} ${max} znakov.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nie je povolen\xe1 hodnota.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Nie je mo\u{17E}n\xe9 pou\u{17E}i\u{165} viac ne\u{17E} ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} men\u{161}ie alebo rovn\xe9 ako ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Nie s\xfa povolen\xe9 form\xe1ty s\xfaborov.";
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} typu: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Nem\xf4\u{17E}e by\u{165} menej ne\u{17E} ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} minim\xe1lne ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} nie je povolen\xe9 hodnota pre ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mus\xed by\u{165} \u{10D}\xedslo.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" alebo ")} je potrebn\xfd.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} je povinn\xe9.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} neza\u{10D}\xedn\xe1 s ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Zadajte platn\xfa adresu URL.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Vybran\xfd d\xe1tum je neplatn\xfd."
};
var $a262a7e50e5a100c$var$sk = {
    ui: $a262a7e50e5a100c$var$ui34,
    validation: $a262a7e50e5a100c$var$validation34
};
var $a262a7e50e5a100c$var$ui35 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Dodaj",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Odstrani",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Odstrani vse",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Nekatera polja niso pravilno izpolnjena.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Po\u0161lji",
    /**
   * Shown when no files are selected.
   */ noFiles: "Nobena datoteka ni izbrana",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Premakni se navzgor",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Premakni se navzdol",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Nalaganje...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Nalo\u017Ei ve\u010D",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Naslednji",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Prej\u0161nji",
    /**
   * Shown when adding all values.
   */ addAllValues: "Dodajte vse vrednosti",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Dodajanje izbranih vrednosti",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Odstranite vse vrednosti",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Odstrani izbrane vrednosti",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Izberite datum",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Spremeni datum",
    /**
   * Shown when there is something to close
   */ close: "Zapri",
    /**
   * Shown when there is something to open.
   */ open: "Odpri"
};
var $a262a7e50e5a100c$var$validation35 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Prosimo popravite ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti po ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti v prihodnosti.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} lahko vsebuje samo znake abecede.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} lahko vsebuje samo \u{10D}rke in \u{161}tevilke.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} lahko vsebuje samo \u{10D}rke in presledke.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora vsebovati abecedne znake.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora vsebovati \u{10D}rke ali \u{161}tevilke.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora vsebovati \u{10D}rke ali presledke.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora vsebovati simbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora vsebovati velike \u{10D}rke.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora vsebovati male \u{10D}rke.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora vsebovati \u{161}tevilke.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti simbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} lahko vsebuje le velike \u{10D}rke.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} lahko vsebuje le male \u{10D}rke.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti pred ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti v preteklosti.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `To polje je narobe nastavljeno in ne mora biti izpolnjeno.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti med ${a} in ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} se ne ujema.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ni pravilen datum, prosimo uporabite format ${args[0]}`;
        return "To polje je narobe nastavljeno in ne mora biti izpolnjeno.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti med ${$a262a7e50e5a100c$var$date(args[0])} in ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Vnesite veljaven e-po\u0161tni naslov.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} se mora ko\u{10D}ati z ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ni dovoljena vrednost.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mora vsebovati vsaj en znak.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} mora vsebovati najve\u{10D} ${max} znakov.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti dolg ${max} znakov.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mora vsebovati vsaj ${min} znakov.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora vsebovati med ${min} in ${max} znakov.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ni dovoljena vrednost.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Najve\u{10D} je ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} je lahko najve\u{10D} ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Nobena vrsta datoteke ni dovoljena.";
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti tipa: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Najmanj ${args[0]} ${name} je dovoljenih.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti vsaj ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} ni dovoljen(a/o) ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti \u{161}tevilka.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" ali ")} zahtevan je.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} je zahtevan(o/a).`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} se mora za\u{10D}eti z ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Vnesite veljaven URL.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Izbrani datum je neveljaven."
};
var $a262a7e50e5a100c$var$sl = {
    ui: $a262a7e50e5a100c$var$ui35,
    validation: $a262a7e50e5a100c$var$validation35
};
var $a262a7e50e5a100c$var$ui36 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "Dodaj",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Ukloni",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Ukloni sve",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Pojedina polja nisu ispravno ispunjena.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Po\u0161alji",
    /**
   * Shown when no files are selected.
   */ noFiles: "Fajl nije odabran",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Pomerite se gore",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Pomeri se dole",
    /**
   * Shown when something is actively loading.
   */ isLoading: "U\u010Ditavanje...",
    /**
   * Shown when there is more to load.
   */ loadMore: "U\u010Ditaj vi\u0161e",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Slede\u0107a",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Prethodna",
    /**
   * Shown when adding all values.
   */ addAllValues: "Dodajte sve vrednosti",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Dodajte izabrane vrednosti",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Uklonite sve vrednosti",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Uklonite izabrane vrednosti",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Izaberite datum",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Promenite datum",
    /**
   * Shown when there is something to close
   */ close: "Zatvori",
    /**
   * Shown when there is something to open.
   */ open: "Otvori"
};
var $a262a7e50e5a100c$var$validation36 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Molimo prihvatite ${name}`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti posle ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti u buduc\u{301}nosti.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17E}e da sadr\u{17E}i samo abecedne znakove.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17E}e da sadr\u{17E}i samo slova i brojeve.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17E}e da sadr\u{17E}i samo slova i razmake.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora da sadr\u{17E}i abecedne znakove.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora da sadr\u{17E}i slova ili brojeve.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora da sadr\u{17E}i slova ili razmake.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora da sadr\u{17E}i simbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora da sadr\u{17E}i velika slova.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora da sadr\u{17E}i mala slova.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora da sadr\u{17E}i brojeve.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti simbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17E}e da sadr\u{17E}i samo velika slova.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mo\u{17E}e da sadr\u{17E}i samo mala slova.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti pre ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti u pro\u{161}losti.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Ovo polje je pogre\u{161}no konfigurisano i ne mo\u{17E}e se poslati.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti izme\u{111}u ${a} i ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} se ne podudara.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} nije va\u{17E}ec\u{301}i datum, molimo Vas koristite format ${args[0]}`;
        return "Ovo polje je pogre\u0161no konfigurisano i ne mo\u017Ee se poslati";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti izme\u{111}u ${$a262a7e50e5a100c$var$date(args[0])} i ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Unesite ispravnu e-mail adresu.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} se ne zavr\u{161}ava sa ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nije dozvoljena vrednost`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti najmanje jedan karakter.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti manji ili jednaki od ${max} karaktera.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} treba da bude ${max} znakova duga\u{10D}ak.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} mora biti vec\u{301}i ili jednaki od ${min} karaktera.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti izme\u{111}u ${min} i ${max} karaktera.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} nije dozvoljena vrednost.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Ne mo\u{17E}e imati vi\u{161}e od ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti manji ili jednaki od ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Nisu dozvoljeni formati datoteka.";
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti tipa: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Ne mo\u{17E}e imati manje od ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} mora da ima najmanje ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} nije dozvoljeno ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mora biti broj.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" \u0438\u043B\u0438 ")} \u{43F}\u{43E}\u{442}\u{440}\u{435}\u{431}\u{430}\u{43D} \u{458}\u{435}.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} je obavezno polje.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ne po\u{10D}inje sa ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Unesite va\u{17E}e\u{107}u URL adresu.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Izabrani datum je neva\u017Ee\u0107i."
};
var $a262a7e50e5a100c$var$sr = {
    ui: $a262a7e50e5a100c$var$ui36,
    validation: $a262a7e50e5a100c$var$validation36
};
var $a262a7e50e5a100c$var$ui37 = {
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Ta bort",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Ta bort alla",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Tyv\xe4rr \xe4r inte alla f\xe4lt korrekt ifyllda",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Skicka",
    /**
   * Shown when no files are selected.
   */ noFiles: "Ingen fil vald",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Flytta upp",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Flytta ner",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Laddar...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Ladda mer",
    /**
   * Shown on buttons that navigate state forward
   */ next: "N\xe4sta",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "F\xf6reg\xe5ende",
    /**
   * Shown when adding all values.
   */ addAllValues: "L\xe4gg till alla v\xe4rden",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "L\xe4gg till valda v\xe4rden",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Ta bort alla v\xe4rden",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Ta bort valda v\xe4rden",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "V\xe4lj datum",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\xc4ndra datum",
    /**
   * Shown when there is something to close
   */ close: "St\xe4ng",
    /**
   * Shown when there is something to open.
   */ open: "\xd6ppna"
};
var $a262a7e50e5a100c$var$validation37 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Var god acceptera ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara efter ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara fram\xe5t i tiden.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan enbart inneh\xe5lla bokst\xe4ver i alfabetet.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan bara inneh\xe5lla bokst\xe4ver och siffror.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan bara inneh\xe5lla bokst\xe4ver och blanksteg.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste inneh\xe5lla alfabetiska tecken.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste inneh\xe5lla bokst\xe4ver eller siffror.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste inneh\xe5lla bokst\xe4ver eller mellanslag.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste inneh\xe5lla symbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste inneh\xe5lla versaler.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste inneh\xe5lla gemener.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste inneh\xe5lla siffror.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara en symbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan bara inneh\xe5lla versaler.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kan bara inneh\xe5lla sm\xe5 bokst\xe4ver.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara f\xf6re ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara bak\xe5t i tiden.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Det h\xe4r f\xe4ltet st\xe4lldes inte in korrekt och kan inte anv\xe4ndas.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara mellan ${a} och ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} matchar inte.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \xe4r inte ett giltigt datum, var god anv\xe4nd formatet ${args[0]}`;
        return "Det h\xe4r f\xe4ltet st\xe4lldes inte in korrekt och kan inte anv\xe4ndas";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara mellan ${$a262a7e50e5a100c$var$date(args[0])} och ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Var god fyll i en giltig e-postadress.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} slutar inte med ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \xe4r inte ett godk\xe4nt v\xe4rde.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste ha minst ett tecken.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara ${max} tecken eller f\xe4rre.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} b\xf6r vara ${max} tecken l\xe5nga.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara ${min} tecken eller fler.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara mellan ${min} och ${max} tecken.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \xe4r inte ett godk\xe4nt v\xe4rde.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Kan inte ha mer \xe4n ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara ${args[0]} eller mindre.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Inga filtyper till\xe5tna.";
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara av filtypen: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Kan inte ha mindre \xe4n ${args[0]} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara minst ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} \xe4r inte ett godk\xe4nt ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} m\xe5ste vara en siffra.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" eller ")} kr\xe4vs.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \xe4r obligatoriskt.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} b\xf6rjar inte med ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Ange en giltig URL.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Det valda datumet \xe4r ogiltigt."
};
var $a262a7e50e5a100c$var$sv = {
    ui: $a262a7e50e5a100c$var$ui37,
    validation: $a262a7e50e5a100c$var$validation37
};
// packages/i18n/src/locales/tet.ts
var $a262a7e50e5a100c$var$ui38 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "Aumenta",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Hasai",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Hasai Hotu",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Deskulpa, iha informasaun neebe sala iha formul\xe1riu",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Submete",
    /**
   * Shown when no files are selected.
   */ noFiles: "Seidauk hili file",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Muda ba leten",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Muda ba kotuk",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Hein lai...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Foti tan",
    /**
   * Show on buttons that navigate state forward
   */ next: "Ba oin",
    /**
   * Show on buttons that navigate state backward
   */ prev: "Ba kotuk",
    /**
   * Shown when adding all values.
   */ addAllValues: "Aumenta hotu",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Aumenta buat neebe hili ona",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Hasai hotu",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Hasai buat neebe hili ona",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Hili data",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Troka data"
};
var $a262a7e50e5a100c$var$validation38 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `Favor ida simu ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} tenki depoid ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} tenki iha futuru.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} bele uza letra deit.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} bele uza letra ka numeru deit.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} bele uza letra ka numeru deit.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} tenki antes ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} tenki antes ohin loron.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Informasaun nee la loos no la bele submete.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} tenki iha klaran entre ${a} no ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} la hanesan.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} la loos, favor ida hakerek tuir ${args[0]}`;
        return "Informasaun nee la loos no la bele submete.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} tenki iha ${$a262a7e50e5a100c$var$date(args[0])} no ${$a262a7e50e5a100c$var$date(args[1])} nia klaran`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Favor hakerek endresu email neebe loos.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} la remata ho ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `la bele uza ${$a262a7e50e5a100c$var$sentence(name)}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} tenki iha letra ida ka liu.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} tenki badak liu ${max} letra.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} tenki iha letra ${max}.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} tenki iha letra ${min} ka liu.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} tenki iha letra ${min} too ${max}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `la bele uza ${$a262a7e50e5a100c$var$sentence(name)}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `La bele iha ${args[0]} ka liu ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} tenki kiik liu ka hanesan ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return `La bele simu 'format' ida.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} tenki iha tipo: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `Presiza ${args[0]} ${name} ka liu.`;
        return `${name} tenki ${args[0]} ka liu.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `La bele uza \u{201C}${value}\u{201D} ba ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} tenki numeru.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `Presiza ${$a262a7e50e5a100c$var$sentence(name)}.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} la komesa ho ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Favor hakerek URL neebe loos.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Data la loos."
};
var $a262a7e50e5a100c$var$tet = {
    ui: $a262a7e50e5a100c$var$ui38,
    validation: $a262a7e50e5a100c$var$validation38
};
var $a262a7e50e5a100c$var$ui39 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "\u0418\u043B\u043E\u0432\u0430 \u043A\u0430\u0440\u0434\u0430\u043D",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u0425\u043E\u0440\u0438\u04B7 \u043A\u0430\u0440\u0434\u0430\u043D",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u04B2\u0430\u043C\u0430\u0440\u043E \u0445\u043E\u0440\u0438\u04B7 \u043A\u0443\u043D\u0435\u0434",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u0411\u0443\u0431\u0430\u0445\u0448\u0435\u0434, \u043D\u0430 \u04B3\u0430\u043C\u0430 \u043C\u0430\u0439\u0434\u043E\u043D\u04B3\u043E \u0434\u0443\u0440\u0443\u0441\u0442 \u043F\u0443\u0440 \u043A\u0430\u0440\u0434\u0430 \u0448\u0443\u0434\u0430\u0430\u043D\u0434.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u041F\u0435\u0448\u043D\u0438\u04B3\u043E\u0434 \u043A\u0443\u043D\u0435\u0434",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u042F\u0433\u043E\u043D \u0444\u0430\u0439\u043B \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043D\u0430\u0448\u0443\u0434\u0430\u0430\u0441\u0442",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u0411\u0430 \u0431\u043E\u043B\u043E \u04B3\u0430\u0440\u0430\u043A\u0430\u0442 \u043A\u0443\u043D\u0435\u0434",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u0411\u0430 \u043F\u043E\u0451\u043D \u04B3\u0430\u0440\u0430\u043A\u0430\u0442 \u043A\u0443\u043D\u0435\u0434",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u0414\u0430\u0440 \u04B3\u043E\u043B\u0438 \u0431\u043E\u0440\u0433\u0443\u0437\u043E\u0440\u04E3",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u0411\u0435\u0448\u0442\u0430\u0440 \u0431\u043E\u0440 \u043A\u0443\u043D\u0435\u0434",
    /**
   * Show on buttons that navigate state forward
   */ next: "\u0411\u0430\u044A\u0434\u04E3",
    /**
   * Show on buttons that navigate state backward
   */ prev: "\u0413\u0443\u0437\u0430\u0448\u0442\u0430",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u04B2\u0430\u043C\u0430 \u0430\u0440\u0437\u0438\u0448\u04B3\u043E\u0440\u043E \u0438\u043B\u043E\u0432\u0430 \u043A\u0443\u043D\u0435\u0434",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u0418\u043B\u043E\u0432\u0430 \u043A\u0430\u0440\u0434\u0430\u043D\u0438 \u0430\u0440\u0437\u0438\u0448\u04B3\u043E\u0438 \u0438\u043D\u0442\u0438\u0445\u043E\u0431\u0448\u0443\u0434\u0430",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u04B2\u0430\u043C\u0430 \u0430\u0440\u0437\u0438\u0448\u04B3\u043E\u0440\u043E \u0445\u043E\u0440\u0438\u04B7 \u043A\u0443\u043D\u0435\u0434",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u0410\u0440\u0437\u0438\u0448\u04B3\u043E\u0438 \u0438\u043D\u0442\u0438\u0445\u043E\u0431\u0448\u0443\u0434\u0430\u0440\u043E \u0445\u043E\u0440\u0438\u04B7 \u043A\u0443\u043D\u0435\u0434",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u0421\u0430\u043D\u0430 \u0438\u043D\u0442\u0438\u0445\u043E\u0431 \u043A\u0443\u043D\u0435\u0434",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u0422\u0430\u0493\u0439\u0438\u0440 \u0434\u043E\u0434\u0430\u043D\u0438 \u0441\u0430\u043D\u0430"
};
var $a262a7e50e5a100c$var$validation39 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `\u{41B}\u{443}\u{442}\u{444}\u{430}\u{43D} ${name}-\u{440}\u{43E} \u{49B}\u{430}\u{431}\u{443}\u{43B} \u{43A}\u{443}\u{43D}\u{435}\u{434}`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{43F}\u{430}\u{441} \u{430}\u{437} ${$a262a7e50e5a100c$var$date(args[0])} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{434}\u{430}\u{440} \u{43E}\u{44F}\u{43D}\u{434}\u{430} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{435}\u{442}\u{430}\u{432}\u{43E}\u{43D}\u{430}\u{434} \u{442}\u{430}\u{43D}\u{4B3}\u{43E} \u{430}\u{43B}\u{43E}\u{43C}\u{430}\u{442}\u{4B3}\u{43E}\u{438} \u{430}\u{43B}\u{438}\u{444}\u{431}\u{43E}\u{440}\u{43E} \u{434}\u{430}\u{440} \u{431}\u{430}\u{440} \u{433}\u{438}\u{440}\u{430}\u{434}.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{435}\u{442}\u{430}\u{432}\u{43E}\u{43D}\u{430}\u{434} \u{442}\u{430}\u{43D}\u{4B3}\u{43E} \u{4B3}\u{430}\u{440}\u{444}\u{4B3}\u{43E} \u{432}\u{430} \u{440}\u{430}\u{49B}\u{430}\u{43C}\u{4B3}\u{43E}\u{440}\u{43E} \u{434}\u{430}\u{440} \u{431}\u{430}\u{440} \u{433}\u{438}\u{440}\u{430}\u{434}.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{435}\u{442}\u{430}\u{432}\u{43E}\u{43D}\u{430}\u{434} \u{442}\u{430}\u{43D}\u{4B3}\u{43E} \u{4B3}\u{430}\u{440}\u{444}\u{4B3}\u{43E} \u{432}\u{430} \u{444}\u{43E}\u{441}\u{438}\u{43B}\u{430}\u{4B3}\u{43E}\u{440}\u{43E} \u{434}\u{430}\u{440} \u{431}\u{430}\u{440} \u{433}\u{438}\u{440}\u{430}\u{434}.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain alphabetical characters.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain letters and numbers.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain letters and spaces.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain symbol.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain uppercase.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain lowercase.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} must contain number.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain symbol.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain uppercase.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} can only contain lowercase.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{43F}\u{435}\u{448} \u{430}\u{437} ${$a262a7e50e5a100c$var$date(args[0])} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{434}\u{430}\u{440} \u{433}\u{443}\u{437}\u{430}\u{448}\u{442}\u{430} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{418}\u{43D} \u{43C}\u{430}\u{439}\u{434}\u{43E}\u{43D} \u{43D}\u{43E}\u{434}\u{443}\u{440}\u{443}\u{441}\u{442} \u{442}\u{430}\u{43D}\u{437}\u{438}\u{43C} \u{448}\u{443}\u{434}\u{430}\u{430}\u{441}\u{442} \u{432}\u{430} \u{43E}\u{43D}\u{440}\u{43E} \u{43F}\u{435}\u{448}\u{43D}\u{438}\u{4B3}\u{43E}\u{434} \u{43A}\u{430}\u{440}\u{434}\u{430}\u{43D} \u{493}\u{430}\u{439}\u{440}\u{438}\u{438}\u{43C}\u{43A}\u{43E}\u{43D} \u{430}\u{441}\u{442}.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{434}\u{430}\u{440} \u{431}\u{430}\u{439}\u{43D}\u{438} ${a} \u{432}\u{430} ${b} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{443}\u{432}\u{43E}\u{444}\u{438}\u{49B}\u{430}\u{442} \u{43D}\u{430}\u{43C}\u{435}\u{43A}\u{443}\u{43D}\u{430}\u{434}.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{441}\u{430}\u{43D}\u{430}\u{438} \u{434}\u{443}\u{440}\u{443}\u{441}\u{442} \u{43D}\u{435}\u{441}\u{442}, \u{43B}\u{443}\u{442}\u{444}\u{430}\u{43D} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442}\u{438} ${args[0]}-\u{440}\u{43E} \u{438}\u{441}\u{442}\u{438}\u{444}\u{43E}\u{434}\u{430} \u{431}\u{430}\u{440}\u{435}\u{434}`;
        return "\u0418\u043D \u043C\u0430\u0439\u0434\u043E\u043D \u043D\u043E\u0434\u0443\u0440\u0443\u0441\u0442 \u0442\u0430\u043D\u0437\u0438\u043C \u0448\u0443\u0434\u0430\u0430\u0441\u0442 \u0432\u0430 \u043E\u043D\u0440\u043E \u043F\u0435\u0448\u043D\u0438\u04B3\u043E\u0434 \u043A\u0430\u0440\u0434\u0430\u043D \u0493\u0430\u0439\u0440\u0438\u0438\u043C\u043A\u043E\u043D \u0430\u0441\u0442";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{434}\u{430}\u{440} \u{431}\u{430}\u{439}\u{43D}\u{438} ${$a262a7e50e5a100c$var$date(args[0])} \u{432}\u{430} ${$a262a7e50e5a100c$var$date(args[1])} \u{431}\u{43E}\u{448}\u{430}\u{434}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u041B\u0443\u0442\u0444\u0430\u043D \u043D\u0438\u0448\u043E\u043D\u0430\u0438 \u0438\u043C\u0435\u0439\u043B\u0438 \u0430\u043C\u0430\u043B\u043A\u0443\u043D\u0430\u043D\u0434\u0430\u0440\u043E \u0432\u043E\u0440\u0438\u0434 \u043D\u0430\u043C\u043E\u0435\u0434.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E} ${$a262a7e50e5a100c$var$list(args)} \u{431}\u{430} \u{43E}\u{445}\u{438}\u{440} \u{43D}\u{430}\u{43C}\u{435}\u{440}\u{430}\u{441}\u{430}\u{434}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{430}\u{440}\u{437}\u{438}\u{448}\u{438} \u{438}\u{4B7}\u{43E}\u{437}\u{430}\u{442}\u{434}\u{43E}\u{434}\u{430}\u{448}\u{443}\u{434}\u{430} \u{43D}\u{435}\u{441}\u{442}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{4B3}\u{430}\u{434}\u{434}\u{438} \u{430}\u{49B}\u{49B}\u{430}\u{43B} \u{44F}\u{43A} \u{430}\u{43B}\u{43E}\u{43C}\u{430}\u{442} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{430}\u{437} ${max} \u{430}\u{43B}\u{43E}\u{43C}\u{430}\u{442} \u{43A}\u{430}\u{43C}\u{442}\u{430}\u{440} \u{451} \u{431}\u{430}\u{440}\u{43E}\u{431}\u{430}\u{440} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} ${max} \u{430}\u{43B}\u{43E}\u{43C}\u{430}\u{442} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{430}\u{437} ${min} \u{430}\u{43B}\u{43E}\u{43C}\u{430}\u{442} \u{437}\u{438}\u{451}\u{434} \u{451} \u{431}\u{430}\u{440}\u{43E}\u{431}\u{430}\u{440} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{434}\u{430}\u{440} \u{431}\u{430}\u{439}\u{43D}\u{438} ${min} \u{432}\u{430} ${max} \u{430}\u{43B}\u{43E}\u{43C}\u{430}\u{442} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{430}\u{440}\u{437}\u{438}\u{448}\u{438} \u{438}\u{4B7}\u{43E}\u{437}\u{430}\u{442}\u{434}\u{43E}\u{434}\u{430}\u{448}\u{443}\u{434}\u{430} \u{43D}\u{435}\u{441}\u{442}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{417}\u{438}\u{451}\u{434}\u{430} \u{430}\u{437} ${args[0]} ${name} \u{434}\u{43E}\u{448}\u{442}\u{430} \u{43D}\u{430}\u{43C}\u{435}\u{442}\u{430}\u{432}\u{43E}\u{43D}\u{430}\u{434}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{430}\u{437} ${args[0]} \u{43A}\u{430}\u{43C}\u{442}\u{430}\u{440} \u{451} \u{431}\u{430}\u{440}\u{43E}\u{431}\u{430}\u{440} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u042F\u0433\u043E\u043D \u0444\u043E\u0440\u043C\u0430\u0442\u0438 \u0444\u0430\u0439\u043B \u0438\u04B7\u043E\u0437\u0430\u0442 \u0434\u043E\u0434\u0430 \u043D\u0430\u043C\u0435\u0448\u0430\u0432\u0430\u0434.";
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{447}\u{443}\u{43D}\u{438}\u{43D} \u{43D}\u{430}\u{43C}\u{443}\u{434} \u{431}\u{43E}\u{448}\u{430}\u{434}: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{41A}\u{430}\u{43C}\u{442}\u{430}\u{440} \u{430}\u{437} ${args[0]} ${name} \u{434}\u{43E}\u{448}\u{442}\u{430} \u{43D}\u{430}\u{43C}\u{435}\u{442}\u{430}\u{432}\u{43E}\u{43D}\u{430}\u{434}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{4B3}\u{430}\u{434}\u{434}\u{438} \u{430}\u{49B}\u{49B}\u{430}\u{43B} ${args[0]} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `"${value}" ${name} \u{438}\u{4B7}\u{43E}\u{437}\u{430}\u{442} \u{434}\u{43E}\u{434}\u{430} \u{43D}\u{430}\u{43C}\u{435}\u{448}\u{430}\u{432}\u{430}\u{434}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E}\u{44F}\u{434} \u{440}\u{430}\u{49B}\u{430}\u{43C} \u{431}\u{43E}\u{448}\u{430}\u{434}.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" \u0451 ")} \u{437}\u{430}\u{440}\u{443}\u{440} \u{430}`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43B}\u{43E}\u{437}\u{438}\u{43C} \u{430}\u{441}\u{442}.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{431}\u{43E} ${$a262a7e50e5a100c$var$list(args)} \u{43E}\u{493}\u{43E}\u{437} \u{43D}\u{430}\u{43C}\u{435}\u{448}\u{430}\u{432}\u{430}\u{434}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{41B}\u{443}\u{442}\u{444}\u{430}\u{43D} URL-\u{438} \u{434}\u{443}\u{440}\u{443}\u{441}\u{442}\u{440}\u{43E} \u{434}\u{43E}\u{445}\u{438}\u{43B} \u{43A}\u{443}\u{43D}\u{435}\u{434}.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u0421\u0430\u043D\u0430\u0438 \u0438\u043D\u0442\u0438\u0445\u043E\u0431\u0448\u0443\u0434\u0430 \u043D\u043E\u0434\u0443\u0440\u0443\u0441\u0442 \u0430\u0441\u0442."
};
var $a262a7e50e5a100c$var$tg = {
    ui: $a262a7e50e5a100c$var$ui39,
    validation: $a262a7e50e5a100c$var$validation39
};
var $a262a7e50e5a100c$var$ui40 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "\u0E40\u0E1E\u0E34\u0E48\u0E21",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u0E40\u0E2D\u0E32\u0E2D\u0E2D\u0E01",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u0E40\u0E2D\u0E32\u0E2D\u0E2D\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u0E02\u0E2D\u0E2D\u0E20\u0E31\u0E22 \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E32\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E01\u0E23\u0E2D\u0E01\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u0E2A\u0E48\u0E07",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E1F\u0E25\u0E4C",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E02\u0E36\u0E49\u0E19",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E25\u0E07",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    /**
   * Shown on buttons that navigate state forward
   */ next: "\u0E16\u0E31\u0E14\u0E44\u0E1B",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E48\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E48\u0E32\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u0E25\u0E1A\u0E04\u0E48\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u0E25\u0E1A\u0E04\u0E48\u0E32\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48",
    /**
   * Shown when there is something to close
   */ close: "\u0E1B\u0E34\u0E14",
    /**
   * Shown when there is something to open.
   */ open: "\u0E40\u0E1B\u0E34\u0E14"
};
var $a262a7e50e5a100c$var$validation40 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `\u{E01}\u{E23}\u{E38}\u{E13}\u{E32}\u{E22}\u{E2D}\u{E21}\u{E23}\u{E31}\u{E1A} ${name}`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2B}\u{E25}\u{E31}\u{E07}\u{E08}\u{E32}\u{E01} ${$a262a7e50e5a100c$var$date(args[0])}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E35}\u{E48}\u{E22}\u{E31}\u{E07}\u{E44}\u{E21}\u{E48}\u{E21}\u{E32}\u{E16}\u{E36}\u{E07}`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E44}\u{E14}\u{E49}\u{E41}\u{E04}\u{E48}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}\u{E40}\u{E17}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E44}\u{E14}\u{E49}\u{E41}\u{E04}\u{E48}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}\u{E41}\u{E25}\u{E30}\u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E02}\u{E40}\u{E17}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E44}\u{E14}\u{E49}\u{E41}\u{E04}\u{E48}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}\u{E41}\u{E25}\u{E30}\u{E40}\u{E27}\u{E49}\u{E19}\u{E27}\u{E23}\u{E23}\u{E04}\u{E40}\u{E17}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E02}`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}\u{E2B}\u{E23}\u{E37}\u{E2D}\u{E0A}\u{E48}\u{E2D}\u{E07}\u{E27}\u{E48}\u{E32}\u{E07}`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E2A}\u{E31}\u{E0D}\u{E25}\u{E31}\u{E01}\u{E29}\u{E13}\u{E4C}`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E15}\u{E31}\u{E27}\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E43}\u{E2B}\u{E0D}\u{E48}`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E15}\u{E31}\u{E27}\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E40}\u{E25}\u{E47}\u{E01}`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E02}`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E2A}\u{E31}\u{E0D}\u{E25}\u{E31}\u{E01}\u{E29}\u{E13}\u{E4C}`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E40}\u{E17}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E21}\u{E35}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}\u{E15}\u{E31}\u{E27}\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E43}\u{E2B}\u{E0D}\u{E48}`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E40}\u{E17}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}\u{E17}\u{E35}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E21}\u{E35}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}\u{E15}\u{E31}\u{E27}\u{E1E}\u{E34}\u{E21}\u{E1E}\u{E4C}\u{E40}\u{E25}\u{E47}\u{E01}`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E35}\u{E48}\u{E21}\u{E32}\u{E01}\u{E48}\u{E2D}\u{E19} ${$a262a7e50e5a100c$var$date(args[0])}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E35}\u{E48}\u{E1C}\u{E48}\u{E32}\u{E19}\u{E21}\u{E32}\u{E41}\u{E25}\u{E49}\u{E27}`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{E0A}\u{E48}\u{E2D}\u{E07}\u{E19}\u{E35}\u{E49}\u{E16}\u{E39}\u{E01}\u{E15}\u{E31}\u{E49}\u{E07}\u{E04}\u{E48}\u{E32}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E44}\u{E21}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07} \u{E41}\u{E25}\u{E30}\u{E08}\u{E30}\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E2A}\u{E48}\u{E07}\u{E02}\u{E49}\u{E2D}\u{E21}\u{E39}\u{E25}\u{E44}\u{E14}\u{E49}`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E04}\u{E48}\u{E32}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07} ${a} \u{E41}\u{E25}\u{E30} ${b}`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E44}\u{E21}\u{E48}\u{E15}\u{E23}\u{E07}\u{E01}\u{E31}\u{E19}`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{E44}\u{E21}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E43}\u{E19}\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E17}\u{E35}\u{E48}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07} \u{E01}\u{E23}\u{E38}\u{E13}\u{E32}\u{E01}\u{E23}\u{E2D}\u{E01}\u{E15}\u{E32}\u{E21}\u{E23}\u{E39}\u{E1B}\u{E41}\u{E1A}\u{E1A} ${args[0]}`;
        return "\u0E0A\u0E48\u0E2D\u0E07\u0E19\u0E35\u0E49\u0E16\u0E39\u0E01\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E41\u0E25\u0E30\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E27}\u{E31}\u{E19}\u{E17}\u{E35}\u{E48}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07} ${$a262a7e50e5a100c$var$date(args[0])} \u{E41}\u{E25}\u{E30} ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E25}\u{E07}\u{E17}\u{E49}\u{E32}\u{E22}\u{E14}\u{E49}\u{E27}\u{E22} ${$a262a7e50e5a100c$var$list(args)}`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E44}\u{E21}\u{E48}\u{E43}\u{E0A}\u{E48}\u{E04}\u{E48}\u{E32}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E01}\u{E23}\u{E2D}\u{E01}`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E04}\u{E27}\u{E32}\u{E21}\u{E22}\u{E32}\u{E27}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E19}\u{E49}\u{E2D}\u{E22}\u{E2B}\u{E19}\u{E36}\u{E48}\u{E07}\u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E04}\u{E27}\u{E32}\u{E21}\u{E22}\u{E32}\u{E27}\u{E44}\u{E21}\u{E48}\u{E40}\u{E01}\u{E34}\u{E19} ${max} \u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{E04}\u{E27}\u{E23}\u{E08}\u{E30}\u{E40}\u{E1B}\u{E47}\u{E19} ${max} \u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}\u{E22}\u{E32}\u{E27}`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E04}\u{E27}\u{E32}\u{E21}\u{E22}\u{E32}\u{E27} ${min} \u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}\u{E02}\u{E36}\u{E49}\u{E19}\u{E44}\u{E1B}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E04}\u{E27}\u{E32}\u{E21}\u{E22}\u{E32}\u{E27}\u{E23}\u{E30}\u{E2B}\u{E27}\u{E48}\u{E32}\u{E07} ${min} \u{E41}\u{E25}\u{E30} ${max} \u{E15}\u{E31}\u{E27}\u{E2D}\u{E31}\u{E01}\u{E29}\u{E23}`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E44}\u{E21}\u{E48}\u{E43}\u{E0A}\u{E48}\u{E04}\u{E48}\u{E32}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E01}\u{E23}\u{E2D}\u{E01}`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E21}\u{E32}\u{E01}\u{E01}\u{E27}\u{E48}\u{E32} ${args[0]} ${name} \u{E44}\u{E14}\u{E49}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E04}\u{E48}\u{E32}\u{E44}\u{E21}\u{E48}\u{E40}\u{E01}\u{E34}\u{E19} ${args[0]}`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E02\u0E2D\u0E07\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15";
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E44}\u{E1F}\u{E25}\u{E4C}\u{E1B}\u{E23}\u{E30}\u{E40}\u{E20}\u{E17} ${args[0]} \u{E40}\u{E17}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{E44}\u{E21}\u{E48}\u{E2A}\u{E32}\u{E21}\u{E32}\u{E23}\u{E16}\u{E40}\u{E25}\u{E37}\u{E2D}\u{E01}\u{E19}\u{E49}\u{E2D}\u{E22}\u{E01}\u{E27}\u{E48}\u{E32} ${args[0]} ${name} \u{E44}\u{E14}\u{E49}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E21}\u{E35}\u{E04}\u{E48}\u{E32}\u{E2D}\u{E22}\u{E48}\u{E32}\u{E07}\u{E19}\u{E49}\u{E2D}\u{E22} ${args[0]}`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} \u{E44}\u{E21}\u{E48}\u{E43}\u{E0A}\u{E48}\u{E04}\u{E48}\u{E32} ${name} \u{E17}\u{E35}\u{E48}\u{E2D}\u{E19}\u{E38}\u{E0D}\u{E32}\u{E15}\u{E43}\u{E2B}\u{E49}\u{E01}\u{E23}\u{E2D}\u{E01}`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E1B}\u{E47}\u{E19}\u{E15}\u{E31}\u{E27}\u{E40}\u{E25}\u{E02}\u{E40}\u{E17}\u{E48}\u{E32}\u{E19}\u{E31}\u{E49}\u{E19}`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" \u0E2B\u0E23\u0E37\u0E2D ")} \u{E15}\u{E49}\u{E2D}\u{E07}\u{E01}\u{E32}\u{E23}.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `\u{E01}\u{E23}\u{E38}\u{E13}\u{E32}\u{E01}\u{E23}\u{E2D}\u{E01} ${$a262a7e50e5a100c$var$sentence(name)}`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{E08}\u{E30}\u{E15}\u{E49}\u{E2D}\u{E07}\u{E40}\u{E23}\u{E34}\u{E48}\u{E21}\u{E15}\u{E49}\u{E19}\u{E14}\u{E49}\u{E27}\u{E22} ${$a262a7e50e5a100c$var$list(args)}`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{E01}\u{E23}\u{E38}\u{E13}\u{E32}\u{E23}\u{E30}\u{E1A}\u{E38}\u{E17}\u{E35}\u{E48}\u{E2D}\u{E22}\u{E39}\u{E48}\u{E25}\u{E34}\u{E07}\u{E01}\u{E4C}\u{E43}\u{E2B}\u{E49}\u{E16}\u{E39}\u{E01}\u{E15}\u{E49}\u{E2D}\u{E07}`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07"
};
var $a262a7e50e5a100c$var$th = {
    ui: $a262a7e50e5a100c$var$ui40,
    validation: $a262a7e50e5a100c$var$validation40
};
var $a262a7e50e5a100c$var$ui41 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Ekle",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Kald\u0131r",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Hepsini kald\u0131r",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Maalesef, t\xfcm alanlar do\u011Fru doldurulmad\u0131.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "G\xf6nder",
    /**
   * Shown when no files are selected.
   */ noFiles: "Dosya yok",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Yukar\u0131 Ta\u015F\u0131",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "A\u015Fa\u011F\u0131 ta\u015F\u0131",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Y\xfckleniyor...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Daha fazla y\xfckle",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Sonraki",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\xd6nceki",
    /**
   * Shown when adding all values.
   */ addAllValues: "T\xfcm de\u011Ferleri ekle",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Se\xe7ili de\u011Ferleri ekle",
    /**
   * Shown when removing all values.
   */ removeAllValues: "T\xfcm de\u011Ferleri kald\u0131r",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Se\xe7ili de\u011Ferleri kald\u0131r",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Tarih se\xe7in",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Tarihi de\u011Fi\u015Ftir",
    /**
   * Shown when there is something to close
   */ close: "Kapat",
    /**
   * Shown when there is something to open.
   */ open: "A\xe7\u0131k"
};
var $a262a7e50e5a100c$var$validation41 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `L\xfctfen ${name}'yi kabul edin.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$date(args[0])}'den sonra olmal\u{131}d\u{131}r.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} gelecekte bir zaman olmal\u{131}d\u{131}r.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} sadece alfabetik karakterler i\xe7erebilir.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} sadece alfabetik karakterler ve say\u{131} i\xe7erebilir.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} yaln\u{131}zca harf ve bo\u{15F}luk i\xe7erebilir.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} alfabetik karakterler i\xe7ermelidir.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harf veya rakam\u{131} i\xe7ermelidir.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harf veya bo\u{15F}luk i\xe7ermelidir.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} sembol i\xe7ermelidir.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} b\xfcy\xfck harf i\xe7ermelidir.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} k\xfc\xe7\xfck harf i\xe7ermelidir.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} say\u{131} i\xe7ermelidir.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} bir sembol olmal\u{131}d\u{131}r.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} yaln\u{131}zca b\xfcy\xfck harfler i\xe7erebilir.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} yaln\u{131}zca k\xfc\xe7\xfck harfler i\xe7erebilir.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$date(args[0])} tarihinden \xf6nce olmal\u{131}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ge\xe7mi\u{15F}te olmal\u{131}.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Alan yanl\u{131}\u{15F} yap\u{131}land\u{131}r\u{131}lm\u{131}\u{15F} ve g\xf6nderilemez.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} ${a} ve ${b} aral\u{131}\u{11F}\u{131}nda olmal\u{131}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} e\u{15F}le\u{15F}miyor.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ge\xe7erli bir tarih de\u{11F}il, l\xfctfen ${args[0]} bi\xe7imini kullan\u{131}n.`;
        return "Alan yanl\u0131\u015F yap\u0131land\u0131r\u0131lm\u0131\u015F ve g\xf6nderilemez.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}, ${$a262a7e50e5a100c$var$date(args[0])} ve ${$a262a7e50e5a100c$var$date(args[1])} aral\u{131}\u{11F}\u{131}nda olmal\u{131}.`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "L\xfctfen ge\xe7erli bir e-mail adresi girin.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$list(args)} ile bitmiyor.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} izin verilen bir de\u{11F}er de\u{11F}il.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} en az\u{131}ndan bir karakter uzunlu\u{11F}unda olmal\u{131}.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} ${max}'e e\u{15F}it veya daha k\xfc\xe7\xfck olmal\u{131}.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} ${max} karakter uzunlu\u{11F}unda olmal\u{131}d\u{131}r.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} ${min}'e e\u{15F}it veya daha b\xfcy\xfck olmal\u{131}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)}, ${min} ve ${max} karakter uzunlu\u{11F}u aral\u{131}\u{11F}\u{131}nda olmal\u{131}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} izin verilen bir de\u{11F}er de\u{11F}il.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name}'in uzunlu\u{11F}u ${args[0]}'dan daha uzun olamaz.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} en az\u{131}ndan ${args[0]} uzunlu\u{11F}unda veya ona e\u{15F}it olmal\u{131}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Hi\xe7bir dosya t\xfcr\xfcne izin verilmez.";
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{15F}u tiplerden biri olmal\u{131}: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name}'in uzunlu\u{11F}u ${args[0]}'dan daha k\u{131}sa olamaz.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} en az\u{131}ndan ${args[0]} uzunlu\u{11F}unda olmal\u{131}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} ${name} olamaz.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} say\u{131} olmal\u{131}.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" veya ")} gereklidir.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} gerekli.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$list(args)} ile ba\u{15F}lam\u{131}yor.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `L\xfctfen ge\xe7erli bir URL girin.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Se\xe7ilen tarih ge\xe7ersiz."
};
var $a262a7e50e5a100c$var$tr = {
    ui: $a262a7e50e5a100c$var$ui41,
    validation: $a262a7e50e5a100c$var$validation41
};
var $a262a7e50e5a100c$var$ui42 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "\u0414\u043E\u0434\u0430\u0442\u0438",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0432\u0441\u0435",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u0412\u0438\u0431\u0430\u0447\u0442\u0435, \u043D\u0435 \u0432\u0441\u0456 \u043F\u043E\u043B\u044F \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u0456 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u0424\u0430\u0439\u043B \u043D\u0435 \u0432\u0438\u0431\u0440\u0430\u043D\u043E",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u0420\u0443\u0445\u0430\u0442\u0438\u0441\u044F \u0432\u0433\u043E\u0440\u0443",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u041F\u0435\u0440\u0435\u0441\u0443\u043D\u0443\u0442\u0438 \u0432\u043D\u0438\u0437",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435 \u0431\u0456\u043B\u044C\u0448\u0435",
    /**
   * Shown on buttons that navigate state forward
   */ next: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0432\u0441\u0456 \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u0412\u0438\u043B\u0443\u0447\u0438\u0442\u0438 \u0432\u0441\u0456 \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u0412\u0438\u043B\u0443\u0447\u0438\u0442\u0438 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0434\u0430\u0442\u0443",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u0434\u0430\u0442\u0443",
    /**
   * Shown when there is something to close
   */ close: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
    /**
   * Shown when there is something to open.
   */ open: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438"
};
var $a262a7e50e5a100c$var$validation42 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `\u{411}\u{443}\u{434}\u{44C} \u{43B}\u{430}\u{441}\u{43A}\u{430}, \u{43F}\u{440}\u{438}\u{439}\u{43C}\u{456}\u{442}\u{44C} ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `\u{414}\u{430}\u{442}\u{430} ${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{43D}\u{430} \u{431}\u{443}\u{442}\u{438} \u{43F}\u{456}\u{437}\u{43D}\u{456}\u{448}\u{435} \u{437}\u{430} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `\u{414}\u{430}\u{442}\u{430} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{432} \u{43C}\u{430}\u{439}\u{431}\u{443}\u{442}\u{43D}\u{44C}\u{43E}\u{43C}\u{443}.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43B}\u{438}\u{448}\u{435} \u{43B}\u{456}\u{442}\u{435}\u{440}\u{438}.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43B}\u{438}\u{448}\u{435} \u{43B}\u{456}\u{442}\u{435}\u{440}\u{438} \u{442}\u{430} \u{446}\u{438}\u{444}\u{440}\u{438}.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43B}\u{438}\u{448}\u{435} \u{43B}\u{456}\u{442}\u{435}\u{440}\u{438} \u{442}\u{430} \u{43F}\u{440}\u{43E}\u{431}\u{456}\u{43B}\u{438}.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{430}\u{43B}\u{444}\u{430}\u{432}\u{456}\u{442}\u{43D}\u{456} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{438}.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{431}\u{443}\u{43A}\u{432}\u{438} \u{430}\u{431}\u{43E} \u{446}\u{438}\u{444}\u{440}\u{438}.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43B}\u{456}\u{442}\u{435}\u{440}\u{438} \u{430}\u{431}\u{43E} \u{43F}\u{440}\u{43E}\u{431}\u{456}\u{43B}\u{438}.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{432}\u{435}\u{43B}\u{438}\u{43A}\u{456} \u{440}\u{435}\u{433}\u{456}\u{441}\u{442}\u{440}\u{438}.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43C}\u{430}\u{43B}\u{456} \u{440}\u{435}\u{433}\u{456}\u{441}\u{442}\u{440}\u{438}.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{435}\u{43D} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{446}\u{438}\u{444}\u{440}\u{438}.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{43E}\u{43C}.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43B}\u{438}\u{448}\u{435} \u{432}\u{435}\u{43B}\u{438}\u{43A}\u{456} \u{43B}\u{456}\u{442}\u{435}\u{440}\u{438}.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{43E}\u{436}\u{435} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{43B}\u{438}\u{448}\u{435} \u{43C}\u{430}\u{43B}\u{456} \u{43B}\u{456}\u{442}\u{435}\u{440}\u{438}.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `\u{414}\u{430}\u{442}\u{430} ${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{43D}\u{430} \u{431}\u{443}\u{442}\u{438} \u{440}\u{430}\u{43D}\u{456}\u{448}\u{435} \u{437}\u{430} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `\u{414}\u{430}\u{442}\u{430} ${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{43D}\u{430} \u{431}\u{443}\u{442}\u{438} \u{432} \u{43C}\u{438}\u{43D}\u{443}\u{43B}\u{43E}\u{43C}\u{443}.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{426}\u{435} \u{43F}\u{43E}\u{43B}\u{435} \u{437}\u{430}\u{43F}\u{43E}\u{432}\u{43D}\u{435}\u{43D}\u{43E} \u{43D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{43E} \u{456} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{435} \u{431}\u{443}\u{442}\u{438} \u{43D}\u{430}\u{434}\u{456}\u{441}\u{43B}\u{430}\u{43D}\u{43E}.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{43D}\u{43E} \u{431}\u{443}\u{442}\u{438} \u{43C}\u{456}\u{436} ${a} \u{442}\u{430} ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{435} \u{437}\u{431}\u{456}\u{433}\u{430}\u{454}\u{442}\u{44C}\u{441}\u{44F}.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{430}\u{454} \u{43D}\u{435}\u{43F}\u{440}\u{430}\u{432}\u{438}\u{43B}\u{44C}\u{43D}\u{443} \u{434}\u{430}\u{442}\u{443}. \u{411}\u{443}\u{434}\u{44C} \u{43B}\u{430}\u{441}\u{43A}\u{430}, \u{432}\u{438}\u{43A}\u{43E}\u{440}\u{438}\u{441}\u{442}\u{43E}\u{432}\u{443}\u{439}\u{442}\u{435} \u{444}\u{43E}\u{440}\u{43C}\u{430}\u{442} ${args[0]}.`;
        return "\u0426\u0435 \u043F\u043E\u043B\u0435 \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u043E \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E \u0456 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `\u{414}\u{430}\u{442}\u{430} ${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{43D}\u{430} \u{431}\u{443}\u{442}\u{438} \u{43C}\u{456}\u{436} ${$a262a7e50e5a100c$var$date(args[0])} \u{442}\u{430} ${$a262a7e50e5a100c$var$date(args[1])}.`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u0434\u0456\u0439\u0441\u043D\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43D}\u{435} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{43D}\u{43E} \u{437}\u{430}\u{43A}\u{456}\u{43D}\u{447}\u{443}\u{432}\u{430}\u{442}\u{438}\u{441}\u{44F} \u{43D}\u{430} ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{430}\u{454} \u{43D}\u{435}\u{43F}\u{440}\u{438}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F}.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{430}\u{454} \u{43C}\u{456}\u{441}\u{442}\u{438}\u{442}\u{438} \u{449}\u{43E}\u{43D}\u{430}\u{439}\u{43C}\u{435}\u{43D}\u{448}\u{435} \u{43E}\u{434}\u{438}\u{43D} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}.`;
        if (min == 0 && max) return `\u{414}\u{43E}\u{432}\u{436}\u{438}\u{43D}\u{430} \u{43F}\u{43E}\u{43B}\u{44F} ${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{43D}\u{430} \u{431}\u{443}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{448}\u{43E}\u{44E} \u{430}\u{431}\u{43E} \u{434}\u{43E}\u{440}\u{456}\u{432}\u{43D}\u{44E}\u{432}\u{430}\u{442}\u{438} ${max} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{430}\u{43C}.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{434}\u{43E}\u{432}\u{436}\u{438}\u{43D}\u{43E}\u{44E} ${max} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{456}\u{432}.`;
        if (min && max === Infinity) return `\u{414}\u{43E}\u{432}\u{436}\u{438}\u{43D}\u{430} \u{43F}\u{43E}\u{43B}\u{44F} ${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{43D}\u{430} \u{431}\u{443}\u{442}\u{438} \u{431}\u{456}\u{43B}\u{44C}\u{448}\u{43E}\u{44E} \u{430}\u{431}\u{43E} \u{434}\u{43E}\u{440}\u{456}\u{432}\u{43D}\u{44E}\u{432}\u{430}\u{442}\u{438} ${min} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{430}\u{43C}.`;
        return `\u{414}\u{43E}\u{432}\u{436}\u{438}\u{43D}\u{430} \u{43F}\u{43E}\u{43B}\u{44F} ${$a262a7e50e5a100c$var$sentence(name)} \u{43F}\u{43E}\u{432}\u{438}\u{43D}\u{43D}\u{430} \u{431}\u{443}\u{442}\u{438} \u{43C}\u{456}\u{436} ${min} \u{442}\u{430} ${max} \u{441}\u{438}\u{43C}\u{432}\u{43E}\u{43B}\u{430}\u{43C}\u{438}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{430}\u{454} \u{43D}\u{435}\u{43F}\u{440}\u{438}\u{43F}\u{443}\u{441}\u{442}\u{438}\u{43C}\u{435} \u{437}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F}.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{41D}\u{435} \u{43C}\u{43E}\u{436}\u{435} \u{431}\u{443}\u{442}\u{438} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{431}\u{456}\u{43B}\u{44C}\u{448}\u{435} \u{43D}\u{456}\u{436} ${args[0]} ${name}.`;
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{43C}\u{435}\u{43D}\u{448}\u{435} \u{430}\u{431}\u{43E} \u{434}\u{43E}\u{440}\u{456}\u{432}\u{43D}\u{44E}\u{432}\u{430}\u{442}\u{438} ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u041D\u0435 \u0432\u043A\u0430\u0437\u0430\u043D\u043E \u0434\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u0456 \u0442\u0438\u043F\u0438 \u0444\u0430\u0439\u043B\u0456\u0432.";
        return `\u{422}\u{438}\u{43F} \u{444}\u{430}\u{439}\u{43B}\u{443} \u{432} \u{43F}\u{43E}\u{43B}\u{456} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438}: ${args[0]}.`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{41D}\u{435} \u{43C}\u{43E}\u{436}\u{435} \u{431}\u{443}\u{442}\u{438} \u{432}\u{438}\u{431}\u{440}\u{430}\u{43D}\u{43E} \u{43C}\u{435}\u{43D}\u{448}\u{435} \u{43D}\u{456}\u{436} ${args[0]} ${name}.`;
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{43D}\u{435} \u{43C}\u{435}\u{43D}\u{448}\u{435} \u{43D}\u{456}\u{436} ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} \u{43D}\u{435} \u{434}\u{43E}\u{437}\u{432}\u{43E}\u{43B}\u{435}\u{43D}\u{43E} \u{432} \u{43F}\u{43E}\u{43B}\u{456} ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{447}\u{438}\u{441}\u{43B}\u{43E}\u{43C}.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" \u0430\u0431\u043E ")} \u{43F}\u{43E}\u{442}\u{440}\u{456}\u{431}\u{43D}\u{43E}.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{454} \u{43E}\u{431}\u{43E}\u{432}'\u{44F}\u{437}\u{43A}\u{43E}\u{432}\u{438}\u{43C}.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `\u{41F}\u{43E}\u{43B}\u{435} ${$a262a7e50e5a100c$var$sentence(name)} \u{43C}\u{430}\u{454} \u{43F}\u{43E}\u{447}\u{438}\u{43D}\u{430}\u{442}\u{438}\u{441}\u{44F} \u{437} ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{411}\u{443}\u{434}\u{44C} \u{43B}\u{430}\u{441}\u{43A}\u{430}, \u{432}\u{432}\u{435}\u{434}\u{456}\u{442}\u{44C} \u{43A}\u{43E}\u{440}\u{435}\u{43A}\u{442}\u{43D}\u{443} URL-\u{430}\u{434}\u{440}\u{435}\u{441}\u{443}.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u0412\u0438\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430 \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u0430."
};
var $a262a7e50e5a100c$var$uk = {
    ui: $a262a7e50e5a100c$var$ui42,
    validation: $a262a7e50e5a100c$var$validation42
};
var $a262a7e50e5a100c$var$ui43 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "Qo'shish",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "O'chirish",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Hammasini o'chirish",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Kechirasiz, barcha maydonlar to'g'ri to'ldirilmagan.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "Yuborish",
    /**
   * Shown when no files are selected.
   */ noFiles: "Hech qanday fayl tanlanmagan",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Yuqoriga ko\u2019taring",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Pastga siljish",
    /**
   * Shown when something is actively loading.
   */ isLoading: "Yuklanmoqda...",
    /**
   * Shown when there is more to load.
   */ loadMore: "Ko\u2019proq yuklang",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Keyingi",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Oldingi",
    /**
   * Shown when adding all values.
   */ addAllValues: `Barcha qiymatlarni qo'shish`,
    /**
   * Shown when adding selected values.
   */ addSelectedValues: `Tanlangan qiymatlarni qo\u{2BB}shish`,
    /**
   * Shown when removing all values.
   */ removeAllValues: "Barcha qiymatlarni olib tashlang",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Tanlangan qiymatlarni olib tashlash",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Sanani tanlang",
    /**
   * Shown when there is a date to change.
   */ changeDate: `O'zgartirish sanasi`,
    /**
   * Shown when there is something to close
   */ close: "Yopish",
    /**
   * Shown when there is something to open.
   */ open: "Ochiq"
};
var $a262a7e50e5a100c$var$validation43 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `${name} ni qabul qiling.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$date(args[0])} dan keyin bo'lishi kerak.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} kelajakda bo'lishi kerak.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} faqat alifbo tartibidagi belgilardan iborat bo'lishi mumkin.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} faqat harflar va raqamlardan iborat bo'lishi mumkin.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} faqat harf va bo'shliqlardan iborat bo'lishi mumkin.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} alfavit belgilarini o'z ichiga olishi kerak.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harflar yoki raqamlarni o'z ichiga olishi kerak.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} harflar yoki bo'shliqlar bo'lishi kerak.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} belgisi bo'lishi kerak.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} katta harfni o'z ichiga olishi kerak.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kichik harflarni o'z ichiga olishi kerak.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} raqamlarini o'z ichiga olishi kerak.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} belgisi bo'lishi kerak.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} faqat katta harflarni o'z ichiga olishi mumkin.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} faqat kichik harflarni o'z ichiga olishi mumkin.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$date(args[0])} dan oldin bo'lishi kerak`;
        return `${$a262a7e50e5a100c$var$sentence(name)} o'tmishda bo'lishi kerak.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Bu maydon noto'g'ri sozlangan va uni yuborib bo'lmaydi.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} ${a} va ${b} orasida bo'lishi kerak.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} mos emas.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} haqiqiy sana emas, iltimos ${args[0]} formatidan foydalaning`;
        return "Bu maydon noto'g'ri sozlangan va uni yuborib bo'lmaydi";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$date(args[0])} va ${$a262a7e50e5a100c$var$date(args[1])} oralig'ida bo'lishi kerak`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "Iltimos amaldagi e-mail manzilingizni kiriting.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$list(args)} bilan tugamaydi.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ruxsat etilgan qiymat emas.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} kamida bitta belgidan iborat bo'lishi kerak.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} ${max} ta belgidan kam yoki teng bo'lishi kerak.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} bo'lishi kerak ${max} belgilar uzun.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} ${min} ta belgidan ko'p yoki teng bo'lishi kerak.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ${min} va ${max} gacha belgilardan iborat bo'lishi kerak.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ruxsat etilgan qiymat emas.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${args[0]} ${name} dan ortiq bo'lishi mumkin emas.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ${args[0]} dan kichik yoki teng bo'lishi kerak.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "Fayl formatlariga ruxsat berilmagan.";
        return `${$a262a7e50e5a100c$var$sentence(name)} quyidagi turdagi bo'lishi kerak: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${args[0]} ${name} dan kam bo'lmasligi kerak.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} kamida ${args[0]} bo'lishi kerak.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `"${value}" ruxsat berilmagan ${name}.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} raqam bo'lishi kerak.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" yoki ")} kerak.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} talab qilinadi.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ${$a262a7e50e5a100c$var$list(args)} bilan boshlanmaydi.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Iltimos, tegishli URL manzilini kiriting.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Tanlangan sana yaroqsiz."
};
var $a262a7e50e5a100c$var$uz = {
    ui: $a262a7e50e5a100c$var$ui43,
    validation: $a262a7e50e5a100c$var$validation43
};
var $a262a7e50e5a100c$var$ui44 = {
    /**
   * Shown on buttons for adding new items.
   */ add: "Th\xeam",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "Xo\xe1",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "Xo\xe1 t\u1EA5t c\u1EA3",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "Xin l\u1ED7i, kh\xf4ng ph\u1EA3i t\u1EA5t c\u1EA3 c\xe1c tr\u01B0\u1EDDng \u0111\u1EC1u \u0111\u01B0\u1EE3c nh\u1EADp \u0111\xfang.",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "G\u1EEDi",
    /**
   * Shown when no files are selected.
   */ noFiles: "Ch\u01B0a ch\u1ECDn file",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "Di chuy\u1EC3n l\xean",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "Di chuy\u1EC3n xu\u1ED1ng",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u0110ang t\u1EA3i...",
    /**
   * Shown when there is more to load.
   */ loadMore: "T\u1EA3i th\xeam",
    /**
   * Shown on buttons that navigate state forward
   */ next: "Ti\u1EBFp",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "Tr\u01B0\u1EDBc",
    /**
   * Shown when adding all values.
   */ addAllValues: "Th\xeam t\u1EA5t c\u1EA3 c\xe1c gi\xe1 tr\u1ECB",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "Th\xeam c\xe1c gi\xe1 tr\u1ECB \u0111\xe3 ch\u1ECDn",
    /**
   * Shown when removing all values.
   */ removeAllValues: "Lo\u1EA1i b\u1ECF t\u1EA5t c\u1EA3 c\xe1c gi\xe1 tr\u1ECB",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "Lo\u1EA1i b\u1ECF c\xe1c gi\xe1 tr\u1ECB \u0111\xe3 ch\u1ECDn",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "Ch\u1ECDn ng\xe0y",
    /**
   * Shown when there is a date to change.
   */ changeDate: "Thay \u0111\u1ED5i ng\xe0y",
    /**
   * Shown when there is something to close
   */ close: "\u0110\xf3ng",
    /**
   * Shown when there is something to open.
   */ open: "M\u1EDF"
};
var $a262a7e50e5a100c$var$validation44 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `H\xe3y \u{111}\u{1ED3}ng \xfd v\u{1EDB}i ${name}.`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i sau ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i trong t\u{1B0}\u{1A1}ng lai.`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} c\xf3 th\u{1EC3} ch\u{1EC9} bao g\u{1ED3}m c\xe1c ch\u{1EEF} c\xe1i alphabet.`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} c\xf3 th\u{1EC3} ch\u{1EC9} bao g\u{1ED3}m c\xe1c ch\u{1EEF} c\xe1i v\xe0 ch\u{1EEF} s\u{1ED1}.`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ch\u{1EC9} c\xf3 th\u{1EC3} ch\u{1EE9}a c\xe1c ch\u{1EEF} c\xe1i v\xe0 kho\u{1EA3}ng tr\u{1EAF}ng.`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i ch\u{1EE9}a c\xe1c k\xfd t\u{1EF1} ch\u{1EEF} c\xe1i.`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i ch\u{1EE9}a ch\u{1EEF} c\xe1i ho\u{1EB7}c s\u{1ED1}.`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i ch\u{1EE9}a ch\u{1EEF} c\xe1i ho\u{1EB7}c d\u{1EA5}u c\xe1ch.`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i ch\u{1EE9}a k\xfd hi\u{1EC7}u.`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i ch\u{1EE9}a ch\u{1EEF} hoa.`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i ch\u{1EE9}a ch\u{1EEF} th\u{1B0}\u{1EDD}ng.`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i ch\u{1EE9}a s\u{1ED1}.`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i l\xe0 m\u{1ED9}t k\xfd hi\u{1EC7}u.`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ch\u{1EC9} c\xf3 th\u{1EC3} ch\u{1EE9}a ch\u{1EEF} hoa.`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ch\u{1EC9} c\xf3 th\u{1EC3} ch\u{1EE9}a ch\u{1EEF} th\u{1B0}\u{1EDD}ng.`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i tr\u{1B0}\u{1EDB}c ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i trong qu\xe1 kh\u{1EE9}.`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `Tr\u{1B0}\u{1EDD}ng n\xe0y \u{111}\xe3 \u{111}\u{1B0}\u{1EE3}c thi\u{1EBF}t l\u{1EAD}p sai v\xe0 kh\xf4ng th\u{1EC3} g\u{1EED}i.`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i \u{1EDF} gi\u{1EEF}a ${a} v\xe0 ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kh\xf4ng kh\u{1EDB}p.`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} kh\xf4ng ph\u{1EA3}i ng\xe0y h\u{1EE3}p l\u{1EC7}, h\xe3y s\u{1EED} d\u{1EE5}ng \u{111}\u{1ECB}nh d\u{1EA1}ng ${args[0]}`;
        return "Tr\u01B0\u1EDDng n\xe0y \u0111\xe3 \u0111\u01B0\u1EE3c thi\u1EBFt l\u1EADp sai v\xe0 kh\xf4ng th\u1EC3 g\u1EEDi.";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i \u{1EDF} gi\u{1EEF}a kho\u{1EA3}ng t\u{1EEB} ${$a262a7e50e5a100c$var$date(args[0])} \u{111}\u{1EBF}n ${$a262a7e50e5a100c$var$date(args[1])}.`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "H\xe3y nh\u1EADp m\u1ED9t \u0111\u1ECBa ch\u1EC9 email h\u1EE3p l\u1EC7.",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kh\xf4ng k\u{1EBF}t th\xfac v\u{1EDB}i ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kh\xf4ng ph\u{1EA3}i m\u{1ED9}t gi\xe1 tr\u{1ECB} \u{111}\u{1B0}\u{1EE3}c cho ph\xe9p.`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i c\xf3 \u{111}\u{1ED9} d\xe0i t\u{1ED1}i thi\u{1EC3}u m\u{1ED9}t k\xfd t\u{1EF1}.`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i c\xf3 \u{111}\u{1ED9} d\xe0i t\u{1ED1}i \u{111}a ${max} k\xfd t\u{1EF1}.`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} n\xean d\xe0i ${max} k\xfd t\u{1EF1}.`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i c\xf3 \u{111}\u{1ED9} d\xe0i t\u{1ED1}i thi\u{1EC3}u ${min} k\xfd t\u{1EF1}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i c\xf3 \u{111}\u{1ED9} d\xe0i t\u{1ED1}i \u{111}a trong kho\u{1EA3}ng t\u{1EEB} ${min} \u{111}\u{1EBF}n ${max} k\xfd t\u{1EF1}.`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kh\xf4ng ph\u{1EA3}i m\u{1ED9}t gi\xe1 tr\u{1ECB} \u{111}\u{1B0}\u{1EE3}c cho ph\xe9p.`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name} kh\xf4ng th\u{1EC3} l\u{1EDB}n h\u{1A1}n ${args[0]}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i t\u{1ED1}i \u{111}a b\u{1EB1}ng ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u0110\u1ECBnh d\u1EA1ng t\u1EC7p tin n\xe0y kh\xf4ng \u0111\u01B0\u1EE3c ph\xe9p.";
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i l\xe0 m\u{1ED9}t trong c\xe1c d\u{1EA1}ng: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name} kh\xf4ng th\u{1EC3} nh\u{1ECF} h\u{1A1}n ${args[0]}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i t\u{1ED1}i thi\u{1EC3}u b\u{1EB1}ng ${args[0]}.`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `"${value}" kh\xf4ng ph\u{1EA3}i gi\xe1 tr\u{1ECB} ${name} \u{111}\u{1B0}\u{1EE3}c ph\xe9p.`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} ph\u{1EA3}i l\xe0 m\u{1ED9}t s\u{1ED1}.`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join(" ho\u1EB7c ")} c\u{1EA7}n c\xf3.`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} l\xe0 b\u{1EAF}t bu\u{1ED9}c.`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} kh\xf4ng b\u{1EAF}t \u{111}\u{1EA7}u v\u{1EDB}i ${$a262a7e50e5a100c$var$list(args)}.`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `Vui l\xf2ng nh\u{1EAD}p m\u{1ED9}t URL h\u{1EE3}p l\u{1EC7}.`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "Ng\xe0y \u0111\xe3 ch\u1ECDn kh\xf4ng h\u1EE3p l\u1EC7."
};
var $a262a7e50e5a100c$var$vi = {
    ui: $a262a7e50e5a100c$var$ui44,
    validation: $a262a7e50e5a100c$var$validation44
};
var $a262a7e50e5a100c$var$ui45 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "\u6DFB\u52A0",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u79FB\u9664",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u79FB\u9664\u5168\u90E8",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u62B1\u6B49\uFF0C\u90E8\u5206\u5B57\u6BB5\u672A\u88AB\u6B63\u786E\u586B\u5199\u3002",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u63D0\u4EA4",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u672A\u9009\u62E9\u6587\u4EF6",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u4E0A\u79FB",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u4E0B\u79FB",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u52A0\u8F7D\u4E2D...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u52A0\u8F7D\u66F4\u591A",
    /**
   * Shown on buttons that navigate state forward
   */ next: "\u4E0B\u4E00\u6B65",
    /**
   * Shown on buttons that navigate state backward
   */ prev: "\u4E0A\u4E00\u6B65",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u6DFB\u52A0\u6240\u6709\u503C",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u6DFB\u52A0\u6240\u9009\u503C",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u79FB\u9664\u6240\u6709\u503C",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u79FB\u9664\u6240\u9009\u503C",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u9009\u62E9\u65E5\u671F",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u66F4\u6539\u65E5\u671F",
    /**
   * Shown when there is something to close
   */ close: "\u5173\u95ED",
    /**
   * Shown when there is something to open.
   */ open: "\u6253\u5F00"
};
var $a262a7e50e5a100c$var$validation45 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `\u{8BF7}\u{63A5}\u{53D7}${name}\u{3002}`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{665A}\u{4E8E}${$a262a7e50e5a100c$var$date(args[0])}\u{3002}`;
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{662F}\u{672A}\u{6765}\u{7684}\u{65E5}\u{671F}\u{3002}`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{53EA}\u{80FD}\u{5305}\u{542B}\u{82F1}\u{6587}\u{5B57}\u{6BCD}\u{3002}`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{53EA}\u{80FD}\u{5305}\u{542B}\u{5B57}\u{6BCD}\u{548C}\u{6570}\u{5B57}\u{3002}`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{53EA}\u{80FD}\u{5305}\u{542B}\u{5B57}\u{6BCD}\u{548C}\u{7A7A}\u{683C}\u{3002}`;
    },
    /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */ contains_alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{987B}\u{5305}\u{542B}\u{5B57}\u{6BCD}\u{5B57}\u{7B26}`;
    },
    /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */ contains_alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{987B}\u{5305}\u{542B}\u{5B57}\u{6BCD}\u{6216}\u{6570}\u{5B57}\u{3002}`;
    },
    /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */ contains_alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{987B}\u{5305}\u{542B}\u{5B57}\u{6BCD}\u{6216}\u{7A7A}\u{683C}\u{3002}`;
    },
    /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */ contains_symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{987B}\u{5305}\u{542B}\u{7B26}\u{53F7}\u{3002}`;
    },
    /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */ contains_uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{987B}\u{5305}\u{542B}\u{5927}\u{5199}\u{5B57}\u{6BCD}\u{3002}`;
    },
    /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */ contains_lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{987B}\u{5305}\u{542B}\u{5C0F}\u{5199}\u{5B57}\u{6BCD}\u{3002}`;
    },
    /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */ contains_numeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{987B}\u{5305}\u{542B}\u{6570}\u{5B57}\u{3002}`;
    },
    /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */ symbol ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{987B}\u{662F}\u{7B26}\u{53F7}\u{3002}`;
    },
    /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */ uppercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{53EA}\u{80FD}\u{5305}\u{542B}\u{5927}\u{5199}\u{5B57}\u{6BCD}\u{3002}`;
    },
    /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */ lowercase ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{53EA}\u{80FD}\u{5305}\u{542B}\u{5C0F}\u{5199}\u{5B57}\u{6BCD}\u{3002}`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{65E9}\u{4E8E}${$a262a7e50e5a100c$var$date(args[0])}\u{3002}`;
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{662F}\u{8FC7}\u{53BB}\u{7684}\u{65E5}\u{671F}\u{3002}`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{8BE5}\u{5B57}\u{6BB5}\u{672A}\u{88AB}\u{6B63}\u{786E}\u{8BBE}\u{7F6E}\u{800C}\u{65E0}\u{6CD5}\u{63D0}\u{4EA4}\u{3002}`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{5728}${a}\u{548C}${b}\u{4E4B}\u{95F4}\u{3002}`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{4E0D}\u{5339}\u{914D}\u{3002}`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)}\u{4E0D}\u{662F}\u{5408}\u{6CD5}\u{65E5}\u{671F}\u{FF0C}\u{8BF7}\u{4F7F}\u{7528} ${args[0]} \u{683C}\u{5F0F}`;
        return "\u8BE5\u5B57\u6BB5\u672A\u88AB\u6B63\u786E\u8BBE\u7F6E\u800C\u65E0\u6CD5\u63D0\u4EA4";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{5728}${$a262a7e50e5a100c$var$date(args[0])}\u{548C}${$a262a7e50e5a100c$var$date(args[1])}\u{4E4B}\u{95F4}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u8BF7\u8F93\u5165\u5408\u6CD5\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u3002",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{4EE5}${$a262a7e50e5a100c$var$list(args)}\u{7ED3}\u{5C3E}\u{3002}`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{662F}\u{4E0D}\u{5141}\u{8BB8}\u{7684}\u{3002}`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)}\u{81F3}\u{5C11}\u{8981}\u{6709}\u{4E00}\u{4E2A}\u{5B57}\u{7B26}\u{3002}`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{5C11}\u{4E8E}\u{6216}\u{7B49}\u{4E8E}${max}\u{4E2A}\u{5B57}\u{7B26}\u{3002}`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{5305}\u{542B}${max}\u{4E2A}\u{5B57}\u{7B26}\u{3002}`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{591A}\u{4E8E}\u{6216}\u{7B49}\u{4E8E}${min}\u{4E2A}\u{5B57}\u{7B26}\u{3002}`;
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{4ECB}\u{4E8E}${min}\u{548C}${max}\u{4E2A}\u{5B57}\u{7B26}\u{4E4B}\u{95F4}\u{3002}`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{662F}\u{4E0D}\u{5141}\u{8BB8}\u{7684}\u{3002}`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name}\u{4E0D}\u{5F97}\u{591A}\u{4E8E}${args[0]}\u{4E2A}\u{503C}\u{3002}`;
        return `${name}\u{4E0D}\u{5F97}\u{5927}\u{4E8E}${args[0]}\u{3002}`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u6CA1\u6709\u5141\u8BB8\u7684\u6587\u4EF6\u683C\u5F0F\u3002";
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{7684}\u{7C7B}\u{578B}\u{5FC5}\u{987B}\u{4E3A}\u{FF1A}${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `${name}\u{4E0D}\u{5F97}\u{5C11}\u{4E8E}${args[0]}\u{4E2A}\u{503C}\u{3002}`;
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{4E0D}\u{5F97}\u{5C0F}\u{4E8E}${args[0]}\u{3002}`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `"${value}"\u{4E0D}\u{662F}\u{4E00}\u{4E2A}\u{5408}\u{6CD5}\u{7684}${name}\u{3002}`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{4E3A}\u{6570}\u{5B57}\u{3002}`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join("\u6216")}${labels}\u{9700}\u{8981}\u{3002}`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{4E0D}\u{5F97}\u{7559}\u{7A7A}\u{3002}`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)}\u{5FC5}\u{987B}\u{4EE5}${$a262a7e50e5a100c$var$list(args)}\u{5F00}\u{5934}\u{3002}`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{8BF7}\u{8F93}\u{5165}\u{6709}\u{6548}\u{7684} URL\u{3002}`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u6240\u9009\u65E5\u671F\u65E0\u6548\u3002"
};
var $a262a7e50e5a100c$var$zh = {
    ui: $a262a7e50e5a100c$var$ui45,
    validation: $a262a7e50e5a100c$var$validation45
};
var $a262a7e50e5a100c$var$ui46 = {
    /**
   * Shown on a button for adding additional items.
   */ add: "\u65B0\u589E",
    /**
   * Shown when a button to remove items is visible.
   */ remove: "\u79FB\u9664",
    /**
   * Shown when there are multiple items to remove at the same time.
   */ removeAll: "\u79FB\u9664\u5168\u90E8",
    /**
   * Shown when all fields are not filled out correctly.
   */ incomplete: "\u5F88\u62B1\u6B49\uFF0C\u90E8\u5206\u6B04\u4F4D\u586B\u5BEB\u932F\u8AA4",
    /**
   * Shown in a button inside a form to submit the form.
   */ submit: "\u63D0\u4EA4",
    /**
   * Shown when no files are selected.
   */ noFiles: "\u5C1A\u672A\u9078\u53D6\u6A94\u6848",
    /**
   * Shown on buttons that move fields up in a list.
   */ moveUp: "\u4E0A\u79FB",
    /**
   * Shown on buttons that move fields down in a list.
   */ moveDown: "\u4E0B\u79FB",
    /**
   * Shown when something is actively loading.
   */ isLoading: "\u8F09\u5165\u4E2D...",
    /**
   * Shown when there is more to load.
   */ loadMore: "\u8F09\u5165\u66F4\u591A",
    /**
   * Show on buttons that navigate state forward
   */ next: "\u4E0B\u4E00\u500B",
    /**
   * Show on buttons that navigate state backward
   */ prev: "\u4E0A\u4E00\u500B",
    /**
   * Shown when adding all values.
   */ addAllValues: "\u52A0\u5165\u5168\u90E8\u7684\u503C",
    /**
   * Shown when adding selected values.
   */ addSelectedValues: "\u52A0\u5165\u9078\u53D6\u7684\u503C",
    /**
   * Shown when removing all values.
   */ removeAllValues: "\u79FB\u9664\u5168\u90E8\u7684\u503C",
    /**
   * Shown when removing selected values.
   */ removeSelectedValues: "\u79FB\u9664\u9078\u53D6\u7684\u503C",
    /**
   * Shown when there is a date to choose.
   */ chooseDate: "\u9078\u64C7\u65E5\u671F",
    /**
   * Shown when there is a date to change.
   */ changeDate: "\u8B8A\u66F4\u65E5\u671F",
    /**
   * Shown when there is something to close
   */ close: "\u95DC\u9589",
    /**
   * Shown when there is something to open.
   */ open: "\u958B\u653E"
};
var $a262a7e50e5a100c$var$validation46 = {
    /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */ accepted ({ name: name }) {
        return `\u{8ACB}\u{63A5}\u{53D7} ${name}`;
    },
    /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */ date_after ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{9808}\u{665A}\u{65BC} ${$a262a7e50e5a100c$var$date(args[0])}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{9808}\u{665A}\u{65BC}\u{4ECA}\u{65E5}`;
    },
    /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */ alpha ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{6B04}\u{4F4D}\u{5118}\u{80FD}\u{586B}\u{5BEB}\u{82F1}\u{6587}\u{5B57}\u{6BCD}`;
    },
    /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */ alphanumeric ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{6B04}\u{4F4D}\u{50C5}\u{80FD}\u{586B}\u{5BEB}\u{82F1}\u{6587}\u{5B57}\u{6BCD}\u{8207}\u{6578}\u{5B57}`;
    },
    /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */ alpha_spaces ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{6B04}\u{4F4D}\u{5118}\u{80FD}\u{586B}\u{5BEB}\u{82F1}\u{6587}\u{5B57}\u{6BCD}\u{8207}\u{7A7A}\u{767D}`;
    },
    /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */ date_before ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{9808}\u{65E9}\u{65BC} ${$a262a7e50e5a100c$var$date(args[0])}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{9808}\u{65E9}\u{65BC}\u{4ECA}\u{65E5}`;
    },
    /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */ between ({ name: name, args: args }) {
        if (isNaN(args[0]) || isNaN(args[1])) return `\u{6B04}\u{4F4D}\u{503C}\u{932F}\u{8AA4}\u{FF0C}\u{7121}\u{6CD5}\u{63D0}\u{4EA4}`;
        const [a, b] = $a262a7e50e5a100c$var$order(args[0], args[1]);
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{9808}\u{4ECB}\u{65BC} ${a} \u{548C} ${b}.`;
    },
    /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */ confirm ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{8207}\u{76EE}\u{6A19}\u{4E0D}\u{4E00}\u{81F4}`;
    },
    /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */ date_format ({ name: name, args: args }) {
        if (Array.isArray(args) && args.length) return `${$a262a7e50e5a100c$var$sentence(name)} \u{4E0D}\u{662F}\u{6709}\u{6548}\u{7684}\u{65E5}\u{671F}\u{FF0C}\u{8ACB}\u{4F7F}\u{7528} ${args[0]} \u{683C}\u{5F0F}`;
        return "\u6B04\u4F4D\u503C\u932F\u8AA4\uFF0C\u7121\u6CD5\u63D0\u4EA4";
    },
    /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */ date_between ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{9808}\u{4ECB}\u{65BC} ${$a262a7e50e5a100c$var$date(args[0])} \u{548C} ${$a262a7e50e5a100c$var$date(args[1])}`;
    },
    /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */ email: "\u8ACB\u8F38\u5165\u6709\u6548\u7684 email",
    /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */ ends_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{7684}\u{7D50}\u{5C3E}\u{5FC5}\u{9808}\u{662F} ${$a262a7e50e5a100c$var$list(args)}`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */ is ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{6B04}\u{4F4D}\u{7684}\u{503C}\u{4E0D}\u{5408}\u{898F}\u{5247}`;
    },
    /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */ length ({ name: name, args: [first = 0, second = Infinity] }) {
        const min = Number(first) <= Number(second) ? first : second;
        const max = Number(second) >= Number(first) ? second : first;
        if (min == 1 && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{6B04}\u{4F4D}\u{5FC5}\u{9808}\u{81F3}\u{5C11}\u{5305}\u{542B}\u{4E00}\u{500B}\u{5B57}`;
        if (min == 0 && max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{7684}\u{5B57}\u{6578}\u{5FC5}\u{9808}\u{5C0F}\u{65BC}\u{7B49}\u{65BC} ${max}`;
        if (min === max) return `${$a262a7e50e5a100c$var$sentence(name)} \u{7684}\u{5B57}\u{6578}\u{5FC5}\u{9808}\u{70BA} ${max}`;
        if (min && max === Infinity) return `${$a262a7e50e5a100c$var$sentence(name)} \u{7684}\u{5B57}\u{6578}\u{5FC5}\u{9808}\u{5927}\u{65BC}\u{7B49}\u{65BC} ${min}`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{7684}\u{5B57}\u{6578}\u{5FC5}\u{9808}\u{4ECB}\u{65BC} ${min} \u{548C} ${max}`;
    },
    /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */ matches ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{6B04}\u{4F4D}\u{7684}\u{503C}\u{7121}\u{6548}`;
    },
    /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */ max ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{4E0D}\u{80FD}\u{8D85}\u{904E} ${args[0]} \u{500B} ${name}.`;
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{5FC5}\u{9808}\u{5C0F}\u{65BC}\u{7B49}\u{65BC} ${args[0]}.`;
    },
    /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */ mime ({ name: name, args: args }) {
        if (!args[0]) return "\u975E\u6709\u6548\u7684\u6A94\u6848\u683C\u5F0F";
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{53EF}\u{63A5}\u{53D7}\u{7684}\u{6A94}\u{6848}\u{683C}\u{5F0F}\u{70BA}: ${args[0]}`;
    },
    /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */ min ({ name: name, node: { value: value }, args: args }) {
        if (Array.isArray(value)) return `\u{4E0D}\u{53EF}\u{5C11}\u{65BC} ${args[0]} \u{500B} ${name}`;
        return `${name} \u{5FC5}\u{9808}\u{5927}\u{65BC}\u{7B49}\u{65BC} ${args[0]}`;
    },
    /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */ not ({ name: name, node: { value: value } }) {
        return `\u{201C}${value}\u{201D} \u{4E0D}\u{662F} ${name} \u{6B04}\u{4F4D}\u{53EF}\u{63A5}\u{53D7}\u{7684}\u{503C}`;
    },
    /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */ number ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{6B04}\u{4F4D}\u{5FC5}\u{9808}\u{662F}\u{6578}\u{5B57}`;
    },
    /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */ require_one: ({ name: name, node: node, args: inputNames })=>{
        const labels = inputNames.map((name2)=>{
            const dependentNode = node.at(name2);
            if (dependentNode) return $06f542080289832c$export$543f455c924f61d5(dependentNode);
            return false;
        }).filter((name2)=>!!name2);
        labels.unshift(name);
        return `${labels.join("\u6216")}${labels}\u{9700}\u{8981}\u{3002}`;
    },
    /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */ required ({ name: name }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{662F}\u{5FC5}\u{8981}\u{6B04}\u{4F4D}`;
    },
    /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */ starts_with ({ name: name, args: args }) {
        return `${$a262a7e50e5a100c$var$sentence(name)} \u{7684}\u{958B}\u{982D}\u{5FC5}\u{9808}\u{662F} ${$a262a7e50e5a100c$var$list(args)}`;
    },
    /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */ url () {
        return `\u{8ACB}\u{8F38}\u{5165}\u{6709}\u{6548}\u{7684} url`;
    },
    /**
   * Shown when the date is invalid.
   */ invalidDate: "\u9078\u53D6\u7684\u65E5\u671F\u7121\u6548"
};
var $a262a7e50e5a100c$var$zhTW = {
    ui: $a262a7e50e5a100c$var$ui46,
    validation: $a262a7e50e5a100c$var$validation46
};
var $a262a7e50e5a100c$var$i18nNodes = /* @__PURE__ */ new Set();
var $a262a7e50e5a100c$var$activeLocale = null;
function $a262a7e50e5a100c$var$createI18nPlugin(registry) {
    return function i18nPlugin(node) {
        $a262a7e50e5a100c$var$i18nNodes.add(node);
        if ($a262a7e50e5a100c$var$activeLocale) node.config.locale = $a262a7e50e5a100c$var$activeLocale;
        node.on("destroying", ()=>$a262a7e50e5a100c$var$i18nNodes.delete(node));
        let localeKey = $a262a7e50e5a100c$var$parseLocale(node.config.locale, registry);
        let locale = localeKey ? registry[localeKey] : {};
        node.on("prop:locale", ({ payload: lang })=>{
            localeKey = $a262a7e50e5a100c$var$parseLocale(lang, registry);
            locale = localeKey ? registry[localeKey] : {};
            node.store.touch();
        });
        node.on("prop:label", ()=>node.store.touch());
        node.on("prop:validationLabel", ()=>node.store.touch());
        node.hook.text((fragment, next)=>{
            const key = fragment.meta?.messageKey || fragment.key;
            if ($639fe8cc1eae7e21$export$a4f4bb6b1453fff5(locale, fragment.type) && $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(locale[fragment.type], key)) {
                const t = locale[fragment.type][key];
                if (typeof t === "function") fragment.value = Array.isArray(fragment.meta?.i18nArgs) ? t(...fragment.meta.i18nArgs) : t(fragment);
                else fragment.value = t;
            }
            return next(fragment);
        });
    };
}
function $a262a7e50e5a100c$var$parseLocale(locale, availableLocales) {
    if ($639fe8cc1eae7e21$export$a4f4bb6b1453fff5(availableLocales, locale)) return locale;
    const [lang] = locale.split("-");
    if ($639fe8cc1eae7e21$export$a4f4bb6b1453fff5(availableLocales, lang)) return lang;
    for(const locale2 in availableLocales)return locale2;
    return false;
}
function $a262a7e50e5a100c$var$changeLocale(locale) {
    $a262a7e50e5a100c$var$activeLocale = locale;
    for (const node of $a262a7e50e5a100c$var$i18nNodes)node.config.locale = locale;
}
// packages/i18n/src/index.ts
var $a262a7e50e5a100c$var$locales = {
    ar: $a262a7e50e5a100c$var$ar,
    az: $a262a7e50e5a100c$var$az,
    bg: $a262a7e50e5a100c$var$bg,
    bs: $a262a7e50e5a100c$var$bs,
    ca: $a262a7e50e5a100c$var$ca,
    cs: $a262a7e50e5a100c$var$cs,
    da: $a262a7e50e5a100c$var$da,
    de: $a262a7e50e5a100c$var$de,
    el: $a262a7e50e5a100c$var$el,
    en: $a262a7e50e5a100c$var$en,
    es: $a262a7e50e5a100c$var$es,
    fa: $a262a7e50e5a100c$var$fa,
    fi: $a262a7e50e5a100c$var$fi,
    fr: $a262a7e50e5a100c$var$fr,
    fy: $a262a7e50e5a100c$var$fy,
    he: $a262a7e50e5a100c$var$he,
    hr: $a262a7e50e5a100c$var$hr,
    hu: $a262a7e50e5a100c$var$hu,
    id: $a262a7e50e5a100c$var$id,
    it: $a262a7e50e5a100c$var$it,
    ja: $a262a7e50e5a100c$var$ja,
    kk: $a262a7e50e5a100c$var$kk,
    ko: $a262a7e50e5a100c$var$ko,
    lt: $a262a7e50e5a100c$var$lt,
    lv: $a262a7e50e5a100c$var$lv,
    nb: $a262a7e50e5a100c$var$nb,
    nl: $a262a7e50e5a100c$var$nl,
    pl: $a262a7e50e5a100c$var$pl,
    pt: $a262a7e50e5a100c$var$pt,
    ro: $a262a7e50e5a100c$var$ro,
    ru: $a262a7e50e5a100c$var$ru,
    sk: $a262a7e50e5a100c$var$sk,
    sl: $a262a7e50e5a100c$var$sl,
    sr: $a262a7e50e5a100c$var$sr,
    sv: $a262a7e50e5a100c$var$sv,
    tet: $a262a7e50e5a100c$var$tet,
    tg: $a262a7e50e5a100c$var$tg,
    th: $a262a7e50e5a100c$var$th,
    tr: $a262a7e50e5a100c$var$tr,
    uk: $a262a7e50e5a100c$var$uk,
    uz: $a262a7e50e5a100c$var$uz,
    vi: $a262a7e50e5a100c$var$vi,
    zh: $a262a7e50e5a100c$var$zh,
    "zh-TW": $a262a7e50e5a100c$var$zhTW,
    is: $a262a7e50e5a100c$var$is,
    mn: $a262a7e50e5a100c$var$mn
};
$a262a7e50e5a100c$export$d24c54395ce0c509 = $a262a7e50e5a100c$var$ar;
$a262a7e50e5a100c$export$3d12bd131bb975d1 = $a262a7e50e5a100c$var$az;
$a262a7e50e5a100c$export$136fd86de524d3c2 = $a262a7e50e5a100c$var$bg;
$a262a7e50e5a100c$export$4e222d082f82ee97 = $a262a7e50e5a100c$var$bs;
$a262a7e50e5a100c$export$89e9012e902952b6 = $a262a7e50e5a100c$var$ca;
$a262a7e50e5a100c$export$7343075cd7f756c5 = $a262a7e50e5a100c$var$changeLocale;
$a262a7e50e5a100c$export$c69ea711f447870e = $a262a7e50e5a100c$var$createI18nPlugin;
$a262a7e50e5a100c$export$bde1ed0f60b38f2f = $a262a7e50e5a100c$var$cs;
$a262a7e50e5a100c$export$8c8450b83b664ba4 = $a262a7e50e5a100c$var$da;
$a262a7e50e5a100c$export$324d90190a8b822a = $a262a7e50e5a100c$var$date;
$a262a7e50e5a100c$export$2fa162a495d26869 = $a262a7e50e5a100c$var$de;
$a262a7e50e5a100c$export$c3da0dad1b44eea9 = $a262a7e50e5a100c$var$el;
$a262a7e50e5a100c$export$84584c2a98eb6753 = $a262a7e50e5a100c$var$en;
$a262a7e50e5a100c$export$ca5e4045a55e76d2 = $a262a7e50e5a100c$var$es;
$a262a7e50e5a100c$export$48a262eaf0aadda2 = $a262a7e50e5a100c$var$fa;
$a262a7e50e5a100c$export$ed5179c818622fb = $a262a7e50e5a100c$var$fi;
$a262a7e50e5a100c$export$acb2a88f7d552ebf = $a262a7e50e5a100c$var$fr;
$a262a7e50e5a100c$export$c0dcd1f2238f086d = $a262a7e50e5a100c$var$fy;
$a262a7e50e5a100c$export$10cc7d172bb7969 = $a262a7e50e5a100c$var$he;
$a262a7e50e5a100c$export$b4adb3f464574dcf = $a262a7e50e5a100c$var$hr;
$a262a7e50e5a100c$export$9901d21957972d53 = $a262a7e50e5a100c$var$hu;
$a262a7e50e5a100c$export$d560c7e4a29451c2 = $a262a7e50e5a100c$var$id;
$a262a7e50e5a100c$export$226b3eccf92c9ed9 = $a262a7e50e5a100c$var$is;
$a262a7e50e5a100c$export$3486a10f30cf1ee4 = $a262a7e50e5a100c$var$it;
$a262a7e50e5a100c$export$8c6f505e9474ce90 = $a262a7e50e5a100c$var$ja;
$a262a7e50e5a100c$export$4b04b6f14f77e727 = $a262a7e50e5a100c$var$kk;
$a262a7e50e5a100c$export$798cf677954c9533 = $a262a7e50e5a100c$var$ko;
$a262a7e50e5a100c$export$8837f4fc672e936d = $a262a7e50e5a100c$var$list;
$a262a7e50e5a100c$export$df1c34db1371eeed = $a262a7e50e5a100c$var$locales;
$a262a7e50e5a100c$export$b961576059b7aeb6 = $a262a7e50e5a100c$var$lt;
$a262a7e50e5a100c$export$54ca4d1eb7926f1 = $a262a7e50e5a100c$var$lv;
$a262a7e50e5a100c$export$e78c44be168181dc = $a262a7e50e5a100c$var$mn;
$a262a7e50e5a100c$export$38ef0e3f791a121e = $a262a7e50e5a100c$var$nb;
$a262a7e50e5a100c$export$9c64ee4d84d79ce1 = $a262a7e50e5a100c$var$nl;
$a262a7e50e5a100c$export$aaaeab0fac9a3ccb = $a262a7e50e5a100c$var$order;
$a262a7e50e5a100c$export$6ea5311eda92944f = $a262a7e50e5a100c$var$pl;
$a262a7e50e5a100c$export$84175d5f1cb4e39d = $a262a7e50e5a100c$var$pt;
$a262a7e50e5a100c$export$ea30ec7f37fb148d = $a262a7e50e5a100c$var$ro;
$a262a7e50e5a100c$export$cf48009033a0126b = $a262a7e50e5a100c$var$ru;
$a262a7e50e5a100c$export$ae6a5ab41f356242 = $a262a7e50e5a100c$var$sentence;
$a262a7e50e5a100c$export$d608fa5b5bfd2021 = $a262a7e50e5a100c$var$sk;
$a262a7e50e5a100c$export$c48c9775cb5125a6 = $a262a7e50e5a100c$var$sl;
$a262a7e50e5a100c$export$187592e8a03966af = $a262a7e50e5a100c$var$sr;
$a262a7e50e5a100c$export$65540e5f7f6e7dce = $a262a7e50e5a100c$var$sv;
$a262a7e50e5a100c$export$caa0a79844f1a673 = $a262a7e50e5a100c$var$tet;
$a262a7e50e5a100c$export$fe45ecdd3e49b545 = $a262a7e50e5a100c$var$tg;
$a262a7e50e5a100c$export$d657bc098992a431 = $a262a7e50e5a100c$var$th;
$a262a7e50e5a100c$export$72451b88a72ad9c2 = $a262a7e50e5a100c$var$tr;
$a262a7e50e5a100c$export$312745a8a3013c00 = $a262a7e50e5a100c$var$uk;
$a262a7e50e5a100c$export$461e3962c82dff4f = $a262a7e50e5a100c$var$uz;
$a262a7e50e5a100c$export$e3786bf10a8abdf2 = $a262a7e50e5a100c$var$vi;
$a262a7e50e5a100c$export$b65a7f08f2280505 = $a262a7e50e5a100c$var$zh;
$a262a7e50e5a100c$export$3991fdf1bb6f66b9 = $a262a7e50e5a100c$var$zhTW; //# sourceMappingURL=out.js.map
 //# sourceMappingURL=index.cjs.map


var $1b459c88f1929f4a$export$2de5f27892b805a;
var $1b459c88f1929f4a$export$a85ce4af57d6b2bc;
var $1b459c88f1929f4a$export$3364fcc330baceba;
var $1b459c88f1929f4a$export$24842cd1e1f3d46f;
var $1b459c88f1929f4a$export$db7f9ed9bf568723;
var $1b459c88f1929f4a$export$e324594224ef24da;
var $1b459c88f1929f4a$export$827f4ee28efc37;
var $1b459c88f1929f4a$export$c23431c9527ba83c;
var $1b459c88f1929f4a$export$a92079fdd70b94fa;
var $1b459c88f1929f4a$export$d0d4067a57339678;
var $1b459c88f1929f4a$export$2d975de0ff5c173c;
var $1b459c88f1929f4a$export$cd3a5ab9a642d6cf;
var $1b459c88f1929f4a$export$e28608303d03208c;
var $1b459c88f1929f4a$export$2ba01fb71ed41cb6;
var $1b459c88f1929f4a$export$bedd464e4425c72f;
var $1b459c88f1929f4a$export$47614749115bca3d;
var $1b459c88f1929f4a$export$9eecbb16f1974b2e;
var $1b459c88f1929f4a$export$b07e517d22efa1ca;
var $1b459c88f1929f4a$export$b5b4a55c683fb898;
var $1b459c88f1929f4a$export$35e9368ef982300f;
var $1b459c88f1929f4a$export$9e8a64b7e8d7f4c8;
var $1b459c88f1929f4a$export$f3a183bf2efcc835;
var $1b459c88f1929f4a$export$324d90190a8b822a;
var $1b459c88f1929f4a$export$7dda925e4d5db125;
var $1b459c88f1929f4a$export$46bdae34a7208737;
var $1b459c88f1929f4a$export$ca2f546e21dcce87;
var $1b459c88f1929f4a$export$e67d6a3cfb794f72;
var $1b459c88f1929f4a$export$330ddc712022f49b;
var $1b459c88f1929f4a$export$d290fa47940df19d;
var $1b459c88f1929f4a$export$35f5fe5f3e862ea3;
var $1b459c88f1929f4a$export$a38812d1aa1302d9;
var $1b459c88f1929f4a$export$c2a28f090bb0afd6;
var $1b459c88f1929f4a$export$5d5b61cfc3d870a9;
var $1b459c88f1929f4a$export$747c38e0dbf42300;
var $1b459c88f1929f4a$export$df3d8d727a3f9a33;
var $1b459c88f1929f4a$export$45547f6c19231c9;
var $1b459c88f1929f4a$export$96b575204aec369c;
var $1b459c88f1929f4a$export$3a444357c5f65f65;
var $1b459c88f1929f4a$export$967ce3543c950aeb;
var $1b459c88f1929f4a$export$6210fa4921d2a466;
var $1b459c88f1929f4a$export$326bce2259f858eb;
var $1b459c88f1929f4a$export$71730bae229ad1d;
var $1b459c88f1929f4a$export$f00aeb236b6f05af;
var $1b459c88f1929f4a$export$e5e25fbcc1f7affe;
var $1b459c88f1929f4a$export$34512e3b2db52a4e;
var $1b459c88f1929f4a$export$73920f18ca706874;
var $1b459c88f1929f4a$export$1ca1ec8b29a4ce27;
var $1b459c88f1929f4a$export$3943f6a2f9e1f610;
var $1b459c88f1929f4a$export$f36c9b20522c59e3;
var $1b459c88f1929f4a$export$4ae363f1d88fb658;
var $1b459c88f1929f4a$export$7b388ca536128c6d;
var $1b459c88f1929f4a$export$74e910429f6e69d1;
var $1b459c88f1929f4a$export$f7e911aee08201e7;
var $1b459c88f1929f4a$export$e9fd0e554af48a3b;
var $1b459c88f1929f4a$export$1237798dc640739a;
var $1b459c88f1929f4a$export$9a9b59e08de24cef;
var $1b459c88f1929f4a$export$8837f4fc672e936d;
var $1b459c88f1929f4a$export$b3bd0bc58e36cd63;
var $1b459c88f1929f4a$export$a8ecead220dd38a6;
var $1b459c88f1929f4a$export$defe85febe8b728c;
var $1b459c88f1929f4a$export$6990040ee07315;
var $1b459c88f1929f4a$export$af5de1609f06c8e6;
var $1b459c88f1929f4a$export$fedd547672325f13;
var $1b459c88f1929f4a$export$7e362809f088c235;
var $1b459c88f1929f4a$export$eb806c0b85b62f7a;
var $1b459c88f1929f4a$export$98e628dec113755e;
var $1b459c88f1929f4a$export$cc10c2220752a218;
var $1b459c88f1929f4a$export$a75d1723e6bda2ec;
var $1b459c88f1929f4a$export$fcc54c27da4fc173;
var $1b459c88f1929f4a$export$41c562ebe57d11e2;
var $1b459c88f1929f4a$export$e4f60e4df8811b1;
var $1b459c88f1929f4a$export$b9394e9ffbbc2ec7;
var $1b459c88f1929f4a$export$82e9f45cca5ba907;
var $1b459c88f1929f4a$export$b56dc0f160585b86;
var $1b459c88f1929f4a$export$3b403ceea8242d0a;
var $1b459c88f1929f4a$export$d02631cccf789723;
var $1b459c88f1929f4a$export$405f879a3148f344;
var $1b459c88f1929f4a$export$491e3fe6732c33f1;
var $1b459c88f1929f4a$export$d23afc634f3c7cc7;
var $1b459c88f1929f4a$export$b8f47637d11b035b;
var $1b459c88f1929f4a$export$d76128d007d19019;
var $1b459c88f1929f4a$export$2e6c959c16ff56b8;
var $1b459c88f1929f4a$export$4f502711de93d534;
var $1b459c88f1929f4a$export$2e44bf0978869fd4;
var $1b459c88f1929f4a$export$853c27de4ce0f746;
var $1b459c88f1929f4a$export$c94d76fb82ce4837;
var $1b459c88f1929f4a$export$559d1204393b53b9;
var $1b459c88f1929f4a$export$6d3b74af955b7df3;
var $1b459c88f1929f4a$export$6f093cfa640b7166;
var $1b459c88f1929f4a$export$181ff85155496734;
var $1b459c88f1929f4a$export$a3574df893ffa88d;
var $1b459c88f1929f4a$export$b3e13b598c0b8d61;
var $1b459c88f1929f4a$export$2da9be4cfdb689b1;
var $1b459c88f1929f4a$export$128fa18b7194ef;
var $1b459c88f1929f4a$export$aecd9c955413bc92;
var $1b459c88f1929f4a$export$36cb58223e61606e;
var $1b459c88f1929f4a$export$cc74dcc53cfce4eb;
'use strict';


// packages/inputs/src/plugin.ts
function $1b459c88f1929f4a$var$createLibraryPlugin(...libraries) {
    const library = libraries.reduce((merged, lib)=>$639fe8cc1eae7e21$export$8b58be045bf06082(merged, lib), {});
    const plugin = ()=>{};
    plugin.library = function(node) {
        const type = $639fe8cc1eae7e21$export$ddab50941423df32(node.props.type);
        if ($639fe8cc1eae7e21$export$a4f4bb6b1453fff5(library, type)) node.define(library[type]);
    };
    return plugin;
}
// packages/inputs/src/props.ts
var $1b459c88f1929f4a$var$runtimeProps = [
    "classes",
    "config",
    "delay",
    "errors",
    "id",
    "index",
    "inputErrors",
    "library",
    "modelValue",
    "onUpdate:modelValue",
    "name",
    "number",
    "parent",
    "plugins",
    "sectionsSchema",
    "type",
    "validation",
    "validationLabel",
    "validationMessages",
    "validationRules",
    // Runtime event props:
    "onInput",
    "onInputRaw",
    "onUpdate:modelValue",
    "onNode",
    "onSubmit",
    "onSubmitInvalid",
    "onSubmitRaw"
];
function $1b459c88f1929f4a$var$isGroupOption(option2) {
    return option2 && typeof option2 === "object" && "group" in option2 && Array.isArray(option2.options);
}
function $1b459c88f1929f4a$var$normalizeOptions(options2, i = {
    count: 1
}) {
    if (Array.isArray(options2)) return options2.map((option2)=>{
        if (typeof option2 === "string" || typeof option2 === "number") return {
            label: String(option2),
            value: String(option2)
        };
        if (typeof option2 == "object") {
            if ("group" in option2) {
                option2.options = $1b459c88f1929f4a$var$normalizeOptions(option2.options || [], i);
                return option2;
            } else if ("value" in option2 && typeof option2.value !== "string") Object.assign(option2, {
                value: `__mask_${i.count++}`,
                __original: option2.value
            });
        }
        return option2;
    });
    return Object.keys(options2).map((value)=>{
        return {
            label: options2[value],
            value: value
        };
    });
}
function $1b459c88f1929f4a$var$optionValue(options2, value, undefinedIfNotFound = false) {
    if (Array.isArray(options2)) for (const option2 of options2){
        if (typeof option2 !== "object" && option2) continue;
        if ($1b459c88f1929f4a$var$isGroupOption(option2)) {
            const found = $1b459c88f1929f4a$var$optionValue(option2.options, value, true);
            if (found !== void 0) return found;
        } else if (value == option2.value) return "__original" in option2 ? option2.__original : option2.value;
    }
    return undefinedIfNotFound ? void 0 : value;
}
function $1b459c88f1929f4a$var$shouldSelect(valueA, valueB) {
    if (valueA === null && valueB === void 0 || valueA === void 0 && valueB === null) return false;
    if (valueA == valueB) return true;
    if ($639fe8cc1eae7e21$export$d4c25d8e0539e508(valueA) && $639fe8cc1eae7e21$export$d4c25d8e0539e508(valueB)) return $639fe8cc1eae7e21$export$9663ddc1cf085b32(valueA, valueB);
    return false;
}
function $1b459c88f1929f4a$var$options(node) {
    node.hook.prop((prop, next)=>{
        var _a;
        if (prop.prop === "options") {
            if (typeof prop.value === "function") {
                node.props.optionsLoader = prop.value;
                prop.value = [];
            } else {
                (_a = node.props)._normalizeCounter ?? (_a._normalizeCounter = {
                    count: 1
                });
                prop.value = $1b459c88f1929f4a$var$normalizeOptions(prop.value, node.props._normalizeCounter);
            }
        }
        return next(prop);
    });
}
// @__NO_SIDE_EFFECTS__
function $1b459c88f1929f4a$var$createSection(section, el, fragment2 = false) {
    return (...children)=>{
        const extendable = (extensions)=>{
            const node = !el || typeof el === "string" ? {
                $el: el
            } : el();
            if ($0deed543ccab4a3d$export$41e30d8dd0ba7a50(node) || $0deed543ccab4a3d$export$3b2d240469e38cce(node)) {
                if (!node.meta) node.meta = {
                    section: section
                };
                else node.meta.section = section;
                if (children.length && !node.children) node.children = [
                    ...children.map((child)=>typeof child === "function" ? child(extensions) : child)
                ];
                if ($0deed543ccab4a3d$export$41e30d8dd0ba7a50(node)) node.attrs = {
                    class: `$classes.${section}`,
                    ...node.attrs || {}
                };
            }
            return {
                if: `$slots.${section}`,
                then: `$slots.${section}`,
                else: section in extensions ? /* @__PURE__ */ $1b459c88f1929f4a$var$extendSchema(node, extensions[section]) : node
            };
        };
        extendable._s = section;
        return fragment2 ? /* @__PURE__ */ $1b459c88f1929f4a$var$createRoot(extendable) : extendable;
    };
}
// @__NO_SIDE_EFFECTS__
function $1b459c88f1929f4a$var$createRoot(rootSection) {
    return (extensions)=>{
        return [
            rootSection(extensions)
        ];
    };
}
function $1b459c88f1929f4a$var$isSchemaObject(schema) {
    return !!(schema && typeof schema === "object" && ("$el" in schema || "$cmp" in schema || "$formkit" in schema));
}
// @__NO_SIDE_EFFECTS__
function $1b459c88f1929f4a$var$extendSchema(schema, extension = {}) {
    if (typeof schema === "string") return $1b459c88f1929f4a$var$isSchemaObject(extension) || typeof extension === "string" ? extension : schema;
    else if (Array.isArray(schema)) return $1b459c88f1929f4a$var$isSchemaObject(extension) ? extension : schema;
    return $639fe8cc1eae7e21$export$8b58be045bf06082(schema, extension);
}
// packages/inputs/src/sections/actions.ts
var $1b459c88f1929f4a$var$actions = $1b459c88f1929f4a$var$createSection("actions", ()=>({
        $el: "div",
        if: "$actions"
    }));
// packages/inputs/src/sections/box.ts
var $1b459c88f1929f4a$var$box = $1b459c88f1929f4a$var$createSection("input", ()=>({
        $el: "input",
        bind: "$attrs",
        attrs: {
            type: "$type",
            name: "$node.props.altName || $node.name",
            disabled: "$option.attrs.disabled || $disabled",
            onInput: "$handlers.toggleChecked",
            checked: "$fns.eq($_value, $onValue)",
            onBlur: "$handlers.blur",
            value: "$: true",
            id: "$id",
            "aria-describedby": {
                if: "$options.length",
                then: {
                    if: "$option.help",
                    then: '$: "help-" + $option.attrs.id',
                    else: void 0
                },
                else: {
                    if: "$help",
                    then: '$: "help-" + $id',
                    else: void 0
                }
            }
        }
    }));
// packages/inputs/src/sections/boxHelp.ts
var $1b459c88f1929f4a$var$boxHelp = $1b459c88f1929f4a$var$createSection("optionHelp", ()=>({
        $el: "div",
        if: "$option.help",
        attrs: {
            id: '$: "help-" + $option.attrs.id'
        }
    }));
// packages/inputs/src/sections/boxInner.ts
var $1b459c88f1929f4a$var$boxInner = $1b459c88f1929f4a$var$createSection("inner", "span");
// packages/inputs/src/sections/boxLabel.ts
var $1b459c88f1929f4a$var$boxLabel = $1b459c88f1929f4a$var$createSection("label", "span");
// packages/inputs/src/sections/boxOption.ts
var $1b459c88f1929f4a$var$boxOption = $1b459c88f1929f4a$var$createSection("option", ()=>({
        $el: "li",
        for: [
            "option",
            "$options"
        ],
        attrs: {
            "data-disabled": "$option.attrs.disabled || $disabled || undefined"
        }
    }));
// packages/inputs/src/sections/boxOptions.ts
var $1b459c88f1929f4a$var$boxOptions = $1b459c88f1929f4a$var$createSection("options", "ul");
// packages/inputs/src/sections/boxWrapper.ts
var $1b459c88f1929f4a$var$boxWrapper = $1b459c88f1929f4a$var$createSection("wrapper", ()=>({
        $el: "label",
        attrs: {
            "data-disabled": {
                if: "$options.length",
                then: void 0,
                else: "$disabled || undefined"
            },
            "data-checked": {
                if: "$options == undefined",
                then: "$fns.eq($_value, $onValue) || undefined",
                else: "$fns.isChecked($option.value) || undefined"
            }
        }
    }));
// packages/inputs/src/sections/buttonInput.ts
var $1b459c88f1929f4a$var$buttonInput = $1b459c88f1929f4a$var$createSection("input", ()=>({
        $el: "button",
        bind: "$attrs",
        attrs: {
            type: "$type",
            disabled: "$disabled",
            name: "$node.name",
            id: "$id"
        }
    }));
// packages/inputs/src/sections/buttonLabel.ts
var $1b459c88f1929f4a$var$buttonLabel = $1b459c88f1929f4a$var$createSection("default", null);
// packages/inputs/src/sections/decorator.ts
var $1b459c88f1929f4a$var$decorator = $1b459c88f1929f4a$var$createSection("decorator", ()=>({
        $el: "span",
        attrs: {
            "aria-hidden": "true"
        }
    }));
// packages/inputs/src/sections/fieldset.ts
var $1b459c88f1929f4a$var$fieldset = $1b459c88f1929f4a$var$createSection("fieldset", ()=>({
        $el: "fieldset",
        attrs: {
            id: "$id",
            "aria-describedby": {
                if: "$help",
                then: '$: "help-" + $id',
                else: void 0
            }
        }
    }));
// packages/inputs/src/sections/fileInput.ts
var $1b459c88f1929f4a$var$fileInput = $1b459c88f1929f4a$var$createSection("input", ()=>({
        $el: "input",
        bind: "$attrs",
        attrs: {
            type: "file",
            disabled: "$disabled",
            name: "$node.name",
            onChange: "$handlers.files",
            onBlur: "$handlers.blur",
            id: "$id",
            "aria-describedby": "$describedBy",
            "aria-required": "$state.required || undefined"
        }
    }));
// packages/inputs/src/sections/fileItem.ts
var $1b459c88f1929f4a$var$fileItem = $1b459c88f1929f4a$var$createSection("fileItem", ()=>({
        $el: "li",
        for: [
            "file",
            "$value"
        ]
    }));
// packages/inputs/src/sections/fileList.ts
var $1b459c88f1929f4a$var$fileList = $1b459c88f1929f4a$var$createSection("fileList", ()=>({
        $el: "ul",
        if: "$value.length",
        attrs: {
            "data-has-multiple": "$_hasMultipleFiles"
        }
    }));
// packages/inputs/src/sections/fileName.ts
var $1b459c88f1929f4a$var$fileName = $1b459c88f1929f4a$var$createSection("fileName", ()=>({
        $el: "span",
        attrs: {
            class: "$classes.fileName"
        }
    }));
// packages/inputs/src/sections/fileRemove.ts
var $1b459c88f1929f4a$var$fileRemove = $1b459c88f1929f4a$var$createSection("fileRemove", ()=>({
        $el: "button",
        attrs: {
            type: "button",
            onClick: "$handlers.resetFiles"
        }
    }));
// packages/inputs/src/sections/formInput.ts
var $1b459c88f1929f4a$var$formInput = $1b459c88f1929f4a$var$createSection("form", ()=>({
        $el: "form",
        bind: "$attrs",
        meta: {
            autoAnimate: true
        },
        attrs: {
            id: "$id",
            name: "$node.name",
            onSubmit: "$handlers.submit",
            "data-loading": "$state.loading || undefined"
        }
    }));
// packages/inputs/src/sections/fragment.ts
var $1b459c88f1929f4a$var$fragment = $1b459c88f1929f4a$var$createSection("wrapper", null, true);
// packages/inputs/src/sections/help.ts
var $1b459c88f1929f4a$var$help = $1b459c88f1929f4a$var$createSection("help", ()=>({
        $el: "div",
        if: "$help",
        attrs: {
            id: '$: "help-" + $id'
        }
    }));
// packages/inputs/src/sections/icon.ts
var $1b459c88f1929f4a$var$icon = (sectionKey, el)=>{
    return $1b459c88f1929f4a$var$createSection(`${sectionKey}Icon`, ()=>{
        const rawIconProp = `_raw${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}Icon`;
        return {
            if: `$${sectionKey}Icon && $${rawIconProp}`,
            $el: `${el ? el : "span"}`,
            attrs: {
                class: `$classes.${sectionKey}Icon + " " + $classes.icon`,
                innerHTML: `$${rawIconProp}`,
                onClick: `$handlers.iconClick(${sectionKey})`,
                role: `$fns.iconRole(${sectionKey})`,
                tabindex: `$fns.iconRole(${sectionKey}) === "button" && "0" || undefined`,
                for: {
                    if: `${el === "label"}`,
                    then: "$id"
                }
            }
        };
    })();
};
// packages/inputs/src/sections/inner.ts
var $1b459c88f1929f4a$var$inner = $1b459c88f1929f4a$var$createSection("inner", "div");
// packages/inputs/src/sections/label.ts
var $1b459c88f1929f4a$var$label = $1b459c88f1929f4a$var$createSection("label", ()=>({
        $el: "label",
        if: "$label",
        attrs: {
            for: "$id"
        }
    }));
// packages/inputs/src/sections/legend.ts
var $1b459c88f1929f4a$var$legend = $1b459c88f1929f4a$var$createSection("legend", ()=>({
        $el: "legend",
        if: "$label"
    }));
// packages/inputs/src/sections/message.ts
var $1b459c88f1929f4a$var$message = $1b459c88f1929f4a$var$createSection("message", ()=>({
        $el: "li",
        for: [
            "message",
            "$messages"
        ],
        attrs: {
            key: "$message.key",
            id: `$id + '-' + $message.key`,
            "data-message-type": "$message.type"
        }
    }));
// packages/inputs/src/sections/messages.ts
var $1b459c88f1929f4a$var$messages = $1b459c88f1929f4a$var$createSection("messages", ()=>({
        $el: "ul",
        if: "$defaultMessagePlacement && $fns.length($messages)"
    }));
// packages/inputs/src/sections/noFiles.ts
var $1b459c88f1929f4a$var$noFiles = $1b459c88f1929f4a$var$createSection("noFiles", ()=>({
        $el: "span",
        if: "$value == null || $value.length == 0"
    }));
// packages/inputs/src/sections/optGroup.ts
var $1b459c88f1929f4a$var$optGroup = $1b459c88f1929f4a$var$createSection("optGroup", ()=>({
        $el: "optgroup",
        bind: "$option.attrs",
        attrs: {
            label: "$option.group"
        }
    }));
// packages/inputs/src/sections/option.ts
var $1b459c88f1929f4a$var$option = $1b459c88f1929f4a$var$createSection("option", ()=>({
        $el: "option",
        bind: "$option.attrs",
        attrs: {
            class: "$classes.option",
            value: "$option.value",
            selected: "$fns.isSelected($option)"
        }
    }));
// packages/inputs/src/sections/optionSlot.ts
var $1b459c88f1929f4a$var$optionSlot = $1b459c88f1929f4a$var$createSection("options", ()=>({
        $el: null,
        if: "$options.length",
        for: [
            "option",
            "$option.options || $options"
        ]
    }));
// packages/inputs/src/sections/outer.ts
var $1b459c88f1929f4a$var$outer = $1b459c88f1929f4a$var$createSection("outer", ()=>({
        $el: "div",
        meta: {
            autoAnimate: true
        },
        attrs: {
            key: "$id",
            "data-family": "$family || undefined",
            "data-type": "$type",
            "data-multiple": '$attrs.multiple || ($type != "select" && $options != undefined) || undefined',
            "data-has-multiple": "$_hasMultipleFiles",
            "data-disabled": '$: ($disabled !== "false" && $disabled) || undefined',
            "data-empty": "$state.empty || undefined",
            "data-complete": "$state.complete || undefined",
            "data-invalid": "$state.invalid || undefined",
            "data-errors": "$state.errors || undefined",
            "data-submitted": "$state.submitted || undefined",
            "data-prefix-icon": "$_rawPrefixIcon !== undefined || undefined",
            "data-suffix-icon": "$_rawSuffixIcon !== undefined || undefined",
            "data-prefix-icon-click": "$onPrefixIconClick !== undefined || undefined",
            "data-suffix-icon-click": "$onSuffixIconClick !== undefined || undefined"
        }
    }));
// packages/inputs/src/sections/prefix.ts
var $1b459c88f1929f4a$var$prefix = $1b459c88f1929f4a$var$createSection("prefix", null);
// packages/inputs/src/sections/selectInput.ts
var $1b459c88f1929f4a$var$selectInput = $1b459c88f1929f4a$var$createSection("input", ()=>({
        $el: "select",
        bind: "$attrs",
        attrs: {
            id: "$id",
            "data-placeholder": "$fns.showPlaceholder($_value, $placeholder)",
            disabled: "$disabled",
            class: "$classes.input",
            name: "$node.name",
            onChange: "$handlers.onChange",
            onInput: "$handlers.selectInput",
            onBlur: "$handlers.blur",
            "aria-describedby": "$describedBy",
            "aria-required": "$state.required || undefined"
        }
    }));
// packages/inputs/src/sections/submitInput.ts
var $1b459c88f1929f4a$var$submitInput = $1b459c88f1929f4a$var$createSection("submit", ()=>({
        $cmp: "FormKit",
        bind: "$submitAttrs",
        props: {
            type: "submit",
            label: "$submitLabel"
        }
    }));
// packages/inputs/src/sections/suffix.ts
var $1b459c88f1929f4a$var$suffix = $1b459c88f1929f4a$var$createSection("suffix", null);
// packages/inputs/src/sections/textInput.ts
var $1b459c88f1929f4a$var$textInput = $1b459c88f1929f4a$var$createSection("input", ()=>({
        $el: "input",
        bind: "$attrs",
        attrs: {
            type: "$type",
            disabled: "$disabled",
            name: "$node.name",
            onInput: "$handlers.DOMInput",
            onBlur: "$handlers.blur",
            value: "$_value",
            id: "$id",
            "aria-describedby": "$describedBy",
            "aria-required": "$state.required || undefined"
        }
    }));
// packages/inputs/src/sections/textareaInput.ts
var $1b459c88f1929f4a$var$textareaInput = $1b459c88f1929f4a$var$createSection("input", ()=>({
        $el: "textarea",
        bind: "$attrs",
        attrs: {
            disabled: "$disabled",
            name: "$node.name",
            onInput: "$handlers.DOMInput",
            onBlur: "$handlers.blur",
            value: "$_value",
            id: "$id",
            "aria-describedby": "$describedBy",
            "aria-required": "$state.required || undefined"
        },
        children: "$initialValue"
    }));
// packages/inputs/src/sections/wrapper.ts
var $1b459c88f1929f4a$var$wrapper = $1b459c88f1929f4a$var$createSection("wrapper", "div");
// packages/inputs/src/features/renamesRadios.ts
var $1b459c88f1929f4a$var$radioInstance = 0;
function $1b459c88f1929f4a$var$resetRadio() {
    $1b459c88f1929f4a$var$radioInstance = 0;
}
function $1b459c88f1929f4a$var$renamesRadios(node) {
    if (node.type === "group" || node.type === "list") node.plugins.add($1b459c88f1929f4a$var$renamesRadiosPlugin);
}
function $1b459c88f1929f4a$var$renamesRadiosPlugin(node) {
    if (node.props.type === "radio") {
        node.addProps([
            "altName"
        ]);
        node.props.altName = `${node.name}_${$1b459c88f1929f4a$var$radioInstance++}`;
    }
}
function $1b459c88f1929f4a$var$normalizeBoxes(node) {
    return function(prop, next) {
        if (prop.prop === "options" && Array.isArray(prop.value)) {
            prop.value = prop.value.map((option2)=>{
                if (!option2.attrs?.id) return $639fe8cc1eae7e21$export$8b58be045bf06082(option2, {
                    attrs: {
                        id: `${node.props.id}-option-${$639fe8cc1eae7e21$export$c383cdd2a518017a(String(option2.value))}`
                    }
                });
                return option2;
            });
            if (node.props.type === "checkbox" && !Array.isArray(node.value)) {
                if (node.isCreated) node.input([], false);
                else node.on("created", ()=>{
                    if (!Array.isArray(node.value)) node.input([], false);
                });
            }
        }
        return next(prop);
    };
}
// packages/inputs/src/features/checkboxes.ts
function $1b459c88f1929f4a$var$toggleChecked(node, e) {
    const el = e.target;
    if (el instanceof HTMLInputElement) {
        const value = Array.isArray(node.props.options) ? $1b459c88f1929f4a$var$optionValue(node.props.options, el.value) : el.value;
        if (Array.isArray(node.props.options) && node.props.options.length) {
            if (!Array.isArray(node._value)) node.input([
                value
            ]);
            else if (!node._value.some((existingValue)=>$1b459c88f1929f4a$var$shouldSelect(value, existingValue))) node.input([
                ...node._value,
                value
            ]);
            else node.input(node._value.filter((existingValue)=>!$1b459c88f1929f4a$var$shouldSelect(value, existingValue)));
        } else if (el.checked) node.input(node.props.onValue);
        else node.input(node.props.offValue);
    }
}
function $1b459c88f1929f4a$var$isChecked(node, value) {
    node.context?.value;
    node.context?._value;
    if (Array.isArray(node._value)) return node._value.some((existingValue)=>$1b459c88f1929f4a$var$shouldSelect($1b459c88f1929f4a$var$optionValue(node.props.options, value), existingValue));
    return false;
}
function $1b459c88f1929f4a$var$checkboxes(node) {
    node.on("created", ()=>{
        if (node.context?.handlers) node.context.handlers.toggleChecked = $1b459c88f1929f4a$var$toggleChecked.bind(null, node);
        if (node.context?.fns) node.context.fns.isChecked = $1b459c88f1929f4a$var$isChecked.bind(null, node);
        if (!$639fe8cc1eae7e21$export$a4f4bb6b1453fff5(node.props, "onValue")) node.props.onValue = true;
        if (!$639fe8cc1eae7e21$export$a4f4bb6b1453fff5(node.props, "offValue")) node.props.offValue = false;
    });
    node.hook.prop($1b459c88f1929f4a$var$normalizeBoxes(node));
}
// packages/inputs/src/features/icon.ts
function $1b459c88f1929f4a$var$defaultIcon(sectionKey, defaultIcon2) {
    return (node)=>{
        if (node.props[`${sectionKey}Icon`] === void 0) node.props[`${sectionKey}Icon`] = defaultIcon2.startsWith("<svg") ? defaultIcon2 : `default:${defaultIcon2}`;
    };
}
function $1b459c88f1929f4a$var$disables(node) {
    node.on("created", ()=>{
        if ("disabled" in node.props) {
            node.props.disabled = $639fe8cc1eae7e21$export$96e6ef1411d879b1(node.props.disabled);
            node.config.disabled = $639fe8cc1eae7e21$export$96e6ef1411d879b1(node.props.disabled);
        }
    });
    node.hook.prop(({ prop: prop, value: value }, next)=>{
        value = prop === "disabled" ? $639fe8cc1eae7e21$export$96e6ef1411d879b1(value) : value;
        return next({
            prop: prop,
            value: value
        });
    });
    node.on("prop:disabled", ({ payload: value })=>{
        node.config.disabled = $639fe8cc1eae7e21$export$96e6ef1411d879b1(value);
    });
}
function $1b459c88f1929f4a$var$localize(key, value) {
    return (node)=>{
        node.store.set(/* @__PURE__ */ $0deed543ccab4a3d$export$62651879628e0c4c({
            key: key,
            type: "ui",
            value: value || key,
            meta: {
                localize: true,
                i18nArgs: [
                    node
                ]
            }
        }));
    };
}
// packages/inputs/src/features/files.ts
var $1b459c88f1929f4a$var$isBrowser = typeof window !== "undefined";
function $1b459c88f1929f4a$var$removeHover(e) {
    if (e.target instanceof HTMLElement && e.target.hasAttribute("data-file-hover")) e.target.removeAttribute("data-file-hover");
}
function $1b459c88f1929f4a$var$preventStrayDrop(type, e) {
    if (!(e.target instanceof HTMLInputElement)) e.preventDefault();
    else if (type === "dragover") e.target.setAttribute("data-file-hover", "true");
    if (type === "drop") $1b459c88f1929f4a$var$removeHover(e);
}
function $1b459c88f1929f4a$var$files(node) {
    $1b459c88f1929f4a$var$localize("noFiles", "Select file")(node);
    $1b459c88f1929f4a$var$localize("removeAll", "Remove all")(node);
    $1b459c88f1929f4a$var$localize("remove")(node);
    node.addProps([
        "_hasMultipleFiles"
    ]);
    if ($1b459c88f1929f4a$var$isBrowser) {
        if (!window._FormKit_File_Drop) {
            window.addEventListener("dragover", $1b459c88f1929f4a$var$preventStrayDrop.bind(null, "dragover"));
            window.addEventListener("drop", $1b459c88f1929f4a$var$preventStrayDrop.bind(null, "drop"));
            window.addEventListener("dragleave", $1b459c88f1929f4a$var$removeHover);
            window._FormKit_File_Drop = true;
        }
    }
    node.hook.input((value, next)=>next(Array.isArray(value) ? value : []));
    node.on("input", ({ payload: value })=>{
        node.props._hasMultipleFiles = Array.isArray(value) && value.length > 1 ? true : void 0;
    });
    node.on("reset", ()=>{
        if (node.props.id && $1b459c88f1929f4a$var$isBrowser) {
            const el = document.getElementById(node.props.id);
            if (el) el.value = "";
        }
    });
    node.on("created", ()=>{
        if (!Array.isArray(node.value)) node.input([], false);
        if (!node.context) return;
        node.context.handlers.resetFiles = (e)=>{
            e.preventDefault();
            node.input([]);
            if (node.props.id && $1b459c88f1929f4a$var$isBrowser) {
                const el = document.getElementById(node.props.id);
                if (el) el.value = "";
                el?.focus();
            }
        };
        node.context.handlers.files = (e)=>{
            const files2 = [];
            if (e.target instanceof HTMLInputElement && e.target.files) {
                for(let i = 0; i < e.target.files.length; i++){
                    let file2;
                    if (file2 = e.target.files.item(i)) files2.push({
                        name: file2.name,
                        file: file2
                    });
                }
                node.input(files2);
            }
            if (node.context) node.context.files = files2;
            if (typeof node.props.attrs?.onChange === "function") node.props.attrs?.onChange(e);
        };
    });
}
var $1b459c88f1929f4a$var$loading = /* @__PURE__ */ $0deed543ccab4a3d$export$62651879628e0c4c({
    key: "loading",
    value: true,
    visible: false
});
async function $1b459c88f1929f4a$var$handleSubmit(node, submitEvent) {
    const submitNonce = Math.random();
    node.props._submitNonce = submitNonce;
    submitEvent.preventDefault();
    await node.settled;
    if (node.ledger.value("validating")) {
        node.store.set($1b459c88f1929f4a$var$loading);
        await node.ledger.settled("validating");
        node.store.remove("loading");
        if (node.props._submitNonce !== submitNonce) return;
    }
    const setSubmitted = (n)=>n.store.set(/* @__PURE__ */ $0deed543ccab4a3d$export$62651879628e0c4c({
            key: "submitted",
            value: true,
            visible: false
        }));
    node.walk(setSubmitted);
    setSubmitted(node);
    node.emit("submit-raw");
    if (typeof node.props.onSubmitRaw === "function") node.props.onSubmitRaw(submitEvent, node);
    if (node.ledger.value("blocking")) {
        if (typeof node.props.onSubmitInvalid === "function") node.props.onSubmitInvalid(node);
        if (node.props.incompleteMessage !== false) $1b459c88f1929f4a$var$setIncompleteMessage(node);
    } else {
        if (typeof node.props.onSubmit === "function") {
            const retVal = node.props.onSubmit(node.hook.submit.dispatch($639fe8cc1eae7e21$export$9cd59f9826255e47(node.value)), node);
            if (retVal instanceof Promise) {
                const autoDisable = node.props.disabled === void 0 && node.props.submitBehavior !== "live";
                if (autoDisable) node.props.disabled = true;
                node.store.set($1b459c88f1929f4a$var$loading);
                await retVal;
                if (autoDisable) node.props.disabled = false;
                node.store.remove("loading");
            }
        } else if (submitEvent.target instanceof HTMLFormElement) submitEvent.target.submit();
    }
}
function $1b459c88f1929f4a$var$setIncompleteMessage(node) {
    node.store.set(/* @__PURE__ */ $0deed543ccab4a3d$export$62651879628e0c4c({
        blocking: false,
        key: `incomplete`,
        meta: {
            localize: node.props.incompleteMessage === void 0,
            i18nArgs: [
                {
                    node: node
                }
            ],
            showAsMessage: true
        },
        type: "ui",
        value: node.props.incompleteMessage || "Form incomplete."
    }));
}
function $1b459c88f1929f4a$var$form(node) {
    var _a;
    node.props.isForm = true;
    node.ledger.count("validating", (m)=>m.key === "validating");
    (_a = node.props).submitAttrs ?? (_a.submitAttrs = {
        disabled: node.props.disabled
    });
    node.on("prop:disabled", ({ payload: disabled })=>{
        node.props.submitAttrs = {
            ...node.props.submitAttrs,
            disabled: disabled
        };
    });
    node.on("created", ()=>{
        if (node.context?.handlers) node.context.handlers.submit = $1b459c88f1929f4a$var$handleSubmit.bind(null, node);
        if (!$639fe8cc1eae7e21$export$a4f4bb6b1453fff5(node.props, "actions")) node.props.actions = true;
    });
    node.on("prop:incompleteMessage", ()=>{
        if (node.store.incomplete) $1b459c88f1929f4a$var$setIncompleteMessage(node);
    });
    node.on("settled:blocking", ()=>node.store.remove("incomplete"));
}
// packages/inputs/src/features/ignores.ts
function $1b459c88f1929f4a$var$ignore(node) {
    if (node.props.ignore === void 0) {
        node.props.ignore = true;
        node.parent = null;
    }
}
// packages/inputs/src/features/initialValue.ts
function $1b459c88f1929f4a$var$initialValue(node) {
    node.on("created", ()=>{
        if (node.context) node.context.initialValue = node.value || "";
    });
}
// packages/inputs/src/features/casts.ts
function $1b459c88f1929f4a$var$casts(node) {
    if (typeof node.props.number === "undefined") return;
    const strict = [
        "number",
        "range",
        "hidden"
    ].includes(node.props.type);
    node.hook.input((value, next)=>{
        if (value === "") return next(void 0);
        const numericValue = node.props.number === "integer" ? parseInt(value) : parseFloat(value);
        if (!Number.isFinite(numericValue)) return strict ? next(void 0) : next(value);
        return next(numericValue);
    });
}
function $1b459c88f1929f4a$var$toggleChecked2(node, event) {
    if (event.target instanceof HTMLInputElement) node.input($1b459c88f1929f4a$var$optionValue(node.props.options, event.target.value));
}
function $1b459c88f1929f4a$var$isChecked2(node, value) {
    node.context?.value;
    node.context?._value;
    return $1b459c88f1929f4a$var$shouldSelect($1b459c88f1929f4a$var$optionValue(node.props.options, value), node._value);
}
function $1b459c88f1929f4a$var$radios(node) {
    node.on("created", ()=>{
        if (!Array.isArray(node.props.options)) $0deed543ccab4a3d$export$c106dd0671a0fc2d(350, {
            node: node,
            inputType: "radio"
        });
        if (node.context?.handlers) node.context.handlers.toggleChecked = $1b459c88f1929f4a$var$toggleChecked2.bind(null, node);
        if (node.context?.fns) node.context.fns.isChecked = $1b459c88f1929f4a$var$isChecked2.bind(null, node);
    });
    node.hook.prop($1b459c88f1929f4a$var$normalizeBoxes(node));
}
function $1b459c88f1929f4a$var$isSelected(node, option2) {
    if ($1b459c88f1929f4a$var$isGroupOption(option2)) return false;
    node.context && node.context.value;
    const optionValue2 = "__original" in option2 ? option2.__original : option2.value;
    return Array.isArray(node._value) ? node._value.some((optionA)=>$1b459c88f1929f4a$var$shouldSelect(optionA, optionValue2)) : (node._value === void 0 || node._value === null && !$1b459c88f1929f4a$var$containsValue(node.props.options, null)) && option2.attrs && option2.attrs["data-is-placeholder"] ? true : $1b459c88f1929f4a$var$shouldSelect(optionValue2, node._value);
}
function $1b459c88f1929f4a$var$containsValue(options2, value) {
    return options2.some((option2)=>{
        if ($1b459c88f1929f4a$var$isGroupOption(option2)) return $1b459c88f1929f4a$var$containsValue(option2.options, value);
        else return ("__original" in option2 ? option2.__original : option2.value) === value;
    });
}
async function $1b459c88f1929f4a$var$deferChange(node, e) {
    if (typeof node.props.attrs?.onChange === "function") {
        await new Promise((r)=>setTimeout(r, 0));
        await node.settled;
        node.props.attrs.onChange(e);
    }
}
function $1b459c88f1929f4a$var$selectInput2(node, e) {
    const target = e.target;
    const value = target.hasAttribute("multiple") ? Array.from(target.selectedOptions).map((o)=>$1b459c88f1929f4a$var$optionValue(node.props.options, o.value)) : $1b459c88f1929f4a$var$optionValue(node.props.options, target.value);
    node.input(value);
}
function $1b459c88f1929f4a$var$applyPlaceholder(options2, placeholder) {
    if (!options2.some((option2)=>option2.attrs && option2.attrs["data-is-placeholder"])) return [
        {
            label: placeholder,
            value: "",
            attrs: {
                hidden: true,
                disabled: true,
                "data-is-placeholder": "true"
            }
        },
        ...options2
    ];
    return options2;
}
function $1b459c88f1929f4a$var$firstValue(options2) {
    const option2 = options2.length > 0 ? options2[0] : void 0;
    if (!option2) return void 0;
    if ($1b459c88f1929f4a$var$isGroupOption(option2)) return $1b459c88f1929f4a$var$firstValue(option2.options);
    return "__original" in option2 ? option2.__original : option2.value;
}
function $1b459c88f1929f4a$var$select(node) {
    node.on("created", ()=>{
        const isMultiple = $639fe8cc1eae7e21$export$96e6ef1411d879b1(node.props.attrs?.multiple);
        if (!isMultiple && node.props.placeholder && Array.isArray(node.props.options)) {
            node.hook.prop(({ prop: prop, value: value }, next)=>{
                if (prop === "options") value = $1b459c88f1929f4a$var$applyPlaceholder(value, node.props.placeholder);
                return next({
                    prop: prop,
                    value: value
                });
            });
            node.props.options = $1b459c88f1929f4a$var$applyPlaceholder(node.props.options, node.props.placeholder);
        }
        if (isMultiple) {
            if (node.value === void 0) node.input([], false);
        } else if (node.context && !node.context.options) {
            node.props.attrs = Object.assign({}, node.props.attrs, {
                value: node._value
            });
            node.on("input", ({ payload: payload })=>{
                node.props.attrs = Object.assign({}, node.props.attrs, {
                    value: payload
                });
            });
        }
        if (node.context?.handlers) {
            node.context.handlers.selectInput = $1b459c88f1929f4a$var$selectInput2.bind(null, node);
            node.context.handlers.onChange = $1b459c88f1929f4a$var$deferChange.bind(null, node);
        }
        if (node.context?.fns) {
            node.context.fns.isSelected = $1b459c88f1929f4a$var$isSelected.bind(null, node);
            node.context.fns.showPlaceholder = (value, placeholder)=>{
                if (!Array.isArray(node.props.options)) return false;
                const hasMatchingValue = node.props.options.some((option2)=>{
                    if (option2.attrs && "data-is-placeholder" in option2.attrs) return false;
                    const optionValue2 = "__original" in option2 ? option2.__original : option2.value;
                    return $639fe8cc1eae7e21$export$9663ddc1cf085b32(value, optionValue2);
                });
                return placeholder && !hasMatchingValue ? true : void 0;
            };
        }
    });
    node.hook.input((value, next)=>{
        if (!node.props.placeholder && value === void 0 && Array.isArray(node.props?.options) && node.props.options.length && !$639fe8cc1eae7e21$export$96e6ef1411d879b1(node.props?.attrs?.multiple)) value = $1b459c88f1929f4a$var$firstValue(node.props.options);
        return next(value);
    });
}
// packages/inputs/src/compose.ts
// @__NO_SIDE_EFFECTS__
function $1b459c88f1929f4a$var$isSlotCondition(node) {
    if ($0deed543ccab4a3d$export$33d5b72ec833fd5f(node) && node.if && node.if.startsWith("$slots.") && typeof node.then === "string" && node.then.startsWith("$slots.") && "else" in node) return true;
    return false;
}
// @__NO_SIDE_EFFECTS__
function $1b459c88f1929f4a$var$findSection(schema, target) {
    return $1b459c88f1929f4a$var$eachSection(schema, (section, sectionCondition, parent)=>{
        if (section.meta?.section === target) return [
            parent,
            sectionCondition
        ];
        return;
    }, true) ?? [
        false,
        false
    ];
}
function $1b459c88f1929f4a$var$eachSection(schema, callback, stopOnCallbackReturn = false, schemaParent) {
    if (Array.isArray(schema)) {
        for (const node of schema){
            const callbackReturn = $1b459c88f1929f4a$var$eachSection(node, callback, stopOnCallbackReturn, schema);
            if (callbackReturn && stopOnCallbackReturn) return callbackReturn;
        }
        return;
    }
    if ($1b459c88f1929f4a$var$isSection(schema)) {
        const callbackReturn = callback(schema.else, schema, schemaParent);
        if (callbackReturn && stopOnCallbackReturn) return callbackReturn;
        return $1b459c88f1929f4a$var$eachSection(schema.else, callback, stopOnCallbackReturn, schema);
    } else if (($0deed543ccab4a3d$export$3b2d240469e38cce(schema) || $0deed543ccab4a3d$export$41e30d8dd0ba7a50(schema)) && schema.children) return $1b459c88f1929f4a$var$eachSection(schema.children, callback, stopOnCallbackReturn);
    else if ($0deed543ccab4a3d$export$33d5b72ec833fd5f(schema)) {
        let callbackReturn = void 0;
        if (schema.then && typeof schema.then !== "string") callbackReturn = $1b459c88f1929f4a$var$eachSection(schema.then, callback, stopOnCallbackReturn, schema);
        if (!callbackReturn && schema.else && typeof schema.else !== "string") callbackReturn = $1b459c88f1929f4a$var$eachSection(schema.else, callback, stopOnCallbackReturn, schema);
        if (callbackReturn && stopOnCallbackReturn) return callbackReturn;
    }
}
function $1b459c88f1929f4a$var$isSection(section) {
    if ($0deed543ccab4a3d$export$33d5b72ec833fd5f(section) && typeof section.then === "string" && section.else && typeof section.else !== "string" && !Array.isArray(section.else) && !$0deed543ccab4a3d$export$33d5b72ec833fd5f(section.else) && section.else.meta?.section) return true;
    return false;
}
// @__NO_SIDE_EFFECTS__
function $1b459c88f1929f4a$var$useSchema(inputSection, sectionsSchema = {}) {
    const schema = /* @__PURE__ */ $1b459c88f1929f4a$var$outer(/* @__PURE__ */ $1b459c88f1929f4a$var$wrapper(/* @__PURE__ */ $1b459c88f1929f4a$var$label("$label"), /* @__PURE__ */ $1b459c88f1929f4a$var$inner(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("prefix"), /* @__PURE__ */ $1b459c88f1929f4a$var$prefix(), inputSection(), /* @__PURE__ */ $1b459c88f1929f4a$var$suffix(), /* @__PURE__ */ $1b459c88f1929f4a$var$icon("suffix"))), /* @__PURE__ */ $1b459c88f1929f4a$var$help("$help"), /* @__PURE__ */ $1b459c88f1929f4a$var$messages(/* @__PURE__ */ $1b459c88f1929f4a$var$message("$message.value")));
    return (propSectionsSchema = {})=>schema($639fe8cc1eae7e21$export$8b58be045bf06082(sectionsSchema, propSectionsSchema));
}
// @__NO_SIDE_EFFECTS__
function $1b459c88f1929f4a$var$$attrs(attrs, section) {
    const extendable = (extensions)=>{
        const node = section(extensions);
        const attributes = typeof attrs === "function" ? attrs() : attrs;
        if (!$639fe8cc1eae7e21$export$a6cdc56e425d0d0a(attributes)) return node;
        if (/* @__PURE__ */ $1b459c88f1929f4a$var$isSlotCondition(node) && $0deed543ccab4a3d$export$41e30d8dd0ba7a50(node.else)) node.else.attrs = {
            ...node.else.attrs,
            ...attributes
        };
        else if ($0deed543ccab4a3d$export$41e30d8dd0ba7a50(node)) node.attrs = {
            ...node.attrs,
            ...attributes
        };
        return node;
    };
    extendable._s = section._s;
    return extendable;
}
// @__NO_SIDE_EFFECTS__
function $1b459c88f1929f4a$var$$if(condition, then, otherwise) {
    const extendable = (extensions)=>{
        const node = then(extensions);
        if (otherwise || $1b459c88f1929f4a$var$isSchemaObject(node) && "if" in node || /* @__PURE__ */ $1b459c88f1929f4a$var$isSlotCondition(node)) {
            const conditionalNode = {
                if: condition,
                then: node
            };
            if (otherwise) conditionalNode.else = otherwise(extensions);
            return conditionalNode;
        } else if (/* @__PURE__ */ $1b459c88f1929f4a$var$isSlotCondition(node)) Object.assign(node.else, {
            if: condition
        });
        else if ($1b459c88f1929f4a$var$isSchemaObject(node)) Object.assign(node, {
            if: condition
        });
        return node;
    };
    extendable._s = $639fe8cc1eae7e21$export$9e1725a4cfeada27();
    return extendable;
}
// @__NO_SIDE_EFFECTS__
function $1b459c88f1929f4a$var$$for(varName, inName, section) {
    return (extensions)=>{
        const node = section(extensions);
        if (/* @__PURE__ */ $1b459c88f1929f4a$var$isSlotCondition(node)) Object.assign(node.else, {
            for: [
                varName,
                inName
            ]
        });
        else if ($1b459c88f1929f4a$var$isSchemaObject(node)) Object.assign(node, {
            for: [
                varName,
                inName
            ]
        });
        return node;
    };
}
// @__NO_SIDE_EFFECTS__
function $1b459c88f1929f4a$var$$extend(section, extendWith) {
    const extendable = (extensions)=>{
        const node = section({});
        if (/* @__PURE__ */ $1b459c88f1929f4a$var$isSlotCondition(node)) {
            if (Array.isArray(node.else)) return node;
            node.else = $1b459c88f1929f4a$var$extendSchema($1b459c88f1929f4a$var$extendSchema(node.else, extendWith), section._s ? extensions[section._s] : {});
            return node;
        }
        return $1b459c88f1929f4a$var$extendSchema($1b459c88f1929f4a$var$extendSchema(node, extendWith), section._s ? extensions[section._s] : {});
    };
    extendable._s = section._s;
    return extendable;
}
// @__NO_SIDE_EFFECTS__
function $1b459c88f1929f4a$var$$root(section) {
    $0deed543ccab4a3d$export$c106dd0671a0fc2d(800, "$root");
    return $1b459c88f1929f4a$var$createRoot(section);
}
function $1b459c88f1929f4a$var$resetCounts() {
    $1b459c88f1929f4a$var$resetRadio();
}
// packages/inputs/src/inputs/button.ts
var $1b459c88f1929f4a$var$button = {
    /**
   * The actual schema of the input, or a function that returns the schema.
   */ schema: /* @__PURE__ */ $1b459c88f1929f4a$var$outer(/* @__PURE__ */ $1b459c88f1929f4a$var$messages(/* @__PURE__ */ $1b459c88f1929f4a$var$message("$message.value")), /* @__PURE__ */ $1b459c88f1929f4a$var$wrapper(/* @__PURE__ */ $1b459c88f1929f4a$var$buttonInput(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("prefix"), /* @__PURE__ */ $1b459c88f1929f4a$var$prefix(), /* @__PURE__ */ $1b459c88f1929f4a$var$buttonLabel("$label || $ui.submit.value"), /* @__PURE__ */ $1b459c88f1929f4a$var$suffix(), /* @__PURE__ */ $1b459c88f1929f4a$var$icon("suffix"))), /* @__PURE__ */ $1b459c88f1929f4a$var$help("$help")),
    /**
   * The type of node, can be a list, group, or input.
   */ type: "input",
    /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */ family: "button",
    /**
   * An array of extra props to accept for this input.
   */ props: [],
    /**
   * Additional features that should be added to your input
   */ features: [
        $1b459c88f1929f4a$var$localize("submit"),
        $1b459c88f1929f4a$var$ignore
    ],
    /**
   * A key to use for memoizing the schema. This is used to prevent the schema
   * from needing to be stringified when performing a memo lookup.
   */ schemaMemoKey: "h6st4epl3j8"
};
// packages/inputs/src/inputs/checkbox.ts
var $1b459c88f1929f4a$var$checkbox = {
    /**
   * The actual schema of the input, or a function that returns the schema.
   */ schema: /* @__PURE__ */ $1b459c88f1929f4a$var$outer($1b459c88f1929f4a$var$$if("$options == undefined", /**
       * Single checkbox structure.
       */ /* @__PURE__ */ $1b459c88f1929f4a$var$boxWrapper(/* @__PURE__ */ $1b459c88f1929f4a$var$boxInner(/* @__PURE__ */ $1b459c88f1929f4a$var$prefix(), /* @__PURE__ */ $1b459c88f1929f4a$var$box(), /* @__PURE__ */ $1b459c88f1929f4a$var$decorator(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("decorator")), /* @__PURE__ */ $1b459c88f1929f4a$var$suffix()), $1b459c88f1929f4a$var$$extend(/* @__PURE__ */ $1b459c88f1929f4a$var$boxLabel("$label"), {
        if: "$label"
    })), /**
       * Multi checkbox structure.
       */ /* @__PURE__ */ $1b459c88f1929f4a$var$fieldset(/* @__PURE__ */ $1b459c88f1929f4a$var$legend("$label"), /* @__PURE__ */ $1b459c88f1929f4a$var$help("$help"), /* @__PURE__ */ $1b459c88f1929f4a$var$boxOptions(/* @__PURE__ */ $1b459c88f1929f4a$var$boxOption(/* @__PURE__ */ $1b459c88f1929f4a$var$boxWrapper(/* @__PURE__ */ $1b459c88f1929f4a$var$boxInner(/* @__PURE__ */ $1b459c88f1929f4a$var$prefix(), $1b459c88f1929f4a$var$$extend(/* @__PURE__ */ $1b459c88f1929f4a$var$box(), {
        bind: "$option.attrs",
        attrs: {
            id: "$option.attrs.id",
            value: "$option.value",
            checked: "$fns.isChecked($option.value)"
        }
    }), /* @__PURE__ */ $1b459c88f1929f4a$var$decorator(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("decorator")), /* @__PURE__ */ $1b459c88f1929f4a$var$suffix()), $1b459c88f1929f4a$var$$extend(/* @__PURE__ */ $1b459c88f1929f4a$var$boxLabel("$option.label"), {
        if: "$option.label"
    })), /* @__PURE__ */ $1b459c88f1929f4a$var$boxHelp("$option.help"))))), // Help text only goes under the input when it is a single.
    $1b459c88f1929f4a$var$$if("$options == undefined && $help", /* @__PURE__ */ $1b459c88f1929f4a$var$help("$help")), /* @__PURE__ */ $1b459c88f1929f4a$var$messages(/* @__PURE__ */ $1b459c88f1929f4a$var$message("$message.value"))),
    /**
   * The type of node, can be a list, group, or input.
   */ type: "input",
    /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */ family: "box",
    /**
   * An array of extra props to accept for this input.
   */ props: [
        "options",
        "onValue",
        "offValue",
        "optionsLoader"
    ],
    /**
   * Additional features that should be added to your input
   */ features: [
        $1b459c88f1929f4a$var$options,
        $1b459c88f1929f4a$var$checkboxes,
        $1b459c88f1929f4a$var$defaultIcon("decorator", "checkboxDecorator")
    ],
    /**
   * The key used to memoize the schema.
   */ schemaMemoKey: "qje02tb3gu8"
};
// packages/inputs/src/inputs/file.ts
var $1b459c88f1929f4a$var$file = {
    /**
   * The actual schema of the input, or a function that returns the schema.
   */ schema: /* @__PURE__ */ $1b459c88f1929f4a$var$outer(/* @__PURE__ */ $1b459c88f1929f4a$var$wrapper(/* @__PURE__ */ $1b459c88f1929f4a$var$label("$label"), /* @__PURE__ */ $1b459c88f1929f4a$var$inner(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("prefix", "label"), /* @__PURE__ */ $1b459c88f1929f4a$var$prefix(), /* @__PURE__ */ $1b459c88f1929f4a$var$fileInput(), /* @__PURE__ */ $1b459c88f1929f4a$var$fileList(/* @__PURE__ */ $1b459c88f1929f4a$var$fileItem(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("fileItem"), /* @__PURE__ */ $1b459c88f1929f4a$var$fileName("$file.name"), $1b459c88f1929f4a$var$$if("$value.length === 1", /* @__PURE__ */ $1b459c88f1929f4a$var$fileRemove(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("fileRemove"), '$ui.remove.value + " " + $file.name')))), $1b459c88f1929f4a$var$$if("$value.length > 1", /* @__PURE__ */ $1b459c88f1929f4a$var$fileRemove("$ui.removeAll.value")), /* @__PURE__ */ $1b459c88f1929f4a$var$noFiles(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("noFiles"), "$ui.noFiles.value"), /* @__PURE__ */ $1b459c88f1929f4a$var$suffix(), /* @__PURE__ */ $1b459c88f1929f4a$var$icon("suffix"))), /* @__PURE__ */ $1b459c88f1929f4a$var$help("$help"), /* @__PURE__ */ $1b459c88f1929f4a$var$messages(/* @__PURE__ */ $1b459c88f1929f4a$var$message("$message.value"))),
    /**
   * The type of node, can be a list, group, or input.
   */ type: "input",
    /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */ family: "text",
    /**
   * An array of extra props to accept for this input.
   */ props: [],
    /**
   * Additional features that should be added to your input
   */ features: [
        $1b459c88f1929f4a$var$files,
        $1b459c88f1929f4a$var$defaultIcon("fileItem", "fileItem"),
        $1b459c88f1929f4a$var$defaultIcon("fileRemove", "fileRemove"),
        $1b459c88f1929f4a$var$defaultIcon("noFiles", "noFiles")
    ],
    /**
   * The key used to memoize the schema.
   */ schemaMemoKey: "9kqc4852fv8"
};
// packages/inputs/src/inputs/form.ts
var $1b459c88f1929f4a$var$form2 = {
    /**
   * The actual schema of the input, or a function that returns the schema.
   */ schema: /* @__PURE__ */ $1b459c88f1929f4a$var$formInput("$slots.default", /* @__PURE__ */ $1b459c88f1929f4a$var$messages(/* @__PURE__ */ $1b459c88f1929f4a$var$message("$message.value")), /* @__PURE__ */ $1b459c88f1929f4a$var$actions(/* @__PURE__ */ $1b459c88f1929f4a$var$submitInput())),
    /**
   * The type of node, can be a list, group, or input.
   */ type: "group",
    /**
   * An array of extra props to accept for this input.
   */ props: [
        "actions",
        "submit",
        "submitLabel",
        "submitAttrs",
        "submitBehavior",
        "incompleteMessage"
    ],
    /**
   * Additional features that should be added to your input
   */ features: [
        $1b459c88f1929f4a$var$form,
        $1b459c88f1929f4a$var$disables
    ],
    /**
   * The key used to memoize the schema.
   */ schemaMemoKey: "5bg016redjo"
};
// packages/inputs/src/inputs/group.ts
var $1b459c88f1929f4a$var$group = {
    /**
   * The actual schema of the input, or a function that returns the schema.
   */ schema: /* @__PURE__ */ $1b459c88f1929f4a$var$fragment("$slots.default"),
    /**
   * The type of node, can be a list, group, or input.
   */ type: "group",
    /**
   * An array of extra props to accept for this input.
   */ props: [],
    /**
   * Additional features that should be added to your input
   */ features: [
        $1b459c88f1929f4a$var$disables,
        $1b459c88f1929f4a$var$renamesRadios
    ]
};
// packages/inputs/src/inputs/hidden.ts
var $1b459c88f1929f4a$var$hidden = {
    /**
   * The actual schema of the input, or a function that returns the schema.
   */ schema: /* @__PURE__ */ $1b459c88f1929f4a$var$textInput(),
    /**
   * The type of node, can be a list, group, or input.
   */ type: "input",
    /**
   * An array of extra props to accept for this input.
   */ props: [],
    /**
   * Additional features that should be added to your input
   */ features: [
        $1b459c88f1929f4a$var$casts
    ]
};
// packages/inputs/src/inputs/list.ts
var $1b459c88f1929f4a$var$list = {
    /**
   * The actual schema of the input, or a function that returns the schema.
   */ schema: /* @__PURE__ */ $1b459c88f1929f4a$var$fragment("$slots.default"),
    /**
   * The type of node, can be a list, group, or input.
   */ type: "list",
    /**
   * An array of extra props to accept for this input.
   */ props: [
        "sync",
        "dynamic"
    ],
    /**
   * Additional features that should be added to your input
   */ features: [
        $1b459c88f1929f4a$var$disables,
        $1b459c88f1929f4a$var$renamesRadios
    ]
};
// packages/inputs/src/inputs/meta.ts
var $1b459c88f1929f4a$var$meta = {
    /**
   * The actual schema of the input, or a function that returns the schema.
   */ schema: /* @__PURE__ */ $1b459c88f1929f4a$var$fragment(),
    /**
   * The type of node, can be a list, group, or input.
   */ type: "input",
    /**
   * An array of extra props to accept for this input.
   */ props: [],
    /**
   * Additional features that should be added to your input
   */ features: []
};
// packages/inputs/src/inputs/radio.ts
var $1b459c88f1929f4a$var$radio = {
    /**
   * The actual schema of the input, or a function that returns the schema.
   */ schema: /* @__PURE__ */ $1b459c88f1929f4a$var$outer($1b459c88f1929f4a$var$$if("$options == undefined", /**
       * Single radio structure.
       */ /* @__PURE__ */ $1b459c88f1929f4a$var$boxWrapper(/* @__PURE__ */ $1b459c88f1929f4a$var$boxInner(/* @__PURE__ */ $1b459c88f1929f4a$var$prefix(), /* @__PURE__ */ $1b459c88f1929f4a$var$box(), /* @__PURE__ */ $1b459c88f1929f4a$var$decorator(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("decorator")), /* @__PURE__ */ $1b459c88f1929f4a$var$suffix()), $1b459c88f1929f4a$var$$extend(/* @__PURE__ */ $1b459c88f1929f4a$var$boxLabel("$label"), {
        if: "$label"
    })), /**
       * Multi radio structure.
       */ /* @__PURE__ */ $1b459c88f1929f4a$var$fieldset(/* @__PURE__ */ $1b459c88f1929f4a$var$legend("$label"), /* @__PURE__ */ $1b459c88f1929f4a$var$help("$help"), /* @__PURE__ */ $1b459c88f1929f4a$var$boxOptions(/* @__PURE__ */ $1b459c88f1929f4a$var$boxOption(/* @__PURE__ */ $1b459c88f1929f4a$var$boxWrapper(/* @__PURE__ */ $1b459c88f1929f4a$var$boxInner(/* @__PURE__ */ $1b459c88f1929f4a$var$prefix(), $1b459c88f1929f4a$var$$extend(/* @__PURE__ */ $1b459c88f1929f4a$var$box(), {
        bind: "$option.attrs",
        attrs: {
            id: "$option.attrs.id",
            value: "$option.value",
            checked: "$fns.isChecked($option.value)"
        }
    }), /* @__PURE__ */ $1b459c88f1929f4a$var$decorator(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("decorator")), /* @__PURE__ */ $1b459c88f1929f4a$var$suffix()), $1b459c88f1929f4a$var$$extend(/* @__PURE__ */ $1b459c88f1929f4a$var$boxLabel("$option.label"), {
        if: "$option.label"
    })), /* @__PURE__ */ $1b459c88f1929f4a$var$boxHelp("$option.help"))))), // Help text only goes under the input when it is a single.
    $1b459c88f1929f4a$var$$if("$options == undefined && $help", /* @__PURE__ */ $1b459c88f1929f4a$var$help("$help")), /* @__PURE__ */ $1b459c88f1929f4a$var$messages(/* @__PURE__ */ $1b459c88f1929f4a$var$message("$message.value"))),
    /**
   * The type of node, can be a list, group, or input.
   */ type: "input",
    /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */ family: "box",
    /**
   * An array of extra props to accept for this input.
   */ props: [
        "options",
        "onValue",
        "offValue",
        "optionsLoader"
    ],
    /**
   * Additional features that should be added to your input
   */ features: [
        $1b459c88f1929f4a$var$options,
        $1b459c88f1929f4a$var$radios,
        $1b459c88f1929f4a$var$defaultIcon("decorator", "radioDecorator")
    ],
    /**
   * The key used to memoize the schema.
   */ schemaMemoKey: "qje02tb3gu8"
};
// packages/inputs/src/inputs/select.ts
var $1b459c88f1929f4a$var$select2 = {
    /**
   * The actual schema of the input, or a function that returns the schema.
   */ schema: /* @__PURE__ */ $1b459c88f1929f4a$var$outer(/* @__PURE__ */ $1b459c88f1929f4a$var$wrapper(/* @__PURE__ */ $1b459c88f1929f4a$var$label("$label"), /* @__PURE__ */ $1b459c88f1929f4a$var$inner(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("prefix"), /* @__PURE__ */ $1b459c88f1929f4a$var$prefix(), /* @__PURE__ */ $1b459c88f1929f4a$var$selectInput($1b459c88f1929f4a$var$$if("$slots.default", ()=>"$slots.default", /* @__PURE__ */ $1b459c88f1929f4a$var$optionSlot($1b459c88f1929f4a$var$$if("$option.group", /* @__PURE__ */ $1b459c88f1929f4a$var$optGroup(/* @__PURE__ */ $1b459c88f1929f4a$var$optionSlot(/* @__PURE__ */ $1b459c88f1929f4a$var$option("$option.label"))), /* @__PURE__ */ $1b459c88f1929f4a$var$option("$option.label"))))), $1b459c88f1929f4a$var$$if("$attrs.multiple !== undefined", ()=>"", /* @__PURE__ */ $1b459c88f1929f4a$var$icon("select")), /* @__PURE__ */ $1b459c88f1929f4a$var$suffix(), /* @__PURE__ */ $1b459c88f1929f4a$var$icon("suffix"))), /* @__PURE__ */ $1b459c88f1929f4a$var$help("$help"), /* @__PURE__ */ $1b459c88f1929f4a$var$messages(/* @__PURE__ */ $1b459c88f1929f4a$var$message("$message.value"))),
    /**
   * The type of node, can be a list, group, or input.
   */ type: "input",
    /**
   * An array of extra props to accept for this input.
   */ props: [
        "options",
        "placeholder",
        "optionsLoader"
    ],
    /**
   * Additional features that should be added to your input
   */ features: [
        $1b459c88f1929f4a$var$options,
        $1b459c88f1929f4a$var$select,
        $1b459c88f1929f4a$var$defaultIcon("select", "select")
    ],
    /**
   * The key used to memoize the schema.
   */ schemaMemoKey: "cb119h43krg"
};
// packages/inputs/src/inputs/textarea.ts
var $1b459c88f1929f4a$var$textarea = {
    /**
   * The actual schema of the input, or a function that returns the schema.
   */ schema: /* @__PURE__ */ $1b459c88f1929f4a$var$outer(/* @__PURE__ */ $1b459c88f1929f4a$var$wrapper(/* @__PURE__ */ $1b459c88f1929f4a$var$label("$label"), /* @__PURE__ */ $1b459c88f1929f4a$var$inner(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("prefix", "label"), /* @__PURE__ */ $1b459c88f1929f4a$var$prefix(), /* @__PURE__ */ $1b459c88f1929f4a$var$textareaInput(), /* @__PURE__ */ $1b459c88f1929f4a$var$suffix(), /* @__PURE__ */ $1b459c88f1929f4a$var$icon("suffix"))), /* @__PURE__ */ $1b459c88f1929f4a$var$help("$help"), /* @__PURE__ */ $1b459c88f1929f4a$var$messages(/* @__PURE__ */ $1b459c88f1929f4a$var$message("$message.value"))),
    /**
   * The type of node, can be a list, group, or input.
   */ type: "input",
    /**
   * An array of extra props to accept for this input.
   */ props: [],
    /**
   * Additional features that should be added to your input
   */ features: [
        $1b459c88f1929f4a$var$initialValue
    ],
    /**
   * The key used to memoize the schema.
   */ schemaMemoKey: "b1n0td79m9g"
};
// packages/inputs/src/inputs/text.ts
var $1b459c88f1929f4a$var$text = {
    /**
   * The actual schema of the input, or a function that returns the schema.
   */ schema: /* @__PURE__ */ $1b459c88f1929f4a$var$outer(/* @__PURE__ */ $1b459c88f1929f4a$var$wrapper(/* @__PURE__ */ $1b459c88f1929f4a$var$label("$label"), /* @__PURE__ */ $1b459c88f1929f4a$var$inner(/* @__PURE__ */ $1b459c88f1929f4a$var$icon("prefix", "label"), /* @__PURE__ */ $1b459c88f1929f4a$var$prefix(), /* @__PURE__ */ $1b459c88f1929f4a$var$textInput(), /* @__PURE__ */ $1b459c88f1929f4a$var$suffix(), /* @__PURE__ */ $1b459c88f1929f4a$var$icon("suffix"))), /* @__PURE__ */ $1b459c88f1929f4a$var$help("$help"), /* @__PURE__ */ $1b459c88f1929f4a$var$messages(/* @__PURE__ */ $1b459c88f1929f4a$var$message("$message.value"))),
    /**
   * The type of node, can be a list, group, or input.
   */ type: "input",
    /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */ family: "text",
    /**
   * An array of extra props to accept for this input.
   */ props: [],
    /**
   * Additional features that should be added to your input
   */ features: [
        $1b459c88f1929f4a$var$casts
    ],
    /**
   * The key used to memoize the schema.
   */ schemaMemoKey: "c3cc4kflsg"
};
// packages/inputs/src/index.ts
var $1b459c88f1929f4a$var$inputs = {
    button: $1b459c88f1929f4a$var$button,
    submit: $1b459c88f1929f4a$var$button,
    checkbox: $1b459c88f1929f4a$var$checkbox,
    file: $1b459c88f1929f4a$var$file,
    form: $1b459c88f1929f4a$var$form2,
    group: $1b459c88f1929f4a$var$group,
    hidden: $1b459c88f1929f4a$var$hidden,
    list: $1b459c88f1929f4a$var$list,
    meta: $1b459c88f1929f4a$var$meta,
    radio: $1b459c88f1929f4a$var$radio,
    select: $1b459c88f1929f4a$var$select2,
    textarea: $1b459c88f1929f4a$var$textarea,
    text: $1b459c88f1929f4a$var$text,
    color: $1b459c88f1929f4a$var$text,
    date: $1b459c88f1929f4a$var$text,
    datetimeLocal: $1b459c88f1929f4a$var$text,
    email: $1b459c88f1929f4a$var$text,
    month: $1b459c88f1929f4a$var$text,
    number: $1b459c88f1929f4a$var$text,
    password: $1b459c88f1929f4a$var$text,
    search: $1b459c88f1929f4a$var$text,
    tel: $1b459c88f1929f4a$var$text,
    time: $1b459c88f1929f4a$var$text,
    url: $1b459c88f1929f4a$var$text,
    week: $1b459c88f1929f4a$var$text,
    range: $1b459c88f1929f4a$var$text
};
$1b459c88f1929f4a$export$2de5f27892b805a = $1b459c88f1929f4a$var$$attrs;
$1b459c88f1929f4a$export$a85ce4af57d6b2bc = $1b459c88f1929f4a$var$$extend;
$1b459c88f1929f4a$export$3364fcc330baceba = $1b459c88f1929f4a$var$$for;
$1b459c88f1929f4a$export$24842cd1e1f3d46f = $1b459c88f1929f4a$var$$if;
$1b459c88f1929f4a$export$db7f9ed9bf568723 = $1b459c88f1929f4a$var$$root;
$1b459c88f1929f4a$export$e324594224ef24da = $1b459c88f1929f4a$var$actions;
$1b459c88f1929f4a$export$827f4ee28efc37 = $1b459c88f1929f4a$var$box;
$1b459c88f1929f4a$export$c23431c9527ba83c = $1b459c88f1929f4a$var$boxHelp;
$1b459c88f1929f4a$export$a92079fdd70b94fa = $1b459c88f1929f4a$var$boxInner;
$1b459c88f1929f4a$export$d0d4067a57339678 = $1b459c88f1929f4a$var$boxLabel;
$1b459c88f1929f4a$export$2d975de0ff5c173c = $1b459c88f1929f4a$var$boxOption;
$1b459c88f1929f4a$export$cd3a5ab9a642d6cf = $1b459c88f1929f4a$var$boxOptions;
$1b459c88f1929f4a$export$e28608303d03208c = $1b459c88f1929f4a$var$boxWrapper;
$1b459c88f1929f4a$export$2ba01fb71ed41cb6 = $1b459c88f1929f4a$var$button;
$1b459c88f1929f4a$export$bedd464e4425c72f = $1b459c88f1929f4a$var$buttonInput;
$1b459c88f1929f4a$export$47614749115bca3d = $1b459c88f1929f4a$var$buttonLabel;
$1b459c88f1929f4a$export$9eecbb16f1974b2e = $1b459c88f1929f4a$var$casts;
$1b459c88f1929f4a$export$b07e517d22efa1ca = $1b459c88f1929f4a$var$checkbox;
$1b459c88f1929f4a$export$b5b4a55c683fb898 = $1b459c88f1929f4a$var$checkboxes;
$1b459c88f1929f4a$export$35e9368ef982300f = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$9e8a64b7e8d7f4c8 = $1b459c88f1929f4a$var$createLibraryPlugin;
$1b459c88f1929f4a$export$f3a183bf2efcc835 = $1b459c88f1929f4a$var$createSection;
$1b459c88f1929f4a$export$324d90190a8b822a = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$7dda925e4d5db125 = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$46bdae34a7208737 = $1b459c88f1929f4a$var$decorator;
$1b459c88f1929f4a$export$ca2f546e21dcce87 = $1b459c88f1929f4a$var$defaultIcon;
$1b459c88f1929f4a$export$e67d6a3cfb794f72 = $1b459c88f1929f4a$var$disables;
$1b459c88f1929f4a$export$330ddc712022f49b = $1b459c88f1929f4a$var$eachSection;
$1b459c88f1929f4a$export$d290fa47940df19d = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$35f5fe5f3e862ea3 = $1b459c88f1929f4a$var$extendSchema;
$1b459c88f1929f4a$export$a38812d1aa1302d9 = $1b459c88f1929f4a$var$fieldset;
$1b459c88f1929f4a$export$c2a28f090bb0afd6 = $1b459c88f1929f4a$var$file;
$1b459c88f1929f4a$export$5d5b61cfc3d870a9 = $1b459c88f1929f4a$var$fileInput;
$1b459c88f1929f4a$export$747c38e0dbf42300 = $1b459c88f1929f4a$var$fileItem;
$1b459c88f1929f4a$export$df3d8d727a3f9a33 = $1b459c88f1929f4a$var$fileList;
$1b459c88f1929f4a$export$45547f6c19231c9 = $1b459c88f1929f4a$var$fileName;
$1b459c88f1929f4a$export$96b575204aec369c = $1b459c88f1929f4a$var$fileRemove;
$1b459c88f1929f4a$export$3a444357c5f65f65 = $1b459c88f1929f4a$var$files;
$1b459c88f1929f4a$export$967ce3543c950aeb = $1b459c88f1929f4a$var$findSection;
$1b459c88f1929f4a$export$6210fa4921d2a466 = $1b459c88f1929f4a$var$form2;
$1b459c88f1929f4a$export$326bce2259f858eb = $1b459c88f1929f4a$var$formInput;
$1b459c88f1929f4a$export$71730bae229ad1d = $1b459c88f1929f4a$var$form;
$1b459c88f1929f4a$export$f00aeb236b6f05af = $1b459c88f1929f4a$var$fragment;
$1b459c88f1929f4a$export$e5e25fbcc1f7affe = $1b459c88f1929f4a$var$group;
$1b459c88f1929f4a$export$34512e3b2db52a4e = $1b459c88f1929f4a$var$help;
$1b459c88f1929f4a$export$73920f18ca706874 = $1b459c88f1929f4a$var$hidden;
$1b459c88f1929f4a$export$1ca1ec8b29a4ce27 = $1b459c88f1929f4a$var$icon;
$1b459c88f1929f4a$export$3943f6a2f9e1f610 = $1b459c88f1929f4a$var$ignore;
$1b459c88f1929f4a$export$f36c9b20522c59e3 = $1b459c88f1929f4a$var$initialValue;
$1b459c88f1929f4a$export$4ae363f1d88fb658 = $1b459c88f1929f4a$var$inner;
$1b459c88f1929f4a$export$7b388ca536128c6d = $1b459c88f1929f4a$var$inputs;
$1b459c88f1929f4a$export$74e910429f6e69d1 = $1b459c88f1929f4a$var$isGroupOption;
$1b459c88f1929f4a$export$f7e911aee08201e7 = $1b459c88f1929f4a$var$isSchemaObject;
$1b459c88f1929f4a$export$e9fd0e554af48a3b = $1b459c88f1929f4a$var$isSlotCondition;
$1b459c88f1929f4a$export$1237798dc640739a = $1b459c88f1929f4a$var$label;
$1b459c88f1929f4a$export$9a9b59e08de24cef = $1b459c88f1929f4a$var$legend;
$1b459c88f1929f4a$export$8837f4fc672e936d = $1b459c88f1929f4a$var$list;
$1b459c88f1929f4a$export$b3bd0bc58e36cd63 = $1b459c88f1929f4a$var$localize;
$1b459c88f1929f4a$export$a8ecead220dd38a6 = $1b459c88f1929f4a$var$message;
$1b459c88f1929f4a$export$defe85febe8b728c = $1b459c88f1929f4a$var$messages;
$1b459c88f1929f4a$export$6990040ee07315 = $1b459c88f1929f4a$var$meta;
$1b459c88f1929f4a$export$af5de1609f06c8e6 = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$fedd547672325f13 = $1b459c88f1929f4a$var$noFiles;
$1b459c88f1929f4a$export$7e362809f088c235 = $1b459c88f1929f4a$var$normalizeBoxes;
$1b459c88f1929f4a$export$eb806c0b85b62f7a = $1b459c88f1929f4a$var$normalizeOptions;
$1b459c88f1929f4a$export$98e628dec113755e = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$cc10c2220752a218 = $1b459c88f1929f4a$var$optGroup;
$1b459c88f1929f4a$export$a75d1723e6bda2ec = $1b459c88f1929f4a$var$option;
$1b459c88f1929f4a$export$fcc54c27da4fc173 = $1b459c88f1929f4a$var$optionSlot;
$1b459c88f1929f4a$export$41c562ebe57d11e2 = $1b459c88f1929f4a$var$options;
$1b459c88f1929f4a$export$e4f60e4df8811b1 = $1b459c88f1929f4a$var$outer;
$1b459c88f1929f4a$export$b9394e9ffbbc2ec7 = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$82e9f45cca5ba907 = $1b459c88f1929f4a$var$prefix;
$1b459c88f1929f4a$export$b56dc0f160585b86 = $1b459c88f1929f4a$var$radio;
$1b459c88f1929f4a$export$3b403ceea8242d0a = $1b459c88f1929f4a$var$radios;
$1b459c88f1929f4a$export$d02631cccf789723 = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$405f879a3148f344 = $1b459c88f1929f4a$var$renamesRadios;
$1b459c88f1929f4a$export$491e3fe6732c33f1 = $1b459c88f1929f4a$var$resetCounts;
$1b459c88f1929f4a$export$d23afc634f3c7cc7 = $1b459c88f1929f4a$var$resetRadio;
$1b459c88f1929f4a$export$b8f47637d11b035b = $1b459c88f1929f4a$var$runtimeProps;
$1b459c88f1929f4a$export$d76128d007d19019 = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$2e6c959c16ff56b8 = $1b459c88f1929f4a$var$select2;
$1b459c88f1929f4a$export$4f502711de93d534 = $1b459c88f1929f4a$var$selectInput;
$1b459c88f1929f4a$export$2e44bf0978869fd4 = $1b459c88f1929f4a$var$select;
$1b459c88f1929f4a$export$853c27de4ce0f746 = $1b459c88f1929f4a$var$button;
$1b459c88f1929f4a$export$c94d76fb82ce4837 = $1b459c88f1929f4a$var$submitInput;
$1b459c88f1929f4a$export$559d1204393b53b9 = $1b459c88f1929f4a$var$suffix;
$1b459c88f1929f4a$export$6d3b74af955b7df3 = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$6f093cfa640b7166 = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$181ff85155496734 = $1b459c88f1929f4a$var$textInput;
$1b459c88f1929f4a$export$a3574df893ffa88d = $1b459c88f1929f4a$var$textarea;
$1b459c88f1929f4a$export$b3e13b598c0b8d61 = $1b459c88f1929f4a$var$textareaInput;
$1b459c88f1929f4a$export$2da9be4cfdb689b1 = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$128fa18b7194ef = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$aecd9c955413bc92 = $1b459c88f1929f4a$var$useSchema;
$1b459c88f1929f4a$export$36cb58223e61606e = $1b459c88f1929f4a$var$text;
$1b459c88f1929f4a$export$cc74dcc53cfce4eb = $1b459c88f1929f4a$var$wrapper; //# sourceMappingURL=out.js.map
 //# sourceMappingURL=index.cjs.map



// packages/themes/src/index.ts
function $1d18f2ec05e756c7$export$c1381b51adc80aa4(classes) {
    const classesBySectionKey = {};
    Object.keys(classes).forEach((type)=>{
        Object.keys(classes[type]).forEach((sectionKey)=>{
            if (!classesBySectionKey[sectionKey]) classesBySectionKey[sectionKey] = {
                [type]: classes[type][sectionKey]
            };
            else classesBySectionKey[sectionKey][type] = classes[type][sectionKey];
        });
    });
    Object.keys(classesBySectionKey).forEach((sectionKey)=>{
        const classesObject = classesBySectionKey[sectionKey];
        classesBySectionKey[sectionKey] = function(node, sectionKey2) {
            return $1d18f2ec05e756c7$var$addClassesBySection(node, sectionKey2, classesObject);
        };
    });
    return classesBySectionKey;
}
function $1d18f2ec05e756c7$var$addClassesBySection(node, _sectionKey, classesByType) {
    const type = node.props.type;
    const family = node.props.family;
    let classList = "";
    if (classesByType.global) classList += classesByType.global + " ";
    if (classesByType[`family:${family}`]) classList += classesByType[`family:${family}`] + " ";
    if (classesByType[type]) classList += classesByType[type];
    const listParts = classList.split("$reset");
    if (listParts.length > 1) return `$reset ${listParts[listParts.length - 1].trim()}`;
    return listParts[0].trim();
}
var $1d18f2ec05e756c7$var$documentStyles = void 0;
var $1d18f2ec05e756c7$var$documentThemeLinkTag = null;
var $1d18f2ec05e756c7$var$themeDidLoad;
var $1d18f2ec05e756c7$var$themeHasLoaded = false;
var $1d18f2ec05e756c7$var$themeWasRequested = false;
var $1d18f2ec05e756c7$var$themeLoaded = /* @__PURE__ */ new Promise((res)=>{
    $1d18f2ec05e756c7$var$themeDidLoad = ()=>{
        $1d18f2ec05e756c7$var$themeHasLoaded = true;
        res();
    };
});
var $1d18f2ec05e756c7$var$isClient = typeof window !== "undefined" && typeof fetch !== "undefined";
$1d18f2ec05e756c7$var$documentStyles = $1d18f2ec05e756c7$var$isClient ? /* @__PURE__ */ getComputedStyle(document.documentElement) : void 0;
var $1d18f2ec05e756c7$export$6472055b82c8bdda = {};
var $1d18f2ec05e756c7$var$iconRequests = {};
function $1d18f2ec05e756c7$export$39cbc80ca8fc43a1(theme, icons, iconLoaderUrl, iconLoader) {
    if (icons) Object.assign($1d18f2ec05e756c7$export$6472055b82c8bdda, icons);
    if ($1d18f2ec05e756c7$var$isClient && !$1d18f2ec05e756c7$var$themeWasRequested && $1d18f2ec05e756c7$var$documentStyles?.getPropertyValue("--formkit-theme")) {
        $1d18f2ec05e756c7$var$themeDidLoad();
        $1d18f2ec05e756c7$var$themeWasRequested = true;
    } else if (theme && !$1d18f2ec05e756c7$var$themeWasRequested && $1d18f2ec05e756c7$var$isClient) $1d18f2ec05e756c7$var$loadTheme(theme);
    else if (!$1d18f2ec05e756c7$var$themeWasRequested && $1d18f2ec05e756c7$var$isClient) $1d18f2ec05e756c7$var$themeDidLoad();
    const themePlugin = function themePlugin2(node) {
        node.addProps([
            "iconLoader",
            "iconLoaderUrl"
        ]);
        node.props.iconHandler = $1d18f2ec05e756c7$export$90a7723193b39e9(node.props?.iconLoader ? node.props.iconLoader : iconLoader, node.props?.iconLoaderUrl ? node.props.iconLoaderUrl : iconLoaderUrl);
        $1d18f2ec05e756c7$var$loadIconPropIcons(node, node.props.iconHandler);
        node.on("created", ()=>{
            if (node?.context?.handlers) node.context.handlers.iconClick = (sectionKey)=>{
                const clickHandlerProp = `on${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}IconClick`;
                const handlerFunction = node.props[clickHandlerProp];
                if (handlerFunction && typeof handlerFunction === "function") return (e)=>{
                    return handlerFunction(node, e);
                };
                return void 0;
            };
            if (node?.context?.fns) node.context.fns.iconRole = (sectionKey)=>{
                const clickHandlerProp = `on${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}IconClick`;
                return typeof node.props[clickHandlerProp] === "function" ? "button" : null;
            };
        });
    };
    themePlugin.iconHandler = $1d18f2ec05e756c7$export$90a7723193b39e9(iconLoader, iconLoaderUrl);
    return themePlugin;
}
function $1d18f2ec05e756c7$var$loadTheme(theme) {
    if (!theme || !$1d18f2ec05e756c7$var$isClient || typeof getComputedStyle !== "function") return;
    $1d18f2ec05e756c7$var$themeWasRequested = true;
    $1d18f2ec05e756c7$var$documentThemeLinkTag = document.getElementById("formkit-theme");
    if (theme && // if we have a window object
    $1d18f2ec05e756c7$var$isClient && // we don't have an existing theme OR the theme being set up is different
    (!$1d18f2ec05e756c7$var$documentStyles?.getPropertyValue("--formkit-theme") && !$1d18f2ec05e756c7$var$documentThemeLinkTag || $1d18f2ec05e756c7$var$documentThemeLinkTag?.getAttribute("data-theme") && $1d18f2ec05e756c7$var$documentThemeLinkTag?.getAttribute("data-theme") !== theme)) {
        const formkitVersion = (0, $0deed543ccab4a3d$export$a65c7cc2c8845330).startsWith("__") ? "latest" : (0, $0deed543ccab4a3d$export$a65c7cc2c8845330);
        const themeUrl = `https://cdn.jsdelivr.net/npm/@formkit/themes@${formkitVersion}/dist/${theme}/theme.css`;
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.id = "formkit-theme";
        link.setAttribute("data-theme", theme);
        link.onload = ()=>{
            $1d18f2ec05e756c7$var$documentStyles = getComputedStyle(document.documentElement);
            $1d18f2ec05e756c7$var$themeDidLoad();
        };
        document.head.appendChild(link);
        link.href = themeUrl;
        if ($1d18f2ec05e756c7$var$documentThemeLinkTag) $1d18f2ec05e756c7$var$documentThemeLinkTag.remove();
    }
}
function $1d18f2ec05e756c7$export$90a7723193b39e9(iconLoader, iconLoaderUrl) {
    return (iconName)=>{
        if (typeof iconName !== "string") return;
        if (iconName.startsWith("<svg")) return iconName;
        const isDefault = iconName.startsWith("default:");
        iconName = isDefault ? iconName.split(":")[1] : iconName;
        const iconWasAlreadyLoaded = iconName in $1d18f2ec05e756c7$export$6472055b82c8bdda;
        let loadedIcon = void 0;
        if (iconWasAlreadyLoaded) return $1d18f2ec05e756c7$export$6472055b82c8bdda[iconName];
        else if (!$1d18f2ec05e756c7$var$iconRequests[iconName]) {
            loadedIcon = $1d18f2ec05e756c7$var$getIconFromStylesheet(iconName);
            loadedIcon = $1d18f2ec05e756c7$var$isClient && typeof loadedIcon === "undefined" ? Promise.resolve(loadedIcon) : loadedIcon;
            if (loadedIcon instanceof Promise) $1d18f2ec05e756c7$var$iconRequests[iconName] = loadedIcon.then((iconValue)=>{
                if (!iconValue && typeof iconName === "string" && !isDefault) return loadedIcon = typeof iconLoader === "function" ? iconLoader(iconName) : $1d18f2ec05e756c7$var$getRemoteIcon(iconName, iconLoaderUrl);
                return iconValue;
            }).then((finalIcon)=>{
                if (typeof iconName === "string") $1d18f2ec05e756c7$export$6472055b82c8bdda[isDefault ? `default:${iconName}` : iconName] = finalIcon;
                return finalIcon;
            });
            else if (typeof loadedIcon === "string") {
                $1d18f2ec05e756c7$export$6472055b82c8bdda[isDefault ? `default:${iconName}` : iconName] = loadedIcon;
                return loadedIcon;
            }
        }
        return $1d18f2ec05e756c7$var$iconRequests[iconName];
    };
}
function $1d18f2ec05e756c7$var$getIconFromStylesheet(iconName) {
    if (!$1d18f2ec05e756c7$var$isClient) return;
    if ($1d18f2ec05e756c7$var$themeHasLoaded) return $1d18f2ec05e756c7$var$loadStylesheetIcon(iconName);
    else return $1d18f2ec05e756c7$var$themeLoaded.then(()=>{
        return $1d18f2ec05e756c7$var$loadStylesheetIcon(iconName);
    });
}
function $1d18f2ec05e756c7$var$loadStylesheetIcon(iconName) {
    const cssVarIcon = $1d18f2ec05e756c7$var$documentStyles?.getPropertyValue(`--fk-icon-${iconName}`);
    if (cssVarIcon) {
        const icon = atob(cssVarIcon);
        if (icon.startsWith("<svg")) {
            $1d18f2ec05e756c7$export$6472055b82c8bdda[iconName] = icon;
            return icon;
        }
    }
    return void 0;
}
function $1d18f2ec05e756c7$var$getRemoteIcon(iconName, iconLoaderUrl) {
    const formkitVersion = (0, $0deed543ccab4a3d$export$a65c7cc2c8845330).startsWith("__") ? "latest" : (0, $0deed543ccab4a3d$export$a65c7cc2c8845330);
    const fetchUrl = typeof iconLoaderUrl === "function" ? iconLoaderUrl(iconName) : `https://cdn.jsdelivr.net/npm/@formkit/icons@${formkitVersion}/dist/icons/${iconName}.svg`;
    if (!$1d18f2ec05e756c7$var$isClient) return void 0;
    return fetch(`${fetchUrl}`).then(async (r)=>{
        const icon = await r.text();
        if (icon.startsWith("<svg")) return icon;
        return void 0;
    }).catch((e)=>{
        console.error(e);
        return void 0;
    });
}
function $1d18f2ec05e756c7$var$loadIconPropIcons(node, iconHandler) {
    const iconRegex = /^[a-zA-Z-]+(?:-icon|Icon)$/;
    const iconProps = Object.keys(node.props).filter((prop)=>{
        return iconRegex.test(prop);
    });
    iconProps.forEach((sectionKey)=>{
        return $1d18f2ec05e756c7$var$loadPropIcon(node, iconHandler, sectionKey);
    });
}
function $1d18f2ec05e756c7$var$loadPropIcon(node, iconHandler, sectionKey) {
    const iconName = node.props[sectionKey];
    const loadedIcon = iconHandler(iconName);
    const rawIconProp = `_raw${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}`;
    const clickHandlerProp = `on${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}Click`;
    node.addProps([
        rawIconProp,
        clickHandlerProp
    ]);
    node.on(`prop:${sectionKey}`, $1d18f2ec05e756c7$var$reloadIcon);
    if (loadedIcon instanceof Promise) return loadedIcon.then((svg)=>{
        node.props[rawIconProp] = svg;
    });
    else node.props[rawIconProp] = loadedIcon;
    return;
}
function $1d18f2ec05e756c7$var$reloadIcon(event) {
    const node = event.origin;
    const iconName = event.payload;
    const iconHandler = node?.props?.iconHandler;
    const sectionKey = event.name.split(":")[1];
    const rawIconProp = `_raw${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}`;
    if (iconHandler && typeof iconHandler === "function") {
        const loadedIcon = iconHandler(iconName);
        if (loadedIcon instanceof Promise) return loadedIcon.then((svg)=>{
            node.props[rawIconProp] = svg;
        });
        else node.props[rawIconProp] = loadedIcon;
    }
}
 //# sourceMappingURL=out.js.map


var $712bae6f5b595b3c$export$30f3b02011db23c0;
var $712bae6f5b595b3c$export$6503ec6e8aabbaf;
var $712bae6f5b595b3c$export$cce7aaa89215f32b;
'use strict';

// packages/dev/src/index.ts
var $712bae6f5b595b3c$var$errors = {
    /**
   * FormKit errors:
   */ 100: ({ data: node })=>`Only groups, lists, and forms can have children (${node.name}).`,
    101: ({ data: node })=>`You cannot directly modify the store (${node.name}). See: https://formkit.com/advanced/core#message-store`,
    102: ({ data: [node, property] })=>`You cannot directly assign node.${property} (${node.name})`,
    103: ({ data: [operator] })=>`Schema expressions cannot start with an operator (${operator})`,
    104: ({ data: [operator, expression] })=>`Schema expressions cannot end with an operator (${operator} in "${expression}")`,
    105: ({ data: expression })=>`Invalid schema expression: ${expression}`,
    106: ({ data: name })=>`Cannot submit because (${name}) is not in a form.`,
    107: ({ data: [node, value] })=>`Cannot set ${node.name} to non object value: ${value}`,
    108: ({ data: [node, value] })=>`Cannot set ${node.name} to non array value: ${value}`,
    /**
   * Input specific errors:
   */ 300: ({ data: [node] })=>`Cannot set behavior prop to overscroll (on ${node.name} input) when options prop is a function.`,
    /**
   * FormKit vue errors:
   */ 600: ({ data: node })=>`Unknown input type${typeof node.props.type === "string" ? ' "' + node.props.type + '"' : ""} ("${node.name}")`,
    601: ({ data: node })=>`Input definition${typeof node.props.type === "string" ? ' "' + node.props.type + '"' : ""} is missing a schema or component property (${node.name}).`
};
var $712bae6f5b595b3c$var$warnings = {
    /**
   * Core warnings:
   */ 150: ({ data: fn })=>`Schema function "${fn}()" is not a valid function.`,
    151: ({ data: id })=>`No form element with id: ${id}`,
    152: ({ data: id })=>`No input element with id: ${id}`,
    /**
   * Input specific warnings:
   */ 350: ({ data: { node: node, inputType: inputType } })=>`Invalid options prop for ${node.name} input (${inputType}). See https://formkit.com/inputs/${inputType}`,
    /**
   * Vue warnings:
   */ 650: 'Schema "$get()" must use the id of an input to access.',
    651: ({ data: id })=>`Cannot setErrors() on "${id}" because no such id exists.`,
    652: ({ data: id })=>`Cannot clearErrors() on "${id}" because no such id exists.`,
    /**
   * Deprecation warnings:
   */ 800: ({ data: name })=>`${name} is deprecated.`
};
var $712bae6f5b595b3c$var$decodeErrors = (error, next)=>{
    if (error.code in $712bae6f5b595b3c$var$errors) {
        const err = $712bae6f5b595b3c$var$errors[error.code];
        error.message = typeof err === "function" ? err(error) : err;
    }
    return next(error);
};
var $712bae6f5b595b3c$var$registered = false;
function $712bae6f5b595b3c$var$register() {
    if (!$712bae6f5b595b3c$var$registered) {
        $0deed543ccab4a3d$export$cc3fdd528b56c4a9($712bae6f5b595b3c$var$decodeErrors);
        $0deed543ccab4a3d$export$3d46431aec5d0165($712bae6f5b595b3c$var$decodeWarnings);
        $712bae6f5b595b3c$var$registered = true;
    }
}
var $712bae6f5b595b3c$var$decodeWarnings = (warning, next)=>{
    if (warning.code in $712bae6f5b595b3c$var$warnings) {
        const warn = $712bae6f5b595b3c$var$warnings[warning.code];
        warning.message = typeof warn === "function" ? warn(warning) : warn;
    }
    return next(warning);
};
$712bae6f5b595b3c$export$30f3b02011db23c0 = $712bae6f5b595b3c$var$errors;
$712bae6f5b595b3c$export$6503ec6e8aabbaf = $712bae6f5b595b3c$var$register;
$712bae6f5b595b3c$export$cce7aaa89215f32b = $712bae6f5b595b3c$var$warnings; //# sourceMappingURL=out.js.map
 //# sourceMappingURL=index.cjs.map


function $4e74f275bd5b5b89$var$_interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== 'default') {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function() {
                    return e[k];
                }
            });
        }
    });
    n.default = e;
    return Object.freeze(n);
}
var $4e74f275bd5b5b89$var$defaultRules__namespace = /*#__PURE__*/ $4e74f275bd5b5b89$var$_interopNamespace($10427b96296db38b$exports);
var $4e74f275bd5b5b89$var$__defProp = Object.defineProperty;
var $4e74f275bd5b5b89$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $4e74f275bd5b5b89$var$__esm = (fn, res)=>function __init() {
        return fn && (res = (0, fn[$4e74f275bd5b5b89$var$__getOwnPropNames(fn)[0]])(fn = 0)), res;
    };
var $4e74f275bd5b5b89$var$__export = (target, all)=>{
    for(var name in all)$4e74f275bd5b5b89$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $4e74f275bd5b5b89$var$vueBindings;
$4e74f275bd5b5b89$exports.bindings = void 0;
var $4e74f275bd5b5b89$var$init_bindings = $4e74f275bd5b5b89$var$__esm({
    "packages/vue/src/bindings.ts" () {
        $4e74f275bd5b5b89$var$vueBindings = function vueBindings2(node) {
            node.ledger.count("blocking", (m)=>m.blocking);
            const isValid = $8bTPG.ref(!node.ledger.value("blocking"));
            node.ledger.count("errors", (m)=>m.type === "error");
            const hasErrors = $8bTPG.ref(!!node.ledger.value("errors"));
            let hasTicked = false;
            $ani5R.nextTick(()=>{
                hasTicked = true;
            });
            const availableMessages = $8bTPG.reactive(node.store.reduce((store, message3)=>{
                if (message3.visible) store[message3.key] = message3;
                return store;
            }, {}));
            const validationVisibility = $8bTPG.ref(node.props.validationVisibility || (node.props.type === "checkbox" ? "dirty" : "blur"));
            node.on("prop:validationVisibility", ({ payload: payload })=>{
                validationVisibility.value = payload;
            });
            const hasShownErrors = $8bTPG.ref(validationVisibility.value === "live");
            const isRequired = $8bTPG.ref(false);
            const checkForRequired = (parsedRules)=>{
                isRequired.value = (parsedRules ?? []).some((rule)=>rule.name === "required");
            };
            checkForRequired(node.props.parsedRules);
            node.on("prop:parsedRules", ({ payload: payload })=>checkForRequired(payload));
            const items = $8bTPG.ref(node.children.map((child)=>child.uid));
            const validationVisible = $8bTPG.computed(()=>{
                if (!context.state) return false;
                if (context.state.submitted) return true;
                if (!hasShownErrors.value && !context.state.settled) return false;
                switch(validationVisibility.value){
                    case "live":
                        return true;
                    case "blur":
                        return context.state.blurred;
                    case "dirty":
                        return context.state.dirty;
                    default:
                        return false;
                }
            });
            const isInvalid = $8bTPG.computed(()=>{
                return context.state.failing && validationVisible.value;
            });
            const isComplete = $8bTPG.computed(()=>{
                return context && hasValidation.value ? isValid.value && !hasErrors.value : context.state.dirty && !$639fe8cc1eae7e21$export$6e22c362a0406a2c(context.value);
            });
            const hasValidation = $8bTPG.ref(Array.isArray(node.props.parsedRules) && node.props.parsedRules.length > 0);
            node.on("prop:parsedRules", ({ payload: rules })=>{
                hasValidation.value = Array.isArray(rules) && rules.length > 0;
            });
            const messages3 = $8bTPG.computed(()=>{
                const visibleMessages = {};
                for(const key in availableMessages){
                    const message3 = availableMessages[key];
                    if (message3.type !== "validation" || validationVisible.value) visibleMessages[key] = message3;
                }
                return visibleMessages;
            });
            const ui = $8bTPG.reactive(node.store.reduce((messages4, message3)=>{
                if (message3.type === "ui" && message3.visible) messages4[message3.key] = message3;
                return messages4;
            }, {}));
            const passing = $8bTPG.computed(()=>!context.state.failing);
            const cachedClasses = $8bTPG.reactive({});
            const classes2 = new Proxy(cachedClasses, {
                get (...args) {
                    if (!node) return "";
                    const [target, property] = args;
                    let className = Reflect.get(...args);
                    if (!className && typeof property === "string") {
                        if (!$639fe8cc1eae7e21$export$a4f4bb6b1453fff5(target, property) && !property.startsWith("__v")) {
                            const observedNode = $e098f7e2ce93da90$export$9e6a5ff84f57576(node);
                            observedNode.watch((node2)=>{
                                const rootClasses = typeof node2.config.rootClasses === "function" ? node2.config.rootClasses(property, node2) : {};
                                const globalConfigClasses = node2.config.classes ? $0deed543ccab4a3d$export$1f803343cd5d268d(property, node2, node2.config.classes[property]) : {};
                                const classesPropClasses = $0deed543ccab4a3d$export$1f803343cd5d268d(property, node2, node2.props[`_${property}Class`]);
                                const sectionPropClasses = $0deed543ccab4a3d$export$1f803343cd5d268d(property, node2, node2.props[`${property}Class`]);
                                className = $0deed543ccab4a3d$export$fe64dbc167601fe7(node2, property, rootClasses, globalConfigClasses, classesPropClasses, sectionPropClasses);
                                target[property] = className ?? "";
                            });
                        }
                    }
                    return className;
                }
            });
            node.on("prop:rootClasses", ()=>{
                const keys = Object.keys(cachedClasses);
                for (const key of keys)delete cachedClasses[key];
            });
            const describedBy = $8bTPG.computed(()=>{
                if (!node) return void 0;
                const describers = [];
                if (context.help) describers.push(`help-${node.props.id}`);
                for(const key in messages3.value)describers.push(`${node.props.id}-${key}`);
                return describers.length ? describers.join(" ") : void 0;
            });
            const value = $8bTPG.ref(node.value);
            const _value = $8bTPG.ref(node.value);
            const context = $8bTPG.reactive({
                _value: _value,
                attrs: node.props.attrs,
                disabled: node.props.disabled,
                describedBy: describedBy,
                fns: {
                    length: (obj)=>Object.keys(obj).length,
                    number: (value2)=>Number(value2),
                    string: (value2)=>String(value2),
                    json: (value2)=>JSON.stringify(value2),
                    eq: $639fe8cc1eae7e21$export$9663ddc1cf085b32
                },
                handlers: {
                    blur: (e)=>{
                        if (!node) return;
                        node.store.set(/* @__PURE__ */ $0deed543ccab4a3d$export$62651879628e0c4c({
                            key: "blurred",
                            visible: false,
                            value: true
                        }));
                        if (typeof node.props.attrs.onBlur === "function") node.props.attrs.onBlur(e);
                    },
                    touch: ()=>{
                        const doCompare = context.dirtyBehavior === "compare";
                        if (node.store.dirty?.value && !doCompare) return;
                        const isDirty = !$639fe8cc1eae7e21$export$9663ddc1cf085b32(node.props._init, node._value);
                        if (!isDirty && !doCompare) return;
                        node.store.set(/* @__PURE__ */ $0deed543ccab4a3d$export$62651879628e0c4c({
                            key: "dirty",
                            visible: false,
                            value: isDirty
                        }));
                    },
                    DOMInput: (e)=>{
                        node.input(e.target.value);
                        node.emit("dom-input-event", e);
                    }
                },
                help: node.props.help,
                id: node.props.id,
                items: items,
                label: node.props.label,
                messages: messages3,
                didMount: false,
                node: $8bTPG.markRaw(node),
                options: node.props.options,
                defaultMessagePlacement: true,
                slots: node.props.__slots,
                state: {
                    blurred: false,
                    complete: isComplete,
                    dirty: false,
                    empty: $639fe8cc1eae7e21$export$6e22c362a0406a2c(value),
                    submitted: false,
                    settled: node.isSettled,
                    valid: isValid,
                    invalid: isInvalid,
                    errors: hasErrors,
                    rules: hasValidation,
                    validationVisible: validationVisible,
                    required: isRequired,
                    failing: false,
                    passing: passing
                },
                type: node.props.type,
                family: node.props.family,
                ui: ui,
                value: value,
                classes: classes2
            });
            node.on("created", ()=>{
                if (!$639fe8cc1eae7e21$export$9663ddc1cf085b32(context.value, node.value)) {
                    _value.value = node.value;
                    value.value = node.value;
                    $8bTPG.triggerRef(value);
                    $8bTPG.triggerRef(_value);
                }
                (async ()=>{
                    await node.settled;
                    if (node) node.props._init = $639fe8cc1eae7e21$export$359e5dfb2bfaf73a(node.value);
                })();
            });
            node.on("mounted", ()=>{
                context.didMount = true;
            });
            node.on("settled", ({ payload: isSettled })=>{
                context.state.settled = isSettled;
            });
            function observeProps(observe) {
                const propNames = Array.isArray(observe) ? observe : Object.keys(observe);
                propNames.forEach((prop)=>{
                    prop = $639fe8cc1eae7e21$export$ddab50941423df32(prop);
                    if (!$639fe8cc1eae7e21$export$a4f4bb6b1453fff5(context, prop)) context[prop] = node.props[prop];
                    node.on(`prop:${prop}`, ({ payload: payload })=>{
                        context[prop] = payload;
                    });
                });
            }
            const rootProps = ()=>{
                const props = [
                    "__root",
                    "help",
                    "label",
                    "disabled",
                    "options",
                    "type",
                    "attrs",
                    "preserve",
                    "preserveErrors",
                    "id",
                    "dirtyBehavior"
                ];
                const iconPattern = /^[a-zA-Z-]+(?:-icon|Icon)$/;
                const matchingProps = Object.keys(node.props).filter((prop)=>{
                    return iconPattern.test(prop);
                });
                return props.concat(matchingProps);
            };
            observeProps(rootProps());
            function definedAs(definition3) {
                if (definition3.props) observeProps(definition3.props);
            }
            node.props.definition && definedAs(node.props.definition);
            node.on("added-props", ({ payload: payload })=>observeProps(payload));
            node.on("input", ({ payload: payload })=>{
                if (node.type !== "input" && !$8bTPG.isRef(payload) && !$8bTPG.isReactive(payload)) _value.value = $639fe8cc1eae7e21$export$370e8311c3cdebd9(payload);
                else {
                    _value.value = payload;
                    $8bTPG.triggerRef(_value);
                }
            });
            node.on("commitRaw", ({ payload: payload })=>{
                if (node.type !== "input" && !$8bTPG.isRef(payload) && !$8bTPG.isReactive(payload)) value.value = _value.value = $639fe8cc1eae7e21$export$370e8311c3cdebd9(payload);
                else {
                    value.value = _value.value = payload;
                    $8bTPG.triggerRef(value);
                }
                node.emit("modelUpdated");
            });
            node.on("commit", ({ payload: payload })=>{
                if ((!context.state.dirty || context.dirtyBehavior === "compare") && node.isCreated && hasTicked) {
                    if (!node.store.validating?.value) context.handlers.touch();
                    else {
                        const receipt = node.on("message-removed", ({ payload: message3 })=>{
                            if (message3.key === "validating") {
                                context.handlers.touch();
                                node.off(receipt);
                            }
                        });
                    }
                }
                if (isComplete && node.type === "input" && hasErrors.value && !$639fe8cc1eae7e21$export$96e6ef1411d879b1(node.props.preserveErrors)) node.store.filter((message3)=>!(message3.type === "error" && message3.meta?.autoClear === true));
                if (node.type === "list" && node.sync) items.value = node.children.map((child)=>child.uid);
                context.state.empty = $639fe8cc1eae7e21$export$6e22c362a0406a2c(payload);
            });
            const updateState = async (message3)=>{
                if (message3.type === "ui" && message3.visible && !message3.meta.showAsMessage) ui[message3.key] = message3;
                else if (message3.visible) availableMessages[message3.key] = message3;
                else if (message3.type === "state") context.state[message3.key] = !!message3.value;
            };
            node.on("message-added", (e)=>updateState(e.payload));
            node.on("message-updated", (e)=>updateState(e.payload));
            node.on("message-removed", ({ payload: message3 })=>{
                delete ui[message3.key];
                delete availableMessages[message3.key];
                delete context.state[message3.key];
            });
            node.on("settled:blocking", ()=>{
                isValid.value = true;
            });
            node.on("unsettled:blocking", ()=>{
                isValid.value = false;
            });
            node.on("settled:errors", ()=>{
                hasErrors.value = false;
            });
            node.on("unsettled:errors", ()=>{
                hasErrors.value = true;
            });
            $8bTPG.watch(validationVisible, (value2)=>{
                if (value2) hasShownErrors.value = true;
            });
            node.context = context;
            node.emit("context", node, false);
            node.on("destroyed", ()=>{
                node.context = void 0;
                node = null;
            });
        };
        $4e74f275bd5b5b89$exports.bindings = $4e74f275bd5b5b89$var$vueBindings;
    }
});
// packages/vue/src/defaultConfig.ts
var $4e74f275bd5b5b89$var$defaultConfig_exports = {};
$4e74f275bd5b5b89$var$__export($4e74f275bd5b5b89$var$defaultConfig_exports, {
    defaultConfig: ()=>$4e74f275bd5b5b89$exports.defaultConfig
});
$4e74f275bd5b5b89$exports.defaultConfig = void 0;
var $4e74f275bd5b5b89$var$init_defaultConfig = $4e74f275bd5b5b89$var$__esm({
    "packages/vue/src/defaultConfig.ts" () {
        $4e74f275bd5b5b89$var$init_bindings();
        $4e74f275bd5b5b89$exports.defaultConfig = (options = {})=>{
            $712bae6f5b595b3c$export$6503ec6e8aabbaf();
            const { rules: rules = {}, locales: locales = {}, inputs: inputs$1 = {}, messages: messages3 = {}, locale: locale, theme: theme, iconLoaderUrl: iconLoaderUrl, iconLoader: iconLoader, icons: icons = {}, ...nodeOptions } = options;
            const validation$1 = $06f542080289832c$export$3d3614fdf24c7f55({
                ...$4e74f275bd5b5b89$var$defaultRules__namespace,
                ...rules || {}
            });
            const i18n$1 = $a262a7e50e5a100c$export$c69ea711f447870e($639fe8cc1eae7e21$export$8b58be045bf06082({
                en: $a262a7e50e5a100c$export$84584c2a98eb6753,
                ...locales || {}
            }, messages3));
            const library = $1b459c88f1929f4a$export$9e8a64b7e8d7f4c8($1b459c88f1929f4a$export$7b388ca536128c6d, inputs$1);
            const themePlugin = $1d18f2ec05e756c7$export$39cbc80ca8fc43a1(theme, icons, iconLoaderUrl, iconLoader);
            return $639fe8cc1eae7e21$export$8b58be045bf06082({
                plugins: [
                    library,
                    themePlugin,
                    $4e74f275bd5b5b89$exports.bindings,
                    i18n$1,
                    validation$1
                ],
                ...!locale ? {} : {
                    config: {
                        locale: locale
                    }
                }
            }, nodeOptions || {}, true);
        };
    }
});
// packages/vue/src/composables/onSSRComplete.ts
var $4e74f275bd5b5b89$var$isServer = typeof window === "undefined";
var $4e74f275bd5b5b89$var$ssrCompleteRegistry = /* @__PURE__ */ new Map();
function $4e74f275bd5b5b89$var$ssrComplete(app) {
    if (!$4e74f275bd5b5b89$var$isServer) return;
    const callbacks = $4e74f275bd5b5b89$var$ssrCompleteRegistry.get(app);
    if (!callbacks) return;
    for (const callback of callbacks)callback();
    callbacks.clear();
    $4e74f275bd5b5b89$var$ssrCompleteRegistry.delete(app);
}
function $4e74f275bd5b5b89$var$onSSRComplete(app, callback) {
    if (!$4e74f275bd5b5b89$var$isServer || !app) return;
    if (!$4e74f275bd5b5b89$var$ssrCompleteRegistry.has(app)) $4e74f275bd5b5b89$var$ssrCompleteRegistry.set(app, /* @__PURE__ */ new Set());
    $4e74f275bd5b5b89$var$ssrCompleteRegistry.get(app)?.add(callback);
}
// packages/vue/src/FormKitSchema.ts
var $4e74f275bd5b5b89$var$isServer2 = typeof window === "undefined";
var $4e74f275bd5b5b89$var$memo = {};
var $4e74f275bd5b5b89$var$memoKeys = {};
var $4e74f275bd5b5b89$var$instanceKey;
var $4e74f275bd5b5b89$var$instanceScopes = /* @__PURE__ */ new WeakMap();
var $4e74f275bd5b5b89$var$raw = "__raw__";
var $4e74f275bd5b5b89$var$isClassProp = /[a-zA-Z0-9\-][cC]lass$/;
function $4e74f275bd5b5b89$var$getRef(token3, data) {
    const value = $8bTPG.ref(null);
    if (token3 === "get") {
        const nodeRefs = {};
        value.value = $4e74f275bd5b5b89$var$get.bind(null, nodeRefs);
        return value;
    }
    const path = token3.split(".");
    $ani5R.watchEffect(()=>{
        value.value = $4e74f275bd5b5b89$var$getValue($8bTPG.isRef(data) ? data.value : data, path);
    });
    return value;
}
function $4e74f275bd5b5b89$var$getValue(set, path) {
    if (Array.isArray(set)) {
        for (const subset of set){
            const value = subset !== false && $4e74f275bd5b5b89$var$getValue(subset, path);
            if (value !== void 0) return value;
        }
        return void 0;
    }
    let foundValue = void 0;
    let obj = set;
    for(const i in path){
        const key = path[i];
        if (typeof obj !== "object" || obj === null) {
            foundValue = void 0;
            break;
        }
        const currentValue = obj[key];
        if (Number(i) === path.length - 1 && currentValue !== void 0) {
            foundValue = typeof currentValue === "function" ? currentValue.bind(obj) : currentValue;
            break;
        }
        obj = currentValue;
    }
    return foundValue;
}
function $4e74f275bd5b5b89$var$get(nodeRefs, id) {
    if (typeof id !== "string") return $0deed543ccab4a3d$export$c106dd0671a0fc2d(650);
    if (!(id in nodeRefs)) nodeRefs[id] = $8bTPG.ref(void 0);
    if (nodeRefs[id].value === void 0) {
        nodeRefs[id].value = null;
        const root = $0deed543ccab4a3d$export$3f778c4e796a1f9c(id);
        if (root) nodeRefs[id].value = root.context;
        $0deed543ccab4a3d$export$e6fd047a0a0a675b(id, ({ payload: node })=>{
            nodeRefs[id].value = $0deed543ccab4a3d$export$8ee0fc9ee280b4ee(node) ? node.context : node;
        });
    }
    return nodeRefs[id].value;
}
function $4e74f275bd5b5b89$var$parseSchema(library, schema, memoKey) {
    function parseCondition(library2, node) {
        const condition = provider($0deed543ccab4a3d$export$ef7acd7185315e22(node.if), {
            if: true
        });
        const children = createElements(library2, node.then);
        const alternate = node.else ? createElements(library2, node.else) : null;
        return [
            condition,
            children,
            alternate
        ];
    }
    function parseConditionAttr(attr, _default) {
        const condition = provider($0deed543ccab4a3d$export$ef7acd7185315e22(attr.if));
        let b = ()=>_default;
        let a = ()=>_default;
        if (typeof attr.then === "object") a = parseAttrs(attr.then, void 0);
        else if (typeof attr.then === "string" && attr.then?.startsWith("$")) a = provider($0deed543ccab4a3d$export$ef7acd7185315e22(attr.then));
        else a = ()=>attr.then;
        if ($639fe8cc1eae7e21$export$a4f4bb6b1453fff5(attr, "else")) {
            if (typeof attr.else === "object") b = parseAttrs(attr.else);
            else if (typeof attr.else === "string" && attr.else?.startsWith("$")) b = provider($0deed543ccab4a3d$export$ef7acd7185315e22(attr.else));
            else b = ()=>attr.else;
        }
        return ()=>condition() ? a() : b();
    }
    function parseAttrs(unparsedAttrs, bindExp, _default = {}) {
        const explicitAttrs = new Set(Object.keys(unparsedAttrs || {}));
        const boundAttrs = bindExp ? provider($0deed543ccab4a3d$export$ef7acd7185315e22(bindExp)) : ()=>({});
        const setters = [
            (attrs)=>{
                const bound = boundAttrs();
                for(const attr in bound)if (!explicitAttrs.has(attr)) attrs[attr] = bound[attr];
            }
        ];
        if (unparsedAttrs) {
            if ($0deed543ccab4a3d$export$33d5b72ec833fd5f(unparsedAttrs)) {
                const condition = parseConditionAttr(unparsedAttrs, _default);
                return condition;
            }
            for(let attr in unparsedAttrs){
                const value = unparsedAttrs[attr];
                let getValue2;
                const isStr = typeof value === "string";
                if (attr.startsWith($4e74f275bd5b5b89$var$raw)) {
                    attr = attr.substring(7);
                    getValue2 = ()=>value;
                } else if (isStr && value.startsWith("$") && value.length > 1 && !(value.startsWith("$reset") && $4e74f275bd5b5b89$var$isClassProp.test(attr))) getValue2 = provider($0deed543ccab4a3d$export$ef7acd7185315e22(value));
                else if (typeof value === "object" && $0deed543ccab4a3d$export$33d5b72ec833fd5f(value)) getValue2 = parseConditionAttr(value, void 0);
                else if (typeof value === "object" && $639fe8cc1eae7e21$export$d4c25d8e0539e508(value)) getValue2 = parseAttrs(value);
                else getValue2 = ()=>value;
                setters.push((attrs)=>{
                    attrs[attr] = getValue2();
                });
            }
        }
        return ()=>{
            const attrs = Array.isArray(unparsedAttrs) ? [] : {};
            setters.forEach((setter)=>setter(attrs));
            return attrs;
        };
    }
    function parseNode(library2, _node) {
        let element = null;
        let attrs = ()=>null;
        let condition = false;
        let children = null;
        let alternate = null;
        let iterator = null;
        let resolve = false;
        const node = $0deed543ccab4a3d$export$e970e05fc1e8bae(_node);
        if ($0deed543ccab4a3d$export$41e30d8dd0ba7a50(node)) {
            element = node.$el;
            attrs = node.$el !== "text" ? parseAttrs(node.attrs, node.bind) : ()=>null;
        } else if ($0deed543ccab4a3d$export$3b2d240469e38cce(node)) {
            if (typeof node.$cmp === "string") {
                if ($639fe8cc1eae7e21$export$a4f4bb6b1453fff5(library2, node.$cmp)) element = library2[node.$cmp];
                else {
                    element = node.$cmp;
                    resolve = true;
                }
            } else element = node.$cmp;
            attrs = parseAttrs(node.props, node.bind);
        } else if ($0deed543ccab4a3d$export$33d5b72ec833fd5f(node)) [condition, children, alternate] = parseCondition(library2, node);
        if (!$0deed543ccab4a3d$export$33d5b72ec833fd5f(node) && "if" in node) condition = provider($0deed543ccab4a3d$export$ef7acd7185315e22(node.if));
        else if (!$0deed543ccab4a3d$export$33d5b72ec833fd5f(node) && element === null) condition = ()=>true;
        if ("children" in node && node.children) {
            if (typeof node.children === "string") {
                if (node.children.startsWith("$slots.")) {
                    element = element === "text" ? "slot" : element;
                    children = provider($0deed543ccab4a3d$export$ef7acd7185315e22(node.children));
                } else if (node.children.startsWith("$") && node.children.length > 1) {
                    const value = provider($0deed543ccab4a3d$export$ef7acd7185315e22(node.children));
                    children = ()=>String(value());
                } else children = ()=>String(node.children);
            } else if (Array.isArray(node.children)) children = createElements(library2, node.children);
            else {
                const [childCondition, c, a] = parseCondition(library2, node.children);
                children = (iterationData)=>childCondition && childCondition() ? c && c(iterationData) : a && a(iterationData);
            }
        }
        if ($0deed543ccab4a3d$export$3b2d240469e38cce(node)) {
            if (children) {
                const produceChildren = children;
                children = (iterationData)=>{
                    return {
                        default (slotData2, key) {
                            const currentKey = $4e74f275bd5b5b89$var$instanceKey;
                            if (key) $4e74f275bd5b5b89$var$instanceKey = key;
                            if (slotData2) $4e74f275bd5b5b89$var$instanceScopes.get($4e74f275bd5b5b89$var$instanceKey)?.unshift(slotData2);
                            if (iterationData) $4e74f275bd5b5b89$var$instanceScopes.get($4e74f275bd5b5b89$var$instanceKey)?.unshift(iterationData);
                            const c = produceChildren(iterationData);
                            if (slotData2) $4e74f275bd5b5b89$var$instanceScopes.get($4e74f275bd5b5b89$var$instanceKey)?.shift();
                            if (iterationData) $4e74f275bd5b5b89$var$instanceScopes.get($4e74f275bd5b5b89$var$instanceKey)?.shift();
                            $4e74f275bd5b5b89$var$instanceKey = currentKey;
                            return c;
                        }
                    };
                };
                children.slot = true;
            } else children = ()=>({});
        }
        if ("for" in node && node.for) {
            const values = node.for.length === 3 ? node.for[2] : node.for[1];
            const getValues = typeof values === "string" && values.startsWith("$") ? provider($0deed543ccab4a3d$export$ef7acd7185315e22(values)) : ()=>values;
            iterator = [
                getValues,
                node.for[0],
                node.for.length === 3 ? String(node.for[1]) : null
            ];
        }
        return [
            condition,
            element,
            attrs,
            children,
            alternate,
            iterator,
            resolve
        ];
    }
    function createSlots(children, iterationData) {
        const slots = children(iterationData);
        const currentKey = $4e74f275bd5b5b89$var$instanceKey;
        return Object.keys(slots).reduce((allSlots, slotName)=>{
            const slotFn = slots && slots[slotName];
            allSlots[slotName] = (data)=>{
                return slotFn && slotFn(data, currentKey) || null;
            };
            return allSlots;
        }, {});
    }
    function createElement(library2, node) {
        const [condition, element, attrs, children, alternate, iterator, resolve] = parseNode(library2, node);
        let createNodes = (iterationData)=>{
            if (condition && element === null && children) return condition() ? children(iterationData) : alternate && alternate(iterationData);
            if (element && (!condition || condition())) {
                if (element === "text" && children) return $ani5R.createTextVNode(String(children()));
                if (element === "slot" && children) return children(iterationData);
                const el = resolve ? $ani5R.resolveComponent(element) : element;
                const slots = children?.slot ? createSlots(children, iterationData) : null;
                return $ani5R.h(el, attrs(), slots || (children ? children(iterationData) : []));
            }
            return typeof alternate === "function" ? alternate(iterationData) : alternate;
        };
        if (iterator) {
            const repeatedNode = createNodes;
            const [getValues, valueName, keyName] = iterator;
            createNodes = ()=>{
                const _v = getValues();
                const values = Number.isFinite(_v) ? Array(Number(_v)).fill(0).map((_, i)=>i) : _v;
                const fragment = [];
                if (typeof values !== "object") return null;
                const instanceScope = $4e74f275bd5b5b89$var$instanceScopes.get($4e74f275bd5b5b89$var$instanceKey) || [];
                const isArray = Array.isArray(values);
                for(const key in values){
                    if (isArray && key in Array.prototype) continue;
                    const iterationData = Object.defineProperty({
                        ...instanceScope.reduce((previousIterationData, scopedData)=>{
                            if (previousIterationData.__idata) return {
                                ...previousIterationData,
                                ...scopedData
                            };
                            return scopedData;
                        }, {}),
                        [valueName]: values[key],
                        ...keyName !== null ? {
                            [keyName]: isArray ? Number(key) : key
                        } : {}
                    }, "__idata", {
                        enumerable: false,
                        value: true
                    });
                    instanceScope.unshift(iterationData);
                    fragment.push(repeatedNode.bind(null, iterationData)());
                    instanceScope.shift();
                }
                return fragment;
            };
        }
        return createNodes;
    }
    function createElements(library2, schema2) {
        if (Array.isArray(schema2)) {
            const els = schema2.map(createElement.bind(null, library2));
            return (iterationData)=>els.map((element2)=>element2(iterationData));
        }
        const element = createElement(library2, schema2);
        return (iterationData)=>element(iterationData);
    }
    const providers = [];
    function provider(compiled, hints = {}) {
        const compiledFns = /* @__PURE__ */ new WeakMap();
        providers.push((callback, key)=>{
            compiledFns.set(key, compiled.provide((tokens)=>callback(tokens, hints)));
        });
        return ()=>compiledFns.get($4e74f275bd5b5b89$var$instanceKey)();
    }
    function createInstance(providerCallback, key) {
        memoKey ?? (memoKey = $4e74f275bd5b5b89$var$toMemoKey(schema));
        const [render, compiledProviders] = $639fe8cc1eae7e21$export$a4f4bb6b1453fff5($4e74f275bd5b5b89$var$memo, memoKey) ? $4e74f275bd5b5b89$var$memo[memoKey] : [
            createElements(library, schema),
            providers
        ];
        if (!$4e74f275bd5b5b89$var$isServer2) {
            $4e74f275bd5b5b89$var$memoKeys[memoKey] ?? ($4e74f275bd5b5b89$var$memoKeys[memoKey] = 0);
            $4e74f275bd5b5b89$var$memoKeys[memoKey]++;
            $4e74f275bd5b5b89$var$memo[memoKey] = [
                render,
                compiledProviders
            ];
        }
        compiledProviders.forEach((compiledProvider)=>{
            compiledProvider(providerCallback, key);
        });
        return ()=>{
            $4e74f275bd5b5b89$var$instanceKey = key;
            return render();
        };
    }
    return createInstance;
}
function $4e74f275bd5b5b89$var$useScope(token3, defaultValue) {
    const scopedData = $4e74f275bd5b5b89$var$instanceScopes.get($4e74f275bd5b5b89$var$instanceKey) || [];
    let scopedValue = void 0;
    if (scopedData.length) scopedValue = $4e74f275bd5b5b89$var$getValue(scopedData, token3.split("."));
    return scopedValue === void 0 ? defaultValue : scopedValue;
}
function $4e74f275bd5b5b89$var$slotData(data, key) {
    return new Proxy(data, {
        get (...args) {
            let data2 = void 0;
            const property = args[1];
            if (typeof property === "string") {
                const prevKey = $4e74f275bd5b5b89$var$instanceKey;
                $4e74f275bd5b5b89$var$instanceKey = key;
                data2 = $4e74f275bd5b5b89$var$useScope(property, void 0);
                $4e74f275bd5b5b89$var$instanceKey = prevKey;
            }
            return data2 !== void 0 ? data2 : Reflect.get(...args);
        }
    });
}
function $4e74f275bd5b5b89$var$createRenderFn(instanceCreator, data, instanceKey2) {
    return instanceCreator((requirements, hints = {})=>{
        return requirements.reduce((tokens, token3)=>{
            if (token3.startsWith("slots.")) {
                const slot = token3.substring(6);
                const hasSlot = ()=>data.slots && $639fe8cc1eae7e21$export$a4f4bb6b1453fff5(data.slots, slot) && typeof data.slots[slot] === "function";
                if (hints.if) tokens[token3] = hasSlot;
                else if (data.slots) {
                    const scopedData = $4e74f275bd5b5b89$var$slotData(data, instanceKey2);
                    tokens[token3] = ()=>hasSlot() ? data.slots[slot](scopedData) : null;
                }
            } else {
                const value = $4e74f275bd5b5b89$var$getRef(token3, data);
                tokens[token3] = ()=>$4e74f275bd5b5b89$var$useScope(token3, value.value);
            }
            return tokens;
        }, {});
    }, instanceKey2);
}
function $4e74f275bd5b5b89$var$clean(schema, memoKey, instanceKey2) {
    memoKey ?? (memoKey = $4e74f275bd5b5b89$var$toMemoKey(schema));
    $4e74f275bd5b5b89$var$memoKeys[memoKey]--;
    if ($4e74f275bd5b5b89$var$memoKeys[memoKey] === 0) {
        delete $4e74f275bd5b5b89$var$memoKeys[memoKey];
        const [, providers] = $4e74f275bd5b5b89$var$memo[memoKey];
        delete $4e74f275bd5b5b89$var$memo[memoKey];
        providers.length = 0;
    }
    $4e74f275bd5b5b89$var$instanceScopes.delete(instanceKey2);
}
function $4e74f275bd5b5b89$var$toMemoKey(schema) {
    return JSON.stringify(schema, (_, value)=>{
        if (typeof value === "function") return value.toString();
        return value;
    });
}
var $4e74f275bd5b5b89$var$FormKitSchema = /* @__PURE__ */ $ani5R.defineComponent({
    name: "FormKitSchema",
    props: {
        schema: {
            type: [
                Array,
                Object
            ],
            required: true
        },
        data: {
            type: Object,
            default: ()=>({})
        },
        library: {
            type: Object,
            default: ()=>({})
        },
        memoKey: {
            type: String,
            required: false
        }
    },
    emits: [
        "mounted"
    ],
    setup (props, context) {
        const instance = $ani5R.getCurrentInstance();
        let instanceKey2 = {};
        $4e74f275bd5b5b89$var$instanceScopes.set(instanceKey2, []);
        const library = {
            FormKit: $8bTPG.markRaw($4e74f275bd5b5b89$var$FormKit_default),
            ...props.library
        };
        let provider = $4e74f275bd5b5b89$var$parseSchema(library, props.schema, props.memoKey);
        let render;
        let data;
        if (!$4e74f275bd5b5b89$var$isServer2) $8bTPG.watch(()=>props.schema, (newSchema, oldSchema)=>{
            const oldKey = instanceKey2;
            instanceKey2 = {};
            $4e74f275bd5b5b89$var$instanceScopes.set(instanceKey2, []);
            provider = $4e74f275bd5b5b89$var$parseSchema(library, props.schema, props.memoKey);
            render = $4e74f275bd5b5b89$var$createRenderFn(provider, data, instanceKey2);
            if (newSchema === oldSchema) (instance?.proxy?.$forceUpdate)();
            $4e74f275bd5b5b89$var$clean(props.schema, props.memoKey, oldKey);
        }, {
            deep: true
        });
        $ani5R.watchEffect(()=>{
            data = Object.assign($8bTPG.reactive(props.data ?? {}), {
                slots: context.slots
            });
            context.slots;
            render = $4e74f275bd5b5b89$var$createRenderFn(provider, data, instanceKey2);
        });
        function cleanUp() {
            $4e74f275bd5b5b89$var$clean(props.schema, props.memoKey, instanceKey2);
            if (data) {
                if (data.node) data.node.destroy();
                data.slots = null;
                data = null;
            }
            render = null;
        }
        $ani5R.onMounted(()=>context.emit("mounted"));
        $ani5R.onUnmounted(cleanUp);
        $4e74f275bd5b5b89$var$onSSRComplete($ani5R.getCurrentInstance()?.appContext.app, cleanUp);
        return ()=>render ? render() : null;
    }
});
var $4e74f275bd5b5b89$var$FormKitSchema_default = $4e74f275bd5b5b89$var$FormKitSchema;
var $4e74f275bd5b5b89$var$isServer3 = typeof window === "undefined";
var $4e74f275bd5b5b89$var$parentSymbol = Symbol("FormKitParent");
var $4e74f275bd5b5b89$var$componentSymbol = Symbol("FormKitComponentCallback");
var $4e74f275bd5b5b89$var$currentSchemaNode = null;
var $4e74f275bd5b5b89$var$getCurrentSchemaNode = ()=>$4e74f275bd5b5b89$var$currentSchemaNode;
function $4e74f275bd5b5b89$var$FormKit(props, context) {
    const node = $4e74f275bd5b5b89$var$useInput(props, context);
    if (!node.props.definition) $0deed543ccab4a3d$export$a3bc9b8ed74fc(600, node);
    if (node.props.definition.component) return ()=>$ani5R.h(node.props.definition?.component, {
            context: node.context
        }, {
            ...context.slots
        });
    const schema = $8bTPG.ref([]);
    let memoKey = node.props.definition.schemaMemoKey;
    const generateSchema = ()=>{
        const schemaDefinition = node.props?.definition?.schema;
        if (!schemaDefinition) $0deed543ccab4a3d$export$a3bc9b8ed74fc(601, node);
        if (typeof schemaDefinition === "function") {
            $4e74f275bd5b5b89$var$currentSchemaNode = node;
            schema.value = schemaDefinition({
                ...props.sectionsSchema || {}
            });
            $4e74f275bd5b5b89$var$currentSchemaNode = null;
            if (memoKey && props.sectionsSchema || "memoKey" in schemaDefinition && typeof schemaDefinition.memoKey === "string") memoKey = (memoKey ?? schemaDefinition?.memoKey) + JSON.stringify(props.sectionsSchema);
        } else schema.value = schemaDefinition;
    };
    generateSchema();
    if (!$4e74f275bd5b5b89$var$isServer3) node.on("schema", ()=>{
        memoKey += "\u267B\uFE0F";
        generateSchema();
    });
    context.emit("node", node);
    const definitionLibrary = node.props.definition.library;
    const library = {
        FormKit: $8bTPG.markRaw($4e74f275bd5b5b89$var$formkitComponent),
        ...definitionLibrary,
        ...props.library ?? {}
    };
    function didMount() {
        node.emit("mounted");
    }
    context.expose({
        node: node
    });
    return ()=>$ani5R.h($4e74f275bd5b5b89$var$FormKitSchema, {
            schema: schema.value,
            data: node.context,
            onMounted: didMount,
            library: library,
            memoKey: memoKey
        }, {
            ...context.slots
        });
}
var $4e74f275bd5b5b89$var$formkitComponent = /* @__PURE__ */ $ani5R.defineComponent($4e74f275bd5b5b89$var$FormKit, {
    props: $1b459c88f1929f4a$export$b8f47637d11b035b,
    inheritAttrs: false
});
var $4e74f275bd5b5b89$var$FormKit_default = $4e74f275bd5b5b89$var$formkitComponent;
var $4e74f275bd5b5b89$var$rootSymbol = Symbol();
var $4e74f275bd5b5b89$var$FormKitRoot = /* @__PURE__ */ $ani5R.defineComponent((_p, context)=>{
    const boundary = $8bTPG.ref(null);
    const showBody = $8bTPG.ref(false);
    const shadowRoot = $8bTPG.ref(void 0);
    const stopWatch2 = $8bTPG.watch(boundary, (el)=>{
        let parent = el;
        let root = null;
        while(parent = parent?.parentNode){
            root = parent;
            if (root instanceof ShadowRoot || root instanceof Document) {
                foundRoot(root);
                break;
            }
        }
        stopWatch2();
        showBody.value = true;
    });
    $ani5R.provide($4e74f275bd5b5b89$var$rootSymbol, shadowRoot);
    function foundRoot(root) {
        shadowRoot.value = root;
    }
    return ()=>showBody.value && context.slots.default ? context.slots.default() : $ani5R.h("template", {
            ref: boundary
        });
});
function $4e74f275bd5b5b89$var$createPlugin(app, options) {
    app.component(options.alias || "FormKit", $4e74f275bd5b5b89$var$FormKit_default).component(options.schemaAlias || "FormKitSchema", $4e74f275bd5b5b89$var$FormKitSchema_default);
    return {
        get: $0deed543ccab4a3d$export$3f778c4e796a1f9c,
        setLocale: (locale)=>{
            if (options.config?.rootConfig) options.config.rootConfig.locale = locale;
        },
        clearErrors: $0deed543ccab4a3d$export$69c7a77cf657af8f,
        setErrors: $0deed543ccab4a3d$export$8b2e7eab72dc3481,
        submit: $0deed543ccab4a3d$export$e02251cfbe407ee6,
        reset: $0deed543ccab4a3d$export$aad8462122ac592b
    };
}
var $4e74f275bd5b5b89$var$optionsSymbol = Symbol.for("FormKitOptions");
var $4e74f275bd5b5b89$var$configSymbol = Symbol.for("FormKitConfig");
var $4e74f275bd5b5b89$var$plugin = {
    install (app, _options) {
        const options = Object.assign({
            alias: "FormKit",
            schemaAlias: "FormKitSchema"
        }, typeof _options === "function" ? _options() : _options);
        const rootConfig = $0deed543ccab4a3d$export$45a69314cf48a3eb(options.config || {});
        options.config = {
            rootConfig: rootConfig
        };
        app.config.globalProperties.$formkit = $4e74f275bd5b5b89$var$createPlugin(app, options);
        app.provide($4e74f275bd5b5b89$var$optionsSymbol, options);
        app.provide($4e74f275bd5b5b89$var$configSymbol, rootConfig);
        if (typeof window !== "undefined") globalThis.__FORMKIT_CONFIGS__ = (globalThis.__FORMKIT_CONFIGS__ || []).concat([
            rootConfig
        ]);
    }
};
// packages/vue/src/composables/useInput.ts
var $4e74f275bd5b5b89$var$isBrowser = typeof window !== "undefined";
var $4e74f275bd5b5b89$var$pseudoProps = [
    // Boolean props
    "ignore",
    "disabled",
    "preserve",
    // String props
    "help",
    "label",
    /^preserve(-e|E)rrors/,
    /^[a-z]+(?:-visibility|Visibility|-behavior|Behavior)$/,
    /^[a-zA-Z-]+(?:-class|Class)$/,
    "prefixIcon",
    "suffixIcon",
    /^[a-zA-Z-]+(?:-icon|Icon)$/
];
var $4e74f275bd5b5b89$var$boolProps = [
    "disabled",
    "ignore",
    "preserve"
];
function $4e74f275bd5b5b89$var$classesToNodeProps(node, props) {
    if (props.classes) Object.keys(props.classes).forEach((key)=>{
        if (typeof key === "string") {
            node.props[`_${key}Class`] = props.classes[key];
            if ($639fe8cc1eae7e21$export$a6cdc56e425d0d0a(props.classes[key]) && key === "inner") Object.values(props.classes[key]);
        }
    });
}
function $4e74f275bd5b5b89$var$onlyListeners(props) {
    if (!props) return {};
    const knownListeners = [
        "Submit",
        "SubmitRaw",
        "SubmitInvalid"
    ].reduce((listeners, listener)=>{
        const name = `on${listener}`;
        if (name in props) {
            if (typeof props[name] === "function") listeners[name] = props[name];
        }
        return listeners;
    }, {});
    return knownListeners;
}
function $4e74f275bd5b5b89$var$useInput(props, context, options = {}) {
    const config = Object.assign({}, $ani5R.inject($4e74f275bd5b5b89$var$optionsSymbol) || {}, options);
    const __root = $ani5R.inject($4e74f275bd5b5b89$var$rootSymbol, $8bTPG.ref($4e74f275bd5b5b89$var$isBrowser ? document : void 0));
    const __cmpCallback = $ani5R.inject($4e74f275bd5b5b89$var$componentSymbol, ()=>{});
    const instance = $ani5R.getCurrentInstance();
    const listeners = $4e74f275bd5b5b89$var$onlyListeners(instance?.vnode.props);
    const isVModeled = [
        "modelValue",
        "model-value"
    ].some((prop)=>prop in (instance?.vnode.props ?? {}));
    let isMounted = false;
    $ani5R.onMounted(()=>{
        isMounted = true;
    });
    const value = props.modelValue !== void 0 ? props.modelValue : $639fe8cc1eae7e21$export$359e5dfb2bfaf73a(context.attrs.value);
    function createInitialProps() {
        const initialProps2 = {
            ...$639fe8cc1eae7e21$export$db0c04b6ea9f34a0(props),
            ...listeners,
            type: props.type ?? "text",
            __root: __root.value,
            __slots: context.slots
        };
        const attrs = $639fe8cc1eae7e21$export$67aba9fb222c5e1d($639fe8cc1eae7e21$export$db0c04b6ea9f34a0(context.attrs), $4e74f275bd5b5b89$var$pseudoProps);
        if (!attrs.key) attrs.key = $639fe8cc1eae7e21$export$9e1725a4cfeada27();
        initialProps2.attrs = attrs;
        const propValues = $639fe8cc1eae7e21$export$fe98000b1ab912f3($639fe8cc1eae7e21$export$db0c04b6ea9f34a0(context.attrs), $4e74f275bd5b5b89$var$pseudoProps);
        for(const propName in propValues){
            if ($4e74f275bd5b5b89$var$boolProps.includes(propName) && propValues[propName] === "") propValues[propName] = true;
            initialProps2[$639fe8cc1eae7e21$export$ddab50941423df32(propName)] = propValues[propName];
        }
        const classesProps = {
            props: {}
        };
        $4e74f275bd5b5b89$var$classesToNodeProps(classesProps, props);
        Object.assign(initialProps2, classesProps.props);
        if (typeof initialProps2.type !== "string") {
            initialProps2.definition = initialProps2.type;
            delete initialProps2.type;
        }
        return initialProps2;
    }
    const initialProps = createInitialProps();
    const parent = initialProps.ignore ? null : props.parent || $ani5R.inject($4e74f275bd5b5b89$var$parentSymbol, null);
    const node = $0deed543ccab4a3d$export$270e7ba5936d3c48($639fe8cc1eae7e21$export$8b58be045bf06082(config || {}, {
        name: props.name || void 0,
        value: value,
        parent: parent,
        plugins: (config.plugins || []).concat(props.plugins ?? []),
        config: props.config || {},
        props: initialProps,
        index: props.index,
        sync: !!$639fe8cc1eae7e21$export$96e6ef1411d879b1(context.attrs.sync || context.attrs.dynamic)
    }, false, true));
    __cmpCallback(node);
    if (!node.props.definition) $0deed543ccab4a3d$export$a3bc9b8ed74fc(600, node);
    const lateBoundProps = $8bTPG.ref(new Set(Array.isArray(node.props.__propDefs) ? node.props.__propDefs : Object.keys(node.props.__propDefs ?? {})));
    node.on("added-props", ({ payload: lateProps })=>{
        const propNames = Array.isArray(lateProps) ? lateProps : Object.keys(lateProps ?? {});
        propNames.forEach((newProp)=>lateBoundProps.value.add(newProp));
    });
    const pseudoPropNames = $8bTPG.computed(()=>$4e74f275bd5b5b89$var$pseudoProps.concat([
            ...lateBoundProps.value
        ]).reduce((names, prop)=>{
            if (typeof prop === "string") {
                names.push($639fe8cc1eae7e21$export$ddab50941423df32(prop));
                names.push($639fe8cc1eae7e21$export$28a4dff995472450(prop));
            } else names.push(prop);
            return names;
        }, []));
    $ani5R.watchEffect(()=>$4e74f275bd5b5b89$var$classesToNodeProps(node, props));
    const passThrough = $639fe8cc1eae7e21$export$db0c04b6ea9f34a0(props);
    for(const prop in passThrough)$8bTPG.watch(()=>props[prop], ()=>{
        if (props[prop] !== void 0) node.props[prop] = props[prop];
    });
    $ani5R.watchEffect(()=>{
        node.props.__root = __root.value;
    });
    const attributeWatchers = /* @__PURE__ */ new Set();
    const possibleProps = $639fe8cc1eae7e21$export$db0c04b6ea9f34a0(context.attrs);
    $ani5R.watchEffect(()=>{
        watchAttributes($639fe8cc1eae7e21$export$fe98000b1ab912f3(possibleProps, pseudoPropNames.value));
    });
    function watchAttributes(attrProps) {
        attributeWatchers.forEach((stop)=>{
            stop();
            attributeWatchers.delete(stop);
        });
        for(const prop in attrProps){
            const camelName = $639fe8cc1eae7e21$export$ddab50941423df32(prop);
            attributeWatchers.add($8bTPG.watch(()=>context.attrs[prop], ()=>{
                node.props[camelName] = context.attrs[prop];
            }));
        }
    }
    $ani5R.watchEffect(()=>{
        const attrs = $639fe8cc1eae7e21$export$67aba9fb222c5e1d($639fe8cc1eae7e21$export$db0c04b6ea9f34a0(context.attrs), pseudoPropNames.value);
        if ("multiple" in attrs) attrs.multiple = $639fe8cc1eae7e21$export$96e6ef1411d879b1(attrs.multiple);
        if (typeof attrs.onBlur === "function") attrs.onBlur = $639fe8cc1eae7e21$export$16a9f4045037bb61(attrs.onBlur);
        node.props.attrs = Object.assign({}, node.props.attrs || {}, attrs);
    });
    $ani5R.watchEffect(()=>{
        const messages3 = (props.errors ?? []).map((error3)=>/* @__PURE__ */ $0deed543ccab4a3d$export$62651879628e0c4c({
                key: $639fe8cc1eae7e21$export$c383cdd2a518017a(error3),
                type: "error",
                value: error3,
                meta: {
                    source: "prop"
                }
            }));
        node.store.apply(messages3, (message3)=>message3.type === "error" && message3.meta.source === "prop");
    });
    if (node.type !== "input") {
        const sourceKey = `${node.name}-prop`;
        $ani5R.watchEffect(()=>{
            const inputErrors = props.inputErrors ?? {};
            const keys = Object.keys(inputErrors);
            if (!keys.length) node.clearErrors(true, sourceKey);
            const messages3 = keys.reduce((messages4, key)=>{
                let value2 = inputErrors[key];
                if (typeof value2 === "string") value2 = [
                    value2
                ];
                if (Array.isArray(value2)) messages4[key] = value2.map((error3)=>/* @__PURE__ */ $0deed543ccab4a3d$export$62651879628e0c4c({
                        key: error3,
                        type: "error",
                        value: error3,
                        meta: {
                            source: sourceKey
                        }
                    }));
                return messages4;
            }, {});
            node.store.apply(messages3, (message3)=>message3.type === "error" && message3.meta.source === sourceKey);
        });
    }
    $ani5R.watchEffect(()=>Object.assign(node.config, props.config));
    if (node.type !== "input") $ani5R.provide($4e74f275bd5b5b89$var$parentSymbol, node);
    let clonedValueBeforeVmodel = void 0;
    node.on("modelUpdated", ()=>{
        context.emit("inputRaw", node.context?.value, node);
        if (isMounted) context.emit("input", node.context?.value, node);
        if (isVModeled && node.context) {
            clonedValueBeforeVmodel = $639fe8cc1eae7e21$export$359e5dfb2bfaf73a(node.value);
            context.emit("update:modelValue", $639fe8cc1eae7e21$export$370e8311c3cdebd9(node.value));
        }
    });
    if (isVModeled) {
        $8bTPG.watch($8bTPG.toRef(props, "modelValue"), (value2)=>{
            if (!$639fe8cc1eae7e21$export$9663ddc1cf085b32(clonedValueBeforeVmodel, value2)) node.input(value2, false);
        }, {
            deep: true
        });
        if (node.value !== value) node.emit("modelUpdated");
    }
    $ani5R.onBeforeUnmount(()=>node.destroy());
    return node;
}
var $4e74f275bd5b5b89$var$totalCreated = 1;
function $4e74f275bd5b5b89$var$isComponent2(obj) {
    return typeof obj === "function" && obj.length === 2 || typeof obj === "object" && !Array.isArray(obj) && !("$el" in obj) && !("$cmp" in obj) && !("if" in obj);
}
function $4e74f275bd5b5b89$var$createInput(schemaOrComponent, definitionOptions = {}, sectionsSchema = {}) {
    const definition3 = {
        type: "input",
        ...definitionOptions
    };
    let schema;
    if ($4e74f275bd5b5b89$var$isComponent2(schemaOrComponent)) {
        const cmpName = `SchemaComponent${$4e74f275bd5b5b89$var$totalCreated++}`;
        schema = $1b459c88f1929f4a$export$f3a183bf2efcc835("input", ()=>({
                $cmp: cmpName,
                props: {
                    context: "$node.context"
                }
            }));
        definition3.library = {
            [cmpName]: $8bTPG.markRaw(schemaOrComponent)
        };
    } else if (typeof schemaOrComponent === "function") schema = schemaOrComponent;
    else schema = $1b459c88f1929f4a$export$f3a183bf2efcc835("input", ()=>$639fe8cc1eae7e21$export$359e5dfb2bfaf73a(schemaOrComponent));
    definition3.schema = $1b459c88f1929f4a$export$aecd9c955413bc92(schema || "Schema undefined", sectionsSchema);
    if (!definition3.schemaMemoKey) definition3.schemaMemoKey = `${Math.random()}`;
    return definition3;
}
// packages/vue/src/composables/defineFormKitConfig.ts
function $4e74f275bd5b5b89$var$defineFormKitConfig(config) {
    return ()=>typeof config === "function" ? config() : config;
}
var $4e74f275bd5b5b89$var$inputList = {};
var $4e74f275bd5b5b89$var$schemas = {};
var $4e74f275bd5b5b89$var$classes = {
    container: `
    formkit-kitchen-sink 
    p-8
  `,
    tabs: `
    formkit-tabs 
    mt-4 
    mr-[min(350px,25vw)]
  `,
    tab: `
    formkit-kitchen-sink-tab
    inline-block
    mb-4
    -mr-px
    cursor-pointer
    px-4
    py-2
    border
    border-neutral-200
    text-neutral-800
    data-[active]:bg-neutral-800
    data-[active]:border-neutral-800
    data-[active]:text-neutral-50
    hover:bg-neutral-100
    hover:text-neutral-900
    dark:border-neutral-700
    dark:text-neutral-50
    dark:data-[active]:bg-neutral-100
    dark:data-[active]:border-neutral-100
    dark:data-[active]:text-neutral-800
    dark:hover:bg-neutral-800
    dark:hover:text-neutral-50
  `,
    filterContainer: `
    formkit-filter-container
    grid
    grid-cols-[repeat(auto-fit,300px)]
    mr-[min(350px,25vw)]
    -mt-4
    mb-8
    px-4
    pt-8
    pb-4
    border
    relative
    -translate-y-px
    max-w-[1000px]
    border-neutral-200
    dark:border-neutral-700
  `,
    filterGroup: `
    formkit-filter-group
    mr-8
    mb-8
    [&_legend]:text-lg
    [&_ul]:columns-2
    [&_ul>li:first-child]:[column-span:all]
    [&_ul>li:first-child]:mt-2
    [&_ul>li:first-child]:mb-2
    [&_ul>li:first-child]:pb-2
    [&_ul>li:first-child]:border-b
    [&_ul>li:first-child]:border-neutral-200
    dark:[&_ul>li:first-child]:border-neutral-700
  `,
    formContainer: `
    formkit-form-container
    w-full
    bg-white
    rounded
    border
    border-neutral-100
    shadow-lg
    max-w-[800px]
    p-[min(5vw,5rem)]
    dark:bg-neutral-900
    dark:border-neutral-800
    dark:shadow-3xl
    [&_form>h1]:text-2xl
    [&_form>h1]:mb-4
    [&_form>h1]:font-bold
    [&_form>h1+p]:text-base
    [&_form>h1+p]:mb-4
    [&_form>h1+p]:-mt-2
    [&_form_.double]:flex
    [&_form_.double>*]:w-1/2
    [&_form_.double>*:first-child]:mr-2
    [&_form_.triple]:flex
    [&_form_.triple>*]:w-1/3
    [&_form_.triple>*:first-child]:mr-2
    [&_form_.triple>*:last-child]:ml-2
  `,
    inputs: `formkit-inputs`,
    specimen: `
    formkit-specimen 
    flex 
    flex-col 
    p-2 
    max-w-[75vw]
  `,
    inputSection: `
    group/section
    formkit-input-section 
    mr-[min(325px,25vw)]
  `,
    specimenGroup: `
    formkit-specimen-group
    grid
    mb-16
    grid-cols-[repeat(auto-fit,400px)]
    group-data-[type="transferlist"]/section:grid-cols-[repeat(auto-fit,650px)]
    group-data-[type="multi-step"]/section:grid-cols-[repeat(auto-fit,550px)]
  `,
    inputType: `
    formkit-input-type
    block
    font-bold
    text-neutral-900
    border-b
    border-neutral-100
    text-3xl
    mb-8
    pb-2
    capitalize
    dark:border-neutral-800 
    dark:text-neutral-50
  `
};
async function $4e74f275bd5b5b89$var$fetchInputList() {
    const response = await fetch("https://raw.githubusercontent.com/formkit/input-schemas/master/index.json");
    const json = await response.json();
    return json;
}
async function $4e74f275bd5b5b89$var$fetchInputSchema(input) {
    try {
        const response = await fetch(`https://raw.githubusercontent.com/formkit/input-schemas/master/schemas/${input}.json`);
        const json = await response.json();
        return json;
    } catch (error3) {
        console.error(error3);
    }
}
var $4e74f275bd5b5b89$var$FormKitKitchenSink = /* @__PURE__ */ $ani5R.defineComponent({
    name: "FormKitKitchenSink",
    props: {
        schemas: {
            type: Array,
            required: false
        },
        pro: {
            type: Boolean,
            default: true
        },
        addons: {
            type: Boolean,
            default: true
        },
        forms: {
            type: Boolean,
            default: true
        },
        navigation: {
            type: Boolean,
            default: true
        }
    },
    async setup (props) {
        $ani5R.onMounted(()=>{
            const filterNode = $0deed543ccab4a3d$export$3f778c4e796a1f9c("filter-checkboxes");
            data.filters = $8bTPG.computed(()=>{
                if (!filterNode?.context) return [];
                const filters = filterNode.context.value;
                const filterValues = [];
                Object.keys(filters).forEach((key)=>{
                    filterValues.push(...filters[key]);
                });
                return filterValues;
            });
        });
        $4e74f275bd5b5b89$var$inputList = Object.keys($4e74f275bd5b5b89$var$inputList).length ? $4e74f275bd5b5b89$var$inputList : await $4e74f275bd5b5b89$var$fetchInputList();
        const promises = [];
        const activeTab = $8bTPG.ref("");
        const inputCheckboxes = $8bTPG.computed(()=>{
            const inputGroups = {
                core: {
                    label: "Inputs",
                    name: "core",
                    inputs: $4e74f275bd5b5b89$var$inputList.core
                }
            };
            if (props.pro) inputGroups.pro = {
                label: "Pro Inputs",
                name: "pro",
                inputs: $4e74f275bd5b5b89$var$inputList.pro
            };
            if (props.addons) inputGroups.addons = {
                label: "Add-ons",
                name: "addons",
                inputs: $4e74f275bd5b5b89$var$inputList.addons
            };
            return inputGroups;
        });
        if (!props.schemas) {
            const coreInputPromises = $4e74f275bd5b5b89$var$inputList.core.map(async (schema)=>{
                const response = await $4e74f275bd5b5b89$var$fetchInputSchema(schema);
                $4e74f275bd5b5b89$var$schemas[schema] = response;
            });
            promises.push(...coreInputPromises);
            if (props.forms) {
                const formsPromises = $4e74f275bd5b5b89$var$inputList.forms.map(async (schema)=>{
                    const schemaName = `form/${schema}`;
                    const response = await $4e74f275bd5b5b89$var$fetchInputSchema(schemaName);
                    $4e74f275bd5b5b89$var$schemas[schemaName] = response;
                });
                promises.push(...formsPromises);
            }
            if (props.pro) {
                const proInputPromises = $4e74f275bd5b5b89$var$inputList.pro.map(async (schema)=>{
                    const response = await $4e74f275bd5b5b89$var$fetchInputSchema(schema);
                    $4e74f275bd5b5b89$var$schemas[schema] = response;
                });
                promises.push(...proInputPromises);
            }
            if (props.addons) {
                const addonPromises = $4e74f275bd5b5b89$var$inputList.addons.map(async (schema)=>{
                    const response = await $4e74f275bd5b5b89$var$fetchInputSchema(schema);
                    $4e74f275bd5b5b89$var$schemas[schema] = response;
                });
                promises.push(...addonPromises);
            }
        } else {
            const schemaPromises = props.schemas.map(async (schema)=>{
                const response = await $4e74f275bd5b5b89$var$fetchInputSchema(`${schema}`);
                $4e74f275bd5b5b89$var$schemas[`${schema}`] = response;
            });
            promises.push(...schemaPromises);
        }
        const selectAll = (node)=>{
            let previousValue = [];
            let skip = false;
            if (node.props.type !== "checkbox") return;
            node.on("created", ()=>{
                const currentValue = node.value;
                if (Array.isArray(currentValue) && currentValue.length === 1 && currentValue[0] === "all") node.input(node.props.options.map((option)=>{
                    if (typeof option !== "string") return option.value;
                    return option;
                }));
                previousValue = Array.isArray(node.value) ? node.value : [];
            });
            node.on("commit", ({ payload: payload })=>{
                if (skip) {
                    skip = false;
                    return;
                }
                if (!Array.isArray(payload)) return;
                const previousValueHadAll = previousValue.includes("all");
                const currentValueHasAll = payload.includes("all");
                if (!previousValueHadAll && currentValueHasAll) {
                    const computedOptions = node.props.options.map((option)=>{
                        if (typeof option !== "string") return option.value;
                        return option;
                    });
                    node.input(computedOptions);
                    previousValue = computedOptions;
                    return;
                }
                if (previousValueHadAll && !currentValueHasAll) {
                    node.input([]);
                    previousValue = [];
                    return;
                }
                const valueMinusAll = payload.filter((value)=>value !== "all");
                if (valueMinusAll.length < node.props.options.length - 1 && currentValueHasAll) {
                    node.input(valueMinusAll);
                    previousValue = valueMinusAll;
                    skip = true;
                    return;
                }
                if (valueMinusAll.length === node.props.options.length - 1 && !currentValueHasAll) {
                    const computedOptions = node.props.options.map((option)=>{
                        if (typeof option !== "string") return option.value;
                        return option;
                    });
                    node.input(computedOptions);
                    previousValue = Array.isArray(node.value) ? node.value : [];
                    return;
                }
            });
        };
        const data = $8bTPG.reactive({
            twClasses: $4e74f275bd5b5b89$var$classes,
            basicOptions: Array.from({
                length: 15
            }, (_, i)=>`Option ${i + 1}`),
            asyncLoader: async ()=>{
                return await new Promise(()=>{});
            },
            paginatedLoader: async ({ page: page, hasNextPage: hasNextPage })=>{
                const base = (page - 1) * 10;
                hasNextPage();
                return Array.from({
                    length: 10
                }, (_, i)=>`Option ${base + i + 1}`);
            },
            formSubmitHandler: async (data2)=>{
                await new Promise((resolve)=>setTimeout(resolve, 1e3));
                alert("Form submitted (fake) \u2014 check console for data object");
                console.log("Form data:", data2);
            },
            includes: (array, value)=>{
                if (!Array.isArray(array)) return false;
                return array.includes(value);
            },
            checkboxPlugins: [
                selectAll
            ],
            filters: []
        });
        await Promise.all(promises);
        const inputKeys = Object.keys($4e74f275bd5b5b89$var$schemas);
        const formNames = inputKeys.map((key)=>{
            if (key.startsWith("form/")) switch(key){
                case "form/tshirt":
                    return {
                        id: key,
                        name: "Order Form"
                    };
                default:
                    const name = key.replace("form/", "");
                    return {
                        id: key,
                        name: name.charAt(0).toUpperCase() + name.slice(1) + " Form"
                    };
            }
            return {
                id: key,
                name: ""
            };
        });
        const filteredFormNames = formNames.filter((form)=>form.name !== "");
        const forms = inputKeys.filter((schema)=>{
            return schema.startsWith("form/");
        });
        const inputs = inputKeys.filter((schema)=>!schema.startsWith("form/"));
        const tabs = [];
        if (inputs.length) tabs.push({
            id: "kitchen-sink",
            name: "Kitchen Sink"
        });
        if (forms.length) tabs.push(...filteredFormNames.sort((a, b)=>a.name > b.name ? 1 : -1));
        if (tabs.length) activeTab.value = tabs[0].id;
        const kitchenSinkRenders = $8bTPG.computed(()=>{
            inputs.sort();
            const schemaDefinitions = inputs.reduce((schemaDefinitions2, inputName)=>{
                const schemaDefinition = $4e74f275bd5b5b89$var$schemas[inputName];
                schemaDefinitions2.push({
                    $el: "div",
                    if: '$includes($filters, "' + inputName + '")',
                    attrs: {
                        key: inputName,
                        class: "$twClasses.inputSection",
                        "data-type": inputName
                    },
                    children: [
                        {
                            $el: "h2",
                            attrs: {
                                class: "$twClasses.inputType"
                            },
                            children: inputName
                        },
                        {
                            $el: "div",
                            attrs: {
                                class: "$twClasses.specimenGroup"
                            },
                            children: [
                                ...(Array.isArray(schemaDefinition) ? schemaDefinition : [
                                    schemaDefinition
                                ]).map((specimen)=>{
                                    return {
                                        $el: "div",
                                        attrs: {
                                            class: "$twClasses.specimen"
                                        },
                                        children: [
                                            specimen
                                        ]
                                    };
                                })
                            ]
                        }
                    ]
                });
                return schemaDefinitions2;
            }, []);
            return $ani5R.h($ani5R.KeepAlive, {}, {
                default: ()=>{
                    return activeTab.value === "kitchen-sink" ? $ani5R.h($4e74f275bd5b5b89$var$FormKitSchema, {
                        schema: schemaDefinitions,
                        data: data
                    }) : null;
                }
            });
        });
        const formRenders = $8bTPG.computed(()=>{
            return filteredFormNames.map((form)=>{
                const schemaDefinition = $4e74f275bd5b5b89$var$schemas[form.id];
                return $ani5R.h("div", {
                    key: form.id
                }, activeTab.value === form.id ? [
                    $ani5R.h("div", {
                        class: $4e74f275bd5b5b89$var$classes.formContainer
                    }, [
                        $ani5R.h($4e74f275bd5b5b89$var$FormKitSchema, {
                            schema: schemaDefinition[0],
                            data: data
                        })
                    ])
                ] : "");
            }).filter((form)=>form.children);
        });
        const tabBar = $8bTPG.computed(()=>{
            return $ani5R.h("div", {
                key: "tab-bar",
                class: $4e74f275bd5b5b89$var$classes.tabs
            }, tabs.map((tab)=>{
                return $ani5R.h("span", {
                    class: $4e74f275bd5b5b89$var$classes.tab,
                    key: tab.id,
                    "data-tab": tab.id,
                    "data-active": activeTab.value === tab.id || void 0,
                    onClick: ()=>{
                        activeTab.value = tab.id;
                    }
                }, tab.name);
            }));
        });
        const filterCheckboxes = $8bTPG.computed(()=>{
            const createCheckboxSchema = (inputGroup)=>{
                return {
                    $el: "div",
                    attrs: {
                        class: "$twClasses.filterGroup"
                    },
                    children: [
                        {
                            $formkit: "checkbox",
                            name: inputGroup.name,
                            label: inputGroup.label,
                            plugins: "$checkboxPlugins",
                            value: [
                                "all"
                            ],
                            options: [
                                {
                                    label: "All",
                                    value: "all"
                                },
                                ...Array.isArray(inputGroup.inputs) ? inputGroup.inputs : []
                            ]
                        }
                    ]
                };
            };
            const filterSchema = $ani5R.h($4e74f275bd5b5b89$var$FormKitSchema, {
                key: "filter-checkboxes",
                data: data,
                schema: {
                    $formkit: "group",
                    id: "filter-checkboxes",
                    children: [
                        {
                            $el: "div",
                            attrs: {
                                class: "$twClasses.filterContainer"
                            },
                            children: Object.keys(inputCheckboxes.value).map((key)=>{
                                const inputGroup = inputCheckboxes.value[key];
                                return createCheckboxSchema(inputGroup);
                            })
                        }
                    ]
                }
            });
            return $ani5R.h($ani5R.KeepAlive, {}, {
                default: ()=>{
                    if (!(tabs.find((tab)=>tab.id === "kitchen-sink") && activeTab.value === "kitchen-sink")) return null;
                    return filterSchema;
                }
            });
        });
        return ()=>{
            return $ani5R.h("div", {
                class: $4e74f275bd5b5b89$var$classes.container
            }, [
                tabs.length > 1 ? tabBar.value : void 0,
                filterCheckboxes.value,
                ...formRenders.value,
                kitchenSinkRenders.value
            ]);
        };
    }
});
var $4e74f275bd5b5b89$var$messages = $1b459c88f1929f4a$export$f3a183bf2efcc835("messages", ()=>({
        $el: "ul",
        if: "$fns.length($messages)"
    }));
var $4e74f275bd5b5b89$var$message = $1b459c88f1929f4a$export$f3a183bf2efcc835("message", ()=>({
        $el: "li",
        for: [
            "message",
            "$messages"
        ],
        attrs: {
            key: "$message.key",
            id: `$id + '-' + $message.key`,
            "data-message-type": "$message.type"
        }
    }));
var $4e74f275bd5b5b89$var$definition = $4e74f275bd5b5b89$var$messages($4e74f275bd5b5b89$var$message("$message.value"));
var $4e74f275bd5b5b89$var$FormKitMessages = /* @__PURE__ */ $ani5R.defineComponent({
    props: {
        node: {
            type: Object,
            required: false
        },
        sectionsSchema: {
            type: Object,
            default: {}
        },
        defaultPosition: {
            type: [
                String,
                Boolean
            ],
            default: false
        },
        library: {
            type: Object,
            default: ()=>({})
        }
    },
    setup (props, context) {
        const node = $8bTPG.computed(()=>{
            return props.node || $ani5R.inject($4e74f275bd5b5b89$var$parentSymbol, void 0);
        });
        $8bTPG.watch(node, ()=>{
            if (node.value?.context && !$639fe8cc1eae7e21$export$96e6ef1411d879b1(props.defaultPosition)) node.value.context.defaultMessagePlacement = false;
        }, {
            immediate: true
        });
        const schema = $4e74f275bd5b5b89$var$definition(props.sectionsSchema || {});
        const data = $8bTPG.computed(()=>{
            return {
                messages: node.value?.context?.messages || {},
                fns: node.value?.context?.fns || {},
                classes: node.value?.context?.classes || {}
            };
        });
        return ()=>node.value?.context ? $ani5R.h($4e74f275bd5b5b89$var$FormKitSchema_default, {
                schema: schema,
                data: data.value,
                library: props.library
            }, {
                ...context.slots
            }) : null;
    }
});
function $4e74f275bd5b5b89$var$useConfig(config) {
    const options = Object.assign({
        alias: "FormKit",
        schemaAlias: "FormKitSchema"
    }, typeof config === "function" ? config() : config);
    const rootConfig = $0deed543ccab4a3d$export$45a69314cf48a3eb(options.config || {});
    options.config = {
        rootConfig: rootConfig
    };
    $ani5R.provide($4e74f275bd5b5b89$var$optionsSymbol, options);
    $ani5R.provide($4e74f275bd5b5b89$var$configSymbol, rootConfig);
    if (typeof window !== "undefined") globalThis.__FORMKIT_CONFIGS__ = (globalThis.__FORMKIT_CONFIGS__ || []).concat([
        rootConfig
    ]);
}
var $4e74f275bd5b5b89$var$FormKitProvider = /* @__PURE__ */ $ani5R.defineComponent(function FormKitProvider2(props, { slots: slots, attrs: attrs }) {
    const options = {};
    if (props.config) $4e74f275bd5b5b89$var$useConfig(props.config);
    return ()=>slots.default ? slots.default(options).map((vnode)=>{
            return $ani5R.h(vnode, {
                ...attrs,
                ...vnode.props
            });
        }) : null;
}, {
    props: [
        "config"
    ],
    name: "FormKitProvider",
    inheritAttrs: false
});
var $4e74f275bd5b5b89$var$FormKitConfigLoader = /* @__PURE__ */ $ani5R.defineComponent(async function FormKitConfigLoader2(props, context) {
    let config = {};
    if (props.configFile) {
        const configFile = await import(/*@__formkit.config.ts__*/ /* @vite-ignore */ /* webpackIgnore: true */ props.configFile);
        config = "default" in configFile ? configFile.default : configFile;
    }
    if (typeof config === "function") config = config();
    const useDefaultConfig = props.defaultConfig ?? true;
    if (useDefaultConfig) {
        const { defaultConfig: defaultConfig2 } = await Promise.resolve().then(function() {
            return import(props.configFile);
        }).then((res)=>($4e74f275bd5b5b89$var$init_defaultConfig(), $4e74f275bd5b5b89$var$defaultConfig_exports));
        config = /* @__PURE__ */ defaultConfig2(config);
    }
    return ()=>$ani5R.h($4e74f275bd5b5b89$var$FormKitProvider, {
            ...context.attrs,
            config: config
        }, context.slots);
}, {
    props: [
        "defaultConfig",
        "configFile"
    ],
    inheritAttrs: false
});
var $4e74f275bd5b5b89$var$FormKitLazyProvider = /* @__PURE__ */ $ani5R.defineComponent(function FormKitLazyProvider2(props, context) {
    const config = $ani5R.inject($4e74f275bd5b5b89$var$optionsSymbol, null);
    const passthru = (vnode)=>{
        return $ani5R.h(vnode, {
            ...context.attrs,
            ...vnode.props
        });
    };
    if (config) return ()=>context.slots?.default ? context.slots.default().map(passthru) : null;
    const instance = $ani5R.getCurrentInstance();
    if (instance.suspense) return ()=>$ani5R.h($4e74f275bd5b5b89$var$FormKitConfigLoader, props, {
            default: ()=>context.slots?.default ? context.slots.default().map(passthru) : null
        });
    return ()=>$ani5R.h($ani5R.Suspense, null, {
            ...context.slots,
            default: ()=>$ani5R.h($4e74f275bd5b5b89$var$FormKitConfigLoader, {
                    ...context.attrs,
                    ...props
                }, context.slots)
        });
}, {
    props: [
        "defaultConfig",
        "configFile"
    ],
    inheritAttrs: false
});
function $4e74f275bd5b5b89$var$useFormKitContext(addressOrEffect, optionalEffect) {
    const address = typeof addressOrEffect === "string" ? addressOrEffect : void 0;
    const effect = typeof addressOrEffect === "function" ? addressOrEffect : optionalEffect;
    const context = $8bTPG.ref();
    const parentNode = $ani5R.inject($4e74f275bd5b5b89$var$parentSymbol, null);
    if (parentNode) {
        if (address) {
            context.value = parentNode.at(address)?.context;
            const root = parentNode.at("$root");
            if (root) {
                const receipt = root.on("child.deep", ()=>{
                    const targetNode = parentNode.at(address);
                    if (targetNode && targetNode.context !== context.value) {
                        context.value = targetNode.context;
                        if (effect) effect(context.value);
                    }
                });
                $ani5R.onUnmounted(()=>{
                    root.off(receipt);
                });
            }
        } else context.value = parentNode?.context;
    }
    if (context.value && effect) effect(context.value);
    return context;
}
function $4e74f275bd5b5b89$var$useFormKitContextById(id, effect) {
    const context = $8bTPG.ref();
    const targetNode = $0deed543ccab4a3d$export$3f778c4e796a1f9c(id);
    if (targetNode) context.value = targetNode.context;
    if (!targetNode) {
        const receipt = $0deed543ccab4a3d$export$e6fd047a0a0a675b(id, ({ payload: node })=>{
            if (node) {
                context.value = node.context;
                $0deed543ccab4a3d$export$d38475e6e890fc63(receipt);
                if (effect) effect(context.value);
            }
        });
    }
    if (context.value && effect) effect(context.value);
    return context;
}
function $4e74f275bd5b5b89$var$useFormKitNodeById(id, effect) {
    const nodeRef = $8bTPG.ref();
    const targetNode = $0deed543ccab4a3d$export$3f778c4e796a1f9c(id);
    if (targetNode) nodeRef.value = targetNode;
    if (!targetNode) {
        const receipt = $0deed543ccab4a3d$export$e6fd047a0a0a675b(id, ({ payload: node })=>{
            if (node) {
                nodeRef.value = node;
                $0deed543ccab4a3d$export$d38475e6e890fc63(receipt);
                if (effect) effect(node);
            }
        });
    }
    if (nodeRef.value && effect) effect(nodeRef.value);
    return nodeRef;
}
var $4e74f275bd5b5b89$var$summary = $1b459c88f1929f4a$export$f3a183bf2efcc835("summary", ()=>({
        $el: "div",
        attrs: {
            "aria-live": "polite"
        }
    }));
var $4e74f275bd5b5b89$var$summaryInner = $1b459c88f1929f4a$export$f3a183bf2efcc835("summaryInner", ()=>({
        $el: "div",
        if: "$summaries.length && $showSummaries"
    }));
var $4e74f275bd5b5b89$var$messages2 = $1b459c88f1929f4a$export$f3a183bf2efcc835("messages", ()=>({
        $el: "ul",
        if: "$summaries.length && $showSummaries"
    }));
var $4e74f275bd5b5b89$var$message2 = $1b459c88f1929f4a$export$f3a183bf2efcc835("message", ()=>({
        $el: "li",
        for: [
            "summary",
            "$summaries"
        ],
        attrs: {
            key: "$summary.key",
            "data-message-type": "$summary.type"
        }
    }));
var $4e74f275bd5b5b89$var$summaryHeader = $1b459c88f1929f4a$export$f3a183bf2efcc835("summaryHeader", ()=>({
        $el: "h2",
        attrs: {
            id: "$id"
        }
    }));
var $4e74f275bd5b5b89$var$messageLink = $1b459c88f1929f4a$export$f3a183bf2efcc835("messageLink", ()=>({
        $el: "a",
        attrs: {
            id: "$summary.key",
            href: '$: "#" + $summary.id',
            onClick: "$jumpLink"
        }
    }));
var $4e74f275bd5b5b89$var$definition2 = $4e74f275bd5b5b89$var$summary($4e74f275bd5b5b89$var$summaryInner($4e74f275bd5b5b89$var$summaryHeader("$summaryHeader"), $4e74f275bd5b5b89$var$messages2($4e74f275bd5b5b89$var$message2($4e74f275bd5b5b89$var$messageLink("$summary.message")))));
var $4e74f275bd5b5b89$var$FormKitSummary = /* @__PURE__ */ $ani5R.defineComponent({
    props: {
        node: {
            type: Object,
            required: false
        },
        forceShow: {
            type: Boolean,
            default: false
        },
        sectionsSchema: {
            type: Object,
            default: {}
        }
    },
    emits: {
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ show: (_summaries)=>true
    },
    setup (props, context) {
        const id = `summary-${$639fe8cc1eae7e21$export$9e1725a4cfeada27()}`;
        const node = $8bTPG.computed(()=>{
            return props.node || $ani5R.inject($4e74f275bd5b5b89$var$parentSymbol, void 0);
        });
        if (!node) throw new Error("FormKitSummary must have a FormKit parent or use the node prop.");
        const summaryContexts = $8bTPG.ref([]);
        const showSummaries = $8bTPG.ref(false);
        const summaries = $8bTPG.computed(()=>{
            const summarizedMessages = [];
            summaryContexts.value.forEach((context2)=>{
                for(const idx in context2.messages){
                    const message3 = context2.messages[idx];
                    if (typeof message3.value !== "string") continue;
                    summarizedMessages.push({
                        message: message3.value,
                        id: context2.id,
                        key: `${context2.id}-${message3.key}`,
                        type: message3.type
                    });
                }
            });
            return summarizedMessages;
        });
        const addContexts = ()=>{
            summaryContexts.value = [];
            node.value?.walk((child)=>child.context && summaryContexts.value.push(child.context));
        };
        node.value?.on("submit-raw", async ()=>{
            addContexts();
            if (summaries.value.length === 0) return;
            context.emit("show", summaries.value);
            showSummaries.value = true;
            await $ani5R.nextTick();
            if (typeof window !== "undefined") {
                document.getElementById(id)?.scrollIntoView({
                    behavior: "smooth"
                });
                if (summaries.value[0]) document.getElementById(summaries.value[0].key)?.focus();
            }
        });
        node.value?.on("child", addContexts);
        function jumpLink(e) {
            if (e.target instanceof HTMLAnchorElement) {
                e.preventDefault();
                const id2 = e.target.getAttribute("href")?.substring(1);
                if (id2) {
                    document.getElementById(id2)?.scrollIntoView({
                        behavior: "smooth"
                    });
                    document.getElementById(id2)?.focus();
                }
            }
        }
        $1b459c88f1929f4a$export$b3bd0bc58e36cd63("summaryHeader", "There were errors in your form.")(node.value);
        const schema = $4e74f275bd5b5b89$var$definition2(props.sectionsSchema || {});
        const data = $8bTPG.computed(()=>{
            return {
                id: id,
                fns: node.value?.context?.fns || {},
                classes: node.value?.context?.classes || {},
                summaries: summaries.value,
                showSummaries: props.forceShow || showSummaries.value,
                summaryHeader: node.value?.context?.ui?.summaryHeader?.value || "",
                jumpLink: jumpLink
            };
        });
        return ()=>node.value?.context ? $ani5R.h($4e74f275bd5b5b89$var$FormKitSchema_default, {
                schema: schema,
                data: data.value
            }, {
                ...context.slots
            }) : null;
    }
});
// packages/vue/src/index.ts
$4e74f275bd5b5b89$var$init_defaultConfig();
$4e74f275bd5b5b89$var$init_bindings();
var $4e74f275bd5b5b89$var$FormKitIcon = /* @__PURE__ */ $ani5R.defineComponent({
    name: "FormKitIcon",
    props: {
        icon: {
            type: String,
            default: ""
        },
        iconLoader: {
            type: Function,
            default: null
        },
        iconLoaderUrl: {
            type: Function,
            default: null
        }
    },
    setup (props) {
        const icon = $8bTPG.ref(void 0);
        const config = $ani5R.inject($4e74f275bd5b5b89$var$optionsSymbol, {});
        const parent = $ani5R.inject($4e74f275bd5b5b89$var$parentSymbol, null);
        let iconHandler = void 0;
        function loadIcon() {
            if (!iconHandler || typeof iconHandler !== "function") return;
            const iconOrPromise = iconHandler(props.icon);
            if (iconOrPromise instanceof Promise) iconOrPromise.then((iconValue)=>{
                icon.value = iconValue;
            });
            else icon.value = iconOrPromise;
        }
        if (props.iconLoader && typeof props.iconLoader === "function") iconHandler = $1d18f2ec05e756c7$export$90a7723193b39e9(props.iconLoader);
        else if (parent && parent.props?.iconLoader) iconHandler = $1d18f2ec05e756c7$export$90a7723193b39e9(parent.props.iconLoader);
        else if (props.iconLoaderUrl && typeof props.iconLoaderUrl === "function") iconHandler = $1d18f2ec05e756c7$export$90a7723193b39e9(iconHandler, props.iconLoaderUrl);
        else {
            const iconPlugin = config?.plugins?.find((plugin2)=>{
                return typeof plugin2.iconHandler === "function";
            });
            if (iconPlugin) iconHandler = iconPlugin.iconHandler;
        }
        $8bTPG.watch(()=>props.icon, ()=>{
            loadIcon();
        }, {
            immediate: true
        });
        return ()=>{
            if (props.icon && icon.value) return $ani5R.h("span", {
                class: "formkit-icon",
                innerHTML: icon.value
            });
            return null;
        };
    }
});
function $4e74f275bd5b5b89$var$resetCount() {
    $1b459c88f1929f4a$export$491e3fe6732c33f1();
    $0deed543ccab4a3d$export$218404c250ebcb05();
}
Object.defineProperty($4e74f275bd5b5b89$exports, "clearErrors", {
    enumerable: true,
    get: function() {
        return $0deed543ccab4a3d$export$69c7a77cf657af8f;
    }
});
Object.defineProperty($4e74f275bd5b5b89$exports, "errorHandler", {
    enumerable: true,
    get: function() {
        return $0deed543ccab4a3d$export$cc3fdd528b56c4a9;
    }
});
Object.defineProperty($4e74f275bd5b5b89$exports, "reset", {
    enumerable: true,
    get: function() {
        return $0deed543ccab4a3d$export$aad8462122ac592b;
    }
});
Object.defineProperty($4e74f275bd5b5b89$exports, "setErrors", {
    enumerable: true,
    get: function() {
        return $0deed543ccab4a3d$export$8b2e7eab72dc3481;
    }
});
Object.defineProperty($4e74f275bd5b5b89$exports, "submitForm", {
    enumerable: true,
    get: function() {
        return $0deed543ccab4a3d$export$e02251cfbe407ee6;
    }
});
Object.defineProperty($4e74f275bd5b5b89$exports, "changeLocale", {
    enumerable: true,
    get: function() {
        return $a262a7e50e5a100c$export$7343075cd7f756c5;
    }
});
$4e74f275bd5b5b89$exports.FormKit = $4e74f275bd5b5b89$var$FormKit_default;
$4e74f275bd5b5b89$exports.FormKitIcon = $4e74f275bd5b5b89$var$FormKitIcon;
$4e74f275bd5b5b89$exports.FormKitKitchenSink = $4e74f275bd5b5b89$var$FormKitKitchenSink;
$4e74f275bd5b5b89$exports.FormKitLazyProvider = $4e74f275bd5b5b89$var$FormKitLazyProvider;
$4e74f275bd5b5b89$exports.FormKitMessages = $4e74f275bd5b5b89$var$FormKitMessages;
$4e74f275bd5b5b89$exports.FormKitProvider = $4e74f275bd5b5b89$var$FormKitProvider;
$4e74f275bd5b5b89$exports.FormKitRoot = $4e74f275bd5b5b89$var$FormKitRoot;
$4e74f275bd5b5b89$exports.FormKitSchema = $4e74f275bd5b5b89$var$FormKitSchema;
$4e74f275bd5b5b89$exports.FormKitSummary = $4e74f275bd5b5b89$var$FormKitSummary;
$4e74f275bd5b5b89$exports.componentSymbol = $4e74f275bd5b5b89$var$componentSymbol;
$4e74f275bd5b5b89$exports.configSymbol = $4e74f275bd5b5b89$var$configSymbol;
$4e74f275bd5b5b89$exports.createInput = $4e74f275bd5b5b89$var$createInput;
$4e74f275bd5b5b89$exports.defineFormKitConfig = $4e74f275bd5b5b89$var$defineFormKitConfig;
$4e74f275bd5b5b89$exports.getCurrentSchemaNode = $4e74f275bd5b5b89$var$getCurrentSchemaNode;
$4e74f275bd5b5b89$exports.onSSRComplete = $4e74f275bd5b5b89$var$onSSRComplete;
$4e74f275bd5b5b89$exports.optionsSymbol = $4e74f275bd5b5b89$var$optionsSymbol;
$4e74f275bd5b5b89$exports.parentSymbol = $4e74f275bd5b5b89$var$parentSymbol;
$4e74f275bd5b5b89$exports.plugin = $4e74f275bd5b5b89$var$plugin;
$4e74f275bd5b5b89$exports.resetCount = $4e74f275bd5b5b89$var$resetCount;
$4e74f275bd5b5b89$exports.rootSymbol = $4e74f275bd5b5b89$var$rootSymbol;
$4e74f275bd5b5b89$exports.ssrComplete = $4e74f275bd5b5b89$var$ssrComplete;
$4e74f275bd5b5b89$exports.useConfig = $4e74f275bd5b5b89$var$useConfig;
$4e74f275bd5b5b89$exports.useFormKitContext = $4e74f275bd5b5b89$var$useFormKitContext;
$4e74f275bd5b5b89$exports.useFormKitContextById = $4e74f275bd5b5b89$var$useFormKitContextById;
$4e74f275bd5b5b89$exports.useFormKitNodeById = $4e74f275bd5b5b89$var$useFormKitNodeById;
$4e74f275bd5b5b89$exports.useInput = $4e74f275bd5b5b89$var$useInput; //# sourceMappingURL=out.js.map
 //# sourceMappingURL=index.cjs.map



var $gqFxE = parcelRequire("gqFxE");
let $4a6c4fb475a37d22$var$script;



let $4a6c4fb475a37d22$var$initialize = ()=>{
    $4a6c4fb475a37d22$var$script = (parcelRequire("lHFn1"));
    if ($4a6c4fb475a37d22$var$script.__esModule) $4a6c4fb475a37d22$var$script = $4a6c4fb475a37d22$var$script.default;
    $4a6c4fb475a37d22$var$script.render = (parcelRequire("13HSe")).render;
    (parcelRequire("jT0Dj")).default($4a6c4fb475a37d22$var$script);
    $4a6c4fb475a37d22$var$script.__scopeId = 'data-v-4932d5';
    $4a6c4fb475a37d22$var$script.__file = "App.vue";
};
$4a6c4fb475a37d22$var$initialize();
var $4a6c4fb475a37d22$export$2e2bcd8739ae039 = $4a6c4fb475a37d22$var$script;


let $af18753956600624$var$script;




let $af18753956600624$var$initialize = ()=>{
    $af18753956600624$var$script = (parcelRequire("3lAm9"));
    if ($af18753956600624$var$script.__esModule) $af18753956600624$var$script = $af18753956600624$var$script.default;
    $af18753956600624$var$script.render = (parcelRequire("5Uig2")).render;
    $af18753956600624$var$script.__cssModules = {};
    (parcelRequire("9oGFb")).default($af18753956600624$var$script);
    $af18753956600624$var$script.__scopeId = 'data-v-308c00';
    $af18753956600624$var$script.__file = "ContactForm.vue";
};
$af18753956600624$var$initialize();
var $af18753956600624$export$2e2bcd8739ae039 = $af18753956600624$var$script;



const $122ebb9b04db9379$var$getRandomId = ()=>{
    const randomStrBase = "privacyhub-vue-";
    const randomId = Math.floor(Math.random() * 100000000).toString();
    return randomStrBase.concat(randomId);
};
const $122ebb9b04db9379$var$createMountPoint = (selector, selectorId)=>{
    selector.setAttribute("id", selectorId);
};
const $122ebb9b04db9379$var$getVueMountPoint = (mountPoint)=>{
    return '#'.concat(mountPoint);
};
const $122ebb9b04db9379$var$findEmbeds = ()=>{
    const mountSelector = "[data-id='privacyhub-vue']";
    return document.querySelectorAll(mountSelector);
};
const $122ebb9b04db9379$var$getStartPage = (foundEmbed)=>{
    if (!foundEmbed) return false;
    const page = foundEmbed.dataset?.page;
    return page ?? false;
};
const $122ebb9b04db9379$var$getQuery = (foundEmbed)=>{
    const query = foundEmbed.dataset?.query;
    return query ?? '';
};
const $122ebb9b04db9379$var$getFolder = (foundEmbed)=>{
    const folder = foundEmbed.dataset?.folder;
    return folder ?? '';
};
const $122ebb9b04db9379$var$initVueOnEmbed = (foundEmbed)=>{
    const startPage = $122ebb9b04db9379$var$getStartPage(foundEmbed);
    if (!startPage) return;
    const query = $122ebb9b04db9379$var$getQuery(foundEmbed);
    const folder = $122ebb9b04db9379$var$getFolder(foundEmbed);
    const embedMountId = $122ebb9b04db9379$var$getRandomId();
    $122ebb9b04db9379$var$createMountPoint(foundEmbed, embedMountId);
    const vueMountPoint = $122ebb9b04db9379$var$getVueMountPoint(embedMountId);
    const app = (0, $dDLnc.createApp)((0, $4a6c4fb475a37d22$export$2e2bcd8739ae039), {
        startPage: startPage,
        query: query,
        folder: folder
    });
    app.component('ContactForm', (0, $af18753956600624$export$2e2bcd8739ae039));
    app.component("v-select", (0, $16dcc0d2591159e5$export$2e2bcd8739ae039));
    app.use((0, $gqFxE.createPinia)());
    app.use((0, $4e74f275bd5b5b89$exports.plugin), (0, $4e74f275bd5b5b89$exports.defaultConfig));
    app.mount(vueMountPoint);
};
(()=>{
    const foundEmbeds = $122ebb9b04db9379$var$findEmbeds();
    foundEmbeds.forEach((foundEmbed)=>{
        $122ebb9b04db9379$var$initVueOnEmbed(foundEmbed);
    });
})();



})();
//# sourceMappingURL=custom-widget.js.map
